/*COMMON*/
export const SEARCH = "search";
export const LOADING_INFORMATION = "loadingInformation";
export const LOADING_SIMILAR_PROFILES_INFORMATION =
  "loadingSimilarProfilesInformation";
export const LOADING_SUGGESTED_INFORMATION = "loadingSuggestedInformation";
export const LOADING_REPORT_INFORMATION = "loadingReportInformation";
export const LOADING_DOWNLOAD_PROFILES = "loadingDownloadProfiles";
export const LOADING_CONTENT = "loadingContent";
export const LOADING_CONFIGURATION = "loadingConfiguration";
export const LOADING_PLAN_INFORMATION = "loadingPlanInformation";
export const UPDATING_INFORMATION = "updatingInformation";
export const INFORMATION_INVALID_ACCESS = "informationInvalidAccess";
export const EMPTY_SIMILAR_PROFILES_SHOW = "emptySimilarProfilesShow";
export const EMPTY_CONTENT_SHOW = "emptyContentShow";
export const NO_MORE_RESULTS_TO_SHOW = "noMoreResultsToShow";
export const EMPTY_RESULTS_SHOW = "emptyResultsShow";
export const EMPTY_RESULTS_SHOW_ON_THIS_PAGE = "emptyResultsShowOnThisPage";
export const EMPTY_QUESTIONS_SHOW = "emptyQuestionsShow";
export const EMPTY_ANALYTICS = "emptyAnalytics";
export const EMPTY_KEYWORDS = "emptyKeywords";
export const ADVANCED_CONFIGURATION = "advancedConfiguration";
export const WAIT = "wait";
export const COLLABORATIONS = "colLaborations";
export const COLLABORATION = "colLaboration";
export const DEACTIVATE = "deactivate";
export const DEACTIVATED = "deactivated";
export const ACTIVATE = "activate";
export const ACTIVE = "active";
export const ALL = "all";
export const BRAND = "brand";
export const WARNING = "warning";
export const INFORMATION = "information";
export const ERROR = "error";
export const ACTIONS = "actions";
export const STATUS = "status";
export const CITIES = "cities";
export const UNKNOWN_FORMAT = "unknownFormat";
export const CATEGORY = "category";
export const CATEGORIES = "categories";
export const PRODUCT = "product";
export const PRODUCTS = "products";
export const ERROR_DESCRIPTION_GENERIC = "errorDescriptionGeneric";
export const READY = "ready";
export const FIELD_HAS_NO_VALUE_TO_COPY = "field_has_no_value_to_copy";
export const HELP = "help";
export const GO = "go";
export const GO_TO_ACCOUNT = "goToAccount";
export const GO_TO_PROFILE = "goToProfile";
export const PROFILE = "profile";
export const LOGOUT = "logout";
export const CLIENT = "client";
export const NAME = "name";
export const ADDRESS = "address";
export const IDENTIFICATION_NUMBER = "identificationNumber";
export const PHONE_NUMBER = "phoneNumber";
export const EMAIL = "email";
export const NOTIFICATIONS = "notifications";
export const CONTENT = "content";
export const ANALYTIC = "analytic";
export const ANALYTICS = "analytics";
export const COMMENTS = "comments";
export const COMMENT = "comment";
export const SHOW_COMMENTS = "showComments";
export const EMPTY_COMMENTS = "emptyComments";
export const REVIEWS = "reviews";
export const REVIEW = "review";
export const SHOW_REVIEWS = "showReviews";
export const EMPTY_REVIEWS = "emptyReviews";
export const SCORE = "score";
export const QUALITY_AUDIENCE = "qualityAudience";
export const QUALITY_CONTENT = "qualityContent";
export const AUDIENCE = "audience";
export const AUDIENCE_TITLE_EXPLANATION = "audienceTitleExplanation";
export const AUDIENCE_EXPLANATION = "audienceExplanation";
export const ENGAGEMENT = "engagement";
export const ENGAGEMENT_TITLE_EXPLANATION = "engagementTitleExplanation";
export const ENGAGEMENT_EXPLANATION = "engagementExplanation";
export const FOLLOWERS = "followers";
export const AVG_VIEWS = "avgViews";
export const AVG_LIKES = "avgLikes";
export const POST = "post";
export const AVG_COMMENTS = "avgComments";
export const RECORDS_IN_TABLE = "recordsInTable";
export const PAGE_IN_TABLE = "pageInTable";
export const SHOP_DEACTIVATE_ALERT_DESCRIPTION =
  "shopDeactivateAlertDescription";
export const UPDATE = "update";
export const MALES = "males";
export const MALE = "male";
export const FEMALES = "females";
export const FEMALE = "female";
export const STORE = "store";
export const SELECT_STORE = "selectStore";
export const EMPTY_STORES = "emptyStores";
export const NEW_ORDER = "newOrder";
export const ORDER = "order";
export const NEW = "new";
export const SECOND = "second";
export const SECONDS = "seconds";
export const MINUTE = "minute";
export const MINUTES = "minutes";
export const MINUTE_LETTER_COUNT_DOWN = "minuteLetterCountDown";
export const HOUR = "hour";
export const HOURS = "hours";
export const HOUR_LETTER_COUNT_DOWN = "hourLetterCountDown";
export const DAY = "day";
export const DAYS = "days";
export const DAY_LETTER_COUNT_DOWN = "dayTextCountDown";
export const WEEK = "week";
export const WEEKS = "weeks";
export const WEEK_LETTER_COUNT_DOWN = "weekLetterCountDown";
export const MONTH = "month";
export const MONTHS = "months";
export const CALENDAR_MONTH = "calendarMonth";
export const CALENDAR_WEEK = "calendarWeek";
export const CALENDAR_DAY = "calendarDay";
export const CALENDAR_TODAY = "calendarToday";
export const CALENDAR_TOMORROW = "calendarTomorrow";
export const CALENDAR_NEXT = "calendarNext";
export const CALENDAR_PREVIOUS = "calendarPrevious";
export const CALENDAR_AGENDA = "calendarAgenda";
export const CALENDAR_SHOW_MORE = "calendarShowMore";
export const VIEW_CALENDAR = "viewCalendar";
export const POST_TITLE = "calendarTitle";
export const CALENDAR_POST_TITLE = "calendarPostTitle";
export const CALENDAR_STORIES_TITLE = "calendarStoriesTitle";
export const CALENDAR_REELS_TITLE = "calendarReelsTitle";
export const CALENDAR_MULTIPLE_POST_TITLE = "calendarMultiplePostTitle";
export const CALENDAR_INVALID_DATE_ERROR = "calendarInvalidDateError";
export const EVENT_DETAILS_DESCRIPTION = "eventDetailsDescription";
export const EVENT_DETAILS_DATE_AND_TIME = "eventDetailsDateAndTime";
export const EVENT_DETAILS_SOCIAL_NETWORK = "eventDetailsSocialNetwork";
export const EVENT_DETAILS_STATUS = "eventDetailsStatus";
export const EVENT_DETAILS_STATUS_DRAFT = "eventDetailsStatusDraft";
export const EVENT_DETAILS_STATUS_SCHEDULED = "eventDetailsStatusScheduled";
export const EVENT_DETAILS_STATUS_PUBLISHED = "eventDetailsStatusPublished";
export const GALLERY_MAX_SELECTIONS_REACHED = "galleryMaxSelectionsReached";
export const GALLERY_PUBLISHED_ON_PLATFORMS = "galleryPublishedOnPlatforms";
export const GALLERY_PLATFORM_STATUSES_LABEL = "galleryPlatformStatusesLabel";
export const GALLERY_STATUS_PUBLISHED_DIRECT = "galleryStatusPublishedDirect";
export const GALLERY_STATUS_PUBLISHED_DIRECT_UNKNOWN =
  "galleryStatusPublishedDirectUnknown";
export const GALLERY_STATUS_SCHEDULED = "galleryStatusScheduled";
export const GALLERY_STATUS_SCHEDULED_UNKNOWN = "galleryStatusScheduledUnknown";
export const GALLERY_STATUS_PUBLISHED_SCHEDULE =
  "galleryStatusPublishedSchedule";
export const GALLERY_STATUS_PUBLISHED_SCHEDULE_UNKNOWN =
  "galleryStatusPublishedScheduleUnknown";
export const GALLERY_STATUS_FAILED = "galleryStatusFailed";
export const GALLERY_STATUS_FAILED_UNKNOWN = "galleryStatusFailedUnknown";
export const GALLERY_STATUS_PUBLISHED_LEGACY = "galleryStatusPublishedLegacy";
export const SHARE_MODAL_PLATFORM_ALREADY_PUBLISHED =
  "shareModalPlatformAlreadyPublished";
export const EVENT_DETAILS_STATUS_FAILED = "eventDetailsStatusFailed";

export const ORGANIC_PUBLISH_RETRY_CONFIRM_TITLE =
  "organicPublishRetryConfirmTitle";
export const ORGANIC_PUBLISH_RETRY_CONFIRM_DESCRIPTION =
  "organicPublishRetryConfirmDescription";
export const ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL =
  "organicPublishRetryAlertAriaLabel";
export const ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM =
  "organicPublishRetryAlertColumnPlatform";
export const ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE =
  "organicPublishRetryAlertColumnMessage";
export const ORGANIC_PUBLISH_RETRY_ERROR = "organicPublishRetryError";
export const ORGANIC_PUBLISH_PARTIAL_STATUS = "organicPublishPartialStatus";
export const BUTTON_RETRY_PUBLISHING = "buttonRetryPublishing";
export const EVENT_DETAILS_NETWORK_INSTAGRAM = "eventDetailsNetworkInstagram";
export const EVENT_DETAILS_NETWORK_FACEBOOK = "eventDetailsNetworkFacebook";
export const EVENT_DETAILS_NETWORK_TIKTOK = "eventDetailsNetworkTiktok";
export const EVENT_DETAILS_NETWORK_LINKEDIN = "eventDetailsNetworkLinkedin";
export const EVENT_DETAILS_NETWORK_YOUTUBE = "eventDetailsNetworkYoutube";
export const EVENT_DETAILS_CONTENT = "eventDetailsContent";
export const QUESTION = "question";
export const QUESTIONS = "questions";
export const CONTENT_CREATOR = "contentCreator";
export const ADD = "add";
export const MONDAY = "monday";
export const TUESDAY = "tuesday";
export const WEDNESDAY = "wednesday";
export const THURSDAY = "thursday";
export const FRIDAY = "friday";
export const SATURDAY = "saturday";
export const SUNDAY = "sunday";
export const SELECT_A_OPTION = "selectAOption";
export const FILE_SELECTED = "fileSelected";
export const YES = "yes";
export const NO = "no";
export const IMAGES = "images";
export const VIDEOS = "videos";
export const OK = "ok";
export const FILTER = "filter";
export const SUPER_ADMIN = "superAdmin";
export const ADMIN = "admin";
export const OPERATOR = "operator";
export const DESIGNER = "designer";
export const TOTAL = "total";
export const NO_HAVE = "noHave";
export const NO_ADDED = "noAdded";
export const SUPPORT = "support";
export const CONTACT_US = "contactUs";
export const ONE = "one";
export const TWO = "two";
export const THREE = "three";
export const ANY = "any";
export const GENDER = "gender";
export const REVISIONS = "revisions";
export const CURRENT = "current";
export const CURRENT_CONTENT = "currentContent";
export const CURRENT_CONTENT_EMPTY = "currentContentEmpty";
export const NO_SEND_CONTENT_FEEDBACK = "noSendContentFeedback";
export const EDIT = "edit";
export const THIS_CREATOR_IS_FAVORITE = "thisCreatorIsFavorite";
export const ADD_TO_FAVORITES = "addToFavorites";
export const REMOVE_FROM_FAVORITES = "removeFromFavorites";
export const SPANISH = "spanish";
export const ENGLISH = "english";
export const PORTUGUESE = "portuguese";
export const FRENCH = "french";
export const RUSSIAN = "russian";
export const JAPANESE = "japanese";
export const MANDARIN = "mandarin";
export const HINDI = "hindi";
export const ARABIC = "arabic";
export const BENGALI = "bengali";
export const PUNJABI = "punjabi";
export const GERMAN = "german";
export const JAVANESE = "javanese";
export const KOREAN = "korean";
export const INDONESIAN = "indonesian";
export const TURKISH = "turkish";
export const BULGARIAN = "bulgarian";
export const SLOVAK = "slovak";
export const CROATIAN = "croatian";
export const DANISH = "danish";
export const UKRAINIAN = "ukrainian";
export const ENGLISH_US = "englishUs";
export const ENGLISH_UK = "englishUk";
export const SPANISH_SPAIN = "spanishSpain";
export const PORTUGUESE_BRAZIL = "portugueseBrazil";
export const PORTUGUESE_PORTUGAL = "portuguesePortugal";
export const FRENCH_FRANCE = "frenchFrance";
export const FRENCH_CANADA = "frenchCanada";
export const TRADITIONAL_CHINESE_HONG_KONG = "traditionalChineseHongKong";
export const TRADITIONAL_CHINESE_TAIWAN = "traditionalChineseTaiwan";
export const JAPANESE_KANSAI = "japaneseKansai";
export const NORWEGIAN_BOKMAL = "norwegianBokmal";
export const NORWEGIAN_NYNORSK = "norwegianNynorsk";
export const CATALAN = "catalan";
export const CZECH = "czech";
export const WELSH = "welsh";
export const BASQUE = "basque";
export const FINNISH = "finnish";
export const GALICIAN = "galician";
export const HUNGARIAN = "hungarian";
export const ITALIAN = "italian";
export const DUTCH = "dutch";
export const FRISIAN = "frisian";
export const POLISH = "polish";
export const ROMANIAN = "romanian";
export const SLOVENIAN = "slovenian";
export const SWEDISH = "swedish";
export const FLEMISH = "flemish";
export const ESPERANTO = "esperanto";
export const ESTONIAN = "estonian";
export const FAROESE = "faroese";
export const GREEK = "greek";
export const ICELANDIC = "icelandic";
export const IRISH = "irish";
export const LATVIAN = "latvian";
export const LITHUANIAN = "lithuanian";
export const MACEDONIAN = "macedonian";
export const THAI = "thai";
export const VIETNAMESE = "vietnamese";
export const KHMER = "khmer";
export const FILIPINO = "filipino";
export const MALAY = "malay";
export const GUJARATI = "gujarati";
export const KANNADA = "kannada";
export const TAMIL = "tamil";
export const TELUGU = "telugu";
export const MALAYALAM = "malayalam";
export const URDU = "urdu";
export const HEBREW = "hebrew";
export const PERSIAN = "persian";
export const NORTHERN_KURDISH_KURMANJI = "northernKurdishKurmanji";
export const ARMENIAN = "armenian";
export const AZERBAIJANI = "azerbaijani";
export const BELARUSIAN = "belarusian";
export const BOSNIAN = "bosnian";
export const GEORGIAN = "georgian";
export const KAZAKH = "kazakh";
export const MONGOLIAN = "mongolian";
export const SERBIAN = "serbian";
export const TAJIK = "tajik";
export const UZBEK = "uzbek";
export const AFRIKAANS = "afrikaans";
export const SWAHILI = "swahili";
export const ALBANIAN = "albanian";
export const CEBUANO = "cebuano";
export const GUARANI = "guarani";
export const MARATHI = "marathi";
export const NEPALI = "nepali";
export const PASHTO = "pashto";
export const SINHALA = "sinhala";
export const CHINESE = "chinese";
export const ASSAMESE = "assamese";
export const HARYANAVI = "haryanavi";
export const BIHARI = "bihari";
export const ORIYA = "oriya";
export const RAJASTHANI = "rajasthani";
export const NORWEGIAN = "norwegian";
export const CAMPAIGNS = "campaigns";

export const VIEW = "view";
export const USERS = "users";
export const ANONYMOUS_USER = "anonymousUser";
export const STORES = "stores";
export const PLAN = "plan";
export const AUTOMATIC_RENOVATION = "automaticRenovation";
export const ACCEPTED = "accepted";
export const PENDING = "pending";
export const ARE_YOU_SURE = "areYouSure";
export const ARE_YOU_SURE_TO_DISCONNECT_ACCOUNT =
  "areYouSureToDisconnectAccount";
export const CHANGE = "change";
export const REPORT_REQUESTS = "reportRequests";
export const REQUESTS_ACCEPTED = "requestsAccepted";
export const REQUESTS_REJECTED = "requestsRejected";
export const REQUESTS_ACTIVE = "requestsActive";
export const CODE = "code";
export const IS_AUTOMATIC = "isAutomatic";
export const REDEEMED = "redeemed";
export const EXPIRED = "expired";
export const REDEEMED_SINGULAR = "redeemedSingular";
export const EXPIRED_SINGULAR = "expiredSingular";
export const REJECTED = "rejected";
export const ROLE = "role";
export const UNKNOWN = "unknown";
export const LEFT = "left";
export const RIGHT = "right";
export const LOGO = "logo";
export const LOGO_DESCRIPTION = "logoDescription";
export const ADD_BRAND = "addBrand";
export const DATE = "date";
export const NAME_BUSINESS_BOT = "nameBusinessBot";
export const SERVICE_FEE = "serviceFee";
export const TOTAL_PAYMENT = "totalPayment";
export const LAST_COLLABORATION = "lastCollaboration";
export const PERSONALIZED_INSTRUCTIONS = "personalizedInstructions";
export const EMPTY_REQUESTS = "emptyRequests";
export const EMPTY_CAMPAIGNS = "emptyCampaigns";
export const EMPTY_ORDERS = "emptyOrders";
export const EMPTY_REDEEM_CODES = "emptyRedeemCodes";
export const EMPTY_USERS = "emptyUsers";
export const EMPTY_CONTACTS = "emptyContacts";
export const EMPTY_INVOICES = "emptyInvoices";
export const EMPTY_APPLICANTS_PENDING = "emptyApplicantsPending";
export const EMPTY_APPLICANTS_ACCEPTED = "emptyApplicantsAccepted";
export const EMPTY_ADS_CAMPAIGNS = "emptyAdsCampaigns";
export const TARGET_CAMPAIGN = "targetCampaign";
export const LOCATIONS = "locations";
export const GENDERS = "genders";
export const AGES = "ages";
export const PLATFORMS = "platforms";
export const PLATFORM = "platform";
export const REPORTS = "statistics";
export const IMPRESSIONS = "impressions";
export const CLICKS = "clicks";
export const CTR = "ctr";
export const CPA = "cpa";
export const CLICK = "click";
export const CPM = "cpm";
export const CPC = "cpc";
export const RESULTS = "results";
export const SPEND = "spend";
export const PERIOD = "period";
export const AVERAGE = "average";
export const TYPE_LEAST_CHARACTERS = "typeLeastCharacters";
export const LOADING = "loading";
export const OBJECTIVE = "objective";
export const INTERACTIONS = "interactions";
export const AWARENESS = "awareness";
export const TRAFFIC = "traffic";
export const LEADS = "leads";
export const DOWNLOADS = "downloads";
export const SALES = "sales";
export const META_CAMPAIGN = "metaCampaign";
export const TIKTOK_CAMPAIGN = "tiktokCampaign";
export const CONTENT_TO_ADVERTISE = "contentToAdvertise";
export const EMPTY_TRACKING_IDS_META = "emptyTrackingIdsMeta";
export const FINISHED = "finished";
export const TIKTOK_BUSINESS = "tiktokBusiness";
export const EMPTY_TRACKING_IDS_TIKTOK = "emptyTrackingIdsTiktok";
export const SHORT_TIME_HAS_PASSED_SINCE_ACTIVATION_STATISTICS =
  "shortTimeHasPassedSinceActivationStatistics";
export const SHOPIFY = "shopify";
export const WOOCOMMERCE = "woocommerce";
export const ADD_NEW_STYLE = "addNewStyle";
export const WANTS_SOCIAL_MEDIA_POST = "wantsSocialMediaPost";
export const DOES_NOT_WANTS_SOCIAL_MEDIA_POST = "doesNotWantsSocialMediaPost";
export const FOLLOWERS_ABBREVIATED = "followersAbbreviated";
export const ENGAGEMENT_ABBREVIATED = "engagementAbbreviated";
export const EXPLANATION_SEND_ONE_REVISION = "explanationSendOneRevision";
export const I_NEED_HELP = "iNeedHelp";
export const REVISION_OPTION_GOOD = "revisionOptionGood";
export const REVISION_OPTION_REGULAR = "revisionOptionRegular";
export const REVISION_OPTION_BAD = "revisionOptionBad";
export const WHY_THESE_RECOMMENDED_SETTINGS = "whyTheseRecommendedSettings";
export const PIXEL_REQUIRED = "pixelRequired";
export const DRAFT = "draft";
export const CANVA = "canva";
export const CONNECTED_ACCOUNTS = "connectedAccounts";
export const CONNECTED_ACCOUNTS_CONNECT_MORE_PLATFORMS =
  "connectedAccountsConnectMorePlatforms";
export const CONNECTED_ACCOUNTS_BUTTON_CONNECT =
  "connectedAccountsButtonConnect";
export const CONNECTED_ACCOUNTS_EMPTY_HINT = "connectedAccountsEmptyHint";
export const CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT =
  "connectedAccountsIntegrationsCount";
export const CONNECTED_ACCOUNTS_INTEGRATIONS_COUNT_SINGULAR =
  "connectedAccountsIntegrationsCountSingular";
export const CONNECTED_ACCOUNTS_PLATFORM_META = "connectedAccountsPlatformMeta";
export const CONNECTED_ACCOUNTS_PLATFORM_GOOGLE =
  "connectedAccountsPlatformGoogle";
export const CONNECTED_ACCOUNTS_PLATFORM_TIKTOK_BUSINESS =
  "connectedAccountsPlatformTiktokBusiness";
export const CONNECTED_ACCOUNTS_PLATFORM_LINKEDIN =
  "connectedAccountsPlatformLinkedin";
export const CONNECTED_ACCOUNTS_ACCORDION_EXPAND =
  "connectedAccountsAccordionExpand";
export const CONNECTED_ACCOUNTS_ACCORDION_COLLAPSE =
  "connectedAccountsAccordionCollapse";
export const SLIDE_MENU_COLLAPSE = "slideMenuCollapse";
export const SLIDE_MENU_EXPAND = "slideMenuExpand";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TITLE =
  "connectedAccountsPlatformDefaultsTitle";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE =
  "connectedAccountsPlatformDefaultsSave";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_SUCCESS =
  "connectedAccountsPlatformDefaultsSaveSuccess";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_SAVE_ERROR =
  "connectedAccountsPlatformDefaultsSaveError";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_LOADING =
  "connectedAccountsPlatformDefaultsLoading";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_AD_FORMAT_LABEL =
  "connectedAccountsPlatformDefaultsAdFormatLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_LABEL =
  "connectedAccountsPlatformDefaultsAppLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_APP_PROMOTION_LABEL =
  "connectedAccountsPlatformDefaultsAppPromotionLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CAMPAIGN_TYPE_LABEL =
  "connectedAccountsPlatformDefaultsCampaignTypeLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_FOR_APP_INSTALL_LABEL =
  "connectedAccountsPlatformDefaultsCatalogForAppInstallLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_CATALOG_LABEL =
  "connectedAccountsPlatformDefaultsCatalogLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DEEP_LINK_LABEL =
  "connectedAccountsPlatformDefaultsDeepLinkLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_TYPE_LABEL =
  "connectedAccountsPlatformDefaultsDestinationTypeLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_DESTINATION_URL_LABEL =
  "connectedAccountsPlatformDefaultsDestinationUrlLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_IDENTITIES_ACCOUNTS_LABEL =
  "connectedAccountsPlatformDefaultsIdentitiesAccountsLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_MERCHANT_ID_LABEL =
  "connectedAccountsPlatformDefaultsMerchantIdLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_OBJECTIVE_LABEL =
  "connectedAccountsPlatformDefaultsObjectiveLabel";
export const CONNECTED_ACCOUNTS_PLATFORM_DEFAULTS_TIKTOK_CAMPAIGN_TYPE_LABEL =
  "connectedAccountsPlatformDefaultsTiktokCampaignTypeLabel";
export const CAMPAIGN = "campaign";
export const ASSETS_GROUP = "assetsGroup";
export const AD_GROUP = "adGroup";
export const AD = "ad";
export const ACTIVATED = "activated";
export const NUMBER_ITEM = "numberItem";
export const TITLES = "titles";
export const TITLES_META = "titlesMeta";
export const LONG_HEADLINES = "longHeadlines";
export const TITLE = "title";
export const HEADLINES = "headlines";
export const DESCRIPTIONS = "descriptions";
export const COMING_SOON = "comingSoon";
export const ENTER_CODE = "enterCode";
export const WE_SEND_VERIFICATION_CODE_TO_YOUR_PHONE =
  "weSendVerificationCodeToYourPhone";
export const MODIFY_PHONE_NUMBER = "modifyPhoneNumber";
export const OTP_VERIFICATION_TITLE = "otpVerificationTitle";
export const OTP_VERIFICATION_EMAIL_SENT = "otpVerificationEmailSent";
export const OTP_BACK_TO_EMAIL = "otpBackToEmail";
export const META_TOGGLE_DESCRIPTION = "metaToggleDescription";
export const GOOGLE_TOGGLE_DESCRIPTION = "googleToggleDescription";
export const TIKTOK_TOGGLE_DESCRIPTION = "tiktokToggleDescription";
export const LINKEDIN_TOGGLE_DESCRIPTION = "linkedinToggleDescription";
export const NOT_AVAILABLE = "notAvailable";
export const EDIT_INSTRUCTIONS = "editInstructions";
export const PROMPT = "prompt";
export const TYPE = "type";
export const RETENTION_DAYS = "retentionDays";
export const ERRORS = "errors";
export const DELIVERY_STATUS = "deliveryStatus";
export const OPERATION_STATUS = "operationStatus";
export const MOST_POPULAR = "mostPopular";
export const MANUAL_SEGMENTATION = "manualSegmentation";
export const RE_TARGETING_SEGMENTATION = "reTargetingSegmentation";
export const IDENTITIES_TIK_TOK_EMPTY = "identitiesTikTokEmpty";
export const ADD_NEW_IDENTITY = "addNewIdentity";
export const GENERAL_INFORMATION = "generalInformation";
export const CONTEXT = "context";
export const CAMPAIGN_HAS_NEVER_BEEN_ACTIVATED =
  "campaignHasNeverBeenActivated";
export const LOADING_METRICS_FROM_PLATFORMS = "loadingMetricsFromPlatforms";
export const HOW_IS_YOUR_CAMPAIGN_GOING = "howIsYourCampaignGoing";
export const AN_ERROR_OCCURRED_GETTING_THE_REPORT =
  "anErrorOccurredGettingTheReport";
export const AD_ACCOUNTS = "adAccounts";
export const FACEBOOK_PAGES = "facebookPages";
export const INSTAGRAM_ACCOUNTS = "instagramAccounts";
export const LAST_UPDATE = "lastUpdate";
export const LAST_RECORDED_EVENT_ON = "lastRecordedEventOn";
export const NEVER = "never";
export const PIXEL_HAS_NO_RECORDED_EVENTS = "pixelHasNoRecordedEvents";
export const IN_A_FEW_MINUTES_YOUR_INVOICE_WILL_BE_AVAILABLE =
  "inAFewMinutesYourInvoiceWillBeAvailable";
export const RETRIEVING_GENERAL_INFORMATION = "retrievingGeneralInformation";
export const RETRIEVING_AD_ACCOUNTS = "retrievingAdAccounts";
export const RETRIEVING_FACEBOOK_PAGES = "retrievingFacebookPages";
export const RETRIEVING_INSTAGRAM_ACCOUNTS = "retrievingInstagramAccounts";
export const ENDING_CONNECTION = "endingConnection";
export const RETRIEVING_YOUTUBE_CHANNEL = "retrievingYoutubeChannel";
export const RETRIEVING_TIKTOK_PROFILE = "retrievingTiktokProfile";
export const ESTABLISHING_CONNECTION_WITH_PLATFORM =
  "establishingConnectionWithPlatform";
export const RETRIEVING_AUTHORIZATION_DATA = "retrievingAuthorizationData";
export const OPENING_AUTHORIZATION_WINDOW = "openingAuthorizationWindow";
export const CONNECTING_CANVA_VERIFYING_AUTHORIZATION =
  "connectingCanvaVerifyingAuthorization";
export const CONNECTING_CANVA_LINKING_ACCOUNT = "connectingCanvaLinkingAccount";
export const VERIFYING_YOUR_SESSION = "verifyingYourSession";
export const GETTING_REQUIRED_INFORMATION = "gettingRequiredInformation";
export const VERIFYING_PLATFORMS_INFORMATION = "verifyingPlatformsInformation";
export const CREATING_CAMPAIGN = "creatingCampaign";
export const CREATING_AD_GROUPS = "creatingAdGroups";
export const UPLOADING_CONTENTS = "uploadingContents";
export const CREATING_ADS = "creatingAds";
export const SAVING_INFORMATION = "savingInformation";
export const INACTIVE = "inactive";
export const CUSTOM_EVENT = "customEvent";
export const FAST = "fast";
export const EASY = "easy";
export const AUTOMATED = "automated";
export const FULL_CONTROL = "fullControl";
export const CUSTOMIZE = "customize";
export const TAILORED = "tailored";
export const RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION =
  "retargetingEmptySegmentationClarification";
export const CAMPAIGN_CREATED = "campaignCreated";
export const CAMPAIGN_UPDATED = "campaignUpdated";
export const CREATIFY_VIDEO_PREVIEW_CLARIFICATION =
  "creatifyVideoPreviewClarification";
export const CREATIFY_VIDEO_ERROR_RENDER_CLARIFICATION =
  "creatifyVideoErrorRenderClarification";
export const CREATIFY_VIDEO_RENDERING_CLARIFICATION_AND_CREATE_CAMPAIGN =
  "creatifyVideoRenderingClarificationAndCreateCampaign";
export const CREATIFY_VIDEO_RENDERING_CLARIFICATION =
  "creatifyVideoRenderingClarification";
export const COPY = "copy";
export const GENERATING_VIDEO_MESSAGE = "generatingVideoMessage";
export const TASK_ALERT_ESTIMATED_TIME = "taskAlertEstimatedTime";
export const DO_YOU_HAVE_DISCOUNT_CODE = "doYouHaveDiscountCode";
export const DISCOUNT_VALUE = "discountValue";
export const NORMAL_PRICE = "normalPrice";
export const CONTENT_NUMERATION = "contentNumeration";
export const WE_CANT_GET_AVATARS = "weCantGetAvatars";
export const CONTENT_GENERATOR = "configurationVideo";
export const SELECT_BACKGROUND_CONTENT = "selectBackgroundContent";
export const SELECT_BACKGROUND_CONTENT_CLARIFICATION =
  "selectBackgroundContentClarification";
export const CUSTOM = "custom";
export const GETTING_CREATIFY_VIDEO_DATA = "gettingCreatifyVideoData";
export const CREDITS = "credits";
export const COINS = "coins";
export const CREDITS_VALUE = "creditsValue";
export const COST_OF_ACTION = "costOfAction";
export const COST_OF_CAMPAIGN = "costOfCampaign";
export const COST_OF_RESIZE = "costOfResize";
export const CURRENT_BALANCE = "currentBalance";
export const BALANCE_AFTER = "balanceAfter";
export const COINS_VALUE = "coinsValue";
export const PER_MONTH = "perMonth";
export const ACTION_CONFIRM_TEXT = "actionConfirmText";
export const CURRENT_USAGE_TYPE = "currentUsageType";
export const YOUR_TRIAL_CREDITS_END = "yourTrialCreditsEnd";
export const YOUR_TRIAL_COINS_END = "yourTrialCoinsEnd";
export const YOUR_TRIAL_END = "yourTrialEnd";
export const CREATE_DEACTIVATED = "createDeactivated";
export const CREATE_ACTIVATED = "createActivated";
export const EMPTY_TRACKING_IDS_GOOGLE = "emptyTrackingIdsGoogle";
export const EMPTY_TRACKING_IDS_LINKEDIN = "emptyTrackingIdsLinkedin";
export const REST_CAMPAIGNS = "restCampaigns";
export const REST_CREATIVES = "restCreatives";
export const REST_CREATIVE_SINGULAR = "restCreativeSingular";
export const REST_VIDEOS = "restVideos";
export const REST_VIDEO_SINGULAR = "restVideoSingular";
export const REST_CREDITS = "restCredits";
export const CREATIVES_REMAINING_SHORT = "creativesRemainingShort";
export const VIDEOS_REMAINING_SHORT = "videosRemainingShort";
export const CREATIVES_REMAINING_SHORT_SINGULAR =
  "creativesRemainingShortSingular";
export const SUGGESTED_CREATIVES_COUNT = "suggestedCreativesCount";
export const SUGGESTED_CREATIVES_PROGRESS = "suggestedCreativesProgress";
export const VIDEOS_REMAINING_SHORT_SINGULAR = "videosRemainingShortSingular";
export const CREDITS_EXPLANATION = "creditsExplanation";
export const COINS_EXPLANATION = "coinsExplanation";
export const META_DESTINATION_TYPE_INSTAGRAM_PROFILE_CLARIFICATION =
  "metaDestinationTypeInstagramProfileClarification";
export const ADVERTISER = "advertiser";
export const MARKETER = "marketer";
export const VIEWER = "viewer";
export const DELETED = "deleted";
export const PASSWORD_CLARIFICATION_IN_EDIT_USER =
  "passwordClarificationInEditUser";
export const CREATED_AT = "createdAt";
export const CREATED_BY = "createdBy";
export const MONTHLY = "monthly_subscription";
export const QUARTERLY = "quarterly";
export const SEMIYEARLY = "semiyearly";
export const YEARLY = "yearly";
export const GREETING = "greeting";
export const FIRST_USER_MESSAGE = "firstUserMessage";
export const CPA_CLARIFICATION = "cpaClarification";
export const BID_CONTROL_PLACEHOLDER = "bidControlPlaceholder";
export const HIGHEST_VOLUME_PLACEHOLDER = "highestVolumePlaceholder";
export const MAIN_STATISTIC_CPM_CLARIFICATION = "mainStatisticCpmClarification";
export const MAIN_STATISTIC_CLICK_CLARIFICATION =
  "mainStatisticClickClarification";
export const MAIN_STATISTIC_POST_ENGAGEMENT_CLARIFICATION =
  "mainStatisticPostEngagementClarification";
export const MAIN_STATISTIC_LEAD_CLARIFICATION =
  "mainStatisticLeadClarification";
export const MAIN_STATISTIC_PURCHASE_CLARIFICATION =
  "mainStatisticPurchaseClarification";
export const MAIN_STATISTIC_AD_RECALL_CLARIFICATION =
  "mainStatisticAdRecallClarification";
export const MAIN_STATISTIC_VIDEO_VIEW_CLARIFICATION =
  "mainStatisticVideoViewClarification";
export const MAIN_STATISTICS_INSTAGRAM_PROFILE_CLARIFICATION =
  "mainStatisticsInstagramProfileClarification";
export const MAIN_STATISTIC_VALUE_CPM_CLARIFICATION =
  "mainStatisticValueCpmClarification";
export const MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION =
  "mainStatisticValueClickClarification";
export const MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION =
  "mainStatisticValuePostEngagementClarification";
export const MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION =
  "mainStatisticValueLeadClarification";
export const MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION =
  "mainStatisticValuePurchaseClarification";
export const MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION =
  "mainStatisticValueAdRecallClarification";
export const MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION =
  "mainStatisticValueVideoViewClarification";
export const MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION =
  "mainStatisticValueInstagramProfileClarification";
export const ANALYZING_CAMPAIGN_STATISTICS = "analyzingCampaignStatistics";
export const COMPARING_RESULTS_OBTAINED = "comparingResultsObtained";
export const GENERATING_OPTIMIZATIONS = "generatingOptimizations";
export const CAMPAIGN_OPTIMIZED_NAME = "campaignOptimizedName";
export const CAMPAIGN_OPTIMIZED = "campaignOptimized";
export const CAMPAIGN_OPTIMIZED_GENERATED = "campaignOptimizedGenerated";
export const APPLYING_OPTIMIZATIONS = "applyingOptimizations";
export const IMPRESSIONS_BY_PLATFORM = "impressionsByPlatform";
export const CLICKS_BY_PLATFORM = "clicksByPlatform";
export const MAIN_ACTIONS_BY_PLATFORM = "mainActionsByPlatform";
export const CONCLUSION = "conclusion";
export const RECOMMENDATIONS = "recommendations";
export const DAY_COUNT = "dayCount";
export const ADS_CAMPAIGN_REPORT_BREAKDOWN_DAILY =
  "adsCampaignReportBreakdownDaily";
export const WEEK_COUNT = "weekCount";
export const EMPTY_STATISTICS_FOR_DETAILED_REPORT =
  "emptyStatisticsForDetailedReport";
export const LOCATIONS_TIK_TOK_EMPTY = "locationsTikTokEmpty";
export const PRODUCT_OR_SERVICE_CONTEXT = "productOrServiceContext";
export const TARGET_AUDIENCE_CONTEXT = "targetAudienceContext";
export const IS_CAROUSEL = "isCarousel";
export const CARD = "card";
export const FORM = "form";
export const FORMS = "forms";
export const ANSWER = "answer";
export const ANSWERS = "answers";
export const GOOGLE_PHRASE_KEYWORD = "googlePhraseKeyword";
export const GOOGLE_PHRASE_KEYWORD_EXPLANATION =
  "googlePhraseKeywordExplanation";
export const GOOGLE_EXACT_KEYWORD = "googleExactKeyword";
export const GOOGLE_EXACT_KEYWORD_EXPLANATION = "googleExactKeywordExplanation";
export const GOOGLE_BROAD_KEYWORD = "googleBroadKeyword";
export const GOOGLE_BROAD_KEYWORD_EXPLANATION = "googleBroadKeywordExplanation";
export const GOOGLE_KEYWORDS_EXPLANATION = "googleKeywordsExplanation";
export const GOOGLE_KEYWORDS_NEGATIVE_EXPLANATION =
  "googleKeywordsNegativeExplanation";
export const GOOGLE_SEARCH_AD_GROUP_TYPE_LABEL = "googleSearchAdGroupTypeLabel";
export const GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD =
  "googleSearchAdGroupTypeStandard";
export const GOOGLE_SEARCH_AD_GROUP_TYPE_DSA = "googleSearchAdGroupTypeDsa";
export const GOOGLE_WEBPAGE_CRITERIA_TITLE = "googleWebpageCriteriaTitle";
export const GOOGLE_WEBPAGE_CRITERIA_EXPLANATION =
  "googleWebpageCriteriaExplanation";
export const GOOGLE_WEBPAGE_CRITERION_OPERATOR_LABEL =
  "googleWebpageCriterionOperatorLabel";
export const GOOGLE_WEBPAGE_CRITERION_VALUE_LABEL =
  "googleWebpageCriterionValueLabel";
export const GOOGLE_WEBPAGE_CRITERION_URL_EQUALS =
  "googleWebpageCriterionUrlEquals";
export const GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS =
  "googleWebpageCriterionUrlContains";
export const FIELD_WEBPAGE_CRITERIA_REQUIRED = "fieldWebpageCriteriaRequired";
export const FIELD_WEBPAGE_CRITERIA_REPEATED = "fieldWebpageCriteriaRepeated";
export const GOOGLE_SEARCH_AD_GROUP_DSA_NO_KEYWORDS_STATS =
  "googleSearchAdGroupDsaNoKeywordsStats";
export const GOOGLE_DSA_SETTINGS_TITLE = "googleDsaSettingsTitle";
export const GOOGLE_DSA_SETTINGS_EXPLANATION = "googleDsaSettingsExplanation";
export const GOOGLE_DSA_DOMAIN_LABEL = "googleDsaDomainLabel";
export const GOOGLE_DSA_LANGUAGE_LABEL = "googleDsaLanguageLabel";
export const GOOGLE_WEBPAGES_NOT_ADDED = "googleWebpagesNotAdded";
export const GOOGLE_WEBPAGE_ADD_TITLE = "googleWebpageAddTitle";
export const GOOGLE_WEBPAGE_EDIT_TITLE = "googleWebpageEditTitle";
export const GOOGLE_WEBPAGE_URL_LABEL = "googleWebpageUrlLabel";
export const COLUMN_NAME_TYPE = "columnNameType";
export const COLUMN_NAME_URL = "columnNameUrl";
export const ALERT_DELETE_WEBPAGE_TITLE = "alertDeleteWebpageTitle";
export const ALERT_DELETE_WEBPAGE_DESCRIPTION = "alertDeleteWebpageDescription";
export const ALERT_DELETE_WEBPAGES_TITLE = "alertDeleteWebpagesTitle";
export const ALERT_DELETE_WEBPAGES_DESCRIPTION =
  "alertDeleteWebpagesDescription";
export const GOOGLE_NETWORK_SETTING_GOOGLE_SEARCH =
  "googleNetworkSettingGoogleSearch";
export const GOOGLE_NETWORK_SETTING_SEARCH_NETWORK =
  "googleNetworkSettingSearchNetwork";
export const GOOGLE_NETWORK_SETTING_CONTENT_NETWORK =
  "googleNetworkSettingContentNetwork";
export const GOOGLE_NETWORK_SETTING_PARTNER_SEARCH_NETWORK =
  "googleNetworkSettingPartnerSearchNetwork";
export const GOOGLE_AI_MAX_ENABLE_QUESTION = "googleAiMaxEnableQuestion";
export const GOOGLE_AI_MAX_ACTIVATED = "googleAiMaxActivated";
export const GOOGLE_AI_MAX_DEACTIVATED = "googleAiMaxDeactivated";
export const TOP_KEYWORDS = "topKeywords";
export const BETA = "beta";
export const PROCESSING_MEDIA_TO_USE = "processingMediaToUse";
export const SAVING_MEDIA = "savingMedia";
export const TUTORIAL = "tutorial";
export const SELECT_RANGE_DATE = "selectRangeDate";
export const TO = "to";
export const MONTH_COUNT = "monthCount";
export const WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN =
  "writeInstructionsToCreateYourCampaign";
export const TITLE_CAMPAIGN_INSTRUCTIONS = "titleCampaignInstructions";
export const DOCUMENTS_ATTACHMENT_LABEL = "documentsAttachmentLabel";
export const FILE_UPLOADED = "fileUploaded";
export const ADD_PLATFORMS = "addPlatforms";
export const ERROR_GENERATING_CAMPAIGN = "errorGeneratingCampaign";
export const THIS_ITEM_HAS_ERRORS = "thisItemHasErrors";
export const INDIVIDUAL = "individual";
export const CAROUSEL = "carousel";
export const RADIUS = "radius";
export const AROUND = "around";
export const ADVANTAGE_ENHANCES_ACTIVE_COUNT = "advantageEnhancesActiveCount";
export const WE_ARE_SYNCHRONIZING_INFORMATION_WITH_PLATFORMS =
  "weAreSynchronizingInformationWithPlatforms";
export const OPTIONAL = "optional";
export const KEYWORDS_NOT_ADDED = "keywordsNotAdded";
export const KEYWORDS_NEGATIVE_NOT_ADDED = "keywordsNegativeNotAdded";
export const ENTER_ONE_KEYWORD_PER_LINE = "enterOneKeywordPerLine";
export const KEYWORDS = "keywords";
export const KEYWORDS_NEGATIVE = "keywordsNegative";
export const TOTAL_IMPRESSIONS = "totalImpressions";
export const TOTAL_CLICKS = "totalClicks";
export const TOTAL_CLICK = "totalClick";
export const TOTAL_RESULTS = "totalResults";
export const TOTAL_SPEND = "totalSpend";
export const AVERAGE_CTR = "averageCtr";
export const TOTAL_ROAS_GOOGLE = "totalRoasGoogle";
export const TOTAL_ROAS_TIK_TOK = "totalRoasTikTok";
export const TOTAL_ROAS_META = "totalRoasMeta";
export const CUSTOM_AUDIENCES = "customAudiences";
export const CREATIVE = "creative";
export const SELECTED = "selected";
export const ROAS = "roas";
export const FORECAST = "forecast";
export const ACTION = "action";
export const DELETE = "delete";
export const INSIGHTS = "insights";
export const INSIGHT = "insight";
export const CHANGE_CONTENT_FOR_OPTIMIZATION_AD_INSIGHT =
  "changeContentForOptimizationAdInsight";
export const PRESS_ENTER_TO_ADD_OPTION = "pressEnterToAddOption";
export const GOOGLE_SEARCH = "googleSearch";
export const GOOGLE_P_MAX = "googlePMax";
export const GOOGLE_APP = "googleApp";
export const YOUTUBE_VIDEO_LINK = "youtubeVideoLink";
export const DO_NOT_UPLOAD_VIDEO_ON_YOUTUBE_HELPER_TEXT =
  "doNotUploadVideoOnYoutubeHelperText";
export const YOUTUBE_VIDEO_SOURCE_YOUTUBE = "youtubeVideoSourceYoutube";
export const YOUTUBE_VIDEO_SOURCE_GALLERY = "youtubeVideoSourceGallery";
export const YOUTUBE_VIDEO_SOURCE_URL = "youtubeVideoSourceUrl";
export const MODAL_GALLERY_YOUTUBE_TITLE = "modalGalleryYoutubeTitle";
export const MODAL_GALLERY_YOUTUBE_EMPTY = "modalGalleryYoutubeEmpty";
export const BUTTON_SELECT_FROM_YOUTUBE = "buttonSelectFromYoutube";
export const BUTTON_PUBLISH_VIDEO_ON_YOUTUBE = "buttonPublishVideoOnYoutube";
export const MODAL_UPLOAD_YOUTUBE_VIDEO_TITLE = "modalUploadYoutubeVideoTitle";
export const MODAL_UPLOAD_YOUTUBE_VIDEO_DURATION_INVALID =
  "modalUploadYoutubeVideoDurationInvalid";
export const REQUIRED_IMAGES_GOOGLE_ASSETS_GROUP_HELPER_TEXT =
  "requiredImagesGoogleAssetsGroupHelperText";
export const REQUIRED_IMAGES_GOOGLE_SQUARE_IMAGE =
  "requiredImagesGoogleSquareImage";
export const REQUIRED_IMAGES_GOOGLE_HORIZONTAL_IMAGE =
  "requiredImagesGoogleHorizontalImage";
export const REQUIRED_VIDEOS_GOOGLE_ASSETS_GROUP_HELPER_TEXT =
  "requiredVideosGoogleAssetsGroupHelperText";
export const CAMPAIGNS_NOT_FOUND = "campaignsNotFound";
export const CAMPAIGN_SELECTED = "campaignSelected";
export const ALREADY_IMPORTED = "alreadyImported";
export const CREATE_A_CAMPAIGN = "createACampaign";
export const CREATE_A_CAMPAIGN_FOR_BRAND_NAME = "createACampaignForBrandName";
export const COPY_VALUE_IN_OTHER_ADS = "copyValueInOtherAds";
export const COPY_VALUES_IN_OTHER_ADS = "copyValuesInOtherAds";
export const COPY_VALUE_IN_OTHER_ADGROUPS = "copyValueInOtherAdgroups";
export const COPY_VALUES_IN_OTHER_ADGROUPS = "copyValuesInOtherAdgroups";
export const GETTING_METRICS = "gettingMetrics";
export const GENERATING_REPORT = "generatingReport";
export const EXPORT_COPIES_TO_GOOGLE_DRIVE = "exportCopiesToGoogleDrive";
export const COPIES_OF_AD = "copiesOfAd";
export const ALL_COPIES_OF_PLATFORM = "allCopiesOfPlatform";
export const CONFIGURED_SITE_LINKS = "configuredSiteLinks";
export const FIRST_USER_MESSAGE_BRAND_SETUP = "firstUserMessageBrandSetup";
export const DATA_TYPE_CONTACT_INFORMATION_OPTION =
  "dataTypeContactInformationOption";
export const DATA_TYPE_CRM_ID_OPTION = "dataTypeCrmIdOption";
export const ALL_CUSTOMERS = "allCustomers";
export const PURCHASERS = "purchasers";
export const HIGH_VALUE_CUSTOMERS = "highValueCustomers";
export const DISENGAGED_CUSTOMERS = "disengagedCustomers";
export const QUALIFIED_LEADS = "qualifiedLeads";
export const CONVERTED_LEADS = "convertedLeads";
export const PAID_SUBSCRIBERS = "paidSubscribers";
export const LOYALTY_SIGN_UPS = "loyaltySignUps";
export const CART_ABANDONERS = "cartAbandoners";
export const NO_HEADERS_TABLE_VALID_NOT_MODIFY_HEADERS_GOOGLE_CUSTOM_AUDIENCE =
  "noHeadersTableValidNotModifyHeadersGoogleCustomAudience";
export const WITH_OUT_PLAN = "withOutPlan";
export const CONFIRMATION_USAGE_TEXT = "confirmationUsageText";
export const SELECT_CONTENT_CONFIRMATION_TEXT = "selectContentConfirmationText";
export const SQUARE_FORMAT = "squareFormat";
export const VERTICAL_FORMAT = "verticalFormat";
export const HORIZONTAL_FORMAT = "horizontalFormat";
export const RESIZE_TO_SQUARE = "resizeToSquare";
export const RESIZE_TO_VERTICAL = "resizeToVertical";
export const RESIZE_TO_HORIZONTAL = "resizeToHorizontal";
export const RESIZE_TO_FEED = "resizeToFeed";
export const RESIZE_MENU_LABEL = "resizeMenuLabel";
export const RESIZING_IMAGES_BATCH_MESSAGE = "resizingImagesBatchMessage";
export const MULTI_FORMAT_RESIZE_FORMATS_COUNT =
  "multiFormatResizeFormatsCount";
export const MULTI_FORMAT_RESIZE_CREDITS_COUNT =
  "multiFormatResizeCreditsCount";
export const MULTI_FORMAT_RESIZE_ONE_FORMAT = "multiFormatResizeOneFormat";
export const MULTI_FORMAT_RESIZE_ONE_CREDIT = "multiFormatResizeOneCredit";
export const RESIZE_CUSTOM = "resizeCustom";
export const MODAL_RESIZE_CUSTOM_TITLE = "modalResizeCustomTitle";
export const MODAL_RESIZE_CUSTOM_DESCRIPTION = "modalResizeCustomDescription";
export const MODAL_RESIZE_CUSTOM_DEFAULT_SIZE_LABEL =
  "modalResizeCustomDefaultSizeLabel";
export const ERROR_RESIZE_DIMENSION_INVALID = "errorResizeDimensionInvalid";
export const ERROR_RESIZE_DIMENSION_MAX_EDGE = "errorResizeDimensionMaxEdge";
export const ERROR_RESIZE_DIMENSION_NOT_MULTIPLE_PREFIX =
  "errorResizeDimensionNotMultiplePrefix";
export const ERROR_RESIZE_DIMENSION_OR = "errorResizeDimensionOr";
export const ERROR_RESIZE_TOTAL_TOO_SMALL = "errorResizeTotalTooSmall";
export const ERROR_RESIZE_TOTAL_TOO_LARGE = "errorResizeTotalTooLarge";
export const ERROR_RESIZE_ASPECT_RATIO_EXCEEDED_PREFIX =
  "errorResizeAspectRatioExceededPrefix";
export const ERROR_RESIZE_ASPECT_RATIO_CHOOSE_OPTION =
  "errorResizeAspectRatioChooseOption";
export const ERROR_RESIZE_ASPECT_RATIO_ADJUST_WIDTH_PREFIX =
  "errorResizeAspectRatioAdjustWidthPrefix";
export const ERROR_RESIZE_ASPECT_RATIO_KEEP_HEIGHT_SUFFIX =
  "errorResizeAspectRatioKeepHeightSuffix";
export const ERROR_RESIZE_ASPECT_RATIO_ADJUST_HEIGHT_PREFIX =
  "errorResizeAspectRatioAdjustHeightPrefix";
export const ERROR_RESIZE_ASPECT_RATIO_KEEP_WIDTH_SUFFIX =
  "errorResizeAspectRatioKeepWidthSuffix";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID =
  "imageResizingCustomDimensionsInvalid";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16 =
  "imageResizingCustomDimensionsWidthNotMultipleOf16";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16 =
  "imageResizingCustomDimensionsHeightNotMultipleOf16";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED =
  "imageResizingCustomDimensionsMaxEdgeExceeded";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED =
  "imageResizingCustomDimensionsAspectRatioExceeded";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS =
  "imageResizingCustomDimensionsTooFewPixels";
export const IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS =
  "imageResizingCustomDimensionsTooManyPixels";
export const IMAGE_TOO_SMALL_FOR_LAYERIZE = "imageTooSmallForLayerize";
export const BUTTON_RESIZE_IMAGE = "buttonResizeImage";
export const MODAL_BATCH_IMAGE_EDIT_TITLE = "modalBatchImageEditTitle";
export const MODAL_BATCH_IMAGE_EDIT_VERSION_LABEL =
  "modalBatchImageEditVersionLabel";
export const MODAL_BATCH_IMAGE_EDIT_PROMPT_PLACEHOLDER =
  "modalBatchImageEditPromptPlaceholder";
export const MODAL_BATCH_IMAGE_EDIT_IMAGE_ALT = "modalBatchImageEditImageAlt";
export const MODAL_BATCH_IMAGE_EDIT_GENERATE = "modalBatchImageEditGenerate";
export const MODAL_BATCH_IMAGE_EDIT_APPLY = "modalBatchImageEditApply";
export const MODAL_BATCH_IMAGE_EDIT_STATUS_PENDING =
  "modalBatchImageEditStatusPending";
export const MODAL_BATCH_IMAGE_EDIT_STATUS_SUCCESS =
  "modalBatchImageEditStatusSuccess";
export const MODAL_BATCH_IMAGE_EDIT_STATUS_ERROR =
  "modalBatchImageEditStatusError";
export const MODAL_BATCH_IMAGE_EDIT_RETRY = "modalBatchImageEditRetry";
export const MODAL_BATCH_IMAGE_EDIT_FAILED_BADGE =
  "modalBatchImageEditFailedBadge";
export const MODAL_BATCH_IMAGE_EDIT_EXPAND = "modalBatchImageEditExpand";
export const MODAL_BATCH_IMAGE_EDIT_BACK_TO_GRID =
  "modalBatchImageEditBackToGrid";
export const MODAL_BATCH_IMAGE_EDIT_FOOTER_ACTION =
  "modalBatchImageEditFooterAction";
export const MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_TITLE =
  "modalBatchImageEditSaveAlertTitle";
export const MODAL_BATCH_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION =
  "modalBatchImageEditSaveAlertDescription";
export const MODAL_BATCH_IMAGE_EDIT_SAVE_AS_NEW_BUTTON =
  "modalBatchImageEditSaveAsNewButton";
export const MODAL_BATCH_IMAGE_EDIT_REPLACE_BUTTON =
  "modalBatchImageEditReplaceButton";
export const EDIT_WITH_CANVA = "editWithCanva";
export const EDIT_WITH_IA = "editWithIA";
export const ANIMATE_IMAGE_WITH_AI = "animateImageWithAI";
export const ANIMATE = "animate";
export const ANIMATE_IMAGE_CONFIRMATION_TITLE = "animateImageConfirmationTitle";
export const ANIMATE_IMAGE_CONFIRMATION_DESCRIPTION =
  "animateImageConfirmationDescription";
export const MODAL_ANIMATE_IMAGE_PREVIEW_TITLE =
  "modalAnimateImagePreviewTitle";
export const MODAL_ANIMATE_IMAGE_PROMPT_LABEL = "modalAnimateImagePromptLabel";
export const MODAL_ANIMATE_IMAGE_PROMPT_PLACEHOLDER =
  "modalAnimateImagePromptPlaceholder";
export const MODAL_ANIMATE_IMAGE_PROMPT_HELPER =
  "modalAnimateImagePromptHelper";
export const MODAL_ANIMATE_IMAGE_PROMPT_MAX_LENGTH =
  "modalAnimateImagePromptMaxLength";
export const ANIMATE_IMAGE_OUTRO_LABEL = "animateImageOutroLabel";
export const ANIMATE_IMAGE_OUTRO_HELPER = "animateImageOutroHelper";
export const ANIMATE_IMAGE_OUTRO_NONE = "animateImageOutroNone";
export const ANIMATE_IMAGE_SAVE_OUTRO = "animateImageSaveOutro";
export const ANIMATE_IMAGE_SAVE_OUTRO_TITLE = "animateImageSaveOutroTitle";
export const ANIMATE_IMAGE_SAVE_OUTRO_SUCCESS = "animateImageSaveOutroSuccess";
export const ANIMATE_IMAGE_SAVE_OUTRO_ERROR = "animateImageSaveOutroError";
export const ANIMATE_IMAGE_OUTRO_FILE = "animateImageOutroFile";
export const ANIMATE_IMAGE_OUTRO_FILE_HINT = "animateImageOutroFileHint";
export const ANIMATE_IMAGE_IMPORT_OUTRO = "animateImageImportOutro";
export const ANIMATE_IMAGE_IMPORT_OUTRO_TITLE = "animateImageImportOutroTitle";
export const ANIMATE_IMAGE_IMPORT_OUTRO_EMPTY = "animateImageImportOutroEmpty";
export const ANIMATE_IMAGE_IMPORT_OUTRO_ERROR = "animateImageImportOutroError";
export const ANIMATE_IMAGE_DELETE_OUTRO = "animateImageDeleteOutro";
export const ANIMATE_IMAGE_DELETE_OUTRO_ERROR = "animateImageDeleteOutroError";
export const ANIMATE_IMAGE_OUTRO_CLEAR = "animateImageOutroClear";
export const ANIMATE_IMAGE_OUTRO_TOO_LARGE = "animateImageOutroTooLarge";
export const ANIMATE_IMAGE_OUTRO_TOO_LONG = "animateImageOutroTooLong";
export const ANIMATE_IMAGE_OUTRO_INVALID_TYPE = "animateImageOutroInvalidType";
export const ANIMATE_IMAGE_USE_SELECTED = "animateImageUseSelected";
export const FORMAT_OPTIONS_TOOLTIP = "formatOptionsTooltip";
export const CHANGES = "changes";
export const EMPTY_CHANGES = "emptyChanges";
export const AD_GROUPS = "adGroups";
export const ADS = "ads";
export const ASSETS_GROUPS = "assetsGroups";
export const ADDED = "added";
export const REMOVED = "removed";
export const IT_WAS_CREATED = "itWasCreated";
export const HISTORICAL_CHANGES = "historicalChanges";
export const LOG_GROUP_AUDIENCE_NETWORK = "logGroupAudienceNetwork";
export const LOG_GROUP_FEEDS = "logGroupFeeds";
export const LOG_GROUP_REELS_STORIES = "logGroupReelsStories";
export const STATUS_DEACTIVATED = "statusDeactivated";
export const STATUS_ACTIVE = "statusActive";
export const STATUS_FINISHED = "statusFinished";
export const N_NUMBER_SELECTED = "NNumberSelected";
export const FILTER_BY_STATUS = "filterByStatus";
export const SELECT_CATALOG_IN_CAMPAIGN_LEVEL = "selectCatalogInCampaignLevel";
export const INTRO_CARD = "introCard";
export const CATALOG_CARD = "catalogCard";
export const PROFILE_CARD = "profileCard";
export const FROM_CATALOG = "fromCatalog";
export const MANUAL_UPLOAD = "manualUpload";
export const SINGLE_IMAGE = "singleImage";
export const SLIDES_SHOW = "slidesShow";
export const MODIFY_CATALOG_LABELS = "modifyCatalogLabels";
export const MODIFY_PRODUCT_TAGS = "modifyProductTags";
export const SOLID = "solid";
export const TRANSPARENT = "transparent";
export const AUTOMATIC_LABELS = "automaticLabels";
export const MANUAL_LABEL = "manualLabel";
export const RECTANGLE = "rectangle";
export const PILL = "pill";
export const CIRCLE = "circle";
export const TRIANGLE = "triangle";
export const TOP_LEFT = "topLeft";
export const TOP_RIGHT = "topRight";
export const BOTTOM_LEFT = "bottomLeft";
export const BOTTOM_RIGHT = "bottomRight";
export const AUTOMATICALLY_TAG_PRODUCTS = "automaticallyTagProducts";
export const INSTANT_EXPERIENCE = "instantExperience";
export const FILTER_BY_NAME = "filterByName";
export const ALL_PRODUCTS = "allProducts";
export const USE_A_SELECTION_OF_PRODUCTS = "useASelectionOfProducts";
export const SELECT_PRODUCTS_BY = "selectProductsBy";
export const CONDITION = "condition";
export const PRODUCT_TYPE = "productType";
export const CHANNEL = "channel";
export const CUSTOM_LABEL = "customLabel";
export const CONDITION_NEW = "conditionNew";
export const CONDITION_USED = "conditionUsed";
export const CONDITION_REFURBISHED = "conditionRefurbished";
export const CHANNEL_ONLINE = "channelOnline";
export const CHANNEL_LOCAL = "channelLocal";
export const ITEM_ID = "itemID";
export const SELECT_ALL = "selectAll";
export const RECOMMENDED_ACTIONS = "recommendedActions";
export const DAY_SLASH_TIME = "daySlashTime";
export const DRAG_THE_MOUSE_TO_SELECT_THE_TIME_PERIOD =
  "dragTheMouseToSelectTheTimePeriod";
export const SELECTED_TIME_PERIOD = "selectedTimePeriod";
export const NO_SELECTION = "noSelection";
export const USER_TIMEZONE = "userTimezone";
export const AD_ACCOUNT_TIMEZONE = "adAccountTimezone";
export const GOOGLE_ORIGIN_APP = "APP";
export const GOOGLE_ORIGIN_CALL_FROM_ADS = "CALL_FROM_ADS";
export const GOOGLE_ORIGIN_GOOGLE_HOSTED = "GOOGLE_HOSTED";
export const GOOGLE_ORIGIN_STORE = "STORE";
export const GOOGLE_ORIGIN_WEBSITE = "WEBSITE";
export const GOOGLE_ORIGIN_YOUTUBE_HOSTED = "YOUTUBE_HOSTED";
export const GOOGLE_CATEGORY_ADD_TO_CART = "ADD_TO_CART";
export const GOOGLE_CATEGORY_BEGIN_CHECKOUT = "BEGIN_CHECKOUT";
export const GOOGLE_CATEGORY_BOOK_APPOINTMENT = "BOOK_APPOINTMENT";
export const GOOGLE_CATEGORY_CONTACT = "CONTACT";
export const GOOGLE_CATEGORY_CONVERTED_LEAD = "CONVERTED_LEAD";
export const GOOGLE_CATEGORY_DEFAULT = "DEFAULT";
export const GOOGLE_CATEGORY_DOWNLOAD = "DOWNLOAD";
export const GOOGLE_CATEGORY_ENGAGEMENT = "ENGAGEMENT";
export const GOOGLE_CATEGORY_GET_DIRECTIONS = "GET_DIRECTIONS";
export const GOOGLE_CATEGORY_IMPORTED_LEAD = "IMPORTED_LEAD";
export const GOOGLE_CATEGORY_OUTBOUND_CLICK = "OUTBOUND_CLICK";
export const GOOGLE_CATEGORY_PAGE_VIEW = "PAGE_VIEW";
export const GOOGLE_CATEGORY_PHONE_CALL_LEAD = "PHONE_CALL_LEAD";
export const GOOGLE_CATEGORY_PURCHASE = "PURCHASE";
export const GOOGLE_CATEGORY_QUALIFIED_LEAD = "QUALIFIED_LEAD";
export const GOOGLE_CATEGORY_REQUEST_QUOTE = "REQUEST_QUOTE";
export const GOOGLE_CATEGORY_SIGNUP = "SIGNUP";
export const GOOGLE_CATEGORY_STORE_SALE = "STORE_SALE";
export const GOOGLE_CATEGORY_STORE_VISIT = "STORE_VISIT";
export const GOOGLE_CATEGORY_SUBMIT_LEAD_FORM = "SUBMIT_LEAD_FORM";
export const GOOGLE_CATEGORY_SUBSCRIBE_PAID = "SUBSCRIBE_PAID";
export const TRACKING_WEBSITE_EVENTS = "trackingWebsiteEvents";
export const TRACKING_EVENTS = "trackingEvents";
export const VALID = "valid";
export const INVALID = "invalid";
export const NOT_READY = "notReady";
export const INSIGHT_APPLIED = "insightApplied";
export const INSIGHT_DISCARDED = "insightDiscarded";
export const MAXIMIZE_CONVERSIONS = "maximizeConversions";
export const MAXIMIZE_CONVERSION_VALUE = "maximizeConversionValue";
export const IN_CURRENCY = "inCurrency";
export const TARGET_CPA_EXPLANATION = "targetCpaExplanation";
export const BID_GOAL_EXPLANATION = "bidGoalExplanation";
export const OPTIMIZATION_GOAL_CONVERSATIONS = "optimizationGoalConversations";
export const OPTIMIZATION_GOAL_VISIT_INSTAGRAM_PROFILE =
  "optimizationGoalVisitInstagramProfile";
export const OPTIMIZATION_GOAL_LINK_CLICKS = "optimizationGoalLinkClicks";
export const OPTIMIZATION_GOAL_THRUPLAY = "optimizationGoalThruplay";
export const OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS =
  "optimizationGoalLandingPageViews";
export const OPTIMIZATION_GOAL_OPTION_REACH = "optimizationGoalOptionReach";
export const OPTIMIZATION_GOAL_OPTION_THRUPLAY =
  "optimizationGoalOptionThruplay";
export const OPTIMIZATION_GOAL_OPTION_LINK_CLICKS =
  "optimizationGoalOptionLinkClicks";
export const OPTIMIZATION_GOAL_OPTION_LANDING_PAGE_VIEWS =
  "optimizationGoalOptionLandingPageViews";
export const OPTIMIZATION_GOAL_PLACEHOLDER = "optimizationGoalPlaceholder";
export const OPTIMIZATION_GOAL_POST_ENGAGEMENT =
  "optimizationGoalPostEngagement";
export const OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS =
  "optimizationGoalOffsiteConversions";
export const OPTIMIZATION_GOAL_LEAD_GENERATION =
  "optimizationGoalLeadGeneration";
export const OPTIMIZATION_GOAL_APP_INSTALLS = "optimizationGoalAppInstalls";
export const OPTIMIZATION_GOAL_CPM = "optimizationGoalCpm";
export const OPTIMIZATION_GOAL_CLICK_TO_APP = "optimizationGoalClickToApp";
export const OPTIMIZATION_GOAL_CONVERSION_IN_APP =
  "optimizationGoalConversionInApp";
export const SYNCING_INFORMATION_NO_EDIT_CLARIFICATION =
  "syncingInformationNoEditClarification";
export const WAIT_FOR_CAMPAIGN_SYNC = "waitForCampaignSync";
export const BRAND_GUIDELINES_ENABLED_CLARIFICATION =
  "brandGuidelinesEnabledClarification";
export const METRICS = "metrics";
export const TIMES_EVERY = "timesEvery";
export const FREQUENCY_CAP_EXPLANATION = "frequencyCapExplanation";
export const FREQUENCY_TARGET_EXPLANATION = "frequencyTargetExplanation";
export const TARGET = "target";
export const TARGET_FREQUENCY_EXPLANATION = "targetFrequencyExplanation";
export const CAP = "cap";
export const CAP_FREQUENCY_EXPLANATION = "capFrequencyExplanation";
export const FREQUENCY_SPECS_CONTROL_PLACEHOLDER =
  "frequencySpecsControlPlaceholder";
export const FREQUENCY_SPECS_CAP_EXPLANATION = "frequencySpecsCapExplanation";
export const FREQUENCY_SPECS_CAP_DESCRIPTION = "frequencySpecsCapDescription";
export const RESERVATION_ESTIMATES = "reservationEstimates";
export const AUDIENCE_ESTIMATES = "audienceEstimates";
export const LOADING_LOCATIONS_IN_MAP = "loadingLocationsInMap";
export const EXPORTING_LOCATIONS_TO_FORM = "exportingLocationsToForm";
export const SUGGESTED_LOCATIONS_TITLE = "suggestedLocationsTitle";
export const LOADING_SUGGESTED_LOCATIONS = "loadingSuggestedLocations";
export const SUGGESTED_LOCATIONS_COUNT = "suggestedLocationsCount";
export const ADD_ALL_LOCATIONS = "addAllLocations";
export const ALL_USERS = "allUsers";
export const ALL_TIME = "allTime";
export const APPLY_OPTIMIZATIONS_WITH_NAME = "applyOptimizationsWithName";
export const VIDEO = "video";
export const IMAGE = "image";
export const DISCONNECTED_ACCOUNT = "disconnectedAccount";
export const CAMPAIGN_ALREADY_BEING_CREATED = "campaignAlreadyBeingCreated";
export const CAMPAIGN_ALREADY_BEING_UPDATED = "campaignAlreadyBeingUpdated";
export const UNKNOWN_VALUE = "unknownValue";
export const TEXT_IN_IMAGE = "textInImage";
export const VIDEO_LANGUAGE = "videoLanguage";
export const LOGO_IN_IMAGE = "logoInImage";
export const LOGO_IN_VIDEO = "logoInVideo";
export const LOGO_IN_VIDEO_DESCRIPTION_LEAD = "logoInVideoDescriptionLead";
export const I_DONT_HAVE_A_WEBSITE = "iDontHaveAWebsite";
export const SET_UP_BRAND = "setUpBrand";
export const OVERLAPS_WITH = "overlapsWith";
export const GENERATION_FAILED = "generationFailed";
export const YOUR_CAMPAIGN_HAS_SOME_DISAPPROVALS =
  "yourCampaignHasSomeDisapprovals";
export const ANALYZING_CONTENT = "analyzingContent";
export const CONTENT_RECOMMENDATIONS = "contentRecommendations";
export const NO_CONTENT_RECOMMENDATIONS = "noContentRecommendations";
export const CONTENT_WARNING_TITLE = "contentWarningTitle";
export const CONTENT_RECOMMENDATIONS_SUBTITLE =
  "contentRecommendationsSubtitle";
export const CONTENT_RECOMMENDATION_OPEN_CREATE_WITH_IA =
  "contentRecommendationOpenCreateWithIA";
export const CONTENT_RECOMMENDATIONS_BANNER_TITLE =
  "contentRecommendationsBannerTitle";
export const CONTENT_RECOMMENDATIONS_BANNER_DESCRIPTION =
  "contentRecommendationsBannerDescription";
export const CONTENT_RECOMMENDATIONS_VIEW_ALL = "contentRecommendationsViewAll";
export const CONTENT_RECOMMENDATIONS_COMPLETED_PROGRESS =
  "contentRecommendationsCompletedProgress";
export const CONTENT_RECOMMENDATION_GENERATED =
  "contentRecommendationGenerated";
export const CONTENT_RECOMMENDATION_GENERATE_ARIA =
  "contentRecommendationGenerateAria";
export const CONTENT_RECOMMENDATIONS_ALL_COMPLETED =
  "contentRecommendationsAllCompleted";
export const BAD = "bad";
export const REGULAR = "regular";
export const GOOD = "good";
export const VERY_GOOD = "veryGood";
export const EXCELLENT = "excellent";
export const FIELD = "field";
export const ID_PLATFORM = "idPlatform";

/*PAYMENTS*/
export const SELECT_PAYMENT_METHOD = "selectPaymentMethod";
export const ADD_PAYMENT_METHOD = "addPaymentMethod";
export const PAYMENT_METHOD = "paymentMethod";
export const PAYMENT_METHODS = "paymentMethods";
export const PAYMENT_METHODS_EMPTY = "paymentMethodsEmpty";
export const MAIN_PAYMENT_METHOD = "mainPaymentMethod";
export const OTHERS_PAYMENT_METHODS = "othersPaymentMethods";
export const OTHERS_PAYMENT_METHODS_EMPTY = "othersPaymentMethodsEmpty";
export const PAYMENT_METHODS_SECURE = "paymentMethodsSecure";
export const PAYMENT_METHODS_SECURE_EXPLANATION =
  "paymentMethodsSecureExplanation";
export const PAYMENT_METHODS_ENCRYPTED = "paymentMethodsEncrypted";
export const PAYMENT_SUCCESSFUL = "paymentSuccessful";
export const UPGRADE_SUBSCRIPTION_SUCCESSFUL = "upgradeSubscriptionSuccessful";
export const PRICE_TO_BE_PAID = "priceToBePaid";
export const PAY = "pay";
export const ADD_CARD = "addCard";
export const VERIFY_SUBSCRIPTION_TITLE = "verifySubscriptionTitle";
export const VERIFY_SUBSCRIPTION_DESCRIPTION = "verifySubscriptionDescription";
export const VERIFY_SUBSCRIPTION_CTA = "verifySubscriptionCta";
export const SAVE_CONFIGURATION = "saveConfiguration";
export const CARD_INFORMATION_EXPLANATION_TITLE =
  "cardInformationExplanationTitle";
export const CARD_INFORMATION_NUMBER_CARD_EXPLANATION_TITLE =
  "cardInformationNumberCardExplanationTitle";
export const CARD_INFORMATION_NUMBER_CARD_EXPLANATION_DESCRIPTION =
  "cardInformationNumberCardExplanationDescription";
export const CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_TITLE =
  "cardInformationExpirationDateExplanationTitle";
export const CARD_INFORMATION_EXPIRATION_DATE_EXPLANATION_DESCRIPTION =
  "cardInformationExpirationDateExplanationDescription";
export const CARD_INFORMATION_CVV_EXPLANATION_TITLE =
  "cardInformationCVVExplanationTitle";
export const CARD_INFORMATION_CVV_EXPLANATION_DESCRIPTION =
  "cardInformationCVVExplanationDescription";
export const YOU_WILL_PAY = "youWillPay";
export const ACCEPT_TERMS_PAY = "acceptTermsPay";
export const DELETE_PAYMENT_METHOD_CONFIRMATION_TITLE =
  "deletePaymentMethodConfirmationTitle";
export const QUANTITY_TO_PAY = "quantityToPay";

/*FIELDS PLACEHOLDERS*/
export const NAME_PLACEHOLDER = "namePlaceholder";
export const EMAIL_PLACEHOLDER = "emailPlaceholder";
export const PASSWORD_PLACEHOLDER = "passwordPlaceholder";
export const PASSWORD_CONFIRMATION_PLACEHOLDER =
  "passwordConfirmationPlaceholder";
export const SELECT_BUSINESS_PLACEHOLDER = "selectBusinessPlaceholder";
export const NAME_BUSINESS_PLACEHOLDER = "nameBusinessPlaceholder";
export const SELECT_BRANDS_PLACEHOLDER = "selectBrandsPlaceholder";
export const MAIN_BRAND_PLACEHOLDER = "mainBrandPlaceholder";
export const SELECT_BRAND_PLACEHOLDER = "selectBrandPlaceholder";
export const SELECT_STORE_PLACEHOLDER = "selectStorePlaceholder";
export const NAME_AND_LAST_NAME_PLACEHOLDER = "nameAndLastNamePlaceholder";
export const SELECT_TYPE_PLAN_PLACEHOLDER = "selectTypePlanPlaceholder";
export const COST_COLLABORATION_PLACEHOLDER = "costCollaborationPlaceholder";
export const CREDITS_PLACEHOLDER = "creditsPlaceholder";
export const TRIAL_DAYS_PLACEHOLDER = "trialDaysPlaceholder";
export const TYPE_PACKAGE_PLACEHOLDER = "typePackagePlaceholder";
export const PRICE_BASIC_PLACEHOLDER = "priceBasicPlaceholder";
export const COST_COLLABORATION_BASIC_PLACEHOLDER =
  "costCollaborationBasicPlaceholder";
export const PRICE_PRO_PLACEHOLDER = "priceProPlaceholder";
export const COST_COLLABORATION_PRO_PLACEHOLDER =
  "costCollaborationProPlaceholder";
export const PRICE_GROWTH_PLACEHOLDER = "priceGrowthPlaceholder";
export const COST_COLLABORATION_GROWTH_PLACEHOLDER =
  "costCollaborationGrowthPlaceholder";
export const COMMERCIAL_PLACEHOLDER = "commercialPlaceholder";
export const BUSINESS_NAME_PLACEHOLDER = "businessNamePlaceholder";
export const BUSINESS_DESCRIPTION_PLACEHOLDER =
  "businessDescriptionPlaceholder";
export const BUSINESS_TEXT_STYLE_PLACEHOLDER = "businessTextStylePlaceholder";
export const BUSINESS_LOOK_AND_FEEL_PLACEHOLDER =
  "businessLookAndFeelPlaceholder";
export const LOOK_AND_FEEL_PLACEHOLDER = "lookAndFeelPlaceholder";
export const BUSINESS_OFFERING_PLACEHOLDER = "businessOfferingPlaceholder";
export const BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER =
  "businessOfferingPhysicalProductPlaceholder";
export const BUSINESS_OFFERING_SERVICES_PLACEHOLDER =
  "businessOfferingServicesPlaceholder";
export const DESCRIPTION_OPTIONAL_PLACEHOLDER =
  "descriptionOptionalPlaceholder";
export const PRICE_PLACEHOLDER = "pricePlaceholder";
export const CURRENCY_PLACEHOLDER = "currencyPlaceholder";
export const IS_RECURRENCE_PLACEHOLDER = "isRecurrencePlaceholder";
export const RECURRENCE_PLACEHOLDER = "recurrencePlaceholder";
export const START_DATE_PLACEHOLDER = "startDatePlaceholder";
export const END_DATE_PLACEHOLDER = "endDatePlaceholder";
export const SELECT_CAMPAIGN_PLACEHOLDER = "selectCampaignPlaceholder";
export const SELECT_UGC_CONTENT_FORMAT = "selectUgcContentFormat";
export const SELECT_SOME_OPTIONS = "selectSomeOptions";
export const OBJECTIVE_PLACEHOLDER = "objectivePlaceholder";
export const PLATFORMS_PLACEHOLDER = "platformsPlaceholder";
export const PLATFORM_PLACEHOLDER = "platformPlaceholder";
export const TYPE_BUDGET_PLACEHOLDER = "typeBudgetPlaceholder";
export const BUDGET_PLACEHOLDER = "budgetPlaceholder";
export const DAILY_BUDGET_PLACEHOLDER = "dailyBudgetPlaceholder";
export const LIFETIME_BUDGET_PLACEHOLDER = "lifetimeBudgetPlaceholder";
export const LOCATIONS_PLACEHOLDER = "locationsPlaceholder";
export const EXCLUDED_LOCATIONS_PLACEHOLDER = "excludedLocationsPlaceholder";
export const AGE_RANGE_PLACEHOLDER = "ageRangePlaceholder";
export const GENDERS_PLACEHOLDER = "gendersPlaceholder";
export const INTERESTS_PLACEHOLDER = "interestsPlaceholder";
export const BEHAVIORS_PLACEHOLDER = "behaviorsPlaceholder";
export const DEMOGRAPHICS_PLACEHOLDER = "demographicsPlaceholder";
export const INDUSTRIES_PLACEHOLDER = "industriesPlaceholder";
export const JOB_FUNCTIONS_PLACEHOLDER = "jobFunctionsPlaceholder";
export const SENIORITIES_PLACEHOLDER = "senioritiesPlaceholder";
export const JOB_TITLES_PLACEHOLDER = "jobTitlesPlaceholder";
export const COMPANY_SIZES_PLACEHOLDER = "companySizesPlaceholder";
export const COMPANIES_PLACEHOLDER = "companiesPlaceholder";
export const DEGREES_PLACEHOLDER = "degreesPlaceholder";
export const FIELDS_OF_STUDY_PLACEHOLDER = "fieldsOfStudyPlaceholder";
export const SCHOOLS_PLACEHOLDER = "schoolsPlaceholder";
export const SKILLS_PLACEHOLDER = "skillsPlaceholder";
export const MEMBER_TRAITS_PLACEHOLDER = "memberTraitsPlaceholder";
export const MEMBER_BEHAVIORS_PLACEHOLDER = "memberBehaviorsPlaceholder";
export const MEMBER_GROUPS_PLACEHOLDER = "memberGroupsPlaceholder";
export const AUDIENCE_ATTRIBUTES_PLACEHOLDER = "audienceAttributesPlaceholder";

// LinkedIn segmentation search placeholders (examples for autocomplete fields)
export const DEGREES_SEARCH_PLACEHOLDER = "degreesSearchPlaceholder";
export const FIELDS_OF_STUDY_SEARCH_PLACEHOLDER =
  "fieldsOfStudySearchPlaceholder";
export const INTERESTS_SEARCH_PLACEHOLDER = "interestsSearchPlaceholder";
export const SCHOOLS_SEARCH_PLACEHOLDER = "schoolsSearchPlaceholder";
export const SKILLS_SEARCH_PLACEHOLDER = "skillsSearchPlaceholder";
export const COMPANIES_SEARCH_PLACEHOLDER = "companiesSearchPlaceholder";
export const INDUSTRIES_SEARCH_PLACEHOLDER = "industriesSearchPlaceholder";
export const COMPANY_SIZES_SEARCH_PLACEHOLDER = "companySizesSearchPlaceholder";
export const JOB_FUNCTIONS_SEARCH_PLACEHOLDER = "jobFunctionsSearchPlaceholder";
export const JOB_TITLES_SEARCH_PLACEHOLDER = "jobTitlesSearchPlaceholder";
export const SENIORITIES_SEARCH_PLACEHOLDER = "senioritiesSearchPlaceholder";
export const MEMBER_BEHAVIORS_SEARCH_PLACEHOLDER =
  "memberBehaviorsSearchPlaceholder";

// LinkedIn targeting - Company sizes (staffCountRanges)
export const LINKEDIN_STAFF_COUNT_MYSELF_ONLY = "linkedinStaffCountMyselfOnly";
export const LINKEDIN_STAFF_COUNT_2_10 = "linkedinStaffCount2_10";
export const LINKEDIN_STAFF_COUNT_11_50 = "linkedinStaffCount11_50";
export const LINKEDIN_STAFF_COUNT_51_200 = "linkedinStaffCount51_200";
export const LINKEDIN_STAFF_COUNT_201_500 = "linkedinStaffCount201_500";
export const LINKEDIN_STAFF_COUNT_501_1000 = "linkedinStaffCount501_1000";
export const LINKEDIN_STAFF_COUNT_1001_5000 = "linkedinStaffCount1001_5000";
export const LINKEDIN_STAFF_COUNT_5001_10000 = "linkedinStaffCount5001_10000";
export const LINKEDIN_STAFF_COUNT_10001_PLUS = "linkedinStaffCount10001Plus";

// LinkedIn targeting - Job functions
export const LINKEDIN_JOB_FUNCTION_ACCOUNTING = "linkedinJobFunctionAccounting";
export const LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE =
  "linkedinJobFunctionAdministrative";
export const LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN =
  "linkedinJobFunctionArtsAndDesign";
export const LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT =
  "linkedinJobFunctionBusinessDevelopment";
export const LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES =
  "linkedinJobFunctionCommunityAndSocialServices";
export const LINKEDIN_JOB_FUNCTION_CONSULTING = "linkedinJobFunctionConsulting";
export const LINKEDIN_JOB_FUNCTION_EDUCATION = "linkedinJobFunctionEducation";
export const LINKEDIN_JOB_FUNCTION_ENGINEERING =
  "linkedinJobFunctionEngineering";
export const LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP =
  "linkedinJobFunctionEntrepreneurship";
export const LINKEDIN_JOB_FUNCTION_FINANCE = "linkedinJobFunctionFinance";
export const LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES =
  "linkedinJobFunctionHealthcareServices";
export const LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES =
  "linkedinJobFunctionHumanResources";
export const LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY =
  "linkedinJobFunctionInformationTechnology";
export const LINKEDIN_JOB_FUNCTION_LEGAL = "linkedinJobFunctionLegal";
export const LINKEDIN_JOB_FUNCTION_MARKETING = "linkedinJobFunctionMarketing";
export const LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION =
  "linkedinJobFunctionMediaAndCommunication";
export const LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES =
  "linkedinJobFunctionMilitaryAndProtectiveServices";
export const LINKEDIN_JOB_FUNCTION_OPERATIONS = "linkedinJobFunctionOperations";
export const LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT =
  "linkedinJobFunctionProductManagement";
export const LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT =
  "linkedinJobFunctionProgramAndProjectManagement";
export const LINKEDIN_JOB_FUNCTION_PURCHASING = "linkedinJobFunctionPurchasing";
export const LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE =
  "linkedinJobFunctionQualityAssurance";
export const LINKEDIN_JOB_FUNCTION_REAL_ESTATE =
  "linkedinJobFunctionRealEstate";
export const LINKEDIN_JOB_FUNCTION_RESEARCH = "linkedinJobFunctionResearch";
export const LINKEDIN_JOB_FUNCTION_SALES = "linkedinJobFunctionSales";
export const LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT =
  "linkedinJobFunctionCustomerSuccessAndSupport";

// LinkedIn targeting - Seniorities
export const LINKEDIN_SENIORITY_UNPAID = "linkedinSeniorityUnpaid";
export const LINKEDIN_SENIORITY_TRAINING = "linkedinSeniorityTraining";
export const LINKEDIN_SENIORITY_ENTRY = "linkedinSeniorityEntry";
export const LINKEDIN_SENIORITY_SENIOR = "linkedinSenioritySenior";
export const LINKEDIN_SENIORITY_MANAGER = "linkedinSeniorityManager";
export const LINKEDIN_SENIORITY_DIRECTOR = "linkedinSeniorityDirector";
export const LINKEDIN_SENIORITY_VP = "linkedinSeniorityVP";
export const LINKEDIN_SENIORITY_CXO = "linkedinSeniorityCXO";
export const LINKEDIN_SENIORITY_PARTNER = "linkedinSeniorityPartner";
export const LINKEDIN_SENIORITY_OWNER = "linkedinSeniorityOwner";

// LinkedIn targeting - Member behaviors
export const LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS =
  "linkedinMemberBehaviorFrequentTravelers";
export const LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS =
  "linkedinMemberBehaviorJobSeekers";
export const LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION =
  "linkedinMemberBehaviorOpenToEducation";
export const LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS =
  "linkedinMemberBehaviorFrequentContributors";
export const LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED =
  "linkedinMemberBehaviorRecentlyRelocated";
export const LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED =
  "linkedinMemberBehaviorRecentlyPromoted";
export const LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS =
  "linkedinMemberBehaviorCareerChangers";
export const LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS =
  "linkedinMemberBehaviorRecentlySwitchedJobs";
export const LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION =
  "linkedinMemberBehaviorOpenToRelocation";
export const LINKEDIN_MEMBER_BEHAVIOR_EXPAT = "linkedinMemberBehaviorExpat";
export const LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS =
  "linkedinMemberBehaviorMobileUsers";
export const LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS =
  "linkedinMemberBehaviorDesktopLaptopUsers";
export const LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS =
  "linkedinMemberBehaviorDomesticFrequentTravelers";
export const LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS =
  "linkedinMemberBehaviorInternationalFrequentTravelers";
export const LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC =
  "linkedinMemberBehaviorRecentlyRelocatedDomestic";
export const LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL =
  "linkedinMemberBehaviorRecentlyRelocatedInternational";
export const LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC =
  "linkedinMemberBehaviorOpenToRelocationDomestic";
export const LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL =
  "linkedinMemberBehaviorOpenToRelocationInternational";
export const LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS =
  "linkedinMemberBehaviorAndroidUsers";
export const LINKEDIN_MEMBER_BEHAVIOR_WINDOWS = "linkedinMemberBehaviorWindows";
export const LINKEDIN_MEMBER_BEHAVIOR_MAC = "linkedinMemberBehaviorMac";
export const LINKEDIN_MEMBER_BEHAVIOR_LINUX = "linkedinMemberBehaviorLinux";

export const BUDGET_CONFIGURATION_PLACEHOLDER =
  "budgetConfigurationPlaceholder";
export const BUDGET_CAMPAIGN_DATES_PLACEHOLDER =
  "budgetCampaignDatesPlaceholder";
export const DESTINATION_TYPE_PLACEHOLDER = "destinationTypePlaceholder";
export const DEMOGRAPHICS_BASIC_PLACEHOLDER = "demographicsBasicPlaceholder";
export const CUSTOM_AUDIENCES_PLACEHOLDER = "customAudiencesPlaceholder";
export const CUSTOM_PLACEMENTS_PLACEHOLDER = "customPlacementsPlaceholder";
export const EXCLUDED_CUSTOM_AUDIENCES_PLACEHOLDER =
  "excludedCustomAudiencesPlaceholder";
export const KEYWORDS_PLACEHOLDER = "keywordsPlaceholder";
export const KEYWORDS_NEGATIVE_PLACEHOLDER = "keywordsNegativePlaceholder";
export const DESCRIPTION_PLACEHOLDER = "descriptionPlaceholder";
export const LONG_HEADLINE_PLACEHOLDER = "longHeadlinePlaceholder";
export const TRACKING_META_ID_PLACEHOLDER = "trackingMetaIdPlaceholder";
export const TRACKING_TIKTOK_ID_PLACEHOLDER = "trackingTikTokIdPlaceholder";
export const TRACKING_GOOGLE_ID_PLACEHOLDER = "trackingGoogleIdPlaceholder";
export const TRACKING_LINKEDIN_ID_PLACEHOLDER = "trackingLinkedinIdPlaceholder";
export const TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER =
  "trackingCustomEventIdMetaPlaceholder";
export const TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER =
  "trackingCustomEventIdTikTokPlaceholder";
export const TRACKING_CUSTOM_EVENT_ID_GOOGLE_PLACEHOLDER =
  "trackingCustomEventIdGooglePlaceholder";
export const TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER =
  "trackingCustomEventIdLinkedinPlaceholder";
export const DESTINATION_URL_PLACEHOLDER = "destinationUrlPlaceholder";
export const CREATOR_BODY_BUILD_PLACEHOLDER = "creatorBodyBuildPlaceholder";
export const CREATOR_CLOTHING_STYLE_PLACEHOLDER =
  "creatorClothingStylePlaceholder";
export const CREATOR_CONTENT_STYLE_PLACEHOLDER =
  "creatorContentStylePlaceholder";
export const CREATOR_DISTINGUISHING_FEATURES_PLACEHOLDER =
  "creatorDistinguishingFeaturesPlaceholder";
export const CALL_TO_ACTION_PLACEHOLDER = "callToActionPlaceholder";
export const CHOOSE_AN_ADDRESS_PLACEHOLDER = "chooseAnAddressPlaceholder";
export const CALL_TO_ACTIONS_PLACEHOLDER = "callToActionsPlaceholder";
export const ADS_CAMPAIGN_CONTEXT = "adsCampaignContext";
export const TITLE_PLACEHOLDER = "titlePlaceholder";
export const HEADLINE_PLACEHOLDER = "headlinePlaceholder";
export const WEBSITE_URL_PLACEHOLDER = "websiteUrlPlaceholder";
export const LANGUAGE_CAMPAIGN_PLACEHOLDER = "languagePlaceholder";
export const LANGUAGE_PLACEHOLDER = "languagePlaceholder";
export const VERIFICATION_CODE_PLACEHOLDER = "verificationCodePlaceholder";
export const TYPE_PLACEHOLDER = "typePlaceholder";
export const RETENTION_DAYS_PLACEHOLDER = "retentionDaysPlaceholder";
export const IDENTITY_TIK_TOK_PLACEHOLDER = "identityTikTokPlaceholder";
export const PROFILE_NAME_PLACEHOLDER = "profileNamePlaceholder";
export const PROFILE_IMAGE_PLACEHOLDER = "profileImagePlaceholder";
export const AD_ACCOUNT_META_PLACEHOLDER = "adAccountMetaPlaceholder";
export const AD_ACCOUNT_TIKTOK_PLACEHOLDER = "adAccountTikTokPlaceholder";
export const AD_ACCOUNT_GOOGLE_PLACEHOLDER = "adAccountGooglePlaceholder";
export const AD_ACCOUNT_LINKEDIN_PLACEHOLDER = "adAccountLinkedinPlaceholder";
export const LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER =
  "linkedinAccountSharePlaceholder";
export const LINKEDIN_PUBLISH_AS_PERSONAL_LABEL =
  "linkedinPublishAsPersonalLabel";
export const LINKEDIN_PUBLISH_AS_COMPANY_PAGE_LABEL =
  "linkedinPublishAsCompanyPageLabel";
export const PAGE_FACEBOOK_PLACEHOLDER = "pageFacebookPlaceholder";
export const INSTAGRAM_ACCOUNT_PLACEHOLDER = "instagramAccountPlaceholder";
export const USE_FB_PAGE_AS_IG = "useFbPageAsIg";
export const YOUTUBE_ACCOUNT_PLACEHOLDER = "youtubeAccountPlaceholder";
export const YOUTUBE_PRIVACY_LEVEL_PUBLIC = "youtubePrivacyLevelPublic";
export const YOUTUBE_PRIVACY_LEVEL_UNLISTED = "youtubePrivacyLevelUnlisted";
export const YOUTUBE_PRIVACY_LEVEL_PRIVATE = "youtubePrivacyLevelPrivate";
export const YOUTUBE_PRIVACY_LEVEL_LABEL = "youtubePrivacyLevelLabel";
export const YOUTUBE_TITLE_LABEL = "youtubeTitleLabel";
export const YOUTUBE_DESCRIPTION_LABEL = "youtubeDescriptionLabel";
export const YOUTUBE_NOTIFY_SUBSCRIBERS_LABEL = "youtubeNotifySubscribersLabel";
export const YOUTUBE_MADE_FOR_KIDS_LABEL = "youtubeMadeForKidsLabel";
export const FORMAT_PLACEHOLDER = "formatPlaceholder";
export const ADVERTISER_SELECTOR_BRANDS_COUNT = "advertiserSelectorBrandsCount";
export const ADVERTISER_SELECTOR_BRANDS_COUNT_SINGLE =
  "advertiserSelectorBrandsCountSingle";
export const ADVERTISER_SELECTOR_NO_RESULTS = "advertiserSelectorNoResults";
export const ADVERTISER_SELECTOR_SEARCH_PLACEHOLDER =
  "advertiserSelectorSearchPlaceholder";
export const ADVERTISER_SELECTOR_TRY_ANOTHER_NAME =
  "advertiserSelectorTryAnotherName";
export const ADVERTISER_SELECTOR_CONFIGURE_LIMITS_BUTTON =
  "advertiserSelectorConfigureLimitsButton";
export const SELECT_ADVERTISER_ID_PLACEHOLDER = "selectAdvertiserIDPlaceholder";
export const SOCIAL_NETWORK_URL_PLACEHOLDER = "socialNetworkUrlPlaceholder";
export const DISCOUNT_CODE_PLACEHOLDER = "discountCodePlaceholder";
export const WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER =
  "whatsappBusinessNumberPlaceholder";
export const BRAND_INSTAGRAM_PROFILE_URL_PLACEHOLDER =
  "brandInstagramProfileUrlPlaceholder";
export const INSTAGRAM_PROFILE_URL_PLACEHOLDER =
  "instagramProfileUrlPlaceholder";
export const SCRIPT_PLACEHOLDER = "scriptPlaceholder";
export const CAMPAIGN_TYPE_PLACEHOLDER = "campaignTypePlaceholder";
export const META_DESTINATION_TYPE_PLACEHOLDER =
  "metaDestinationTypePlaceholder";
export const WELCOME_MESSAGE_TEMPLATE_PLACEHOLDER =
  "welcomeMessageTemplatePlaceholder";
export const GREETING_MESSAGE_PLACEHOLDER = "greetingMessagePlaceholder";
export const CUSTOMER_TYPE_MESSAGE_PLACEHOLDER =
  "customerTypeMessagePlaceholder";
export const CUSTOMER_TYPE_PREFILL_MESSAGE = "customerTypePrefillMessage";
export const CUSTOMER_TYPE_QUICK_QUESTIONS_MESSAGE =
  "customerTypeQuickQuestionsMessage";
export const CUSTOMER_TEXT_PLACEHOLDER = "customerTextPlaceholder";
export const CUSTOMER_TEXTS_PLACEHOLDER = "customerTextsPlaceholder";
export const LOG_MESSAGE_TEMPLATE_CUSTOMER_TEXTS =
  "logMessageTemplateCustomerTexts";
export const ROLE_PLACEHOLDER = "rolePlaceholder";
export const INSTANT_FORM_PLACEHOLDER = "instantFormPlaceholder";
export const TIKTOK_LEAD_DESTINATION_WEBSITE = "tiktokLeadDestinationWebsite";
export const TIKTOK_LEAD_DESTINATION_INSTANT_FORM =
  "tiktokLeadDestinationInstantForm";
export const TIKTOK_INSTANT_FORM_EDITOR_HINT = "tiktokInstantFormEditorHint";
export const TIKTOK_INSTANT_FORM_CREATE = "tiktokInstantFormCreate";
export const TIKTOK_INSTANT_FORM_EDITOR_FAILED =
  "tiktokInstantFormEditorFailed";
export const INTEGRATION_MISSING_PERMISSION = "integrationMissingPermission";
export const TIKTOK_INSTANT_FORM_LOCKED_DESTINATION =
  "tiktokInstantFormLockedDestination";
export const TIKTOK_CAROUSEL_REQUIRES_TIKTOK_PLACEMENT =
  "tiktokCarouselRequiresTiktokPlacement";
export const TIKTOK_INSTANT_FORM_PREVIEW_NAME = "tiktokInstantFormPreviewName";
export const CREATE_ADS_CAMPAIGN_TIKTOK_LEAD_DESTINATION_QUESTION =
  "createAdsCampaignTiktokLeadDestinationQuestion";
export const CREATE_ADS_CAMPAIGN_TIKTOK_INSTANT_FORM_QUESTION =
  "createAdsCampaignTiktokInstantFormQuestion";
export const WHY_WOULD_IT_WORK = "whyWouldItWork";
export const INSTANT_FORM_SECTION_FORM_TYPE = "instantFormSectionFormType";
export const INSTANT_FORM_SECTION_INTRO = "instantFormSectionIntro";
export const INSTANT_FORM_SECTION_QUESTIONS = "instantFormSectionQuestions";
export const INSTANT_FORM_SECTION_END = "instantFormSectionEnd";
export const INSTANT_FORM_FIELD_HEADLINE = "instantFormFieldHeadline";
export const INSTANT_FORM_FIELD_DESCRIPTION = "instantFormFieldDescription";
export const INSTANT_FORM_FIELD_CTA = "instantFormFieldCta";
export const ENTER_ANSWER_PLACEHOLDER = "enterAnswerPlaceholder";
export const CONVERSION_ACTIONS_PLACEHOLDER = "conversionActionsPlaceholder";
export const SEARCH_KEYWORDS_PLACEHOLDER = "searchKeywordsPlaceholder";
export const IMAGES_OF_CAMPAIGN_PLACEHOLDER = "imagesOfCampaignPlaceholder";
export const LOGO_URLS_PLACEHOLDER = "logoUrlsPlaceholder";
export const VIDEOS_OF_CAMPAIGN_PLACEHOLDER = "videosOfCampaignPlaceholder";
export const LOGO_OF_THE_BRAND_PLACEHOLDER = "logoOfTheBrandPlaceholder";
export const NETWORK_DISPLAY_SETTING_PLACEHOLDER = "networkDisplaySetting";
export const REPORT_BREAKDOWN_PLACEHOLDER = "reportBreakdownPlaceholder";
export const ADS_CAMPAIGN_CONTEXT_PLACEHOLDER = "adsCampaignContextPlaceholder";
export const ADS_CAMPAIGN_LANGUAGE_PLACEHOLDER =
  "adsCampaignLanguagePlaceholder";
export const ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER =
  "adsCampaignLanguageSelectPlaceholder";
export const ADS_CAMPAIGN_LOCATION_PLACEHOLDER =
  "adsCampaignLocationPlaceholder";
export const ADS_CAMPAIGN_PLATFORMS_PLACEHOLDER =
  "adsCampaignPlatformsPlaceholder";
export const SOCIAL_NETWORKS_PLACEHOLDER = "socialNetworksPlaceholder";
export const BUSINESS_COMPETITORS_PLACEHOLDER =
  "businessCompetitorsPlaceholder";
export const FIND_A_LOCATION_PLACEHOLDER = "findALocationPlaceholder";
export const CREATIVE_TYPE_PLACEHOLDER = "creativeTypePlaceholder";
export const ADVANTAGE_CREATIVE_ENHANCES_PLACEHOLDER =
  "advantageCreativeEnhancesPlaceholder";
export const SITE_LINKS_PLACEHOLDER = "siteLinksPlaceholder";
export const SITE_LINK_PLACEHOLDER = "siteLinkPlaceholder";
export const SITE_LINK_TEXT_PLACEHOLDER = "siteLinkTextPlaceholder";
export const SITE_LINK_DESCRIPTION_PLACEHOLDER =
  "siteLinkDescriptionPlaceholder";
export const SITE_LINK_FINAL_URL_PLACEHOLDER = "siteLinkFinalUrlPlaceholder";
export const SITE_LINK_DESCRIPTIONS_PLACEHOLDER =
  "siteLinkDescriptionsPlaceholder";
export const CALLOUTS_PLACEHOLDER = "calloutsPlaceholder";
export const CALLOUT_TEXT_PLACEHOLDER = "calloutTextPlaceholder";
export const KEYWORD_PLACEHOLDER = "keywordPlaceholder";
export const KEYWORD_MATCH_TYPE_PLACEHOLDER = "keywordMatchTypePlaceholder";
export const KEYWORD_TYPE_NORMAL = "keywordTypeNormal";
export const KEYWORD_TYPE_NEGATIVE = "keywordTypeNegative";
export const FROM_PLACEHOLDER = "fromPlaceholder";
export const SEARCH_THEMES_PLACEHOLDER = "searchThemesPlaceholder";
export const STATUS_PLACEHOLDER = "statusPlaceholder";
export const USE_CAMPAIGN_BUDGET_PLACEHOLDER = "useCampaignBudgetPlaceholder";
export const DESTINATION_TYPE_AD_PLACEHOLDER = "destinationTypeAdPlaceholder";
export const DATA_TYPE_PLACEHOLDER = "dataTypePlaceholder";
export const CUSTOMER_TYPES_PLACEHOLDER = "customerTypesPlaceholder";
export const FIRST_NAME_PLACEHOLDER = "firstNamePlaceholder";
export const LAST_NAME_PLACEHOLDER = "lastNamePlaceholder";
export const COUNTRY_CODE_PLACEHOLDER = "countryCodePlaceholder";
export const POSTAL_CODE_PLACEHOLDER = "postalCodePlaceholder";
export const PHONE_PLACEHOLDER = "phonePlaceholder";
export const BUSINESS_LOGO = "businessLogo";
export const SELECT_RANGE_DATE_PLACEHOLDER = "selectRangeDatePlaceholder";
export const MEDIA_URLS_PLACEHOLDER = "mediaUrlsPlaceholder";
export const CATALOG_PLACEHOLDER = "catalogPlaceholder";
export const IS_CATALOG_CAMPAIGN_PLACEHOLDER = "isCatalogCampaignPlaceholder";
export const PROMOTED_PRODUCTS_PLACEHOLDER = "promotedProductsPlaceholder";
export const PRODUCT_SET = "productSet";
export const PRODUCT_SET_PLACEHOLDER = "productSetPlaceholder";
export const PRODUCT_CONFIGURATION_PLACEHOLDER =
  "productConfigurationPlaceholder";
export const PRODUCT_LIST = "productList";
export const PRODUCT_LIST_PLACEHOLDER = "productListPlaceholder";
export const BUTTON_ADD_PRODUCTS = "buttonAddProducts";
export const MODAL_PRODUCT_LIST_TIKTOK_TITLE = "modalProductListTikTokTitle";
export const MODAL_PRODUCT_LIST_TIKTOK_DESCRIPTION =
  "modalProductListTikTokDescription";
export const SEARCH_PRODUCT_PLACEHOLDER = "searchProductPlaceholder";
export const BRAND_PLACEHOLDER = "brandPlaceholder";
export const RETAILER_ID_PLACEHOLDER = "retailerIdPlaceholder";
export const SHORT_DESCRIPTION_PLACEHOLDER = "shortDescriptionPlaceholder";
export const CURRENT_PRICE_PLACEHOLDER = "currentPricePlaceholder";
export const UNIT_PRICE_PLACEHOLDER = "unitPricePlaceholder";
export const CUSTOM_LABEL_NUMBER_PLACEHOLDER = "customLabelNumberPlaceholder";
export const CUSTOM_NUMBER_PLACEHOLDER = "customNumberPlaceholder";
export const URL_PLACEHOLDER = "urlPlaceholder";
export const CREATIVE_FROM_PLACEHOLDER = "creativeFromPlaceholder";
export const EDIT_CREATIVE_TOOLS_PLACEHOLDER = "editCreativeToolsPlaceholder";
export const OVERLAY_TYPE_PLACEHOLDER = "overlayTypePlaceholder";
export const OVERLAY_POSITION_PLACEHOLDER = "overlayPositionPlaceholder";
export const OVERLAY_SHAPE_PLACEHOLDER = "overlayShapePlaceholder";
export const OVERLAY_COLOR_PLACEHOLDER = "overlayColorPlaceholder";
export const OVERLAY_OPACITY_PLACEHOLDER = "overlayOpacityPlaceholder";
export const OVERLAY_FONT_PLACEHOLDER = "overlayFontPlaceholder";
export const PRICE_LABEL_PLACEHOLDER = "priceLabelPlaceholder";
export const AUTO_SHOW_LABEL_PLACEHOLDER = "autoShowLabelPlaceholder";
export const LABEL_TEXT_PLACEHOLDER = "labelTextPlaceholder";
export const STRIKETHROUGH_PRICE_PLACEHOLDER = "strikethroughPricePlaceholder";
export const PERCENTAGE_OFF_PLACEHOLDER = "percentageOffPlaceholder";
export const FREE_SHIPPING_PLACEHOLDER = "freeShippingPlaceholder";
export const OVERLAY_TEXT_COLOR_PLACEHOLDER = "overlayTextColorPlaceholder";
export const OVERLAY_TEXT_FONT_PLACEHOLDER = "overlayTextFontPlaceholder";
export const ONLY_SHOW_LABEL_WHEN_INCREASE_ENGAGEMENT =
  "onlyShowLabelWhenIncreaseEngagement";
export const APP_PLACEHOLDER = "appPlaceholder";
export const ANDROID_DEEP_LINK_PLACEHOLDER = "androidDeepLinkPlaceholder";
export const IOS_DEEP_LINK_PLACEHOLDER = "iosDeepLinkPlaceholder";
export const INSTANT_EXPERIENCE_PLACEHOLDER = "instantExperiencePlaceholder";
export const DEEP_DESTINATION_APP_URL_PLACEHOLDER =
  "deepDestinationAppUrlPlaceholder";
export const CUSTOM_STORE_LISTING_ID_PLACEHOLDER =
  "customStoreListingIdPlaceholder";
export const CUSTOM_PRODUCT_PAGE_ID_PLACEHOLDER =
  "customProductPageIdPlaceholder";
export const IOS_14_CAMPAIGN_PLACEHOLDER = "ios14CampaignPlaceholder";
export const UTM_PARAMETERS_PLACEHOLDER = "utmParametersPlaceholder";
export const MERCHANT_CENTER_ID_PLACEHOLDER = "merchantCenterIDPlaceholder";
export const PRODUCTS_TO_PROMOTE_PLACEHOLDER = "productsToPromotePlaceholder";
export const ADS_SCHEDULE_PLACEHOLDER = "adsSchedulePlaceholder";
export const ADS_SCHEDULE_ALWAYS_ON = "adsScheduleAlwaysOn";
export const TIMEZONE_PLACEHOLDER = "timezonePlaceholder";
export const AD_SCHEDULE_PLACEHOLDER = "adSchedulePlaceholder";
export const SEARCH_BY_NAME_PLACEHOLDER = "searchByNamePlaceholder";
export const PLACEMENTS_PLACEHOLDER = "placementsPlaceholder";
export const DEVICES_PLACEHOLDER = "devicesPlaceholder";
export const CREATIVE_SOURCE_PLACEHOLDER = "creativeSourcePlaceholder";
export const MANUAL_UPLOAD_PLACEHOLDER = "manualUploadPlaceholder";
export const ADVANTAGE_CATALOG_PLACEHOLDER = "advantageCatalogPlaceholder";
export const DESTINATION_DEEP_LINK_CONFIGURATION_PLACEHOLDER =
  "destinationDeepLinkConfigurationPlaceholder";
export const COVER_CONTENT_PLACEHOLDER = "coverContentPlaceholder";
export const SEARCH_PLACEHOLDER = "searchPlaceholder";
export const OFFLINE_EVENTS_PLACEHOLDER = "offlineEventsPlaceholder";
export const DEEP_LINK_PLACEHOLDER = "deepLinkPlaceholder";
export const SIZE_FOR_DISPLAY_PLACEHOLDER = "sizeForDisplayPlaceholder";
export const SIZE_FOR_SEARCH_PLACEHOLDER = "sizeForSearchPlaceholder";
export const SIZE_PLACEHOLDER = "sizePlaceholder";
export const MAXIMUM_COST_PER_CLICK_PLACEHOLDER =
  "maximumCostPerClickPlaceholder";
export const TARGET_CPA_PLACEHOLDER = "targetCpaPlaceholder";
export const TARGET_ROAS_PLACEHOLDER = "targetRoasPlaceholder";
export const BIDDING_STRATEGY_TYPE_PLACEHOLDER =
  "biddingStrategyTypePlaceholder";
export const ADVERTISERS_AVAILABLE_PLACEHOLDER =
  "advertisersAvailablePlaceholder";
export const BUYING_TYPE_PLACEHOLDER = "buyingTypePlaceholder";
export const SEARCH_SPECIFIC_LOCATION_PLACEHOLDER =
  "searchSpecificLocationPlaceholder";
export const LANGUAGES_PLACEHOLDER = "languagesPlaceholder";
export const FREQUENCY_CONTROL_PLACEHOLDER = "frequencyControlPlaceholder";
export const FILTER_BY_USERS_PLACEHOLDER = "filterByUsersPlaceholder";
export const FILTER_BY_DATES_PLACEHOLDER = "filterByDatesPlaceholder";
export const TRACKING_OFFLINE_EVENTS_PLACEHOLDER =
  "trackingOfflineEventsPlaceholder";
export const PRESETS_DATE_PLACEHOLDER = "presetsDatePlaceholder";
export const MIN_DAILY_BUDGET_PLACEHOLDER = "minDailyBudgetPlaceholder";
export const MAX_DAILY_BUDGET_PLACEHOLDER = "maxDailyBudgetPlaceholder";
export const MIN_TOTAL_BUDGET_PLACEHOLDER = "minTotalBudgetPlaceholder";
export const MAX_TOTAL_BUDGET_PLACEHOLDER = "maxTotalBudgetPlaceholder";
export const ASPECT_RATIO_PLACEHOLDER = "aspectRatioPlaceholder";
export const DARK_POST_PLACEHOLDER = "darkPostPlaceholder";
export const DARK_POST_DESCRIPTION_PLACEHOLDER =
  "darkPostDescriptionPlaceholder";
export const IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER =
  "isAdvantageAudienceActivePlaceholder";
export const IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER =
  "isAdvantageAudienceActiveDescriptionPlaceholder";

//EXAMPLES
export const ADS_CAMPAIGN_CONTEXT_EXAMPLE = "adsCampaignContextExample";
export const ADS_CAMPAIGN_LOCATION_EXAMPLE = "adsCampaignLocationExample";
export const SEARCH_SPECIFIC_LOCATION_EXAMPLE = "searchSpecificLocationExample";
export const SOCIAL_NETWORK_EXAMPLE = "socialNetworkExample";

/*OPTIONS SELECTS*/
export const PLAN_PAY_PER_USE = "planPayPerUse";
export const PLAN_PACKAGE = "planPackage";
export const PLAN_REGULAR = "planRegular";
export const PLAN_ENTERPRISE = "planEnterprise";
export const ADD_NEW_OPTION = "addNewOption";
export const RECURRENT_OPTION = "recurrentOption";
export const RECURRING_DAYS = "recurringDays";
export const RECURRING_WEEKS = "recurringWeeks";
export const RECURRING_MONTHS = "recurringMonths";
export const RECURRING_YEARS = "recurringYears";
export const ASPECT_RATIO_9_16 = "aspectRatio916";
export const ASPECT_RATIO_16_9 = "aspectRatio169";
export const ASPECT_RATIO_1_1 = "aspectRatio11";
export const ASPECT_RATIO_4_5 = "aspectRatio45";

/*PLANS*/
export const PLAN_PAY_PER_USE_NAME = "planPayPerUseName";
export const PLAN_PACKAGE_NAME = "planPackageName";

/*FIELDS VALIDATIONS*/
export const FIELD_REQUIRED = "fieldRequired";
export const FIELD_MUST_BE_SELECT_AT_LEAST_PRODUCTS =
  "fieldMustBeSelectAtLeastProducts";
export const FIELDS_REQUIRED = "fieldsRequired";
export const FIELD_NUMERIC = "fieldNumeric";
export const FIELD_TEXT = "fieldText";
export const FIELD_ALPHANUMERIC = "fieldAlphanumeric";
export const FIELD_MIN_LENGTH = "fieldMinLength";
export const FIELD_MAX_LENGTH = "fieldMaxLength";
export const FIELD_MAX_LENGTH_SHORT = "fieldMaxLengthShort";
export const FIELD_FILE_VALID_REQUIRED = "fieldFileValidRequired";
export const FIELD_FILE_MAX_SIZE = "fieldFileMaxSize";
export const FIELD_MEDIA_FILE_MIN_DIMENSIONS = "fieldMediaFileMinDimensions";
export const FIELD_IMAGE_REQUIRED = "fieldImageRequired";
export const FIELD_IMAGE_FORMAT_VALID = "fieldImageFormatValid";
export const FIELD_IMAGE_SIZE_VALID = "fieldImageSizeValid";
export const FIELD_FILE_REQUIRED = "fieldImageRequired";
export const FIELD_FILE_SIZE_VALID = "fieldImageSizeValid";
export const FIELD_URL_VALID = "fieldUrlValid";
export const FIELD_URL_ADLE_APP_DOMAIN = "fieldUrlAdleAppDomain";
export const FIELD_URL_VALID_WITH_PROTOCOL = "fieldUrlValidWithProtocal";
export const FIELD_URL_HTTPS_VALID = "fieldUrlHttpsValid";
export const FIELD_URL_REPEATED = "fieldUrlRepeated";
export const FIELD_EMAIL_VALID = "fieldEmailValid";
export const FIELD_EMAIL_REGISTERED = "fieldEmailRegistered";
export const FIELD_SPACES_VALID = "fieldSpacesValid";
export const FIELD_PHONE_VALID = "fieldPhoneValid";
export const FIELD_ALL_REQUIRED = "fieldAllRequired";
export const FIELD_BOTH_PASSWORD_REQUIRED = "fieldBothPasswordRequired";
export const FIELD_PASSWORDS_NO_MATCH = "fieldPasswordsNoMatch";
export const FIELD_PASSWORD_MIN_LENGTH = "fieldPasswordMinLength";
export const FIELD_PASSWORD_CHANGE_MIN_LENGTH = "fieldPasswordChangeMinLength";
export const FIELD_PASSWORD_INSECURE = "fieldPasswordInsecure";
export const FIELD_NUMBER_NEGATIVE = "fieldNumberNegative";
export const FIELD_EMAIL_REQUIRED = "fieldEmailRequired";
export const FIELD_SEARCH_CHATS_MORE_3_CHARACTERS =
  "fieldSearchChatsMore3Characters";
export const FIELD_NUMBER_0_OR_NEGATIVE = "fieldNumber0OrNegative";
export const FIELD_NUMBER_100_GREATER = "fieldNumber100Greater";
export const FIELD_NUMBER_LESS_THAN = "fieldNumberLessThan";
export const FIELD_NUMBER_GREATER_THAN = "fieldNumberGreaterThan";
export const FIELD_CREDITS_NOT_BE_NEGATIVE = "fieldCreditsNotBeNegative";
export const FIELD_COST_COLLABORATION_NOT_BE_NEGATIVE =
  "fieldCostCollaborationNotBeNegative";
export const FIELD_TRIAL_MONTHS_NOT_BE_NEGATIVE =
  "fieldTrialMonthsNotBeNegative";
export const FIELD_TRIAL_DAYS_NOT_BE_NEGATIVE = "fieldTrialDaysNotBeNegative";
export const FIELD_PLAN_PRICES_NOT_BE_NEGATIVE = "fieldPlanPricesNotBeNegative";
export const FIELD_STAFF_IS_REQUIRED = "fieldStaffIsRequired";
export const FIELD_BOTH_DATES_REQUIRED = "fieldBothDatesRequired";
export const FIELD_START_DATE_GREATER_THAN_END_DATE =
  "fieldStartDateGreaterThanEndDate";
export const FIELD_END_DATE_GREATER_NOW = "fieldEndDateGreaterNow";
export const FIELD_START_DATE_LESS_THAN_NOW = "fieldStartDateLessThanNow";
export const FIELD_END_DATE_LESS_THAN_NOW = "fieldEndDateLessThanNow";
export const FIELD_DATE_IN_PAST = "fieldDateInPast";
export const FIELD_DATE_AT_LEAST_FIFTEEN_MINUTES_FUTURE =
  "fieldDateAtLeastFifteenMinutesFuture";
export const FIELD_DATE_AT_LEAST_FIVE_MINUTES_FUTURE =
  "fieldDateAtLeastFiveMinutesFuture";
export const FIELD_MIN_AMOUNT_PAY = "fieldMinAmountPay";
export const FIELD_ACCESS_TOKEN_SHOPIFY_VALID = "fieldAccessTokenShopifyValid";
export const FIELD_NAME_REQUIRED = "fieldNameRequired";
export const FIELD_OBJECTIVE_REQUIRED = "fieldObjectiveRequired";
export const FIELD_PLATFORMS_REQUIRED = "fieldPlatformsRequired";
export const FIELD_PLATFORM_REQUIRED = "fieldPlatformRequired";
export const FIELD_TYPE_BUDGET_REQUIRED = "fieldTypeBudgetRequired";
export const FIELD_BUDGET_REQUIRED = "fieldBudgetRequired";
export const FIELD_CURRENCY_MIN_VALUE = "fieldCurrencyMinValue";
export const FIELD_LOCATIONS_REQUIRED = "fieldLocationsRequired";
export const FIELD_GENDERS_REQUIRED = "fieldGendersRequired";
export const FIELD_INTERESTS_REQUIRED = "fieldInterestsRequired";
export const FIELD_BEHAVIORS_REQUIRED = "fieldBehaviorsRequired";
export const FIELD_DESCRIPTION_REQUIRED = "fieldDescriptionRequired";
export const FIELD_VIDEO_REQUIRED = "fieldVideoRequired";
export const FIELD_CREATIVE_MUST_BE_VIDEO_NOT_IMAGE =
  "fieldCreativeMustBeVideoNotImage";
export const FIELD_META_TRACKING_ID_REQUIRED = "fieldMetaTrackingIdRequired";
export const FIELD_DESTINATION_URL_REQUIRED = "fieldDestinationUrlRequired";
export const FIELD_WEBSITE_URL_REQUIRED = "fieldWebsiteUrlRequired";
export const FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL_REQUIRED =
  "fieldDestinationUrlNotFoundInEventsPixelRequired";
export const FIELD_DESTINATION_URL_NOT_FOUND_IN_EVENTS_PIXEL =
  "fieldDestinationUrlNotFoundInEventsPixel";
export const FIELD_TIKTOK_TRACKING_ID_REQUIRED =
  "fieldTikTokTrackingIdRequired";
export const FIELD_MIN_LENGTH_SELECT = "fieldMinLengthSelect";
export const FIELD_MAX_LENGTH_SELECT = "fieldMaxLengthSelect";
export const FIELD_CONTENT_REQUIRED = "fieldContentRequired";
export const FIELD_START_AND_END_DATES_REQUIRED =
  "fieldStartAndEndDatesRequired";
export const FIELD_LANGUAGE_REQUIRED = "fieldLanguageRequired";
export const FIELD_CALL_TO_ACTION_VALID_BY_OBJECTIVE =
  "fieldCallToActionValidByObjective";
export const FIELD_TRACKING_IDS_REQUIRED = "fieldTrackingIdsRequired";
export const FIELD_AD_ACCOUNTS_REQUIRED = "fieldAdAccountsRequired";
export const FIELD_CONTENT_IS_BEING_PROCESSED = "fieldContentIsBeingProcessed";
export const FIELD_MIN_TOTAL_BUDGET_ONE_DOLLAR = "fieldMinTotalBudgetOneDollar";
export const FIELD_MIN_DAILY_BUDGET = "fieldMinDailyBudget;";
export const FIELD_MIN_BUDGET = "fieldMinBudget";
export const FIELD_URL_INSTAGRAM = "fieldUrlInstagram";
export const FIELD_MIN_CONTENT = "fieldMinContent";
export const FIELD_MAX_CONTENT = "fieldMaxContent";
export const FIELD_TRAFFIC_URL_NOT_BE_LINK_FACEBOOK =
  "fieldTrafficUrlNotBeLinkFacebook";
export const FIELD_TRAFFIC_URL_NOT_BE_LINK_INSTAGRAM =
  "fieldTrafficUrlNotBeLinkInstagram";
export const FIELD_TRAFFIC_URL_NOT_BE_LINK_WHATSAPP =
  "fieldTrafficUrlNotBeLinkWhatsapp";
export const FIELD_AD_FORMAT_REQUIRED_AD_PREVIEW =
  "fieldAdFormatRequiredAdPreview";
export const FIELD_CALL_TO_ACTION_REQUIRED_AD_PREVIEW =
  "fieldCallToActionRequiredAdPreview";
export const FIELD_PAGE_ID_REQUIRED_AD_PREVIEW = "fieldPageIdRequiredAdPreview";
export const FIELD_SPONSOR_PAGE_ID_REQUIRED_AD_PREVIEW =
  "fieldSponsorPageIdRequiredAdPreview";
export const FIELD_INSTAGRAM_ID_REQUIRED_AD_PREVIEW =
  "fieldInstagramIDRequiredAdPreview";
export const FIELD_APP_ID_REQUIRED_AD_PREVIEW = "fieldAppIdRequiredAdPreview";
export const FIELD_IDENTITY_TIK_TOK_ID_REQUIRED_AD_PREVIEW =
  "fieldIdentityTikTokIdRequiredAdPreview";
export const FIELD_POST_ID_REQUIRED_AD_PREVIEW = "fieldPostIdRequiredAdPreview";
export const FIELD_ADDRESS_REQUIRED_AD_PREVIEW =
  "fieldAddressRequiredAdPreview";
export const FIELD_MIN_CARDS_AD_CAROUSEL = "fieldMinCardsAdCarousel";
export const FIELD_TEXT_ONLY_HAS_LETTERS_NUMBERS_DOTS_COMMAS =
  "fieldTextOnlyHasLettersNumbersDotsCommas";
export const FIELD_TEXT_REPEATED = "fieldTextRepeated";
export const FIELD_IMAGES_REPEATED = "fieldImagesRepeated";
export const FIELD_VIDEOS_REPEATED = "fieldVideosRepeated";
export const FIELD_KEYWORDS_REPEATED = "fieldsKeywordsRepeated";
export const FIELD_KEYWORDS_MAX_LENGTH = "fieldsKeywordsMaxLength";
export const FIELD_TWO_CARDS_REQUIRED_FOR_GENERATE_PREVIEW =
  "fieldTwoCardsRequiredForGeneratedPreview";
export const FIELD_KEYWORDS_AND_KEYWORDS_NEGATIVE_REPEATED =
  "fieldKeywordsAndKeywordsNegativeRepeated";
export const FIELD_CAMPAIGN_MUST_HAVE_ONE_DAY_ACTIVE =
  "fieldCampaignMustHaveOneDayActive";
export const FIELD_THIS_KEYWORD_ALREADY_EXIST_IN_YOUR_LIST =
  "fieldThisKeywordAlreadyExistInYourList";
export const FIELD_MEDIA_URL_REQUIRED_AD_PREVIEW =
  "fieldMediaUrlRequiredAdPreview";
export const FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_DRAFT =
  "fieldAdPreviewContentChangeWarningDraft";
export const FIELD_AD_PREVIEW_CONTENT_CHANGE_WARNING_CREATED =
  "fieldAdPreviewContentChangeWarningCreated";
export const META_AD_PREVIEW_AD_BLOCKER_NOTICE = "metaAdPreviewAdBlockerNotice";
export const FIELD_START_DATE_REQUIRED = "fieldStartDateRequired";
export const FIELD_VIDEO_YOUTUBE_URL_INVALID = "fieldVideoYoutubeUrlInvalid";
export const FIELD_MAX_IMAGES_VALID = "fieldMaxImagesValid";
export const FIELD_MAX_VIDEOS_YOUTUBE_VALID = "fieldMaxVideosValid";
export const FIELD_YOUTUBE_VIDEO_NOT_PUBLIC = "fieldYoutubeVideoNotPublic";
export const FIELD_YOUTUBE_VIDEO_DURATION_INVALID =
  "fieldYoutubeVideoDurationInvalid";
export const FIELD_YOUTUBE_VIDEO_NOT_PUBLIC_AND_DURATION_INVALID =
  "fieldYoutubeVideoNotPublicAndDurationInvalid";
export const FIELD_MIN_TEXTS_VALID = "fieldMinTextsValid";
export const FIELD_MAX_TEXTS_VALID = "fieldMaxTextsValid";
export const FIELD_TITLES_REQUIRED_AD_PREVIEW = "fieldTitlesRequiredAdPreview";
export const FIELD_TITLES_REQUIRED_AD_PREVIEW_TIKTOK =
  "fieldTitlesRequiredAdPreviewTikTok";
export const FIELD_HEADLINES_REQUIRED_AD_PREVIEW =
  "fieldHeadlinesRequiredAdPreview";
export const FIELD_DESCRIPTIONS_REQUIRED_AD_PREVIEW =
  "fieldDescriptionsRequiredAdPreview";
export const FIELD_INSTANT_EXPERIENCE_REQUIRED_AD_PREVIEW =
  "fieldInstantExperienceRequiredAdPreview";
export const FIELD_PRODUCT_SET_ID_REQUIRED_AD_PREVIEW =
  "fieldProductSetIdRequiredAdPreview";
export const FIELD_ALMOST_ONE_INCLUSION_OR_EXCLUSION =
  "fieldAlmostOneInclusionOrExclusion";
export const FIELD_CONTENT_INTRO_CARD_IS_REQUIRED_AD_PREVIEW =
  "fieldContentIntroCardIsRequiredAdPreview";
export const FIELD_META_PLACEMENT_FACEBOOK_PROFILE_FEED_REQUIRED =
  "fieldMetaPlacementFacebookProfileFeedRequired";
export const FIELD_META_PLACEMENT_FACEBOOK_MARKETPLACE_REQUIRED =
  "fieldMetaPlacementFacebookMarketplaceRequired";
export const FIELD_META_PLACEMENT_MESSENGER_INBOX_REQUIRED =
  "fieldMetaPlacementMessengerInboxRequired";
export const FIELD_META_PLACEMENT_FACEBOOK_NOTIFICATIONS_REQUIRED =
  "fieldMetaPlacementFacebookNotificationsRequired";
export const FIELD_META_PLACEMENT_FACEBOOK_STORIES_REQUIRED =
  "fieldMetaPlacementFacebookStoriesRequired";
export const FIELD_META_PLACEMENT_AUDIENCE_NETWORK_NATIVE_BANNER_INTERSTITIAL_REQUIRED =
  "fieldMetaPlacementAudienceNetworkNativeBannerInterstitialRequired";
export const FIELD_META_PLACEMENT_AUDIENCE_NETWORK_REWARDED_VIDEOS_REQUIRED =
  "fieldMetaPlacementAudienceNetworkRewardedVideosRequired";
export const FIELD_META_PLACEMENT_ADS_ON_FACEBOOK_REELS_REQUIRED =
  "fieldMetaPlacementAdsOnFacebookReelsRequired";
export const FIELD_META_PLACEMENT_FACEBOOK_INSTREAM_VIDEOS_REQUIRED =
  "fieldMetaPlacementFacebookInstreamVideosRequired";
export const FIELD_META_PLACEMENT_FACEBOOK_SEARCH_RESULTS_REQUIRED =
  "fieldMetaPlacementFacebookSearchResultsRequired";
export const FIELD_META_PLACEMENT_INSTAGRAM_STORIES_REQUIRED =
  "fieldMetaPlacementInstagramStoriesRequired";
export const FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_FEED_REQUIRED =
  "fieldMetaPlacementInstagramProfileFeedRequired";
export const FIELD_META_PLACEMENT_INSTAGRAM_SEARCH_RESULTS_REQUIRED =
  "fieldMetaPlacementInstagramSearchResultsRequired";
export const FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_REQUIRED =
  "fieldMetaPlacementInstagramExploreRequired";
export const FIELD_META_PLACEMENT_INSTAGRAM_EXPLORE_HOME_REQUIRED =
  "fieldMetaPlacementInstagramExploreHomeRequired";
export const FIELD_META_PLACEMENT_INSTAGRAM_PROFILE_REELS_REQUIRED =
  "fieldMetaPlacementInstagramProfileReelsRequired";
export const FIELD_DESTINATION_URL_REQUIRED_AD_PREVIEW =
  "fieldDestinationUrlRequiredAdPreview";
export const FIELD_DESTINATION_URL_IN_YOUR_CAROUSEL_REQUIRED_AD_PREVIEW =
  "fieldDestinationUrlInYourCarouselRequiredAdPreview";
export const FIELD_IMAGES_MIN_REQUIRED = "fieldImagesMinRequired";
export const FIELD_ESTIMATION_ID_REQUIRED = "fieldEstimationIdRequired";
export const FIELD_ESTIMATION_BUDGET_REQUIRED = "fieldEstimationBudgetRequired";
export const FIELD_ESTIMATION_START_END_DATE_REQUIRED =
  "fieldEstimationStartEndDateRequired";
export const FIELD_ESTIMATION_FREQUENCY_REQUIRED =
  "fieldEstimationFrequencyRequired";
export const FIELD_ESTIMATION_LOCATION_REQUIRED =
  "fieldEstimationLocationRequired";
export const FIELD_SEARCH_THEMES_MAX_WORDS = "fieldSearchThemesMaxWords";
export const FIELD_MUSIC_URL_REQUIRED_AD_PREVIEW =
  "fieldMusicUrlRequiredAdPreview";
export const FIELD_CONSECUTIVE_UPPERCASE = "fieldConsecutiveUppercase";
export const FIELD_EMOJI_NOT_ALLOWED = "fieldEmojiNotAllowed";

export const REQUEST_REJECT_CONFIRMATION_DESCRIPTION =
  "requestRejectConfirmationDescription";
export const REQUEST_APPROVE_CONFIRMATION_DESCRIPTION =
  "requestApproveConfirmationDescription";
export const REQUEST_REJECTED = "requestRejected";
export const REQUEST_REJECTED_DESCRIPTION = "requestRejectedDescription";
export const REPORTED_CONTENT_STATUS_REJECTED = "reportedContentStatusRejected";
export const REPORTED_CONTENT_STATUS_PENDING = "reportedContentStatusPending";
export const REPORTED_CONTENT_STATUS_APPROVED = "reportedContentStatusApproved";
export const LIST_OF_CREATORS = "listOfCreators";

/*MODAL COMMERCIAL*/
export const MODAL_COMMERCIAL_TITLE_CREATE = "modalCommercialTitleCreate";
export const MODAL_COMMERCIAL_TITLE_EDIT = "modalCommercialTitleEdit";
export const MODAL_COMMERCIAL_CREATE_COMMERCIAL =
  "modalCommercialCreateCommercial";
export const MODAL_COMMERCIAL_ALREADY_EXIST = "modalCommercialAlreadyExist";

/*MODAL CREATE PAYMENT LINK*/
export const MODAL_CREATE_PAYMENT_LINK_TITLE = "modalCreatePaymentLinkTitle";
export const MODAL_CREATE_PAYMENT_LINK_DESCRIPTION =
  "modalCreatePaymentLinkDescription";
export const MODAL_CREATE_PAYMENT_LINK_ARIA_LABEL =
  "modalCreatePaymentLinkAriaLabel";
export const MODAL_CREATE_PAYMENT_LINK_LINKS = "modalCreatePaymentLinkLinks";
export const MODAL_CREATE_PAYMENT_LINK_LINKS_EMPTY =
  "modalCreatePaymentLinkLinksEmpty";
export const MODAL_CREATE_PAYMENT_LINK_NAME = "modalCreatePaymentLinkName";

/*MODAL HELP VIDEO AND FAQ*/
export const WARNING_MOBILE_TUTORIAL = "warningMobileTutorial";
export const FAQ_DESCRIPTION = "faqDescription";
export const FAQ_QUESTION_WHAT_IS_BUZZLY = "faqQuestionWhatIsBuzzly";
export const FAQ_QUESTION_WHAT_IS_BUZZLY_DESCRIPTION =
  "faqQuestionWhatIsBuzzlyDescription";
export const FAQ_QUESTION_WHAT_IS_REQUEST = "faqQuestionWhatIsRequest";
export const FAQ_QUESTION_WHAT_IS_REQUEST_DESCRIPTION =
  "faqQuestionWhatIsRequestDescription";
export const FAQ_QUESTION_WHAT_IS_PUBLICATION = "faqQuestionWhatIsPublication";
export const FAQ_QUESTION_WHAT_IS_PUBLICATION_DESCRIPTION =
  "faqQuestionWhatIsPublicationDescription";
export const FAQ_QUESTION_WHAT_IS_CAMPAIGN = "faqQuestionWhatIsCampaign";
export const FAQ_QUESTION_WHAT_IS_CAMPAIGN_DESCRIPTION =
  "faqQuestionWhatIsCampaignDescription";
export const FAQ_QUESTION_WHAT_IS_ORDER = "faqQuestionWhatIsOrder";
export const FAQ_QUESTION_WHAT_IS_ORDER_DESCRIPTION =
  "faqQuestionWhatIsOrderDescription";
export const FAQ_QUESTION_WHAT_IS_STORE = "faqQuestionWhatIsStore";
export const FAQ_QUESTION_WHAT_IS_STORE_DESCRIPTION =
  "faqQuestionWhatIsStoreDescription";
export const FAQ_QUESTION_WHAT_ROLES_EXISTS = "faqQuestionWhatRolesExists";
export const FAQ_QUESTION_WHAT_ROLES_EXISTS_DESCRIPTION =
  "faqQuestionWhatRolesExistsDescription";
export const FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS =
  "faqQuestionAdditionalActionsDeliveredProducts";
export const FAQ_QUESTION_ADDITIONAL_ACTIONS_DELIVERED_PRODUCTS_DESCRIPTION =
  "faqQuestionAdditionalActionsDeliveredProductsDescription";
export const FAQ_QUESTION_MUST_CALL_ADMIN = "faqQuestionMustCallAdmin";
export const FAQ_QUESTION_MUST_CALL_ADMIN_DESCRIPTION =
  "faqQuestionMustCallAdminDescription";
export const FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE =
  "faqQuestionCreatorRedeemCodeWithMinorValue";
export const FAQ_QUESTION_CREATOR_REDEEM_CODE_WITH_MINOR_VALUE_DESCRIPTION =
  "faqQuestionCreatorRedeemCodeWithMinorValueDescription";
export const FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS =
  "faqQuestionDifferenceBetweenExchangesAndCampaigns";
export const FAQ_QUESTION_DIFFERENCE_BETWEEN_EXCHANGES_AND_CAMPAIGNS_DESCRIPTION =
  "faqQuestionDifferenceBetweenExchangesAndCampaignsDescription";
export const FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS =
  "faqQuestionEnsureCreatorsUnderstandAcceptExchangeTerms";
export const FAQ_QUESTION_ENSURE_CREATORS_UNDERSTAND_ACCEPT_EXCHANGE_TERMS_DESCRIPTION =
  "faqQuestionEnsureCreatorsUnderstandAcceptExchangeTermsDescription";

export const LIST_CREATORS_WITH_AUDIENCE_SIMILAR =
  "listCreatorsWithAudienceSimilar";
export const AUDIENCE_INFORMATION = "audienceInformation";
export const AUDIENCE_CREDIBILITY = "audienceCredibility";
export const AUDIENCE_CREDIBILITY_TITLE_EXPLANATION =
  "audienceCredibilityTitleExplanation";
export const AUDIENCE_CREDIBILITY_DESCRIPTION_EXPLANATION =
  "audienceCredibilityDescriptionExplanation";
export const AUDIENCE_BY_COUNTRY = "audienceByCountry";
export const AUDIENCE_BY_CITIES = "audienceByCities";
export const AUDIENCE_BY_BRAND_AFFINITY = "brandAffinity";
export const AUDIENCE_BY_INTERESTS = "audienceByInterests";
export const AUDIENCE_BY_DISTRIBUTION_AGE = "audienceByDistributionAge";
export const AUDIENCE_BY_PERCENTAGE_GENDERS = "audienceByPercentageGenders";
export const AUDIENCE_BY_SIMILAR_AUDIENCE = "audienceBySimilarAudience";
export const AUDIENCE_BY_SIMILAR_AUDIENCE_NOT_FOUND =
  "audienceBySimilarAudienceNotFound";
export const GALLERY_CONTENT_BUZZLY = "galleryContentBuzzly";

/*MODAL BRAND SETUP*/
export const MODAL_BRAND_SETUP_TITLE = "modalBrandSetupTitle";
export const MODAL_BRAND_SETUP_DESCRIPTION = "modalBrandSetupDescription";

/*LIST MENU*/
export const MENU_CONNECTED_ACCOUNTS = "menuConnectedAccounts";
export const MENU_PLATFORM = "menuPlatform";
export const MENU_MEDIA = "menuMedia";
export const MENU_SERVICES = "menuServices";
export const MENU_ACTIONS = "menuActions";
export const MENU_CONFIGURATION = "menuConfiguration";
export const MENU_ADMINISTRATION = "menuAdministration";
export const SUB_MENU_CREATORS = "subMenuCreators";
export const SUB_MENU_PUBLICATIONS = "subMenuPublications";
export const SUB_MENU_EVENTS = "subMenuEvents";
export const SUB_MENU_CAMPAIGNS = "subMenuCampaigns";
export const SUB_MENU_ADS_CAMPAIGNS = "subMenuAdsCampaigns";
export const SUB_MENU_REPORTS = "subMenuReports";
export const SUB_MENU_DISCOVERY = "subMenuDiscovery";
export const SUB_MENU_SOCIAL_FEED = "subMenuSocialFeed";
export const SUB_MENU_GALLERY = "subMenuGallery";
export const SUB_MENU_REDEEM_CODE = "subMenuRedeemCode";
export const SUB_MENU_ORDERS = "subMenuOrders";
export const SUB_MENU_ACCOUNT = "subMenuAccount";
export const SUB_MENU_STORES = "subMenuStores";
export const SUB_MENU_MENU = "subMenuMenu";
export const SUB_MENU_USERS = "subMenuUsers";
export const SUB_MENU_BILLING_AND_PAYMENTS = "subMenuBillingAndPayments";
export const SUB_MENU_BILLING_DASHBOARD = "subMenuBillingDashboard";
export const SUB_MENU_BILLING_DATA = "subMenuBillingData";
export const SUB_MENU_USERS_OWNER = "subMenuUsersOwner";
export const SUB_MENU_BRANDS = "subMenuShops";
export const SUB_MENU_BRAND_SIGNUPS = "subMenuRegisterShops";
export const SUB_MENU_CREATORS_OWNER = "subMenuCreatorsOwner";
export const SUB_MENU_CREATORS_EXTERNALS = "subMenuCreatorsExternals";
export const SUB_MENU_PAY_CREATORS = "subMenuPayCreators";
export const SUB_MENU_CREATOR_SIGNUPS = "subMenuRequestsAccounts";
export const SUB_MENU_CONTENTS = "subMenuContents";
export const SUB_MENU_DELIVERIES = "subMenuDeliveries";
export const SUB_MENU_CONTENT_APPLICATION = "subMenuContentApplication";
export const SUB_MENU_REPORTS_OWNER = "subMenuReportsOwner";
export const SUB_MENU_FEEDBACK = "subMenuFeedback";
export const SUB_MENU_PAYMENTS_FAILED = "subMenuPaymentsFailed";
export const CANCEL_ANYTIME = "cancelAnytime";

/*DATE*/
export const DATE_HOUR = "dateHour";
export const DATE_SHORT = "dateShort";
export const DATE_SHORT_2 = "dateShort2";
export const DATE_SHORT_LOCALIZED = "dateShortLocalized";
export const DATE_RELATIVE = "dateRelative";
export const DATE_LONG = "dateLong";
export const DATE_LONG_TEXT = "dateLongText";
export const DATE_LONG_TEXT_2 = "dateLongText2";
export const DATE_LONG_TEXT_WITH_HOUR = "dateLongTextWithHour";
export const DATE_LONG_LOCALIZED = "dateLongLocalized";
export const DATE_DISTANCE = "dateDistance";
export const RENEWED_ON = "renewedOn";
export const EXPIRE_ON = "expireOn";
export const LAST_UPDATE_DATE = "lastUpdateDate";
export const LAST_UPDATE_DATE_SHORT = "lastUpdateDateShort";
export const DATE_DAY_AND_MONTH_SHORT = "dateDayAndMonthShort";
export const MONTH_SHORT = "monthShort";
export const PUBLISHED_DATE = "publishedDate";

/*CURRENCY*/
export const VALUE_WITH_CURRENCY = "valueWithCurrency";
export const VALUE_WITH_PERCENTAGE = "valueWithPercentage";
export const NUMBER_CURRENCY = "numberCurrency";
export const VALUE_SUBSCRIPTION_3_DAYS_FREE = "valueSubscription3DaysFree";
export const VALUE_SUBSCRIPTION_MONTHLY = "valueSubscriptionMonthly";
export const VALUE_SUBSCRIPTION_YEARLY_UNIQUE_PAYMENT =
  "valueSubscriptionYearlyUniquePayment";
export const VALUE_SUBSCRIPTION_PRORATED = "valueSubscriptionProrated";
export const VALUE_SUBSCRIPTION_AFTER_PRORATED =
  "valueSubscriptionAfterProrated";
export const VALUE_EXPRESSED_IN = "valueExpressedIn";
export const VALUE_NUMBER = "valueNumber";
export const VALUE_WITH_CURRENCY_MANUAL_FORMAT =
  "valueWithCurrencyManualFormat";

/*BUTTON*/
export const BUTTON_RETRY = "buttonRetry";
export const BUTTON_INVITE = "buttonInvite";
export const BUTTON_VIEW_INVITE = "buttonViewInvite";
export const BUTTON_EDIT_INVITE = "buttonEditInvite";
export const BUTTON_CANCEL_INVITE = "buttonCancelInvite";
export const BUTTON_VIEW_REQUEST = "buttonViewRequest";
export const BUTTON_START_NOW = "buttonStartNow";
export const BUTTON_REJECT_REQUEST = "buttonCancelRequest";
export const BUTTON_ORDER_IN_PROCESS = "buttonOrderInProcess";
export const BUTTON_VIEW_COLLABORATION = "buttonViewCollaboration";
export const BUTTON_VIEW_METRICS = "buttonViewMetrics";
export const BUTTON_VIEW_REPORT = "buttonViewReport";
export const BUTTON_INIT_CHAT = "buttonInitChat";
export const BUTTON_ADD_REFERENCE_PROFILE = "buttonAddReferenceProfile";
export const BUTTON_USE_AS_REFERENCE_PROFILE = "buttonUseAsReferenceProfile";
export const BUTTON_ADD_AS_REFERENCE = "buttonAddAsReference";
export const BUTTON_ADDED = "buttonAdded";
export const BUTTON_DOWNLOAD = "buttonDownload";
export const BUTTON_DOWNLOAD_PDF = "buttonDownloadPDF";
export const BUTTON_CALCULATE = "buttonCalculate";
export const BUTTON_ENTERPRISE_CALCULATE = "buttonEnterpriseCalculate";
export const BUTTON_REDEEM_CODE = "buttonRedeemCode";
export const BUTTON_ADD_STORE = "buttonAddStore";
export const BUTTON_SEARCH = "buttonSearch";
export const BUTTON_ACCEPT_ORDER = "buttonAcceptOrder";
export const BUTTON_REJECT_ORDER = "buttonRejectOrder";
export const BUTTON_READY_ORDER = "buttonReadyOrder";
export const BUTTON_DELIVER_ORDER = "buttonDeliverOrder";
export const BUTTON_CANCEL = "buttonCancel";
export const BUTTON_DISCARD = "buttonDiscard";
export const BUTTON_VIEW = "buttonView";
export const BUTTON_CREATE_CAMPAIGN = "buttonCreateCampaign";
export const BUTTON_CREATE_CONTENT = "buttonCreateContent";
export const BUTTON_CREATE_CAMPAIGN2 = "buttonCreateCampaign2";
export const BUTTON_LAUNCH_AD = "buttonLaunchAd";
export const BUTTON_SAVE_PROGRESS = "buttonSaveProgress";
export const BUTTON_NEXT = "buttonNext";
export const BUTTON_PREVIOUS = "buttonPrevious";
export const BUTTON_ADVANCED_CONFIGURATION = "buttonAdvancedConfiguration";
export const BUTTON_FINISH = "buttonFinish";
export const BUTTON_URL = "buttonUrl";
export const BUTTON_UPLOAD = "buttonUpload";
export const BUTTON_UPLOAD_FILES = "buttonUploadFiles";
export const BUTTON_UPLOAD_FOLDER = "buttonUploadFolder";
export const BUTTON_UPLOAD_CONTENT = "buttonUploadContent";
export const BUTTON_UPLOAD_DOCUMENT = "buttonUploadDocument";
export const BUTTON_REMOVE_CONTENT = "buttonRemoveContent";
export const DELETE_CONTENT_CONFIRMATION_TITLE =
  "deleteContentConfirmationTitle";
export const DELETE_CONTENT_CONFIRMATION_DESCRIPTION =
  "deleteContentConfirmationDescription";
export const DELETE_SCHEDULED_CONTENT_CONFIRMATION_TITLE =
  "deleteScheduledContentConfirmationTitle";
export const DELETE_SCHEDULED_CONTENT_CONFIRMATION_DESCRIPTION =
  "deleteScheduledContentConfirmationDescription";
export const DELETE_SCHEDULED_CONTENT_ERROR_DESCRIPTION =
  "deleteScheduledContentErrorDescription";
export const DELETE_SCHEDULED_CONTENT_SUCCESS = "deleteScheduledContentSuccess";
export const DELETE_MULTIPLE_CONTENT_CONFIRMATION_TITLE =
  "deleteMultipleContentConfirmationTitle";
export const DELETE_MULTIPLE_CONTENT_CONFIRMATION_DESCRIPTION =
  "deleteMultipleContentConfirmationDescription";
export const BUTTON_DELETE_CONTENT = "buttonDeleteContent";
export const BUTTON_FINISHED_CAMPAIGN = "buttonFinishedCampaign";
export const BUTTON_SAVE_CAMPAIGN = "buttonSaveCampaign";
export const BUTTON_DEACTIVATE_CAMPAIGN = "buttonDeactivateCampaign";
export const BUTTON_ACTIVATE_CAMPAIGN = "buttonActivateCampaign";
export const BUTTON_SEND_INVITE = "buttonSendInvite";
export const BUTTON_REJECT = "buttonReject";
export const BUTTON_ACCEPT = "buttonAccept";
export const BUTTON_ACCEPT_AND_PAY = "buttonAcceptAndPay";
export const BUTTON_ASSIGN_INVITE = "buttonAssignInvite";
export const BUTTON_REVIEW_CONTENT = "buttonReviewContent";
export const BUTTON_VIEW_PRELIMINARY_CONTENT = "buttonViewPreliminaryContent";
export const BUTTON_VIEW_APPLICANT = "buttonViewApplicant";
export const BUTTON_REVIEW = "buttonReview";
export const BUTTON_ACCEPT_CONTENT = "buttonAcceptContent";
export const BUTTON_REJECT_CONTENT = "buttonRejectContent";
export const BUTTON_SEND_REVIEW = "buttonSendReview";
export const BUTTON_CONTINUE = "buttonContinue";
export const BUTTON_SIGN_UP = "buttonSignUp";
export const BUTTON_CONTINUOUS = "buttonContinuous";
export const BUTTON_CONTINUE_WITHOUT_CHANGES = "buttonContinueWithoutChanges";
export const BUTTON_RESIZE_AND_CONTINUE = "buttonResizeAndContinue";
export const BUTTON_UNDERSTOOD = "buttonUnderstood";
export const BUTTON_MORE_QUESTIONS = "buttonMoreQuestions";
export const BUTTON_INIT_TUTORIAL = "buttonInitTutorial";
export const BUTTON_PAYMENTS = "buttonPayments";
export const BUTTON_BROADCAST = "buttonBroadcast";
export const BUTTON_SAVE = "buttonSave";
export const BUTTON_SEND_MESSAGE = "buttonSendMessage";
export const BUTTON_UPLOAD_FILE = "buttonUploadFile";
export const BUTTON_REMOVE_FILE = "buttonRemoveFile";
export const BUTTON_VERIFY_PUBLICATION = "buttonVerifyPublication";
export const BUTTON_SEE_PUBLICATION_ON = "buttonSeePublicationOn";
export const BUTTON_METRICS_READY = "buttonMetricsReady";
export const BUTTON_UPLOAD_TIKTOK = "buttonUploadTiktok";
export const BUTTON_VIEW_PROFILE = "buttonViewProfile";
export const BUTTON_GENERATE_DESCRIPTION = "buttonGenerateDescription";
export const BUTTON_GENERATE_COMMENT = "buttonGenerateComment";
export const BUTTON_UPLOAD_IMAGE = "buttonUploadImage";
export const BUTTON_REMOVE_IMAGE = "buttonRemoveImage";
export const BUTTON_SAVE_CHANGES = "buttonSaveChanges";
export const BUTTON_UPLOAD_VIDEO = "buttonUploadVideo";
export const BUTTON_REMOVE_VIDEO = "buttonRemoveVideo";
export const BUTTON_DISCONNECT = "buttonDisconnect";
export const BUTTON_CONNECT_TIKTOK = "buttonConnectTiktok";
export const BUTTON_CONNECT_TIKTOK_BUSINESS = "buttonConnectTiktokBusiness";
export const BUTTON_BE_ECOMMERCE = "buttonBeEcommerce";
export const BUTTON_NOT_BE_ECOMMERCE = "buttonNotBeEcommerce";
export const BUTTON_ADD_TURN = "buttonAddTurn";
export const BUTTON_DELETE = "buttonDelete";
export const BUTTON_ARCHIVE_CAMPAIGN = "buttonArchiveCampaign";
export const BUTTON_CREATE = "buttonCreate";
export const BUTTON_CREATE_ACCOUNT = "buttonCreateAccount";
export const MODAL_CREATE_ACCOUNT_TITLE = "modalCreateAccountTitle";
export const MODAL_CREATE_ACCOUNT_DESCRIPTION = "modalCreateAccountDescription";
export const BUTTON_CONNECT_WOOCOMMERCE = "buttonConnectWoocommerce";
export const BUTTON_CREATE_USER = "buttonCreateUser";
export const BUTTON_CREATE_CONTACT = "buttonCreateContact";
export const BUTTON_VIEW_DETAILS = "buttonViewDetails";
export const BUTTON_DOWNLOAD_INVOICE = "buttonDownloadInvoice";
export const BUTTON_CLOSE = "buttonClose";
export const BUTTON_UPLOAD_CATALOG = "buttonUploadCatalog";
export const BUTTON_COPY_CATALOG = "buttonCopyCatalog";
export const BUTTON_DOWNLOAD_FORMAT = "buttonDownloadFormat";
export const BUTTON_DUPLICATE = "buttonDuplicate";
export const BUTTON_DUPLICATE_IN_SAME_GROUP = "buttonDuplicateInSameGroup";
export const BUTTON_DUPLICATE_IN_OTHER_AD_GROUP =
  "buttonDuplicateInOtherAdGroup";
export const DUPLICATE_AD_OTHER_GROUP_MODAL_TITLE =
  "duplicateAdOtherGroupModalTitle";
export const DUPLICATE_AD_OTHER_GROUP_MODAL_DESCRIPTION =
  "duplicateAdOtherGroupModalDescription";
export const DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_CHANGE_WARNING =
  "duplicateAdOtherGroupCampaignChangeWarning";
export const DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_LABEL =
  "duplicateAdOtherGroupCampaignLabel";
export const DUPLICATE_AD_OTHER_GROUP_CAMPAIGN_PLACEHOLDER =
  "duplicateAdOtherGroupCampaignPlaceholder";
export const DUPLICATE_AD_OTHER_GROUP_AD_GROUP_LABEL =
  "duplicateAdOtherGroupAdGroupLabel";
export const DUPLICATE_AD_OTHER_GROUP_AD_GROUP_PLACEHOLDER =
  "duplicateAdOtherGroupAdGroupPlaceholder";
export const DUPLICATE_AD_OTHER_GROUP_EMPTY_AD_GROUPS =
  "duplicateAdOtherGroupEmptyAdGroups";
export const BUTTON_DUPLICATE_IN_SAME_CAMPAIGN =
  "buttonDuplicateInSameCampaign";
export const BUTTON_DUPLICATE_IN_OTHER_CAMPAIGN =
  "buttonDuplicateInOtherCampaign";
export const DUPLICATE_AD_GROUP_MODAL_TITLE = "duplicateAdGroupModalTitle";
export const DUPLICATE_AD_GROUP_MODAL_DESCRIPTION =
  "duplicateAdGroupModalDescription";
export const DUPLICATE_AD_GROUP_CAMPAIGN_CHANGE_WARNING =
  "duplicateAdGroupCampaignChangeWarning";
export const DUPLICATE_ASSETS_GROUP_MODAL_TITLE =
  "duplicateAssetsGroupModalTitle";
export const DUPLICATE_ASSETS_GROUP_MODAL_DESCRIPTION =
  "duplicateAssetsGroupModalDescription";
export const DUPLICATE_ASSETS_GROUP_CAMPAIGN_CHANGE_WARNING =
  "duplicateAssetsGroupCampaignChangeWarning";
export const DUPLICATE_CAMPAIGN_AD_FORMAT_MISMATCH =
  "duplicateCampaignAdFormatMismatch";
export const DUPLICATE_AD_GROUP_CAMPAIGN_TYPE_MISMATCH =
  "duplicateAdGroupCampaignTypeMismatch";
export const BUTTON_EDIT = "buttonEdit";
export const BUTTON_MOVE_OTHER_CATEGORY = "buttonMoveOtherCategory";
export const BUTTON_COPY = "buttonCopy";
export const BUTTON_REGISTER = "buttonRegister";
export const BUTTON_NO_HAVE_DOCUMENT = "buttonNoHaveDocument";
export const BUTTON_UPLOAD_AFTER = "buttonUploadAfter";
export const BUTTON_INVITED = "buttonInvited";
export const BUTTON_YES_I_SURE = "buttonYesISure";
export const BUTTON_SEND_REVISION = "buttonSendRevision";
export const BUTTON_APPROVE_CONTENT = "buttonApproveContent";
export const BUTTON_UPLOAD_INSTAGRAM = "buttonUploadInstagram";
export const BUTTON_CONNECT_INSTAGRAM = "buttonConnectInstagram";
export const BUTTON_RELOAD_PAGE = "buttonReloadPage";
export const BUTTON_REPLACE_IMAGE = "buttonReplaceImage";
export const BUTTON_GENERATE_CONTENT = "buttonGenerateContent";
export const BUTTON_REGENERATE_CONTENT = "buttonRegenerateContent";
export const BUTTON_REGENERATE_TEXT = "buttonRegenerateText";
export const BUTTON_UPLOAD_LOGO = "buttonUploadLogo";
export const BUTTON_REPLACE_LOGO = "buttonReplaceLogo";
export const BUTTON_UPLOAD_BACKGROUND = "buttonUploadBackground";
export const BUTTON_REPLACE_BACKGROUND = "buttonReplaceBackground";
export const BUTTON_REMOVE_BACKGROUND = "buttonRemoveBackground";
export const BUTTON_GENERATE_OTHER = "buttonGenerateOther";
export const BUTTON_SUBSCRIBE_NOW = "buttonSubscribeNow";
export const BUTTON_ADD_USER = "buttonAddUser";
export const BUTTON_ADD_SHOP = "buttonAddShop";
export const BUTTON_DOWNLOAD_REPORT = "buttonDownloadReport";
export const BUTTON_PASS_TO_SUBSCRIPTION_BASIC =
  "buttonPassToSubscriptionBasic";
export const BUTTON_EXTEND = "buttonExtend";
export const BUTTON_ARCHIVE = "buttonArchive";
export const BUTTON_UNARCHIVE = "buttonUnarchive";
export const BUTTON_CREATE_TRANSACTION = "buttonCreateTransaction";
export const BUTTON_UPDATE_STATISTICS = "buttonUpdateStatistics";
export const BUTTON_SEND_PAYMENT = "buttonSendPayment";
export const BUTTON_CREATOR_CHAT = "buttonCreatorChat";
export const BUTTON_SEND_FILE = "buttonSendFile";
export const BUTTON_SEE_MORE = "buttonSeeMore";
export const BUTTON_SEE_LESS = "buttonSeeLess";
export const BUTTON_SEND = "buttonSend";
export const BUTTON_YOU_HAVE_DOUBTS = "buttonYouHaveDoubts";
export const BUTTON_WATCH_DEMO = "buttonBookDemo";
export const BUTTON_SAVE_CONTENT = "buttonSaveContent";
export const BUTTON_SEND_BROADCAST = "buttonSendBroadcast";
export const BUTTON_ADD_CONTENT = "buttonAddContent";
export const BUTTON_ADD_SELECTED_CONTENT = "buttonAddSelectedContent";
export const BUTTON_SEE_ALL_APPLICANTS = "buttonSeeAllApplicants";
export const BUTTON_GO_BACK = "buttonGoBack";
export const BUTTON_CLEAR_FILTERS = "buttonClearFilters";

export const BUTTON_TIKTOK_BILLING = "buttonTiktokBilling";
export const BUTTON_META_BILLING = "buttonMetaBilling";
export const BUTTON_REPLACE_CONTENT = "buttonReplaceContent";
export const BUTTON_CHANGE_CONTENT = "buttonChangeContent";
export const BUTTON_EDIT_CONTENT = "buttonEditContent";
export const BUTTON_CHANGE_SLIDE = "buttonChangeSlide";
export const PLATFORM_ONLY_ACCEPTS_VIDEOS = "platformOnlyAcceptsVideos";
export const BUTTON_SELECT_VIDEO = "buttonSelectVideo";
export const BUTTON_REPLACE_VIDEO = "buttonReplaceVideo";
export const BUTTON_SELECT_THIS_CONTENT = "buttonSelectThisContent";
export const BUTTON_REMOVE_SELECTION = "buttonRemoveSelection";
export const BUTTON_RECHARGE_BALANCE = "buttonRechargeBalance";
export const BUTTON_CONNECT_SHOPIFY = "buttonConnectShopify";
export const BUTTON_CONNECT_META = "buttonConnectMeta";
export const BUTTON_CONTACT_AN_ADVISOR = "buttonContactAnAdvisor";
export const BUTTON_GENERATE_SCRIPT = "buttonGenerateScript";
export const BUTTON_VIEW_INVOICE = "buttonViewInvoice";
export const BUTTON_ADJUST_PREFERENCES = "buttonAdjustPreferences";
export const BUTTON_GENERATE_AGAIN = "buttonGenerateAgain";
export const BUTTON_CREATE_ADS_CAMPAIGN = "buttonCreateAdsCampaign";
export const BUTTON_EDIT_BUDGET = "buttonEditBudget";
export const BUTTON_PUBLISH_CAMPAIGN = "buttonPublishCampaign";
export const BUTTON_START_CHAT = "buttonStartChat";
export const BUTTON_SELECT_CONTENT = "buttonSelectContent";
export const BUTTON_SELECT_DOCUMENT = "buttonSelectDocument";
export const BUTTON_SELECT_POST = "buttonSelectPost";
export const BUTTON_CREATE_WITH_CANVA = "buttonCreateWithCanva";
export const BUTTON_CREATE_WITH_IA = "buttonCreateWithIA";
export const BUTTON_CONNECT_CANVA = "buttonConnectCanva";
export const BUTTON_USE_THIS_CONTENT = "buttonUseThisContent";
export const BUTTON_CONNECT_GOOGLE = "buttonConnectGoogle";
export const BUTTON_CONNECT_GOOGLE_DRIVE = "buttonConnectGoogleDrive";
export const BUTTON_SELECT = "buttonSelect";
export const BUTTON_DESELECT = "buttonDeselect";
export const BUTTON_SEND_CODE = "buttonSendCode";
export const BUTTON_VERIFY_CODE = "buttonVerifyCode";
export const BUTTON_RESEND_CODE = "buttonResendCode";
export const BUTTON_CONNECTED = "buttonConnected";
export const BUTTON_DISCONNECTED = "buttonDisconnected";
export const BUTTON_ADD_RE_TARGETING = "buttonAddReTargeting";
export const BUTTON_BUY_PLAN = "buttonBuyPlan";
export const BUTTON_ADD = "buttonAdd";
export const BUTTON_UPLOAD_CONTENT_FROM_ADS_PLATFORMS =
  "buttonUploadContentFromAdsPlatforms";
export const BUTTON_UPDATE = "buttonUpdate";
export const BUTTON_CONNECT_ACCOUNT = "buttonConnectAccount";
export const BUTTON_REPLACE = "buttonReplace";
export const BUTTON_SUPPORT = "buttonSupport";
export const BUTTON_CANCEL_SUBSCRIPTION = "buttonCancelSubscription";
export const BUTTON_REACTIVATE_SUBSCRIPTION = "buttonReactivateSubscription";
export const BUTTON_CHANGE_PAYMENT_METHODS = "buttonManagePaymentMethods";
export const BUTTON_DELETE_PLATFORM = "buttonDeletePlatform";
export const BUTTON_GENERATE_WITH_AI = "buttonGenerateWithAI";
export const BUTTON_SELECT_AVATAR = "buttonSelectAvatar";
export const BUTTON_CHANGE_AVATAR = "buttonChangeAvatar";
export const BUTTON_CONTACT_US = "buttonContactUs";
export const BUTTON_GENERATE_RANDOM = "buttonGenerateRandom";
export const BUTTON_GENERATE = "buttonGenerate";
export const BUTTON_REGISTER_WITH_GOOGLE = "buttonRegisterWithGoogle";
export const BUTTON_LOG_IN_WITH_GOOGLE = "buttonLogInWithGoogle";
export const BUTTON_CHANGE_LOGO = "buttonChangeLogo";
export const BUTTON_DELETE_LOGO = "buttonDeleteLogo";
export const BUTTON_UPGRADE_PLAN = "buttonUpgradePlan";
export const BUTTON_UPGRADE_PLAN_2 = "buttonUpgradePlan2";
export const LABEL_CURRENT_SUBSCRIPTION_PLAN = "labelCurrentSubscriptionPlan";
export const BUTTON_UPGRADE_TO_PAID_PLAN = "buttonUpgradeToPaidPlan";
export const BUTTON_BOOK_A_DEMO = "buttonBookADemo";
export const BUTTON_CREATE_TEMPLATE = "buttonCreateTemplate";
export const BUTTON_EDIT_TEMPLATE = "buttonEditTemplate";
export const BUTTON_APPLY_OPTIMIZATIONS = "buttonApplyOptimizations";
export const BUTTON_OPTIMIZATION_APPLIED = "buttonOptimizationApplied";
export const BUTTON_CHANGES_APPLIED = "buttonChangesApplied";
export const BUTTON_APPLY_CHANGES = "buttonApplyChanges";
export const BUTTON_PREVIEW_CHANGES = "buttonPreviewChanges";
export const BUTTON_DISCARD_OPTIMIZATIONS = "buttonDiscardOptimizations";
export const BUTTON_DISCARD_OPTIMIZATIONS_DESCRIPTION =
  "buttonDiscardOptimizationsDescription";
export const BUTTON_VIEW_DETAILED_REPORT = "buttonViewDetailedReport";
export const BUTTON_SELECT_INSTANT_FORM = "buttonSelectInstantForm";
export const BUTTON_RECONNECT_ACCOUNT = "buttonReconnectAccount";
export const BUTTON_RECONNECT = "buttonReconnect";
export const BUTTON_ADD_CONVERSION_ACTION = "buttonAddConversionAction";
export const BUTTON_FILTER = "buttonFilter";
export const BUTTON_CONNECT_LINKEDIN = "buttonConnectLinkedin";
export const BUTTON_REMOVE = "buttonRemove";
export const BUTTON_TRY_AGAIN = "buttonTryAgain";
export const BUTTON_PUBLISH_CHANGES = "buttonPublishChanges";
export const BUTTON_ANALYZE = "buttonAnalyze";
export const BUTTON_EDIT_PLACEMENTS = "buttonEditPlacements";
export const BUTTON_DROP_PIN = "buttonDropPin";
export const BUTTON_EDIT_ADVANTAGE_ENHANCES = "buttonEditAdvantageEnhances";
export const BUTTON_COMPLETE_INFORMATION = "buttonCompleteInformation";
export const BUTTON_ADD_KEYWORDS = "buttonAddKeyword";
export const BUTTON_SELECT_POST_FROM_SOCIAL_NETWORKS =
  "buttonSelectPostFromSocialNetworks";
export const BUTTON_CREATE_NEW = "buttonCreateNew";
export const BUTTON_PREVIEW_OPTIMIZATION = "buttonPreviewOptimization";
export const BUTTON_CHANGE_CREATIVE = "buttonChangeCreative";
export const BUTTON_APPLIED = "buttonApplied";
export const BUTTON_SKIP = "buttonSkip";
export const BUTTON_ADD_VIDEO = "buttonAddVideo";
export const BUTTON_CREATE_FROM_SCRATCH = "buttonCreateFromScratch";
export const BUTTON_CREATE_FROM_TEMPLATES = "buttonCreateFromTemplates";
export const BUTTON_IMPORT_FROM_PLATFORM = "buttonImportFromPlatform";
export const BUTTON_IMPORT_FROM_GOOGLE_DRIVE = "buttonImportFromGoogleDrive";
export const BUTTON_IMPORT_CAMPAIGN = "buttonImportCampaign";
export const BUTTON_DUPLICATE_FROM_PLATFORM = "buttonDuplicateFromPlatform";
export const BUTTON_DUPLICATE_CAMPAIGN = "buttonDuplicateCampaign";
export const BUTTON_SAVE_AND_PUBLISH = "buttonSaveAndPublish";
export const BUTTON_ADD_SITE_LINK = "buttonAddSiteLink";
export const BUTTON_EDIT_SITE_LINKS = "buttonEditSiteLinks";
export const BUTTON_SELECT_CSV_FILE = "buttonSelectCsvFile";
export const BUTTON_DOWNLOAD_TEMPLATE = "buttonDownloadTemplate";
export const BUTTON_UPLOAD_GOOGLE_ASSET_LIBRARY =
  "buttonUploadGoogleAssetLibrary";
export const BUTTON_MARK_AS_DONE = "buttonMarkAsDone";
export const BUTTON_SELECT_INSTANT_EXPERIENCE = "buttonSelectInstantExperience";
export const BUTTON_VIEW_ACTION = "buttonViewAction";
export const BUTTON_CREATE_CUSTOM_AUDIENCE = "buttonCreateCustomAudience";
export const BUTTON_CLEAR_ALL = "buttonClearAll";
export const BUTTON_RESET_TO_BASIC_METRICS = "buttonResetToBasicMetrics";
export const BUTTON_GO_TO_BILLING = "buttonGoToBilling";
export const BUTTON_WHY_THIS_RECOMMENDATION = "buttonWhyThisRecommendation";
export const BUTTON_CLEAR_DATES = "buttonClearDates";
export const BUTTON_NEW_CAMPAIGN = "buttonNewCampaign";
export const BUTTON_DISCONNECT_ACCOUNT = "buttonDisconnectAccount";
export const BUTTON_SELECT_ALL = "buttonSelectAll";
export const BUTTON_DESELECT_ALL = "buttonDeselectAll";
export const BUTTON_USE_SAVED_AUDIENCE = "buttonUseSavedAudience";

/*CATEGORIES*/
export const NEW_CREATORS_CATEGORY = "newCategoryCreator";
export const FAVORITES_CATEGORY = "favoritesCategory";
export const TOP_RATED_CATEGORY = "topRatedCategory";

//VERSION
export const NEW_VERSION_TITLE = "newVersionTitle";
export const NEW_VERSION_DESCRIPTION = "newVersionDescription";

export const DESCRIPTION_SEND_MESSAGE = "descriptionSendMessage";
export const DESCRIPTION_SEND_PAYMENT = "descriptionSendPayment";

export const MODAL_PAY_CREATOR_AMOUNT_LABEL = "modalPayCreatorAmountLabel";

/*PAGES*/

//CREATORS
export const CREATORS_TITLE = "creatorsTitle";
export const CREATOR_DESCRIPTION = "creatorsDescription";
export const SEARCH_BAR_TEXT_CREATORS = "searchBarTextCreators";
export const TAB_CREATORS = "tabCreators";
export const TAB_REQUESTS = "tabRequests";
export const TAB_SUGGESTED = "tabSuggested";
export const CREATORS_SUGGESTED_EMPTY = "creatorsSuggestedEmpty";
export const CREATORS_TABLE_COLUMN_NAME = "creatorsTableColumnName";
export const CREATORS_TABLE_COLUMN_CITY = "creatorsTableColumnCity";
export const CREATORS_TABLE_COLUMN_AUDIENCE = "creatorsTableColumnAudience";
export const CREATORS_TABLE_COLUMN_ENGAGEMENT = "creatorsTableColumnEngagement";
export const CREATORS_TABLE_COLUMN_DATE = "creatorsTableColumnDate";
export const CREATORS_TABLE_COLUMN_CATEGORIES = "creatorsTableColumnCategories";
export const CREATORS_TABLE_COLUMN_SCORE = "creatorsTableColumnScore";
export const CREATORS_TABLE_COLUMN_ACTIVITY = "creatorsTableColumnActivity";
export const DISCOVER_NEW_CREATORS = "discoverNewCreators";

export const RECURRENT_FIELDS_DEFAULT_TITLE = "recurrentFieldsDefaultTitle";
export const RECURRENT_FIELD_REPEAT_COUNT_PLACEHOLDER =
  "recurrentFieldRepeatCountPlaceholder";
export const RECURRENT_FIELD_REPEAT_COUNT_MIN_VALIDATION =
  "recurrentFieldRepeatCountMinValidation";
export const RECURRENT_FIELD_REPEAT_COUNT_MAX_VALIDATION =
  "recurrentFieldRepeatCountMaxValidation";
export const RECURRENT_FIELD_FREQUENCY_PLACEHOLDER =
  "recurrentFieldFrequencyPlaceholder";
export const RECURRENT_FIELD_DAY_AN_PLACEHOLDER =
  "recurrentFieldDayAnPlaceholder";
export const RECURRENT_FIELD_DAY_ALL_PLACEHOLDER =
  "recurrentFieldDayAllPlaceholder";
export const MODAL_BROADCAST_ARIAL_LABEL = "modalBroadcastAriaLabel";
export const MODAL_BROADCAST_TITLE = "modalBroadcastTitle";
export const MODAL_BROADCAST_DESCRIPTION = "modalBroadcastDescription";
export const MODAL_BROADCAST_SELECT_USER_PLACEHOLDER =
  "modalBroadcastSelectUserPlaceholder";
export const MODAL_BROADCAST_SELECT_USER_REQUIRED =
  "modalBroadcastSelectUserRequired";
export const MODAL_BROADCAST_MESSAGE_PLACEHOLDER =
  "modalBroadcastMessagePlaceholder";
export const MODAL_BROADCAST_CONFIRM_TITLE = "modalBroadcastConfirmTitle";
export const MODAL_BROADCAST_CONFIRM_DESCRIPTION =
  "modalBroadcastConfirmDescription";
export const BROADCAST_MESSAGE_SENT = "broadcastMessageSent";

//PUBLICATIONS
export const PUBLICATIONS_TITLE = "publicationsTitle";
export const PUBLICATIONS_DESCRIPTION = "publicationsDescription";
export const PUBLICATIONS_TABLE_ARIA_LABEL = "publicationsTableAriaLabel";
export const PUBLICATIONS_TABLE_COLUMN_DATE = "publicationsTableColumnDate";
export const PUBLICATION_STATUS_PENDING_CONTENT =
  "publicationStatusPendingContent";
export const PUBLICATION_STATUS_PENDING_APPROVAL =
  "publicationStatusPendingApproval";
export const PUBLICATION_STATUS_PENDING = "publicationStatusPending";
export const PUBLICATION_STATUS_PENDING_SOCIAL =
  "publicationStatusPendingSocial";
export const PUBLICATIONS_STATUS_PENDING_ANALYTICS =
  "publicationStatusPendingAnalytics";
export const PUBLICATIONS_STATUS_SENT = "publicationStatusSent";
export const PUBLICATIONS_STATUS_FEEDBACK = "publicationStatusFeedback";
export const PUBLICATIONS_STATUS_VERIFIED = "publicationStatusVerified";

//PUBLICATION
export const PUBLICATION_TITLE = "publicationTitle";
export const NUMBER_PUBLICATION = "numberPublication";
export const FEEDBACK_TITLE = "feedbackTitle";
export const PUBLICATION_DESCRIPTION = "publicationDescription";
export const PUBLICATION_FINISH_ONBOARDING_NEW_BRANDS_DESCRIPTION =
  "publicationFinishOnboardingNewBrandsDescription";
export const PUBLICATION_FINISH_DESCRIPTION = "publicationFinishDescription";
export const FEEDBACK_PLACEHOLDER = "feedbackPlaceholder";
export const FEEDBACK_REASON_ABOUT = "feedbackReasonAbout";
export const FEEDBACK_REASON = "feedbackReason";
export const FEEDBACK_COMMENT = "feedbackComment";
export const ANALYTICS_EXPLANATION_TITLE = "analyticsExplanationTitle";
export const ANALYTICS_EXPLANATION_DESCRIPTION =
  "analyticsExplanationDescription";
export const ANALYTICS_EXPLANATION_DESCRIPTION_2 =
  "analyticsExplanationDescription2";
export const ANALYTICS_EXPLANATION_ACCOUNTS_REACHED_DESCRIPTION =
  "analyticsExplanationAccountsReachedDescription";
export const ANALYTICS_EXPLANATION_ENGAGEMENT_DESCRIPTION =
  "analyticsExplanationEngagementDescription";
export const ANALYTICS_EXPLANATION_STICKERS_TAPS_DESCRIPTION =
  "analyticsExplanationStickersTapsDescription";
export const ANALYTICS_EXPLANATION_NAVIGATION_DESCRIPTION =
  "analyticsExplanationNavigationDescription";
export const RECURRENT_VALUE_NOT_FOUND = "recurrentValueNotFound";
export const MODAL_REVIEW_ARIA_LABEL = "modalReviewAriaLabel";
export const MODAL_REVIEW_DISCLAIMER = "modalReviewDisclaimer";
export const MODAL_REVIEW_SCORE_PLACEHOLDER = "modalReviewScorePlaceholder";
export const MODAL_REVIEW_SCORE_CONTENT_PLACEHOLDER =
  "modalReviewScoreContentPlaceholder";
export const MODAL_REVIEW_SCORE_CONTENT_MIN_VALUE =
  "modalReviewScoreContentMinValue";
export const MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_TITLE =
  "modalReviewScoreContentExplanationTitle";
export const MODAL_REVIEW_SCORE_CONTENT_EXPLANATION_DESCRIPTION =
  "modalReviewScoreContentExplanationDescription";
export const MODAL_REVIEW_SCORE_ENGAGEMENT_PLACEHOLDER =
  "modalReviewScoreEngagementPlaceholder";
export const MODAL_REVIEW_SCORE_ENGAGEMENT_MIN_VALUE =
  "modalReviewScoreEngagementMinValue";
export const MODAL_REVIEW_COMMENT_PLACEHOLDER = "modalReviewCommentPlaceholder";
export const REVISION_COUNT = "revisionCount";
export const UPLOAD_NEW_CONTENT = "uploadNewContent";
export const ADD_URL_PUBLICATION = "addUrlPublication";

//ADS CAMPAIGNS LOGS
export const ADS_CAMPAIGNS_LOGS_TITLE = "adsCampaignsLogsTitle";
export const ADS_CAMPAIGNS_LOGS_CONTEXT_TITLE = "adsCampaignsLogsContextTitle";
export const BUTTON_REVERT_CHANGE = "buttonRevertChange";
export const REVERT_CHANGE_CONFIRM_TITLE = "revertChangeConfirmTitle";
export const REVERT_CHANGE_CONFIRM_TEXT = "revertChangeConfirmText";
export const REVERT_CHANGE_SUCCESS = "revertChangeSuccess";
export const REVERT_CHANGE_ERROR = "revertChangeError";

//SETTINGS
export const SETTINGS_TITLE = "settingsTitle";
export const API_KEYS_TAB_TITLE = "apiKeysTabTitle";
export const BYOK_SETTINGS_DESCRIPTION = "byokSettingsDescription";
export const BYOK_DEFAULT_PAYMENT_MODE_LABEL = "byokDefaultPaymentModeLabel";
export const BYOK_DEFAULT_PAYMENT_MODE_HELPER = "byokDefaultPaymentModeHelper";
export const BYOK_PAYMENT_MODE_CREDITS = "byokPaymentModeCredits";
export const BYOK_PAYMENT_MODE_BYOK = "byokPaymentModeByok";
export const BYOK_CONFIGURED_PREVIEW = "byokConfiguredPreview";
export const BYOK_NOT_CONFIGURED = "byokNotConfigured";
export const BYOK_PROVIDER_INPUT_LABEL = "byokProviderInputLabel";
export const BYOK_PROVIDER_INPUT_PLACEHOLDER = "byokProviderInputPlaceholder";
export const BYOK_SAVE_BUTTON = "byokSaveButton";
export const BYOK_SAVING_BUTTON = "byokSavingButton";
export const BYOK_SAVE_SUCCESS_TITLE = "byokSaveSuccessTitle";
export const BYOK_SAVE_SUCCESS_DESCRIPTION = "byokSaveSuccessDescription";
export const BYOK_SAVE_ERROR = "byokSaveError";
export const BYOK_PROVIDER_KEYS_TITLE = "byokProviderKeysTitle";
export const BYOK_PROVIDERS_COUNTER = "byokProvidersCounter";
export const BYOK_KEY_CONFIGURED_STATUS = "byokKeyConfiguredStatus";
export const BYOK_NO_KEY_CONFIGURED_STATUS = "byokNoKeyConfiguredStatus";
export const BYOK_REPLACE_KEY = "byokReplaceKey";
export const BYOK_DELETE_KEY = "byokDeleteKey";
export const BYOK_DELETE_KEY_TITLE = "byokDeleteKeyTitle";
export const BYOK_DELETE_KEY_DESCRIPTION = "byokDeleteKeyDescription";
export const BYOK_DELETE_KEY_ERROR = "byokDeleteKeyError";
export const BYOK_DELETE_KEY_SUCCESS_TITLE = "byokDeleteKeySuccessTitle";
export const BYOK_DELETE_KEY_SUCCESS_DESCRIPTION =
  "byokDeleteKeySuccessDescription";
export const BYOK_KEY_ENCRYPTED_NOTICE = "byokKeyEncryptedNotice";
export const BYOK_DEFAULT_PAYMENT_MODE_DESCRIPTION =
  "byokDefaultPaymentModeDescription";
export const BYOK_PROVIDERS_WILL_BE_USED = "byokProvidersWillBeUsed";
export const BYOK_CONFIGURE_MISSING_PROVIDERS = "byokConfigureMissingProviders";
export const MODAL_API_KEYS_ARIA_LABEL = "modalApiKeysAriaLabel";

//ADS CAMPAIGNS
export const ADS_CAMPAIGNS_TITLE = "adsCampaignsTitle";
export const ADS_CAMPAIGNS_TITLE_DASHBOARD = "adsCampaignsTitleDashboard";
export const ADS_CAMPAIGNS_DESCRIPTION = "adsCampaignsDescription";

//ADS CAMPAIGN
export const ADS_CONFIGURATION_APPS_TITLE = "adsConfigurationAppsTitle";
export const ADS_CONFIGURATION_DESTINATION_TITLE =
  "adsConfigurationDestinationTitle";
export const ADS_CAMPAIGN_PREVIEW = "adsCampaignPreviewTitle";
export const ADS_CAMPAIGN_TITLE = "adsCampaignTitle";
export const ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE =
  "adsCampaignCampaignInformationSubTitle";
export const ADS_CAMPAIGN_BUDGET_INFORMATION_SUB_TITLE =
  "adsCampaignBudgetInformationSubTitle";
export const ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE =
  "adsCampaignSegmentationSubTitle";
export const ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE =
  "adsCampaignSavedAudienceSubTitle";
export const ADS_CAMPAIGN_ADDITIONAL_CONFIGURATION_AD_GROUP_SUB_TITLE =
  "adsCampaignAdditionalConfigurationAdGroupSubTitle";
export const ADS_CAMPAIGN_HAS_BEEN_FINISHED = "adsCampaignHasBeenFinished";
export const ADS_CAMPAIGN_HAS_BEEN_ACTIVATE = "adsCampaignHasBeenActivate";
export const ADS_CAMPAIGN_HAS_BEEN_SAVE = "adsCampaignHasBeenSave";
export const ADS_CAMPAIGN_HAS_BEEN_DUPLICATE = "adsCampaignHasBeenDuplicate";
export const ADS_CAMPAIGN_USE_GENERAL_BUDGET = "adsCampaignUseGeneralBudget";
export const ADS_CAMPAIGN_PLATFORM_BRAND_CONFIGURATION_SUB_TITLE =
  "adsCampaignPlatformBrandConfigurationSubTitle";
export const ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE =
  "adsCampaignAdGroupBudgetInformationSubTitle";
export const ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL =
  "adsCampaignAdGroupBudgetInformationGeneral";
export const ADS_CAMPAIGN_AD_GROUP_INFORMATION_SUB_TITLE =
  "adsCampaignAdGroupInformationSubTitle";
export const ADS_CAMPAIGN_PLATFORM_ADDITIONAL_CONFIGURATION_SUB_TITLE =
  "adsCampaignPlatformAdditionalConfigurationSubTitle";
export const ADS_CAMPAIGN_PLATFORM_ASSETS_CONFIGURATION_SUB_TITLE =
  "adsCampaignPlatformAssetsConfigurationSubTitle";
export const ADS_CAMPAIGNS_PLATFORM_TEXTS_SUB_TITLE =
  "adsCampaignsPlatformTextsSubTitle";
export const ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE =
  "adsCampaignAdGroupProductsSubTitle";
export const ADS_CAMPAIGN_AD_APP_CONFIGURATION_SUB_TITLE =
  "adsCampaignAdAppConfigurationSubTitle";
export const ADS_CAMPAIGN_PRODUCTS_CONFIGURATION_SUB_TITLE =
  "adsCampaignProductsConfigurationSubTitle";

//ProductSetAudienceBuilder
export const PRODUCT_SET_AUDIENCE_BUILDER_TITLE =
  "productSetAudienceBuilderTitle";
export const PRODUCT_SET_AUDIENCE_BUILDER_PROSPECTING_TITLE =
  "productSetAudienceBuilderProspectingTitle";
export const PRODUCT_SET_AUDIENCE_BUILDER_RETARGETING_TITLE =
  "productSetAudienceBuilderRetargetingTitle";
export const PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_PROSPECTING_SEGMENT =
  "productSetAudienceBuilderTiktokProspectingSegment";
export const PRODUCT_SET_AUDIENCE_BUILDER_TIKTOK_RETARGETING_SEGMENT =
  "productSetAudienceBuilderTiktokRetargetingSegment";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_TITLE =
  "productSetAudienceBuilderCustomTitle";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_TITLE =
  "productSetAudienceBuilderCustomInclusionsTitle";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_INCLUSIONS_ADD_BUTTON =
  "productSetAudienceBuilderCustomInclusionsAddButton";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_TITLE =
  "productSetAudienceBuilderCustomExclusionsTitle";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_EXCLUSIONS_ADD_BUTTON =
  "productSetAudienceBuilderCustomExclusionsAddButton";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_IN_THE_LAST =
  "productSetAudienceBuilderCustomInTheLast";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_DAYS =
  "productSetAudienceBuilderCustomDays";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_LABEL =
  "productSetAudienceBuilderPresetViewedOrAddedNotPurchasedLabel";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_VIEWED_OR_ADDED_NOT_PURCHASED_DESCRIPTION =
  "productSetAudienceBuilderPresetViewedOrAddedNotPurchasedDescription";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_LABEL =
  "productSetAudienceBuilderPresetAddedNotPurchasedLabel";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_ADDED_NOT_PURCHASED_DESCRIPTION =
  "productSetAudienceBuilderPresetAddedNotPurchasedDescription";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_LABEL =
  "productSetAudienceBuilderPresetUpSellLabel";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_DESCRIPTION =
  "productSetAudienceBuilderPresetUpSellDescription";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_UP_SELL_SELECT_PRODUCT_SET_LABEL =
  "productSetAudienceBuilderPresetUpSellSelectProductSetLabel";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_LABEL =
  "productSetAudienceBuilderPresetCrossSellLabel";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_DESCRIPTION =
  "productSetAudienceBuilderPresetCrossSellDescription";
export const PRODUCT_SET_AUDIENCE_BUILDER_PRESET_CROSS_SELL_SELECT_PRODUCT_SET_LABEL =
  "productSetAudienceBuilderPresetCrossSellSelectProductSetLabel";
export const PRODUCT_SET_AUDIENCE_BUILDER_CUSTOM_SELECT_PRODUCT_SET_LABEL =
  "productSetAudienceBuilderCustomSelectProductSetLabel";

export const MODAL_ERRORS_CAMPAIGNS_TITLE = "modalErrorsCampaignsTitle";
export const MODAL_ERRORS_CAMPAIGNS_DESCRIPTION =
  "modalErrorsCampaignsDescription";

//CREATE ADS CAMPAIGN
export const CREATE_ADS_CAMPAIGN_MODE_QUESTION =
  "createAdsCampaignModeQuestion";
export const CREATE_ADS_CAMPAIGN_NAME_QUESTION =
  "createAdsCampaignNameQuestion";
export const CREATE_ADS_CAMPAIGN_NAME_PLACEHOLDER =
  "createAdsCampaignNamePlaceholder";
export const CREATE_ADS_CAMPAIGN_OBJECTIVE_QUESTION =
  "createAdsCampaignObjectiveQuestion";
export const CREATE_ADS_CAMPAIGN_APP_PROMOTION_QUESTION =
  "createAdsCampaignAppPromotionQuestion";
export const CREATE_ADS_CAMPAIGN_TYPE_QUESTION =
  "createAdsCampaignTypeQuestion";
export const CREATE_ADS_CAMPAIGN_OBJECTIVE_DESCRIPTION =
  "createAdsCampaignObjectiveDescription";
export const CREATE_ADS_CAMPAIGN_DESTINATION_TYPE_QUESTION =
  "createAdsCampaignDestinationTypeQuestion";
export const CREATE_ADS_CAMPAIGN_TARGET_CPA_QUESTION =
  "createAdsCampaignTargetCpaQuestion";
export const CREATE_ADS_CAMPAIGN_DESTINATION_URL_QUESTION =
  "createAdsCampaignDestinationUrlQuestion";
export const CREATE_ADS_CAMPAIGN_DEEP_LINK_QUESTION =
  "createAdsCampaignDeepLinkQuestion";
export const CREATE_ADS_CAMPAIGN_DATES_QUESTION =
  "createAdsCampaignDatesQuestion";
export const CREATE_ADS_CAMPAIGN_AD_FORMAT_QUESTION =
  "createAdsCampaignAdFormatQuestion";
export const CREATE_ADS_CAMPAIGN_WEBSITE_URL_QUESTION =
  "createAdsCampaignWebsiteUrlQuestion";
export const CREATE_ADS_CAMPAIGN_AD_ACCOUNT_QUESTION =
  "createAdsCampaignAdAccountQuestion";
export const CREATE_ADS_CAMPAIGN_AD_ACCOUNTS_QUESTION =
  "createAdsCampaignAdAccountsQuestion";
export const CREATE_ADS_CAMPAIGN_IDENTITIES_ACCOUNTS_QUESTION =
  "createAdsCampaignIdentitiesQuestion";
export const CREATE_ADS_CAMPAIGN_CATALOG_QUESTION =
  "createAdsCampaignCatalogQuestion";
export const CREATE_ADS_CAMPAIGN_CATALOG_FOR_APP_INSTALL_QUESTION =
  "createAdsCampaignCatalogForAppInstallQuestion";
export const CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_QUESTION =
  "createAdsCampaignTikTokCampaignTypeQuestion";
export const CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_WEBSITE =
  "createAdsCampaignTikTokCampaignTypeOptionWebsite";
export const CREATE_ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_OPTION_APP =
  "createAdsCampaignTikTokCampaignTypeOptionApp";
export const CREATE_ADS_CAMPAIGN_APP_ID_QUESTION =
  "createAdsCampaignAppIdQuestion";
export const CREATE_ADS_CAMPAIGN_TRACKING_QUESTION =
  "createAdsCampaignTrackingQuestion";
export const CREATE_ADS_CAMPAIGN_TRACKINGS_QUESTION =
  "createAdsCampaignTrackingsQuestion";
export const CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENT_QUESTION =
  "createAdsCampaignTrackingCustomEventQuestion";
export const CREATE_ADS_CAMPAIGN_TRACKING_CUSTOM_EVENTS_QUESTION =
  "createAdsCampaignTrackingsCustomEventsQuestion";
export const CREATE_ADS_CAMPAIGN_PLATFORM_QUESTION =
  "createAdsCampaignPlatformQuestion";
export const CREATE_ADS_CAMPAIGN_TYPE_BUDGET_QUESTION =
  "createAdsCampaignTypeBudgetQuestion";

export const CREATE_ADS_CAMPAIGN_TYPE_BUDGET_DAILY_RADIO_LABEL =
  "createAdsCampaignTypeBudgetDailyRadioLabel";

export const CREATE_ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_RADIO_LABEL =
  "createAdsCampaignTypeBudgetLifetimeRadioLabel";
export const CREATE_ADS_CAMPAIGN_BUDGET_DAILY_QUESTION =
  "createAdsCampaignBudgetDailyQuestion";
export const CREATE_ADS_CAMPAIGN_BUDGET_TOTAL_QUESTION =
  "createAdsCampaignBudgetTotalQuestion";
export const CREATE_ADS_CAMPAIGN_BUDGET_DESCRIPTION_QUESTION =
  "createAdsCampaignBudgetDescriptionQuestion";
export const CREATE_ADS_CAMPAIGN_BUDGET_PLACEHOLDER =
  "createAdsCampaignBudgetPlaceholder";
export const CREATE_ADS_CAMPAIGN_START_END_DATE_QUESTION =
  "createAdsCampaignStartEndDateQuestion";
export const CREATE_ADS_CAMPAIGN_LOCATIONS_QUESTION =
  "createAdsCampaignLocationsQuestion";
export const CREATE_ADS_CAMPAIGN_LOCATIONS_PLACEHOLDER =
  "createAdsCampaignLocationsPlaceholder";
export const CREATE_ADS_CAMPAIGN_AGE_RANGE_QUESTION =
  "createAdsCampaignAgeRangeQuestion";
export const CREATE_ADS_CAMPAIGN_GENDERS_QUESTION =
  "createAdsCampaignGendersQuestion";
export const CREATE_ADS_CAMPAIGN_INTERESTS_QUESTION =
  "createAdsCampaignInterestsQuestion";
export const CREATE_ADS_CAMPAIGN_INTERESTS_PLACEHOLDER =
  "createAdsCampaignInterestsPlaceholder";
export const CREATE_ADS_CAMPAIGN_BEHAVIORS_QUESTION =
  "createAdsCampaignBehaviorsQuestion";
export const CREATE_ADS_CAMPAIGN_BEHAVIORS_PLACEHOLDER =
  "createAdsCampaignBehaviorsPlaceholder";
export const CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_QUESTION =
  "createAdsCampaignDemographicsQuestion";
export const CREATE_ADS_CAMPAIGN_DEMOGRAPHICS_PLACEHOLDER =
  "createAdsCampaignDemographicsPlaceholder";
export const CREATE_ADS_CAMPAIGN_DESCRIPTION_QUESTION =
  "createAdsCampaignDescriptionQuestion";
export const CREATE_ADS_CAMPAIGN_DESCRIPTION_PLACEHOLDER =
  "createAdsCampaignDescriptionPlaceholder";
export const CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION =
  "createAdsCampaignContextQuestion";
export const CREATE_ADS_CAMPAIGN_CONTEXT_DESCRIPTION =
  "createAdsCampaignContextDescription";
export const CREATE_ADS_CAMPAIGN_CONTEXT_PLACEHOLDER =
  "createAdsCampaignContextPlaceholder";
export const CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_QUESTION =
  "createAdsCampaignProductContextQuestion";
export const CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_DESCRIPTION =
  "createAdsCampaignProductContextDescription";
export const CREATE_ADS_CAMPAIGN_PRODUCT_CONTEXT_PLACEHOLDER =
  "createAdsCampaignProductContextPlaceholder";
export const CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_QUESTION =
  "createAdsCampaignTargetContextQuestion";
export const CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_DESCRIPTION =
  "createAdsCampaignTargetContextDescription";
export const CREATE_ADS_CAMPAIGN_TARGET_CONTEXT_PLACEHOLDER =
  "createAdsCampaignTargetContextPlaceholder";
export const CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_QUESTION =
  "createAdsCampaignBrandContextQuestion";
export const CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_DESCRIPTION =
  "createAdsCampaignBrandContextDescription";
export const CREATE_ADS_CAMPAIGN_BRAND_CONTEXT_PLACEHOLDER =
  "createAdsCampaignBrandContextPlaceholder";
export const CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_QUESTION =
  "createAdsCampaignSocialNetworkQuestion";
export const CREATE_ADS_CAMPAIGN_SOCIAL_NETWORK_PLACEHOLDER =
  "createAdsCampaignSocialNetworkPlaceholder";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_QUESTION =
  "createAdsCampaignMediaUrlQuestion";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_SERVICES_QUESTION =
  "createAdsCampaignMediaUrlServicesQuestion";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DOCUMENTS_QUESTION =
  "createAdsCampaignMediaUrlDocumentsQuestion";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_POSTS_QUESTION =
  "createAdsCampaignMediaUrlPostsQuestion";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_PRODUCTS_QUESTION =
  "createAdsCampaignMediaUrlProductsQuestion";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT =
  "createAdsCampaignMediaUrlDescriptionProduct";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_PRODUCT_SINGLE =
  "createAdsCampaignMediaUrlDescriptionProductSingle";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE_SINGLE =
  "createAdsCampaignMediaUrlDescriptionServiceSingle";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_SERVICE =
  "createAdsCampaignMediaUrlDescriptionService";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_WITH_OUT_CAROUSEL =
  "createAdsCampaignMediaUrlDescriptionWithoutCarousel";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_DOCUMENTS =
  "createAdsCampaignMediaUrlDescriptionDocuments";
export const LINKEDIN_DOCUMENT_PDF_PREVIEW_LOADING =
  "linkedinDocumentPdfPreviewLoading";
export const LINKEDIN_DOCUMENT_PDF_PREVIEW_ERROR =
  "linkedinDocumentPdfPreviewError";
export const LINKEDIN_DOCUMENT_PDF_PREVIEW_ALT =
  "linkedinDocumentPdfPreviewAlt";
export const LINKEDIN_DOCUMENT_PREVIEW_PREV = "linkedinDocumentPreviewPrev";
export const LINKEDIN_DOCUMENT_PREVIEW_NEXT = "linkedinDocumentPreviewNext";
export const LINKEDIN_DOCUMENT_PREVIEW_PAGE_COUNT =
  "linkedinDocumentPreviewPageCount";
export const LINKEDIN_DOCUMENT_PREVIEW_OPEN_NEW_TAB =
  "linkedinDocumentPreviewOpenNewTab";
export const CREATE_ADS_CAMPAIGN_MEDIA_URL_DESCRIPTION_CAROUSEL =
  "createAdsCampaignMediaUrlDescriptionCarousel";
export const CREATE_ADS_CAMPAIGN_TEMPLATE_QUESTION =
  "createAdsCampaignTemplateQuestion";
export const CREATE_ADS_CAMPAIGN_TEMPLATE_SINGULAR =
  "createAdsCampaignTemplateSingular";
export const CREATE_ADS_CAMPAIGN_TEMPLATE_MULTIPLE =
  "createAdsCampaignTemplateMultiple";
export const CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_QUESTION =
  "createAdsCampaignMultipleProductsQuestion";
export const CREATE_ADS_CAMPAIGN_MULTIPLE_PRODUCTS_DESCRIPTION =
  "createAdsCampaignMultipleProductsDescription";
export const CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_QUESTION =
  "createAdsCampaignMultipleServicesQuestion";
export const CREATE_ADS_CAMPAIGN_MULTIPLE_SERVICES_DESCRIPTION =
  "createAdsCampaignMultipleServicesDescription";
export const BUTTON_ADD_PRODUCT = "buttonAddProduct";
export const BUTTON_ADD_SERVICE = "buttonAddService";
export const PRODUCT_URL_PLACEHOLDER = "productUrlPlaceholder";
export const SERVICE_URL_PLACEHOLDER = "serviceUrlPlaceholder";
export const PRODUCT_LABEL = "productLabel";
export const SERVICE_LABEL = "serviceLabel";
export const PRODUCT_FIELDS_REQUIRED = "productFieldsRequired";
export const SERVICE_FIELDS_REQUIRED = "serviceFieldsRequired";
export const PRODUCT_URL_INVALID = "productUrlInvalid";
export const SERVICE_URL_INVALID = "serviceUrlInvalid";
export const MEDIA_URLS_TAB_SINGULAR_PRODUCT = "mediaUrlsTabSingularProduct";
export const MEDIA_URLS_TAB_SINGULAR_SERVICE = "mediaUrlsTabSingularService";
export const MEDIA_URLS_TAB_MULTIPLE_PRODUCTS = "mediaUrlsTabMultipleProducts";
export const MEDIA_URLS_TAB_MULTIPLE_SERVICES = "mediaUrlsTabMultipleServices";
export const MEDIA_URLS_MODE_EXPLANATION_PRODUCTS =
  "mediaUrlsModeExplanationProducts";
export const MEDIA_URLS_MODE_EXPLANATION_SERVICES =
  "mediaUrlsModeExplanationServices";
export const CREATE_ADS_CAMPAIGN_LOADING_GETTING_REQUIRED_INFORMATION =
  "createAdsCampaignLoadingGettingRequiredInformation";
export const CREATE_ADS_CAMPAIGN_LOADING_ANALYZING_INFORMATION =
  "createAdsCampaignLoadingAnalyzingInformation";
export const CREATE_ADS_CAMPAIGN_LOADING_GENERATING_RECOMMENDATIONS =
  "createAdsCampaignLoadingGeneratingRecommendations";
export const CREATE_ADS_CAMPAIGN_LOADING_FINALIZING_DETAILS =
  "createAdsCampaignLoadingFinalizingDetails";
export const CREATE_ADS_CAMPAIGN_LOADING_CREATING_INSTANT_FORM =
  "createAdsCampaignLoadingCreatingInstantForm";
export const CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_PRODUCT_ADVERTISE =
  "createAdsCampaignContextQuestionProductAdvertise";
export const CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_COMMUNICATE =
  "createAdsCampaignContextQuestionCommunicate";
export const CREATE_ADS_CAMPAIGN_CONTEXT_QUESTION_SEGMENTATION =
  "createAdsCampaignContextQuestionSegmentation";
export const CREATE_ADS_LANGUAGE_QUESTION = "createAdsLanguageQuestion";
export const CREATE_ADS_PLATFORMS_QUESTION = "createAdsPlatformsQuestion";
export const CREATE_ADS_CAMPAIGN_QUICK_MODE = "createAdsCampaignQuickMode";
export const CREATE_ADS_CAMPAIGN_QUICK_MODE_DESCRIPTION =
  "createAdsCampaignQuickModeDescription";
export const CREATE_ADS_CAMPAIGN_ADVANCED_MODE =
  "createAdsCampaignAdvancedMode";
export const CREATE_ADS_CAMPAIGN_ADVANCED_MODE_DESCRIPTION =
  "createAdsCampaignAdvancedModeDescription";
export const CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_QUESTION =
  "createAdsCampaignGoogleConversionActionsQuestion";
export const CREATE_ADS_CAMPAIGN_GOOGLE_CONVERSION_ACTIONS_DESCRIPTION =
  "createAdsCampaignGoogleConversionActionsDescription";
export const CREATE_ADS_CAMPAIGN_VIDEO_URLS_QUESTION =
  "createAdsCampaignVideoUrlsQuestion";
export const CREATE_ADS_CAMPAIGN_VIDEO_URLS_DESCRIPTION =
  "createAdsCampaignVideoUrlsDescription";
export const CREATE_ADS_CAMPAIGN_IMAGE_URLS_QUESTION =
  "createAdsCampaignImageUrlsQuestion";
export const CREATE_ADS_CAMPAIGN_IMAGE_URLS_DESCRIPTION_QUESTION =
  "createAdsCampaignImageUrlsDescriptionQuestion";
export const CREATE_ADS_CAMPAIGN_PROJECTION_QUESTION =
  "createAdsCampaignProjectionQuestion";
export const CREATE_ADS_CAMPAIGN_MERCHANT_ID_QUESTION =
  "createAdsCampaignMerchantIdQuestion";

export const CREATE_ADS_CAMPAIGN_INTRO_TITLE = "createAdsCampaignIntroTitle";
export const CREATE_ADS_CAMPAIGN_INTRO_DESCRIPTION =
  "createAdsCampaignIntroDescription";
export const CREATE_ADS_CAMPAIGN_INTRO_FEATURE_CREATE_CAMPAIGN =
  "createAdsCampaignIntroFeatureCreateCampaign";
export const CREATE_ADS_CAMPAIGN_INTRO_FEATURE_OPTIMIZE_WITH_AI =
  "createAdsCampaignIntroFeatureOptimizeWithAI";
export const CREATE_ADS_CAMPAIGN_INTRO_FEATURE_MANAGE_SIMPLE =
  "createAdsCampaignIntroFeatureManageSimple";
export const CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ANALYZE_PERFORMANCE =
  "createAdsCampaignIntroFeatureAnalyzePerformance";
export const CREATE_ADS_CAMPAIGN_INTRO_FEATURE_ALL_IN_ONE_PLACE =
  "createAdsCampaignIntroFeatureAllInOnePlace";
export const CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_DESCRIPTION =
  "createAdsCampaignIntroCallToActionDescription";
export const CREATE_ADS_CAMPAIGN_INTRO_CALL_TO_ACTION_BUTTON =
  "createAdsCampaignIntroCallToActionButton";

// ADS CAMPAIGN REPORTS
export const ADS_CAMPAIGN_STATISTICS_CURRENT_STATE_TITLE =
  "adsCampaignStatisticsCurrentStateTitle";
export const ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW =
  "adsCampaignStatisticsSlideMenuOverview";
export const ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_STATISTICS =
  "adsCampaignStatisticsSlideMenuStatistics";
export const ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_METRICS =
  "adsCampaignsStatisticsSlideMenuMetrics";
export const ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_PERFORMING_ASSETS =
  "adsCampaignsStatisticsSlideMenuPerformingAssets";
export const ADS_CAMPAIGNS_STATISTICS_SLIDE_MENU_INSIGHTS =
  "adsCampaignsStatisticsSlideMenuInsights";
export const ADS_CAMPAIGNS_STATISTICS_PERFORMANCE_TRENDS =
  "adsCampaignsStatisticsPerformanceTrends";
export const ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPM =
  "adsCampaignStatisticsPlatformsCpm";
export const ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPC =
  "adsCampaignStatisticsPlatformsCpc";
export const ADS_CAMPAIGN_STATISTICS_PLATFORMS_CPA =
  "adsCampaignStatisticsPlatformsCpa";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_ASSETS_GROUP =
  "adsCampaignsStatisticsInsightsBestPerformingAssetsGroup";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_GROUP =
  "adsCampaignsStatisticsInsightsBestPerformingAdGroup";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD =
  "adsCampaignsStatisticsInsightsBestPerformingAd";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_TITLE =
  "adsCampaignsStatisticsInsightsBestPerformingAdTitle";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_BEST_PERFORMING_AD_DESCRIPTION =
  "adsCampaignsStatisticsInsightsBestPerformingAdDescription";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_KEYWORDS =
  "adsCampaignsStatisticsInsightsTopKeywords";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_VIDEOS =
  "adsCampaignsStatisticsInsightsTopVideos";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_IMAGES =
  "adsCampaignsStatisticsInsightsTopImages";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_HEADLINES =
  "adsCampaignsStatisticsInsightsTopHeadlines";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_LONG_HEADLINES =
  "adsCampaignsStatisticsInsightsTopLongHeadlines";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_TOP_DESCRIPTIONS =
  "adsCampaignsStatisticsInsightsTopDescriptions";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AUDIENCE_BREAKDOWN =
  "adsCampaignsStatisticsInsightsAudienceBreakdown";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_HIGHEST_PERFORMING =
  "adsCampaignsStatisticsInsightsHighestPerforming";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_AGE_RANGE_LABEL =
  "adsCampaignsStatisticsInsightsAgeRangeLabel";
export const ADS_CAMPAIGNS_STATISTICS_INSIGHTS_PLAY_VIDEO =
  "adsCampaignsStatisticsInsightsPlayVideo";

//CAMPAIGNS
export const CAMPAIGNS_TITLE = "campaignsTitle";
export const CAMPAIGNS_DESCRIPTION = "campaignsDescription";
export const CAMPAIGNS_SEARCHBAR_PLACEHOLDER = "campaignsSearchBarPlaceholder";
export const CAMPAIGNS_TABLE_COLUMN_NAME = "campaignsTableColumnName";
export const CAMPAIGNS_TABLE_COLUMN_PLATFORMS = "campaignsTableColumnPlatforms";
export const CAMPAIGNS_TABLE_COLUMN_STATUS = "campaignsTableColumnStatus";
export const CAMPAIGN_ACTIVATE = "campaignActivate";
export const CAMPAIGN_DEACTIVATE = "campaignDeactivate";
export const CAMPAIGN_ACTIVATE_TIME_CONFIRMATION =
  "campaignActivateTimeConfirmation";
export const CAMPAIGN_DEACTIVATE_TIME = "campaignDeactivateTime";
export const CAMPAIGN_FINISHED_TIME = "campaignDeactivateTime";
export const CAMPAIGN_DEACTIVATE_APPLICANTS_ACCEPTED =
  "campaignDeactivateApplicantsAccepted";
export const CAMPAIGN_FINISH_APPLICANTS_ACCEPTED =
  "campaignFinishApplicantsAccepted";
export const CAMPAIGN_ACTIVATE_FIELDS_REQUIRED =
  "campaignActivateFieldsRequired";
export const CAMPAIGN_ACTIVATE_MIN_BUDGET_CREATOR =
  "campaignActivateMinBudgetCreator";
export const CAMPAIGN_ACTIVATE_TRAFFIC_LINK = "campaignActivateTrafficLink";
export const CAMPAIGN_ACTIVATE_HAS_COLLABORATION_USER_NAME_INSTAGRAM =
  "campaignActivateHasCollaborationUserNameInstagram";
export const CAMPAIGN_ACTIVATE_ATTACHMENT_LINK =
  "campaignActivateAttachmentLink";
export const CAMPAIGN_FINISHED_CONFIRMATION = "campaignFinishedConfirmation";
export const CAMPAIGN_HAS_BEEN_FINISHED = "campaignHasBeenFinished";
export const CAMPAIGN_FINISH_ONBOARDING = "campaignFinishOnboarding";

//CAMPAIGN DETAIL
export const CAMPAIGN_DETAIL_TITLE = "campaignDetailTitle";
export const CAMPAIGN_DETAIL_APPLICANTS_ACCEPTED_TITLE =
  "campaignDetailApplicantsAcceptedTitle";
export const CAMPAIGN_DETAIL_APPLICANTS_PENDING_TITLE =
  "campaignDetailApplicantsPendingTitle";
export const CAMPAIGN_DETAIL_APPLICANTS_INVITED_TITLE =
  "campaignDetailApplicantsInvitedTitle";
export const CAMPAIGN_DETAIL_CREATORS_INVITED_TITLE =
  "campaignDetailCreatorsInvitedTitle";
export const CAMPAIGN_DETAIL_CAMPAIGN_INFORMATION_TITLE =
  "campaignDetailCampaignInformationTitle";
export const CAMPAIGN_DETAIL_APPLICANT_PAYMENT_DESCRIPTION =
  "campaignDetailApplicantPaymentDescription";
export const CAMPAIGN_DETAIL_APPLICANT_PAYMENT_ADDITIONAL_DESCRIPTION =
  "campaignDetailApplicantPaymentAdditionalDescription";
export const CAMPAIGN_DETAIL_REJECT_APPLICANT_CONFIRMATION =
  "campaignDetailRejectApplicantConfirmation";

export const CAMPAIGN_FIELDS_REQUIRED = "campaignFieldsRequired";
export const CAMPAIGN_NAME_PLACEHOLDER = "campaignNamePlaceholder";
export const CAMPAIGN_DESCRIPTION_PLACEHOLDER =
  "campaignDescriptionPlaceholder";
export const CAMPAIGN_GOAL_PLACEHOLDER = "campaignGoalPlaceholder";
export const CAMPAIGN_BUDGET_PLACEHOLDER = "campaignBudgetPlaceholder";
export const CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER =
  "campaignWithContentInSocialNetworkPlaceholder";
export const CAMPAIGN_PLATFORMS_PLACEHOLDER = "campaignPlatformsPlaceholder";
export const CAMPAIGN_TYPE_CONTENT_MEDIA_PLACEHOLDER =
  "campaignTypeContentMediaPlaceholder";
export const CAMPAIGN_TYPE_CONTENT_PLACEHOLDER =
  "campaignTypeContentPlaceholder";
export const CAMPAIGN_COPY_POST_PLACEHOLDER = "campaignCopyPostPlaceholder";
export const CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER =
  "campaignTrafficLinkPlaceholder";
export const CAMPAIGN_HAS_COLLABORATION_PLACEHOLDER =
  "campaignHasCollaborationPlaceholder";
export const CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER =
  "campaignProductAttributesPlaceholder";
export const CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER =
  "campaignMessageContentPlaceholder";
export const CAMPAIGN_DATES_START_DATE_PLACEHOLDER =
  "campaignDatesStartDatePlaceholder";
export const CAMPAIGN_DATES_END_DATE_PLACEHOLDER =
  "campaignDatesEndDatePlaceholder";
export const CAMPAIGN_REPOST_PLACEHOLDER = "campaignRepostPlaceholder";
export const CAMPAIGN_REPOST_PLACEHOLDER_ITEM = "campaignRepostPlaceholderItem";
export const CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER =
  "campaignAudienceLocationPlaceholder";
export const CAMPAIGN_AGE_RANGE_PLACEHOLDER = "campaignAgeRangePlaceholder";
export const CAMPAIGN_BRIEF_PLACEHOLDER = "campaignBriefPlaceholder";
export const CAMPAIGN_BRIEF_DESCRIPTION = "campaignBriefDescription";
export const CAMPAIGN_ATTACHMENT_FILE_PLACEHOLDER =
  "campaignAttachmentFilePlaceholder";
export const CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION =
  "campaignAttachmentFileDescription";
export const CAMPAIGN_ATTACHMENT_LINK_TITLE = "campaignAttachmentLinkTitle";
export const CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION =
  "campaignAttachmentLinkDescription";
export const CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER =
  "campaignAttachmentLinkPlaceholder";
export const CAMPAIGN_GENDERS_PLACEHOLDER = "campaignGendersPlaceholder";
export const CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER =
  "campaignReferenceProfilesPlaceholder";
export const CAMPAIGN_HASHTAG_PLACEHOLDER = "campaignHashtagPlaceholder";
export const CAMPAIGN_MESSAGE_TONE_PLACEHOLDER =
  "campaignMessageTonePlaceholder";
export const CAMPAIGN_ENVIRONMENT_PLACEHOLDER =
  "campaignEnvironmentPlaceholder";
export const CAMPAIGN_COLORS_CONTENT_PLACEHOLDER =
  "campaignColorsContentPlaceholder";
export const CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER =
  "campaignProhibitedColorsContentPlaceholder";
export const CAMPAIGN_KEY_WORDS_PLACEHOLDER = "campaignKeyWordsPlaceholder";
export const CAMPAIGN_PROHIBITED_KEY_WORDS_PLACEHOLDER =
  "campaignProhibitedKeyWordsPlaceholder";
export const CAMPAIGN_OUTFIT_PLACEHOLDER = "campaignOutfitPlaceholder";

//CREATE CAMPAIGNS
export const CREATE_CAMPAIGN_QUESTION = "createCampaignQuestion";
export const CREATE_CAMPAIGN_ACCEPT_TERMS_DISCLAIMER =
  "createCampaignAcceptTermsDisclaimer";
export const CREATE_CAMPAIGN_NAME_EXAMPLE = "createCampaignNameExample";
export const CREATE_CAMPAIGN_NAME_REQUIRED = "createCampaignNameRequired";
export const CREATE_CAMPAIGN_DESCRIPTION_REQUIRED =
  "createCampaignDescriptionRequired";
export const CREATE_CAMPAIGN_BUDGET_REQUIRED = "createCampaignBudgetRequired";
export const CREATE_CAMPAIGN_BUDGET_MIN_VALUE = "createCampaignBudgetMinValue";
export const CREATE_CAMPAIGN_PLATFORMS_REQUIRED =
  "createCampaignPlatformsRequired";
export const CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA =
  "createCampaignTypeContentMedia";
export const CREATE_CAMPAIGN_TYPE_CONTENT = "createCampaignTypeContent";
export const CREATE_CAMPAIGN_TRAFFIC_LINK_REQUIRED =
  "createCampaignTrafficLinkRequired";
export const CREATE_CAMPAIGN_TRAFFIC_LINK_VALID =
  "createCampaignTrafficLinkValid";
export const CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_REQUIRED =
  "createCampaignProductAttributesRequired";
export const CREATE_CAMPAIGN_MESSAGE_CONTENT_REQUIRED =
  "createCampaignMessageContentRequired";
export const CREATE_CAMPAIGN_DATES_REQUIRED = "createCampaignDatesRequired";
export const CREATE_CAMPAIGN_REPOST_HAS_COLLABORATION =
  "createCampaignRepostHasCollaboration";
export const CREATE_CAMPAIGN_AUDIENCE_LOCATION_REQUIRED =
  "createCampaignAudienceLocationRequired";
export const CREATE_CAMPAIGN_ATTACHMENT_LINK = "createCampaignAttachmentLink";
export const CREATE_CAMPAIGN_HAS_BEEN_ACTIVATE =
  "createCampaignHasBeenActivate";
export const CREATE_CAMPAIGN_HAS_BEEN_SAVE = "createCampaignHasBeenSave";
export const CREATE_CAMPAIGN_SAVE_PROGRESS_NAME_REQUIRED =
  "createCampaignSaveProgressNameRequired";
export const CREATE_CAMPAIGN_SAVE_PROGRESS = "createCampaignSaveProgress";
export const CREATE_CAMPAIGN_NAME_QUESTION = "createCampaignNameQuestion";
export const CREATE_CAMPAIGN_NAME_PLACEHOLDER = "createCampaignNamePlaceholder";
export const CREATE_CAMPAIGN_DESCRIPTION_QUESTION =
  "createCampaignDescriptionQuestion";
export const CREATE_CAMPAIGN_DESCRIPTION_PLACEHOLDER =
  "createCampaignDescriptionPlaceholder";
export const CREATE_CAMPAIGN_GOAL_QUESTION = "createCampaignGoalQuestion";
export const CREATE_CAMPAIGN_GOAL_PLACEHOLDER = "createCampaignGoalPlaceholder";
export const CREATE_CAMPAIGN_GOAL_ENGAGEMENT_OPTION =
  "createCampaignGoalEngagementOption";
export const CREATE_CAMPAIGN_GOAL_BRAND_AWARENESS_OPTION =
  "createCampaignGoalBrandAwarenessOption";
export const CREATE_CAMPAIGN_GOAL_LEADS_OPTION =
  "createCampaignGoalLeadsOption";
export const CREATE_CAMPAIGN_GOAL_SALES_OPTION =
  "createCampaignGoalSalesOption";
export const CREATE_CAMPAIGN_GOAL_REQUIRED = "createCampaignGoalRequired";
export const CREATE_CAMPAIGN_BUDGET_QUESTION = "createCampaignBudgetQuestion";
export const CREATE_CAMPAIGN_BUDGET_DESCRIPTION =
  "createCampaignBudgetDescription";
export const CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_QUESTION =
  "createCampaignWithContentInSocialNetworkQuestion";
export const CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_DESCRIPTION =
  "createCampaignWithContentInSocialNetworkDescription";
export const CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_PLACEHOLDER =
  "createCampaignWithContentInSocialNetworkPlaceholder";
export const CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_UGC_OPTION =
  "createCampaignWithContentInSocialNetworkUgcOption";
export const CREATE_CAMPAIGN_WITH_CONTENT_IN_SOCIAL_NETWORK_REQUIRED =
  "createCampaignWithContentInSocialNetworkRequired";
export const CREATE_CAMPAIGN_PLATFORMS = "createCampaignPlatforms";
export const CREATE_CAMPAIGN_TYPE_CONTENT_MEDIA_QUESTION =
  "createCampaignTypeContentMediaQuestion";
export const CREATE_CAMPAIGN_TYPE_CONTENT_QUESTION =
  "createCampaignTypeContentQuestion";
export const CREATE_CAMPAIGN_COPYWRITING_QUESTION =
  "createCampaignCopywritingQuestion";
export const CREATE_CAMPAIGN_COPYWRITING_PLACEHOLDER =
  "createCampaignCopywritingPlaceholder";
export const CREATE_CAMPAIGN_TRAFFIC_LINK_QUESTION =
  "createCampaignTrafficLinkQuestion";
export const CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER =
  "createCampaignTrafficLinkPlaceholder";
export const CREATE_CAMPAIGN_HAS_COLLABORATION_QUESTION =
  "createCampaignHasCollaborationQuestion";
export const CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_QUESTION =
  "createCampaignProductAttributesQuestion";
export const CREATE_CAMPAIGN_PRODUCT_ATTRIBUTES_PLACEHOLDER =
  "createCampaignProductAttributesPlaceholder";
export const CREATE_CAMPAIGN_MESSAGE_CONTENT_QUESTION =
  "createCampaignMessageContentQuestion";
export const CREATE_CAMPAIGN_MESSAGE_CONTENT_PLACEHOLDER =
  "createCampaignMessageContentPlaceholder";
export const CREATE_CAMPAIGN_DATES_QUESTION = "createCampaignDatesQuestion";
export const CREATE_CAMPAIGN_DATES_DESCRIPTION =
  "createCampaignDatesDescription";
export const CREATE_CAMPAIGN_DATES_START_DATE_PLACEHOLDER =
  "createCampaignDatesStartDatePlaceholder";
export const CREATE_CAMPAIGN_DATES_END_DATE_PLACEHOLDER =
  "createCampaignDatesEndDatePlaceholder";
export const CREATE_CAMPAIGN_REPOST_QUESTION = "createCampaignRepostQuestion";
export const CREATE_CAMPAIGN_AUDIENCE_LOCATION_QUESTION =
  "createCampaignAudienceLocationQuestion";
export const CREATE_CAMPAIGN_AUDIENCE_LOCATION_PLACEHOLDER =
  "createCampaignAudienceLocationPlaceholder";
export const CREATE_CAMPAIGN_AUDIENCE_LOCATION_ALL_OPTION =
  "createCampaignAudienceLocationAllOption";
export const CREATE_CAMPAIGN_AGE_RANGE_QUESTION =
  "createCampaignAgeRangeQuestion";
export const CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_QUESTION =
  "createCampaignUGCContentFormatQuestion";
export const CREATE_CAMPAIGN_UGC_CONTENT_FORMAT_PLACEHOLDER =
  "createCampaignUGCContentFormatPlaceholder";
export const CREATE_CAMPAIGN_BRIEF_QUESTION = "createCampaignBriefQuestion";
export const CREATE_CAMPAIGN_BRIEF_DESCRIPTION =
  "createCampaignBriefDescription";
export const CREATE_CAMPAIGN_UPLOAD_BRIEF = "createCampaignUploadBrief";
export const CREATE_CAMPAIGN_REMOVED_BRIEF = "createCampaignRemovedBrief";
export const CREATE_CAMPAIGN_ATTACHMENT_FILE_QUESTION =
  "createCampaignAttachmentFileQuestion";
export const CREATE_CAMPAIGN_ATTACHMENT_FILE_DESCRIPTION =
  "createCampaignAttachmentFileDescription";
export const CREATE_CAMPAIGN_ATTACHMENT_LINK_QUESTION =
  "createCampaignAttachmentLinkQuestion";
export const CREATE_CAMPAIGN_ATTACHMENT_LINK_DESCRIPTION =
  "createCampaignAttachmentLinkDescription";
export const CREATE_CAMPAIGN_ATTACHMENT_LINK_PLACEHOLDER =
  "createCampaignAttachmentLinkPlaceholder";
export const CREATE_CAMPAIGN_QUANTITY_GENDER_QUESTION =
  "createCampaignQuantityGenderQuestion";
export const CREATE_CAMPAIGN_REFERENCE_PROFILES_QUESTION =
  "createCampaignReferenceProfilesQuestion";
export const CREATE_CAMPAIGN_REFERENCE_PROFILES_PLACEHOLDER =
  "createCampaignReferenceProfilesPlaceholder";
export const CREATE_CAMPAIGN_HASHTAG_QUESTION = "createCampaignHashtagQuestion";
export const CREATE_CAMPAIGN_HASHTAG_PLACEHOLDER =
  "createCampaignHashtagPlaceholder";
export const CREATE_CAMPAIGN_MESSAGE_TONE_QUESTION =
  "createCampaignMessageToneQuestion";
export const CREATE_CAMPAIGN_MESSAGE_TONE_PLACEHOLDER =
  "createCampaignMessageTonePlaceholder";
export const CREATE_CAMPAIGN_ENVIRONMENT_QUESTION =
  "createCampaignEnvironmentQuestion";
export const CREATE_CAMPAIGN_ENVIRONMENT_PLACEHOLDER =
  "createCampaignEnvironmentPlaceholder";
export const CREATE_CAMPAIGN_COLORS_CONTENT_QUESTION =
  "createCampaignColorsContentQuestion";
export const CREATE_CAMPAIGN_COLORS_CONTENT_PLACEHOLDER =
  "createCampaignColorsContentPlaceholder";
export const CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_QUESTION =
  "createCampaignProhibitedColorsContentQuestion";
export const CREATE_CAMPAIGN_PROHIBITED_COLORS_CONTENT_PLACEHOLDER =
  "createCampaignProhibitedColorsContentPlaceholder";
export const CREATE_CAMPAIGN_KEY_WORDS_QUESTION =
  "createCampaignKeyWordsQuestion";
export const CREATE_CAMPAIGN_KEY_WORDS_PLACEHOLDER =
  "createCampaignKeyWordsPlaceholder";
export const CREATE_CAMPAIGN_PROHIBITED_WORDS_QUESTION =
  "createCampaignProhibitedWordsQuestion";
export const CREATE_CAMPAIGN_PROHIBITED_WORDS_PLACEHOLDER =
  "createCampaignProhibitedWordsPlaceholder";
export const CREATE_CAMPAIGN_OUTFIT_QUESTION = "createCampaignOutfitQuestion";
export const CREATE_CAMPAIGN_OUTFIT_PLACEHOLDER =
  "createCampaignOutfitPlaceholder";
export const CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE =
  "createCampaignModalGenerateScriptAndDescriptionTitle";
export const CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_TITLE_GENERATING =
  "createCampaignModalGenerateScriptAndDescriptionTitleGenerating";
export const CREATE_CAMPAIGN_MODAL_GENERATE_SCRIPT_AND_DESCRIPTION_SCRIPT_LABEL =
  "createCampaignModalGenerateScriptAndDescriptionScriptLabel";

//APPLICANTS
export const APPLICANTS_STATUS_PENDING = "applicantsStatusPending";
export const APPLICANTS_STATUS_ACCEPTED = "applicantsStatusAccepted";
export const APPLICANTS_STATUS_REJECTED = "applicantsStatusRejected";
export const APPLICANTS_STATUS_CONTENT_SUBMITTED =
  "applicantsStatusContentSubmitted";
export const APPLICANTS_STATUS_CONTENT_REVISIONS =
  "applicantsStatusContentRevisions";
export const APPLICANTS_STATUS_CONTENT_PENDING_SOCIAL =
  "applicantsStatusContentPendingSocial";
export const APPLICANTS_STATUS_CONTENT_PENDING_ANALYTICS =
  "applicantsStatusContentPendingAnalytics";
export const APPLICANTS_STATUS_DELIVERED = "applicantsStatusDelivered";
export const APPLICANT_CONTENT_OF_CREATOR = "applicantContentOfCreator";
export const APPLICANT_REVISION_PLACEHOLDER = "applicantRevisionPlaceholder";

//REPORTS SHOP
export const START_DATE_AND_END_DATE_VALIDATION =
  "startDateAndEndDateValidation";
export const LIKES = "likes";
export const SHARES = "shares";
export const PREVIOUS_PERIOD = "previousPeriod";
export const LOADING_CONFIGURATION_METRICS = "loadingConfigurationMetrics";

// CUSTOMER ACQUISITION CONFIGURATION
export const CUSTOMER_ACQUISITION_TITLE = "customerAcquisitionTitle";
export const CUSTOMER_ACQUISITION_SWITCH_LABEL =
  "customerAcquisitionSwitchLabel";
export const CUSTOMER_ACQUISITION_ACCOUNT_LEVEL =
  "customerAcquisitionAccountLevel";
export const CUSTOMER_ACQUISITION_CAMPAIGN_LEVEL =
  "customerAcquisitionCampaignLevel";
export const CUSTOMER_ACQUISITION_NEW_CUSTOMER_VALUE =
  "customerAcquisitionNewCustomerValue";
export const CUSTOMER_ACQUISITION_NEW_CUSTOMER_HIGH_VALUE =
  "customerAcquisitionNewCustomerHighValue";

//GALLERY
export const GALLERY_TITLE = "galleryTitle";
export const MODAL_GALLERY_ARIA_LABEL = "modalGalleryAriaLabel";
export const MODAL_GALLERY_EMPTY_CONTENT = "modalGalleryEmptyContent";
export const SELECT_ACCOUNT_TO_LOAD_GALLERY_CONTENT =
  "selectAccountToLoadGalleryContent";
export const SELECT_YOUTUBE_ACCOUNT_TO_LOAD_GALLERY_CONTENT =
  "selectYoutubeAccountToLoadGalleryContent";
export const MODAL_GALLERY_NO_MORE_CONTENT = "modalGalleryNoMoreContent";
export const MODAL_FILTERS_LABEL = "modalFiltersLabel";

// ADGROUP PLACEMENTS
export const META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE =
  "metaAdgroupPlacementsTypeAdvantage";
export const META_ADGROUP_PLACEMENTS_TYPE_ADVANTAGE_DESCRIPTION =
  "metaAdgroupPlacementsTypeAdvantageDescription";
export const META_ADGROUP_PLACEMENTS_TYPE_MANUAL =
  "metaAdgroupPlacementsTypeManual";
export const META_ADGROUP_PLACEMENTS_TYPE_MANUAL_DESCRIPTION =
  "metaAdgroupPlacementsTypeManualDescription";

// TIKTOK ADGROUP PLACEMENTS
export const TIKTOK_ADGROUP_PLACEMENTS_TITLE = "tiktokAdgroupPlacementsTitle";
export const TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_LABEL =
  "tiktokAdgroupPlacementsTiktokLabel";
export const TIKTOK_ADGROUP_PLACEMENTS_TIKTOK_DESCRIPTION =
  "tiktokAdgroupPlacementsTiktokDescription";
export const TIKTOK_ADGROUP_PLACEMENTS_PANGLE_LABEL =
  "tiktokAdgroupPlacementsPangleLabel";
export const TIKTOK_ADGROUP_PLACEMENTS_PANGLE_DESCRIPTION =
  "tiktokAdgroupPlacementsPangleDescription";

//MODAL MEDIA
export const MODAL_MEDIA_ARIA_LABEL = "modalMediaAriaLabel";

//MODAL UPLOAD TIKTOK
export const MODAL_UPLOAD_TIKTOK_ARIA_LABEL = "modalUploadTiktokAriaLabel";
export const MODAL_UPLOAD_TIKTOK_TITLE = "modalUploadTiktokTitle";
export const MODAL_UPLOAD_FAILED_GET_CONFIGURATION =
  "modalUploadFailedGetConfiguration";
export const MODAL_UPLOAD_CONTENT_UPLOADED = "modalUploadTiktokVideoUploaded";
export const MODAL_UPLOAD_TIKTOK_VIDEO_UPLOADED_DESCRIPTION =
  "modalUploadTiktokVideoUploadedDescription";
export const MODAL_UPLOAD_FAILED_GENERATE_DESCRIPTION =
  "modalUploadTiktokFailedGenerateDescription";
export const MODAL_UPLOAD_TIKTOK_DESCRIPTION_LABEL =
  "modalUploadTiktokDescriptionLabel";
export const MODAL_UPLOAD_TIKTOK_DESCRIPTION_PLACEHOLDER =
  "modalUploadTiktokDescriptionPlaceholder";
export const MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_LABEL =
  "modalUploadTiktokWhoCanWatchLabel";
export const MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_PUBLIC_OPTION =
  "modalUploadTiktokWhoCanWatchPublicOption";
export const MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_FOLLOWERS_OPTION =
  "modalUploadTiktokWhoCanWatchFollowersOption";
export const MODAL_UPLOAD_TIKTOK_WHO_CAN_WATCH_ONLY_I_OPTION =
  "modalUploadTiktokWhoCanWatchOnlyIOption";
export const MODAL_UPLOAD_TIKTOK_ALLOW_USERS_PLACEHOLDER =
  "modalUploadTiktokAllowUsersPlaceholder";
export const MODAL_UPLOAD_TIKTOK_ALLOW_USERS_COMMENT_OPTION =
  "modalUploadTiktokAllowUsersCommentOption";
export const MODAL_UPLOAD_TIKTOK_ALLOW_USERS_DUOS_OPTION =
  "modalUploadTiktokAllowUsersDuosOption";
export const MODAL_UPLOAD_TIKTOK_ALLOW_USERS_CUT_OPTION =
  "modalUploadTiktokAllowUsersCutOption";

//MODAL MAP RADIUS
export const MARKER_LIST = "markerList";
export const MARKER_NUMBER_LIST = "markerNumberList";
export const MARKER_TYPE = "markerType";
export const MARKER_LNG = "markerLng";
export const MARKER_LAT = "markerLat";
export const MARKER_RADIUS = "markerRadius";

//MODAL PREVIEW OPTIMIZATION
export const MODAL_PREVIEW_OPTIMIZATIONS_TITLE =
  "modalPreviewOptimizationsTitle";
export const MODAL_PREVIEW_OPTIMIZATIONS_DESCRIPTION =
  "modalPreviewOptimizationsDescription";
export const WHY_THIS_OPTIMIZATION = "whyThisOptimization";

//MODAL STEP DATA
export const MODAL_STEP_DATA_TITLE = "modalStepDataTitle";

//MODAL MESSAGE TEMPLATE
export const MODAL_MESSAGE_TEMPLATE_TITLE = "modalMessageTemplateTitle";
export const MESSAGE_TEMPLATE_UNSUPPORTED_TITLE =
  "messageTemplateUnsupportedTitle";
export const MESSAGE_TEMPLATE_UNSUPPORTED_DESCRIPTION =
  "messageTemplateUnsupportedDescription";
export const MODAL_MESSAGE_TEMPLATE_DESCRIPTION =
  "modalMessageTemplateDescription";

//MODAL PRODUCT TAGS META
export const MODAL_PRODUCT_TAGS_TITLE_META = "modalProductTagsTitleMeta";
export const MODAL_PRODUCT_TAGS_DESCRIPTION_META =
  "modalProductTagsDescriptionMeta";

//MODAL CATALOG LABELS
export const MODAL_CATALOG_LABELS_TITLE = "modalCatalogLabelsTitle";
export const MODAL_CATALOG_LABELS_DESCRIPTION = "modalCatalogLabelsDescription";

//MODAL SITE LINKS
export const MODAL_SITE_LINKS_TITLE = "modalSiteLinksTitle";
export const MODAL_SITE_LINKS_DESCRIPTION = "modalSiteLinksDescription";
export const MODAL_SITE_LINK_TITLE = "modalSiteLinkTitle";
export const MODAL_SITE_LINK_IMAGE_URL = "modalSiteLinkImageUrl";
export const MODAL_SITE_LINK_URL = "modalSiteLinkUrl";

//MODAL INSTANT FORMS LIST
export const MODAL_INSTANT_FORMS_LIST_TITLE = "modalInstantFormsListTitle";
export const MODAL_INSTANT_FORMS_LIST_DESCRIPTION =
  "modalInstantFormsListDescription";
export const MODAL_INSTANT_FORMS_EMPTY_TEXT = "modalInstantFormsEmptyText";

//MODAL CREATE INSTANT FORM
export const MODAL_CREATE_INSTANT_FORM_TITLE = "modalCreateInstantFormTitle";
export const MODAL_CREATE_INSTANT_FORM_DESCRIPTION =
  "modalCreateInstantFormDescription";
export const MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME =
  "modalCreateInstantFormTypeMoreVolume";
export const MODAL_CREATE_INSTANT_FORM_TYPE_MORE_VOLUME_DESCRIPTION =
  "modalCreateInstantFormTypeMoreVolumeDescription";
export const MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT =
  "modalCreateInstantFormTypeHigherIntent";
export const MODAL_CREATE_INSTANT_FORM_TYPE_HIGHER_INTENT_DESCRIPTION =
  "modalCreateInstantFormTypeHigherIntentDescription";
export const MODAL_CREATE_INSTANT_FORM_QUESTIONS_HEADLINE =
  "modalCreateInstantFormQuestionsHeadline";
export const MODAL_CREATE_INSTANT_FORM_CONTACT_FIELDS =
  "modalCreateInstantFormContactFields";
export const MODAL_CREATE_INSTANT_FORM_CONTACT_FULL_NAME =
  "modalCreateInstantFormContactFullName";
export const MODAL_CREATE_INSTANT_FORM_CONTACT_WORK_EMAIL =
  "modalCreateInstantFormContactWorkEmail";
export const MODAL_CREATE_INSTANT_FORM_MAX_QUESTIONS =
  "modalCreateInstantFormMaxQuestions";
export const MODAL_CREATE_INSTANT_FORM_PRIVACY_LINK_TEXT =
  "modalCreateInstantFormPrivacyLinkText";
export const MODAL_CREATE_INSTANT_FORM_ADDITIONAL_ACTION =
  "modalCreateInstantFormAdditionalAction";
export const MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE =
  "modalCreateInstantFormActionViewWebsite";
export const MODAL_CREATE_INSTANT_FORM_ACTION_VIEW_WEBSITE_DESCRIPTION =
  "modalCreateInstantFormActionViewWebsiteDescription";
export const MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME =
  "modalCreateInstantFormActionBookTime";
export const MODAL_CREATE_INSTANT_FORM_ACTION_BOOK_TIME_DESCRIPTION =
  "modalCreateInstantFormActionBookTimeDescription";
export const MODAL_CREATE_INSTANT_FORM_WEBSITE_URL =
  "modalCreateInstantFormWebsiteUrl";
export const MODAL_CREATE_INSTANT_FORM_SCHEDULING_LINK =
  "modalCreateInstantFormSchedulingLink";
export const MODAL_CREATE_INSTANT_FORM_SCHEDULING_PROVIDER =
  "modalCreateInstantFormSchedulingProvider";
export const MODAL_CREATE_INSTANT_FORM_BOOK_TIME_HINT =
  "modalCreateInstantFormBookTimeHint";
export const MODAL_CREATE_INSTANT_FORM_BUTTON_TEXT =
  "modalCreateInstantFormButtonText";

// Recommended lead form generation while the editor is open.
export const LEAD_FORM_RECOMMENDATION_GENERATING =
  "leadFormRecommendationGenerating";
export const LEAD_FORM_RECOMMENDATION_CANCEL = "leadFormRecommendationCancel";
export const LEAD_FORM_RECOMMENDATION_FAILED = "leadFormRecommendationFailed";
export const LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING =
  "leadFormRecommendationCampaignGenerating";

//MODAL LEAD FORMS LIST
export const MODAL_LEAD_FORMS_LIST_TITLE = "modalLeadFormsListTitle";
export const MODAL_LEAD_FORMS_LIST_DESCRIPTION =
  "modalLeadFormsListDescription";
export const MODAL_LEAD_FORMS_EMPTY_TEXT = "modalLeadFormsEmptyText";
export const MODAL_LEAD_FORMS_DUPLICATE_AND_EDIT =
  "modalLeadFormsDuplicateAndEdit";
export const MODAL_LEAD_FORMS_VIEW = "modalLeadFormsView";
export const MODAL_LEAD_FORMS_COPY_NAME_PREFIX = "modalLeadFormsCopyNamePrefix";

//MODAL CREATE LEAD FORM
export const MODAL_CREATE_LEAD_FORM_TITLE = "modalCreateLeadFormTitle";
export const MODAL_VIEW_LEAD_FORM_TITLE = "modalViewLeadFormTitle";
export const INSTANT_FORM_PREVIEW_MORE = "instantFormPreviewMore";
export const MODAL_CREATE_LEAD_FORM_DESCRIPTION =
  "modalCreateLeadFormDescription";
export const MODAL_VIEW_LEAD_FORM_DESCRIPTION = "modalViewLeadFormDescription";
export const MODAL_VIEW_LEAD_FORM_LOAD_ERROR = "modalViewLeadFormLoadError";
export const MODAL_CREATE_LEAD_FORM_LOCALE_WARNING =
  "modalCreateLeadFormLocaleWarning";
export const MODAL_CREATE_LEAD_FORM_NAME = "modalCreateLeadFormName";
export const MODAL_CREATE_LEAD_FORM_HEADLINE = "modalCreateLeadFormHeadline";
export const MODAL_CREATE_LEAD_FORM_DETAILS = "modalCreateLeadFormDetails";
export const MODAL_CREATE_LEAD_FORM_SECTION_FORM =
  "modalCreateLeadFormSectionForm";
export const MODAL_CREATE_LEAD_FORM_SECTION_CONTACT =
  "modalCreateLeadFormSectionContact";
export const MODAL_CREATE_LEAD_FORM_SECTION_PRIVACY =
  "modalCreateLeadFormSectionPrivacy";
export const MODAL_CREATE_LEAD_FORM_SECTION_CONFIRMATION =
  "modalCreateLeadFormSectionConfirmation";
export const MODAL_CREATE_LEAD_FORM_PROFILE_FIELDS =
  "modalCreateLeadFormProfileFields";
export const MODAL_CREATE_LEAD_FORM_PROFILE_FIRST_NAME =
  "modalCreateLeadFormProfileFirstName";
export const MODAL_CREATE_LEAD_FORM_PROFILE_LAST_NAME =
  "modalCreateLeadFormProfileLastName";
export const MODAL_CREATE_LEAD_FORM_PROFILE_EMAIL =
  "modalCreateLeadFormProfileEmail";
export const MODAL_CREATE_LEAD_FORM_PROFILE_PHONE =
  "modalCreateLeadFormProfilePhone";
export const MODAL_CREATE_LEAD_FORM_PROFILE_CITY =
  "modalCreateLeadFormProfileCity";
export const MODAL_CREATE_LEAD_FORM_PROFILE_STATE =
  "modalCreateLeadFormProfileState";
export const MODAL_CREATE_LEAD_FORM_PROFILE_COUNTRY =
  "modalCreateLeadFormProfileCountry";
export const MODAL_CREATE_LEAD_FORM_PROFILE_ZIP =
  "modalCreateLeadFormProfileZip";
export const MODAL_CREATE_LEAD_FORM_PROFILE_JOB_TITLE =
  "modalCreateLeadFormProfileJobTitle";
export const MODAL_CREATE_LEAD_FORM_PROFILE_COMPANY =
  "modalCreateLeadFormProfileCompany";
export const MODAL_CREATE_LEAD_FORM_PROFILE_LINKEDIN =
  "modalCreateLeadFormProfileLinkedin";
export const MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTIONS =
  "modalCreateLeadFormCustomQuestions";
export const MODAL_CREATE_LEAD_FORM_ADD_CUSTOM_QUESTION =
  "modalCreateLeadFormAddCustomQuestion";
export const MODAL_CREATE_LEAD_FORM_CUSTOM_QUESTION_HINT =
  "modalCreateLeadFormCustomQuestionHint";
export const MODAL_CREATE_LEAD_FORM_QUESTION_TITLE =
  "modalCreateLeadFormQuestionTitle";
export const MODAL_CREATE_LEAD_FORM_QUESTION_TYPE =
  "modalCreateLeadFormQuestionType";
export const MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_TEXT =
  "modalCreateLeadFormQuestionTypeText";
export const MODAL_CREATE_LEAD_FORM_QUESTION_TYPE_MULTIPLE_CHOICE =
  "modalCreateLeadFormQuestionTypeMultipleChoice";
export const MODAL_CREATE_LEAD_FORM_ADD_OPTION = "modalCreateLeadFormAddOption";
export const MODAL_CREATE_LEAD_FORM_OPTION = "modalCreateLeadFormOption";
export const MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_URL =
  "modalCreateLeadFormPrivacyPolicyUrl";
export const MODAL_CREATE_LEAD_FORM_PRIVACY_POLICY_TEXT =
  "modalCreateLeadFormPrivacyPolicyText";
export const MODAL_CREATE_LEAD_FORM_THANK_YOU_MESSAGE =
  "modalCreateLeadFormThankYouMessage";
export const MODAL_CREATE_LEAD_FORM_LANDING_PAGE_URL =
  "modalCreateLeadFormLandingPageUrl";
export const MODAL_CREATE_LEAD_FORM_CTA = "modalCreateLeadFormCta";
export const MODAL_CREATE_LEAD_FORM_CTA_VISIT_COMPANY_WEBSITE =
  "modalCreateLeadFormCtaVisitCompanyWebsite";
export const MODAL_CREATE_LEAD_FORM_CTA_LEARN_MORE =
  "modalCreateLeadFormCtaLearnMore";
export const MODAL_CREATE_LEAD_FORM_CTA_VIEW_NOW =
  "modalCreateLeadFormCtaViewNow";
export const MODAL_CREATE_LEAD_FORM_CTA_DOWNLOAD_NOW =
  "modalCreateLeadFormCtaDownloadNow";
export const MODAL_CREATE_LEAD_FORM_CTA_TRY_NOW =
  "modalCreateLeadFormCtaTryNow";
export const MODAL_CREATE_LEAD_FORM_MIN_OPTIONS =
  "modalCreateLeadFormMinOptions";
export const MODAL_CREATE_LEAD_FORM_MAX_CUSTOM_QUESTIONS =
  "modalCreateLeadFormMaxCustomQuestions";

//MODAL INSTANT EXPERIENCE LIST
export const MODAL_INSTANT_EXPERIENCE_LIST_TITLE =
  "modalInstantExperienceListTitle";
export const MODAL_INSTANT_EXPERIENCE_LIST_DESCRIPTION =
  "modalInstantExperienceListDescription";
export const MODAL_INSTANT_EXPERIENCE_EMPTY_TEXT =
  "modalInstantExperienceEmptyText";

//MODAL EDIT PRODUCTS CONFIGURATION
export const MODAL_EDIT_PRODUCTS_CONFIGURATION_TITLE =
  "modalEditProductsConfigurationTitle";
export const MODAL_EDIT_PRODUCTS_CONFIGURATION_DESCRIPTION =
  "modalEditProductsConfigurationDescription";
export const PRODUCTS_CONFIGURATION_SYNC_DELAY_CAPTION =
  "productsConfigurationSyncDelayCaption";
export const CATEGORY_ANIMALS_PET_SUPPLIES = "categoryAnimalsPetSupplies";
export const CATEGORY_ARTS_ENTERTAINMENT = "categoryArtsEntertainment";
export const CATEGORY_BUSINESS_INDUSTRIAL = "categoryBusinessIndustrial";
export const CATEGORY_CAMERAS_OPTICS = "categoryCamerasOptics";
export const CATEGORY_CLOTHING_ACCESSORIES = "categoryClothingAccessories";
export const CATEGORY_ELECTRONICS = "categoryElectronics";
export const CATEGORY_FOOD_BEVERAGES = "categoryFoodBeverages";
export const CATEGORY_FURNITURE = "categoryFurniture";
export const CATEGORY_HEALTH_BEAUTY = "categoryHealthBeauty";
export const CATEGORY_HOME_GARDEN = "categoryHomeGarden";
export const CATEGORY_BABY_TODDLER = "categoryBabyToddler";
export const CATEGORY_HARDWARE = "categoryHardware";
export const CATEGORY_MATURE = "categoryMature";
export const CATEGORY_MEDIA = "categoryMedia";
export const CATEGORY_VEHICLES_PARTS = "categoryVehiclesParts";
export const CATEGORY_OFFICE_SUPPLIES = "categoryOfficeSupplies";
export const CATEGORY_SPORTING_GOODS = "categorySportingGoods";
export const CATEGORY_TOYS_GAMES = "categoryToysGames";
export const CATEGORY_SOFTWARE = "categorySoftware";
export const CATEGORY_LUGGAGE_BAGS = "categoryLuggageBags";
export const CATEGORY_RELIGIOUS_CEREMONIAL = "categoryReligiousCeremonial";

//MODAL EDIT PLACEMENTS META
export const MODAL_EDIT_PLACEMENTS_META_TITLE = "modalEditPlacementsMetaTitle";
export const MODAL_EDIT_PLACEMENTS_META_DESCRIPTION =
  "modalEditPlacementsMetaDescription";
export const MODAL_EDIT_GROUP_CREATIVE_META_TITLE =
  "modalEditGroupCreativeMetaTitle";
export const MODAL_EDIT_GROUP_CREATIVE_META_DESCRIPTION =
  "modalEditGroupCreativeMetaDescription";
export const PLACEMENT_META_USE = "placementMetaUse";
export const PLACEMENT_META_RESIZE = "placementMetaResize";
export const PLACEMENT_META_SELECT_OTHER_CONTENT =
  "placementMetaSelectOtherContent";

//MODAL EDIT ADVANTAGE ENHANCES META
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_TITLE =
  "modalEditAdvantageEnhancesMetaTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_DESCRIPTION =
  "modalEditAdvantageEnhancesMetaDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_TITLE =
  "modalEditAdvantageEnhancesStandardEnhancesTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_STANDARD_ENHANCES_DESCRIPTION =
  "modalEditAdvantageEnhancesStandardEnhancesDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_TITLE =
  "modalEditAdvantageEnhancesAutoCropTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_AUTO_CROP_DESCRIPTION =
  "modalEditAdvantageEnhancesAutoCropDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_TITLE =
  "modalEditAdvantageEnhancesMetaTextOptimizationsTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_TEXT_OPTIMIZATIONS_DESCRIPTION =
  "modalEditAdvantageEnhancesMetaTextOptimizationsDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_TITLE =
  "modalEditAdvantageEnhancesMetaInlineCommentTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_INLINE_COMMENT_DESCRIPTION =
  "modalEditAdvantageEnhancesMetaInlineCommentDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_TITLE =
  "modalEditAdvantageEnhancesMetaEnhanceCtaTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_ENHANCE_CTA_DESCRIPTION =
  "modalEditAdvantageEnhancesMetaEnhanceCtaDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_TITLE =
  "modalEditAdvantageEnhancesMetaImageTemplatesTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_TEMPLATES_DESCRIPTION =
  "modalEditAdvantageEnhancesMetaImageTemplatesDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_TITLE =
  "modalEditAdvantageEnhancesMetaImageAnimationTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_META_IMAGE_ANIMATION_DESCRIPTION =
  "modalEditAdvantageEnhancesMetaImageAnimationDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_TITLE =
  "modalEditAdvantageEnhancesCvTransformationTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_CV_TRANSFORMATION_DESCRIPTION =
  "modalEditAdvantageEnhancesCvTransformationDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_TITLE =
  "modalEditAdvantageEnhancesImageBrightnessAndContrastTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_IMAGE_BRIGHTNESS_AND_CONTRAST_DESCRIPTION =
  "modalEditAdvantageEnhancesImageBrightnessAndContrastDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_TITLE =
  "modalEditAdvantageEnhancesVideoFilteringTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_VIDEO_FILTERING_DESCRIPTION =
  "modalEditAdvantageEnhancesVideoFilteringDescription";

//CREATE FOR DESCRIPTION_AUTOMATION, PROFILE_CARD, MEDIA OR CAROUSEL_TO_VIDEO
export const MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_TITLE =
  "modalEditAdvantageEnhancesDescriptionAutomationTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_DESCRIPTION_AUTOMATION_DESCRIPTION =
  "modalEditAdvantageEnhancesDescriptionAutomationDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_TITLE =
  "modalEditAdvantageEnhancesProfileCardTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_PROFILE_CARD_DESCRIPTION =
  "modalEditAdvantageEnhancesProfileCardDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_TITLE =
  "modalEditAdvantageEnhancesMediaOrderTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_MEDIA_ORDER_DESCRIPTION =
  "modalEditAdvantageEnhancesMediaOrderDescription";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_TITLE =
  "modalEditAdvantageEnhancesCarouselToVideoTitle";
export const MODAL_EDIT_ADVANTAGE_ENHANCES_CAROUSEL_TO_VIDEO_DESCRIPTION =
  "modalEditAdvantageEnhancesCarouselToVideoDescription";

//MODAL KEYWORDS
export const MODAL_EDIT_KEYWORD_TITLE = "modalEditKeywordTitle";
export const MODAL_ADD_KEYWORDS_TITLE = "modalAddKeywordTitle";

//MODAL IMPORT ADS CAMPAIGN
export const MODAL_IMPORT_ADS_CAMPAIGN_TITLE = "modalImportAdsCampaignTitle";
export const MODAL_IMPORT_ADS_CAMPAIGN_DESCRIPTION =
  "modalImportAdsCampaignDescription";
export const MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_TITLE =
  "modalImportAdsCampaignSuccessTitle";
export const MODAL_IMPORT_ADS_CAMPAIGN_SUCCESS_DESCRIPTION =
  "modalImportAdsCampaignSuccessDescription";
export const MODAL_DUPLICATE_ADS_CAMPAIGN_TITLE =
  "modalDuplicateAdsCampaignTitle";
export const MODAL_DUPLICATE_ADS_CAMPAIGN_DESCRIPTION =
  "modalDuplicateAdsCampaignDescription";
export const MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_TITLE =
  "modalDuplicateAdsCampaignSuccessTitle";
export const MODAL_DUPLICATE_ADS_CAMPAIGN_SUCCESS_DESCRIPTION =
  "modalDuplicateAdsCampaignSuccessDescription";
export const MODAL_IMPORT_ADS_CAMPAIGN_SUPPORTED_TYPES =
  "modalImportAdsCampaignSupportedTypes";
export const MODAL_DUPLICATE_ADS_CAMPAIGN_SUPPORTED_TYPES =
  "modalDuplicateAdsCampaignSupportedTypes";
export const ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION =
  "alertImportedCampaignReadonlyDescription";

//MODAL UPLOAD INSTAGRAM
export const MODAL_UPLOAD_INSTAGRAM_ARIA_LABEL =
  "modalUploadInstagramAriaLabel";
export const MODAL_UPLOAD_INSTAGRAM_TITLE = "modalUploadInstagramTitle";
export const MODAL_UPLOAD_INSTAGRAM_CONTENT_UPLOADED_DESCRIPTION =
  "modalUploadInstagramVideoUploadedDescription";
export const MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_LABEL =
  "modalUploadInstagramDescriptionLabel";
export const MODAL_UPLOAD_INSTAGRAM_DESCRIPTION_PLACEHOLDER =
  "modalUploadInstagramDescriptionPlaceholder";
export const MODAL_UPLOAD_INSTAGRAM_TYPE_LABEL =
  "modalUploadInstagramTypeLabel";
export const MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL =
  "modalUploadInstagramTypePostLabel";
export const MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL =
  "modalUploadInstagramTypeStoryLabel";
export const MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL =
  "modalUploadInstagramTypeReelLabel";

export const MODAL_UPLOAD_FACEBOOK_TYPE_LABEL = "modalUploadFacebookTypeLabel";
export const TYPE_CONTENT_FACEBOOK_LABEL = "typeContentFacebookLabel";
export const MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL =
  "modalUploadFacebookTypePostLabel";
export const MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL =
  "modalUploadFacebookTypeStoryLabel";
export const MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL =
  "modalUploadFacebookTypeReelLabel";

// CAROUSEL IMAGES
export const INSTAGRAM_FEED_ASPECT_RATIO_WARNING =
  "instagramFeedAspectRatioWarning";
export const CAROUSEL_MIN_IMAGES_WARNING = "carouselMinImagesWarning";
export const CAROUSEL_MAX_IMAGES_WARNING = "carouselMaxImagesWarning";
export const CAROUSEL_DRAG_TO_REORDER = "carouselDragToReorder";
export const CAROUSEL_ADD_MORE_IMAGES = "carouselAddMoreImages";
export const CAROUSEL_IMAGES_SELECTED = "carouselImagesSelected";
export const CAROUSEL_MAIN_IMAGE = "carouselMainImage";

//MODAL CANVA
export const MODAL_CANVA_ARIA_LABEL = "modalCanvaAriaLabel";
export const MODAL_CANVA_TITLE = "modalCanvaTitle";
export const MODAL_CANVA_DESCRIPTION = "modalCanvaDescription";
export const MODAL_CANVA_CREATING_DESIGN = "modalCanvaCreatingDesign";
export const MODAL_CANVA_DESIGN_NOT_CREATED = "modalCanvaDesignNotCreated";
export const MODAL_CANVA_DESIGN_NOT_RETRIEVED = "modalCanvaDesignNotRetrieved";
export const MODAL_CANVA_IS_EDITING_IN_CANVA = "modalCanvaIsEditingInCanva";
export const MODAL_CANVA_IS_GETTING_YOUR_DESIGN =
  "modalCanvaIsGettingYourDesign";
export const MODAL_CANVA_IS_GETTING_YOUR_FINAL_DESIGN =
  "modalCanvaIsGettingYourFinalDesign";
export const MODAL_CANVA_INFORMATION_SAVE_DESIGN =
  "modalCanvaInformationSaveDesign";
export const MODAL_CANVA_IMPORT_IMAGES_ONLY_WARNING_DESCRIPTION =
  "modalCanvaImportImagesOnlyWarningDescription";

//MODAL CANVA IMAGE CONFIG
export const MODAL_CANVA_IMAGE_CONFIG_TITLE = "modalCanvaImageConfigTitle";
export const MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION =
  "modalCanvaImageConfigDescription";
export const MODAL_CANVA_IMAGE_CONFIG_TYPE_LABEL =
  "modalCanvaImageConfigTypeLabel";
export const MODAL_CANVA_IMAGE_CONFIG_WIDTH_LABEL =
  "modalCanvaImageConfigWidthLabel";
export const MODAL_CANVA_IMAGE_CONFIG_HEIGHT_LABEL =
  "modalCanvaImageConfigHeightLabel";
export const MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON =
  "modalCanvaImageConfigCreateButton";
export const MODAL_CANVA_IMAGE_CONFIG_CANCEL_BUTTON =
  "modalCanvaImageConfigCancelButton";
export const MODAL_CANVA_ACCOUNT_LABEL = "modalCanvaAccountLabel";
export const MODAL_GOOGLE_DRIVE_ACCOUNT_LABEL = "modalGoogleDriveAccountLabel";
export const MODAL_GOOGLE_DRIVE_ACCOUNT_TITLE = "modalGoogleDriveAccountTitle";
export const MODAL_GOOGLE_DRIVE_ACCOUNT_DESCRIPTION =
  "modalGoogleDriveAccountDescription";
export const MODAL_GOOGLE_DRIVE_ACCOUNT_CONFIRM_BUTTON =
  "modalGoogleDriveAccountConfirmButton";
export const GOOGLE_DRIVE_CONFIGURING_FILE_SELECTOR =
  "googleDriveConfiguringFileSelector";
export const GOOGLE_DRIVE_OPENING_SELECTOR = "googleDriveOpeningSelector";
export const GOOGLE_DRIVE_IMPORTING_FILES = "googleDriveImportingFiles";
export const MODAL_CANVA_FOLDER_LABEL = "modalCanvaFolderLabel";
export const MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON =
  "modalCanvaImageConfigEditButton";
export const MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE =
  "modalCanvaImageConfigEditTitle";
export const MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION =
  "modalCanvaImageConfigEditDescription";
export const MODAL_CANVA_DISCONNECT_TITLE = "modalCanvaDisconnectTitle";
export const MODAL_CANVA_DISCONNECT_DESCRIPTION =
  "modalCanvaDisconnectDescription";
export const MODAL_CANVA_DISCONNECT_BUTTON = "modalCanvaDisconnectButton";
export const IMAGE_TYPE_PORTRAIT_LABEL = "imageTypePortraitLabel";
export const IMAGE_TYPE_LANDSCAPE_LABEL = "imageTypeLandscapeLabel";
export const IMAGE_TYPE_SQUARE_LABEL = "imageTypeSquareLabel";
export const ERROR_WIDTH_RANGE = "errorWidthRange";
export const ERROR_HEIGHT_RANGE = "errorHeightRange";

//MODAL VERIFY INTEGRATION SCOPES
export const MODAL_VERIFY_INTEGRATION_SCOPES_TITLE =
  "modalVerifyIntegrationScopesTitle";
export const MODAL_VERIFY_INTEGRATION_SCOPES_DESCRIPTION =
  "modalVerifyIntegrationScopesDescription";

//MODAL CUSTOM AUDIENCES
export const MODAL_CUSTOM_AUDIENCES_ARIA_LABEL =
  "modalCustomAudiencesAriaLabel";
export const MODAL_CUSTOM_AUDIENCES_TITLE = "modalCustomAudiencesTitle";
export const MODAL_CUSTOM_AUDIENCES_DESCRIPTION =
  "modalCustomAudiencesDescription";
export const MODAL_CUSTOM_AUDIENCES_EMPTY_TEXT =
  "modalCustomAudiencesEmptyText";

//MODAL CUSTOM AUDIENCES EXCLUDE
export const MODAL_EXCLUDED_CUSTOM_AUDIENCES_ARIA_LABEL =
  "modalExcludedCustomAudiencesAriaLabel";
export const MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE =
  "modalExcludedCustomAudiencesTitle";
export const MODAL_EXCLUDED_CUSTOM_AUDIENCES_DESCRIPTION =
  "modalExcludedCustomAudiencesDescription";

//MODAL SAVED AUDIENCES
export const MODAL_SAVED_AUDIENCES_TITLE = "modalSavedAudiencesTitle";
export const MODAL_SAVED_AUDIENCES_DESCRIPTION =
  "modalSavedAudiencesDescription";

//MODAL CREATE CUSTOM AUDIENCE
export const MODAL_CREATE_CUSTOM_AUDIENCE_ARIA_LABEL =
  "modalCustomAudienceAriaLabel";
export const MODAL_CREATE_CUSTOM_AUDIENCE_TITLE = "modalCustomAudienceTitle";
export const MODAL_CREATE_CUSTOM_AUDIENCE_DESCRIPTION =
  "modalCustomAudienceDescription";
export const MODAL_CREATE_CUSTOM_AUDIENCE_UPLOAD_CSV_CUSTOMER_LIST =
  "modalCreateCustomAudienceUploadCsvCustomerList";

//MODAL CREATE IDENTITY TIKTOK BUSINESS
export const MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_TITLE =
  "modalCreateIdentityTikTokBusinessTitle";
export const MODAL_CREATE_IDENTITY_TIKTOK_BUSINESS_DESCRIPTION =
  "modalCreateIdentityTikTokBusinessDescription";
export const TIKTOK_CREATE_AD_ACCOUNT_OPTION = "tiktokCreateAdAccountOption";
export const TIKTOK_CREDIT_BANNER_EYEBROW = "tiktokCreditBannerEyebrow";
export const TIKTOK_CREDIT_BANNER_TITLE = "tiktokCreditBannerTitle";
export const TIKTOK_CREDIT_BANNER_DESCRIPTION_PREFIX =
  "tiktokCreditBannerDescriptionPrefix";
export const TIKTOK_CREDIT_BANNER_DESCRIPTION_HIGHLIGHT =
  "tiktokCreditBannerDescriptionHighlight";
export const TIKTOK_CREDIT_BANNER_CTA = "tiktokCreditBannerCta";
export const TIKTOK_CREDIT_BADGE_TOOLTIP = "tiktokCreditBadgeTooltip";
export const AD_ACCOUNT_CREATED_FROM_BUSINESS = "adAccountCreatedFromBusiness";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_TITLE =
  "modalCreateAdAccountTikTokTitle";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_DESCRIPTION =
  "modalCreateAdAccountTikTokDescription";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_BUSINESS_CENTER =
  "modalCreateAdAccountTikTokBusinessCenter";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_NAME =
  "modalCreateAdAccountTikTokName";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_COMPANY =
  "modalCreateAdAccountTikTokCompany";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_INDUSTRY =
  "modalCreateAdAccountTikTokIndustry";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_COUNTRY =
  "modalCreateAdAccountTikTokCountry";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY =
  "modalCreateAdAccountTikTokCurrency";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_CURRENCY_HELPER =
  "modalCreateAdAccountTikTokCurrencyHelper";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_TIMEZONE =
  "modalCreateAdAccountTikTokTimezone";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_REVIEW_NOTE =
  "modalCreateAdAccountTikTokReviewNote";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_CREDIT_ALERT =
  "modalCreateAdAccountTikTokCreditAlert";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_NO_BUSINESS_CENTERS =
  "modalCreateAdAccountTikTokNoBusinessCenters";
export const MODAL_CREATE_AD_ACCOUNT_TIKTOK_SUCCESS_TITLE =
  "modalCreateAdAccountTikTokSuccessTitle";

//GUIDE CREATE TIKTOK AD ACCOUNT
export const GUIDE_TIKTOK_AD_ACCOUNT_EYEBROW = "guideTiktokAdAccountEyebrow";
export const GUIDE_TIKTOK_AD_ACCOUNT_TITLE = "guideTiktokAdAccountTitle";
export const GUIDE_TIKTOK_AD_ACCOUNT_INTRO = "guideTiktokAdAccountIntro";
export const GUIDE_TIKTOK_AD_ACCOUNT_BACK = "guideTiktokAdAccountBack";
export const GUIDE_TIKTOK_AD_ACCOUNT_LINK = "guideTiktokAdAccountLink";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP = "guideTiktokAdAccountStep";
export const GUIDE_TIKTOK_AD_ACCOUNT_PATH_SETTINGS =
  "guideTiktokAdAccountPathSettings";
export const GUIDE_TIKTOK_AD_ACCOUNT_PATH_AD_ACCOUNTS =
  "guideTiktokAdAccountPathAdAccounts";
export const GUIDE_TIKTOK_AD_ACCOUNT_PATH_CONNECT =
  "guideTiktokAdAccountPathConnect";
export const GUIDE_TIKTOK_AD_ACCOUNT_PATH_CREATE =
  "guideTiktokAdAccountPathCreate";
export const GUIDE_TIKTOK_AD_ACCOUNT_PATH_ADS_MANAGER =
  "guideTiktokAdAccountPathAdsManager";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_TITLE =
  "guideTiktokAdAccountStep1Title";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_BODY =
  "guideTiktokAdAccountStep1Body";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_ALT =
  "guideTiktokAdAccountStep1Alt";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_1_AUTH_ALT =
  "guideTiktokAdAccountStep1AuthAlt";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_TITLE =
  "guideTiktokAdAccountStep2Title";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_BODY =
  "guideTiktokAdAccountStep2Body";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_2_ALT =
  "guideTiktokAdAccountStep2Alt";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_TITLE =
  "guideTiktokAdAccountStep3Title";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_BODY =
  "guideTiktokAdAccountStep3Body";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_3_ALT =
  "guideTiktokAdAccountStep3Alt";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_TITLE =
  "guideTiktokAdAccountStep4Title";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_4_BODY =
  "guideTiktokAdAccountStep4Body";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_TITLE =
  "guideTiktokAdAccountStep5Title";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_BODY =
  "guideTiktokAdAccountStep5Body";
export const GUIDE_TIKTOK_AD_ACCOUNT_STEP_5_ALT =
  "guideTiktokAdAccountStep5Alt";
export const GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_TITLE =
  "guideTiktokAdAccountChecklistTitle";
export const GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_WEBSITE =
  "guideTiktokAdAccountChecklistWebsite";
export const GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_BILLING =
  "guideTiktokAdAccountChecklistBilling";
export const GUIDE_TIKTOK_AD_ACCOUNT_CHECKLIST_PAYMENT =
  "guideTiktokAdAccountChecklistPayment";

//MODAL MAIN GENERATE SOCIAL MEDIA CONTENT
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL =
  "modalMainGenerateSocialMediaContentAriaLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE =
  "modalMainGenerateSocialMediaContentTitle";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION =
  "modalMainGenerateSocialMediaContentDescription";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_LABEL =
  "modalMainGenerateSocialMediaContextLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTEXT_PLACEHOLDER =
  "modalMainGenerateSocialMediaContextPlaceholder";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WEBSITE_URL_LABEL =
  "modalMainGenerateSocialMediaWebsiteUrlLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_HAS_TEXTS_LABEL =
  "modalMainGenerateSocialMediaHasTextsLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_ALL_WITH_TEXT =
  "modalMainGenerateSocialMediaAllWithText";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_SOME_WITH_TEXT =
  "modalMainGenerateSocialMediaSomeWithText";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_WITHOUT_TEXT =
  "modalMainGenerateSocialMediaWithoutText";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_LANGUAGE_LABEL =
  "modalMainGenerateSocialMediaContentLanguageLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_TONES_LABEL =
  "modalMainGenerateSocialMediaContentTonesLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_TEXT_LABEL =
  "modalMainGenerateSocialMediaContentColorTextLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_COLOR_BACKGROUND_LABEL =
  "modalMainGenerateSocialMediaContentColorBackgroundLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_HAS_TEXT_LABEL =
  "modalMainGenerateSocialMediaContentHasTextLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_FONT_FAMILY_LABEL =
  "modalMainGenerateSocialMediaContentFontFamilyLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_TEXT_LABEL =
  "modalMainGenerateSocialMediaContentAlignTextLabel";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALIGN_LOGO_LABEL =
  "modalMainGenerateSocialMediaContentAlignLogoLabel";
export const MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_TITLE =
  "modalMainSocialMediaContentGalleryTitle";
export const MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_EMPTY =
  "modalMainSocialMediaContentGalleryEmpty";
export const MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_UPLOAD_OPTION =
  "modalMainSocialMediaContentGalleryUploadOption";
export const MODAL_MAIN_SOCIAL_MEDIA_CONTENT_GALLERY_FROM_COLLABORATIONS_OPTION =
  "modalMainSocialMediaContentGalleryFromCollaborationsOption";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENTS_REQUIRED =
  "modalMainGenerateSocialMediaContentDaysRequired";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULE_BUTTON =
  "modalMainGenerateSocialMediaContentScheduleButton";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_SCHEDULED_CONTENT =
  "modalMainGenerateSocialMediaContentScheduledContent";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_ALREADY_CONTENT_ON_THIS_DATE =
  "modalMainGenerateSocialMediaContentAlreadyContentOnThisDate";
export const MODAL_MAIN_GENERATE_SOCIAL_MEDIA_CONTENT_CONTENT_WILL_BE_PUBLISHED_IMMEDIATELY =
  "modalMainGenerateSocialMediaContentContentWillBePublishedImmediately";

//MODAL CONNECT ACCOUNTS
export const MODAL_CONNECT_ACCOUNTS_TITLE = "modalConnectAccountsTitle";
export const MODAL_CONNECT_ACCOUNTS_DESCRIPTION =
  "modalConnectAccountsDescription";

//MODAL GENERATE SOCIAL MEDIA CONTENT
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_ARIA_LABEL =
  "modalGenerateSocialMediaContentAriaLabel";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TITLE =
  "modalGenerateSocialMediaContentTitle";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_LABEL =
  "modalGenerateSocialMediaContentSelectToneLabel";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_TOP_FIVE_OPTION =
  "modalGenerateSocialMediaContentSelectToneTopFiveOption";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_EDUCATION_OPTION =
  "modalGenerateSocialMediaContentSelectToneEducationalOption";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_QUOTES_OPTION =
  "modalGenerateSocialMediaContentSelectToneQuotesOption";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_CURIOUS_FACTS_OPTION =
  "modalGenerateSocialMediaContentSelectToneCuriousFactsOption";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_RHYMES_OR_POEMS_OPTION =
  "modalGenerateSocialMediaContentSelectToneRhymesOrPoemsOption";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_SELECT_TONE_HUMOR_OPTION =
  "modalGenerateSocialMediaContentSelectToneHumorOption";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_EMPTY_CONTENT =
  "modalGenerateSocialMediaContentEmptyContent";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_TEXT_LABEL =
  "modalGenerateSocialMediaContentTextLabel";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_DESCRIPTION =
  "modalGenerateSocialMediaContentDescription";
export const MODAL_GENERATE_SOCIAL_MEDIA_CONTENT_GENERATING_CONTENT =
  "modalGenerateSocialMediaContentGeneratingContent";

//REDEEM CODE
export const REDEEM_CODE_TITLE = "redeemCodeTitle";
export const REDEEM_CODE_DESCRIPTION = "redeemCodeDescription";
export const REDEEM_CODE_SEARCHBAR_PLACEHOLDER = "redeemCodeBarPlaceholder";
export const REDEEM_CODE_TABLE_COLUMN_CODE = "redeemCodeTableColumnCode";
export const REDEEM_CODE_TABLE_COLUMN_DATE = "redeemCodeTableColumnDate";
export const REDEEM_CODE_TABLE_COLUMN_VALUE = "redeemCodeTableColumnValue";
export const REDEEM_CODE_TABLE_COLUMN_TERMS = "redeemCodeTableColumnTerms";
export const CODE_REDEEMED = "codeRedeemed";
export const VALUE_CODE_REDEEMED = "valueCodeRedeemed";
export const VALUE_GENERAL_CODE_REDEEMED = "valueGeneralCodeRedeemed";
export const CODE_NO_EXIST = "codeNoExist";
export const CODE_NO_REDEEM_BEFORE_DATE = "codeNoRedeemBeforeDate";

//ORDERS
export const ORDERS_TITLE = "ordersTitle";
export const ORDERS_DESCRIPTION = "ordersDescription";
export const ORDERS_REMEMBER_MARK_AS_DELIVERED =
  "ordersRememberMarkAsDelivered";
export const ORDERS_SEARCHBAR_PLACEHOLDER = "ordersSearchBarPlaceholder";
export const ORDERS_TAB_TO_BE_ACCEPTED = "ordersTabToBeAccepted";
export const ORDERS_TAB_TO_BE_ACCEPTED_DESCRIPTION =
  "ordersTabToBeAcceptedDescription";
export const ORDERS_TAB_IN_PREPARATION = "ordersTabInPreparation";
export const ORDERS_TAB_IN_PREPARATION_DESCRIPTION =
  "ordersTabInPreparationDescription";
export const ORDERS_TAB_TO_BE_DELIVERED = "ordersTabToBeDelivered";
export const ORDERS_TAB_TO_BE_DELIVERED_DESCRIPTION =
  "ordersTabToBeDeliveredDescription";
export const DELIVERY_INTERN = "deliveryIntern";
export const DELIVERY_INTERN_ON_THE_WAY = "deliveryInternOnTheWay";
export const DELIVERY_ON_THE_WAY = "deliveryOnTheWay";
export const ORDER_ID = "orderId";
export const ORDER_ACCEPTED = "orderAccepted";
export const ORDER_ACCEPTED_DESCRIPTION = "orderAcceptedDescription";
export const ORDER_READY = "orderReady";
export const ORDER_READY_DESCRIPTION = "orderReadyDescription";
export const ORDER_TO_BE_DELIVERED_CONFIRMATION =
  "orderToBeDeliveredConfirmation";
export const ORDER_TO_BE_DELIVERED_CONFIRMATION_BUTTON =
  "orderToBeDeliveredConfirmationButton";
export const ORDER_CANCELLED_CONFIRMATION = "orderCancelledConfirmation";
export const ORDER_CANCELLED_CONFIRMATION_BUTTON =
  "orderCancelledConfirmationButton";
export const ORDER_DELIVERED = "orderDelivered";
export const ORDER_DELIVERED_DESCRIPTION = "orderDeliveredDescription";
export const DELIVERY_SELECTED = "deliverySelected";
export const DELIVERY_SELECTED_DESCRIPTION = "deliverySelectedDescription";
export const ORDER_REJECTED = "orderRejected";
export const ORDER_REJECTED_DESCRIPTION = "orderRejectedDescription";
export const ORDER_TOTAL_VALUE = "orderTotalValue";
export const ORDER_TOTAL_VALUE_DISCOUNT = "orderTotalValueDiscount";
export const ORDER_LIST_OF_PRODUCTS = "orderListOfProducts";
export const ORDER_OPTIONS = "orderOptions";
export const ORDER_TIME_PREPARATION_TITLE = "orderTimePreparationTitle";
export const MIN_VALUE_PREPARATION_ORDER = "minValuePreparationOrder";
export const MAX_VALUE_PREPARATION_ORDER = "maxValuePreparationOrder";
export const INVALID_TIME_PREPARATION = "invalidTimePreparation";
export const TIME_PREPARATION_VALUES_VALIDATION =
  "timePreparationValuesValidation";
export const GUIDE_NUMBER = "guideNumber";
export const GUIDE_NUMBER_REQUIRED = "guideNumberRequired";
export const DELIVERY_TYPE_DUPLICATE = "deliveryTypeDuplicate";
export const SELECT_DELIVERY_TYPE = "selectDeliveryType";
export const SELECT_DELIVERY_TYPE_OTHER = "selectDeliveryTypeOther";
export const DELIVERY_DATA = "deliveryData";
export const OWN_DELIVERY = "ownDelivery";

//EVENTS
export const EVENT_NO_EXIST = "eventNoExist";
export const EVENT_DISABLED = "eventDisabled";
export const EVENT_HAS_FIELDS_REQUIRED = "eventHasFieldsRequired";
export const EVENT_RECURRENT_REQUIRED = "eventRecurrentRequired";

//ACCOUNT
export const ACCOUNT_TITLE = "accountTitle";
export const ACCOUNT_DESCRIPTION = "accountDescription";

//COMPANY INFORMATION
export const COMPANY_INFORMATION_TITLE = "companyInformationTitle";
export const COMPANY_INFORMATION_SUBCATEGORY_DUPLICATE =
  "companyInformationSubcategoryDuplicate";
export const COMPANY_INFORMATION_TYPE_ID_PLACEHOLDER =
  "companyInformationTypeIdPlaceholder";
export const COMPANY_INFORMATION_ID_NUMBER_PLACEHOLDER =
  "companyInformationIdNumberPlaceholder";
export const COMPANY_INFORMATION_ID_NUMBER_MIN_LENGTH =
  "companyInformationIdNumberMinLength";
export const COMPANY_INFORMATION_ID_NUMBER_TYPE =
  "companyInformationIdNumberType";
export const COMPANY_INFORMATION_BRAND_NAME_PLACEHOLDER =
  "companyInformationBrandNamePlaceholder";
export const COMPANY_INFORMATION_BUSINESS_NAME_PLACEHOLDER =
  "companyInformationBusinessNamePlaceholder";
export const COMPANY_INFORMATION_ADDRESS_PLACEHOLDER =
  "companyInformationAddressPlaceholder";
export const COMPANY_INFORMATION_AVERAGE_TICKET_PLACEHOLDER =
  "companyInformationAverageTicketPlaceholder";
export const COMPANY_INFORMATION_AVERAGE_TICKET_MIN_VALUE =
  "companyInformationAverageTicketMinValue";
export const COMPANY_INFORMATION_SOCIAL_NETWORK_PLACEHOLDER =
  "companyInformationSocialNetworkPlaceholder";
export const COMPANY_INFORMATION_SECOND_SOCIAL_NETWORK_PLACEHOLDER =
  "companyInformationSecondSocialNetworkPlaceholder";
export const COMPANY_INFORMATION_WEBSITE_URL_PLACEHOLDER =
  "companyInformationWebsiteUrlPlaceholder";
export const COMPANY_INFORMATION_TRAFFIC_URL_PLACEHOLDER =
  "companyInformationTrafficUrlPlaceholder";
export const COMPANY_INFORMATION_CATEGORY_PLACEHOLDER =
  "companyInformationCategoryPlaceholder";
export const COMPANY_INFORMATION_SUBCATEGORY_PLACEHOLDER =
  "companyInformationSubcategoryPlaceholder";
export const COMPANY_INFORMATION_NEW_SUBCATEGORY =
  "companyInformationNewSubcategory";
export const COMPANY_INFORMATION_SHORT_DESCRIPTION_PLACEHOLDER =
  "companyInformationShortDescriptionPlaceholder";
export const COMPANY_INFORMATION_ADMIN_PHONE_PLACEHOLDER =
  "companyInformationAdminPhonePlaceholder";
export const COMPANY_INFORMATION_RESERVATION_URL_PLACEHOLDER =
  "companyInformationReservationUrlPlaceholder";
export const COMPANY_INFORMATION_UPLOAD_LOGO_PLACEHOLDER =
  "companyInformationUploadLogoPlaceholder";
export const COMPANY_INFORMATION_UPLOAD_LOGO_DESCRIPTION_PLACEHOLDER =
  "companyInformationUploadLogoDescriptionPlaceholder";
export const COMPANY_INFORMATION_UPLOAD_COVER_PLACEHOLDER =
  "companyInformationUploadCoverPlaceholder";
export const COMPANY_INFORMATION_UPLOAD_COVER_DESCRIPTION_PLACEHOLDER =
  "companyInformationUploadCoverDescriptionPlaceholder";
export const COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_PLACEHOLDER =
  "companyInformationUploadRegulatoryDocumentPlaceholder";
export const COMPANY_INFORMATION_UPLOAD_REGULATORY_DOCUMENT_DESCRIPTION_PLACEHOLDER =
  "companyInformationUploadRegulatoryDocumentDescriptionPlaceholder";
export const COMPANY_INFORMATION_VIEW_DOCUMENT =
  "companyInformationViewDocument";
export const COMPANY_INFORMATION_GENERAL_DISCOUNT_TITLE =
  "companyInformationGeneralDiscountTitle";
export const COMPANY_INFORMATION_GENERAL_DISCOUNT_DESCRIPTION =
  "companyInformationGeneralDiscountDescription";
export const COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_1 =
  "companyInformationGeneralDiscountExplanation1";
export const COMPANY_INFORMATION_GENERAL_DISCOUNT_EXPLANATION_2 =
  "companyInformationGeneralDiscountExplanation2";
export const COMPANY_INFORMATION_GENERAL_DISCOUNT_PERCENTAGE_PLACEHOLDER =
  "companyInformationGeneralDiscountPercentagePlaceholder";
export const COMPANY_INFORMATION_GENERAL_DISCOUNT_CODE_PLACEHOLDER =
  "companyInformationGeneralDiscountCodePlaceholder";
export const COMPANY_INFORMATION_SHOP_ID_COPIED =
  "companyInformationShopIdCopied";
export const COMPANY_INFORMATION_ONBOARDING_FINISH_DESCRIPTION =
  "companyInformationOnboardingFinishDescription";
export const COMPANY_INFORMATION_SAVED = "companyInformationSaved";

//PLATFORMS CONNECT
export const PLATFORMS_CONNECTED_TITLE = "platformsConnectedTitle";
export const PLATFORMS_CONNECTED_INSTAGRAM_FAILED =
  "platformsConnectedInstagramFailed";
export const PLATFORMS_CONNECTED_FACEBOOK_SDK_UNAVAILABLE =
  "platformsConnectedFacebookSdkUnavailable";
export const PLATFORMS_CONNECTED_META_BLOCKED_TITLE =
  "platformsConnectedMetaBlockedTitle";
export const PLATFORMS_CONNECTED_META_POPUP_BLOCKED =
  "platformsConnectedMetaPopupBlocked";
export const PLATFORMS_CONNECTED_META_BLOCKED_STEP_DISABLE_BLOCKER =
  "platformsConnectedMetaBlockedStepDisableBlocker";
export const PLATFORMS_CONNECTED_META_BLOCKED_STEP_ALLOW_POPUPS =
  "platformsConnectedMetaBlockedStepAllowPopups";
export const PLATFORMS_CONNECTED_META_BLOCKED_STEP_RETRY =
  "platformsConnectedMetaBlockedStepRetry";
export const PLATFORMS_TOKEN_EXPIRED = "platformsTokenExpired";
export const AD_ACCOUNTS_TITLE = "adAccountsTitle";

//SETUP BRAND
export const BRAND_SETUP_TITLE = "brandSetupTitle";

//SCHEDULE
export const SCHEDULE_TITLE = "scheduleTitle";
export const SCHEDULE_ECOMMERCE_ALERT_TITLE = "scheduleEcommerceAlertTitle";
export const SCHEDULE_ECOMMERCE_ALERT_DESCRIPTION =
  "scheduleEcommerceAlertDescription";
export const SCHEDULE_ONE_DAY_WITH_TURN = "scheduleOneDayWithTurn";
export const SCHEDULE_EMPTY_TURN = "scheduleEmptyTurn";
export const SCHEDULE_OPEN_AND_CLOSE_HOUR_VALIDATION =
  "scheduleOpenAndCloseHourValidation";
export const SCHEDULE_MAX_CLOSE_HOUR = "scheduleMaxCloseHour";
export const SCHEDULE_TABLE_ARIA_LABEL = "scheduleTableAriaLabel";
export const SCHEDULE_TABLE_COLUMN_OPEN = "scheduleTableColumnOpen";
export const SCHEDULE_TABLE_COLUMN_CLOSE = "scheduleTableColumnClose";
export const SCHEDULE_SAVED = "scheduleSaved";

//LEGAL REPRESENTATIVE
export const LEGAL_REPRESENTATIVE_TITLE = "legalRepresentativeTitle";
export const LEGAL_REPRESENTATIVE_NAME_PLACEHOLDER = "legalRepresentativeName";
export const LEGAL_REPRESENTATIVE_LAST_NAME_PLACEHOLDER =
  "legalRepresentativeLastName";
export const LEGAL_REPRESENTATIVE_TYPE_ID_PLACEHOLDER =
  "legalRepresentativeTypeId";
export const LEGAL_REPRESENTATIVE_ID_NUMBER_PLACEHOLDER =
  "legalRepresentativeIdNumber";
export const LEGAL_REPRESENTATIVE_PHONE_PLACEHOLDER =
  "legalRepresentativePhone";
export const LEGAL_REPRESENTATIVE_SAVED = "legalRepresentativeSaved";

//PASSWORD
export const PASSWORD_TITLE = "passwordTitle";
export const PASSWORD_CURRENT_PASSWORD_PLACEHOLDER =
  "passwordCurrentPasswordPlaceholder";
export const PASSWORD_NEW_PASSWORD_PLACEHOLDER =
  "passwordNewPasswordPlaceholder";
export const PASSWORD_CONFIRM_PASSWORD_PLACEHOLDER =
  "passwordConfirmPasswordPlaceholder";
export const PASSWORD_FORMAT_DESCRIPTION = "passwordFormatDescription";
export const PASSWORD_FORMAT_SUGGESTION1 = "passwordFormatSuggestion1";
export const PASSWORD_FORMAT_SUGGESTION2 = "passwordFormatSuggestion2";
export const PASSWORD_FORMAT_SUGGESTION3 = "passwordFormatSuggestion3";
export const PASSWORD_FORMAT_SUGGESTION4 = "passwordFormatSuggestion4";
export const PASSWORD_INSECURE = "passwordInsecure";
export const PASSWORDS_NOT_MATCH = "passwordsNotMatch";
export const PASSWORD_CURRENT_INVALID = "passwordCurrentInvalid";
export const PASSWORD_ACCOUNT_DISABLED_FOR_MORE_INTENTS =
  "passwordAccountDisabledForMoreIntents";
export const PASSWORD_CHANGED = "passwordChanged";

//STORES
export const MODAL_STORE_ARIA_LABEL = "modalStoreAriaLabel";
export const MODAL_STORE_TITLE = "modalStoreTitle";
export const MODAL_STORE_TITLE_EDIT = "modalStoreTitleEdit";
export const MODAL_STORE_DESCRIPTION = "modalStoreDescription";
export const MODAL_STORE_DESCRIPTION_EDIT = "modalStoreDescriptionEdit";
export const MODAL_STORE_TYPE_PLACEHOLDER = "modalStoreTypePlaceholder";
export const MODAL_STORE_TYPE_REGULAR_OPTION = "modalStoreTypeRegularOption";
export const MODAL_STORE_HOW_TO_INTEGRATE_STORE =
  "modalStoreHowToIntegrateStore";
export const MODAL_STORE_NAME_PLACEHOLDER = "modalStoreNamePlaceholder";
export const MODAL_STORE_DESCRIPTION_PLACEHOLDER =
  "modalStoreDescriptionPlaceholder";
export const MODAL_STORE_ADDRESS_PLACEHOLDER = "modalStoreAddressPlaceholder";
export const MODAL_STORE_CITY_PLACEHOLDER = "modalStoreCityPlaceholder";
export const MODAL_STORE_PHONE_PLACEHOLDER = "modalStorePhonePlaceholder";
export const MODAL_STORE_LINK_STORE_SPECIAL_PLACEHOLDER =
  "modalStoreLinkStoreSpecialPlaceholder";
export const MODAL_STORE_NAME_SHOPIFY_PLACEHOLDER =
  "modalStoreNameShopifyPlaceholder";
export const MODAL_STORE_LOOK_NAME_SHOPIFY = "modalStoreLookNameShopify";
export const MODAL_STORE_LOOK_NAME_SHOPIFY_HELPER_TEXT =
  "modalStoreLookNameShopifyHelperText";
export const MODAL_STORE_ACCESS_TOKEN_FOR_BUZZLY_PLACEHOLDER =
  "modalStoreAccessTokenForBuzzlyPlaceholder";
export const MODAL_STORE_DO_CREATE_DISCOUNT_SHIPPING_PLACEHOLDER =
  "modalStoreDoCreateDiscountShippingPlaceholder";
export const MODAL_STORE_CITIES_PLACEHOLDER = "modalStoreCitiesPlaceholder";
export const MODAL_STORE_ORDERS_METHODS_PLACEHOLDER =
  "modalStoreOrdersMethodsPlaceholder";
export const MODAL_STORE_ORDERS_METHODS_DELIVERY_OPTION =
  "modalStoreOrdersMethodsDeliveryOption";
export const MODAL_STORE_ORDERS_METHODS_IN_STORE_OPTION =
  "modalStoreOrdersMethodsInStoreOption";
export const MODAL_STORE_PRODUCT_AVAILABILITY_PLACEHOLDER =
  "modalStoreProductAvailabilityPlaceholder";
export const MODAL_STORE_PRODUCT_AVAILABILITY_NATIONAL_OPTION =
  "modalStoreProductAvailabilityNationalOption";
export const MODAL_STORE_PRODUCT_AVAILABILITY_LOCAL_OPTION =
  "modalStoreProductAvailabilityLocalOption";
export const MODAL_STORE_COVERAGE_RADIUS_PLACEHOLDER =
  "modalStoreCoverageRadiusPlaceholder";
export const MODAL_STORE_TITLE_CREATE_INTEGRATE_SHOPIFY =
  "modalStoreTitleCreateIntegrateShopify";
export const MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_SHOPIFY =
  "modalStoreDescriptionCreateIntegrateShopify";
export const MODAL_STORE_BUTTON_CREATE_INTEGRATE_SHOPIFY =
  "modalStoreButtonCreateIntegrateShopify";
export const MODAL_STORE_DESCRIPTION_DISCONNECT_SHOPIFY =
  "modalStoreDescriptionDisconnectShopify";
export const MODAL_STORE_TITLE_CREATE_INTEGRATE_WOOCOMMERCE =
  "modalStoreTitleCreateIntegrateWoocommerce";
export const MODAL_STORE_DESCRIPTION_CREATE_INTEGRATE_WOOCOMMERCE =
  "modalStoreDescriptionCreateIntegrateWoocommerce";
export const MODAL_STORE_BUTTON_CREATE_INTEGRATE_WOOCOMMERCE =
  "modalStoreButtonCreateIntegrateWoocommerce";
export const MODAL_STORE_DESCRIPTION_DISCONNECT_WOOCOMMERCE =
  "modalStoreDescriptionDisconnectWoocommerce";

//MENU
export const MENU_TITLE = "menuTitle";
export const MENU_DESCRIPTION = "menuDescription";
export const MENU_EMPTY_STORES = "menuEmptyStores";
export const MODAL_COPY_MENU_ARIA_LABEL = "modalCopyMenuAriaLabel";
export const MODAL_COPY_MENU_TITLE = "modalCopyMenuTitle";
export const MODAL_COPY_MENU_DESCRIPTION = "modalCopyMenuDescription";
export const MODAL_COPY_MENU_SAME_STORE = "modalCopyMenuSameStore";
export const MODAL_COPY_MENU_CONFIRM_ALERT_TITLE =
  "modalCopyMenuConfirmAlertTitle";
export const MODAL_COPY_MENU_CONFIRM_ALERT_DESCRIPTION =
  "modalCopyMenuConfirmAlertDescription";
export const MODAL_COPY_MENU_COPIED = "modalCopyMenuCopied";
export const SELECT_CATALOG = "selectCatalog";
export const MODAL_UPLOAD_MENU_ARIA_LABEL = "modalUploadMenuAriaLabel";
export const MODAL_UPLOAD_MENU_TITLE = "modalUploadMenuTitle";
export const MODAL_UPLOAD_MENU_DESCRIPTION = "modalUploadMenuDescription";
export const MODAL_UPLOAD_MENU_FILE_PLACEHOLDER =
  "modalUploadMenuFilePlaceholder";
export const MODAL_UPLOAD_MENU_ERROR_FORMAT = "modalUploadMenuErrorFormat";
export const MODAL_UPLOAD_MENU_MIN_PRICE_PRODUCT =
  "modalUploadMenuMinPriceProduct";
export const MODAL_UPLOAD_MENU_CONFIRM_ALERT_TITLE =
  "modalUploadMenuConfirmAlertTitle";
export const MODAL_UPLOAD_MENU_CONFIRM_ALERT_DESCRIPTION =
  "modalUploadMenuConfirmAlertDescription";
export const MODAL_UPLOAD_MENU_UPLOADED = "modalUploadMenuUploaded";
export const MENU_ADD_CATEGORY = "menuAddCategory";
export const MENU_CATEGORY_NAME_PLACEHOLDER = "menuCategoryNamePlaceholder";
export const MENU_CATEGORY_REQUIRED = "menuCategoryRequired";
export const MENU_ADD_PRODUCT = "menuAddProduct";
export const MENU_PRODUCT_MIN_VALUE = "menuProductMinValue";
export const MENU_CREATE_PRODUCT_TITLE = "menuCreateProductTitle";
export const MENU_PRODUCT_NAME_PLACEHOLDER = "menuProductNamePlaceholder";
export const MENU_PRODUCT_DESCRIPTION_PLACEHOLDER =
  "menuProductDescriptionPlaceholder";
export const MENU_PRODUCT_PRICE_PLACEHOLDER = "menuProductPricePlaceholder";
export const MENU_PRODUCT_TYPE_PRODUCT_PLACEHOLDER =
  "menuProductTypeProductPlaceholder";
export const MENU_PRODUCT_TYPE_PRODUCT_EXPLANATION =
  "menuProductTypeProductExplanation";
export const MENU_PRODUCT_ACCOMPANIMENTS_TYPE_TITLE =
  "menuProductAccompanimentsTypeTitle";
export const MENU_PRODUCT_ACCOMPANIMENTS_TYPE_DESCRIPTION =
  "menuProductAccompanimentsTypeDescription";
export const MENU_PRODUCT_ADD_ACCOMPANIMENT_TYPE_PLACEHOLDER =
  "menuProductAddAccompanimentTypePlaceholder";
export const MENU_PRODUCT_ACCOMPANIMENT_TYPE_IS_MANDATORY_PLACEHOLDER =
  "menuProductAccompanimentTypeIsMandatoryPlaceholder";
export const MENU_PRODUCT_ADD_ACCOMPANIMENT_PLACEHOLDER =
  "menuProductAddAccompanimentPlaceholder";
export const MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_AND_MAX_NUMBER =
  "menuProductAccompanimentTypeMinAndMaxNumber";
export const MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_NUMBER =
  "menuProductAccompanimentTypeMinNumber";
export const MENU_PRODUCT_ACCOMPANIMENT_TYPE_NAME_PLACEHOLDER =
  "menuProductAccompanimentTypeNamePlaceholder";
export const MENU_PRODUCT_ACCOMPANIMENT_TYPE_MIN_OPTIONS_PLACEHOLDER =
  "menuProductAccompanimentTypeMinOptionsPlaceholder";
export const MENU_PRODUCT_ACCOMPANIMENT_TYPE_MAX_OPTIONS_PLACEHOLDER =
  "menuProductAccompanimentTypeMaxOptionsPlaceholder";
export const MENU_PRODUCT_ACCOMPANIMENT_NAME_PLACEHOLDER =
  "menuProductAccompanimentNamePlaceholder";
export const MENU_PRODUCT_ACCOMPANIMENT_PRICE_PLACEHOLDER =
  "menuProductAccompanimentPricePlaceholder";
export const MODAL_MOVE_PRODUCT_ARIA_LABEL = "modalMoveProductAriaLabel";
export const MODAL_MOVE_PRODUCT_CATEGORY_OBJECTIVE =
  "modalMoveProductCategoryObjective";
export const MODAL_MOVE_PRODUCT_CATEGORY_REQUIRED =
  "modalMoveProductCategoryRequired";
export const MODAL_MOVE_PRODUCT_BUTTON = "modalMoveProductButton";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_ARIA_LABEL =
  "modalCopyAccompanimentTypeAriaLabel";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_OBJECTIVE =
  "modalCopyAccompanimentTypeCategoryObjective";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_OBJECTIVE =
  "modalCopyAccompanimentTypeProductObjective";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE =
  "modalCopyAccompanimentTypeObjective";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_OBJECTIVE_PLACEHOLDER =
  "modalCopyAccompanimentTypeObjectivePlaceholder";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_CATEGORY_REQUIRED =
  "modalCopyAccompanimentTypeCategoryRequired";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_PRODUCT_REQUIRED =
  "modalCopyAccompanimentTypeProductRequired";
export const MODAL_COPY_ACCOMPANIMENT_TYPE_REQUIRED =
  "modalCopyAccompanimentTypeRequired";
export const MENU_ONBOARDING_TEST_CATEGORY = "menuOnboardingTestCategory";
export const MENU_ONBOARDING_TEST_PRODUCT = "menuOnboardingTestProduct";
export const MENU_ONBOARDING_TEST_PRODUCT_DESCRIPTION =
  "menuOnboardingTestProductDescription";
export const MENU_ONBOARDING_FINISH_DESCRIPTION =
  "menuOnboardingFinishDescription";
export const MENU_ONBOARDING_FINISH_ADDITIONAL_DESCRIPTION =
  "menuOnboardingFinishAdditionalDescription";
export const MENU_CATEGORY_DUPLICATE = "menuCategoryDuplicate";
export const MENU_CATEGORY_DUPLICATE_DESCRIPTION =
  "menuCategoryDuplicateDescription";
export const MENU_CATEGORY_CREATED = "menuCategoryCreated";
export const MENU_CATEGORY_SAVED = "menuCategorySaved";
export const MENU_CATEGORY_DELETE_CONFIRMATION_TITLE =
  "menuCategoryDeleteConfirmationTitle";
export const MENU_CATEGORY_DELETE_CONFIRMATION_DESCRIPTION =
  "menuCategoryDeleteConfirmationDescription";
export const MENU_CATEGORY_DELETING = "menuCategoryDeleting";
export const MENU_CATEGORY_DELETED = "menuCategoryDeleted";
export const MENU_PRODUCT_DUPLICATE = "menuProductDuplicate";
export const MENU_PRODUCT_DUPLICATE_DESCRIPTION =
  "menuProductDuplicateDescription";
export const MENU_PRODUCT_CREATED = "menuProductCreated";
export const MENU_PRODUCT_SAVED = "menuProductSaved";
export const MENU_PRODUCT_DELETE_CONFIRMATION_TITLE =
  "menuProductDeleteConfirmationTitle";
export const MENU_PRODUCT_DELETE_CONFIRMATION_DESCRIPTION =
  "menuProductDeleteConfirmationDescription";
export const MENU_PRODUCT_DELETING = "menuProductDeleting";
export const MENU_PRODUCT_DELETED = "menuProductDeleted";
export const MENU_PRODUCT_MOVE_SAME_CATEGORY = "menuProductMoveSameCategory";
export const MENU_PRODUCT_MOVED = "menuProductMoved";
export const MENU_PRODUCT_CHANGE_STATUS = "menuProductChangeStatus";
export const MENU_ACCOMPANIMENT_TYPE_DUPLICATE =
  "menuAccompanimentTypeDuplicate";
export const MENU_ACCOMPANIMENT_TYPE_DUPLICATE_DESCRIPTION =
  "menuAccompanimentTypeDuplicateDescription";
export const MENU_ACCOMPANIMENT_TYPE_COPIED = "menuAccompanimentTypeCopied";
export const MENU_ACCOMPANIMENT_DUPLICATED = "menuAccompanimentDuplicated";
export const MENU_ACCOMPANIMENT_DUPLICATED_DESCRIPTION =
  "menuAccompanimentDuplicatedDescription";

//USERS
export const USERS_TITLE = "usersTitle";
export const USERS_DESCRIPTION = "usersDescription";
export const USERS_TABS_ARIA_LABEL = "usersTabsAriaLabel";
export const USERS_PORTAL_TAB = "usersPortalTab";
export const USERS_CONTACTS_TAB = "usersContactsTab";
export const USERS_EMAIL_DUPLICATE = "usersEmailDuplicate";
export const USERS_USER_CREATED = "usersUserCreated";
export const USERS_USER_SAVED = "usersUserSaved";
export const USERS_USER_DELETE_CONFIRMATION_TITLE =
  "usersUserDeleteConfirmationTitle";
export const USERS_USER_DELETE_CONFIRMATION_DESCRIPTION =
  "usersUserDeleteConfirmationDescription";
export const USERS_USER_DELETING = "usersUserDeleting";
export const USERS_USER_DELETED = "usersUserDeleted";
export const USERS_LIMIT_REACHED = "usersLimitReached";
export const ADVERTISERS_LIMIT_REACHED = "advertisersLimitReached";
export const USERS_ONBOARDING_FINISH = "usersOnboardingFinish";
export const USERS_USER_SEARCH_BAR_PLACEHOLDER =
  "usersUserSearchBarPlaceholder";
export const USERS_TABLE_ARIA_LABEL = "usersTableAriaLabel";
export const USERS_TABLE_COLUMN_NAME = "usersTableColumnName";
export const USERS_TABLE_COLUMN_EMAIL = "usersTableColumnEmail";
export const USERS_TABLE_COLUMN_STORE = "usersTableColumnStore";
export const USERS_TABLE_COLUMN_ROLE = "usersTableColumnRole";
export const MODAL_USER_ARIA_LABEL = "modalUserAriaLabel";
export const MODAL_USER_TITLE = "modalUserTitle";
export const MODAL_USER_TITLE_EDIT = "modalUserTitleEdit";
export const MODAL_USER_DESCRIPTION = "modalUserDescription";
export const MODAL_USER_DESCRIPTION_EDIT = "modalUserDescriptionEdit";
export const MODAL_USER_NAME_PLACEHOLDER = "modalUserNamePlaceholder";
export const MODAL_USER_ROLE_PLACEHOLDER = "modalUserRolePlaceholder";
export const MODAL_USER_ROLE_OPERATOR_EXPLANATION =
  "modalUserRoleOperatorExplanation";
export const MODAL_USER_STORE_PLACEHOLDER = "modalUserStorePlaceholder";
export const MODAL_USER_PASSWORD_PLACEHOLDER = "modalUserPasswordPlaceholder";
export const MODAL_USER_REPEAT_PASSWORD_PLACEHOLDER =
  "modalUserRepeatPasswordPlaceholder";
export const USERS_CONTACT_CREATED = "usersContactCreated";
export const USERS_CONTACT_SAVED = "usersContactSaved";
export const USERS_CONTACT_DELETE_CONFIRMATION_TITLE =
  "usersContactDeleteConfirmationTitle";
export const USERS_CONTACT_DELETE_CONFIRMATION_DESCRIPTION =
  "usersContactDeleteConfirmationDescription";
export const USERS_CONTACT_DELETED = "usersContactDeleted";
export const USERS_CONTACT_SEARCH_BAR_PLACEHOLDER =
  "usersContactSearchBarPlaceholder";
export const USERS_CONTACT_TABLE_ARIA_LABEL = "usersContactTableAriaLabel";
export const USERS_CONTACT_TABLE_COLUMN_PHONE = "usersContactTableColumnPhone";
export const MODAL_CONTACT_ARIA_LABEL = "modalContactAriaLabel";
export const MODAL_CONTACT_TITLE = "modalContactTitle";
export const MODAL_CONTACT_TITLE_EDIT = "modalContactTitleEdit";
export const MODAL_CONTACT_DESCRIPTION = "modalContactDescription";
export const MODAL_CONTACT_DESCRIPTION_EDIT = "modalContactDescriptionEdit";
export const MODAL_CONTACT_PHONE_PLACEHOLDER = "modalContactPhonePlaceholder";

//BILLING AND PAYMENTS
export const BILLING_AND_PAYMENTS_TITLE = "billingAndPaymentsTitle";
export const BILLING_AND_PAYMENTS_DESCRIPTION = "billingAndPaymentsDescription";
export const BILLING_AND_PAYMENTS_TABLE_ARIA_LABEL =
  "billingAndPaymentsTableAriaLabel";
export const BILLING_AND_PAYMENTS_TABLE_COLUMN_PAID_DATE =
  "billingAndPaymentsTableColumnPaidDate";
export const BILLING_AND_PAYMENTS_TABLE_COLUMN_DUE_DATE =
  "billingAndPaymentsTableColumnDueDate";
export const BILLING_AND_PAYMENTS_TABLE_COLUMN_VALUE =
  "billingAndPaymentsTableColumnValue";
export const BILLING_AND_PAYMENTS_TABLE_COLUMN_REASON =
  "billingAndPaymentsTableColumnReason";
export const BILLING_AND_PAYMENTS_TABLE_COLUMN_STATUS =
  "billingAndPaymentsTableColumnStatus";
export const STORAGE_USAGE_TITLE = "storageUsageTitle";
export const STORAGE_USAGE_LABEL = "storageUsageLabel";
export const STORAGE_FULL_TITLE = "storageFullTitle";
export const STORAGE_FULL_MESSAGE = "storageFullMessage";
export const STORAGE_FULL_BUTTON_DELETE = "storageFullButtonDelete";
export const STORAGE_FULL_BUTTON_UPGRADE = "storageFullButtonUpgrade";
export const PAYMENT_REASON_COLLABORATION = "paymentReasonCollaboration";
export const PAYMENT_REASON_APPLICANT = "paymentReasonApplicant";
export const PAYMENT_REASON_CLAPP_CREDITS = "paymentReasonClappCredits";
export const PAYMENT_REASON_SUBSCRIPTION_PRO = "paymentReasonSubscriptionPro";
export const PAYMENT_REASON_PACKAGE = "paymentReasonPackage";
export const PAYMENT_REASON_PLAN = "paymentReasonPlan";
export const PAYMENT_PAID = "paymentPaid";
export const PAYMENT_PENDING = "paymentPending";
export const MODAL_INVOICE_ARIA_LABEL = "modalInvoiceAriaLabel";
export const MODAL_INVOICE_TITLE = "modalInvoiceTitle";
export const MODAL_INVOICE_DISCLAIMER = "modalInvoiceDisclaimer";
export const MODAL_INVOICE_CREDITS = "modalInvoiceCredits";
export const MODAL_INVOICE_NUMBER_CREDITS = "modalInvoiceNumberCredits";
export const PURCHASE_CREDITS = "purchaseCredits";
export const PURCHASE_VIDEOS = "purchaseVideos";
export const PURCHASE_X_CREDITS = "purchaseXCredits";
export const MODAL_INVOICE_PLAN_ENTERPRISE_WITH_CREDITS =
  "modalInvoicePlanEnterpriseWithCredits";
export const MODAL_INVOICE_SUBSCRIPTION = "modalInvoiceSubscription";
export const MODAL_INVOICE_LICENSE = "modalInvoiceLicense";
export const MODAL_INVOICE_COLLABORATION = "modalInvoiceCollaboration";
export const MODAL_INVOICE_APPLICANT = "modalInvoiceApplicant";
export const MODAL_INVOICE_FEE = "modalInvoiceFee";
export const MODAL_INVOICE_IVA = "modalInvoiceIva";
export const MODAL_INVOICE_ORDER_TO_COLLECT = "modalInvoiceOrderToCollect";
export const MODAL_INVOICE_APPLICANT_CAMPAIGN_PAID =
  "modalInvoiceApplicantCampaignPaid";
export const MODAL_PAY_INVOICE_ARIA_LABEL = "modalPayInvoiceAriaLabel";
export const MODAL_PAY_INVOICE_TITLE = "modalPayInvoiceTitle";
export const MODAL_PAY_INVOICE_WILL_PAY = "modalPayInvoiceWillPay";
export const MODAL_PAY_SUBSCRIPTION_PENDING_INVOICE_MESSAGE =
  "modalPaySubscriptionPendingInvoiceMessage";
export const MODAL_PAY_SUBSCRIPTION_PAY_NOW = "modalPaySubscriptionPayNow";
export const MODAL_PAY_SUBSCRIPTION_PENDING_PAYMENT_TITLE =
  "modalPaySubscriptionPendingPaymentTitle";
export const BILLING_PENDING_SUBSCRIPTION_PAYMENT_DESCRIPTION =
  "billingPendingSubscriptionPaymentDescription";
export const BILLING_AND_PAYMENT_PLAN_DEACTIVATE =
  "billingAndPaymentPlanDeactivate";
export const BILLING_AND_PAYMENT_PLAN_CANCELLED =
  "billingAndPaymentPlanCancelled";
export const BILLING_AND_PAYMENT_PLAN_TRIAL = "billingAndPaymentPlanTrial";
export const BILLING_AND_PAYMENT_PLAN_TRIAL_DESCRIPTION =
  "billingAndPaymentPlanTrialDescription";
export const BILLING_AND_PAYMENT_CHANGE_YOUR_PLAN =
  "billingAndPaymentChangeYourPlan";
export const BILLING_AND_PAYMENT_ACTIVATE_PLAN =
  "billingAndPaymentActivatePlan";
export const BILLING_AND_PAYMENT_SELECT_PLAN = "billingAndPaymentSelectPlan";
export const BILLING_AND_PAYMENT_NO_HAVE_PLAN = "billingAndPaymentNoHavePlan";
export const BILLING_AND_PAYMENT_PLAN_EXPIRED = "billingAndPaymentPlanExpired";
export const BILLING_AND_PAYMENT_PLAN_NAME = "billingAndPaymentPlanName";
export const BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_TITLE =
  "billingAndPaymentModelUsageCollaborationTitle";
export const BILLING_AND_PAYMENT_MODEL_USAGE_COLLABORATION_COST =
  "billingAndPaymentModelUsageCollaborationCost";
export const BILLING_AND_PAYMENT_MODEL_USAGE_WHAT_BENEFITS =
  "billingAndPaymentModelUsageWhatBenefits";
export const BILLING_AND_PAYMENT_MODEL_USAGE_SHOW_BENEFTIS =
  "billingAndPaymentModelUsageShowBenefits";
export const BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT1 =
  "billingAndPaymentModelUsageBenefit1";
export const BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT2 =
  "billingAndPaymentModelUsageBenefit2";
export const BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT3 =
  "billingAndPaymentModelUsageBenefit3";
export const BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT4 =
  "billingAndPaymentModelUsageBenefit4";
export const BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT5 =
  "billingAndPaymentModelUsageBenefit5";
export const BILLING_AND_PAYMENT_MODEL_USAGE_BENEFIT6 =
  "billingAndPaymentModelUsageBenefit6";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_NAME =
  "billingAndPaymentModelPackageName";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_CHANGE =
  "billingAndPaymentModelPackageChange";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_COLLECT_COST_COLLABORATION =
  "billingAndPaymentModelPackageCollectCostCollaboration";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_ADD_PAYMENT_METHOD_TO_ACTIVATE =
  "billingAndPaymentModelPackageAddPaymentMethodToActivate";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_EXPIRED =
  "billingAndPaymentModelPackageExpired";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_NO_HAVE_PACKAGE =
  "billingAndPaymentModelPackageNoHavePackage";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_ACTIVATE_PACKAGE =
  "billingAndPaymentModelPackageActivatePackage";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_SELECT_PACKAGE =
  "billingAndPaymentModelPackageSelectPackage";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_PACKAGE =
  "billingAndPaymentModelPackageCancelPackage";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_WHAT_BENEFITS =
  "billingAndPaymentModelPackageWhatBenefits";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_COST_COLLABORATION =
  "billingAndPaymentModelPackageCostCollaboration";
export const BILLING_AND_PAYMENT_MODEL_PACKAGE_CANCEL_DISCLAIMER =
  "billingAndPaymentModelPackageCancelDisclaimer";
export const MODAL_SELECT_PACKAGE_ARIA_LABEL = "modalSelectPackageAriaLabel";
export const MODAL_SELECT_CREDITS_ARIA_LABEL = "modalSelectCreditsAriaLabel";
export const MODAL_SELECT_PACKAGE_AND_PAYMENT_METHOD_REQUIRED =
  "modalSelectPackageAndPaymentMethodRequired";
export const MODAL_SELECT_PACKAGE_UPLOAD_GROWTH =
  "modalSelectPackageUploadGrowth";
export const MODAL_SELECT_PACKAGE_PRICING_HERO_TITLE =
  "modalSelectPackagePricingHeroTitle";
export const MODAL_SELECT_PACKAGE_PRICING_DISCOVER_BUZZLY =
  "modalSelectPackagePricingDiscoverBuzzly";
export const MODAL_SELECT_PACKAGE_UPLOAD_GROWTH_DESCRIPTION =
  "modalSelectPackageUploadGrowthDescription";
export const MODAL_SELECT_PACKAGE_PRICING_HERO_DESCRIPTION =
  "modalSelectPackagePricingHeroDescription";
export const MODAL_SELECT_PACKAGE_VALUE_EXPRESSED =
  "modalSelectPackageValueExpressed";
export const MODAL_SELECT_PACKAGE_PRICE = "modalSelectPackagePrice";
export const MODAL_SELECT_PACKAGE_LICENSED_FEE_ENTERPRISE =
  "modalSelectPackageLicensedFeeEnterprise";
export const MODAL_SELECT_PACKAGE_CONTENT_ENTERPRISE =
  "modalSelectPackageContentEnterprise";
export const MODAL_SELECT_PACKAGE_LICENSED_FEE =
  "modalSelectPackageLicensedFee";
export const MODAL_SELECT_PACKAGE_LICENSED_PRICE =
  "modalSelectPackageLicensedPrice";
export const MODAL_SELECT_PACKAGE_PRICE_UPLOAD_GROWTH =
  "modalSelectPackagePriceUploadGrowth";
export const MODAL_SELECT_PACKAGE_ACCORDING_TO_THE_REQUIREMENT =
  "modalSelectPackageAccordingToTheRequirement";
export const MODAL_SELECT_PACKAGE_BUY_PACKAGE_NAME =
  "modalSelectPackageBuyPackageName";
export const MODAL_SELECT_PACKAGE_COST_CONTENT =
  "modalSelectPackageCostContent";
export const MODAL_SELECT_PACKAGE_COST_COLLABORATION =
  "modalSelectPackageCostCollaboration";
export const MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT_WITH_CREATORS =
  "modalSelectPackageBenefitDirectChatWithCreators";
export const MODAL_SELECT_PACKAGE_BENEFIT_CONTENT_CURATION =
  "modalSelectPackageBenefitContentCuration";
export const MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_PUBLICATION_PLATFORM =
  "modalSelectPackageBenefitDirectPublicationPlatform";
export const MODAL_SELECT_PACKAGE_BENEFIT_COLLABORATE_WITH_CREATOR =
  "modalSelectPackageBenefitCollaborateWithCreator";
export const MODAL_SELECT_PACKAGE_BENEFIT_LAUNCH_CAMPAIGNS =
  "modalSelectPackageBenefitLaunchCampaigns";
export const MODAL_SELECT_PACKAGE_BENEFIT_DOWNLOAD_CONTENT =
  "modalSelectPackageBenefitDownloadContent";
export const MODAL_SELECT_PACKAGE_BENEFIT_ANALYZE_METRICS =
  "modalSelectPackageBenefitAnalyzeMetrics";
export const MODAL_SELECT_PACKAGE_BENEFIT_CATALOG =
  "modalSelectPackageBenefitCatalog";
export const MODAL_SELECT_PACKAGE_BENEFIT_AUTOMATIZATION =
  "modalSelectPackageBenefitAutomatization";
export const MODAL_SELECT_PACKAGE_BENEFIT_SUPPORT_TICKETS =
  "modalSelectPackageBenefitSupportTickets";
export const MODAL_SELECT_PACKAGE_BENEFIT_ALL_BASIC =
  "modalSelectPackageBenefitAllBasic";
export const MODAL_SELECT_PACKAGE_BENEFIT_KAM = "modalSelectPackageBenefitKam";
export const MODAL_SELECT_PACKAGE_BENEFIT_VOLUME_CONTENT =
  "modalSelectPackageBenefitVolumeContent";
export const MODAL_SELECT_PACKAGE_BENEFIT_DISCOVERY =
  "modalSelectPackageBenefitDiscovery";
export const MODAL_SELECT_PACKAGE_BENEFIT_DIRECT_CHAT =
  "modalSelectPackageBenefitDirectChat";
export const MODAL_SELECT_PACKAGE_BENEFIT_ASSISTANCE_MARKETING =
  "modalSelectPackageBenefitAssistanceMarketing";
export const MODAL_SELECT_PACKAGE_BENEFIT_ALL_GROWTH =
  "modalSelectPackageBenefitAllGrowth";
export const MODAL_SELECT_PACKAGE_BENEFIT_BRANDS_UNLIMITED =
  "modalSelectPackageBenefitBrandsUnlimited";
export const MODAL_SELECT_PACKAGE_BENEFIT_PERSONALIZED_INTEGRATIONS =
  "modalSelectPackageBenefitPersonalizedIntegrations";
export const MODAL_SELECT_PACKAGE_BENEFIT_IMPLEMENTATIONS_TECHNOLOGICAL =
  "modalSelectPackageBenefitImplementationsTechnological";
export const MODAL_SELECT_PACKAGE_BENEFIT_PRIORITIZED_SUPPORT =
  "modalSelectPackageBenefitPrioritizedSupport";
export const MODAL_SUBSCRIPTION_PRO_ARIA_LABEL =
  "modalSubscriptionProAriaLabel";
export const MODAL_SUBSCRIPTION_PRO_TITLE_HERO =
  "modalSubscriptionProTitleHero";
export const MODAL_SUBSCRIPTION_PRO_DESCRIPTION_HERO =
  "modalSubscriptionProDescriptionHero";
export const MODAL_SUBSCRIPTION_PRO_TITLE = "modalSubscriptionProTitle";
export const MODAL_SUBSCRIPTION_PRO_SUB_HEADER =
  "modalSubscriptionProSubHeader";
export const MODAL_SUBSCRIPTION_PRO_BENEFIT_1 = "modalSubscriptionProBenefit1";
export const MODAL_SUBSCRIPTION_PRO_BUY_BUTTON =
  "modalSubscriptionProBuyButton";

//PACKAGES
export const ADS_SUBSCRIPTION_TITLE = "adsSubscriptionTitle";
export const ADS_SUBSCRIPTION_DESCRIPTION = "adsSubscriptionDescription";
export const SPEND_FEE = "spendFee";

//PRICING
export const PRICING_HERO_TITLE_PACKAGES = "pricingHeroTitlePackages";
export const PRICING_HERO_TITLE_CREDITS = "pricingHeroTitleCredits";
export const PRICING_HERO_DESCRIPTION = "pricingHeroDescription";
export const PRICING_APPSUMO_CREDITS_STACK_TITLE =
  "pricingAppSumoCreditsStackTitle";
export const PRICING_APPSUMO_CREDITS_STACK_DESCRIPTION =
  "pricingAppSumoCreditsStackDescription";
export const PRICING_CREDIT_USAGE_TITLE = "pricingCreditUsageTitle";
export const PRICING_CREDIT_USAGE_CAMPAIGN = "pricingCreditUsageCampaign";
export const PRICING_CREDIT_USAGE_IMAGE = "pricingCreditUsageImage";
export const PRICING_CREDIT_USAGE_VIDEO = "pricingCreditUsageVideo";
export const PRICING_CREDIT_USAGE_ANIMATE_IMAGE =
  "pricingCreditUsageAnimateImage";
export const PRICING_CREDIT_USAGE_ANALYZE_IMAGE_LAYERS =
  "pricingCreditUsageAnalyzeImageLayers";
export const PRICING_CREDIT_USAGE_CUSTOM_REPORT =
  "pricingCreditUsageCustomReport";
export const PRICING_CREDIT_USAGE_CUSTOM_REPORT_DECK =
  "pricingCreditUsageCustomReportDeck";
export const PRICING_CREDIT_USAGE_OPTIMIZATION =
  "pricingCreditUsageOptimization";
export const PRICING_CREDIT_USAGE_SCHEDULED_POST =
  "pricingCreditUsageScheduledPost";
export const PRICING_CREDIT_USAGE_PER = "pricingCreditUsagePer";
export const PRICING_CREDIT_USAGE_CREDIT = "pricingCreditUsageCredit";
export const PRICING_CREDIT_USAGE_CREDITS = "pricingCreditUsageCredits";
export const CREDIT_COST_ITEM = "creditCostItem";
export const ADS_SUBSCRIPTION_CREDITS_BENEFIT = "adsSubscriptionCreditsBenefit";
export const ADS_SUBSCRIPTION_CREDITS_MONTHLY_BENEFIT =
  "adsSubscriptionCreditsMonthlyBenefit";
export const ADS_SUBSCRIPTION_CREDITS_QUARTERLY_BENEFIT =
  "adsSubscriptionCreditsQuarterlyBenefit";
export const ADS_SUBSCRIPTION_CREDITS_SEMIANNUALLY_BENEFIT =
  "adsSubscriptionCreditsSemiannuallyBenefit";
export const ADS_SUBSCRIPTION_CREDITS_YEARLY_BENEFIT =
  "adsSubscriptionCreditsYearlyBenefit";
export const ADS_SUBSCRIPTION_COINS_BENEFIT = "adsSubscriptionCoinsBenefit";
export const ADS_SUBSCRIPTION_BENEFIT_PLATFORMS_CAMPAIGNS =
  "adsSubscriptionBenefitPlatformsCampaigns";
export const ADS_SUBSCRIPTION_BENEFIT_CAMPAIGNS =
  "adsSubscriptionBenefitCampaigns";
export const ADS_SUBSCRIPTION_BENEFIT_CAMPAIGN =
  "adsSubscriptionBenefitCampaign";
export const ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS =
  "adsSubscriptionBenefitAdvertisers";
export const ADS_SUBSCRIPTION_BENEFIT_ADVERTISER =
  "adsSubscriptionBenefitAdvertiser";
export const ADS_SUBSCRIPTION_BENEFIT_CREATIVES =
  "adsSubscriptionBenefitCreatives";
export const ADS_SUBSCRIPTION_ENTERPRISE_CAMPAIGNS_CUSTOM =
  "adsSubscriptionEnterpriseCampaignsCustom";
export const ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_CUSTOM =
  "adsSubscriptionBenefitAdvertisersCustom";
export const ADS_SUBSCRIPTION_BENEFIT_CREATIVES_CUSTOM =
  "adsSubscriptionBenefitCreativesCustom";
export const ADS_SUBSCRIPTION_BENEFIT_VIDEOS = "adsSubscriptionBenefitVideos";
export const ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_MONTH =
  "adsSubscriptionBenefitCreditsPerMonth";
export const ADS_SUBSCRIPTION_BENEFIT_VIDEOS_AI =
  "adsSubscriptionBenefitVideosAi";
export const ADS_SUBSCRIPTION_BENEFIT_ADVERTISERS_UP_TO =
  "adsSubscriptionBenefitAdvertisersUpTo";
export const ADS_SUBSCRIPTION_BENEFIT_USERS_UP_TO =
  "adsSubscriptionBenefitUsersUpTo";
export const ADS_SUBSCRIPTION_BENEFIT_USER = "adsSubscriptionBenefitUser";
export const ADS_SUBSCRIPTION_BENEFIT_UNLIMITED_SOCIAL_POSTS =
  "adsSubscriptionBenefitUnlimitedSocialPosts";
export const ADS_SUBSCRIPTION_BENEFIT_SUPPORT_CHAT_AND_EMAIL =
  "adsSubscriptionBenefitSupportChatAndEmail";
export const ADS_SUBSCRIPTION_BENEFIT_WHITE_LABEL_OPTIONAL =
  "adsSubscriptionBenefitWhiteLabelOptional";

export const ADS_SUBSCRIPTION_BENEFIT_OPTIMIZATIONS =
  "adsSubscriptionBenefitOptimizations";
export const ADS_SUBSCRIPTION_BENEFIT_AI_CAMPAIGNS =
  "adsSubscriptionBenefitMultiPlatformManagement";
export const ADS_SUBSCRIPTION_BENEFIT_AI_AUDIENCE_SEGMENTATION =
  "adsSubscriptionBenefitAIAudienceSegmentation";
export const ADS_SUBSCRIPTION_BENEFIT_AI_CONTENT =
  "adsSubscriptionBenefitAILocationsSelector";
export const ADS_SUBSCRIPTION_BENEFIT_POSTS =
  "adsSubscriptionBenefitAITextsAndCopys";
export const ADS_SUBSCRIPTION_BENEFIT_AI_ADVANCED_INSIGHTS_AND_REPORTS =
  "adsSubscriptionBenefitAIAdvancedInsightsAndReports";
export const ADS_SUBSCRIPTION_BENEFIT_USERS = "adsSubscriptionBenefitUsers";
export const ADS_SUBSCRIPTION_BENEFIT_STORAGE = "adsSubscriptionBenefitStorage";
export const ADS_SUBSCRIPTION_BENEFIT_STORAGE_CUSTOM =
  "adsSubscriptionBenefitStorageCustom";
export const ADS_SUBSCRIPTION_BENEFIT_EMAIL_SUPPORT =
  "adsSubscriptionBenefitEmailSupport";
export const ADS_SUBSCRIPTION_BENEFIT_CHAT_SUPPORT =
  "adsSubscriptionBenefitChatSupport";
export const ADS_SUBSCRIPTION_BENEFIT_PRIORITY_SUPPORT =
  "adsSubscriptionBenefitPrioritySupport";
export const ADS_SUBSCRIPTION_BENEFIT_DEDICATED_ACCOUNT_MANAGER =
  "adsSubscriptionBenefitDedicatedAccountManager";

//BILLING DATA
export const BILLING_DATA_TITLE = "billingDataTitle";
export const BILLING_DATA_DESCRIPTION = "billingDataDescription";
export const BILLING_DATA_SAVED = "billingDataSaved";
export const BILLING_DATA_PERSONAL_INFORMATION_DESCRIPTION =
  "billingDataPersonalInformationDescription";
export const BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_PLACEHOLDER =
  "billingDataPersonalInformationTypePersonPlaceholder";
export const BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_NATURE_OPTION =
  "billingDataPersonalInformationTypePersonNatureOption";
export const BILLING_DATA_PERSONAL_INFORMATION_TYPE_PERSON_LEGAL_OPTION =
  "billingDataPersonalInformationTypePersonLegalOption";
export const BILLING_DATA_PERSONAL_INFORMATION_BUSINESS_NAME_PLACEHOLDER =
  "billingDataPersonalInformationBusinessNamePlaceholder";
export const BILLING_DATA_PERSONAL_INFORMATION_NAME_PLACEHOLDER =
  "billingDataPersonalInformationNamePlaceholder";
export const BILLING_DATA_PERSONAL_INFORMATION_LAST_NAME_PLACEHOLDER =
  "billingDataPersonalInformationLastNamePlaceholder";
export const BILLING_DATA_PERSONAL_INFORMATION_TYPE_ID_PLACEHOLDER =
  "billingDataPersonalInformationTypeIdPlaceholder";
export const BILLING_DATA_PERSONAL_INFORMATION_ID_NUMBER_PLACEHOLDER =
  "billingDataPersonalInformationIdNumberPlaceholder";
export const BILLING_DATA_CONTACT_INFORMATION_DESCRIPTION =
  "billingDataContactInformationDescription";
export const BILLING_DATA_CONTACT_INFORMATION_EMAIL_BILLING_PLACEHOLDER =
  "billingDataContactInformationEmailBillingPlaceholder";
export const BILLING_DATA_CONTACT_INFORMATION_ADDRESS_PLACEHOLDER =
  "billingDataContactInformationAddressPlaceholder";
export const BILLING_DATA_CONTACT_INFORMATION_PHONE_PLACEHOLDER =
  "billingDataContactInformationPhonePlaceholder";

export const MODAL_FREE_TRIAL_TITLE = "modalFreeTrialTitle";
export const MODAL_FREE_TRIAL_DESCRIPTION = "modalFreeTrialDescription";
export const MODAL_FREE_TRIAL_CAPTION = "modalFreeTrialCaption";
export const MODAL_FREE_TRIAL_BUTTON = "modalFreeTrialButton";
export const MODAL_FREE_TRIAL_START_ALERT_DESCRIPTION =
  "modalFreeTrialStartAlertDescription";

export const TRIAL_CONFIGURING_EXPERIENCE = "trialConfiguringExperience";
export const TRIAL_PREPARING_PLATFORM = "trialPreparingPlatform";
export const TRIAL_RETRY_ACCESS = "trialRetryAccess";

export const BLOCK_PAYMENT_FAILED_TITLE = "blockPaymentFailedTitle";
export const BLOCK_TRIAL_END_TITLE = "blockTrialEndTitle";
export const BLOCK_PACKAGE_TITLE = "blockPackageTitle";
export const BLOCK_PACKAGE_DESCRIPTION = "blockPackageDescription";
export const BLOCK_PLAN_BUTTON = "blockPlanButton";
export const BLOCK_PLAN_BUTTON_ACTIVATE_PLAN = "blockPlanButtonActivatePlan";
export const BLOCK_TRIAL_ACTIVE_TITLE = "blockTrialActiveTitle";
export const BLOCK_TRIAL_ACTIVE_DESCRIPTION = "blockTrialActiveDescription";
export const BLOCK_TRIAL_ACTIVE_BUTTON = "blockTrialActiveButton";
export const BLOCK_CONTACT_YOUR_ADMINISTRATOR_TITLE =
  "blockContactYourAdministratorTitle";

export const MODAL_DISSATISFACTION_COLLABORATION_TITLE =
  "modalDissatisfactionCollaborationTitle";
export const MODAL_DISSATISFACTION_COLLABORATION_DESCRIPTION =
  "modalDissatisfactionCollaborationDescription";
export const MODAL_DISSATISFACTION_COLLABORATION_BUTTON =
  "modalDissatisfactionCollaborationButton";
export const MODAL_DISSATISFACTION_COLLABORATION_EXPLANATION_CREDIT =
  "modalDissatisfactionCollaborationExplanationCredit";
export const MODAL_DISSATISFACTION_COLLABORATION_CREDIT_RECEIVED =
  "modalDissatisfactionCollaborationCreditReceived";

export const MODAL_BUY_CREDITS_ARIA_LABEL = "modalBuyCreditsAriaLabel";
export const MODAL_BUY_CREDITS_TITLE = "modalBuyCreditsTitle";
export const MODAL_BUY_CREDITS_DESCRIPTION = "modalBuyCreditsDescription";
export const MODAL_BUY_CREDITS_CREDIT_FOR_COLLABORATION =
  "modalBuyCreditsCreditForCollaboration";
export const MODAL_BUY_CREDITS_HOW_MANY_CREDITS_BUY =
  "modalBuyCreditsHowManyCreditsBuy";
export const MODAL_BUY_CREDITS_REDEEMED_ESTIMATED_TIME =
  "modalBuyCreditsRedeemedEstimatedTime";
export const MODAL_BUY_CREDITS_ADDITIONAL_CREDITS =
  "modalBuyCreditsAdditionalCredits";
export const MODAL_BUY_CREDITS_LAST_TEXT_PAY = "modalBuyCreditsLastTextPay";
export const MODAL_BUY_CREDITS_AMOUNT_FOR_PRICE =
  "modalBuyCreditsAmountForPrice";
export const MODAL_BUY_CREDITS_GIFT_CREDITS = "modalBuyCreditsGiftCredits";
export const MODAL_BUY_CREDITS_AND_PAYMENT_METHOD_REQUIRED =
  "modalBuyCreditsAndPaymentMethodRequired";
export const MODAL_BUY_CREDITS_NEGATIVE = "modalBuyCreditsNegative";
export const MODAL_BUY_CREDITS_PURCHASED = "modalBuyCreditsPurchased";
export const MODAL_BUY_CREDITS_PURCHASED_DESCRIPTION =
  "modalBuyCreditsPurchasedDescription";
export const MODAL_BUY_VIDEOS_PURCHASED = "modalBuyVideosPurchased";
export const MODAL_BUY_VIDEOS_PURCHASED_DESCRIPTION =
  "modalBuyVideosPurchasedDescription";

//MODAL ADD BRAND SUPER ADMIN
export const MODAL_ADD_BRAND_SUPER_ADMIN_TITLE = "modalAddBrandSuperAdminTitle";

//MODAL UPLOAD CUSTOM AUDIENCES GOOGLE
export const MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_TITLE =
  "modalUploadCustomAudiencesGoogleTitle";
export const MODAL_UPLOAD_CUSTOM_AUDIENCES_GOOGLE_DESCRIPTION =
  "modalUploadCustomAudiencesGoogleDescription";

//MODAL INSTANT EXPERIENCE CREATE
export const MODAL_INSTANT_EXPERIENCE_CREATE_TITLE =
  "modalInstantExperienceCreateTitle";
export const MODAL_INSTANT_EXPERIENCE_CREATE_DESCRIPTION =
  "modalInstantExperienceCreateDescription";

//LOGIN
export const FORGOT_PASSWORD = "forgotPassword";
export const NO_HAVE_ACCOUNT = "noHaveAccount";
export const REGISTER_HERE = "registerHere";
export const ALREADY_HAVE_AN_ACCOUNT = "alreadyHaveAnAccount";
export const LOG_IN = "logIn";
export const RESET_PASSWORD_EMAIL_SENT = "resetPasswordEmailSent";

//AUTH LAYOUT (MARKETING PANEL)
export const AUTH_LAYOUT_HERO_TITLE = "authLayoutHeroTitle";
export const AUTH_LAYOUT_HERO_DESCRIPTION = "authLayoutHeroDescription";
export const AUTH_LAYOUT_PREVIEW_PLACEHOLDER = "authLayoutPreviewPlaceholder";
export const AUTH_LAYOUT_PREVIEW_IMAGE_ALT = "authLayoutPreviewImageAlt";
export const AUTH_LAYOUT_FEATURE_AI_TITLE = "authLayoutFeatureAiTitle";
export const AUTH_LAYOUT_FEATURE_AI_DESCRIPTION =
  "authLayoutFeatureAiDescription";
export const AUTH_LAYOUT_FEATURE_ANALYTICS_TITLE =
  "authLayoutFeatureAnalyticsTitle";
export const AUTH_LAYOUT_FEATURE_ANALYTICS_DESCRIPTION =
  "authLayoutFeatureAnalyticsDescription";
export const AUTH_LAYOUT_FEATURE_SCHEDULING_TITLE =
  "authLayoutFeatureSchedulingTitle";
export const AUTH_LAYOUT_FEATURE_SCHEDULING_DESCRIPTION =
  "authLayoutFeatureSchedulingDescription";

//RESET PASSWORD
export const RESET_PASSWORD = "resetPassword";
export const RESET_PASSWORD_GET_TOKEN_FAILED = "resetPasswordGetTokenFailed";
export const RESET_PASSWORD_SAVED = "resetPasswordSaved";

//COMPLETE REGISTRATION
export const SET_PASSWORD = "setPassword";

//REGISTER
export const REGISTER_COUNTRY_ANSWER = "registerCountryAnswer";
export const REGISTER_COUNTRY_PLACEHOLDER = "registerCountryPlaceholder";
export const REGISTER_NAME_ANSWER = "registerNameAnswer";
export const REGISTER_PHONE_ANSWER = "registerPhoneAnswer";
export const REGISTER_EMAIL_ANSWER = "registerEmailAnswer";
export const REGISTER_PASSWORD_ANSWER = "registerPasswordAnswer";
export const REGISTER_BUSINESS_NAME_ANSWER = "registerBusinessNameAnswer";
export const REGISTER_CATEGORY_ANSWER = "registerCategoryAnswer";
export const REGISTER_SOCIAL_NETWORK_ANSWER = "registerSocialNetworkAnswer";
export const REGISTER_SOCIAL_NETWORK_ANSWER_DESCRIPTION =
  "registerSocialNetworkAnswerDescription";
export const REGISTER_WEBSITE_ANSWER = "registerWebsiteAnswer";
export const REGISTER_WEBSITE_ANSWER_DESCRIPTION =
  "registerWebsiteAnswerDescription";
export const REGISTER_MONTHLY_SALES_ANSWER = "registerMonthlySalesAnswer";
export const REGISTER_BUDGET_MARKETING_ANSWER = "registerBudgetMarketingAnswer";
export const REGISTER_EMPLOYEES_ANSWER = "registerEmployeesAnswer";
export const REGISTER_PRODUCT_AVAILABILITY_ANSWER =
  "registerProductAvailabilityAnswer";
export const REGISTER_RUT_ANSWER = "registerRutAnswer";
export const REGISTER_INVIMA_ANSWER = "registerInvimaAnswer";
export const REGISTER_ICA_ANSWER = "registerIcaAnswer";
export const REGISTER_YOU_MEET_ANSWER = "registerYouMeetAnswer";
export const REGISTER_WRITE_PLACEHOLDER = "registerWritePlaceholder";
export const REGISTER_SELECT_PLACEHOLDER = "registerSelectPlaceholder";
export const REGISTER_COUNTRY_REQUIRED = "registerCountryRequired";
export const REGISTER_NAME_REQUIRED = "registerNameRequired";
export const REGISTER_PHONE_REQUIRED = "registerPhoneRequired";
export const REGISTER_PHONE_NUMERIC_REQUIRED = "registerPhoneNumericRequired";
export const REGISTER_BUSINESS_NAME_REQUIRED = "registerBusinessNameRequired";
export const REGISTER_CATEGORY_REQUIRED = "registerCategoryRequired";
export const REGISTER_SOCIAL_NETWORK_REQUIRED = "registerSocialNetworkRequired";
export const REGISTER_WEB_SITE_REQUIRED = "registerWebSiteRequired";
export const REGISTER_MONTHLY_SALES_REQUIRED = "registerMonthlySalesRequired";
export const REGISTER_BUDGET_MARKETING_REQUIRED =
  "registerBudgetMarketingRequired";
export const REGISTER_EMPLOYEES_REQUIRED = "registerEmployeesRequired";
export const REGISTER_PRODUCT_AVAILABILITY_REQUIRED =
  "registerProductAvailabilityRequired";
export const REGISTER_RUT_REQUIRED = "registerRutRequired";
export const REGISTER_INVIMA_REQUIRED = "registerInvimaRequired";
export const REGISTER_ICA_REQUIRED = "registerIcaRequired";
export const REGISTER_YOU_MEET_REQUIRED = "registerYouMeetRequired";
export const REGISTER_NO_HAVE_DOCUMENTS_ALERT_TITLE =
  "registerNoHaveDocumentsAlertTitle";
export const REGISTER_NO_HAVE_DOCUMENTS_ALERT_DESCRIPTION =
  "registerNoHaveDocumentsAlertDescription";
export const REGISTER_REGISTERED_ALERT_DESCRIPTION =
  "registerRegisteredAlertDescription";
export const PLEASE_SELECT_COUNTRY = "pleaseSelectCountry";
export const REGISTER_PROFILE_CREATOR_CITIES_ANSWER =
  "registerProfileCreatorCitiesAnswer";
export const REGISTER_PROFILE_CREATOR_PLATFORMS_ANSWER =
  "registerProfileCreatorPlatformsAnswer";
export const REGISTER_PROFILE_CREATOR_CATEGORIES_ANSWER =
  "registerProfileCreatorCategoriesAnswer";
export const REGISTER_PROFILE_CREATOR_GENDER_ANSWER =
  "registerProfileCreatorGenderAnswer";
export const REGISTER_PROFILE_CREATOR_AGE_ANSWER =
  "registerProfileCreatorAgeAnswer";
export const REGISTER_PROFILE_CREATOR_BODY_BUILD =
  "registerProfileCreatorBodyBuild";
export const REGISTER_PROFILE_CREATOR_CLOTHING_STYLE =
  "registerProfileCreatorClothingStyle";
export const REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES =
  "registerProfileCreatorDistinguishingFeatures";
export const REGISTER_PROFILE_CREATOR_CONTENT_STYLE =
  "registerProfileCreatorContentStyle";
export const REGISTER_PROFILE_CREATOR_CITIES_REQUIRED =
  "registerProfileCreatorCitiesRequired";
export const REGISTER_PROFILE_CREATOR_PLATFORMS_REQUIRED =
  "registerProfileCreatorPlatformsRequired";
export const REGISTER_PROFILE_CREATOR_CATEGORIES_REQUIRED =
  "registerProfileCreatorCategoriesRequired";
export const REGISTER_PROFILE_CREATOR_GENDER_REQUIRED =
  "registerProfileCreatorGenderRequired";
export const REGISTER_PROFILE_CREATOR_AGE_RANGE_REQUIRED =
  "registerProfileCreatorAgeRangeRequired";
export const REGISTER_PROFILE_CREATOR_BODY_BUILD_REQUIRED =
  "registerProfileCreatorBodyBuildRequired";
export const REGISTER_PROFILE_CREATOR_CLOTHING_STYLE_REQUIRED =
  "registerProfileCreatorClothingStyleRequired";
export const REGISTER_PROFILE_CREATOR_DISTINGUISHING_FEATURES_REQUIRED =
  "registerProfileCreatorDistinguishingFeaturesRequired";
export const REGISTER_PROFILE_CREATOR_CONTENT_STYLE_REQUIRED =
  "registerProfileCreatorContentStyleRequired";

//CHATS
export const CHAT_ERROR_SENT_MESSAGE = "chatErrorSentMessage";
export const CHAT_DO_PAYMENT = "chatDoPayment";
export const CHAT_WRITE_QUESTION_HERE = "chatWriteQuestionHere";
export const CHAT_WRITE_MESSAGE_HERE = "chatWriteMessageHere";
export const CHAT_EMAIL_NO_PERMITTED = "chatEmailNoPermitted";
export const CHAT_FIRST_MESSAGE_BOT = "chatFirstMessageBot";
export const CHAT_NO_MORE = "chatNoMore";
export const CHAT_DO_A_QUESTION = "chatDoAQuestion";
export const CHAT_ASK_A_QUESTION_ABOUT_YOUR_CAMPAIGN =
  "chatAskAQuestionAboutYourCampaign";
export const CHAT_CAMPAIGN_OPEN_AUTO_SUMMARY_QUESTION =
  "chatCampaignOpenAutoSummaryQuestion";
export const CHAT_CAMPAIGN_OPEN_ANALYZING_SUGGESTIONS =
  "chatCampaignOpenAnalyzingSuggestions";
export const CHAT_BOT_NAME = "chatBotName";
export const CHAT_BOT_DESCRIPTION = "chatBotDescription";
export const CHAT_BOT_WELCOME_MESSAGE = "chatBotWelcomeMessage";
export const CHAT_BOT_WELCOME_DESCRIPTION = "chatBotWelcomeDescription";
export const CHAT_BOT_WELCOME_MESSAGE_STATISTICS =
  "chatBotWelcomeMessageStatistics";
export const CHAT_BOT_WELCOME_DESCRIPTION_STATISTICS =
  "chatBotWelcomeDescriptionStatistics";
export const CHAT_BOT_WELCOME_MESSAGE_OWNER = "chatBotWelcomeMessageOwner";
export const CHAT_BOT_WELCOME_DESCRIPTION_OWNER =
  "chatBotWelcomeDescriptionOwner";
export const CHAT_ASK_A_QUESTION_OWNER = "chatAskAQuestionOwner";
// Owner dashboard chat cards (AdminDashboard)
export const CARD_OWNER_CLIENT_HEALTH = "cardOwnerClientHealth";
export const CARD_OWNER_CLIENT_HEALTH_DESCRIPTION =
  "cardOwnerClientHealthDescription";
export const CARD_OWNER_CLIENT_HEALTH_QUESTION =
  "cardOwnerClientHealthQuestion";
export const CARD_OWNER_CLIENTS_ACCOUNTS = "cardOwnerClientsAccounts";
export const CARD_OWNER_CLIENTS_ACCOUNTS_DESCRIPTION =
  "cardOwnerClientsAccountsDescription";
export const CARD_OWNER_CLIENTS_ACCOUNTS_QUESTION =
  "cardOwnerClientsAccountsQuestion";
export const CARD_OWNER_BRANDS = "cardOwnerBrands";
export const CARD_OWNER_BRANDS_DESCRIPTION = "cardOwnerBrandsDescription";
export const CARD_OWNER_BRANDS_QUESTION = "cardOwnerBrandsQuestion";
export const CARD_OWNER_PLANS_MRR = "cardOwnerPlansMrr";
export const CARD_OWNER_PLANS_MRR_DESCRIPTION = "cardOwnerPlansMrrDescription";
export const CARD_OWNER_PLANS_MRR_QUESTION = "cardOwnerPlansMrrQuestion";
export const CHAT_REASONING_ANALYZING_USER_MESSAGE =
  "chatReasoningAnalyzingUserMessage";
export const CHAT_REASONING_PROCESSING_CAMPAIGN_DATA =
  "chatReasoningProcessingCampaignData";
export const CHAT_REASONING_GETTING_PERFORMANCE_METRICS =
  "chatReasoningGettingPerformanceMetrics";
export const CHAT_REASONING_ANALYZING_BEST_PRACTICES =
  "chatReasoningAnalyzingBestPractices";
export const CHAT_REASONING_GENERATING_RECOMMENDATIONS =
  "chatReasoningGeneratingRecommendations";
export const CHAT_THINKING = "chatThinking";

//SUMMARY TEXT (CHAT)
export const CHAT_SUMMARY_OVERVIEW_TEXT = "chatSummaryOverviewText";

//NOTIFICATIONS
export const NOTIFICATIONS_TITLE = "notificationsTitle";
export const NOTIFICATIONS_MARK_READS = "notificationsMarkReads";
export const NOTIFICATIONS_EMPTY = "notificationsEmpty";
export const NOTIFICATIONS_NO_MORE = "notificationsNoMore";
export const NOTIFICATIONS_CHECK_NOTIFICATION =
  "notificationsCheckNotification";
export const ONE_SECOND_AGO = "oneSecondAgo";

//TRANSACTION
export const TRANSACTION_CONCEPT_LABEL = "transactionConceptLabel";
export const TRANSACTION_TYPE = "transactionType";
export const TRANSACTION_TYPE_CREDIT = "transactionTypeCredit";
export const TRANSACTION_TYPE_DEBIT = "transactionTypeDebit";
export const TRANSACTION_STATUS = "transactionStatus";
export const TRANSACTION_STATUS_PENDING = "transactionStatusPending";
export const TRANSACTION_STATUS_PENDING_RELEASE =
  "transactionStatusPendingRelease";
export const TRANSACTION_STATUS_IN_PROCESS_RELEASE =
  "transactionStatusInProcessRelease";
export const TRANSACTION_STATUS_RELEASED = "transactionStatusReleased";
export const TRANSACTION_STATUS_PENDING_SENT = "transactionStatusPendingSent";
export const TRANSACTION_IN_TRANSIT = "transactionInTransit";
export const TRANSACTION_STATUS_PAID = "transactionStatusPaid";
export const TRANSACTION_WAS_PAID = "transactionWasPaid";
export const MODAL_CREATE_TRANSACTION = "modalCreateTransaction";
export const MODAL_CREATE_TRANSACTION_AMOUNT_LABEL =
  "modalCreateTransactionAmountLabel";
export const MODAL_CREATE_TRANSACTION_CONCEPT_LABEL =
  "modalCreateTransactionConceptLabel";
export const MODAL_CREATE_TRANSACTION_CONCEPT_APPLICANT =
  "modalCreateTransactionConceptApplicant";
export const MODAL_CREATE_TRANSACTION_CONCEPT_ORDER =
  "modalCreateTransactionConceptOrder";
export const MODAL_CREATE_TRANSACTION_CONCEPT_REFERRAL =
  "modalCreateTransactionConceptReferral";
export const MODAL_CREATE_TRANSACTION_CONCEPT_ID =
  "modalCreateTransactionConceptId";

//CONTENT
export const CONTENT_TITLE = "contentTitle";

//CONTENT APPLICATION
export const CONTENT_APPLICATION_TITLE = "contentApplicationTitle";
export const CONTENT_APPLICATION_ACCEPT_TITLE = "contentApplicationAcceptTitle";
export const CONTENT_APPLICATION_ACCEPT_DESCRIPTION =
  "contentApplicationAcceptDescription";
export const CONTENT_APPLICATION_REJECT_TITLE = "contentApplicationRejectTitle";
export const CONTENT_APPLICATION_REJECT_DESCRIPTION =
  "contentApplicationRejectDescription";

//REPORTS
export const REPORTS_TITLE = "reportsTitle";
export const REPORTS_DESCRIPTION = "reportsDescription";
export const REPORTS_ERROR_GENERATING = "reportsErrorGenerating";
export const REPORTS_REQUESTS_ACTIVE = "reportsRequestsActive";
export const REPORTS_REQUESTS_INACTIVE = "reportsRequestsInactive";
export const REPORTS_TYPE_USERS = "reportsTypeUsers";
export const REPORTS_NUMBER_USERS = "reportsNumberUsers";
export const REPORTS_TYPE_ORDER = "reportsTypeOrder";
export const REPORTS_NUMBER_ORDER = "reportsNumberOrder";
export const REPORTS_MODAL_DESCRIPTION = "reportsModalDescription";
export const REPORTS_MODAL_ONLY_BRANDS_ACTIVE = "reportsModalOnlyBrandsActive";
export const REPORTS_MODAL_TYPE_REPORT_LABEL = "reportsModalTypeReportLabel";
export const REPORTS_MODAL_TYPE_REPORT_BRANDS = "reportsModalTypeReportBrands";
export const REPORTS_MODAL_TYPE_REPORT_CREATORS =
  "reportsModalTypeReportCreators";
export const REPORTS_MODAL_TYPE_REPORT_ORDERS = "reportsModalTypeReportOrders";

//SHOPIFY TERMS
export const INTEGRATIONS_TERMS_TITLE = "shopifyTermsTitle";
export const INTEGRATIONS_TERMS_DESCRIPTION = "shopifyTermsDescription";
export const INTEGRATIONS_TERMS_CONTENT = "shopifyTermsContent";

//AUTH TIK TOK
export const AUTH_TIKTOK_VERIFICATION_LOADING = "authTikTokVerificationLoading";
export const AUTH_TIKTOK_VERIFICATION_SUCCESS = "authTikTokVerificationSuccess";
export const AUTH_TIKTOK_VERIFICATION_FAILED = "authTikTokVerificationFailed";

//COLUMN NAMES
export const COLUMN_NAME_BRAND = "columnNameBrand";
export const COLUMN_NAME_AGENCY = "columnNameAgency";
export const COLUMN_NAME_ADVERTISER = "columnNameAdvertiser";
export const COLUMN_NAME_USER = "columnNameUser";
export const COLUMN_NAME_CATEGORY = "columnNameCategory";
export const COLUMN_NAME_IS_LOGGED = "columnNameIsLogged";
export const COLUMN_NAME_IS_ACTIVE = "columnNameIsActive";
export const COLUMN_NAME_PACKAGE = "columnNamePlan";
export const COLUMN_NAME_EMAIL = "columnNameEmail";
export const COLUMN_NAME_NAME = "columnNameName";
export const COLUMN_NAME_PHONE = "columnNamePhone";
export const COLUMN_NAME_STAFF = "columnNameStaff";
export const COLUMN_NAME_ACCEPTED = "columnNameAcceptation";
export const COLUMN_NAME_MONTHLY_SALES = "columnNameMonthlySales";
export const COLUMN_NAME_BUDGET_MARKETING = "columnNameBudgetMarketing";
export const COLUMN_NAME_EMPLOYEES = "columnNameEmployees";
export const COLUMN_NAME_PRODUCT_AVAILABILITY = "columnNameProductAvailability";
export const COLUMN_NAME_SOCIAL_NETWORK = "columnNameSocialNetwork";
export const COLUMN_NAME_WEB_SITE = "columnNameWebSite";
export const COLUMN_NAME_YOU_MEET = "columnNameYouMeet";
export const COLUMN_NAME_DATE = "columnNameDate";
export const COLUMN_NAME_PLAN = "columnNamePlan";
export const COLUMN_NAME_PAYMENT_METHOD = "columnNamePaymentMethod";
export const COLUMN_NAME_COST_COLLABORATION = "columnNameCostCollaboration";
export const COLUMN_NAME_CREDITS = "columnNameCredits";
export const COLUMN_NAME_COUNTRY = "columnNameCountry";
export const COLUMN_NAME_CREATOR_NAME = "columnNameCreatorName";
export const COLUMN_NAME_CREATOR_PLATFORM = "columnNameCreatorPlatform";
export const COLUMN_NAME_CITY = "columnNameCity";
export const COLUMN_NAME_AUDIENCE = "columnNameAudience";
export const COLUMN_NAME_ENGAGEMENT = "columnNameEngagement";
export const COLUMN_NAME_CATEGORIES = "columnNameCategories";
export const COLUMN_NAME_SCORE = "columnNameScore";
export const COLUMN_NAME_ACTIVITY = "columnNameActivity";
export const COLUMN_NAME_ACTIONS = "columnNameActions";
export const COLUMN_NAME_ACTION = "columnNameAction";
export const COLUMN_NAME_STATUS = "columnNameStatus";
export const COLUMN_NAME_REDEEMED_DATE = "columnNameRedeemedDate";
export const COLUMN_NAME_TERMS = "columnNameTerms";
export const COLUMN_NAME_ADDRESS = "columnNameAddress";
export const COLUMN_NAME_STORE = "columnNameStore";
export const COLUMN_NAME_ROLE = "columnNameRole";
export const COLUMN_NAME_PAID_DATE = "columnNamePaidDate";
export const COLUMN_NAME_DUE_DATE = "columnNameDueDate";
export const COLUMN_NAME_REASON = "columnNameReason";
export const COLUMN_NAME_VALUE = "columnNameValue";
export const COLUMN_NAME_ID = "columnNameID";
export const COLUMN_NAME_CREATOR = "columnNameCreator";
export const COLUMN_NAME_CREATED_DATE = "columnNameCreatedDate";
export const COLUMN_NAME_ACCEPTED_DATE = "columnNameAcceptedDate";
export const COLUMN_NAME_DETAILS = "columnNameDetails";
export const COLUMN_NAME_DELIVERY = "columnNameDelivery";
export const COLUMN_NAME_CODE_VERIFICATION = "columnNameCodeVerification";
export const COLUMN_NAME_ACCOUNT_NAME = "columnNameAccountName";
export const COLUMN_NAME_IS_HIDDEN = "columnNameIsHidden";
export const COLUMN_NAME_COMMENT = "columnNameComment";
export const COLUMN_NAME_URLS = "columnNameURLs";
export const COLUMN_NAME_KEYWORD = "columnaNameKeyword";
export const COLUMN_NAME_IMPRESSIONS = "columnNameImpressions";
export const COLUMN_NAME_CLICKS = "columnNameClicks";
export const COLUMN_NAME_CONFIGURE_COLUMNS = "columnNameConfigureColumns";
export const COLUMN_NAME_CTR = "columnNameCTR";
export const COLUMN_NAME_CONVERSIONS = "columnNameConversions";
export const COLUMN_NAME_CPA = "columnNameCPA";
export const COLUMN_NAME_CPM = "columnNameCPM";
export const COLUMN_NAME_CPC = "columnNameCPC";
export const COLUMN_NAME_SPEND = "columnNameSpend";
export const COLUMN_NAME_MATCH_TYPE = "columnNameMatchType";
export const COLUMN_NAME_PLATFORM = "columnNamePlatform";
export const COLUMN_NAME_RESULTS = "columnNameResults";
export const COLUMN_NAME_FIELD = "columnNameField";
export const COLUMN_NAME_CURRENT_VALUE = "columnNameCurrentValue";
export const COLUMN_NAME_NEW_VALUE = "columnNameNewValue";
export const COLUMN_NAME_CAMPAIGN = "columnNameCampaign";
export const COLUMN_NAME_BUDGET = "columnNameBudget";
export const COLUMN_NAME_CREATED_BY = "columnNameCreatedBy";
export const CAMPAIGNS_TABLE_ARIA_LABEL = "campaignsTableAriaLabel";
export const CAMPAIGNS_TABLE_TITLE = "campaignsTableTitle";
export const CAMPAIGNS_STATUS_DRAFT = "campaignsStatusDraft";
export const CAMPAIGNS_STATUS_FINISHED = "campaignsStatusFinished";
export const CAMPAIGNS_STATUS_DELETED = "campaignsStatusDeleted";
export const CAMPAIGNS_TABLE_FILTER_COLUMNS_TITLE =
  "campaignsTableFilterColumnsTitle";
export const COLUMN_NAME_ENTITY = "columnNameEntity";
export const COLUMN_NAME_SEARCH_TERM = "columnNameSearchTerm";
export const GOOGLE_SEARCH_TERMS_TITLE = "googleSearchTermsTitle";
export const GOOGLE_SEARCH_TERMS_DESCRIPTION = "googleSearchTermsDescription";
export const GOOGLE_SEARCH_TERMS_EMPTY = "googleSearchTermsEmpty";
export const SEARCH_TERM_MATCH_TYPE_BROAD = "searchTermMatchTypeBroad";
export const SEARCH_TERM_MATCH_TYPE_PHRASE = "searchTermMatchTypePhrase";
export const SEARCH_TERM_MATCH_TYPE_EXACT = "searchTermMatchTypeExact";
export const SEARCH_TERM_MATCH_TYPE_NEAR_PHRASE =
  "searchTermMatchTypeNearPhrase";
export const SEARCH_TERM_MATCH_TYPE_NEAR_EXACT = "searchTermMatchTypeNearExact";
export const SEARCH_TERM_MATCH_TYPE_AI_MAX = "searchTermMatchTypeAiMax";

//ALERTS
export const ALERT_PLATFORM_STATUS_BANNER = "alertPlatformStatusBanner";
export const ALERT_IMAGE_PROVIDER_STATUS_BANNER =
  "alertImageProviderStatusBanner";
export const ALERT_VIDEO_PROVIDER_STATUS_BANNER =
  "alertVideoProviderStatusBanner";
export const ALERT_CAMPAIGN_PROVIDER_STATUS_BANNER =
  "alertCampaignProviderStatusBanner";
export const ALERT_REBRAND_BANNER = "alertRebrandBanner";
export const ALERT_REBRAND_BANNER_DISCORD_BODY =
  "alertRebrandBannerDiscordBody";
export const DISCORD_LINK = "alertRebrandBannerDiscordLink";
export const ALERT_REBRAND_BANNER_APPSUMO_REVIEW_BODY =
  "alertRebrandBannerAppSumoReviewBody";
export const ALERT_REBRAND_BANNER_AFFILIATE_BODY =
  "alertRebrandBannerAffiliateBody";
export const ALERT_REBRAND_BANNER_AFFILIATE_LINK =
  "alertRebrandBannerAffiliateLink";
export const APPSUMO_REVIEW_BANNER_LINK = "alertRebrandBannerAppSumoReviewLink";
export const ALERT_REBRAND_BANNER_CAROUSEL_PREVIOUS =
  "alertRebrandBannerCarouselPrevious";
export const ALERT_REBRAND_BANNER_CAROUSEL_NEXT =
  "alertRebrandBannerCarouselNext";
export const MODAL_REBRAND_ADLE_TITLE = "modalRebrandAdleTitle";
export const MODAL_REBRAND_ADLE_DESCRIPTION = "modalRebrandAdleDescription";
export const MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON =
  "modalRebrandAdleGoToAdleButton";
export const ALERT_INACTIVE_SHOP_TITLE = "alertInactiveShopTitle";
export const ALERT_INACTIVE_SHOP_DESCRIPTION = "alertInactiveShopDescription";
export const ALERT_OPERATOR_ACTION_UNAUTHORIZED_DESCRIPTION =
  "alertOperatorActionUnauthorizedDescription";
export const ALERT_CREATE_SECOND_ADS_CAMPAIGN = "alertCreateSecondAdsCampaign";
export const ALERT_CREATE_SECOND_ADS_CAMPAIGN_DESCRIPTION =
  "alertCreateSecondAdsCampaignDescription";
export const ALERT_REMEMBER_IF_RECHARGE_ACCOUNT_PLATFORM =
  "alertRememberIfRechargeAccountPlatform";
export const ALERT_DESCRIPTION_DISCONNECT_FACEBOOK =
  "alertDescriptionDisconnectFacebook";
export const ALERT_DESCRIPTION_DISCONNECT_TIKTOK =
  "alertDescriptionDisconnectTikTok";
export const ALERT_DESCRIPTION_DISCONNECT_TIKTOK_BUSINESS =
  "alertDescriptionDisconnectTikTokBusiness";
export const ALERT_DESCRIPTION_DISCONNECT_LINKEDIN =
  "alertDescriptionDisconnectLinkedin";
export const ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE =
  "alertAdsCampaignBudgetConfirmTitle";
export const ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION =
  "alertAdsCampaignBudgetConfirmDescription";
export const ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE =
  "alertAdsCampaignBudgetConfirmTitleUpdate";
export const ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE =
  "alertAdsCampaignBudgetConfirmDescriptionUpdate";
export const ALERT_DESCRIPTION_DISCONNECT_CANVA =
  "alertDescriptionDisconnectCanva";
export const ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_TITLE =
  "alertTikTokBusinessNeedsCreateIdentityTitle";
export const ALERT_TIK_TOK_BUSINESS_NEEDS_CREATE_IDENTITY_DESCRIPTION =
  "alertTikTokBusinessNeedsCreateIdentityDescription";
export const ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_TITLE =
  "alertConnectAccountForCreateCampaignTitle";
export const ALERT_CONNECT_ACCOUNT_FOR_CREATE_CAMPAIGN_DESCRIPTION =
  "alertConnectAccountForCreateCampaignDescription";
export const ALERT_CANCEL_SUBSCRIPTION_TITLE_CONFIRMATION =
  "alertCancelSubscriptionTitleConfirmation";
export const ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION_CONFIRMATION =
  "alertCancelSubscriptionDescriptionConfirmation";
export const ALERT_CANCEL_SUBSCRIPTION_TITLE = "alertCancelSubscriptionTitle";
export const ALERT_CANCEL_PLAN_TITLE = "alertCancelPlanTitle";
export const ALERT_CANCEL_SUBSCRIPTION_DESCRIPTION =
  "alertCancelSubscriptionDescription";
export const ALERT_REACTIVATE_SUBSCRIPTION_TITLE =
  "alertReactivateSubscriptionTitle";
export const ALERT_PAYMENT_METHOD_CHANGED_TITLE =
  "alertPaymentMethodChangedTitle";
export const ALERT_CONNECT_ACCOUNT_SECURE_DESCRIPTION =
  "alertConnectAccountSecureDescription";
export const ALERT_POPUP_BLOCKED_TITLE = "alertPopupBlockedTitle";
export const ALERT_POPUP_BLOCKED_DESCRIPTION = "alertPopupBlockedDescription";
export const ALERT_DELETE_PLATFORM_CAMPAIGN_DESCRIPTION =
  "alertDeletePlatformCampaignDescription";
export const ALERT_DUPLICATE_CAMPAIGN_TITLE = "alertDuplicateCampaignTitle";
export const ALERT_DUPLICATE_CAMPAIGN_DESCRIPTION =
  "alertDuplicateCampaignDescription";
export const ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE =
  "alertDeleteCampaignActiveTitle";
export const ALERT_DELETE_CAMPAIGN_TITLE = "alertDeleteCampaignTitle";
export const ALERT_ARCHIVE_CAMPAIGN_TITLE = "alertArchiveCampaignTitle";
export const ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE =
  "alertArchiveCampaignTitleActive";
export const ALERT_DELETE_CAMPAIGN_DESCRIPTION =
  "alertDeleteCampaignDescription";
export const ALERT_DELETE_ELEMENT_TITLE = "alertDeleteElementTitle";
export const ALERT_DELETE_ELEMENT_DESCRIPTION = "alertDeleteElementDescription";
export const ALERT_DELETE_CAMPAIGN_ERROR_TITLE =
  "alertDeleteCampaignErrorTitle";
export const ALERT_DELETE_CAMPAIGN_ERROR_TEXT = "alertDeleteCampaignErrorText";
export const ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION =
  "alertArchiveCampaignDescription";
export const ALERT_PUBLISH_ACTIVE_OR_DEACTIVATE_CAMPAIGN_TITLE =
  "alertPublishActiveOrDeactivateCampaignTitle";
export const ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_TITLE =
  "alertGoogleAccountNoRegisteredTitle";
export const ALERT_GOOGLE_ACCOUNT_NO_REGISTERED_DESCRIPTION =
  "alertGoogleAccountNoRegisteredDescription";
export const ALERT_DESCRIPTION_DISCONNECT_GOOGLE =
  "alertDescriptionDisconnectGoogle";
export const ALERT_CONNECT_GOOGLE_BETA_TITLE = "alertConnectGoogleBetaTitle";
export const ALERT_CONNECT_GOOGLE_BETA_DESCRIPTION =
  "alertConnectGoogleBetaDescription";
export const ALERT_FILL_BRAND_SETUP_TITLE = "alertFillBrandSetupTitle";
export const ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN =
  "alertFillBrandSetupDescriptionForCampaign";
export const ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_GENERATE_CREATIVES =
  "alertFillBrandSetupDescriptionForGenerateCreatives";
export const ALERT_DELETE_KEYWORD_TITLE = "alertDeleteKeywordTitle";
export const ALERT_DELETE_KEYWORD_DESCRIPTION = "alertDeleteKeywordDescription";
export const ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE =
  "alertChangeObjectiveOrDestinationTypeAffectMediaURLsTitle";
export const ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION =
  "alertChangeObjectiveOrDestinationTypeAffectMediaURLsDescription";
export const ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE =
  "alertIsDynamicCreativeOnTitle";
export const ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION =
  "alertIsDynamicCreativeOnDescription";
export const ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE =
  "alertIsDynamicCreativeOffTitle";
export const ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION =
  "alertIsDynamicCreativeOffDescription";
export const FIELD_IS_DYNAMIC_CREATIVE_ONLY_ONE_AD =
  "fieldIsDynamicCreativeOnlyOneAd";
export const FIELD_SCHEDULE_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE =
  "fieldScheduleRequiredWhenCampaignBudgetOthersHave";
export const FIELD_BID_GOAL_REQUIRED_WHEN_CAMPAIGN_BUDGET_OTHERS_HAVE =
  "fieldBidGoalRequiredWhenCampaignBudgetOthersHave";
export const ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE =
  "alertChangeAdAccountGeneralTitle";
export const ALERT_CHANGE_AD_ACCOUNT_META_DESCRIPTION =
  "alertChangeAdAccountMetaDescription";
export const ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION =
  "alertChangeAdAccountTikTokDescription";
export const ALERT_CHANGE_AD_ACCOUNT_GOOGLE_DESCRIPTION =
  "alertChangeAdAccountGoogleDescription";
export const ALERT_CHANGE_AD_ACCOUNT_LINKEDIN_DESCRIPTION =
  "alertChangeAdAccountLinkedInDescription";
export const ALERT_DELETE_KEYWORDS_TITLE = "alertDeleteKeywordsTitle";
export const ALERT_DELETE_KEYWORDS_DESCRIPTION =
  "alertDeleteKeywordsDescription";
export const ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_TITLE =
  "alertChangeCustomAudiencesCampaignTitle";
export const ALERT_CHANGE_CUSTOM_AUDIENCES_CAMPAIGN_DESCRIPTION =
  "alertChangeCustomAudiencesCampaignDescription";
export const ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_TITLE =
  "alertChangeCustomAudiencesGroupsTitle";
export const ALERT_CHANGE_CUSTOM_AUDIENCES_GROUPS_DESCRIPTION =
  "alertChangeCustomAudiencesGroupsDescription";
export const SUGGESTION_BUDGET_TITLE = "suggestionBudgetTitle";
export const SUGGESTION_BUDGET_TEXT = "suggestionBudgetText";
export const SUGGESTION_BUDGET_PREVIOUS = "suggestionBudgetPrevious";
export const SUGGESTION_BUDGET_CURRENT = "suggestionBudgetCurrent";
export const SUGGESTION_BUDGET_APPLY = "suggestionBudgetApply";
export const SUGGESTION_BUDGET_CANCEL = "suggestionBudgetCancel";
export const SUGGESTION_BUDGET_MINIMUM = "suggestionBudgetMinimum";
export const ALERT_CHANGE_ADVERTISER_TITLE = "alertChangeAdvertiserTitle";
export const ALERT_RESIZE_IMAGE_FAILED_DESCRIPTION = "alertResizeImageFailed";

//OPTIONS UGC FORMATS
export const OPTION_UGC_FORMAT_GRWM = "optionUGCFormatGRWM";
export const OPTION_UGC_FORMAT_GRWM_EXPLANATION =
  "optionUGCFormatGRWMExplanation";
export const OPTION_UGC_FORMAT_OODT = "optionUGCFormatOODT";
export const OPTION_UGC_FORMAT_OODT_EXPLANATION =
  "optionUGCFormatOODTExplanation";
export const OPTION_UGC_FORMAT_HAULS = "optionUGCFormatHAULS";
export const OPTION_UGC_FORMAT_HAULS_EXPLANATION =
  "optionUGCFormatHAULSExplanation";
export const OPTION_UGC_FORMAT_DIYS = "optionUGCFormatDIYS";
export const OPTION_UGC_FORMAT_DIYS_EXPLANATION =
  "optionUGCFormatDIYSExplanation";
export const OPTION_UGC_FORMAT_UNBOXING = "optionUGCFormatUnboxing";
export const OPTION_UGC_FORMAT_UNBOXING_EXPLANATION =
  "optionUGCFormatUnboxingExplanation";
export const OPTION_UGC_FORMAT_CHALLENGES = "optionUGCFormatChallenges";
export const OPTION_UGC_FORMAT_CHALLENGES_EXPLANATION =
  "optionUGCFormatChallengesExplanation";
export const OPTION_UGC_FORMAT_REVIEWS = "optionUGCFormatReviews";
export const OPTION_UGC_FORMAT_REVIEWS_EXPLANATION =
  "optionUGCFormatReviewsExplanation";
export const OPTION_UGC_FORMAT_VLOGS = "optionUGCFormatVlogs";
export const OPTION_UGC_FORMAT_VLOGS_EXPLANATION =
  "optionUGCFormatVlogsExplanation";
export const OPTION_UGC_FORMAT_QA = "optionUGCFormatQA";
export const OPTION_UGC_FORMAT_QA_EXPLANATION = "optionUGCFormatQAExplanation";
export const OPTION_UGC_FORMAT_STORYTIME = "optionUGCFormatStorytime";
export const OPTION_UGC_FORMAT_STORYTIME_EXPLANATION =
  "optionUGCFormatStorytimeExplanation";
export const OPTION_UGC_FORMAT_ROOM_TOURS = "optionUGCFormatRoomTours";
export const OPTION_UGC_FORMAT_ROOM_TOURS_EXPLANATION =
  "optionUGCFormatRoomToursExplanation";
export const OPTION_UGC_FORMAT_WHATS_IN_MY_BAG = "optionUGCFormatWhatsInMyBag";
export const OPTION_UGC_FORMAT_WHATS_IN_MY_BAG_EXPLANATION =
  "optionUGCFormatWhatsInMyBagExplanation";
export const OPTION_UGC_FORMAT_COOKING = "optionUGCFormatCooking";
export const OPTION_UGC_FORMAT_COOKING_EXPLANATION =
  "optionUGCFormatCookingExplanation";
export const OPTION_UGC_FORMAT_FITNESS_ROUTINES =
  "optionUGCFormatFitnessRoutines";
export const OPTION_UGC_FORMAT_FITNESS_ROUTINES_EXPLANATION =
  "optionUGCFormatFitnessRoutinesExplanation";
export const OPTION_UGC_FORMAT_ASMR = "optionUGCFormatASMR";
export const OPTION_UGC_FORMAT_ASMR_EXPLANATION =
  "optionUGCFormatASMTExplanation";
export const OPTION_UGC_FORMAT_PLAN_WITH_ME = "optionUGCFormatPlanWithMe";
export const OPTION_UGC_FORMAT_PLAN_WITH_ME_EXPLANATION =
  "optionUGCFormatPlanWithMeExplanation";
export const OPTION_UGC_FORMAT_MUKBANG = "optionUGCFormatMukbang";
export const OPTION_UGC_FORMAT_MUKBANG_EXPLANATION =
  "optionUGCFormatMukbangExplanation";
export const OPTION_UGC_FORMAT_DAY_IN_THE_LIFE = "optionUGCFormatDayInTheLife";
export const OPTION_UGC_FORMAT_DAY_IN_THE_LIFE_EXPLANATION =
  "optionUGCFormatDayInTheLifeExplanation";
export const OPTION_UGC_FORMAT_BEHIND_THE_SCENES =
  "optionUGCFormatBehindTheScenes";
export const OPTION_UGC_FORMAT_BEHIND_THE_SCENES_EXPLANATION =
  "optionUGCFormatBehindTheScenesExplanation";
export const OPTION_UGC_FORMAT_TRAVEL_DIARIES = "optionUGCFormatTravelDiaries";
export const OPTION_UGC_FORMAT_TRAVEL_DIARIES_EXPLANATION =
  "optionUGCFormatTravelDiariesExplanation";

//ERRORS
export const SOMETHING_ERROR_GENERATING_STATISTICS =
  "somethingErrorGeneratingStatistics";
export const AUTH_SENT_EMAIL_RESET_PASSWORD = "authSentEmailResetPassword";
export const EMAIL_UNSUBSCRIBE_SUCCESS_TITLE = "emailUnsubscribeSuccessTitle";
export const EMAIL_UNSUBSCRIBE_SUCCESS_TEXT = "emailUnsubscribeSuccessText";
export const EMAIL_UNSUBSCRIBE_ERROR_TITLE = "emailUnsubscribeErrorTitle";
export const EMAIL_UNSUBSCRIBE_ERROR_TEXT = "emailUnsubscribeErrorText";
export const AUTH_PAGE_DOCUMENT_TITLE_LOGIN = "authPageDocumentTitleLoginDemo";
export const AUTH_PAGE_DOCUMENT_TITLE_LOGIN_OWNER =
  "authPageDocumentTitleLoginOwner";
export const AUTH_LOGIN_OWNER_CHIP_LABEL = "authLoginOwnerChipLabel";
export const AUTH_LOGIN_OWNER_SUBMIT = "authLoginOwnerSubmit";
export const AUTH_LOGIN_OWNER_NOT_OWNER = "authLoginOwnerNotOwner";
export const AUTH_LOGIN_OWNER_GO_TO_LOGIN = "authLoginOwnerGoToLogin";
export const AUTH_PAGE_DOCUMENT_TITLE_REGISTER =
  "authPageDocumentTitleRegisterDemo";
export const AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD =
  "authPageDocumentTitleResetPasswordDemo";
export const AUTH_PAGE_BRANDING_LOGO_ALT = "authPageBrandingLogoAlt";
export const AUTH_LOGIN_DEMO_EXISTING_ACCOUNT_BANNER =
  "authLoginDemoExistingAccountBanner";
export const ACCOUNT_ROLE_INVALID = "accountRoleInvalid";
export const ERROR_INTERNAL = "errorInternal";
export const AUTH_INVALID_PASSWORD = "authInvalidPassword";
export const AUTH_WRONG_PASSWORD = "authWrongPassword";
export const AUTH_MANY_REQUESTS = "authManyRequests";
export const AUTH_USER_NOT_FOUND = "authUserNotFound";
export const AUTH_EMAIL_ALREADY_EXISTS = "authEmailAlreadyExists";
export const PHONE_ALREADY_REGISTERED = "phoneAlreadyRegistered";
export const AUTH_INVALID_VERIFICATION_CODE = "authInvalidVerificationCode";
export const AUTH_INVALID_APP_CREDENTIAL = "authInvalidAppCredential";
export const STRIPE_CARD_DECLINED = "authCardDeclined";
export const STRIPE_EXPIRED_CARD = "authExpiredCard";
export const STRIPE_INCORRECT_CVC = "authIncorrectCvc";
export const STRIPE_PROCESSING_ERROR = "authProcessingError";
export const STRIPE_INCORRECT_NUMBER = "authIncorrectNumber";
export const STRIPE_GENERIC_DECLINE = "authGenericDecline";
export const STRIPE_INSUFFICIENT_FUNDS = "authInsufficientFunds";
export const STRIPE_LOST_CARD = "authLostCard";
export const STRIPE_STOLEN_CARD = "authStolenCard";
export const STRIPE_PROFILE_NOT_FOUND = "authProfileNotFound";
export const STRIPE_INTENT_AUTH_FAILURE = "authIntentAuthFailure";
export const NIT_VALID = "nitValid";
export const BUSINESS_NAME_VALID = "businessNameValid";
export const BRAND_NAME_VALID = "brandNameValid";
export const ADDRESS_VALID = "addressValid";
export const CATEGORY_VALID = "categoryValid";
export const SUBCATEGORIES_VALID = "subcategoriesValid";
export const SHORT_DESCRIPTION_VALID = "shortDescriptionValid";
export const ORDERS_METHODS_VALID = "ordersMethodsValid";
export const LOGO_IMG_VALID = "logoImgValid";
export const COVER_IMG_VALID = "coverImgValid";
export const SCHEDULE_VALID = "scheduleValid";
export const STORES_VALID = "storesValid";
export const IS_PLAN_ACTIVE_VALID = "isPlanActiveValid";
export const MENUS_VALID = "menusValid";
export const DEFAULT_PAYMENT_METHOD_VALID = "defaultPaymentMethodValid";
export const HAS_DEBT_VALID = "hasDebtValid";
export const SUBSCRIPTION_PLAN_VALID = "subscriptionPlanValid";
export const MISSING_PARAMETERS = "missingParameters";
export const PASSWORD_INVALID = "passwordInvalid";
export const INVALID_SEARCH = "invalidSearch";
export const USER_ID_REQUIRED = "userIDRequired";
export const SHOP_ID_REQUIRED = "shopIDRequired";
export const LAST_USER_NOT_DELETED = "lastUserNotDeleted";
export const PLAN_TRIAL_USER_USED = "planTrialUserUsed";
export const ORDERS_NOT_FOUND_IN_INTERVAL = "ordersNotFoundInInterval";
export const TYPE_REPORT_NOT_FOUND = "typeReportNotFound";
export const SHOP_NOT_FOUND = "shopNotFound";
export const PAYMENT_MODEL_INVALID = "paymentModelInvalid";
export const SHOP_NOT_HAS_SOCIAL_NETWORK = "shopNotHasSocialNetwork";
export const NO_VALID_PLATFORM_FOUND = "noValidPlatformFound";
export const GETTING_STATISTICS = "gettingStatistics";
export const SHOP_BUSINESS_NAME_NOT_FOUND = "shopBusinessNameNotFound";
export const REFERENCE_PROFILES_REQUIRED = "referenceProfilesRequired";
export const DECRYPTING_PASSWORD = "decryptingPassword";
export const USER_ID_AND_PAYMENT_ID = "userIDAndPaymentID";
export const MESSAGES_REQUIRED = "messagesRequired";
export const PLAN_IS_NO_ACTIVE = "planIsNoActive";
export const USER_BANNED = "userBanned";
export const GETTING_LOCALES = "gettingLocales";
export const GETTING_PROFILE = "gettingProfile";
export const PRODUCTS_NOT_SENT = "productsNotSent";
export const ACCOUNT_NOT_FOUND = "accountNotFound";
export const COLLECTING_INFORMATION_RETRY_AFTER =
  "collectingInformationRetryAfter";
export const ERROR_OCCURRED = "errorOccurred";
export const FREE_BOT_MESSAGES_LIMIT_REACHED = "freeBotMessagesLimitReached";
export const TEXT_REGENERATION_LIMIT_REACHED = "textRegenerationLimitReached";
export const REFERENCE_VIDEO_ANALYSIS_UNAVAILABLE =
  "referenceVideoAnalysisUnavailable";
export const ACTION_COULD_NOT_BE_COMPLETED = "actionCouldNotBeCompleted";
export const PLATFORM_NOT_SENT = "platformNotSent";
export const PLATFORM_APP_REQUEST_LIMIT_REACHED =
  "platformAppRequestLimitReached";
export const VERIFICATION_CODE_NOT_FOUND = "verificationCodeNotFound";
export const VERIFICATION_CODE_INCORRECT = "verificationCodeNotIncorrect";
export const REGISTRATION_EMAIL_NOT_VERIFIED = "registrationEmailNotVerified";
export const ORDER_NOT_FOUND = "orderNotFound";
export const TYPE_OR_PATH_NOT_SENT = "typeOrPathNotSent";
export const ID_OR_PATH_NOT_SENT = "idOrPathNotSent";
export const IDS_NOT_SENT = "idsNotSent";
export const ANALYTIC_URL_NOT_SENT = "analyticUrlNotSent";
export const ANALYTIC_URL_INVALID = "analyticUrlInvalid";
export const EXTRACTING_ANALYTICS = "extractingAnalytics";
export const CREDENTIALS_INVALID = "credentialsInvalid";
export const COLLABORATION_PRICE_NOT_BE_NEGATIVE =
  "collaborationPriceNotBeNegative";
export const CREDITS_NOT_BE_NEGATIVE = "creditsNotBeNegative";
export const PACKAGES_PRICES_NOT_BE_NEGATIVE = "packagesPricesNotBeNegative";
export const ROL_REQUIRED = "rolRequired";
export const SHOP_ID_AND_STORE_ID_REQUIRED = "shopIDAndStoreIDRequired";
export const PASSWORD_MUST_BE_6_CHARACTERS = "passwordMustBe6Characters";
export const ALL_USERS_NOT_DELETE = "allUsersNotDelete";
export const SHOP_APPLICANT_NOT_FOUND = "shopApplicantNotFound";
export const USER_PASSWORD_NOT_FOUND = "userPasswordNotFound";
export const PLAN_NOT_FOUND = "planNotFound";
export const SUBSCRIPTION_NOT_CREATED = "subscriptionNotCreated";
export const ID_SUBSCRIPTION_NOT_FOUND = "idSubscriptionNotFound";
export const SUBSCRIPTION_REACTIVATE = "subscriptionReactivate";
export const CUSTOMER_ID_NOT_FOUND = "customerIDNotFound";
export const APPLICANT_NOT_FOUND = "applicantNotFound";
export const SHOP_COUNTRY_NOT_FOUND = "shopCountryNotFound";
export const FINAL_PRICE_NOT_FOUND = "finalPriceNotFound";
export const PAYMENT_FAILED = "paymentFailed";
export const CREDITS_MUST_BE_GREATER_THAN_ZERO = "creditsMustBeGreaterThanZero";
export const CSRF_INVALID = "csrfInvalid";
export const INTEGRATION_INFORMATION_NOT_FOUND =
  "integrationInformationNotFound";
export const MODAL_INTEGRATION_NOT_FOUND_TITLE =
  "modalIntegrationNotFoundTitle";
export const MODAL_INTEGRATION_NOT_FOUND_DESCRIPTION =
  "modalIntegrationNotFoundDescription";
export const MODAL_INTEGRATION_NOT_FOUND_COLUMN_PLATFORM =
  "modalIntegrationNotFoundColumnPlatform";
export const MODAL_INTEGRATION_NOT_FOUND_COLUMN_CAMPAIGN =
  "modalIntegrationNotFoundColumnCampaign";
export const MODAL_INTEGRATION_NOT_FOUND_COLUMN_AD_ACCOUNT =
  "modalIntegrationNotFoundColumnAdAccount";
export const MODAL_INTEGRATION_NOT_FOUND_COLUMN_REASON =
  "modalIntegrationNotFoundColumnReason";
export const MODAL_INTEGRATION_NOT_FOUND_COLUMN_INTEGRATION =
  "modalIntegrationNotFoundColumnIntegration";
export const MODAL_INTEGRATION_NOT_FOUND_ROW_DISABLED =
  "modalIntegrationNotFoundRowDisabled";
export const MODAL_INTEGRATION_NOT_FOUND_ROW_LOADING =
  "modalIntegrationNotFoundRowLoading";
export const MODAL_INTEGRATION_NOT_FOUND_ROW_ERROR =
  "modalIntegrationNotFoundRowError";
export const MODAL_INTEGRATION_NOT_FOUND_SELECT_PLACEHOLDER =
  "modalIntegrationNotFoundSelectPlaceholder";
export const MODAL_INTEGRATION_NOT_FOUND_SAVE = "modalIntegrationNotFoundSave";
export const GETTING_VIDEO = "gettingVideo";
export const UPLOAD_URL_NOT_FOUND = "uploadUrlNotFound";
export const UPLOADING_VIDEO = "uploadingVideo";
export const STORE_NOT_FOUND = "storeNotFound";
export const NAME_REQUIRED = "nameRequired";
export const PRICE_REQUIRED = "priceRequired";
export const CURRENCY_REQUIRED = "currencyRequired";
export const RECURRING_REQUIRED = "recurringRequired";
export const CREATING_PRODUCT = "creatingProduct";
export const CREATING_PRICE = "creatingPrice";
export const CREATING_PAYMENT_LINK = "creatingPaymentLink";
export const GETTING_PAYMENT_LINK = "gettingPaymentLink";
export const TOKEN_INVALID = "tokenInvalid";
export const TOKEN_EXPIRED = "tokenExpired";
export const IG_ACCOUNT_NOT_FOUND = "igAccountNotFound";
export const IG_DATA_NOT_FOUND = "igDataNotFound";
export const REVIEW_NOT_FOUND = "reviewNotFound";
export const REVIEW_IS_NOT_ONE_START = "reviewIsNotOneStart";
export const DISSATISFACTION_CREDIT_ALREADY_EXISTS =
  "dissatisfactionCreditAlreadyExists";
export const META_INTEGRATION_UNLINKED_PAGES_ERROR =
  "metaIntegrationUnlinkedPagesError";
export const PAYMENT_METHOD_NOT_FOUND = "paymentMethodNotFound";
export const HAS_PENDING_PAYMENTS = "hasPendingPayments";
export const NO_IMAGES_FOUND_ON_PAGE = "noImagesFoundOnPage";
export const NO_CREATE_DISCOUNT_SHOPIFY = "noCreateDiscountShopify";
export const NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY =
  "noCreateWebhookOrderCreatedShopify";
export const NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY =
  "noCreateWebhookFulfillCreatedShopify";
export const NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY =
  "noCreateWebhookFulfillUpdatedShopify";
export const GETTING_INFORMATION_FROM_SHOPIFY_URL =
  "gettingInformationFromShopifyURL";
export const RATE_DAILY_LIMIT_AI = "rateDailyLimitAI";
export const RATE_DAILY_LIMIT_AI_CHAT = "rateDailyLimitAIChat";
export const PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META =
  "permissionsOrConfigurationAccountChangeMeta";
export const ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS =
  "accountIsNotTypeBusinessOrNoAcceptedAllPermissions";
export const FACEBOOK_PAGE_ID_NOT_FOUND = "facebookPageIDNotFound";
export const META_BUSINESS_ACCOUNT_NOT_FOUND = "metaBusinessAccountNotFound";
export const IG_BUSINESS_ACCOUNT_NOT_FOUND = "igBusinessAccountNotFound";
export const ACCOUNT_TIKTOK_AUTH_NOT_MATCH = "accountTiktokAuthNotMatch";
export const ACCOUNT_TOKEN_META_NOT_FOUND = "accountTokenMetaNotFound";
export const ACCOUNT_ID_BUSINESS_META_NOT_FOUND =
  "accountIDBusinessMetaNotFound";
export const OBJECTIVE_CAMPAIGN_META_INVALID = "objectiveCampaignMetaInvalid";
export const SPECIAL_CATEGORY_CAMPAIGN_META_INVALID =
  "specialCategoryCampaignMetaInvalid";
export const CAMPAIGN_META_NOT_DELETED = "campaignMetaNotDeleted";
export const CAMPAIGN_META_NOT_CREATED = "campaignMetaNotCreated";
export const ADS_CAMPAIGN_NOT_FOUND = "adsCampaignNotFound";
export const NO_PIXELS_FOUND = "noPixelsFound";
export const NO_PIXELS_ACTIVE = "noPixelsActive";
export const CAMPAIGN_META_NOT_FOUND = "campaignMetaNotFound";
export const CAMPAIGN_META_NOT_UPDATED = "campaignMetaNotUpdated";
export const CAMPAIGN_AD_SET_META_NOT_CREATED = "campaignAdSetMetaNotCreated";
export const CAMPAIGN_AD_SET_META_NOT_UPDATED = "campaignAdSetMetaNotUpdated";
export const CAMPAIGN_INFORMATION_UPDATE_FAILED_RATE_LIMIT =
  "campaignInformationUpdateFailedRateLimit";
export const CAMPAIGN_MEDIA_META_NOT_CREATED = "campaignMediaMetaNotCreated";
export const CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND =
  "campaignMediaThumbnailMetaNotFound";
export const CAMPAIGN_CREATIVE_AD_META_NOT_CREATED =
  "campaignCreativeAdMetaNotCreated";
export const CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED =
  "campaignCreativeAdMetaNotUpdated";
export const CAMPAIGN_CREATIVE_AD_META_NOT_FOUND =
  "campaignCreativeAdMetaNotFound";
export const CAMPAIGN_MESSAGE_TEMPLATE_META_NOT_FOUND =
  "campaignMessageTemplateMetaNotFound";
export const CAMPAIGN_AD_META_NOT_CREATED = "campaignAdMetaNotCreated";
export const CAMPAIGN_AD_META_NOT_UPDATED = "campaignAdMetaNotUpdated";
export const CAMPAIGN_METRICS_META_NOT_FOUND = "campaignMetricsMetaNotFound";
export const CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE =
  "createAdsCampaignAccountNoHaveBalance";
export const ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE =
  "activeAdsCampaignAccountNoHaveBalance";
export const CAMPAIGN_AUDIENCE_IS_TOO_NARROW = "campaignAudienceIsTooNarrow";
export const CAMPAIGN_BUDGET_IS_TOO_LOW = "campaignBudgetIsTooLow";
export const IDENTITY_NOT_FOUND = "identityNotFound";
export const VIDEO_ERROR_LOW_RESOLUTION = "videoErrorLowResolution";
export const VIDEO_ERROR_NO_BACKGROUND_AUDIO = "videoErrorNoBackgroundAudio";
export const VIDEO_ERROR_ASPECT_RATIO = "videoErrorAspectRatio";
export const VIDEO_ERROR_BLACK_EDGE = "videoErrorBlackEdge";
export const VIDEO_ERROR_ILLEGAL_DURATION = "videoErrorIllegalDuration";
export const ERROR_GETTING_URL_INFORMATION_BY_PROTECTED =
  "errorGettingURLInformationByProtected";
export const META_ERROR_GETTING_USER_INFORMATION =
  "metaErrorGettingUserInformation";
export const META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION =
  "metaErrorGettingBusinessAccountsInformation";
export const META_ERROR_GETTING_ACCOUNTS_INFORMATION =
  "metaErrorGettingAccountsInformation";
export const META_AD_ACCOUNT_IS_NOT_ACTIVE = "metaAdAccountIsNotActive";
export const META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD =
  "metaAdAccountHaveNotPaymentMethod";
export const META_OAUTH_PERMISSIONS_ERROR = "metaOAuthPermissionsError";
export const META_ACCOUNT_AUTHENTICATION_REQUIRED =
  "metaAccountAuthenticationRequired";
export const ADVERTISER_ID_NOT_FOUND_TIK_TOK = "advertiserIDNotFoundTikTok";
export const ADVERTISER_ID_NOT_FOUND_GOOGLE = "advertiserIDNotFoundGoogle";
export const ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK =
  "businessCurrencyNotFoundTikTok";
export const CURRENCY_MISMATCH = "currencyMismatch";
export const ERROR_GETTING_URL_META_DATA_AND_IMAGES =
  "errorGettingURLMetaDataAndImages";
export const ADVERTISER_ID_TO_CHANGE_NO_PERMISSION =
  "advertiserIDToChangeNoPermission";
export const CANNOT_DELETE_MAIN_ADVERTISER = "cannotDeleteMainAdvertiser";
export const TOTAL_ADVERTISERS_COUNT = "totalAdvertisersCount";
export const TOTAL_ADVERTISER_COUNT = "totalAdvertiserCount";
export const ERROR_PROCESSING_CAMPAIGNS = "errorProcessingCampaigns";
export const ERROR_ANALYZING_LINK_CREATIFY = "errorAnalyzingLinkCreatify";
export const DISCOUNT_CODE_NOT_FOUND = "discountCodeNotFound";
export const DISCOUNT_CODE_NOT_APPLICABLE_TO_THIS_PRODUCT =
  "discountCodeNotApplicableToThisProduct";
export const GENERATE_AI_FREE_VIDEO_LIMIT = "generateAIFreeVideoLimit";
export const SCRIPT_IS_TOO_SHORT = "scriptIsTooShort";
export const WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED =
  "websiteAndSocialNetworkCantAnalyzed";
export const EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM =
  "emailProviderIsNotEqualToEmailForm";
export const OAUTH_IN_WINDOW_NO_COMPLETED = "oauthInWindowNoCompleted";
export const OAUTH_CALLBACK_ACCOUNT_CONNECTED_TITLE =
  "oauthCallbackAccountConnectedTitle";
export const OAUTH_CALLBACK_ACCOUNT_CONNECTED_TEXT =
  "oauthCallbackAccountConnectedText";
export const ERROR_PROCESSING_REQUEST = "errorProcessingRequest";
export const NOT_HAVE_ENOUGH_USAGE_VALUE = "notHaveEnoughUsageValue";
export const NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE = "notHaveEnoughBrandUsageValue";
export const NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE_DESCRIPTION =
  "notHaveEnoughBrandUsageValueDescription";
export const BRAND_USAGE_LIMIT_ALERT_EDIT_LIMITS_BUTTON =
  "brandUsageLimitAlertEditLimitsButton";
export const BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN =
  "brandUsageAllocationExceedsPlan";
export const BRAND_USAGE_ALLOCATION_BELOW_CONSUMED =
  "brandUsageAllocationBelowConsumed";
export const USAGE_VALUE_NOT_FOUND = "usageValueNotFound";
export const ERROR_NETWORK_CONNECTION = "errorNetworkConnection";
export const ERROR_ON_AD_ID_OF_AD_GROUP_ID = "errorOnAdIdOfAdGroupId";
export const ERROR_ON_AD_GROUP_ID = "errorOnAdGroupId";
export const ERROR_ON_ASSETS_GROUP_ID = "errorOnAssetsGroupID";
export const REQUEST_TIME_OUT = "requestTimeOut";
export const TIME_OUT_FOR_PROVIDER = "timeOutForProvider";
export const FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER =
  "facebookPageNeedConnectedWhatsappNumber";
export const YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP =
  "yourFacebookPageMustBeInBusinessPortfolioOwnWhatsapp";
export const ERROR_WITH_MOBILE_PROVIDER = "errorWithMobileProvider";
export const ERROR_CREATING_INSTANT_EXPERIENCE =
  "errorCreatingInstantExperience";
export const CAMPAIGN_REQUEST_ABORTED = "campaignRequestAborted";
export const APP_URL_NOT_FOUND = "appURLNotFound";
export const ERROR_CAMPAIGN_NOT_FOUND_TO_DUPLICATE =
  "errorCampaignNotFoundToDuplicate";
export const INVALID_APP_DEEP_LINK = "invalidAppDeepLink";
export const GENERATION_VIDEO_REJECTED = "generationVideoRejected";
export const VIDEO_INPUT_REAL_PERSON_REJECTED = "videoInputRealPersonRejected";
export const IMAGE_LAYERS_CONTENT_POLICY_VIOLATION =
  "imageLayersContentPolicyViolation";
export const AI_PROVIDER_CREDENTIALS_INVALID = "aiProviderCredentialsInvalid";
export const AI_PROVIDER_CREDENTIALS_INVALID_GENERIC =
  "aiProviderCredentialsInvalidGeneric";
export const AI_REQUEST_TIMEOUT = "aiRequestTimeout";
export const FAL_AI_CREDENTIALS_INVALID = "falAiCredentialsInvalid";
export const HEYGEN_CREDENTIALS_INVALID = "heygenCredentialsInvalid";
export const IMAGES_MODERATION_BLOCKED = "imagesModerationBlocked";
export const MALFORMED_FUNCTION_CALL = "malformedFunctionCall";
export const VIDEO_GENERATION_FAILED_BY_PROVIDER =
  "videoGenerationFailedByProvider";
export const AI_RATE_LIMITED = "aiRateLimited";
export const AI_PROVIDER_UNAVAILABLE = "aiProviderUnavailable";
export const AI_GENERATION_FAILED = "aiGenerationFailed";
export const AGENT_REQUEST_COULD_NOT_BE_PROCESSED =
  "agentRequestCouldNotBeProcessed";
export const CREDITS_RETURNED_SUFFIX = "creditsReturnedSuffix";
export const CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR =
  "creativeUnexpectedImageProviderError";
export const CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR =
  "creativeUnexpectedVideoProviderError";
export const CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR =
  "creativeUnexpectedAiProviderError";
export const CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR =
  "creativeTimeoutImageProviderError";
export const CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR =
  "creativeTimeoutVideoProviderError";
export const CREATIVE_TIMEOUT_AI_PROVIDER_ERROR =
  "creativeTimeoutAiProviderError";
export const INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW =
  "invalidUpdateStatusCreativeInReview";
export const BENEFICIARY_OR_PAYER_NOT_FOUND = "beneficiaryOrPayerNotFound";
export const DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN =
  "deleteOperationNotAllowedForCampaign";
export const LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED =
  "linkedInPartnershipCreditsAlreadyClaimed";
export const CAMPAIGN_IS_GENERATING = "campaignIsGenerating";
export const INVALID_JOB_TYPE = "invalidJobType";
export const JOB_CANCELLED_OR_FAILED = "jobCancelledOrFailed";
export const JOB_TIMEOUT = "jobTimeout";
export const CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD =
  "customReportNoActiveCampaignsInPeriod";

//ERROR COMPONENT
export const ERROR_COMPONENT_TITLE = "errorComponentTitle";
export const ERROR_COMPONENT_DESCRIPTION = "errorComponentDescription";
export const ERROR_COMPONENT_BUTTON_RELOAD_PAGE =
  "errorComponentButtonReloadPage";
export const ERROR_COMPONENT_CURRENT_ROUTE = "errorComponentCurrentRoute";

//CATEGORIES
export const RESTAURANTS = "restaurants";
export const FOODS = "foods";
export const TRAVEL = "travel";
export const ENTERTAINMENT = "entertainment";
export const TECHNOLOGY = "technology";
export const FITNESS = "fitness";
export const FASHION = "fashion";
export const BEAUTY = "beauty";
export const PETS = "pets";
export const HOME = "home";

//SUBCATEGORIES
export const RESTAURANTS_SUBCATEGORY_FOOD = "restaurantsSubcategoryFood";
export const RESTAURANTS_SUBCATEGORY_DRINKS = "restaurantsSubcategoryDrinks";
export const RESTAURANTS_SUBCATEGORY_DESSERTS =
  "restaurantsSubcategoryDesserts";
export const RESTAURANTS_SUBCATEGORY_COFFEE = "restaurantsSubcategoryCoffee";
export const RESTAURANTS_SUBCATEGORY_HOT_DRINKS =
  "restaurantsSubcategoryHotDrinks";
export const RESTAURANTS_SUBCATEGORY_COLD_DRINKS =
  "restaurantsSubcategoryColdDrinks";
export const RESTAURANTS_SUBCATEGORY_SOFT_DRINKS =
  "restaurantsSubcategorySoftDrinks";
export const RESTAURANTS_SUBCATEGORY_FROZEN_DRINKS =
  "restaurantsSubcategoryFrozenDrinks";
export const RESTAURANTS_SUBCATEGORY_SUSHI = "restaurantsSubcategorySushi";
export const RESTAURANTS_SUBCATEGORY_ASIAN = "restaurantsSubcategoryAsian";
export const RESTAURANTS_SUBCATEGORY_JAPANESE =
  "restaurantsSubcategoryJapanese";
export const RESTAURANTS_SUBCATEGORY_CHINESE = "restaurantsSubcategoryChinese";
export const RESTAURANTS_SUBCATEGORY_ITALIAN = "restaurantsSubcategoryItalian";
export const RESTAURANTS_SUBCATEGORY_MEXICAN = "restaurantsSubcategoryMexican";
export const RESTAURANTS_SUBCATEGORY_HEALTHY = "restaurantsSubcategoryHealthy";
export const RESTAURANTS_SUBCATEGORY_VEGAN = "restaurantsSubcategoryVegan";
export const RESTAURANTS_SUBCATEGORY_VEGETARIAN =
  "restaurantsSubcategoryVegetarian";
export const FOODS_SUBCATEGORY_SEASONINGS = "foodsSubcategorySeasonings";
export const FOODS_SUBCATEGORY_FOOD = "foodsSubcategoryFood";
export const FOODS_SUBCATEGORY_GRANOLA = "foodsSubcategoryGranola";
export const FOODS_SUBCATEGORY_DRIED_FRUITS = "foodsSubcategoryDriedFruits";
export const FOODS_SUBCATEGORY_HEALTHY = "foodsSubcategoryHealthy";
export const TRAVEL_SUBCATEGORY_BEACH_SUN_TOURISM =
  "travelSubcategoryBeachSunTourism";
export const TRAVEL_SUBCATEGORY_RURAL_TOURISM = "travelSubcategoryRuralTourism";
export const TRAVEL_SUBCATEGORY_GASTRONOMIC_TOURISM =
  "travelSubcategoryGastronomicTourism";
export const TRAVEL_SUBCATEGORY_NATURE_TOURISM =
  "travelSubcategoryNatureTourism";
export const TRAVEL_SUBCATEGORY_CULTURAL_TOURISM =
  "travelSubcategoryCulturalTourism";
export const TRAVEL_SUBCATEGORY_HEALTH_TOURISM =
  "travelSubcategoryHealthTourism";
export const ENTERTAINMENT_SUBCATEGORY_ENTERTAINMENT =
  "entertainmentSubcategoryEntertainment";
export const TECHNOLOGY_SUBCATEGORY_PHONES = "technologySubcategoryPhones";
export const TECHNOLOGY_SUBCATEGORY_COMPUTERS =
  "technologySubcategoryComputers";
export const TECHNOLOGY_SUBCATEGORY_VIDEO_GAME_CONSOLES =
  "technologySubcategoryVideoGameConsoles";
export const TECHNOLOGY_SUBCATEGORY_ACCESSORIES =
  "technologySubcategoryAccessories";
export const TECHNOLOGY_SUBCATEGORY_PERIPHERALS =
  "technologySubcategoryPeripherals";
export const TECHNOLOGY_SUBCATEGORY_ELECTRONICS =
  "technologySubcategoryElectronics";
export const FITNESS_SUBCATEGORY_SPORTSWEAR = "fitnessSubcategorySportswear";
export const FITNESS_SUBCATEGORY_SPORTS_ACCESSORIES =
  "fitnessSubcategorySportsAccessories";
export const FITNESS_SUBCATEGORY_DIETARY_SUPPLEMENTS =
  "fitnessSubcategoryDietarySupplements";
export const FITNESS_SUBCATEGORY_TRAINING_EQUIPMENT =
  "fitnessSubcategoryTrainingEquipment";
export const FASHION_SUBCATEGORY_HAUTE_COUTURE =
  "fashionSubcategoryHauteCouture";
export const FASHION_SUBCATEGORY_HIPSTER = "fashionSubcategoryHipster";
export const FASHION_SUBCATEGORY_CASUAL = "fashionSubcategoryCasual";
export const FASHION_SUBCATEGORY_CLASSIC = "fashionSubcategoryClassic";
export const FASHION_SUBCATEGORY_ROMANTIC = "fashionSubcategoryRomantic";
export const FASHION_SUBCATEGORY_SPORTSWEAR = "fashionSubcategorySportswear";
export const FASHION_SUBCATEGORY_PREPPY = "fashionSubcategoryPreppy";
export const FASHION_SUBCATEGORY_GRUNGE = "fashionSubcategoryGrunge";
export const FASHION_SUBCATEGORY_VINTAGE = "fashionSubcategoryVintage";
export const BEAUTY_SUBCATEGORY_COSMETICS = "beautySubcategoryCosmetics";
export const BEAUTY_SUBCATEGORY_EYE_CARE = "beautySubcategoryEyeCare";
export const BEAUTY_SUBCATEGORY_FEMININE_HYGIENE =
  "beautySubcategoryFeminineHygiene";
export const BEAUTY_SUBCATEGORY_FIRST_AID = "beautySubcategoryFirstAid";
export const BEAUTY_SUBCATEGORY_HAIR_CARE = "beautySubcategoryHairCare";
export const BEAUTY_SUBCATEGORY_MEDICAL_DEVICES =
  "beautySubcategoryMedicalDevices";
export const BEAUTY_SUBCATEGORY_MOBILITY_EQUIPMENT =
  "beautySubcategoryMobilityEquipment";
export const BEAUTY_SUBCATEGORY_NUTRITIONAL_SUPPLEMENTS =
  "beautySubcategoryNutritionalSupplements";
export const BEAUTY_SUBCATEGORY_MEDICATIONS = "beautySubcategoryMedications";
export const BEAUTY_SUBCATEGORY_PERSONAL_HYGIENE =
  "beautySubcategoryPersonalHygiene";
export const BEAUTY_SUBCATEGORY_SCALES = "beautySubcategoryScales";
export const BEAUTY_SUBCATEGORY_SKIN_CARE = "beautySubcategorySkinCare";
export const BEAUTY_SUBCATEGORY_VITAMINS = "beautySubcategoryVitamins";
export const BEAUTY_SUBCATEGORY_FACIAL_TISSUES =
  "beautySubcategoryFacialTissues";
export const PETS_SUBCATEGORY_FOOD = "petsSubcategoryFood";
export const PETS_SUBCATEGORY_COSMETICS = "petsSubcategoryCosmetics";
export const PETS_SUBCATEGORY_ACCESSORIES = "petsSubcategoryAccessories";
export const PETS_SUBCATEGORY_CLOTHING = "petsSubcategoryClothing";
export const PETS_SUBCATEGORY_MEDICATIONS = "petsSubcategoryMedications";
export const HOME_SUBCATEGORY_TEXTILES_CARPETS =
  "homeSubcategoryTextilesCarpets";
export const HOME_SUBCATEGORY_ART_PRINTS = "homeSubcategoryArtPrints";
export const HOME_SUBCATEGORY_STORAGE_ORGANIZATION =
  "homeSubcategoryStorageOrganization";
export const HOME_SUBCATEGORY_PLANT_DECOR = "homeSubcategoryPlantDecor";
export const HOME_SUBCATEGORY_CURTAINS_BLINDS = "homeSubcategoryCurtainsBlinds";

//OPTIONS
export const BODY_BUILD_THIN = "bodyBuildThin";
export const BODY_BUILD_AVERAGE = "bodyBuildAverage";
export const BODY_BUILD_ATHLETIC = "bodyBuildAthletic";
export const BODY_BUILD_WIDE = "bodyBuildWide";
export const BODY_BUILD_MUSCULAR = "bodyBuildMuscular";
export const BODY_BUILD_CURVY = "bodyBuildCurvy";

export const CLOTHING_STYLE_CASUAL = "clothingStyleCasual";
export const CLOTHING_STYLE_FORMAL = "clothingStyleFormal";
export const CLOTHING_STYLE_SPORTY = "clothingStyleSporty";
export const CLOTHING_STYLE_BUSINESS = "clothingStyleBusiness";
export const CLOTHING_STYLE_ELEGANT = "clothingStyleElegant";
export const CLOTHING_STYLE_TRENDY = "clothingStyleTrendy";
export const CLOTHING_STYLE_STREETWEAR = "clothingStyleStreetwear";
export const CLOTHING_STYLE_TRADITIONAL = "clothingStyleTraditional";
export const CLOTHING_STYLE_VINTAGE = "clothingStyleVintage";
export const CLOTHING_STYLE_BOHEMIAN = "clothingStyleBohemian";
export const CLOTHING_STYLE_HIPSTER = "clothingStyleHipster";
export const CLOTHING_STYLE_PUNK = "clothingStylePunk";
export const CLOTHING_STYLE_GOTHIC = "clothingStyleGothic";

export const DISTINGUISHING_FEATURES_TATTOOS = "distinguishingFeaturesTattoos";
export const DISTINGUISHING_FEATURES_SCARS = "distinguishingFeaturesScars";
export const DISTINGUISHING_FEATURES_BIRTHMARKS =
  "distinguishingFeaturesBirthmarks";
export const DISTINGUISHING_FEATURES_FRECKLES =
  "distinguishingFeaturesFreckles";
export const DISTINGUISHING_FEATURES_MOLES = "distinguishingFeaturesMoles";
export const DISTINGUISHING_FEATURES_PIERCINGS =
  "distinguishingFeaturesPiercings";
export const DISTINGUISHING_FEATURES_DIMPLES = "distinguishingFeaturesDimples";
export const DISTINGUISHING_FEATURES_WRINKLES =
  "distinguishingFeaturesWrinkles";
export const DISTINGUISHING_FEATURES_GLASSES = "distinguishingFeaturesGlasses";
export const DISTINGUISHING_FEATURES_BRACES = "distinguishingFeaturesBraces";
export const DISTINGUISHING_FEATURES_MAKEUP = "distinguishingFeaturesMakeup";
export const DISTINGUISHING_FEATURES_HAIR_ACCESSORIES =
  "distinguishingFeaturesHairAccessories";
export const DISTINGUISHING_FEATURES_BEARD = "distinguishingFeaturesBeard";
export const DISTINGUISHING_FEATURES_MUSTACHE =
  "distinguishingFeaturesMustache";

export const CONTENT_STYLE_ELEGANT = "contentStyleElegant";
export const CONTENT_STYLE_AESTHETIC = "contentStyleAesthetic";
export const CONTENT_STYLE_RAW = "contentStyleRaw";
export const CONTENT_STYLE_MINIMALISTIC = "contentStyleMinimalistic";
export const CONTENT_STYLE_ARTISTIC = "contentStyleArtistic";
export const CONTENT_STYLE_VINTAGE = "contentStyleVintage";
export const CONTENT_STYLE_MODERN = "contentStyleModern";
export const CONTENT_STYLE_PLAYFUL = "contentStylePlayful";
export const CONTENT_STYLE_RUSTIC = "contentStyleRustic";
export const CONTENT_STYLE_MONOCHROMATIC = "contentStyleMonochromatic";

export const EMPLOYEES_2_10 = "employees2-10";
export const EMPLOYEES_10_20 = "employees10-20";
export const EMPLOYEES_20_50 = "employees20-50";
export const EMPLOYEES_50_100 = "employees50-100";
export const EMPLOYEES_100_THAN = "employees100-than";

export const PRODUCT_AVAILABILITY_LOCAL = "productAvailabilityLocal";
export const PRODUCT_AVAILABILITY_NATIONAL = "productAvailabilityNational";
export const PRODUCT_AVAILABILITY_INTERNATIONAL =
  "productAvailabilityInternational";

export const INSTAGRAM = "instagram";
export const FACEBOOK = "facebook";
export const X = "x";
export const THREADS = "threads";
export const TIKTOK = "tiktok";
export const LINKEDIN = "linkedIn";
export const META = "meta";
export const META_FACEBOOK_AND_INSTAGRAM = "metaFacebookAndInstagram";
export const GOOGLE = "google";
export const YOUTUBE = "youtube";
export const WHATSAPP = "whatsapp";
export const ORGANIC = "organic";

// TikTok Privacy Levels
export const TIKTOK_PRIVACY_LEVEL_PUBLIC_TO_EVERYONE =
  "tiktokPrivacyLevelPublicToEveryone";
export const TIKTOK_PRIVACY_LEVEL_MUTUAL_FOLLOW_FRIENDS =
  "tiktokPrivacyLevelMutualFollowFriends";
export const TIKTOK_PRIVACY_LEVEL_FOLLOWER_OF_CREATOR =
  "tiktokPrivacyLevelFollowerOfCreator";
export const TIKTOK_PRIVACY_LEVEL_SELF_ONLY = "tiktokPrivacyLevelSelfOnly";
export const TIKTOK_PRIVACY_LEVEL_LABEL = "tiktokPrivacyLevelLabel";
export const TIKTOK_ACCOUNT_LABEL = "tiktokAccountLabel";
export const TYPE_CONTENT_TIKTOK_LABEL = "typeContentTikTokLabel";
export const MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL =
  "modalUploadTikTokTypePostLabel";

// Unified Carousel translation key
export const CONTENT_TYPE_CAROUSEL = "contentTypeCarousel";

// Content type change confirmation
export const CONFIRM_CHANGE_CONTENT_TYPE_TITLE =
  "confirmChangeContentTypeTitle";
export const CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_CAROUSEL =
  "confirmChangeContentTypeMessageCarousel";
export const CONFIRM_CHANGE_CONTENT_TYPE_MESSAGE_POST =
  "confirmChangeContentTypeMessagePost";

export const CONFIRM_REGENERATE_TEXTS_AFTER_CREATIVE_CHANGE_TITLE =
  "confirmRegenerateTextsAfterCreativeChangeTitle";
export const BUTTON_KEEP_TEXTS = "buttonKeepTexts";
export const REGENERATING_AD_TEXTS_OVERLAY_MESSAGE =
  "regeneratingAdTextsOverlayMessage";

// TikTok Post Settings
export const TIKTOK_DISABLE_DUET_LABEL = "tiktokDisableDuetLabel";
export const TIKTOK_DISABLE_DUET_DESCRIPTION = "tiktokDisableDuetDescription";
export const TIKTOK_DISABLE_STITCH_LABEL = "tiktokDisableStitchLabel";
export const TIKTOK_DISABLE_STITCH_DESCRIPTION =
  "tiktokDisableStitchDescription";
export const TIKTOK_DISABLE_COMMENT_LABEL = "tiktokDisableCommentLabel";
export const TIKTOK_DISABLE_COMMENT_DESCRIPTION =
  "tiktokDisableCommentDescription";
export const TIKTOK_AUTO_ADD_MUSIC_LABEL = "tiktokAutoAddMusicLabel";
export const TIKTOK_IS_AIGC_LABEL = "tiktokIsAigcLabel";
export const TIKTOK_IS_AIGC_DESCRIPTION = "tiktokIsAigcDescription";

export const DARK_KITCHEN = "darkKitchen";
export const OTHERS = "others";

export const ADS_CAMPAIGN_OBJECTIVE_AWARENESS = "adsCampaignObjectiveAwareness";
export const ADS_CAMPAIGN_OBJECTIVE_TRAFFIC = "adsCampaignObjectiveTraffic";
export const ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT =
  "adsCampaignObjectiveEngagement";
export const ADS_CAMPAIGN_OBJECTIVE_LEADS = "adsCampaignObjectiveLeads";
export const ADS_CAMPAIGN_OBJECTIVE_LEADS_LINKEDIN =
  "adsCampaignObjectiveLeadsLinkedin";
export const ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION =
  "adsCampaignObjectiveAppPromotion";
export const ADS_CAMPAIGN_OBJECTIVE_SALES = "adsCampaignObjectiveSales";
export const ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS =
  "adsCampaignObjectiveVideoViews";
export const ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS =
  "adsCampaignObjectiveWebsiteConversions";
export const ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL =
  "adsCampaignAppPromotionTypeAppInstall";
export const ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_RETARGETING =
  "adsCampaignAppPromotionTypeAppRetargeting";
export const ADS_CAMPAIGN_TYPE_SEARCH = "adsCampaignTypeSearch";
export const ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX =
  "adsCampaignTypePerformanceMax";
export const ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_TITLE_EXPLANATION =
  "adsCampaignsTypePerformanceMaxTitleExplanation";
export const ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_DESCRIPTION_EXPLANATION =
  "adsCampaignsTypePerformanceMaxDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_APP = "adsCampaignTypeApp";
export const ADS_CAMPAIGN_TYPE_SHOPPING = "adsCampaignTypeShopping";
export const ADS_CAMPAIGN_TYPE_VIDEO = "adsCampaignTypeVideo";
export const ADS_CAMPAIGN_APP_PROMOTION_ANDROID =
  "adsCampaignAppPromotionAndroid";
export const ADS_CAMPAIGN_APP_PROMOTION_IOS = "adsCampaignAppPromotionIos";
export const APP_STORE_ANDROID = "appStoreAndroid";
export const APP_STORE_IOS = "appStoreIos";
export const APP_STORE_PLACEHOLDER = "appStorePlaceholder";
export const ADS_CAMPAIGN_APP_PROMOTION_BOTH = "adsCampaignAppPromotionBoth";
export const ADS_CAMPAIGN_TYPE_BUDGET_DAILY = "adsCampaignTypeBudgetDaily";
export const ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME =
  "adsCampaignTypeBudgetLifetime";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MENU =
  "adsCampaignCallToActionSeeMenu";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SHOP_NOW =
  "adsCampaignCallToActionShopNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SIGN_UP =
  "adsCampaignCallToActionSignUp";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SUBSCRIBE =
  "adsCampaignCallToActionSubscribe";
export const ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_MORE =
  "adsCampaignCallToActionWatchMore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_APPLY_NOW =
  "adsCampaignCallToActionApplyNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_APPLY = "adsCampaignCallToActionApply";
export const ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_QUOTE =
  "adsCampaignCallToActionViewQuote";
export const ADS_CAMPAIGN_CALL_TO_ACTION_JOIN = "adsCampaignCallToActionJoin";
export const ADS_CAMPAIGN_CALL_TO_ACTION_ATTEND =
  "adsCampaignCallToActionAttend";
export const ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_DEMO =
  "adsCampaignCallToActionRequestDemo";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SEE_MORE =
  "adsCampaignCallToActionSeeMore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_REGISTER =
  "adsCampaignCallToActionRegister";
export const ADS_CAMPAIGN_CALL_TO_ACTION_BOOK_NOW =
  "adsCampaignCallToActionBookNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_CALL_NOW =
  "adsCampaignCallToActionCallNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_CONTACT_US =
  "adsCampaignCallToActionContactUs";
export const ADS_CAMPAIGN_CALL_TO_ACTION_DOWNLOAD =
  "adsCampaignCallToActionDownload";
export const ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT =
  "adsCampaignCallToActionUnlockFullDocument";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_DIRECTIONS =
  "adsCampaignCallToActionGetDirections";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_QUOTE =
  "adsCampaignCallToActionGetQuote";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_SHOWTIMES =
  "adsCampaignCallToActionGetShowtimes";
export const ADS_CAMPAIGN_CALL_TO_ACTION_LEARN_MORE =
  "adsCampaignCallToActionLearnMore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE =
  "adsCampaignCallToActionSendWhatsappMessage";
export const ADS_CAMPAIGN_CALL_TO_ACTION_LISTEN_NOW =
  "adsCampaignCallToActionListenNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE =
  "adsCampaignCallToActionSendMessage";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM =
  "adsCampaignCallToActionSendMessageInstagram";
export const ADS_CAMPAIGN_CALL_TO_ACTION_ORDER_NOW =
  "adsCampaignCallToActionOrderNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_REQUEST_TIME =
  "adsCampaignCallToActionRequestTime";
export const ADS_CAMPAIGN_CALL_TO_ACTION_SAVE = "adsCampaignCallToActionSave";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_OFFER =
  "adsCampaignCallToActionGetOffer";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_PROMOTIONS =
  "adsCampaignCallToActionGetPromotions";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_ACCESS =
  "adsCampaignCallToActionGetAccess";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_UPDATES =
  "adsCampaignCallToActionGetUpdates";
export const ADS_CAMPAIGN_CALL_TO_ACTION_INQUIRE_NOW =
  "adsCampaignCallToActionInquireNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_BUY_TICKETS =
  "adsCampaignCallToActionBuyTickets";
export const ADS_CAMPAIGN_CALL_TO_ACTION_PLAY_GAME =
  "adsCampaignCallToActionPlayGame";
export const ADS_CAMPAIGN_CALL_TO_ACTION_EXPLORE_MORE =
  "adsCampaignCallToActionExploreMore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_INSTALL_NOW =
  "adsCampaignCallToActionInstallNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_USE_APP =
  "adsCampaignCallToActionUseApp";
export const ADS_CAMPAIGN_CALL_TO_ACTION_WATCH_NOW =
  "adsCampaignCallToActionWatchNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_READ_MORE =
  "adsCampaignCallToActionReadMore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_NOW =
  "adsCampaignCallToActionViewMore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_INTERESTED =
  "adsCampaignCallToActionInterested";
export const ADS_CAMPAIGN_CALL_TO_ACTION_GET_TICKETS_NOW =
  "adsCampaignCallToActionGetTicketsNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_EXPERIENCE_NOW =
  "adsCampaignCallToActionExperienceNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_PRE_ORDER_NOW =
  "adsCampaignCallToActionPreOrderNow";
export const ADS_CAMPAIGN_CALL_TO_ACTION_VISIT_STORE =
  "adsCampaignCallToActionVisitStore";
export const ADS_CAMPAIGN_CALL_TO_ACTION_VIEW_PROFILE =
  "adsCampaignCallToActionViewProfile";
export const ADS_CAMPAIGN_CALL_TO_ACTION_DYNAMIC =
  "adsCampaignCallToActionDynamic";
export const ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE =
  "adsCampaignCustomAudienceTypeWebsite";
export const ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST =
  "adsCampaignCustomAudienceTypeCustomerList";
export const ADS_CAMPAIGN_CUSTOM_EVENT_ADD_PAYMENT_INFO =
  "adsCampaignCustomEventAddPaymentInfo";
export const ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_CART =
  "adsCampaignCustomEventAddToCart";
export const ADS_CAMPAIGN_CUSTOM_EVENT_ADD_TO_WISHLIST =
  "adsCampaignCustomEventAddToWishlist";
export const ADS_CAMPAIGN_CUSTOM_EVENT_COMPLETE_REGISTRATION =
  "adsCampaignCustomEventCompleteRegistration";
export const ADS_CAMPAIGN_CUSTOM_EVENT_DONATE = "adsCampaignCustomEventDonate";
export const ADS_CAMPAIGN_CUSTOM_EVENT_INITIATED_CHECKOUT =
  "adsCampaignCustomEventInitiatedCheckout";
export const ADS_CAMPAIGN_CUSTOM_EVENT_PURCHASE =
  "adsCampaignCustomEventPurchase";
export const ADS_CAMPAIGN_CUSTOM_EVENT_SEARCH = "adsCampaignCustomEventSearch";
export const ADS_CAMPAIGN_CUSTOM_EVENT_START_TRIAL =
  "adsCampaignCustomEventStartTrial";
export const ADS_CAMPAIGN_CUSTOM_EVENT_SUBSCRIBE =
  "adsCampaignCustomEventSubscribe";
export const ADS_CAMPAIGN_CUSTOM_EVENT_CONTACT =
  "adsCampaignCustomEventContact";
export const ADS_CAMPAIGN_CUSTOM_EVENT_CUSTOMIZE_PRODUCT =
  "adsCampaignCustomEventCustomizeProduct";
export const ADS_CAMPAIGN_CUSTOM_EVENT_FIND_LOCATION =
  "adsCampaignCustomEventFindLocation";
export const ADS_CAMPAIGN_CUSTOM_EVENT_LEAD = "adsCampaignCustomEventLead";
export const ADS_CAMPAIGN_CUSTOM_EVENT_SCHEDULE =
  "adsCampaignCustomEventSchedule";
export const ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_APPLICATION =
  "adsCampaignCustomEventSubmitApplication";
export const ADS_CAMPAIGN_CUSTOM_EVENT_CONTENT_VIEW =
  "adsCampaignCustomEventContentView";
export const ADS_CAMPAIGN_CUSTOM_EVENT_SUBMIT_FORM =
  "adsCampaignCustomEventSubmitForm";
export const ADS_CAMPAIGN_CUSTOM_EVENT_CLICK_BUTTON =
  "adsCampaignCustomEventClickButton";
export const ADS_CAMPAIGN_CUSTOM_EVENT_PLACE_ORDER =
  "adsCampaignCustomEventPlaceOrder";
export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD =
  "MOBILE_FEED_STANDARD";
export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE =
  "FACEBOOK_REELS_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY = "FACEBOOK_STORY_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY = "INSTAGRAM_STORY";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL = "INSTAGRAM_REELS";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED = "INSTAGRAM_FEED_WEB";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD = "INSTAGRAM_STANDARD";
export const ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO = "SINGLE_VIDEO";
export const ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS = "CAROUSEL_ADS";
export const ADS_CAMPAIGN_AD_FORMAT_GOOGLE_SEARCH = "GOOGLE_SEARCH";
export const ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_IMAGE =
  "adsCampaignLinkedinAdFormatImage";
export const ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_VIDEO =
  "adsCampaignLinkedinAdFormatVideo";
export const ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_CAROUSEL =
  "adsCampaignLinkedinAdFormatCarousel";
export const ADS_CAMPAIGN_LINKEDIN_AD_FORMAT_DOCUMENT =
  "adsCampaignLinkedinAdFormatDocument";
export const ADS_CAMPAIGN_LINKEDIN_AD_SETUP = "adsCampaignLinkedinAdSetup";
export const ADS_CAMPAIGN_LINKEDIN_AD_SETUP_CREATE_AD =
  "adsCampaignLinkedinAdSetupCreateAd";
export const ADS_CAMPAIGN_LINKEDIN_AD_SETUP_USE_POST =
  "adsCampaignLinkedinAdSetupUsePost";
export const ADS_CAMPAIGN_LINKEDIN_USE_POST_VIDEO_DOWNLOAD_URL_MISSING =
  "adsCampaignLinkedinUsePostVideoDownloadUrlMissing";
export const AD_FORMAT_PLACEHOLDER = "adFormatPlaceholder";
export const SELECT_AD_FORMAT_TO_CONTINUE = "selectAdFormatToContinue";
export const ADS_META_DESTINATION_TYPE_NONE = "adsMetaDestinationTypeNone";
export const ADS_META_DESTINATION_TYPE_WEBSITE =
  "adsMetaDestinationTypeWebsite";
export const ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE =
  "adsMetaDestinationTypeWebsiteAppAndInStore";
export const ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP =
  "adsMetaDestinationTypeWebsiteAndApp";
export const ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE =
  "adsMetaDestinationTypeWebsiteAndInStore";
export const ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE =
  "adsMetaDestinationTypeInstagramProfile";
export const ADS_META_DESTINATION_TYPE_ON_VIDEO =
  "adsMetaDestinationTypeOnVideo";
export const ADS_META_DESTINATION_TYPE_ON_POST = "adsMetaDestinationTypeOnPost";
export const ADS_META_DESTINATION_TYPE_WHATSAPP =
  "adsMetaDestinationTypeWhatsapp";
export const ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM =
  "adsMetaDestinationTypeMessagesOnInstagram";
export const ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER =
  "adsMetaDestinationTypeMessagesOnMesenger";
export const ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER =
  "adsMetaDestinationTypeMessagesOnInstagramAndMesenger";
export const ADS_META_DESTINATION_TYPE_INSTANT_FORM =
  "adsMetaDestinationTypeInstantForm";
export const ADS_CAMPAIGN_REPORT_BREAKDOWN_WEEKLY = "weekly";
export const ADS_CAMPAIGN_REPORT_BREAKDOWN_MONTHLY = "monthly";
export const ADS_META_DESTINATION_TYPE_CATALOG =
  "adsMetaDestinationTypeCatalog";
export const ADS_META_DESTINATION_TYPE_GOOGLE_PLAY =
  "adsMetaDestinationTypeGooglePlay";
export const ADS_META_DESTINATION_TYPE_APP_STORE =
  "adsMetaDestinationTypeAppStore";
export const ADS_META_DESTINATION_TYPE_APP = "adsMetaDestinationTypeApp";
export const ADS_CAMPAIGN_BUYING_TYPE_RESERVED =
  "adsCampaignBuyingTypeReserved";
export const ADS_CAMPAIGN_BUYING_TYPE_AUCTION = "adsCampaignBuyingTypeAuction";

export const ADS_TIKTOK_APP_EVENT_ACTIVE_OPTION =
  "adsTikTokAppEventActiveOption";
export const ADS_TIKTOK_APP_EVENT_DOWNLOAD_START_OPTION =
  "adsTikTokAppEventDownloadStartOption";
export const ADS_TIKTOK_APP_EVENT_ACTIVE_REGISTER_OPTION =
  "adsTikTokAppEventActiveRegisterOption";
export const ADS_TIKTOK_APP_EVENT_ACTIVE_PAY_OPTION =
  "adsTikTokAppEventActivePayOption";
export const ADS_TIKTOK_APP_EVENT_IN_APP_ORDER_OPTION =
  "adsTikTokAppEventInAppOrderOption";
export const ADS_TIKTOK_APP_EVENT_IN_APP_CART_OPTION =
  "adsTikTokAppEventInAppCartOption";
export const ADS_TIKTOK_APP_EVENT_IN_APP_DETAIL_UV_OPTION =
  "adsTikTokAppEventInAppDetailUvOption";
export const ADS_TIKTOK_APP_EVENT_NEXT_DAY_OPEN_OPTION =
  "adsTikTokAppEventNextDayOpenOption";
export const ADS_TIKTOK_APP_EVENT_LOGIN_OPTION = "adsTikTokAppEventLoginOption";
export const ADS_TIKTOK_APP_EVENT_LAUNCH_APP_OPTION =
  "adsTikTokAppEventLaunchAppOption";
export const ADS_TIKTOK_APP_EVENT_COMPLETE_TUTORIAL_OPTION =
  "adsTikTokAppEventCompleteTutorialOption";
export const ADS_TIKTOK_APP_EVENT_SEARCH_OPTION =
  "adsTikTokAppEventSearchOption";
export const ADS_TIKTOK_APP_EVENT_START_TRIAL_OPTION =
  "adsTikTokAppEventStartTrialOption";
export const ADS_TIKTOK_APP_EVENT_SUBSCRIBE_OPTION =
  "adsTikTokAppEventSubscribeOption";

export const KEYWORD_BROAD_MATCH_TYPE_OPTION = "keywordBroadMatchTypeOption";
export const KEYWORD_PHRASE_MATCH_TYPE_OPTION = "keywordPhraseMatchTypeOption";
export const KEYWORD_EXACT_MATCH_TYPE_OPTION = "keywordExactMatchTypeOption";

export const ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION =
  "adsCampaignMetaIsDynamicCreativeQuestion";
export const ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION =
  "adsCampaignMetaIsDynamicCreativeDescription";
export const ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_ABOUT_LINK =
  "adsCampaignMetaIsDynamicCreativeAboutLink";
export const ADS_CAMPAIGN_META_AD_SETUP = "adsCampaignMetaAdSetup";
export const ADS_CAMPAIGN_META_AD_SETUP_CREATE_AD =
  "adsCampaignMetaAdSetupCreateAd";
export const ADS_CAMPAIGN_META_AD_SETUP_USE_POST =
  "adsCampaignMetaAdSetupUsePost";
export const ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD =
  "adsCampaignMetaAdSetupUseExistingAd";
export const ADS_CAMPAIGN_META_AD_SETUP_USE_EXISTING_AD_HINT =
  "adsCampaignMetaAdSetupUseExistingAdHint";
export const MODAL_META_REUSE_CREATIVES_TITLE = "modalMetaReuseCreativesTitle";
export const MODAL_META_REUSE_CREATIVES_DESCRIPTION =
  "modalMetaReuseCreativesDescription";
export const MODAL_META_REUSE_CREATIVES_EMPTY = "modalMetaReuseCreativesEmpty";
export const MODAL_META_REUSE_CREATIVES_VALID = "modalMetaReuseCreativesValid";
export const MODAL_META_REUSE_CREATIVES_INVALID =
  "modalMetaReuseCreativesInvalid";
export const MODAL_META_REUSE_CREATIVES_FILTER_ACTIVE =
  "modalMetaReuseCreativesFilterActive";
export const MODAL_META_REUSE_CREATIVES_CLEAR_FILTER =
  "modalMetaReuseCreativesClearFilter";
export const MODAL_META_REUSE_CREATIVES_OPTIMIZATION_WARN =
  "modalMetaReuseCreativesOptimizationWarn";
export const MODAL_META_REUSE_CREATIVES_COLUMN_COMPATIBILITY =
  "modalMetaReuseCreativesColumnCompatibility";
export const MODAL_META_REUSE_CREATIVES_COLUMN_TEXTS =
  "modalMetaReuseCreativesColumnTexts";
export const MODAL_META_REUSE_CREATIVES_COLUMN_ENGAGEMENT =
  "modalMetaReuseCreativesColumnEngagement";
export const ADS_CAMPAIGN_META_PARTNERSHIP_AD_SECTION =
  "adsCampaignMetaPartnershipAdSection";
export const ADS_CAMPAIGN_META_PARTNERSHIP_AD_TOGGLE =
  "adsCampaignMetaPartnershipAdToggle";
export const ADS_CAMPAIGN_META_PARTNERSHIP_IDENTITY_ORDER =
  "adsCampaignMetaPartnershipIdentityOrder";
export const ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_FIRST =
  "adsCampaignMetaPartnershipOrderFirst";
export const ADS_CAMPAIGN_META_PARTNERSHIP_PARTNER_NAME_FALLBACK =
  "adsCampaignMetaPartnershipPartnerNameFallback";
export const ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_CAMPAIGN_FIRST =
  "adsCampaignMetaPartnershipOrderCampaignFirst";
export const ADS_CAMPAIGN_META_PARTNERSHIP_ORDER_PARTNER_FIRST_LABEL =
  "adsCampaignMetaPartnershipOrderPartnerFirstLabel";
export const ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_PAGE =
  "adsCampaignMetaPartnershipSponsorPage";
export const ADS_CAMPAIGN_META_PARTNERSHIP_APPROVAL_WARNING =
  "adsCampaignMetaPartnershipApprovalWarning";
export const ADS_CAMPAIGN_META_PARTNERSHIP_SPONSOR_INSTAGRAM =
  "adsCampaignMetaPartnershipSponsorInstagram";
export const ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK =
  "adsCampaignMetaFallbackDeeplinkWithWebFallback";
export const ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK =
  "adsCampaignMetaFallbackDeeplinkWithAppstoreFallback";
export const ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY =
  "adsCampaignMetaFallbackWebOnly";
export const ADS_CAMPAIGN_META_FALLBACK_CATALOG =
  "adsCampaignMetaFallbackCatalog";
export const ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_LABEL =
  "adsCampaignMetaFallbackWebOnlyLabel";
export const ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_LABEL =
  "adsCampaignMetaFallbackDeeplinkWithWebFallbackLabel";
export const ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_LABEL =
  "adsCampaignMetaFallbackDeeplinkWithAppstoreFallbackLabel";
export const DESTINATION_FALLBACK_CONFIGURATION_TITLE =
  "destinationFallbackConfigurationTitle";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_QUESTION =
  "adsCampaignMetaSpecialAdCategoriesQuestion";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_DESCRIPTION =
  "adsCampaignMetaSpecialAdCategoriesDescription";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_PLACEHOLDER =
  "adsCampaignMetaSpecialAdCategoriesPlaceholder";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_HOUSING =
  "adsCampaignMetaSpecialAdCategoriesOptionHousing";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT =
  "adsCampaignMetaSpecialAdCategoriesOptionEmployment";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_FINANCIAL_PRODUCTS_SERVICES =
  "adsCampaignMetaSpecialAdCategoriesOptionFinancialProductsServices";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_OPTION_ISSUES_ELECTIONS_POLITICS =
  "adsCampaignMetaSpecialAdCategoriesOptionIssuesElectionsPolitics";

export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER =
  "adsCampaignTikTokSpecialAdCategoriesPlaceholder";
export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_HOUSING =
  "adsCampaignTikTokSpecialAdCategoriesOptionHousing";
export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_EMPLOYMENT =
  "adsCampaignTikTokSpecialAdCategoriesOptionEmployment";
export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_OPTION_CREDIT =
  "adsCampaignTikTokSpecialAdCategoriesOptionCredit";

export const LESS_500K = "-500000";
export const BETWEEN_500K_1M = "500000-1000000";
export const BETWEEN_1M_2_5M = "1000000-2500000";
export const BETWEEN_2_5M_5M = "2500000-5000000";
export const MORE_5M = "5000000+";
export const LESS_1M = "-1000000";
export const BETWEEN_1M_5M = "1000000-5000000";
export const BETWEEN_5M_15M = "5000000-15000000";
export const BETWEEN_15M_30M = "15000000-30000000";
export const BETWEEN_30M_100M = "30000000-100000000";
export const MORE_100M = "100000000+";
export const LESS_150 = "-150";
export const BETWEEN_150_250 = "150-250";
export const BETWEEN_250_650 = "250-650";
export const BETWEEN_650_1250 = "650-1250";
export const MORE_1250 = "1250+";
export const LESS_250 = "-250";
export const BETWEEN_250_1250 = "250-1250";
export const BETWEEN_1250_3750 = "1250-3750";
export const BETWEEN_3750_7500 = "3750-7500";
export const BETWEEN_7500_25K = "7500-25000";
export const MORE_25K = "25000+";
export const LESS_1000 = "-1000";
export const BETWEEN_1000_5000 = "1000-5000";
export const BETWEEN_5000_15K = "5000-15000";
export const BETWEEN_15K_30K = "15000-30000";
export const BETWEEN_30K_60K = "30000-60000";
export const MORE_60K = "60000+";
export const BETWEEN_1000_2000 = "1000-2000";
export const BETWEEN_2000_5000 = "2000-5000";
export const BETWEEN_5000_10K = "5000-10000";
export const MORE_10K = "10000+";

export const DOCUMENT_CC = "cc";
export const DOCUMENT_CE = "ce";
export const DOCUMENT_NUIP = "nuip";
export const DOCUMENT_NIT = "nit";
export const DOCUMENT_CI = "ci";
export const DOCUMENT_PASSPORT = "passport";
export const DOCUMENT_EIN = "ein";
export const DOCUMENT_RUC = "ruc";
export const DOCUMENT_ID = "id";
export const DOCUMENT_ID_EMIRATES = "idEmirates";
export const DOCUMENT_TRN = "trn";

//EXPLANATIONS TOOLTIP
export const ADS_CAMPAIGN_OBJECTIVE_AWARENESS_TITLE_EXPLANATION =
  "adsCampaignObjectiveAwarenessTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_AWARENESS_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveAwarenessDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_TITLE_EXPLANATION =
  "adsCampaignObjectiveTrafficTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveTrafficDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_TITLE_EXPLANATION =
  "adsCampaignObjectiveEngagementTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveEngagementDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_LEADS_TITLE_EXPLANATION =
  "adsCampaignObjectiveLeadsTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_LEADS_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveLeadsDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_TITLE_EXPLANATION =
  "adsCampaignObjectiveAppPromotionTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveAppPromotionDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_SALES_TITLE_EXPLANATION =
  "adsCampaignObjectiveSalesTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_SALES_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveSalesDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_TITLE_EXPLANATION =
  "adsCampaignObjectiveVideoViewsTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveVideoViewsDescriptionExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_TITLE_EXPLANATION =
  "adsCampaignObjectiveWebsiteConversionsTitleExplanation";
export const ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_DESCRIPTION_EXPLANATION =
  "adsCampaignObjectiveWebsiteConversionsDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_SEARCH_TITLE_EXPLANATION =
  "adsCampaignTypeSearchTitleExplanation";
export const ADS_CAMPAIGN_TYPE_SEARCH_DESCRIPTION_EXPLANATION =
  "adsCampaignTypeSearchDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_SHOPPING_TITLE_EXPLANATION =
  "adsCampaignTypeShoppingTitleExplanation";
export const ADS_CAMPAIGN_TYPE_SHOPPING_DESCRIPTION_EXPLANATION =
  "adsCampaignTypeShoppingDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_VIDEO_TITLE_EXPLANATION =
  "adsCampaignTypeVideoTitleExplanation";
export const ADS_CAMPAIGN_TYPE_VIDEO_DESCRIPTION_EXPLANATION =
  "adsCampaignTypeVideoDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_APP_TITLE_EXPLANATION =
  "adsCampaignTypeAppTitleExplanation";
export const ADS_CAMPAIGN_TYPE_APP_DESCRIPTION_EXPLANATION =
  "adsCampaignTypeAppDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_BUDGET_DAILY_TITLE_EXPLANATION =
  "adsCampaignTypeBudgetDailyTitleExplanation";
export const ADS_CAMPAIGN_TYPE_BUDGET_DAILY_DESCRIPTION_EXPLANATION =
  "adsCampaignTypeBudgetDailyDescriptionExplanation";
export const ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_TITLE_EXPLANATION =
  "adsCampaignTypeBudgetTotalTitleExplanation";
export const ADS_CAMPAIGN_TYPE_BUDGET_TOTAL_DESCRIPTION_EXPLANATION =
  "adsCampaignTypeBudgetTotalDescriptionExplanation";
export const ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_TITLE_EXPLANATION =
  "adsCampaignsCustomAudienceTypeWebsiteTitleExplanation";
export const ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_WEBSITE_DESCRIPTION_EXPLANATION =
  "adsCampaignsCustomAudienceTypeWebsiteDescriptionExplanation";
export const ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_TITLE_EXPLANATION =
  "adsCampaignsCustomAudienceTypeCustomerListTitleExplanation";
export const ADS_CAMPAIGNS_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_DESCRIPTION_EXPLANATION =
  "adsCampaignsCustomAudienceTypeCustomerListDescriptionExplanation";
export const ADS_CAMPAIGNS_PIXELS_TITLE_EXPLANATION =
  "adsCampaignsPixelsTitleExplanation";
export const ADS_CAMPAIGNS_PIXELS_DESCRIPTION_EXPLANATION =
  "adsCampaignsPixelsDescriptionExplanation";
export const ADVERTISER_ROLE_TITLE_EXPLANATION =
  "advertiserRoleTitleExplanation";
export const ADVERTISER_ROLE_DESCRIPTION_EXPLANATION =
  "advertiserRoleDescriptionExplanation";
export const MARKETER_ROLE_TILE_EXPLANATION = "marketerRoleTitleExplanation";
export const MARKETER_ROLE_DESCRIPTION_EXPLANATION =
  "marketerRoleDescriptionExplanation";
export const VIEWER_ROLE_TITLE_EXPLANATION = "viewerRoleTitleExplanation";
export const VIEWER_ROLE_DESCRIPTION_EXPLANATION =
  "viewerRoleDescriptionExplanation";
export const VIEWER_ROLE_READ_ONLY_CAPABILITY = "viewerRoleReadOnlyCapability";
export const VIEWER_CAPABILITY_VIEW_CAMPAIGNS = "viewerCapabilityViewCampaigns";
export const VIEWER_CAPABILITY_VIEW_CONTENT = "viewerCapabilityViewContent";
export const VIEWER_CAPABILITY_VIEW_CALENDAR = "viewerCapabilityViewCalendar";
export const VIEWER_CAPABILITY_VIEW_REPORTS = "viewerCapabilityViewReports";
export const DESIGNER_ROLE_TITLE_EXPLANATION = "designerRoleTitleExplanation";
export const ROLE_CAPABILITY_CAN_MANAGE_USERS = "roleCapabilityCanManageUsers";
export const ROLE_CAPABILITY_CAN_ACCESS_SETTINGS_ACCOUNTS =
  "roleCapabilityCanAccessSettingsAccounts";
export const ROLE_CAPABILITY_CAN_CREATE_CAMPAIGN =
  "roleCapabilityCanCreateCampaign";
export const ROLE_CAPABILITY_CAN_EDIT_CAMPAIGN =
  "roleCapabilityCanEditCampaign";
export const ROLE_CAPABILITY_CAN_USE_CAMPAIGN_AGENT =
  "roleCapabilityCanUseCampaignAgent";
export const ROLE_CAPABILITY_CAN_EDIT_GALLERY = "roleCapabilityCanEditGallery";
export const ROLE_CAPABILITY_CAN_POST = "roleCapabilityCanPost";
export const ROLE_CAPABILITY_CAN_EDIT_BRAND_SETUP =
  "roleCapabilityCanEditBrandSetup";
export const ROLE_CAPABILITY_CAN_EDIT_BILLING = "roleCapabilityCanEditBilling";

//ONBOARDING

//MAIN FUNCTIONALITY
export const MAIN_FUNCTIONALITY_STEP_1 = "mainFunctionalityStep1";
export const MAIN_FUNCTIONALITY_STEP_2 = "mainFunctionalityStep2";
export const MAIN_FUNCTIONALITY_STEP_3 = "mainFunctionalityStep3";
export const MAIN_FUNCTIONALITY_STEP_4 = "mainFunctionalityStep4";
export const PUBLICATIONS_FUNCTIONALITY_STEP_1 =
  "publicationsFunctionalityStep1";
export const PUBLICATIONS_FUNCTIONALITY_STEP_2 =
  "publicationsFunctionalityStep2";
export const PUBLICATIONS_FUNCTIONALITY_STEP_3 =
  "publicationsFunctionalityStep3";
export const PUBLICATIONS_FUNCTIONALITY_STEP_4 =
  "publicationsFunctionalityStep4";
export const PUBLICATION_FUNCTIONALITY_STEP_1 = "publicationFunctionalityStep1";
export const PUBLICATION_FUNCTIONALITY_STEP_2 = "publicationFunctionalityStep2";
export const PUBLICATION_FUNCTIONALITY_STEP_3 = "publicationFunctionalityStep3";
export const REVIEW_FUNCTIONALITY_STEP_1 = "reviewFunctionalityStep1";
export const REVIEW_FUNCTIONALITY_STEP_2 = "reviewFunctionalityStep2";
export const REVIEW_FUNCTIONALITY_STEP_3 = "reviewFunctionalityStep3";
export const REVIEW_FUNCTIONALITY_STEP_4 = "reviewFunctionalityStep4";
export const REVIEW_FUNCTIONALITY_STEP_5 = "reviewFunctionalityStep5";
export const MAIN_FUNCTIONALITY_ONBOARDING_FINISH =
  "mainFunctionalityOnboardingFinish";

//MENU FUNCTIONALITY
export const MENU_FUNCTIONALITY_STEP_1 = "menuFunctionalityStep1";
export const MENU_FUNCTIONALITY_STEP_2 = "menuFunctionalityStep2";
export const MENU_FUNCTIONALITY_STEP_3 = "menuFunctionalityStep3";
export const MENU_FUNCTIONALITY_STEP_4 = "menuFunctionalityStep4";
export const MENU_FUNCTIONALITY_STEP_5 = "menuFunctionalityStep5";
export const MENU_FUNCTIONALITY_STEP_6 = "menuFunctionalityStep6";
export const MENU_FUNCTIONALITY_STEP_7 = "menuFunctionalityStep7";
export const MENU_FUNCTIONALITY_STEP_8 = "menuFunctionalityStep8";
export const MENU_FUNCTIONALITY_STEP_9 = "menuFunctionalityStep9";
export const MENU_FUNCTIONALITY_STEP_10 = "menuFunctionalityStep10";
export const MENU_FUNCTIONALITY_STEP_11 = "menuFunctionalityStep11";
export const MENU_FUNCTIONALITY_STEP_12 = "menuFunctionalityStep12";

//USERS FUNCTIONALITY
export const USERS_FUNCTIONALITY_STEP_1 = "usersFunctionalityStep1";
export const USERS_FUNCTIONALITY_STEP_2 = "usersFunctionalityStep2";
export const USERS_FUNCTIONALITY_STEP_3 = "usersFunctionalityStep3";
export const USERS_FUNCTIONALITY_STEP_4 = "usersFunctionalityStep4";

//OPERATOR FUNCTIONALITY
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_1 =
  "mainFunctionalityOperatorStep1";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_2 =
  "mainFunctionalityOperatorStep2";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_3 =
  "mainFunctionalityOperatorStep3";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_4 =
  "mainFunctionalityOperatorStep4";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_5 =
  "mainFunctionalityOperatorStep5";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_6 =
  "mainFunctionalityOperatorStep6";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_7 =
  "mainFunctionalityOperatorStep7";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_8 =
  "mainFunctionalityOperatorStep8";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_9 =
  "mainFunctionalityOperatorStep9";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_10 =
  "mainFunctionalityOperatorStep10";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_11 =
  "mainFunctionalityOperatorStep11";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_12 =
  "mainFunctionalityOperatorStep12";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_13 =
  "mainFunctionalityOperatorStep13";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_14 =
  "mainFunctionalityOperatorStep14";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_15 =
  "mainFunctionalityOperatorStep15";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_16 =
  "mainFunctionalityOperatorStep16";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_17 =
  "mainFunctionalityOperatorStep17";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_18 =
  "mainFunctionalityOperatorStep18";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_19 =
  "mainFunctionalityOperatorStep19";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_20 =
  "mainFunctionalityOperatorStep20";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_21 =
  "mainFunctionalityOperatorStep21";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_22 =
  "mainFunctionalityOperatorStep22";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_23 =
  "mainFunctionalityOperatorStep23";
export const MAIN_FUNCTIONALITY_OPERATOR_STEP_24 =
  "mainFunctionalityOperatorStep24";

//CAMPAIGNS FUNCTIONALITY
export const CAMPAIGNS_FUNCTIONALITY_STEP_1 = "campaignsFunctionalityStep1";
export const CAMPAIGNS_FUNCTIONALITY_STEP_2 = "campaignsFunctionalityStep2";
export const CAMPAIGNS_FUNCTIONALITY_STEP_3 = "campaignsFunctionalityStep3";
export const CAMPAIGNS_FUNCTIONALITY_STEP_4 = "campaignsFunctionalityStep4";
export const CAMPAIGNS_FUNCTIONALITY_STEP_5 = "campaignsFunctionalityStep5";
export const CAMPAIGNS_FUNCTIONALITY_STEP_6 = "campaignsFunctionalityStep6";
export const CAMPAIGNS_FUNCTIONALITY_STEP_7 = "campaignsFunctionalityStep7";
export const CAMPAIGNS_FUNCTIONALITY_STEP_8 = "campaignsFunctionalityStep8";
export const CAMPAIGNS_FUNCTIONALITY_STEP_9 = "campaignsFunctionalityStep9";
export const CAMPAIGNS_FUNCTIONALITY_STEP_10 = "campaignsFunctionalityStep10";
export const CAMPAIGNS_FUNCTIONALITY_STEP_11 = "campaignsFunctionalityStep11";
export const CAMPAIGNS_FUNCTIONALITY_STEP_12 = "campaignsFunctionalityStep12";
export const CAMPAIGNS_FUNCTIONALITY_STEP_13 = "campaignsFunctionalityStep13";
export const CAMPAIGNS_FUNCTIONALITY_STEP_14 = "campaignsFunctionalityStep14";
export const CAMPAIGNS_FUNCTIONALITY_STEP_15 = "campaignsFunctionalityStep15";
export const CAMPAIGNS_FUNCTIONALITY_STEP_16 = "campaignsFunctionalityStep16";
export const CAMPAIGNS_FUNCTIONALITY_STEP_17 = "campaignsFunctionalityStep17";

//MODALS FUNCTIONALITY

//ALERTS
export const SAVE_LOCATION_SET_TITLE = "saveLocationSetTitle";
export const SAVE_LOCATION_SET_NAME_LABEL = "saveLocationSetNameLabel";
export const SAVE_LOCATION_SET_SAVE_BUTTON = "saveLocationSetSaveButton";
export const SAVE_LOCATION_SET_SAVING_BUTTON = "saveLocationSetSavingButton";
export const SAVE_LOCATION_SET_CANCEL_BUTTON = "saveLocationSetCancelButton";
export const PUBLISHING_ALERT_TITLE = "publishingAlertTitle";
export const PUBLISHING_ALERT_ERROR_TITLE = "publishingAlertErrorTitle";
export const PUBLISHING_ALERT_SUCCESS_TITLE = "publishingAlertSuccessTitle";
export const PUBLISHING_ALERT_RETRY_BUTTON = "publishingAlertRetryButton";
export const GENERATING_CAMPAIGN = "generatingCampaignTitle";
("publishingAlertGeneratingTitle");
export const CAMPAIGN_GENERATED_SUCCESS = "campaignGeneratedSuccess";
export const CAMPAIGN_GENERATED_ERROR = "campaignGeneratedError";
export const CAMPAIGN_GENERATED_ERROR_DESCRIPTION =
  "campaignGeneratedErrorDescription";
export const GENERATING_CREATIVE_TITLE = "generatingCreativeTitle";
export const GENERATING_CREATIVE_SUCCESS = "generatingCreativeSuccess";
export const GENERATING_CREATIVE_ERROR = "generatingCreativeError";
export const ALERT_GENERIC_ERROR_TITLE = "alertGenericErrorTitle";
export const GENERATING_CUSTOM_REPORT_MESSAGE = "generatingCustomReportMessage";
export const GENERATING_CUSTOM_REPORT_SUCCESS = "generatingCustomReportSuccess";
export const GENERATING_CUSTOM_REPORT_ERROR = "generatingCustomReportError";
export const ANALYZING_IMAGE_LAYERS_MESSAGE = "analyzingImageLayersMessage";
export const ANALYZING_IMAGE_LAYERS_SUCCESS = "analyzingImageLayersSuccess";
export const ANALYZING_IMAGE_LAYERS_ERROR = "analyzingImageLayersError";
export const ANALYZING_CREATIVE_TEMPLATE_MESSAGE =
  "analyzingCreativeTemplateMessage";
export const ANALYZING_CREATIVE_TEMPLATE_SUCCESS =
  "analyzingCreativeTemplateSuccess";
export const ANALYZING_CREATIVE_TEMPLATE_ERROR =
  "analyzingCreativeTemplateError";
export const PRODUCING_CREATIVE_TEMPLATE_MESSAGE =
  "producingCreativeTemplateMessage";
export const PRODUCING_CREATIVE_TEMPLATE_PREVIEW_MESSAGE =
  "producingCreativeTemplatePreviewMessage";
export const PRODUCING_CREATIVE_TEMPLATE_PREVIEW_SUCCESS =
  "producingCreativeTemplatePreviewSuccess";
export const PRODUCING_CREATIVE_TEMPLATE_PREVIEW_ERROR =
  "producingCreativeTemplatePreviewError";
export const PRODUCING_CREATIVE_TEMPLATE_SUCCESS =
  "producingCreativeTemplateSuccess";
export const PRODUCING_CREATIVE_TEMPLATE_ERROR =
  "producingCreativeTemplateError";
export const PRODUCING_CREATIVE_TEMPLATE_PARTIAL =
  "producingCreativeTemplatePartial";
export const PRODUCING_CREATIVE_TEMPLATE_PARTIAL_SINGULAR =
  "producingCreativeTemplatePartialSingular";
export const EDITING_IMAGE_TITLE = "editingImageTitle";
export const EDITING_IMAGE_SUCCESS = "editingImageSuccess";
export const EDITING_IMAGE_ERROR = "editingImageError";
export const RESIZING_IMAGE_TITLE = "resizingImageTitle";
export const RESIZING_IMAGE_SUCCESS = "resizingImageSuccess";
export const RESIZING_IMAGE_ERROR = "resizingImageError";
export const ANIMATING_IMAGE_TITLE = "animatingImageTitle";
export const ANIMATING_IMAGE_SUCCESS = "animatingImageSuccess";
export const ANIMATING_IMAGE_ERROR = "animatingImageError";
export const CHANGE_BUYING_TYPE_TO_RESERVED_TITLE =
  "changeBuyingTypeToReservedTitle";
export const CHANGE_BUYING_TYPE_TO_RESERVED_DESCRIPTION =
  "changeBuyingTypeToReservedDescription";
export const RESET_CHAT_ALERT_TITLE = "resetChatAlertTitle";
export const RESET_CHAT_ALERT_DESCRIPTION = "resetChatAlertDescription";
export const DISCARD_OPTIMIZATION_ALERT_TITLE = "discardOptimizationAlertTitle";
export const DISCARD_OPTIMIZATION_ALERT_DESCRIPTION =
  "discardOptimizationAlertDescription";
export const DISCARD_GENERATING_CREATIVE_ALERT_DESCRIPTION =
  "discardGeneratingCreativeAlertDescription";
export const DISCARD_GENERATING_VIDEO_ALERT_DESCRIPTION =
  "discardGeneratingVideoAlertDescription";
export const DISCARD_IMAGE_ANIMATION_ALERT_DESCRIPTION =
  "discardImageAnimationAlertDescription";
export const DISCARD_GENERATING_CUSTOM_REPORT_ALERT_DESCRIPTION =
  "discardGeneratingCustomReportAlertDescription";
export const DISCARD_ANALYZING_IMAGE_LAYERS_ALERT_DESCRIPTION =
  "discardAnalyzingImageLayersAlertDescription";
export const DISCARD_ANALYZING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION =
  "discardAnalyzingCreativeTemplateAlertDescription";
export const DISCARD_PRODUCING_CREATIVE_TEMPLATE_ALERT_DESCRIPTION =
  "discardProducingCreativeTemplateAlertDescription";
export const BUTTON_DISCARD_ALL = "buttonDiscardAll";
export const DISCARD_ALL_ACTIVITIES_TITLE = "discardAllActivitiesTitle";
export const DISCARD_ALL_ACTIVITIES_DESCRIPTION =
  "discardAllActivitiesDescription";

export const HIDE_ALERTS = "hideAlerts";
export const SHOW_ALERTS = "showAlerts";
export const ACTIVITY = "activity";
export const NO_TASKS = "noTasks";
export const NO_TASKS_DESCRIPTION = "noTasksDescription";
export const GLOBAL_ALERTS_PANEL_TITLE = "globalAlertsPanelTitle";
export const GLOBAL_ALERTS_EMPTY = "globalAlertsEmpty";
export const GLOBAL_ALERTS_EMPTY_DESCRIPTION = "globalAlertsEmptyDescription";
export const GLOBAL_ALERTS_BELL_ARIA = "globalAlertsBellAria";

//Saved location sets modal
export const SAVED_LOCATION_SETS_TITLE = "savedLocationSetsTitle";
export const SAVED_LOCATION_SETS_CLOSE_BUTTON = "savedLocationSetsCloseButton";

export const FIELD_OPEN_MAP_RADIUS_SELECT_TITLE =
  "fieldOpenMapRadiusSelectTitle";
export const FIELD_OPEN_MAP_RADIUS_SELECT_DESCRIPTION =
  "fieldOpenMapRadiusSelectDescription";

//Main buttons
export const LOAD_LOCATION_SET_BUTTON = "loadLocationSetButton";
export const SAVE_LOCATION_SET_BUTTON = "saveLocationSetButton";
export const SAVE_LOCATION_SET_SUCCESS = "saveLocationSetSuccess";
export const SAVE_LOCATION_SET_ERROR = "saveLocationSetError";
export const LOAD_LOCATION_SETS_ERROR = "loadLocationSetsError";
export const SAVE_LOCATION_SET_DUPLICATE_ERROR =
  "saveLocationSetDuplicateError";

export const METRICS_NOT_FOUND_MESSAGE = "metricsNotFoundMessage";
export const SEARCH_METRICS_PLACEHOLDER = "searchMetricsPlaceholder";
export const CONFIGURE_METRICS = "configureMetrics";
export const GENERAL_METRIC = "generalMetric";

//Other General metrics
export const REACH = "reach";
export const FREQUENCY = "frequency";
export const CPM_METRICS = "cpm";
export const CPC_METRICS = "cpc";
export const ESTIMATED_AUDIENCE_SIZE = "estimatedAudienceSize";
export const REACH_AT_TARGET_FREQUENCY = "reachAtTargetFrequency";
export const AUDIENCE_SIZE = "audienceSize";
export const POTENTIAL_REACH = "potentialReach";
export const ESTIMATED_DAILY_RESULTS = "estimatedDailyResults";

//Specifics metrics Google
export const ALL_CONVERSIONS = "allConversions";
export const ALL_CONVERSIONS_FROM_INTERACTIONS_RATE =
  "allConversionsFromInteractionsRate";
export const ALL_CONVERSIONS_VALUE = "allConversionsValue";
export const APP_EVENT_ADD_TO_CART = "appEventAddToCart";
export const APP_INSTALL = "appInstall";
export const AVERAGE_CART_SIZE = "averageCartSize";
export const AVERAGE_COST = "averageCost";
export const AVERAGE_CPC = "averageCpc";
export const AVERAGE_ORDER_VALUE_MICROS = "averageOrderValueMicros";
export const CHECKOUT = "checkout";
export const COMMENTS_METRICS = "comments";
export const CONVERSION_RATE = "conversionRate";
export const CONVERSIONS_FROM_INTERACTIONS_RATE =
  "conversionsFromInteractionsRate";
export const CONVERSIONS_VALUE = "conversionsValue";
export const COST_OF_GOODS_SOLD_MICROS = "costOfGoodsSoldMicros";
export const COST_PER_ALL_CONVERSIONS = "costPerAllConversions";
export const COST_PER_APP_EVENT_ADD_TO_CART = "costPerAppEventAddToCart";
export const COST_PER_APP_INSTALL = "costPerAppInstall";
export const COST_PER_CHECKOUT = "costPerCheckout";
export const COST_PER_CONVERSION = "costPerConversion";
export const COST_PER_PURCHASE = "costPerPurchase";
export const COST_PER_VIEW_CONTENT = "costPerViewContent";
export const CROSS_DEVICE_CONVERSIONS = "crossDeviceConversions";
export const CROSS_DEVICE_CONVERSIONS_VALUE_MICROS =
  "crossDeviceConversionsValueMicros";
export const CROSS_SELL_COST_OF_GOODS_SOLD_MICROS =
  "crossSellCostOfGoodsSoldMicros";
export const CROSS_SELL_GROSS_PROFIT_MICROS = "crossSellGrossProfitMicros";
export const CROSS_SELL_REVENUE_MICROS = "crossSellRevenueMicros";
export const CROSS_SELL_UNITS_SOLD = "crossSellUnitsSold";
export const ENGAGEMENT_RATE = "engagementRate";
export const FOLLOWS = "follows";
export const GROSS_PROFIT_MARGIN = "grossProfitMargin";
export const GROSS_PROFIT_MICROS = "grossProfitMicros";
export const INTERACTION_RATE = "interactionRate";
export const INTERACTIONS_METRICS = "interactions";
export const LEAD_COST_OF_GOODS_SOLD_MICROS = "leadCostOfGoodsSoldMicros";
export const LEAD_GROSS_PROFIT_MICROS = "leadGrossProfitMicros";
export const LEAD_REVENUE_MICROS = "leadRevenueMicros";
export const LEAD_UNITS_SOLD = "leadUnitsSold";
export const LIKES_METRICS = "likes";
export const ORDERS_METRICS = "orders";
export const PROFILE_VISITS = "profileVisits";
export const PURCHASE = "purchase";
export const REVENUE_MICROS = "revenueMicros";
export const SHARES_METRICS = "shares";
export const VALUE_PER_ALL_CONVERSIONS = "valuePerAllConversions";
export const VALUE_PER_CONVERSION = "valuePerConversion";
export const VIDEO_VIEWS_P100 = "videoViewsP100";
export const VIEW_CONTENT = "viewContent";
export const VIEW_THROUGH_CONVERSIONS = "viewThroughConversions";
export const ESTIMATED_DAILY_REACH = "estimatedDailyReach";
export const AVERAGE_AUDIENCE_SIZE = "averageAudienceSize";
export const NO_ESTIMATION_AVAILABLE = "noEstimationAvailable";

//Specifics metrics Meta
export const ACTION_VALUES = "actionValues";
export const ACTIONS_METRICS = "actions";
export const COST_PER_ADD_TO_CART_META = "costPerAddToCartMeta";
export const ADD_TO_CART_META = "addToCartMeta";
export const COST_PER_WEB_IN_STORE_PURCHASE_META =
  "costPerWebInStorePurchaseMeta";
export const WEB_IN_STORE_PURCHASE_META = "webInStorePurchaseMeta";
export const COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META =
  "costPerOffsiteConversionFbPixelSearchMeta";
export const OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META =
  "offsiteConversionFbPixelSearchMeta";
export const COST_PER_LINK_CLICK_META = "costPerLinkClickMeta";
export const LINK_CLICK_META = "linkClickMeta";
export const COST_PER_PAGE_ENGAGEMENT_META = "costPerPageEngagementMeta";
export const PAGE_ENGAGEMENT_META = "pageEngagementMeta";
export const COST_PER_PURCHASE_META = "costPerPurchaseMeta";
export const PURCHASE_META = "purchaseMeta";
export const COST_PER_LANDING_PAGE_VIEW_META = "costPerLandingPageViewMeta";
export const LANDING_PAGE_VIEW_META = "landingPageViewMeta";
export const COST_PER_POST_ENGAGEMENT_META = "costPerPostEngagementMeta";
export const POST_ENGAGEMENT_META = "postEngagementMeta";
export const COST_PER_ONSITE_WEB_VIEW_CONTENT_META =
  "costPerOnsiteWebViewContentMeta";
export const ONSITE_WEB_VIEW_CONTENT_META = "onsiteWebViewContentMeta";
export const COST_PER_ONSITE_WEB_ADD_TO_CART_META =
  "costPerOnsiteWebAddToCartMeta";
export const ONSITE_WEB_ADD_TO_CART_META = "onsiteWebAddToCartMeta";
export const COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META =
  "costPerOffsiteConversionFbPixelAddPaymentInfoMeta";
export const OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META =
  "offsiteConversionFbPixelAddPaymentInfoMeta";
export const COST_PER_COMMENT_META = "costPerCommentMeta";
export const COMMENT_META = "commentMeta";
export const COST_PER_ONSITE_WEB_APP_PURCHASE_META =
  "costPerOnsiteWebAppPurchaseMeta";
export const ONSITE_WEB_APP_PURCHASE_META = "onsiteWebAppPurchaseMeta";
export const COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META =
  "costPerOffsiteContentViewAddMetaLeadsMeta";
export const OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META =
  "offsiteContentViewAddMetaLeadsMeta";
export const COST_PER_VIEW_CONTENT_META = "costPerViewContentMeta";
export const VIEW_CONTENT_META = "viewContentMeta";
export const COST_PER_WEB_APP_IN_STORE_PURCHASE_META =
  "costPerWebAppInStorePurchaseMeta";
export const WEB_APP_IN_STORE_PURCHASE_META = "webAppInStorePurchaseMeta";
export const COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META =
  "costPerOnsiteWebAppAddToCartMeta";
export const ONSITE_WEB_APP_ADD_TO_CART_META = "onsiteWebAppAddToCartMeta";
export const COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META =
  "costPerOffsiteSearchAddMetaLeadsMeta";
export const OFFSITE_SEARCH_ADD_META_LEADS_META =
  "offsiteSearchAddMetaLeadsMeta";
export const COST_PER_POST_META = "costPerPostMeta";
export const POST_META = "postMeta";
export const COST_PER_ONSITE_CONVERSION_POST_SAVE_META =
  "costPerOnsiteConversionPostSaveMeta";
export const ONSITE_CONVERSION_POST_SAVE_META = "onsiteConversionPostSaveMeta";
export const COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META =
  "costPerOnsiteWebInitiateCheckoutMeta";
export const ONSITE_WEB_INITIATE_CHECKOUT_META =
  "onsiteWebInitiateCheckoutMeta";
export const COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META =
  "costPerOnsiteConversionPostNetSaveMeta";
export const ONSITE_CONVERSION_POST_NET_SAVE_META =
  "onsiteConversionPostNetSaveMeta";
export const COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META =
  "costPerOnsiteWebAppViewContentMeta";
export const ONSITE_WEB_APP_VIEW_CONTENT_META = "onsiteWebAppViewContentMeta";
export const COST_PER_POST_INTERACTION_GROSS_META =
  "costPerPostInteractionGrossMeta";
export const POST_INTERACTION_GROSS_META = "postInteractionGrossMeta";
export const COST_PER_ONSITE_WEB_PURCHASE_META = "costPerOnsiteWebPurchaseMeta";
export const ONSITE_WEB_PURCHASE_META = "onsiteWebPurchaseMeta";
export const COST_PER_ADD_PAYMENT_INFO_META = "costPerAddPaymentInfoMeta";
export const ADD_PAYMENT_INFO_META = "addPaymentInfoMeta";
export const COST_PER_SEARCH_META = "costPerSearchMeta";
export const SEARCH_META = "searchMeta";
export const COST_PER_VIDEO_VIEW_META = "costPerVideoViewMeta";
export const VIDEO_VIEW_META = "videoViewMeta";
export const COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META =
  "costPerOffsiteConversionFbPixelViewContentMeta";
export const OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META =
  "offsiteConversionFbPixelViewContentMeta";
export const COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META =
  "costPerOffsiteConversionFbPixelAddToCartMeta";
export const OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META =
  "offsiteConversionFbPixelAddToCartMeta";
export const COST_PER_POST_REACTION_META = "costPerPostReactionMeta";
export const POST_REACTION_META = "postReactionMeta";
export const COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META =
  "costPerOffsiteConversionFbPixelInitiateCheckoutMeta";
export const OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META =
  "offsiteConversionFbPixelInitiateCheckoutMeta";
export const COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META =
  "costPerOffsiteConversionFbPixelPurchaseMeta";
export const OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META =
  "offsiteConversionFbPixelPurchaseMeta";
export const COST_PER_INITIATE_CHECKOUT_META = "costPerInitiateCheckoutMeta";
export const INITIATE_CHECKOUT_META = "initiateCheckoutMeta";
export const COST_PER_LIKE_META = "costPerLikeMeta";
export const LIKE_META = "likeMeta";
export const AD_CLICK_ACTIONS = "adClickActions";
export const AD_IMPRESSION_ACTIONS = "adImpressionActions";
export const AUCTION_BID = "auctionBid";
export const AUCTION_COMPETITIVENESS = "auctionCompetitiveness";
export const AUCTION_MAX_COMPETITOR_BID = "auctionMaxCompetitorBid";
export const CANVAS_AVG_VIEW_PERCENT = "canvasAvgViewPercent";
export const CANVAS_AVG_VIEW_TIME = "canvasAvgViewTime";
export const CATALOG_SEGMENT_ACTIONS = "catalogSegmentActions";
export const CATALOG_SEGMENT_VALUE = "catalogSegmentValue";
export const CATALOG_SEGMENT_VALUE_MOBILE_PURCHASE_ROAS =
  "catalogSegmentValueMobilePurchaseRoas";
export const CATALOG_SEGMENT_VALUE_OMNI_PURCHASE_ROAS =
  "catalogSegmentValueOmniPurchaseRoas";
export const CATALOG_SEGMENT_VALUE_WEBSITE_PURCHASE_ROAS =
  "catalogSegmentValueWebsitePurchaseRoas";
export const CONVERSION_VALUES = "conversionValues";
export const CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE =
  "convertedProductAppCustomEventFbMobilePurchase";
export const CONVERTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE =
  "convertedProductAppCustomEventFbMobilePurchaseValue";
export const CONVERTED_PRODUCT_OFFLINE_PURCHASE =
  "convertedProductOfflinePurchase";
export const CONVERTED_PRODUCT_OFFLINE_PURCHASE_VALUE =
  "convertedProductOfflinePurchaseValue";
export const CONVERTED_PRODUCT_OMNI_PURCHASE = "convertedProductOmniPurchase";
export const CONVERTED_PRODUCT_OMNI_PURCHASE_VALUES =
  "convertedProductOmniPurchaseValues";
export const CONVERTED_PRODUCT_QUANTITY = "convertedProductQuantity";
export const CONVERTED_PRODUCT_VALUE = "convertedProductValue";
export const CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE =
  "convertedProductWebsitePixelPurchase";
export const CONVERTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE =
  "convertedProductWebsitePixelPurchaseValue";
export const CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE =
  "convertedPromotedProductAppCustomEventFbMobilePurchase";
export const CONVERTED_PROMOTED_PRODUCT_APP_CUSTOM_EVENT_FB_MOBILE_PURCHASE_VALUE =
  "convertedPromotedProductAppCustomEventFbMobilePurchaseValue";
export const CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE =
  "convertedPromotedProductOfflinePurchase";
export const CONVERTED_PROMOTED_PRODUCT_OFFLINE_PURCHASE_VALUE =
  "convertedPromotedProductOfflinePurchaseValue";
export const CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE =
  "convertedPromotedProductOmniPurchase";
export const CONVERTED_PROMOTED_PRODUCT_OMNI_PURCHASE_VALUES =
  "convertedPromotedProductOmniPurchaseValues";
export const CONVERTED_PROMOTED_PRODUCT_QUANTITY =
  "convertedPromotedProductQuantity";
export const CONVERTED_PROMOTED_PRODUCT_VALUE = "convertedPromotedProductValue";
export const CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE =
  "convertedPromotedProductWebsitePixelPurchase";
export const CONVERTED_PROMOTED_PRODUCT_WEBSITE_PIXEL_PURCHASE_VALUE =
  "convertedPromotedProductWebsitePixelPurchaseValue";
export const COST_PER_15SEC_VIDEO_VIEW = "costPer15SecVideoView";
export const COST_PER_15_SEC_VIDEO_VIEW = "costPer15SecVideoView";
export const COST_PER_2SEC_CONTINUOUS_VIDEO_VIEW =
  "costPer2SecContinuousVideoView";
export const COST_PER_ACTION_TYPE = "costPerActionType";
export const COST_PER_AD_CLICK = "costPerAdClick";
export const COST_PER_DDA_COUNT_BY_CONVS = "costPerDdaCountbyConvs";
export const COST_PER_ESTIMATED_AD_RECALLERS = "costPerEstimatedAdRecallers";
export const COST_PER_INLINE_LINK_CLICK = "costPerInlineLinkClick";
export const COST_PER_INLINE_POST_ENGAGEMENT = "costPerInlinePostEngagement";
export const COST_PER_OBJECTIVE_RESULT = "costPerObjectiveResult";
export const COST_PER_ONE_THOUSAND_AD_IMPRESSION =
  "costPerOneThousandAdImpression";
export const COST_PER_OUTBOUND_CLICK = "costPerOutboundClick";
export const COST_PER_RESULT = "costPerResult";
export const COST_PER_THRUPLAY = "costPerThruplay";
export const COST_PER_UNIQUE_ACTION_TYPE = "costPerUniqueActionType";
export const COST_PER_UNIQUE_CLICK = "costPerUniqueClick";
export const COST_PER_UNIQUE_CONVERSION = "costPerUniqueConversion";
export const COST_PER_UNIQUE_INLINE_LINK_CLICK = "costPerUniqueInlineLinkClick";
export const COST_PER_UNIQUE_OUTBOUND_CLICK = "costPerUniqueOutboundClick";
export const CPP = "cpp";
export const DDA_COUNT_BY_CONVS = "ddaCountbyConvs";
export const DDA_RESULTS = "ddaResults";
export const ESTIMATED_AD_RECALLERS = "estimatedAdRecallers";
export const INSTAGRAM_PROFILE_FOLLOW = "instagramProfileFollow";
export const FULL_VIEW_IMPRESSIONS = "fullViewImpressions";
export const FULL_VIEW_REACH = "fullViewReach";
export const INLINE_LINK_CLICK_CTR = "inlineLinkClickCtr";
export const INLINE_LINK_CLICKS = "inlineLinkClicks";
export const INLINE_POST_ENGAGEMENT = "inlinePostEngagement";
export const INSTANT_EXPERIENCE_CLICKS_TO_OPEN =
  "instantExperienceClicksToOpen";
export const INSTANT_EXPERIENCE_CLICKS_TO_START =
  "instantExperienceClicksToStart";
export const INSTANT_EXPERIENCE_OUTBOUND_CLICKS =
  "instantExperienceOutboundClicks";
export const INTERACTIVE_COMPONENT_TAP = "interactiveComponentTap";
export const LANDING_PAGE_VIEW_PER_LINK_CLICK = "landingPageViewPerLinkClick";
export const MARKETING_MESSAGES_DELIVERY_RATE = "marketingMessagesDeliveryRate";
export const OBJECTIVE_RESULT_RATE = "objectiveResultRate";
export const OBJECTIVE_RESULTS = "objectiveResults";
export const OUTBOUND_CLICKS = "outboundClicks";
export const OUTBOUND_CLICKS_CTR = "outboundClicksCtr";
export const PURCHASE_PER_LANDING_PAGE_VIEW = "purchasePerLandingPageView";
export const QUALIFYING_QUESTION_QUALIFY_ANSWER_RATE =
  "qualifyingQuestionQualifyAnswerRate";
export const RESULT_RATE = "resultRate";
export const RESULTS_METRICS = "results";
export const ROAS_METRICS = "roas";
export const SHOPS_ASSISTED_PURCHASES = "shopsAssistedPurchases";
export const SOCIAL_SPEND = "socialSpend";
export const TOTAL_CARD_VIEW = "totalCardView";
export const VIDEO_30SEC_WATCHED_ACTIONS = "video30SecWatchedActions";
export const VIDEO_30_SEC_WATCHED_ACTIONS = "video30SecWatchedActions";
export const VIDEO_AVG_TIME_WATCHED_ACTIONS = "videoAvgTimeWatchedActions";
export const VIDEO_CONTINUOUS_2SEC_WATCHED_ACTIONS =
  "videoContinuous2SecWatchedActions";
export const VIDEO_P100_WATCHED_ACTIONS = "videoP100WatchedActions";
export const VIDEO_P25_WATCHED_ACTIONS = "videoP25WatchedActions";
export const VIDEO_P50_WATCHED_ACTIONS = "videoP50WatchedActions";
export const VIDEO_P75_WATCHED_ACTIONS = "videoP75WatchedActions";
export const VIDEO_P95_WATCHED_ACTIONS = "videoP95WatchedActions";
export const VIDEO_PLAY_ACTIONS = "videoPlayActions";
export const VIDEO_PLAY_CURVE_ACTIONS = "videoPlayCurveActions";
export const VIDEO_PLAY_RETENTION_0_TO_15S_ACTIONS =
  "videoPlayRetention0To15sActions";
export const VIDEO_PLAY_RETENTION_20_TO_60S_ACTIONS =
  "videoPlayRetention20To60sActions";
export const VIDEO_PLAY_RETENTION_GRAPH_ACTIONS =
  "videoPlayRetentionGraphActions";
export const VIDEO_TIME_WATCHED_ACTIONS = "videoTimeWatchedActions";
export const WEBSITE_CTR = "websiteCtr";
export const WEBSITE_PURCHASE_ROAS = "websitePurchaseRoas";
export const VIDEO_HOOK_RATE = "videoHookRate";
export const VIDEO_RETENTION_RATE = "videoRetentionRate";

//Specifics metrics TikTok
export const BILLED_COST = "billedCost";
export const GROSS_IMPRESSIONS = "grossImpressions";
export const CONVERSION_RATE_TIKTOK = "conversionRate";
export const RESULT_RATE_TIKTOK = "resultRate";
export const VIDEO_VIEWS_P100_TIKTOK = "videoViewsP100";
export const AVERAGE_VIDEO_PLAY = "averageVideoPlay";
export const ENGAGEMENT_RATE_TIKTOK = "engagementRate";
export const FOLLOWS_TIKTOK = "follows";
export const LIKES_TIKTOK = "likes";
export const COMMENTS_TIKTOK = "comments";
export const SHARES_TIKTOK = "shares";
export const PROFILE_VISITS_TIKTOK = "profileVisits";
export const LIVE_VIEWS = "liveViews";
export const APP_INSTALL_TIKTOK = "appInstall";
export const COST_PER_APP_INSTALL_TIKTOK = "costPerAppInstall";
export const REGISTRATION = "registration";
export const COST_PER_REGISTRATION = "costPerRegistration";
export const PURCHASE_TIKTOK = "purchase";
export const COST_PER_PURCHASE_TIKTOK = "costPerPurchase";
export const PURCHASE_RATE = "purchaseRate";
export const TOTAL_PURCHASE_VALUE = "totalPurchaseValue";
export const APP_EVENT_ADD_TO_CART_TIKTOK = "appEventAddToCart";
export const COST_PER_APP_EVENT_ADD_TO_CART_TIKTOK = "costPerAppEventAddToCart";
export const CHECKOUT_TIKTOK = "checkout";
export const COST_PER_CHECKOUT_TIKTOK = "costPerCheckout";
export const VIEW_CONTENT_TIKTOK = "viewContent";
export const COST_PER_VIEW_CONTENT_TIKTOK = "costPerViewContent";
export const NEXT_DAY_OPEN = "nextDayOpen";
export const DAY7_RETENTION = "day7Retention";
export const CASH_SPEND = "cashSpend";
export const VOUCHER_SPEND = "voucherSpend";
export const COST_PER_1000_REACHED = "costPer1000Reached";
export const CONVERSION_RATE_V2 = "conversionRateV2";
export const REAL_TIME_CONVERSION = "realTimeConversion";
export const REAL_TIME_COST_PER_CONVERSION = "realTimeCostPerConversion";
export const REAL_TIME_CONVERSION_RATE = "realTimeConversionRate";
export const REAL_TIME_CONVERSION_RATE_V2 = "realTimeConversionRateV2";
export const REAL_TIME_RESULT = "realTimeResult";
export const REAL_TIME_COST_PER_RESULT = "realTimeCostPerResult";
export const REAL_TIME_RESULT_RATE = "realTimeResultRate";
export const SECONDARY_GOAL_RESULT = "secondaryGoalResult";
export const COST_PER_SECONDARY_GOAL_RESULT = "costPerSecondaryGoalResult";
export const SECONDARY_GOAL_RESULT_RATE = "secondaryGoalResultRate";
export const VIDEO_PLAY_ACTIONS_TIKTOK = "videoPlayActions";
export const VIDEO_WATCHED_2S = "videoWatched2s";
export const VIDEO_WATCHED_6S = "videoWatched6s";
export const VIDEO_VIEWS_P25 = "videoViewsP25";
export const VIDEO_VIEWS_P50 = "videoViewsP50";
export const VIDEO_VIEWS_P75 = "videoViewsP75";
export const AVERAGE_VIDEO_PLAY_PER_USER = "averageVideoPlayPerUser";
export const PAID_ENGAGED_VIEW = "paidEngagedView";
export const PAID_ENGAGEMENT_ENGAGED_VIEW = "paidEngagementEngagedView";
export const ENGAGED_VIEW_15S = "engagedView15s";
export const PAID_ENGAGED_VIEW_15S = "paidEngagedView15s";
export const PAID_ENGAGEMENT_ENGAGED_VIEW_15S = "paidEngagementEngagedView15s";
export const CLICKS_ON_MUSIC_DISC = "clicksOnMusicDisc";
export const DUET_CLICKS = "duetClicks";
export const STITCH_CLICKS = "stitchClicks";
export const SOUND_USAGE_CLICKS = "soundUsageClicks";
export const MUSIC_UPLOAD_TITLE = "musicUploadTitle";
export const MUSIC_UPLOAD_BUTTON = "musicUploadButton";
export const MUSIC_REMOVE_BUTTON = "musicRemoveButton";
export const MUSIC_UPLOAD_DESCRIPTION = "musicUploadDescription";
export const ANCHOR_CLICKS = "anchorClicks";
export const ANCHOR_CLICK_RATE = "anchorClickRate";
export const CLICKS_ON_HASHTAG_CHALLENGE = "clicksOnHashtagChallenge";
export const PROFILE_VISITS_RATE = "profileVisitsRate";
export const TT_PLAYLIST_VISIT = "ttPlaylistVisit";
export const TT_PLAYLIST_VISIT_RATE = "ttPlaylistVisitRate";
export const LIVE_UNIQUE_VIEWS = "liveUniqueViews";
export const LIVE_EFFECTIVE_VIEWS = "liveEffectiveViews";
export const LIVE_PRODUCT_CLICKS = "liveProductClicks";
export const INTERACTIVE_ADD_ON_IMPRESSIONS = "interactiveAddOnImpressions";
export const INTERACTIVE_ADD_ON_DESTINATION_CLICKS =
  "interactiveAddOnDestinationClicks";
export const INTERACTIVE_ADD_ON_ACTIVITY_CLICKS =
  "interactiveAddOnActivityClicks";
export const INTERACTIVE_ADD_ON_OPTION_A_CLICKS =
  "interactiveAddOnOptionAClicks";
export const INTERACTIVE_ADD_ON_OPTION_B_CLICKS =
  "interactiveAddOnOptionBClicks";
export const COUNTDOWN_STICKER_RECALL_CLICKS = "countdownStickerRecallClicks";
export const IX_PAGE_DURATION_AVG = "ixPageDurationAvg";
export const IX_PAGE_VIEWRATE_AVG = "ixPageViewrateAvg";
export const IX_VIDEO_VIEWS = "ixVideoViews";
export const IX_VIDEO_VIEWS_P25 = "ixVideoViewsP25";
export const IX_VIDEO_VIEWS_P50 = "ixVideoViewsP50";
export const IX_VIDEO_VIEWS_P75 = "ixVideoViewsP75";
export const IX_VIDEO_VIEWS_P100 = "ixVideoViewsP100";
export const IX_AVERAGE_VIDEO_PLAY = "ixAverageVideoPlay";
export const REAL_TIME_APP_INSTALL = "realTimeAppInstall";
export const REAL_TIME_APP_INSTALL_COST = "realTimeAppInstallCost";
export const REGISTRATION_RATE = "registrationRate";
export const TOTAL_REGISTRATION = "totalRegistration";
export const COST_PER_TOTAL_REGISTRATION = "costPerTotalRegistration";
export const TOTAL_PURCHASE = "totalPurchase";
export const COST_PER_TOTAL_PURCHASE = "costPerTotalPurchase";
export const VALUE_PER_TOTAL_PURCHASE = "valuePerTotalPurchase";
export const TOTAL_ACTIVE_PAY_ROAS = "totalActivePayRoas";
export const TOTAL_PURCHASE_ROAS_DAY0 = "totalPurchaseRoasDay0";
export const TOTAL_PURCHASE_ROAS_DAY2 = "totalPurchaseRoasDay2";
export const TOTAL_PURCHASE_ROAS_DAY6 = "totalPurchaseRoasDay6";
export const TOTAL_PURCHASE_VALUE_DAY0 = "totalPurchaseValueDay0";
export const TOTAL_PURCHASE_VALUE_DAY2 = "totalPurchaseValueDay2";
export const TOTAL_PURCHASE_VALUE_DAY6 = "totalPurchaseValueDay6";
export const APP_EVENT_ADD_TO_CART_RATE = "appEventAddToCartRate";
export const TOTAL_APP_EVENT_ADD_TO_CART = "totalAppEventAddToCart";
export const COST_PER_TOTAL_APP_EVENT_ADD_TO_CART =
  "costPerTotalAppEventAddToCart";
export const VALUE_PER_TOTAL_APP_EVENT_ADD_TO_CART =
  "valuePerTotalAppEventAddToCart";
export const TOTAL_APP_EVENT_ADD_TO_CART_VALUE = "totalAppEventAddToCartValue";
export const CHECKOUT_RATE = "checkoutRate";
export const TOTAL_CHECKOUT = "totalCheckout";
export const COST_PER_TOTAL_CHECKOUT = "costPerTotalCheckout";
export const VALUE_PER_CHECKOUT = "valuePerCheckout";
export const TOTAL_CHECKOUT_VALUE = "totalCheckoutValue";
export const VIEW_CONTENT_RATE = "viewContentRate";
export const TOTAL_VIEW_CONTENT = "totalViewContent";
export const COST_PER_TOTAL_VIEW_CONTENT = "costPerTotalViewContent";
export const VALUE_PER_TOTAL_VIEW_CONTENT = "valuePerTotalViewContent";
export const TOTAL_VIEW_CONTENT_VALUE = "totalViewContentValue";
export const COST_PER_NEXT_DAY_OPEN = "costPerNextDayOpen";
export const NEXT_DAY_OPEN_RATE = "nextDayOpenRate";
export const TOTAL_NEXT_DAY_OPEN = "totalNextDayOpen";
export const COST_PER_TOTAL_NEXT_DAY_OPEN = "costPerTotalNextDayOpen";
export const COST_PER_DAY7_RETENTION = "costPerDay7Retention";
export const DAY7_RETENTION_RATE = "day7RetentionRate";
export const TOTAL_DAY7_RETENTION = "totalDay7Retention";
export const COST_PER_TOTAL_DAY7_RETENTION = "costPerTotalDay7Retention";
export const VALUE_PER_TOTAL_DAY7_RETENTION = "valuePerTotalDay7Retention";
export const TOTAL_DAY7_RETENTION_VALUE = "totalDay7RetentionValue";
export const ADD_PAYMENT_INFO = "addPaymentInfo";
export const COST_PER_ADD_PAYMENT_INFO = "costPerAddPaymentInfo";
export const ADD_PAYMENT_INFO_RATE = "addPaymentInfoRate";
export const TOTAL_ADD_PAYMENT_INFO = "totalAddPaymentInfo";
export const COST_TOTAL_ADD_PAYMENT_INFO = "costTotalAddPaymentInfo";
export const ADD_TO_WISHLIST = "addToWishlist";
export const COST_PER_ADD_TO_WISHLIST = "costPerAddToWishlist";
export const ADD_TO_WISHLIST_RATE = "addToWishlistRate";
export const TOTAL_ADD_TO_WISHLIST = "totalAddToWishlist";
export const COST_PER_TOTAL_ADD_TO_WISHLIST = "costPerTotalAddToWishlist";
export const VALUE_PER_TOTAL_ADD_TO_WISHLIST = "valuePerTotalAddToWishlist";
export const TOTAL_ADD_TO_WISHLIST_VALUE = "totalAddToWishlistValue";
export const LAUNCH_APP = "launchApp";
export const COST_PER_LAUNCH_APP = "costPerLaunchApp";
export const LAUNCH_APP_RATE = "launchAppRate";
export const TOTAL_LAUNCH_APP = "totalLaunchApp";
export const COST_PER_TOTAL_LAUNCH_APP = "costPerTotalLaunchApp";
export const COMPLETE_TUTORIAL = "completeTutorial";
export const COST_PER_COMPLETE_TUTORIAL = "costPerCompleteTutorial";
export const COMPLETE_TUTORIAL_RATE = "completeTutorialRate";
export const TOTAL_COMPLETE_TUTORIAL = "totalCompleteTutorial";
export const COST_PER_TOTAL_COMPLETE_TUTORIAL = "costPerTotalCompleteTutorial";
export const VALUE_PER_TOTAL_COMPLETE_TUTORIAL =
  "valuePerTotalCompleteTutorial";
export const TOTAL_COMPLETE_TUTORIAL_VALUE = "totalCompleteTutorialValue";
export const CREATE_GROUP = "createGroup";
export const COST_PER_CREATE_GROUP = "costPerCreateGroup";
export const CREATE_GROUP_RATE = "createGroupRate";
export const TOTAL_CREATE_GROUP = "totalCreateGroup";
export const COST_PER_TOTAL_CREATE_GROUP = "costPerTotalCreateGroup";
export const VALUE_PER_TOTAL_CREATE_GROUP = "valuePerTotalCreateGroup";
export const TOTAL_CREATE_GROUP_VALUE = "totalCreateGroupValue";
export const JOIN_GROUP = "joinGroup";
export const COST_PER_JOIN_GROUP = "costPerJoinGroup";
export const JOIN_GROUP_RATE = "joinGroupRate";
export const TOTAL_JOIN_GROUP = "totalJoinGroup";
export const COST_PER_TOTAL_JOIN_GROUP = "costPerTotalJoinGroup";
export const VALUE_PER_TOTAL_JOIN_GROUP = "valuePerTotalJoinGroup";
export const TOTAL_JOIN_GROUP_VALUE = "totalJoinGroupValue";
export const CREATE_GAMEROLE = "createGamerole";
export const COST_PER_CREATE_GAMEROLE = "costPerCreateGamerole";
export const CREATE_GAMEROLE_RATE = "createGameroleRate";
export const TOTAL_CREATE_GAMEROLE = "totalCreateGamerole";
export const COST_PER_TOTAL_CREATE_GAMEROLE = "costPerTotalCreateGamerole";
export const VALUE_PER_TOTAL_CREATE_GAMEROLE = "valuePerTotalCreateGamerole";
export const TOTAL_CREATE_GAMEROLE_VALUE = "totalCreateGameroleValue";
export const SPEND_CREDITS = "spendCredits";
export const COST_PER_SPEND_CREDITS = "costPerSpendCredits";
export const SPEND_CREDITS_RATE = "spendCreditsRate";
export const TOTAL_SPEND_CREDITS = "totalSpendCredits";
export const COST_PER_TOTAL_SPEND_CREDITS = "costPerTotalSpendCredits";
export const VALUE_PER_TOTAL_SPEND_CREDITS = "valuePerTotalSpendCredits";
export const TOTAL_SPEND_CREDITS_VALUE = "totalSpendCreditsValue";
export const ACHIEVE_LEVEL = "achieveLevel";
export const COST_PER_ACHIEVE_LEVEL = "costPerAchieveLevel";
export const ACHIEVE_LEVEL_RATE = "achieveLevelRate";
export const TOTAL_ACHIEVE_LEVEL = "totalAchieveLevel";
export const COST_PER_TOTAL_ACHIEVE_LEVEL = "costPerTotalAchieveLevel";
export const VALUE_PER_TOTAL_ACHIEVE_LEVEL = "valuePerTotalAchieveLevel";
export const TOTAL_ACHIEVE_LEVEL_VALUE = "totalAchieveLevelValue";
export const UNLOCK_ACHIEVEMENT = "unlockAchievement";
export const COST_PER_UNLOCK_ACHIEVEMENT = "costPerUnlockAchievement";
export const UNLOCK_ACHIEVEMENT_RATE = "unlockAchievementRate";
export const TOTAL_UNLOCK_ACHIEVEMENT = "totalUnlockAchievement";
export const COST_PER_TOTAL_UNLOCK_ACHIEVEMENT =
  "costPerTotalUnlockAchievement";
export const VALUE_PER_TOTAL_UNLOCK_ACHIEVEMENT =
  "valuePerTotalUnlockAchievement";
export const TOTAL_UNLOCK_ACHIEVEMENT_VALUE = "totalUnlockAchievementValue";
export const SALES_LEAD = "salesLead";
export const COST_PER_SALES_LEAD = "costPerSalesLead";
export const SALES_LEAD_RATE = "salesLeadRate";
export const TOTAL_SALES_LEAD = "totalSalesLead";
export const COST_PER_TOTAL_SALES_LEAD = "costPerTotalSalesLead";
export const VALUE_PER_TOTAL_SALES_LEAD = "valuePerTotalSalesLead";
export const TOTAL_SALES_LEAD_VALUE = "totalSalesLeadValue";
export const IN_APP_AD_CLICK = "inAppAdClick";
export const COST_PER_IN_APP_AD_CLICK = "costPerInAppAdClick";
export const IN_APP_AD_CLICK_RATE = "inAppAdClickRate";

export const TOTAL_IN_APP_AD_CLICK = "totalInAppAdClick";
export const COST_PER_TOTAL_IN_APP_AD_CLICK = "costPerTotalInAppAdClick";
export const VALUE_PER_TOTAL_IN_APP_AD_CLICK = "valuePerTotalInAppAdClick";
export const TOTAL_IN_APP_AD_CLICK_VALUE = "totalInAppAdClickValue";
export const IN_APP_AD_IMPR = "inAppAdImpr";
export const COST_PER_IN_APP_AD_IMPR = "costPerInAppAdImpr";
export const IN_APP_AD_IMPR_RATE = "inAppAdImprRate";
export const TOTAL_IN_APP_AD_IMPR = "totalInAppAdImpr";
export const COST_PER_TOTAL_IN_APP_AD_IMPR = "costPerTotalInAppAdImpr";
export const VALUE_PER_TOTAL_IN_APP_AD_IMPR = "valuePerTotalInAppAdImpr";
export const TOTAL_IN_APP_AD_IMPR_VALUE = "totalInAppAdImprValue";
export const LOAN_APPLY = "loanApply";
export const COST_PER_LOAN_APPLY = "costPerLoanApply";
export const LOAN_APPLY_RATE = "loanApplyRate";
export const TOTAL_LOAN_APPLY = "totalLoanApply";
export const COST_PER_TOTAL_LOAN_APPLY = "costPerTotalLoanApply";
export const LOAN_CREDIT = "loanCredit";
export const COST_PER_LOAN_CREDIT = "costPerLoanCredit";
export const LOAN_CREDIT_RATE = "loanCreditRate";
export const TOTAL_LOAN_CREDIT = "totalLoanCredit";
export const COST_PER_TOTAL_LOAN_CREDIT = "costPerTotalLoanCredit";
export const LOAN_DISBURSEMENT = "loanDisbursement";
export const COST_PER_LOAN_DISBURSEMENT = "costPerLoanDisbursement";
export const LOAN_DISBURSEMENT_RATE = "loanDisbursementRate";
export const TOTAL_LOAN_DISBURSEMENT = "totalLoanDisbursement";
export const COST_PER_TOTAL_LOAN_DISBURSEMENT = "costPerTotalLoanDisbursement";
export const LOGIN = "login";
export const COST_PER_LOGIN = "costPerLogin";
export const LOGIN_RATE = "loginRate";
export const TOTAL_LOGIN = "totalLogin";
export const COST_PER_TOTAL_LOGIN = "costPerTotalLogin";
export const RATINGS = "ratings";
export const GALLERY_VIEW_SCORES = "galleryViewScores";
export const GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_TITLE =
  "galleryCreateCampaignLeaveFlowTitle";
export const GALLERY_CREATE_CAMPAIGN_LEAVE_FLOW_DESCRIPTION =
  "galleryCreateCampaignLeaveFlowDescription";
export const GALLERY_SELECTED_COUNT_SINGULAR = "gallerySelectedCountSingular";
export const GALLERY_SELECTED_COUNT_PLURAL = "gallerySelectedCountPlural";
export const GALLERY_FOLDERS_ALL = "galleryFoldersAll";
export const GALLERY_FOLDERS_CREATE_TITLE = "galleryFoldersCreateTitle";
export const GALLERY_FOLDERS_NAME = "galleryFoldersName";
export const GALLERY_FOLDERS_DUPLICATE = "galleryFoldersDuplicate";
export const GALLERY_FOLDERS_CREATE_SUCCESS = "galleryFoldersCreateSuccess";
export const GALLERY_FOLDERS_MOVE_SUCCESS = "galleryFoldersMoveSuccess";
export const GALLERY_FOLDERS_CREATE_ERROR = "galleryFoldersCreateError";
export const GALLERY_FOLDERS_MOVE_ERROR = "galleryFoldersMoveError";
export const GALLERY_FOLDERS_BAR_ARIA_LABEL = "galleryFoldersBarAriaLabel";
export const GALLERY_FOLDERS_NEW_INLINE = "galleryFoldersNewInline";
export const GALLERY_UPLOAD_FOLDER_EMPTY = "galleryUploadFolderEmpty";
export const GALLERY_FOLDERS_UNASSIGN_SUCCESS = "galleryFoldersUnassignSuccess";
export const GALLERY_FOLDERS_UNASSIGN_ERROR = "galleryFoldersUnassignError";
export const GALLERY_FOLDERS_CREATE_IN = "galleryFoldersCreateIn";
export const GALLERY_FOLDERS_MOVE = "galleryFoldersMove";
export const GALLERY_FOLDERS_MOVE_TITLE = "galleryFoldersMoveTitle";
export const GALLERY_FOLDERS_MOVE_DESCRIPTION = "galleryFoldersMoveDescription";
export const GALLERY_FOLDERS_DESTINATION = "galleryFoldersDestination";
export const GALLERY_FOLDERS_SELECT = "galleryFoldersSelect";
export const GALLERY_FOLDERS_DESTINATION_PATH = "galleryFoldersDestinationPath";
export const GALLERY_FOLDERS_RENAME_TITLE = "galleryFoldersRenameTitle";
export const GALLERY_FOLDERS_RENAME_SUCCESS = "galleryFoldersRenameSuccess";
export const GALLERY_FOLDERS_RENAME_ERROR = "galleryFoldersRenameError";
export const GALLERY_FOLDERS_RENAME_ARIA_LABEL =
  "galleryFoldersRenameAriaLabel";
export const GALLERY_FOLDERS_DELETE_ARIA_LABEL =
  "galleryFoldersDeleteAriaLabel";
export const GALLERY_FOLDERS_DELETE_TITLE = "galleryFoldersDeleteTitle";
export const GALLERY_FOLDERS_DELETE_TEXT = "galleryFoldersDeleteText";
export const GALLERY_FOLDERS_DELETE_SUCCESS = "galleryFoldersDeleteSuccess";
export const GALLERY_FOLDERS_DELETE_ERROR = "galleryFoldersDeleteError";
export const GALLERY_FOLDERS_REMOVE_FROM_FOLDER =
  "galleryFoldersRemoveFromFolder";
export const GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TITLE =
  "galleryFoldersRemoveFromFolderTitle";
export const GALLERY_FOLDERS_REMOVE_FROM_FOLDER_TEXT =
  "galleryFoldersRemoveFromFolderText";
export const GALLERY_FILTER_APPROVAL_STATUS = "galleryFilterApprovalStatus";
export const CAMPAIGNS_FOLDER_EMPTY = "campaignsFolderEmpty";
export const CAMPAIGNS_MOVE_SELECTED = "campaignsMoveSelected";
export const CAMPAIGNS_FOLDERS_MOVE = "campaignsFoldersMove";
export const CAMPAIGNS_FOLDERS_MOVE_TITLE = "campaignsFoldersMoveTitle";
export const CAMPAIGNS_FOLDERS_MOVE_DESCRIPTION =
  "campaignsFoldersMoveDescription";
export const CAMPAIGNS_FOLDERS_MOVE_SUCCESS = "campaignsFoldersMoveSuccess";
export const CAMPAIGNS_FOLDERS_MOVE_ERROR = "campaignsFoldersMoveError";
export const CAMPAIGNS_FOLDERS_UNASSIGN_SUCCESS =
  "campaignsFoldersUnassignSuccess";
export const CAMPAIGNS_FOLDERS_UNASSIGN_ERROR = "campaignsFoldersUnassignError";
export const CAMPAIGNS_SELECT_ROW = "campaignsSelectRow";
export const COST_PER_RATINGS = "costPerRatings";
export const RATINGS_RATE = "ratingsRate";
export const TOTAL_RATINGS = "totalRatings";
export const COST_PER_TOTAL_RATINGS = "costPerTotalRatings";
export const VALUE_PER_TOTAL_RATINGS = "valuePerTotalRatings";
export const TOTAL_RATINGS_VALUE = "totalRatingsValue";
export const SEARCH_TIKTOK = "search";
export const COST_PER_SEARCH = "costPerSearch";
export const SEARCH_RATE = "searchRate";
export const TOTAL_SEARCH = "totalSearch";
export const COST_PER_TOTAL_SEARCH = "costPerTotalSearch";
export const START_TRIAL = "startTrial";
export const COST_PER_START_TRIAL = "costPerStartTrial";
export const START_TRIAL_RATE = "startTrialRate";
export const TOTAL_START_TRIAL = "totalStartTrial";
export const COST_PER_TOTAL_START_TRIAL = "costPerTotalStartTrial";
export const SUBSCRIBE = "subscribe";
export const COST_PER_SUBSCRIBE = "costPerSubscribe";
export const SUBSCRIBE_RATE = "subscribeRate";
export const TOTAL_SUBSCRIBE = "totalSubscribe";
export const COST_PER_TOTAL_SUBSCRIBE = "costPerTotalSubscribe";
export const VALUE_PER_TOTAL_SUBSCRIBE = "valuePerTotalSubscribe";
export const TOTAL_SUBSCRIBE_VALUE = "totalSubscribeValue";
export const UNIQUE_CUSTOM_APP_EVENTS = "uniqueCustomAppEvents";
export const COST_PER_UNIQUE_CUSTOM_APP_EVENT = "costPerUniqueCustomAppEvent";
export const CUSTOM_APP_EVENT_RATE = "customAppEventRate";
export const CUSTOM_APP_EVENTS = "customAppEvents";
export const COST_PER_CUSTOM_APP_EVENT = "costPerCustomAppEvent";
export const VALUE_PER_CUSTOM_APP_EVENT = "valuePerCustomAppEvent";
export const CUSTOM_APP_EVENTS_VALUE = "customAppEventsValue";
export const UNIQUE_AD_IMPRESSION_EVENTS = "uniqueAdImpressionEvents";
export const COST_PER_UNIQUE_AD_IMPRESSION_EVENT =
  "costPerUniqueAdImpressionEvent";
export const CUSTOMIZED_AD_IMPRESSION_EVENT_RATE =
  "customizedAdImpressionEventRate";
export const ADS_IMPRESSION_EVENTS = "adsImpressionEvents";
export const COST_PRE_AD_IMPRESSION_EVENT = "costPreAdImpressionEvent";
export const VALUE_PER_AD_IMPRESSION_EVENT = "valuePerAdImpressionEvent";
export const TOTAL_AD_IMPRESSION_EVENTS_VALUE = "totalAdImpressionEventsValue";
export const TOTAL_AD_IMPRESSION_ROAS = "totalAdImpressionRoas";
export const AD_IMPRESSION_AD_REVENUE_ROAS_DAY0 =
  "adImpressionAdRevenueRoasDay0";
export const AD_IMPRESSION_AD_REVENUE_ROAS_DAY2 =
  "adImpressionAdRevenueRoasDay2";
export const AD_IMPRESSION_AD_REVENUE_ROAS_DAY6 =
  "adImpressionAdRevenueRoasDay6";
export const AD_IMPRESSION_AD_REVENUE_DAY0 = "adImpressionAdRevenueDay0";
export const AD_IMPRESSION_AD_REVENUE_DAY2 = "adImpressionAdRevenueDay2";
export const AD_IMPRESSION_AD_REVENUE_DAY6 = "adImpressionAdRevenueDay6";
export const COMPLETE_PAYMENT_ROAS = "completePaymentRoas";
export const COMPLETE_PAYMENT = "completePayment";
export const COST_PER_COMPLETE_PAYMENT = "costPerCompletePayment";
export const COMPLETE_PAYMENT_RATE = "completePaymentRate";
export const VALUE_PER_COMPLETE_PAYMENT = "valuePerCompletePayment";
export const TOTAL_COMPLETE_PAYMENT_RATE = "totalCompletePaymentRate";
export const TOTAL_LANDING_PAGE_VIEW = "totalLandingPageView";
export const COST_PER_LANDING_PAGE_VIEW = "costPerLandingPageView";
export const LANDING_PAGE_VIEW_RATE = "landingPageViewRate";
export const TOTAL_PAGEVIEW = "totalPageview";
export const COST_PER_PAGEVIEW = "costPerPageview";
export const PAGEVIEW_RATE = "pageviewRate";
export const AVG_VALUE_PER_PAGEVIEW = "avgValuePerPageview";
export const TOTAL_VALUE_PER_PAGEVIEW = "totalValuePerPageview";
export const PAGE_BROWSE_VIEW = "pageBrowseView";
export const COST_PER_PAGE_BROWSE_VIEW = "costPerPageBrowseView";
export const PAGE_BROWSE_VIEW_RATE = "pageBrowseViewRate";
export const TOTAL_PAGE_BROWSE_VIEW_VALUE = "totalPageBrowseViewValue";
export const VALUE_PER_PAGE_BROWSE_VIEW = "valuePerPageBrowseView";
export const BUTTON_CLICK = "buttonClick";
export const COST_PER_BUTTON_CLICK = "costPerButtonClick";
export const BUTTON_CLICK_RATE = "buttonClickRate";
export const VALUE_PER_BUTTON_CLICK = "valuePerButtonClick";
export const TOTAL_BUTTON_CLICK_VALUE = "totalButtonClickValue";
export const ONLINE_CONSULT = "onlineConsult";
export const COST_PER_ONLINE_CONSULT = "costPerOnlineConsult";
export const ONLINE_CONSULT_RATE = "onlineConsultRate";
export const VALUE_PER_ONLINE_CONSULT = "valuePerOnlineConsult";
export const TOTAL_ONLINE_CONSULT_VALUE = "totalOnlineConsultValue";
export const USER_REGISTRATION = "userRegistration";
export const COST_PER_USER_REGISTRATION = "costPerUserRegistration";
export const USER_REGISTRATION_RATE = "userRegistrationRate";
export const VALUE_PER_USER_REGISTRATION = "valuePerUserRegistration";
export const TOTAL_USER_REGISTRATION_VALUE = "totalUserRegistrationValue";
export const PAGE_CONTENT_VIEW_EVENTS = "pageContentViewEvents";
export const COST_PER_PAGE_CONTENT_VIEW_EVENT = "costPerPageContentViewEvent";
export const PAGE_CONTENT_VIEW_EVENT_RATE = "pageContentViewEventRate";
export const VALUE_PER_PAGE_CONTENT_VIEW_EVENT = "valuePerPageContentViewEvent";
export const TOTAL_PAGE_VIEW_CONTENT_EVENTS_VALUE =
  "totalPageViewContentEventsValue";
export const PRODUCT_DETAILS_PAGE_BROWSE = "productDetailsPageBrowse";
export const COST_PER_PRODUCT_DETAILS_PAGE_BROWSE =
  "costPerProductDetailsPageBrowse";
export const PRODUCT_DETAILS_PAGE_BROWSE_RATE = "productDetailsPageBrowseRate";
export const VALUE_PER_PRODUCT_DETAILS_PAGE_BROWSE =
  "valuePerProductDetailsPageBrowse";
export const TOTAL_PRODUCT_DETAILS_PAGE_BROWSE_VALUE =
  "totalProductDetailsPageBrowseValue";
export const WEB_EVENT_ADD_TO_CART = "webEventAddToCart";
export const COST_PER_WEB_EVENT_ADD_TO_CART = "costPerWebEventAddToCart";
export const WEB_EVENT_ADD_TO_CART_RATE = "webEventAddToCartRate";
export const VALUE_PER_WEB_EVENT_ADD_TO_CART = "valuePerWebEventAddToCart";
export const TOTAL_WEB_EVENT_ADD_TO_CART_VALUE = "totalWebEventAddToCartValue";
export const ON_WEB_ORDER = "onWebOrder";
export const COST_PER_ON_WEB_ORDER = "costPerOnWebOrder";
export const ON_WEB_ORDER_RATE = "onWebOrderRate";
export const VALUE_PER_ON_WEB_ORDER = "valuePerOnWebOrder";
export const TOTAL_ON_WEB_ORDER_VALUE = "totalOnWebOrderValue";
export const INITIATE_CHECKOUT = "initiateCheckout";
export const COST_PER_INITIATE_CHECKOUT = "costPerInitiateCheckout";
export const INITIATE_CHECKOUT_RATE = "initiateCheckoutRate";
export const VALUE_PER_INITIATE_CHECKOUT = "valuePerInitiateCheckout";
export const TOTAL_INITIATE_CHECKOUT_VALUE = "totalInitiateCheckoutValue";
export const ADD_BILLING = "addBilling";
export const COST_PER_ADD_BILLING = "costPerAddBilling";
export const ADD_BILLING_RATE = "addBillingRate";
export const VALUE_PER_ADD_BILLING = "valuePerAddBilling";
export const TOTAL_ADD_BILLING_VALUE = "totalAddBillingValue";
export const PAGE_EVENT_SEARCH = "pageEventSearch";
export const COST_PER_PAGE_EVENT_SEARCH = "costPerPageEventSearch";
export const PAGE_EVENT_SEARCH_RATE = "pageEventSearchRate";
export const VALUE_PER_PAGE_EVENT_SEARCH = "valuePerPageEventSearch";
export const TOTAL_PAGE_EVENT_SEARCH_VALUE = "totalPageEventSearchValue";
export const FORM_TIKTOK = "form";
export const COST_PER_FORM = "costPerForm";
export const FORM_RATE = "formRate";
export const VALUE_PER_FORM = "valuePerForm";
export const TOTAL_FORM_VALUE = "totalFormValue";
export const DOWNLOAD_START = "downloadStart";
export const COST_PER_DOWNLOAD_START = "costPerDownloadStart";
export const DOWNLOAD_START_RATE = "downloadStartRate";
export const VALUE_PER_DOWNLOAD_START = "valuePerDownloadStart";
export const TOTAL_DOWNLOAD_START_VALUE = "totalDownloadStartValue";
export const ON_WEB_ADD_TO_WISHLIST = "onWebAddToWishlist";
export const COST_PER_ON_WEB_ADD_TO_WISHLIST = "costPerOnWebAddToWishlist";
export const ON_WEB_ADD_TO_WISHLIST_PER_CLICK = "onWebAddToWishlistPerClick";
export const VALUE_PER_ON_WEB_ADD_TO_WISHLIST = "valuePerOnWebAddToWishlist";
export const TOTAL_ON_WEB_ADD_TO_WISHLIST_VALUE =
  "totalOnWebAddToWishlistValue";
export const ON_WEB_SUBSCRIBE = "onWebSubscribe";
export const COST_PER_ON_WEB_SUBSCRIBE = "costPerOnWebSubscribe";
export const ON_WEB_SUBSCRIBE_PER_CLICK = "onWebSubscribePerClick";
export const VALUE_PER_ON_WEB_SUBSCRIBE = "valuePerOnWebSubscribe";
export const TOTAL_ON_WEB_SUBSCRIBE_VALUE = "totalOnWebSubscribeValue";
export const WEBSITE_TOTAL_FIND_LOCATION = "websiteTotalFindLocation";
export const WEBSITE_COST_PER_FIND_LOCATION = "websiteCostPerFindLocation";
export const WEBSITE_FIND_LOCATION_RATE = "websiteFindLocationRate";
export const WEBSITE_VALUE_PER_FIND_LOCATION = "websiteValuePerFindLocation";
export const WEBSITE_TOTAL_FIND_LOCATION_VALUE =
  "websiteTotalFindLocationValue";
export const WEBSITE_TOTAL_SCHEDULE = "websiteTotalSchedule";
export const WEBSITE_COST_PER_SCHEDULE = "websiteCostPerSchedule";
export const WEBSITE_SCHEDULE_RATE = "websiteScheduleRate";
export const WEBSITE_VALUE_PER_SCHEDULE = "websiteValuePerSchedule";
export const WEBSITE_TOTAL_SCHEDULE_VALUE = "websiteTotalScheduleValue";
export const WEBSITE_TOTAL_CUSTOMIZE_PRODUCT = "websiteTotalCustomizeProduct";
export const WEBSITE_COST_PER_CUSTOMIZE_PRODUCT =
  "websiteCostPerCustomizeProduct";
export const WEBSITE_CUSTOMIZE_PRODUCT_RATE = "websiteCustomizeProductRate";
export const WEBSITE_VALUE_PER_CUSTOMIZE_PRODUCT =
  "websiteValuePerCustomizeProduct";
export const WEBSITE_TOTAL_CUSTOMIZE_PRODUCT_VALUE =
  "websiteTotalCustomizeProductValue";
export const CUSTOM_PAGE_EVENTS = "customPageEvents";
export const COST_PER_CUSTOM_PAGE_EVENT = "costPerCustomPageEvent";
export const CUSTOM_PAGE_EVENT_RATE = "customPageEventRate";
export const VALUE_PER_CUSTOM_PAGE_EVENT = "valuePerCustomPageEvent";
export const CUSTOM_PAGE_EVENTS_VALUE = "customPageEventsValue";
export const ONSITE_PURCHASES_ROAS = "onsitePurchasesRoas";
export const ONSITE_TOTAL_PURCHASE = "onsiteTotalPurchase";
export const ONSITE_COST_PER_PURCHASE = "onsiteCostPerPurchase";
export const ONSITE_PURCHASE_RATE = "onsitePurchaseRate";
export const ONSITE_VALUE_PER_PURCHASE = "onsiteValuePerPurchase";
export const ONSITE_TOTAL_PURCHASE_VALUE = "onsiteTotalPurchaseValue";
export const ONSITE_TOTAL_CHECKOUT_INITIATION = "onsiteTotalCheckoutInitiation";
export const ONSITE_COST_PER_CHECKOUT_INITIATION =
  "onsiteCostPerCheckoutInitiation";
export const ONSITE_CHECKOUT_INITIATION_RATE = "onsiteCheckoutInitiationRate";
export const ONSITE_VALUE_PER_CHECKOUT_INITIATION =
  "onsiteValuePerCheckoutInitiation";
export const ONSITE_TOTAL_CHECKOUT_INITIATION_VALUE =
  "onsiteTotalCheckoutInitiationValue";
export const ONSITE_TOTAL_ADD_TO_CART = "onsiteTotalAddToCart";
export const ONSITE_COST_PER_ADD_TO_CART = "onsiteCostPerAddToCart";

export const ONSITE_ADD_TO_CART_RATE = "onsiteAddToCartRate";
export const ONSITE_VALUE_PER_ADD_TO_CART = "onsiteValuePerAddToCart";
export const ONSITE_TOTAL_ADD_TO_CART_VALUE = "onsiteTotalAddToCartValue";
export const ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW =
  "onsiteTotalProductDetailsPageView";
export const ONSITE_COST_PER_PRODUCT_DETAILS_PAGE_VIEW =
  "onsiteCostPerProductDetailsPageView";
export const ONSITE_PRODUCT_DETAILS_PAGE_VIEW_RATE =
  "onsiteProductDetailsPageViewRate";
export const ONSITE_VALUE_PER_PRODUCT_DETAILS_PAGE_VIEW =
  "onsiteValuePerProductDetailsPageView";
export const ONSITE_TOTAL_PRODUCT_DETAILS_PAGE_VIEW_VALUE =
  "onsiteTotalProductDetailsPageViewValue";
export const ONSITE_ADD_TO_WISHLIST = "onsiteAddToWishlist";
export const COST_PER_ONSITE_ADD_TO_WISHLIST = "costPerOnsiteAddToWishlist";
export const ONSITE_ADD_TO_WISHLIST_RATE = "onsiteAddToWishlistRate";
export const VALUE_PER_ONSITE_ADD_TO_WISHLIST = "valuePerOnsiteAddToWishlist";
export const TOTAL_ONSITE_ADD_TO_WISHLIST_VALUE =
  "totalOnsiteAddToWishlistValue";
export const ONSITE_ADD_BILLING = "onsiteAddBilling";
export const COST_PER_ONSITE_ADD_BILLING = "costPerOnsiteAddBilling";
export const ONSITE_ADD_BILLING_RATE = "onsiteAddBillingRate";
export const VALUE_PER_ONSITE_ADD_BILLING = "valuePerOnsiteAddBilling";
export const TOTAL_ONSITE_ADD_BILLING_VALUE = "totalOnsiteAddBillingValue";
export const ONSITE_FORM = "onsiteForm";
export const COST_PER_ONSITE_FORM = "costPerOnsiteForm";
export const ONSITE_FORM_RATE = "onsiteFormRate";
export const VALUE_PER_ONSITE_FORM = "valuePerOnsiteForm";
export const TOTAL_ONSITE_FORM_VALUE = "totalOnsiteFormValue";
export const ONSITE_TOTAL_FILTERED_OUT_FORM_SUBMISSION =
  "onsiteTotalFilteredOutFormSubmission";
export const ONSITE_DOWNLOAD_START = "onsiteDownloadStart";
export const COST_PER_ONSITE_DOWNLOAD_START = "costPerOnsiteDownloadStart";
export const ONSITE_DOWNLOAD_START_RATE = "onsiteDownloadStartRate";
export const ONSITE_DESTINATION_VISITS = "onsiteDestinationVisits";
export const COST_PER_ONSITE_DESTINATION_VISIT =
  "costPerOnsiteDestinationVisit";
export const ONSITE_DESTINATION_VISIT_RATE = "onsiteDestinationVisitRate";
export const IX_PAGE_VIEW_COUNT = "ixPageViewCount";
export const COST_PER_IX_PAGE_VIEW_COUNT = "costPerIxPageViewCount";
export const IX_PAGE_VIEW_COUNT_RATE = "ixPageViewCountRate";
export const IX_BUTTON_CLICK_COUNT = "ixButtonClickCount";
export const COST_PER_IX_BUTTON_CLICK_COUNT = "costPerIxButtonClickCount";
export const IX_BUTTON_CLICK_COUNT_RATE = "ixButtonClickCountRate";
export const IX_PRODUCT_CLICK_COUNT = "ixProductClickCount";
export const COST_PER_IX_PRODUCT_CLICK_COUNT = "costPerIxProductClickCount";
export const IX_PRODUCT_CLICK_COUNT_RATE = "ixProductClickCountRate";
export const OFFLINE_TOTAL_CRM_EVENTS = "offlineTotalCrmEvents";
export const OFFLINE_COST_PER_CRM_EVENT = "offlineCostPerCrmEvent";
export const OFFLINE_CRM_EVENT_RATE = "offlineCrmEventRate";
export const OFFLINE_VALUE_PER_CRM_EVENT = "offlineValuePerCrmEvent";
export const OFFLINE_CRM_EVENT_VALUE = "offlineCrmEventValue";
export const OFFLINE_SHOPPING_EVENTS = "offlineShoppingEvents";
export const COST_PER_OFFLINE_SHOPPING_EVENT = "costPerOfflineShoppingEvent";
export const OFFLINE_SHOPPING_EVENT_RATE = "offlineShoppingEventRate";
export const VALUE_PER_OFFLINE_SHOPPING_EVENT = "valuePerOfflineShoppingEvent";
export const OFFLINE_SHOPPING_EVENTS_VALUE = "offlineShoppingEventsValue";
export const OFFLINE_SHOPPING_EVENTS_ROAS = "offlineShoppingEventsRoas";
export const OFFLINE_CONTACT_EVENTS = "offlineContactEvents";
export const COST_PER_OFFLINE_CONTACT_EVENT = "costPerOfflineContactEvent";
export const OFFLINE_CONTACT_EVENT_RATE = "offlineContactEventRate";
export const VALUE_PER_OFFLINE_CONTACT_EVENT = "valuePerOfflineContactEvent";
export const OFFLINE_CONTACT_EVENTS_VALUE = "offlineContactEventsValue";
export const OFFLINE_SUBSCRIBE_EVENTS = "offlineSubscribeEvents";
export const COST_PER_OFFLINE_SUBSCRIBE_EVENT = "costPerOfflineSubscribeEvent";
export const OFFLINE_SUBSCRIBE_EVENT_RATE = "offlineSubscribeEventRate";
export const VALUE_PER_OFFLINE_SUBSCRIBE_EVENT =
  "valuePerOfflineSubscribeEvent";
export const OFFLINE_SUBSCRIBE_EVENTS_VALUE = "offlineSubscribeEventsValue";
export const OFFLINE_FORM_EVENTS = "offlineFormEvents";
export const COST_PER_OFFLINE_FORM_EVENT = "costPerOfflineFormEvent";
export const OFFLINE_FORM_EVENT_RATE = "offlineFormEventRate";
export const VALUE_PER_OFFLINE_FORM_EVENT = "valuePerOfflineFormEvent";
export const OFFLINE_FORM_EVENTS_VALUE = "offlineFormEventsValue";
export const OFFLINE_ADD_PAYMENT_INFO_EVENTS = "offlineAddPaymentInfoEvents";
export const COST_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT =
  "costPerOfflineAddPaymentInfoEvent";
export const OFFLINE_ADD_PAYMENT_INFO_EVENT_RATE =
  "offlineAddPaymentInfoEventRate";
export const VALUE_PER_OFFLINE_ADD_PAYMENT_INFO_EVENT =
  "valuePerOfflineAddPaymentInfoEvent";
export const OFFLINE_ADD_PAYMENT_INFO_EVENTS_VALUE =
  "offlineAddPaymentInfoEventsValue";
export const OFFLINE_ADD_TO_CART_EVENTS = "offlineAddToCartEvents";
export const COST_PER_OFFLINE_ADD_TO_CART_EVENT =
  "costPerOfflineAddToCartEvent";
export const OFFLINE_ADD_TO_CART_EVENT_RATE = "offlineAddToCartEventRate";
export const VALUE_PER_OFFLINE_ADD_TO_CART_EVENT =
  "valuePerOfflineAddToCartEvent";
export const OFFLINE_ADD_TO_CART_EVENTS_VALUE = "offlineAddToCartEventsValue";
export const OFFLINE_ADD_TO_WISHLIST_EVENTS = "offlineAddToWishlistEvents";
export const COST_PER_OFFLINE_ADD_TO_WISHLIST_EVENT =
  "costPerOfflineAddToWishlistEvent";
export const OFFLINE_ADD_TO_WISHLIST_EVENT_RATE =
  "offlineAddToWishlistEventRate";
export const VALUE_PER_OFFLINE_ADD_TO_WISHLIST_EVENT =
  "valuePerOfflineAddToWishlistEvent";
export const OFFLINE_ADD_TO_WISHLIST_EVENTS_VALUE =
  "offlineAddToWishlistEventsValue";
export const OFFLINE_CLICK_BUTTON_EVENTS = "offlineClickButtonEvents";
export const COST_PER_OFFLINE_CLICK_BUTTON_EVENT =
  "costPerOfflineClickButtonEvent";
export const OFFLINE_CLICK_BUTTON_EVENT_RATE = "offlineClickButtonEventRate";
export const VALUE_PER_OFFLINE_CLICK_BUTTON_EVENT =
  "valuePerOfflineClickButtonEvent";
export const OFFLINE_CLICK_BUTTON_EVENTS_VALUE =
  "offlineClickButtonEventsValue";
export const OFFLINE_COMPLETE_REGISTRATION_EVENTS =
  "offlineCompleteRegistrationEvents";
export const COST_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT =
  "costPerOfflineCompleteRegistrationEvent";
export const OFFLINE_COMPLETE_REGISTRATION_EVENT_RATE =
  "offlineCompleteRegistrationEventRate";
export const VALUE_PER_OFFLINE_COMPLETE_REGISTRATION_EVENT =
  "valuePerOfflineCompleteRegistrationEvent";
export const OFFLINE_COMPLETE_REGISTRATION_EVENTS_VALUE =
  "offlineCompleteRegistrationEventsValue";
export const OFFLINE_DOWNLOAD_EVENTS = "offlineDownloadEvents";
export const COST_PER_OFFLINE_DOWNLOAD_EVENT = "costPerOfflineDownloadEvent";
export const OFFLINE_DOWNLOAD_EVENT_RATE = "offlineDownloadEventRate";
export const VALUE_PER_OFFLINE_DOWNLOAD_EVENT = "valuePerOfflineDownloadEvent";
export const OFFLINE_DOWNLOAD_EVENTS_VALUE = "offlineDownloadEventsValue";
export const OFFLINE_INITIATE_CHECKOUT_EVENTS = "offlineInitiateCheckoutEvents";
export const COST_PER_OFFLINE_INITIATE_CHECKOUT_EVENT =
  "costPerOfflineInitiateCheckoutEvent";
export const OFFLINE_INITIATE_CHECKOUT_EVENT_RATE =
  "offlineInitiateCheckoutEventRate";
export const VALUE_PER_OFFLINE_INITIATE_CHECKOUT_EVENT =
  "valuePerOfflineInitiateCheckoutEvent";
export const OFFLINE_INITIATE_CHECKOUT_EVENTS_VALUE =
  "offlineInitiateCheckoutEventsValue";
export const OFFLINE_PLACE_ORDER_EVENTS = "offlinePlaceOrderEvents";
export const COST_PER_OFFLINE_PLACE_ORDER_EVENT =
  "costPerOfflinePlaceOrderEvent";
export const OFFLINE_PLACE_ORDER_EVENT_RATE = "offlinePlaceOrderEventRate";
export const VALUE_PER_OFFLINE_PLACE_ORDER_EVENT =
  "valuePerOfflinePlaceOrderEvent";
export const OFFLINE_PLACE_ORDER_EVENTS_VALUE = "offlinePlaceOrderEventsValue";
export const OFFLINE_SEARCH_EVENTS = "offlineSearchEvents";
export const COST_PER_OFFLINE_SEARCH_EVENT = "costPerOfflineSearchEvent";
export const OFFLINE_SEARCH_EVENT_RATE = "offlineSearchEventRate";
export const VALUE_PER_OFFLINE_SEARCH_EVENT = "valuePerOfflineSearchEvent";
export const OFFLINE_SEARCH_EVENTS_VALUE = "offlineSearchEventsValue";
export const OFFLINE_VIEW_CONTENT_EVENTS = "offlineViewContentEvents";
export const COST_PER_OFFLINE_VIEW_CONTENT_EVENT =
  "costPerOfflineViewContentEvent";
export const OFFLINE_VIEW_CONTENT_EVENT_RATE = "offlineViewContentEventRate";
export const VALUE_PER_OFFLINE_VIEW_CONTENT_EVENT =
  "valuePerOfflineViewContentEvent";
export const OFFLINE_VIEW_CONTENT_EVENTS_VALUE =
  "offlineViewContentEventsValue";
export const OFFLINE_PREFERRED_LEADS = "offlinePreferredLeads";
export const OFFLINE_COST_PER_PREFERRED_LEAD = "offlineCostPerPreferredLead";
export const OFFLINE_PREFERRED_LEAD_RATE = "offlinePreferredLeadRate";
export const OFFLINE_TOTAL_FIND_LOCATION = "offlineTotalFindLocation";
export const OFFLINE_COST_PER_FIND_LOCATION = "offlineCostPerFindLocation";
export const OFFLINE_FIND_LOCATION_RATE = "offlineFindLocationRate";
export const OFFLINE_VALUE_PER_FIND_LOCATION = "offlineValuePerFindLocation";
export const OFFLINE_TOTAL_FIND_LOCATION_VALUE =
  "offlineTotalFindLocationValue";
export const OFFLINE_TOTAL_SCHEDULE = "offlineTotalSchedule";
export const OFFLINE_COST_PER_SCHEDULE = "offlineCostPerSchedule";
export const OFFLINE_SCHEDULE_RATE = "offlineScheduleRate";
export const OFFLINE_VALUE_PER_SCHEDULE = "offlineValuePerSchedule";
export const OFFLINE_TOTAL_SCHEDULE_VALUE = "offlineTotalScheduleValue";
export const OFFLINE_TOTAL_CUSTOMIZE_PRODUCT = "offlineTotalCustomizeProduct";
export const OFFLINE_COST_PER_CUSTOMIZE_PRODUCT =
  "offlineCostPerCustomizeProduct";
export const OFFLINE_CUSTOMIZE_PRODUCT_RATE = "offlineCustomizeProductRate";
export const OFFLINE_VALUE_PER_CUSTOMIZE_PRODUCT =
  "offlineValuePerCustomizeProduct";
export const OFFLINE_TOTAL_CUSTOMIZE_PRODUCT_VALUE =
  "offlineTotalCustomizeProductValue";
export const OFFLINE_TOTAL_CUSTOM_EVENTS = "offlineTotalCustomEvents";
export const OFFLINE_COST_PER_CUSTOM_EVENT = "offlineCostPerCustomEvent";
export const OFFLINE_CUSTOM_EVENT_RATE = "offlineCustomEventRate";
export const OFFLINE_VALUE_PER_CUSTOM_EVENT = "offlineValuePerCustomEvent";
export const OFFLINE_TOTAL_CUSTOM_EVENT_VALUE = "offlineTotalCustomEventValue";
export const MESSAGING_TOTAL_CONVERSATION_TIKTOK_DIRECT_MESSAGE =
  "messagingTotalConversationTiktokDirectMessage";
export const MESSAGING_COST_PER_CONVERSATION_TIKTOK_DIRECT_MESSAGE =
  "messagingCostPerConversationTiktokDirectMessage";
export const MESSAGING_CONVERSATION_RATE_TIKTOK_DIRECT_MESSAGE =
  "messagingConversationRateTiktokDirectMessage";
export const MESSAGING_TOTAL_CONVERSATION_INSTANT_MESSAGING_APP =
  "messagingTotalConversationInstantMessagingApp";
export const MESSAGING_COST_PER_CONVERSATION_INSTANT_MESSAGING_APP =
  "messagingCostPerConversationInstantMessagingApp";
export const MESSAGING_CONVERSATION_RATE_INSTANT_MESSAGING_APP =
  "messagingConversationRateInstantMessagingApp";
export const ONSITE_SHOPPING_ROAS = "onsiteShoppingRoas";
export const ONSITE_SHOPPING = "onsiteShopping";
export const COST_PER_ONSITE_SHOPPING = "costPerOnsiteShopping";
export const ONSITE_SHOPPING_RATE = "onsiteShoppingRate";
export const VALUE_PER_ONSITE_SHOPPING = "valuePerOnsiteShopping";
export const TOTAL_ONSITE_SHOPPING_VALUE = "totalOnsiteShoppingValue";
export const SHOP_TOTAL_PURCHASE_BY_ORDER_SUBMISSION =
  "shopTotalPurchaseByOrderSubmission";
export const SHOP_GROSS_REVENUE_BY_ORDER_SUBMISSION =
  "shopGrossRevenueByOrderSubmission";
export const SHOP_TOTAL_ITEMS_PURCHASED = "shopTotalItemsPurchased";
export const ONSITE_INITIATE_CHECKOUT_COUNT = "onsiteInitiateCheckoutCount";
export const COST_PER_ONSITE_INITIATE_CHECKOUT_COUNT =
  "costPerOnsiteInitiateCheckoutCount";
export const ONSITE_INITIATE_CHECKOUT_COUNT_RATE =
  "onsiteInitiateCheckoutCountRate";
export const VALUE_PER_ONSITE_INITIATE_CHECKOUT_COUNT =
  "valuePerOnsiteInitiateCheckoutCount";
export const TOTAL_ONSITE_INITIATE_CHECKOUT_COUNT_VALUE =
  "totalOnsiteInitiateCheckoutCountValue";
export const ONSITE_ON_WEB_DETAIL = "onsiteOnWebDetail";
export const COST_PER_ONSITE_ON_WEB_DETAIL = "costPerOnsiteOnWebDetail";
export const ONSITE_ON_WEB_DETAIL_RATE = "onsiteOnWebDetailRate";
export const VALUE_PER_ONSITE_ON_WEB_DETAIL = "valuePerOnsiteOnWebDetail";
export const TOTAL_ONSITE_ON_WEB_DETAIL_VALUE = "totalOnsiteOnWebDetailValue";
export const ONSITE_ON_WEB_CART = "onsiteOnWebCart";
export const COST_PER_ONSITE_ON_WEB_CART = "costPerOnsiteOnWebCart";
export const ONSITE_ON_WEB_CART_RATE = "onsiteOnWebCartRate";
export const VALUE_PER_ONSITE_ON_WEB_CART = "valuePerOnsiteOnWebCart";
export const TOTAL_ONSITE_ON_WEB_CART_VALUE = "totalOnsiteOnWebCartValue";
export const VTA_CONVERSION = "vtaConversion";
export const COST_PER_VTA_CONVERSION = "costPerVtaConversion";
export const CTA_CONVERSION = "ctaConversion";
export const COST_PER_CTA_CONVERSION = "costPerCtaConversion";
export const ENGAGED_VIEW_THROUGH_CONVERSIONS = "engagedViewThroughConversions";
export const COST_PER_ENGAGED_VIEW_THROUGH_CONVERSION =
  "costPerEngagedViewThroughConversion";
export const VTA_APP_INSTALL = "vtaAppInstall";
export const COST_PER_VTA_APP_INSTALL = "costPerVtaAppInstall";
export const CTA_APP_INSTALL = "ctaAppInstall";
export const COST_PER_CTA_APP_INSTALL = "costPerCtaAppInstall";
export const EVTA_APP_INSTALL = "evtaAppInstall";
export const COST_PER_EVTA_APP_INSTALL = "costPerEvtaAppInstall";
export const VTA_REGISTRATION = "vtaRegistration";
export const COST_PER_VTA_REGISTRATION = "costPerVtaRegistration";
export const CTA_REGISTRATION = "ctaRegistration";
export const COST_PER_CTA_REGISTRATION = "costPerCtaRegistration";
export const EVTA_REGISTRATION = "evtaRegistration";
export const COST_PER_EVTA_REGISTRATION = "costPerEvtaRegistration";
export const VTA_PURCHASE = "vtaPurchase";
export const COST_PER_VTA_PURCHASE = "costPerVtaPurchase";
export const CTA_PURCHASE = "ctaPurchase";
export const COST_PER_CTA_PURCHASE = "costPerCtaPurchase";
export const EVTA_PURCHASE = "evtaPurchase";
export const COST_PER_EVTA_PURCHASE = "costPerEvtaPurchase";
export const VTA_COMPLETE_PAYMENT = "vtaCompletePayment";
export const COST_PER_VTA_PAYMENTS_COMPLETED = "costPerVtaPaymentsCompleted";
export const EVTA_PAYMENTS_COMPLETED = "evtaPaymentsCompleted";
export const COST_PER_EVTA_PAYMENTS_COMPLETED = "costPerEvtaPaymentsCompleted";
export const VTA_COMPLETE_PAYMENT_VALUE = "vtaCompletePaymentValue";
export const VTA_COMPLETE_PAYMENT_ROAS = "vtaCompletePaymentRoas";

// LinkedIn metrics
export const COMMENTS_LINKEDIN = "comments";
export const COMPANY_PAGE_CLICKS_LINKEDIN = "companyPageClicks";
export const EXTERNAL_WEBSITE_CONVERSIONS_LINKEDIN =
  "externalWebsiteConversions";
export const FOLLOWS_LINKEDIN = "follows";
export const FULL_SCREEN_PLAYS_LINKEDIN = "fullScreenPlays";
export const LANDING_PAGE_CLICKS_LINKEDIN = "landingPageClicks";
export const LIKES_LINKEDIN = "likes";
export const REACTIONS_LINKEDIN = "reactions";
export const RETURN_ON_AD_SPEND_LINKEDIN = "returnOnAdSpend";
export const SHARES_LINKEDIN = "shares";
export const TOTAL_ENGAGEMENTS_LINKEDIN = "totalEngagements";
export const VIDEO_COMPLETIONS_LINKEDIN = "videoCompletions";
export const VIDEO_STARTS_LINKEDIN = "videoStarts";
export const VIDEO_VIEWS_LINKEDIN = "videoViews";
export const ONE_CLICK_LEADS_LINKEDIN = "oneClickLeads";
export const ONE_CLICK_LEAD_FORM_OPENS_LINKEDIN = "oneClickLeadFormOpens";
export const LEAD_FORM_COMPLETION_RATE_LINKEDIN = "leadFormCompletionRate";
export const VALID_WORK_EMAIL_LEADS_LINKEDIN = "validWorkEmailLeads";
export const DOWNLOAD_CLICKS_LINKEDIN = "downloadClicks";
export const DOCUMENT_FIRST_QUARTILE_COMPLETIONS_LINKEDIN =
  "documentFirstQuartileCompletions";
export const DOCUMENT_MIDPOINT_COMPLETIONS_LINKEDIN =
  "documentMidpointCompletions";
export const DOCUMENT_THIRD_QUARTILE_COMPLETIONS_LINKEDIN =
  "documentThirdQuartileCompletions";
export const DOCUMENT_COMPLETIONS_LINKEDIN = "documentCompletions";

export const SKAN_RESULT = "skanResult";
export const SKAN_COST_PER_RESULT = "skanCostPerResult";
export const SKAN_RESULT_RATE = "skanResultRate";
export const SKAN_CONVERSION = "skanConversion";
export const SKAN_COST_PER_CONVERSION = "skanCostPerConversion";
export const SKAN_CONVERSION_RATE = "skanConversionRate";
export const SKAN_CONVERSION_RATE_V2 = "skanConversionRateV2";
export const SKAN_CLICK_TIME_CONVERSION = "skanClickTimeConversion";
export const SKAN_CLICK_TIME_COST_PER_CONVERSION =
  "skanClickTimeCostPerConversion";
export const SKAN_CLICK_TIME_CONVERSION_RATE = "skanClickTimeConversionRate";
export const SKAN_CLICK_TIME_CONVERSION_RATE_V2 =
  "skanClickTimeConversionRateV2";
export const SKAN_APP_INSTALL = "skanAppInstall";
export const SKAN_COST_PER_APP_INSTALL = "skanCostPerAppInstall";
export const SKAN_APP_INSTALL_WITHHELD = "skanAppInstallWithheld";
export const SKAN_REGISTRATION = "skanRegistration";
export const SKAN_COST_PER_REGISTRATION = "skanCostPerRegistration";
export const SKAN_REGISTRATION_RATE = "skanRegistrationRate";
export const SKAN_TOTAL_REGISTRATION = "skanTotalRegistration";
export const SKAN_COST_PER_TOTAL_REGISTRATION = "skanCostPerTotalRegistration";
export const SKAN_PURCHASE = "skanPurchase";
export const SKAN_COST_PER_PURCHASE = "skanCostPerPurchase";
export const SKAN_PURCHASE_RATE = "skanPurchaseRate";
export const SKAN_TOTAL_PURCHASE = "skanTotalPurchase";
export const SKAN_COST_PER_TOTAL_PURCHASE = "skanCostPerTotalPurchase";
export const SKAN_TOTAL_PURCHASE_VALUE = "skanTotalPurchaseValue";
export const SKAN_TOTAL_REPETITIVE_ACTIVE_PAY_ROAS =
  "skanTotalRepetitiveActivePayRoas";
export const SKAN_ADD_TO_CART = "skanAddToCart";
export const SKAN_COST_PER_ADD_TO_CART = "skanCostPerAddToCart";
export const SKAN_ADD_TO_CART_RATE = "skanAddToCartRate";
export const SKAN_TOTAL_ADD_TO_CART = "skanTotalAddToCart";
export const SKAN_COST_PER_TOTAL_ADD_TO_CART = "skanCostPerTotalAddToCart";
export const SKAN_TOTAL_ADD_TO_CART_VALUE = "skanTotalAddToCartValue";
export const SKAN_CHECKOUT = "skanCheckout";
export const SKAN_COST_PER_CHECKOUT = "skanCostPerCheckout";
export const SKAN_CHECKOUT_RATE = "skanCheckoutRate";
export const SKAN_TOTAL_CHECKOUT = "skanTotalCheckout";
export const SKAN_COST_PER_TOTAL_CHECKOUT = "skanCostPerTotalCheckout";
export const SKAN_TOTAL_CHECKOUT_VALUE = "skanTotalCheckoutValue";
export const SKAN_VIEW_CONTENT = "skanViewContent";
export const SKAN_COST_PER_VIEW_CONTENT = "skanCostPerViewContent";
export const SKAN_VIEW_CONTENT_RATE = "skanViewContentRate";
export const SKAN_TOTAL_VIEW_CONTENT = "skanTotalViewContent";
export const SKAN_COST_PER_TOTAL_VIEW_CONTENT = "skanCostPerTotalViewContent";
export const SKAN_TOTAL_VIEW_CONTENT_VALUE = "skanTotalViewContentValue";
export const SKAN_ADD_PAYMENT_INFO = "skanAddPaymentInfo";
export const SKAN_COST_PER_ADD_PAYMENT_INFO = "skanCostPerAddPaymentInfo";
export const SKAN_ADD_PAYMENT_INFO_RATE = "skanAddPaymentInfoRate";
export const SKAN_TOTAL_ADD_PAYMENT_INFO = "skanTotalAddPaymentInfo";
export const SKAN_COST_TOTAL_ADD_PAYMENT_INFO = "skanCostTotalAddPaymentInfo";
export const SKAN_ADD_TO_WISHLIST = "skanAddToWishlist";
export const SKAN_COST_PER_ADD_TO_WISHLIST = "skanCostPerAddToWishlist";
export const SKAN_ADD_TO_WISHLIST_RATE = "skanAddToWishlistRate";
export const SKAN_TOTAL_ADD_TO_WISHLIST = "skanTotalAddToWishlist";
export const SKAN_COST_PER_TOTAL_ADD_TO_WISHLIST =
  "skanCostPerTotalAddToWishlist";
export const SKAN_TOTAL_ADD_TO_WISHLIST_VALUE = "skanTotalAddToWishlistValue";
export const SKAN_LAUNCH_APP = "skanLaunchApp";
export const SKAN_COST_PER_LAUNCH_APP = "skanCostPerLaunchApp";
export const SKAN_LAUNCH_APP_RATE = "skanLaunchAppRate";
export const SKAN_TOTAL_LAUNCH_APP = "skanTotalLaunchApp";
export const SKAN_COST_PER_TOTAL_LAUNCH_APP = "skanCostPerTotalLaunchApp";
export const SKAN_COMPLETE_TUTORIAL = "skanCompleteTutorial";
export const SKAN_COST_PER_COMPLETE_TUTORIAL = "skanCostPerCompleteTutorial";
export const SKAN_COMPLETE_TUTORIAL_RATE = "skanCompleteTutorialRate";
export const SKAN_TOTAL_COMPLETE_TUTORIAL = "skanTotalCompleteTutorial";
export const SKAN_COST_PER_TOTAL_COMPLETE_TUTORIAL =
  "skanCostPerTotalCompleteTutorial";
export const SKAN_TOTAL_COMPLETE_TUTORIAL_VALUE =
  "skanTotalCompleteTutorialValue";
export const SKAN_CREATE_GROUP = "skanCreateGroup";
export const SKAN_COST_PER_CREATE_GROUP = "skanCostPerCreateGroup";
export const SKAN_CREATE_GROUP_RATE = "skanCreateGroupRate";
export const SKAN_TOTAL_CREATE_GROUP = "skanTotalCreateGroup";
export const SKAN_COST_PER_TOTAL_CREATE_GROUP = "skanCostPerTotalCreateGroup";
export const SKAN_TOTAL_CREATE_GROUP_VALUE = "skanTotalCreateGroupValue";
export const SKAN_JOIN_GROUP = "skanJoinGroup";
export const SKAN_COST_PER_JOIN_GROUP = "skanCostPerJoinGroup";
export const SKAN_JOIN_GROUP_RATE = "skanJoinGroupRate";
export const SKAN_TOTAL_JOIN_GROUP = "skanTotalJoinGroup";
export const SKAN_COST_PER_TOTAL_JOIN_GROUP = "skanCostPerTotalJoinGroup";
export const SKAN_TOTAL_JOIN_GROUP_VALUE = "skanTotalJoinGroupValue";
export const SKAN_CREATE_GAMEROLE = "skanCreateGamerole";
export const SKAN_COST_PER_CREATE_GAMEROLE = "skanCostPerCreateGamerole";
export const SKAN_CREATE_GAMEROLE_RATE = "skanCreateGameroleRate";
export const SKAN_TOTAL_CREATE_GAMEROLE = "skanTotalCreateGamerole";
export const SKAN_COST_PER_TOTAL_CREATE_GAMEROLE =
  "skanCostPerTotalCreateGamerole";
export const SKAN_TOTAL_CREATE_GAMEROLE_VALUE = "skanTotalCreateGameroleValue";
export const SKAN_SPEND_CREDITS = "skanSpendCredits";
export const SKAN_COST_PER_SPEND_CREDITS = "skanCostPerSpendCredits";
export const SKAN_SPEND_CREDITS_RATE = "skanSpendCreditsRate";
export const SKAN_TOTAL_SPEND_CREDITS = "skanTotalSpendCredits";
export const SKAN_COST_PER_TOTAL_SPEND_CREDITS = "skanCostPerTotalSpendCredits";
export const SKAN_TOTAL_SPEND_CREDITS_VALUE = "skanTotalSpendCreditsValue";
export const SKAN_ACHIEVE_LEVEL = "skanAchieveLevel";
export const SKAN_COST_PER_ACHIEVE_LEVEL = "skanCostPerAchieveLevel";
export const SKAN_ACHIEVE_LEVEL_RATE = "skanAchieveLevelRate";
export const SKAN_TOTAL_ACHIEVE_LEVEL = "skanTotalAchieveLevel";
export const SKAN_COST_PER_TOTAL_ACHIEVE_LEVEL = "skanCostPerTotalAchieveLevel";
export const SKAN_TOTAL_ACHIEVE_LEVEL_VALUE = "skanTotalAchieveLevelValue";
export const SKAN_UNLOCK_ACHIEVEMENT = "skanUnlockAchievement";
export const SKAN_COST_PER_UNLOCK_ACHIEVEMENT = "skanCostPerUnlockAchievement";
export const SKAN_UNLOCK_ACHIEVEMENT_RATE = "skanUnlockAchievementRate";
export const SKAN_TOTAL_UNLOCK_ACHIEVEMENT = "skanTotalUnlockAchievement";
export const SKAN_COST_PER_TOTAL_UNLOCK_ACHIEVEMENT =
  "skanCostPerTotalUnlockAchievement";
export const SKAN_TOTAL_UNLOCK_ACHIEVEMENT_VALUE =
  "skanTotalUnlockAchievementValue";
export const SKAN_SALES_LEAD = "skanSalesLead";
export const SKAN_COST_PER_SALES_LEAD = "skanCostPerSalesLead";
export const SKAN_SALES_LEAD_RATE = "skanSalesLeadRate";
export const SKAN_TOTAL_SALES_LEAD = "skanTotalSalesLead";
export const SKAN_COST_PER_TOTAL_SALES_LEAD = "skanCostPerTotalSalesLead";
export const SKAN_TOTAL_SALES_LEAD_VALUE = "skanTotalSalesLeadValue";
export const SKAN_IN_APP_AD_CLICK = "skanInAppAdClick";
export const SKAN_COST_PER_IN_APP_AD_CLICK = "skanCostPerInAppAdClick";
export const SKAN_IN_APP_AD_CLICK_RATE = "skanInAppAdClickRate";
export const SKAN_TOTAL_IN_APP_AD_CLICK = "skanTotalInAppAdClick";
export const SKAN_COST_PER_TOTAL_IN_APP_AD_CLICK =
  "skanCostPerTotalInAppAdClick";
export const SKAN_TOTAL_IN_APP_AD_CLICK_VALUE = "skanTotalInAppAdClickValue";
export const SKAN_IN_APP_AD_IMPR = "skanInAppAdImpr";
export const SKAN_COST_PER_IN_APP_AD_IMPR = "skanCostPerInAppAdImpr";
export const SKAN_IN_APP_AD_IMPR_RATE = "skanInAppAdImprRate";
export const SKAN_TOTAL_IN_APP_AD_IMPR = "skanTotalInAppAdImpr";
export const SKAN_COST_PER_TOTAL_IN_APP_AD_IMPR = "skanCostPerTotalInAppAdImpr";
export const SKAN_TOTAL_IN_APP_AD_IMPR_VALUE = "skanTotalInAppAdImprValue";
export const SKAN_LOAN_APPLY = "skanLoanApply";
export const SKAN_COST_PER_LOAN_APPLY = "skanCostPerLoanApply";
export const SKAN_LOAN_APPLY_RATE = "skanLoanApplyRate";
export const SKAN_TOTAL_LOAN_APPLY = "skanTotalLoanApply";
export const SKAN_COST_PER_TOTAL_LOAN_APPLY = "skanCostPerTotalLoanApply";
export const SKAN_LOAN_CREDIT = "skanLoanCredit";
export const SKAN_COST_PER_LOAN_CREDIT = "skanCostPerLoanCredit";
export const SKAN_LOAN_CREDIT_RATE = "skanLoanCreditRate";
export const SKAN_TOTAL_LOAN_CREDIT = "skanTotalLoanCredit";
export const SKAN_COST_PER_TOTAL_LOAN_CREDIT = "skanCostPerTotalLoanCredit";
export const SKAN_LOAN_DISBURSEMENT = "skanLoanDisbursement";
export const SKAN_COST_PER_LOAN_DISBURSEMENT = "skanCostPerLoanDisbursement";
export const SKAN_LOAN_DISBURSEMENT_RATE = "skanLoanDisbursementRate";
export const SKAN_TOTAL_LOAN_DISBURSEMENT = "skanTotalLoanDisbursement";
export const SKAN_COST_PER_TOTAL_LOAN_DISBURSEMENT =
  "skanCostPerTotalLoanDisbursement";
export const SKAN_LOGIN = "skanLogin";
export const SKAN_COST_PER_LOGIN = "skanCostPerLogin";
export const SKAN_LOGIN_RATE = "skanLoginRate";
export const SKAN_TOTAL_LOGIN = "skanTotalLogin";
export const SKAN_COST_PER_TOTAL_LOGIN = "skanCostPerTotalLogin";
export const SKAN_RATINGS = "skanRatings";
export const SKAN_COST_PER_RATINGS = "skanCostPerRatings";
export const SKAN_RATINGS_RATE = "skanRatingsRate";
export const SKAN_TOTAL_RATINGS = "skanTotalRatings";
export const SKAN_COST_PER_TOTAL_RATINGS = "skanCostPerTotalRatings";
export const SKAN_TOTAL_RATINGS_VALUE = "skanTotalRatingsValue";
export const SKAN_SEARCH = "skanSearch";
export const SKAN_COST_PER_SEARCH = "skanCostPerSearch";
export const SKAN_SEARCH_RATE = "skanSearchRate";
export const SKAN_TOTAL_SEARCH = "skanTotalSearch";
export const SKAN_COST_PER_TOTAL_SEARCH = "skanCostPerTotalSearch";
export const SKAN_START_TRIAL = "skanStartTrial";
export const SKAN_COST_PER_START_TRIAL = "skanCostPerStartTrial";
export const SKAN_START_TRIAL_RATE = "skanStartTrialRate";
export const SKAN_TOTAL_START_TRIAL = "skanTotalStartTrial";
export const SKAN_COST_PER_TOTAL_START_TRIAL = "skanCostPerTotalStartTrial";
export const SKAN_SUBSCRIBE = "skanSubscribe";
export const SKAN_COST_PER_SUBSCRIBE = "skanCostPerSubscribe";
export const SKAN_SUBSCRIBE_RATE = "skanSubscribeRate";
export const SKAN_TOTAL_SUBSCRIBE = "skanTotalSubscribe";
export const SKAN_COST_PER_TOTAL_SUBSCRIBE = "skanCostPerTotalSubscribe";
export const SKAN_TOTAL_SUBSCRIBE_VALUE = "skanTotalSubscribeValue";
export const SKAN_VTA_CONVERSION = "skanVtaConversion";
export const SKAN_COST_PER_VTA_CONVERSION = "skanCostPerVtaConversion";
export const SKAN_VTA_APP_INSTALL = "skanVtaAppInstall";
export const SKAN_COST_PER_VTA_APP_INSTALL = "skanCostPerVtaAppInstall";
export const SKAN_VTA_REGISTRATION = "skanVtaRegistration";
export const SKAN_COST_PER_VTA_REGISTRATION = "skanCostPerVtaRegistration";
export const SKAN_VTA_PURCHASE = "skanVtaPurchase";
export const SKAN_COST_PER_VTA_PURCHASE = "skanCostPerVtaPurchase";
export const SKAN_CTA_CONVERSION = "skanCtaConversion";
export const SKAN_COST_PER_CTA_CONVERSION = "skanCostPerCtaConversion";
export const SKAN_CTA_APP_INSTALL = "skanCtaAppInstall";
export const SKAN_COST_PER_CTA_APP_INSTALL = "skanCostPerCtaAppInstall";
export const SKAN_CTA_REGISTRATION = "skanCtaRegistration";
export const SKAN_COST_PER_CTA_REGISTRATION = "skanCostPerCtaRegistration";
export const SKAN_CTA_PURCHASE = "skanCtaPurchase";
export const SKAN_COST_PER_CTA_PURCHASE = "skanCostPerCtaPurchase";

export const CHAT_QUESTION_1 = "chatQuestion1";
export const CHAT_QUESTION_2 = "chatQuestion2";
export const CHAT_QUESTION_3 = "chatQuestion3";
export const CHAT_QUESTION_4 = "chatQuestion4";
export const CHAT_QUESTION_5 = "chatQuestion5";
export const CHAT_QUESTION_6 = "chatQuestion6";
export const CHAT_QUESTION_7 = "chatQuestion7";
export const CHAT_QUESTION_8 = "chatQuestion8";
export const CHAT_QUESTION_9 = "chatQuestion9";

//RESERVATION STATUS
export const RESERVATION_STATUS_1 = "reservationStatus1";
export const RESERVATION_STATUS_2 = "reservationStatus2";
export const RESERVATION_STATUS_3 = "reservationStatus3";
export const RESERVATION_STATUS_4 = "reservationStatus4";
export const RESERVATION_STATUS_5 = "reservationStatus5";
export const RESERVATION_STATUS_6 = "reservationStatus6";
export const RESERVATION_STATUS_7 = "reservationStatus7";
export const RESERVATION_STATUS_8 = "reservationStatus8";
export const RESERVATION_STATUS_9 = "reservationStatus9";
export const RESERVATION_STATUS_10 = "reservationStatus10";
export const RESERVATION_STATUS_11 = "reservationStatus11";
export const RESERVATION_STATUS_12 = "reservationStatus12";
export const RESERVATION_STATUS_13 = "reservationStatus13";
export const RESERVATION_STATUS_14 = "reservationStatus14";
export const RESERVATION_STATUS_15 = "reservationStatus15";
export const RESERVATION_STATUS_16 = "reservationStatus16";
export const RESERVATION_STATUS_17 = "reservationStatus17";
export const RESERVATION_STATUS_18 = "reservationStatus18";
export const RESERVATION_STATUS_19 = "reservationStatus19";
export const RESERVATION_STATUS_20 = "reservationStatus20";
export const RESERVATION_STATUS_21 = "reservationStatus21";
export const RESERVATION_STATUS_23 = "reservationStatus23";
export const RESERVATION_STATUS_24 = "reservationStatus24";
export const RESERVATION_STATUS_25 = "reservationStatus25";
export const RESERVATION_STATUS_26 = "reservationStatus26";
export const RESERVATION_STATUS_27 = "reservationStatus27";
export const RESERVATION_STATUS_28 = "reservationStatus28";
export const RESERVATION_STATUS_29 = "reservationStatus29";
export const RESERVATION_STATUS_30 = "reservationStatus30";
export const RESERVATION_STATUS_31 = "reservationStatus31";
export const RESERVATION_STATUS_32 = "reservationStatus32";
export const RESERVATION_STATUS_35 = "reservationStatus35";
export const RESERVATION_STATUS_36 = "reservationStatus36";
export const RESERVATION_STATUS_37 = "reservationStatus37";
export const RESERVATION_STATUS_39 = "reservationStatus39";
export const RESERVATION_STATUS_40 = "reservationStatus40";
export const RESERVATION_STATUS_41 = "reservationStatus41";
export const RESERVATION_STATUS_42 = "reservationStatus42";
export const RESERVATION_STATUS_44 = "reservationStatus44";
export const RESERVATION_STATUS_45 = "reservationStatus45";
export const RESERVATION_STATUS_50 = "reservationStatus50";
export const RESERVATION_STATUS_53 = "reservationStatus53";
export const RESERVATION_STATUS_60 = "reservationStatus60";
export const RESERVATION_STATUS_66 = "reservationStatus66";
export const RESERVATION_STATUS_69 = "reservationStatus69";
export const RESERVATION_STATUS_100 = "reservationStatus100";

// OVERVIEW REPORT
export const OVERVIEW_REPORT_GENERATING_SUMMARY =
  "overviewReportGeneratingSummary";
export const OVERVIEW_REPORT_SUMMARY_NOT_GENERATED =
  "overviewReportSummaryNotGenerated";

// GENERATE PDF
export const REPORT_DATE_GENERATED = "reportDateGenerated";
export const REPORT_GENERATED_BY_BUZZLY_AI = "reportGeneratedByBuzzlyAI";
export const AI_GENERATED_SECTION_CHIP = "aiGeneratedSectionChip";
export const AI_GENERATED_SECTION_CHIP_ARIA = "aiGeneratedSectionChipAria";
export const DOWNLOADING_PDF = "downloadingPDF";
export const PDF_DOWNLOADED_SUCCESSFULLY = "pdfDownloadedSuccessfully";
export const OPTIMIZATION = "optimization";

// MODAL WELCOME
export const MODAL_WELCOME_TITLE = "modalWelcomeTitle";
export const MODAL_WELCOME_SUBTITLE = "modalWelcomeSubtitle";
export const MODAL_WELCOME_PLAN_NAME = "modalWelcomePlanName";
export const MODAL_WELCOME_BUTTON = "modalWelcomeButton";

// MODAL REDIRECT BRAND SETUP
export const MODAL_REDIRECT_BRAND_SETUP_TITLE = "modalRedirectBrandSetupTitle";
export const MODAL_REDIRECT_BRAND_SETUP_SUBTITLE =
  "modalRedirectBrandSetupSubtitle";
export const MODAL_REDIRECT_BRAND_SETUP_BUTTON =
  "modalRedirectBrandSetupButton";

// MODAL SUCCESS BRAND SETUP
export const MODAL_SUCCESS_BRAND_SETUP_TITLE = "modalSuccessBrandSetupTitle";
export const MODAL_SUCCESS_BRAND_SETUP_SUBTITLE =
  "modalSuccessBrandSetupSubtitle";
export const MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_TITLE =
  "modalSuccessBrandSetupOptionContentTitle";
export const MODAL_SUCCESS_BRAND_SETUP_OPTION_CAMPAIGN_DESCRIPTION =
  "modalSuccessBrandSetupOptionContentDescription";
export const MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_TITLE =
  "modalSuccessBrandSetupOptionAdsTitle";
export const MODAL_SUCCESS_BRAND_SETUP_OPTION_ADS_DESCRIPTION =
  "modalSuccessBrandSetupOptionAdsDescription";
export const MODAL_SUCCESS_BRAND_SETUP_OPTION_POST_TITLE =
  "modalSuccessBrandSetupOptionCalendarTitle";
export const MODAL_SUCCESS_BRAND_SETUP_OPTION_CALENDAR_DESCRIPTION =
  "modalSuccessBrandSetupOptionCalendarDescription";
export const MODAL_SUCCESS_BRAND_SETUP_BUTTON_START =
  "modalSuccessBrandSetupButtonStart";
export const MODAL_SUCCESS_BRAND_SETUP_BUTTON_LATER =
  "modalSuccessBrandSetupButtonLater";

// ONBOARDING CHECKLIST
export const ONBOARDING_CHECKLIST_HEADER_TITLE =
  "onboardingChecklistHeaderTitle";
export const ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_TITLE =
  "onboardingChecklistItemBrandSetupTitle";
export const ONBOARDING_CHECKLIST_ITEM_CREATIVES_TITLE =
  "onboardingChecklistItemCreativesTitle";
export const ONBOARDING_CHECKLIST_ITEM_PUBLISH_TITLE =
  "onboardingChecklistItemPublishTitle";
export const ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_TITLE =
  "onboardingChecklistItemCampaignTitle";
export const ONBOARDING_CHECKLIST_FOOTER_COMPLETED =
  "onboardingChecklistFooterCompleted";
export const ONBOARDING_CHECKLIST_SUBTITLE = "onboardingChecklistSubtitle";
export const ONBOARDING_CHECKLIST_ITEM_BRAND_SETUP_DESCRIPTION =
  "onboardingChecklistItemBrandSetupDescription";
export const ONBOARDING_CHECKLIST_ITEM_CREATIVES_DESCRIPTION =
  "onboardingChecklistItemCreativesDescription";
export const ONBOARDING_CHECKLIST_ITEM_PUBLISH_DESCRIPTION =
  "onboardingChecklistItemPublishDescription";
export const ONBOARDING_CHECKLIST_ITEM_CAMPAIGN_DESCRIPTION =
  "onboardingChecklistItemCampaignDescription";
export const ONBOARDING_CHECKLIST_PROGRESS_COMPLETED =
  "onboardingChecklistProgressCompleted";
export const ONBOARDING_CHECKLIST_SKIP_GUIDE = "onboardingChecklistSkipGuide";

// CONNECTION PROGRESS MODAL
export const CONNECTING_TO_PLATFORM = "connectingToPlatform";
export const CONNECTING_TO_PLATFORM_DESCRIPTION =
  "connectingToPlatformDescription";

// MODAL CANCEL SUBSCRIPTION
export const MODAL_CANCEL_SUBSCRIPTION_TITLE = "modalCancelSubscriptionTitle";
export const MODAL_CANCEL_SUBSCRIPTION_SUBTITLE =
  "modalCancelSubscriptionSubtitle";
export const MODAL_CANCEL_SUBSCRIPTION_SUBTITLE_WARNING =
  "modalCancelSubscriptionSubtitleWarning";
export const MODAL_CANCEL_SUBSCRIPTION_CONFIRM_BUTTON =
  "modalCancelSubscriptionConfirmButton";
export const MODAL_CANCEL_SUBSCRIPTION_REASON_TITLE =
  "modalCancelSubscriptionReasonTitle";
export const MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER =
  "modalCancelSubscriptionReasonPlaceholder";
export const MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT =
  "modalCancelSubscriptionReasonHelperText";
export const MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS =
  "modalCancelSubscriptionReasonHelperTextMinChars";
export const MODAL_CANCEL_SUBSCRIPTION_WARNING_MESSAGE =
  "modalCancelSubscriptionWarningMessage";
export const MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_LIMITED_OFFER =
  "modalCancelSubscriptionBasicRetentionLimitedOffer";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_TITLE =
  "modalCancelSubscriptionDestructiveTitle";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_INTRO =
  "modalCancelSubscriptionDestructiveIntro";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_CAMPAIGNS =
  "modalCancelSubscriptionDestructiveBulletCampaigns";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_GALLERY =
  "modalCancelSubscriptionDestructiveBulletGallery";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_DATA =
  "modalCancelSubscriptionDestructiveBulletData";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_BULLET_API_CONNECTIONS =
  "modalCancelSubscriptionDestructiveBulletApiConnections";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_INTRO =
  "modalCancelSubscriptionDestructiveRecommendationIntro";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DOWNLOAD_GALLERY =
  "modalCancelSubscriptionDestructiveRecommendationBulletDownloadGallery";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_EXPORT_REPORTS =
  "modalCancelSubscriptionDestructiveRecommendationBulletExportReports";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_RECOMMENDATION_BULLET_DUPLICATE_CAMPAIGNS =
  "modalCancelSubscriptionDestructiveRecommendationBulletDuplicateCampaigns";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_NO_RECOVERY =
  "modalCancelSubscriptionDestructiveNoRecovery";
export const MODAL_CANCEL_SUBSCRIPTION_DESTRUCTIVE_CONFIRM_PROMPT =
  "modalCancelSubscriptionDestructiveConfirmPrompt";
export const MODAL_CANCEL_SUBSCRIPTION_CONFIRM_WORD =
  "modalCancelSubscriptionConfirmWord";
export const BUTTON_KEEP_MY_ACCOUNT = "buttonKeepMyAccount";
export const MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_INTRO =
  "modalCancelSubscriptionBasicRetentionIntro";
export const MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_FROM_DATE =
  "modalCancelSubscriptionBasicRetentionPricingFromDate";
export const MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_PRICING_NO_DATE =
  "modalCancelSubscriptionBasicRetentionPricingNoDate";
export const MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_IMMEDIATE_CREDITS =
  "modalCancelSubscriptionBasicRetentionImmediateCredits";
export const MODAL_CANCEL_SUBSCRIPTION_BASIC_RETENTION_TAKE_OFFER_BUTTON =
  "modalCancelSubscriptionBasicRetentionTakeOfferButton";
export const MODAL_CANCEL_SUBSCRIPTION_RETENTION_OFFER_REDEEMED_SUCCESS =
  "modalCancelSubscriptionRetentionOfferRedeemedSuccess";
export const BUTTON_CANCEL_PLAN_AND_DELETE_CAMPAIGNS =
  "buttonCancelPlanAndDeleteCampaigns";

// CANCELLATION REASONS
export const CANCELLATION_REASON_SELECT_LABEL = "cancellationReasonSelectLabel";
export const CANCELLATION_REASON_TOO_EXPENSIVE =
  "cancellationReasonTooExpensive";
export const CANCELLATION_REASON_NOT_FREQUENT_USE =
  "cancellationReasonNotFrequentUse";
export const CANCELLATION_REASON_BETTER_ALTERNATIVE =
  "cancellationReasonBetterAlternative";
export const CANCELLATION_REASON_TECHNICAL_ISSUES =
  "cancellationReasonTechnicalIssues";
export const CANCELLATION_REASON_NOT_MEET_NEEDS =
  "cancellationReasonNotMeetNeeds";
export const CANCELLATION_REASON_DIFFICULT_TO_USE =
  "cancellationReasonDifficultToUse";
export const CANCELLATION_REASON_SITUATION_CHANGED =
  "cancellationReasonSituationChanged";
export const CANCELLATION_REASON_TEMPORARY_NEED =
  "cancellationReasonTemporaryNeed";
export const CANCELLATION_REASON_SECURITY_CONCERNS =
  "cancellationReasonSecurityConcerns";
export const CANCELLATION_REASON_OTHER = "cancellationReasonOther";

// FILTERS GALLERY
export const FILTERS_GALLERY_IMAGE = "filtersGalleryImage";
export const FILTERS_GALLERY_VIDEO = "filtersGalleryVideo";
export const FILTERS_GALLERY_HORIZONTAL = "filtersGalleryHorizontal";
export const FILTERS_GALLERY_VERTICAL = "filtersGalleryVertical";
export const FILTERS_GALLERY_SQUARE = "filtersGallerySquare";
export const FILTERS_GALLERY_TODAY = "filtersGalleryToday";
export const FILTERS_GALLERY_WEEK = "filtersGalleryWeek";
export const FILTERS_GALLERY_MONTH = "filtersGalleryMonth";
export const FILTERS_GALLERY_YEAR = "filtersGalleryYear";
export const FILTERS_GALLERY_RESET_FILTERS = "filtersGalleryResetFilters";
export const FILTERS_GALLERY_RESULTS_COUNTER = "filtersGalleryResultsCounter";

// GALLERY CONTENT SOURCES
export const GALLERY_SOURCE_MY_CONTENT = "gallerySourceMyContent";
export const GALLERY_SOURCE_GOOGLE = "gallerySourceGoogle";
export const GALLERY_SOURCE_AD_ACCOUNT = "gallerySourceAdAccount";
export const GALLERY_SOURCE_AD_ACCOUNT_EMPTY = "gallerySourceAdAccountEmpty";
export const GALLERY_SOURCE_GOOGLE_DRIVE = "gallerySourceGoogleDrive";
export const GALLERY_SOURCE_SOCIAL_POSTS = "gallerySourceSocialPosts";
export const GALLERY_SOCIAL_POSTS_DESCRIPTION = "gallerySocialPostsDescription";
export const GALLERY_VIDEO_THUMBNAIL_FALLBACK_TOOLTIP =
  "galleryVideoThumbnailFallbackTooltip";
export const GALLERY_SOURCE_CANVA = "gallerySourceCanva";
export const GALLERY_SELECT_SOURCE = "gallerySelectSource";
export const GALLERY_ASSETS_TITLE = "galleryAssetsTitle";
export const GALLERY_ASSETS_RENAME_TITLE = "galleryAssetsRenameTitle";
export const GALLERY_ASSETS_RENAME_SUCCESS = "galleryAssetsRenameSuccess";
export const GALLERY_ASSETS_RENAME_ERROR = "galleryAssetsRenameError";
export const GALLERY_ASSETS_RENAME_ARIA_LABEL = "galleryAssetsRenameAriaLabel";
export const GALLERY_ASSETS_NAME_LABEL = "galleryAssetsNameLabel";
export const GALLERY_UPLOADING_ASSETS = "galleryUploadingAssets";
export const GALLERY_GOOGLE_NOT_CONNECTED = "galleryGoogleNotConnected";
export const GALLERY_META_NOT_CONNECTED = "galleryMetaNotConnected";
export const GALLERY_CONTENT_TYPE = "galleryContentType";
export const GALLERY_DIMENSIONS = "galleryDimensions";
export const GALLERY_DATE_RANGE = "galleryDateRange";
export const GALLERY_TITLE_DIMENSIONS = "galleryTitleDimensions";

// CAROUSEL IMAGES MANAGER
export const CAROUSEL_IMAGES_MANAGER_TITLE = "carouselImagesManagerTitle";
export const CAROUSEL_IMAGES_MANAGER_DELETE_ALL =
  "carouselImagesManagerDeleteAll";
export const CAROUSEL_IMAGES_MANAGER_ADD_IMAGE =
  "carouselImagesManagerAddImage";
export const CAROUSEL_IMAGES_MANAGER_NO_IMAGES =
  "carouselImagesManagerNoImages";
export const CAROUSEL_IMAGES_MANAGER_DIMENSIONS_HELP =
  "carouselImagesManagerDimensionsHelp";

// MODAL SHARE INSTAGRAM
export const MODAL_SHARE_TITLE = "modalShareInstagramTitle";
export const MODAL_SHARE_SELECT_PLATFORMS_TITLE =
  "modalShareSelectPlatformsTitle";
export const META_GENERATE_CAMPAIGN_IDENTITIES_PLACEMENTS_HINT =
  "metaGenerateCampaignIdentitiesPlacementsHint";
export const MODAL_CLOSE_UNSAVED_WARNING_DESCRIPTION =
  "modalCloseUnsavedWarningDescription";
export const MODAL_CLOSE_UNSAVED_CONFIRM = "modalCloseUnsavedConfirm";
export const META_ADAPT_PLACEMENTS_CONFIRM_TITLE =
  "metaAdaptPlacementsConfirmTitle";
export const META_ADAPT_PLACEMENTS_CONFIRM_TEXT =
  "metaAdaptPlacementsConfirmText";
export const META_ADAPT_PLACEMENTS_CONFIRM_YES =
  "metaAdaptPlacementsConfirmYes";
export const META_ADAPT_PLACEMENTS_CONFIRM_NO = "metaAdaptPlacementsConfirmNo";
export const META_ADAPT_PLACEMENTS_CHECKBOX_LABEL =
  "metaAdaptPlacementsCheckboxLabel";
export const META_ADAPT_PLACEMENTS_CHECKBOX_COST =
  "metaAdaptPlacementsCheckboxCost";
export const ALERT_SHARE_INSTAGRAM_ERROR = "alertShareInstagramError";
export const ALERT_SHARE_SUCCESS = "alertShareInstagramSuccess";
export const ALERT_SHARE_SCHEDULED_SUCCESS =
  "alertShareInstagramScheduledSuccess";
export const BUTTON_SHARE_MEDIA = "buttonShareInstagram";
export const BUTTON_SHARE_LOADING = "buttonShareInstagramLoading";
export const BUTTON_SCHEDULE_MEDIA = "buttonScheduleInstagram";
export const BUTTON_SCHEDULING_MEDIA = "buttonSchedulingInstagram";
export const BUTTON_PUBLISH_NOW = "buttonPublishNow";
export const SCHEDULE_DATE_MIN_FUTURE_ERROR = "scheduleDateMinFutureError";
export const SUGGESTED_PUBLISH_SCHEDULE_LOADING =
  "suggestedPublishScheduleLoading";
export const DESCRIPTION_INSTAGRAM_LABEL = "descriptionInstagramLabel";
export const DESCRIPTION_INSTAGRAM_GENERATING =
  "descriptionInstagramGenerating";
export const TYPE_CONTENT_INSTAGRAM_LABEL = "typeContentInstagramLabel";
export const INSTAGRAM_COLLABORATORS_LABEL = "instagramCollaboratorsLabel";
export const INSTAGRAM_COLLABORATORS_PLACEHOLDER =
  "instagramCollaboratorsPlaceholder";
export const INSTAGRAM_COLLABORATORS_HELPER = "instagramCollaboratorsHelper";
export const IMAGE_NO_CONTENT_TO_SHOW = "imageNoContentToShow";
export const NO_SUPPORTED_FILE = "noSupportedFile";

export const MODAL_CANVA_IMAGE_CONFIG_CONTENT_TYPE_LABEL =
  "modalCanvaImageConfigContentTypeLabel";

export const MAP_TRADUCCIONES_STATUS = "mapTraduccionesStatus";
export const MAP_TRADUCCIONES_PLATFORM = "mapTraduccionesPlatform";
export const MAP_TRADUCCIONES_TITLES = "mapTraduccionesTitles";
export const MAP_TRADUCCIONES_CALL_TO_ACTION = "mapTraduccionesCallToAction";
export const MAP_TRADUCCIONES_CALL_TO_ACTIONS = "mapTraduccionesCallToActions";
export const MAP_TRADUCCIONES_CALL_TO_ACTION_ID =
  "mapTraduccionesCallToActionID";
export const MAP_TRADUCCIONES_MEDIA_URLS = "mapTraduccionesMediaUrls";
export const MAP_TRADUCCIONES_MEDIA_DATA = "mapTraduccionesMediaData";
export const MAP_TRADUCCIONES_MUSIC_URL = "mapTraduccionesMusicUrl";
export const MAP_TRADUCCIONES_IS_CAROUSEL = "mapTraduccionesIsCarousel";
export const MAP_TRADUCCIONES_OBJECTIVE = "mapTraduccionesObjective";
export const MAP_TRADUCCIONES_INTEGRATION_ID = "mapTraduccionesIntegrationID";
export const MAP_TRADUCCIONES_AD_ACCOUNT_ID = "mapTraduccionesAdAccountID";
export const MAP_TRADUCCIONES_PAGE_ID = "mapTraduccionesPageID";
export const MAP_TRADUCCIONES_INSTAGRAM_ID = "mapTraduccionesInstagramID";
export const MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET =
  "mapTraduccionesUseCampaignBudget";
export const MAP_TRADUCCIONES_TYPE_BUDGET = "mapTraduccionesTypeBudget";
export const MAP_TRADUCCIONES_BUDGET = "mapTraduccionesBudget";
export const MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN =
  "mapTraduccionesIsCatalogCampaign";
export const MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER =
  "mapTraduccionesWhatsappBusinessNumber";
export const MAP_TRADUCCIONES_MESSAGE_TEMPLATE =
  "mapTraduccionesMessageTemplate";
export const MAP_TRADUCCIONES_INSTANT_FORM = "mapTraduccionesInstantForm";
export const MAP_TRADUCCIONES_TRACKING_ID = "mapTraduccionesTrackingID";
export const MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID =
  "mapTraduccionesTrackingCustomEventID";
export const MAP_TRADUCCIONES_CATALOG_ID = "mapTraduccionesCatalogID";
export const MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN =
  "mapTraduccionesIsIOS14Campaign";
export const MAP_TRADUCCIONES_APP_ID = "mapTraduccionesAppID";
export const MAP_TRADUCCIONES_BUYING_TYPE = "mapTraduccionesBuyingType";
export const MAP_TRADUCCIONES_DESCRIPTIONS = "mapTraduccionesDescriptions";
export const MAP_TRADUCCIONES_ADS = "mapTraduccionesAds";
export const MAP_TRADUCCIONES_KEYWORDS = "mapTraduccionesKeywords";
export const MAP_TRADUCCIONES_KEYWORDS_NEGATIVE =
  "mapTraduccionesKeywordsNegative";
export const MAP_TRADUCCIONES_START_DATE = "mapTraduccionesStartDate";
export const MAP_TRADUCCIONES_END_DATE = "mapTraduccionesEndDate";
export const MAP_TRADUCCIONES_AGE_RANGE = "mapTraduccionesAgeRange";
export const MAP_TRADUCCIONES_GENDERS = "mapTraduccionesGenders";
export const MAP_TRADUCCIONES_LOCATIONS = "mapTraduccionesLocations";
export const MAP_TRADUCCIONES_INTERESTS = "mapTraduccionesInterests";
export const MAP_TRADUCCIONES_BEHAVIORS = "mapTraduccionesBehaviors";
export const MAP_TRADUCCIONES_CUSTOM_AUDIENCES =
  "mapTraduccionesCustomAudiences";
export const MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES =
  "mapTraduccionesExcludedCustomAudiences";
export const MAP_TRADUCCIONES_BID_GOAL = "mapTraduccionesBidGoal";
export const MAP_TRADUCCIONES_OPTIMIZATION_GOAL =
  "mapTraduccionesOptimizationGoal";
export const MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID =
  "mapTraduccionesIdentityTikTokID";
export const MAP_TRADUCCIONES_TYPE = "mapTraduccionesType";
export const MAP_TRADUCCIONES_ID = "mapTraduccionesID";
export const MAP_TRADUCCIONES_DESTINATION_URL = "mapTraduccionesDestinationUrl";
export const MAP_TRADUCCIONES_BUSINESS_NAME = "mapTraduccionesBusinessName";
export const MAP_TRADUCCIONES_LOGO_URLS = "mapTraduccionesLogoUrls";
export const MAP_TRADUCCIONES_IMAGE_URLS = "mapTraduccionesImageUrls";
export const MAP_TRADUCCIONES_VIDEO_URLS = "mapTraduccionesVideoUrls";
export const MAP_TRADUCCIONES_LONG_HEADLINES = "mapTraduccionesLongHeadlines";
export const MAP_TRADUCCIONES_SEARCH_THEMES = "mapTraduccionesSearchThemes";
export const MAP_TRADUCCIONES_CTA = "mapTraduccionesCta";
export const MAP_TRADUCCIONES_CTAS = "mapTraduccionesCtas";
export const MAP_TRADUCCIONES_CTA_ID = "mapTraduccionesCtaId";

export const MAP_STATUS_ACTIVE = "mapStatusActive";
export const MAP_STATUS_DEACTIVATED = "mapStatusDeactivated";

export const BUTTON_OPTIMIZE_CAMPAIGN = "buttonOptimizeCampaign";
export const BUTTON_OPTIMIZE_CAMPAIGN_MESSAGE = "buttonOptimizeCampaignMessage";

export const ADD_CHANGES = "addChanges";
export const UPDATE_CHANGES = "updateChanges";
export const REMOVE_CHANGES = "removeChanges";

export const OVERVIEW_HOME_STATISTICS = "overviewHomeStatistics";
export const KPI_TARGET_CPA_ABOVE_PLATFORM = "kpiTargetCpaAbovePlatform";
export const KPI_TARGET_CPA_ALERTS_TITLE = "kpiTargetCpaAlertsTitle";
export const OVERVIEW_HOME_STATISTICS_VIEW_MORE =
  "overviewHomeStatisticsViewMore";
export const STATISTICS_ONLY_BUZZLY_CAMPAIGNS = "statisticsOnlyBuzzlyCampaigns";
export const VIEW_SPEND_BREAKDOWN = "viewSpendBreakdown";
export const LIST_TABLE_CAMPAIGNS_TITLE = "listTableCampaignsTitle";
export const DASHBOARD_METRICS_DELAY_WARNING = "dashboardMetricsDelayWarning";
export const DASHBOARD_METRICS_DELAY_DISMISS = "dashboardMetricsDelayDismiss";
export const TRIAL_CONTENT_CTA_MESSAGE = "trialContentCtaMessage";
export const TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM =
  "trialContentCtaButtonShareInstagram";
export const TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK =
  "trialContentCtaButtonShareTiktok";
export const TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS =
  "trialContentCtaButtonMoreOptions";
export const CAMPAIGN_SYNCING_STATUS = "campaignSyncingStatus";
export const CAMPAIGNS_TABLE_EXPAND_ROW = "campaignsTableExpandRow";
export const CAMPAIGNS_TABLE_COLLAPSE_ROW = "campaignsTableCollapseRow";
export const CAMPAIGNS_TABLE_EXPAND_GROUP = "campaignsTableExpandGroup";
export const CAMPAIGNS_TABLE_COLLAPSE_GROUP = "campaignsTableCollapseGroup";
export const CAMPAIGNS_TABLE_TREE_EMPTY = "campaignsTableTreeEmpty";
export const CAMPAIGNS_TABLE_TREE_ERROR = "campaignsTableTreeError";
export const CAMPAIGNS_TABLE_TREE_METRICS_ERROR =
  "campaignsTableTreeMetricsError";
export const CAMPAIGNS_TABLE_TREE_ADS_EMPTY = "campaignsTableTreeAdsEmpty";
export const CAMPAIGNS_TABLE_SHOW_MORE_ADS = "campaignsTableShowMoreAds";

// MODAL CREATE WITH IA
export const MODAL_CREATE_WITH_IA_TITLE = "modalCreateWithIATitle";
export const MODAL_CREATE_WITH_IA_SUBTITLE = "modalCreateWithIASubtitle";
export const MODAL_CREATE_WITH_IA_GENERATED_CREATIVES =
  "modalCreateWithIAGeneratedCreatives";
export const MODAL_CREATE_WITH_IA_UPLOAD_IMAGE = "modalCreateWithIAUploadImage";
export const MODAL_CREATE_WITH_IA_ADD_URL = "modalCreateWithIAAddUrl";
export const MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_EMPTY =
  "modalCreateWithIAAdditionalAssetsEmpty";
export const MODAL_CREATE_WITH_IA_ADDITIONAL_ASSETS_SUBTITLE =
  "modalCreateWithIAAdditionalAssetsSubtitle";
export const MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_TOGGLE_ARIA =
  "modalCreateWithIAAdditionalAssetToggleAria";
export const MODAL_CREATE_WITH_IA_ADDITIONAL_ASSET_PREVIEW_ARIA =
  "modalCreateWithIAAdditionalAssetPreviewAria";
export const MODAL_CREATE_WITH_IA_EXTRACT_URL = "modalCreateWithIAExtractUrl";
export const MODAL_CREATE_WITH_IA_IMPORT_PHOTOS_URL_HINT =
  "modalCreateWithIAImportPhotosUrlHint";
export const MODAL_CREATE_WITH_IA_DESCRIPTION = "modalCreateWithIADescription";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_BASIC =
  "modalCreateWithIAConfigurationBasic";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE =
  "modalCreateWithIAConfigurationReferenceImage";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_PRODUCTS =
  "modalCreateWithIAConfigurationReferenceImageTitleProducts";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_TITLE_SERVICES =
  "modalCreateWithIAConfigurationReferenceImageTitleServices";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS =
  "modalCreateWithIAConfigurationReferenceImageDescriptionProducts";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES =
  "modalCreateWithIAConfigurationReferenceImageDescriptionServices";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_URL =
  "modalCreateWithIAConfigurationReferenceImageDescriptionProductsUrl";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_PRODUCTS_UPLOAD =
  "modalCreateWithIAConfigurationReferenceImageDescriptionProductsUpload";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_URL =
  "modalCreateWithIAConfigurationReferenceImageDescriptionServicesUrl";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_REFERENCE_IMAGE_DESCRIPTION_SERVICES_UPLOAD =
  "modalCreateWithIAConfigurationReferenceImageDescriptionServicesUpload";
export const MODAL_CREATE_WITH_IA_REFERENCE_AD_TITLE =
  "modalCreateWithIAReferenceAdTitle";
export const MODAL_CREATE_WITH_IA_REFERENCE_AD_DESCRIPTION =
  "modalCreateWithIAReferenceAdDescription";
export const MODAL_CREATE_WITH_IA_REFERENCE_VIDEO_FORCES_CUSTOM =
  "modalCreateWithIAReferenceVideoForcesCustom";
export const MODAL_CREATE_WITH_IA_REFERENCE_AD_STYLE_GUIDE_CHIP =
  "modalCreateWithIAReferenceAdStyleGuideChip";
export const MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_LOCAL =
  "modalCreateWithIAReferenceAdSourceLocal";
export const MODAL_CREATE_WITH_IA_REFERENCE_AD_SOURCE_SEARCH =
  "modalCreateWithIAReferenceAdSourceSearch";
export const MODAL_CREATE_WITH_IA_REFERENCE_IMAGE_ASSETS_CHIP =
  "modalCreateWithIAReferenceImageAssetsChip";
export const MODAL_CREATE_WITH_IA_PHYSICAL_NO_REFERENCE_IMAGES_DESCRIPTION =
  "modalCreateWithIAPhysicalNoReferenceImagesDescription";
export const MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_TITLE =
  "modalCreateWithIAServiceVideoLogoRequiredTitle";
export const MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_REQUIRED_DESCRIPTION =
  "modalCreateWithIAServiceVideoLogoRequiredDescription";
export const MODAL_CREATE_WITH_IA_SERVICE_VIDEO_LOGO_OPTIONAL_DESCRIPTION =
  "modalCreateWithIAServiceVideoLogoOptionalDescription";
export const CONFIGURATION_PANEL_TITLE_IMAGE_PHYSICAL_PRODUCT =
  "configurationPanelTitleImagePhysicalProduct";
export const CONFIGURATION_PANEL_SUBTITLE_IMAGE_PHYSICAL_PRODUCT =
  "configurationPanelSubtitleImagePhysicalProduct";
export const CONFIGURATION_PANEL_ADD_MULTIPLE_PERSPECTIVES_TIP =
  "configurationPanelAddMultiplePerspectivesTip";
export const CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_TITLE =
  "configurationPanelServiceWebsiteUrlTitle";
export const CONFIGURATION_PANEL_SERVICE_WEBSITE_URL_DESCRIPTION =
  "configurationPanelServiceWebsiteUrlDescription";
export const CONFIGURATION_PANEL_WEBSITE_URL_TITLE =
  "configurationPanelWebsiteUrlTitle";
export const CONFIGURATION_PANEL_WEBSITE_URL_DESCRIPTION =
  "configurationPanelWebsiteUrlDescription";
export const CONFIGURATION_PANEL_CLARIFICATION_INPUT_IMAGES =
  "configurationPanelSubtitleImageClarificationInputImages";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_TITLE =
  "configurationPanelReferenceImageRequirementsTitle";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO =
  "configurationPanelReferenceImageRequirementsIntro";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY =
  "configurationPanelReferenceImageRequirementHighQuality";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT =
  "configurationPanelReferenceImageRequirementProminent";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE =
  "configurationPanelReferenceImageRequirementSize";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL =
  "configurationPanelReferenceImageRequirementSameColorAndModel";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE =
  "configurationPanelReferenceImageRequirementComplete";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING =
  "configurationPanelReferenceImageRequirementLighting";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_NO_PEOPLE =
  "configurationPanelReferenceImageRequirementNoPeople";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE =
  "configurationPanelReferenceImageAvoidTitle";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST =
  "configurationPanelReferenceImageAvoidList";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE =
  "configurationPanelReferenceImageExamplesTitle";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_PEOPLE =
  "configurationPanelReferenceImageAvoidPeople";
export const CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION =
  "configurationPanelReferenceImageWarningDistortion";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_INSTRUCTIONS =
  "modalCreateWithIAConfigurationDescription";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_THEME =
  "modalCreateWithIAConfigurationTheme";
export const MODAL_CREATE_WITH_IA_PROMPT_OPTIONAL =
  "modalCreateWithIAPromptOptional";
export const MODAL_CREATE_WITH_IA_PROMPT_THEME_OPTIONAL =
  "modalCreateWithIAPromptThemeOptional";
export const MODAL_CREATE_WITH_IA_EMPTY_STATE_TITLE =
  "modalCreateWithIAEmptyStateTitle";
export const MODAL_CREATE_WITH_IA_EMPTY_STATE_SUBTITLE =
  "modalCreateWithIAEmptyStateSubtitle";
export const MODAL_CREATE_WITH_IA_MAX_IMAGES_MESSAGE =
  "modalCreateWithIAMaxImagesMessage";

// MODAL IMAGE EDIT
export const MODAL_IMAGE_EDIT_EMPTY_STATE_TITLE =
  "modalImageEditEmptyStateTitle";
export const MODAL_IMAGE_EDIT_EMPTY_STATE_DESCRIPTION =
  "modalImageEditEmptyStateDescription";
export const MODAL_IMAGE_EDIT_TITLE = "modalImageEditTitle";
export const MODAL_IMAGE_EDIT_SUBTITLE = "modalImageEditSubtitle";
export const MODAL_IMAGE_EDIT_PROCESSING_MESSAGE =
  "modalImageEditProcessingMessage";
export const MODAL_IMAGE_EDIT_ERROR_CONVERT_BASE64 =
  "modalImageEditErrorConvertBase64";
export const MODAL_IMAGE_EDIT_ERROR_EDITING = "modalImageEditErrorEditing";
export const MODAL_IMAGE_EDIT_ERROR_PROCESSING =
  "modalImageEditErrorProcessing";
export const MODAL_IMAGE_EDIT_INPUT_PLACEHOLDER =
  "modalImageEditInputPlaceholder";
export const MODAL_IMAGE_EDIT_EDITING_LABEL = "modalImageEditEditingLabel";
export const MODAL_IMAGE_EDIT_LOADING_LABEL = "modalImageEditLoadingLabel";
export const MODAL_IMAGE_EDIT_IMAGE_NOT_FOUND = "modalImageEditImageNotFound";
export const MODAL_IMAGE_EDIT_START_CREATING = "modalImageEditStartCreating";
export const MODAL_IMAGE_EDIT_IMAGE_ALT = "modalImageEditImageAlt";
export const MODAL_IMAGE_EDIT_VERSION_FORMAT = "modalImageEditVersionFormat";
export const MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL =
  "modalImageEditOriginalImageLabel";
export const MODAL_IMAGE_EDIT_EDITED_IMAGE_LABEL =
  "modalImageEditEditedImageLabel";
export const MODAL_IMAGE_EDIT_SAVE_ALERT_TITLE = "modalImageEditSaveAlertTitle";
export const MODAL_IMAGE_EDIT_SAVE_ALERT_DESCRIPTION =
  "modalImageEditSaveAlertDescription";
export const MODAL_IMAGE_EDIT_REPLACE_BUTTON = "modalImageEditReplaceButton";

// MODAL VIDEO EDITOR
export const MODAL_VIDEO_EDITOR_TITLE = "modalVideoEditorTitle";
export const MODAL_VIDEO_EDITOR_EDIT_VIDEO = "modalVideoEditorEditVideo";
export const MODAL_VIDEO_EDITOR_ADD_VIDEO = "modalVideoEditorAddVideo";
export const MODAL_VIDEO_EDITOR_ADD_IMAGE = "modalVideoEditorAddImage";
export const MODAL_VIDEO_EDITOR_ADD_AUDIO = "modalVideoEditorAddAudio";
export const MODAL_VIDEO_EDITOR_ADD_SUBTITLES = "modalVideoEditorAddSubtitles";
export const MODAL_VIDEO_EDITOR_EXPORTING = "modalVideoEditorExporting";
export const MODAL_VIDEO_EDITOR_SAVE_ERROR = "modalVideoEditorSaveError";
export const MODAL_VIDEO_EDITOR_SPLIT_HINT = "modalVideoEditorSplitHint";
export const MODAL_VIDEO_EDITOR_ARIA_LABEL = "modalVideoEditorAriaLabel";
export const MODAL_VIDEO_EDITOR_TRACK_VIDEO = "modalVideoEditorTrackVideo";
export const MODAL_VIDEO_EDITOR_TRACK_IMAGE = "modalVideoEditorTrackImage";
export const MODAL_VIDEO_EDITOR_TRACK_AUDIO = "modalVideoEditorTrackAudio";
export const MODAL_VIDEO_EDITOR_CLIP_DURATION = "modalVideoEditorClipDuration";
export const MODAL_VIDEO_EDITOR_SPLIT_CLIP = "modalVideoEditorSplitClip";
export const MODAL_VIDEO_EDITOR_CLIP_ACTIONS = "modalVideoEditorClipActions";
export const MODAL_VIDEO_EDITOR_BRAND = "modalVideoEditorBrand";
export const MODAL_VIDEO_EDITOR_EMPTY_STAGE_TITLE =
  "modalVideoEditorEmptyStageTitle";
export const MODAL_VIDEO_EDITOR_EMPTY_STAGE_HINT =
  "modalVideoEditorEmptyStageHint";
export const MODAL_VIDEO_EDITOR_DROP_HINT = "modalVideoEditorDropHint";
export const MODAL_VIDEO_EDITOR_PLAY = "modalVideoEditorPlay";
export const MODAL_VIDEO_EDITOR_PAUSE = "modalVideoEditorPause";
export const MODAL_VIDEO_EDITOR_DEFAULT_PROJECT_NAME =
  "modalVideoEditorDefaultProjectName";
export const MODAL_VIDEO_EDITOR_TIMELINE_ARIA = "modalVideoEditorTimelineAria";
export const MODAL_VIDEO_EDITOR_TIMELINE_RESIZE =
  "modalVideoEditorTimelineResize";
export const MODAL_VIDEO_EDITOR_INSERT_START = "modalVideoEditorInsertStart";
export const MODAL_VIDEO_EDITOR_INSERT_END = "modalVideoEditorInsertEnd";
export const MODAL_VIDEO_EDITOR_ANALYZING_SUBTITLES =
  "modalVideoEditorAnalyzingSubtitles";
export const MODAL_VIDEO_EDITOR_TRACK_SUBTITLE =
  "modalVideoEditorTrackSubtitle";
export const MODAL_VIDEO_EDITOR_CAPTIONS_ARIA = "modalVideoEditorCaptionsAria";
export const MODAL_VIDEO_EDITOR_CAPTIONS_DISABLE =
  "modalVideoEditorCaptionsDisable";
export const MODAL_VIDEO_EDITOR_CAPTIONS_ENABLE =
  "modalVideoEditorCaptionsEnable";
export const MODAL_VIDEO_EDITOR_SAVE_ALERT_TITLE =
  "modalVideoEditorSaveAlertTitle";
export const MODAL_VIDEO_EDITOR_SAVE_ALERT_DESCRIPTION =
  "modalVideoEditorSaveAlertDescription";
export const MODAL_VIDEO_EDITOR_ANALYZE_SUBTITLES_ERROR =
  "modalVideoEditorAnalyzeSubtitlesError";
export const MODAL_VIDEO_EDITOR_PROPERTIES_TITLE =
  "modalVideoEditorPropertiesTitle";
export const MODAL_VIDEO_EDITOR_PROPERTIES_EMPTY =
  "modalVideoEditorPropertiesEmpty";
export const MODAL_VIDEO_EDITOR_PROPERTIES_NAME =
  "modalVideoEditorPropertiesName";
export const MODAL_VIDEO_EDITOR_PROPERTIES_VOLUME =
  "modalVideoEditorPropertiesVolume";
export const MODAL_VIDEO_EDITOR_PROPERTIES_MIXED =
  "modalVideoEditorPropertiesMixed";
export const MODAL_VIDEO_EDITOR_PROPERTIES_SELECTED_COUNT =
  "modalVideoEditorPropertiesSelectedCount";
export const MODAL_VIDEO_EDITOR_PROPERTIES_POSITION =
  "modalVideoEditorPropertiesPosition";
export const MODAL_VIDEO_EDITOR_PROPERTIES_SIZE =
  "modalVideoEditorPropertiesSize";
export const MODAL_VIDEO_EDITOR_PROPERTIES_X = "modalVideoEditorPropertiesX";
export const MODAL_VIDEO_EDITOR_PROPERTIES_Y = "modalVideoEditorPropertiesY";
export const MODAL_VIDEO_EDITOR_PROPERTIES_WIDTH =
  "modalVideoEditorPropertiesWidth";
export const MODAL_VIDEO_EDITOR_PROPERTIES_HEIGHT =
  "modalVideoEditorPropertiesHeight";
export const MODAL_IMAGE_EDIT_SAVE_AS_NEW_BUTTON =
  "modalImageEditSaveAsNewButton";
export const MODAL_IMAGE_EDIT_WORK_MODE_LABEL = "modalImageEditWorkModeLabel";
export const MODAL_IMAGE_EDIT_GENERATIVE_TITLE =
  "modalImageEditGenerativeTitle";
export const MODAL_IMAGE_EDIT_GENERATIVE_DESCRIPTION =
  "modalImageEditGenerativeDescription";
export const MODAL_IMAGE_EDIT_LAYERS_TITLE = "modalImageEditLayersTitle";
export const MODAL_IMAGE_EDIT_LAYERS_DESCRIPTION =
  "modalImageEditLayersDescription";
export const MODAL_IMAGE_EDIT_LAYERS_BADGE_NEW = "modalImageEditLayersBadgeNew";
export const MODAL_IMAGE_EDIT_LAYERS_EMPTY_TITLE =
  "modalImageEditLayersEmptyTitle";
export const MODAL_IMAGE_EDIT_LAYERS_EMPTY_DESCRIPTION =
  "modalImageEditLayersEmptyDescription";
export const MODAL_IMAGE_EDIT_LAYERS_ERROR_TITLE =
  "modalImageEditLayersErrorTitle";
export const MODAL_IMAGE_EDIT_LAYERS_ERROR_DESCRIPTION =
  "modalImageEditLayersErrorDescription";
export const MODAL_IMAGE_EDIT_LAYERS_ADD = "modalImageEditLayersAdd";
export const MODAL_IMAGE_EDIT_LAYERS_LIST_TITLE =
  "modalImageEditLayersListTitle";
export const MODAL_IMAGE_EDIT_LAYERS_TYPE_IMAGE =
  "modalImageEditLayersTypeImage";
export const MODAL_IMAGE_EDIT_LAYERS_TYPE_OBJECT =
  "modalImageEditLayersTypeObject";
export const MODAL_IMAGE_EDIT_LAYERS_TYPE_TEXT = "modalImageEditLayersTypeText";
export const MODAL_IMAGE_EDIT_LAYERS_TYPE_LOGO = "modalImageEditLayersTypeLogo";
export const MODAL_IMAGE_EDIT_LAYERS_BACKGROUND =
  "modalImageEditLayersBackground";
export const MODAL_IMAGE_EDIT_LAYERS_FALLBACK_NAME =
  "modalImageEditLayersFallbackName";
export const MODAL_IMAGE_EDIT_LAYERS_ANALYZING =
  "modalImageEditLayersAnalyzing";
export const MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_TITLE =
  "modalImageEditAiLosesLayersTitle";
export const MODAL_IMAGE_EDIT_AI_LOSES_LAYERS_DESCRIPTION =
  "modalImageEditAiLosesLayersDescription";
export const MODAL_IMAGE_EDIT_CLOSE_TITLE = "modalImageEditCloseTitle";
export const MODAL_IMAGE_EDIT_CLOSE_DESCRIPTION =
  "modalImageEditCloseDescription";
export const ANALYZE_LAYERS_EDIT_TEXT_TITLE = "analyzeLayersEditTextTitle";
export const ANALYZE_LAYERS_EDIT_TEXT_DESCRIPTION =
  "analyzeLayersEditTextDescription";
export const ANALYZE_LAYERS_EXTRACT_TEXT_ENABLE_BUTTON =
  "analyzeLayersExtractTextEnableButton";
export const ANALYZE_LAYERS_EXTRACT_TEXT_DISABLE_BUTTON =
  "analyzeLayersExtractTextDisableButton";

export const MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE =
  "modalCreateWithIAMediaTypeImage";
export const MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO =
  "modalCreateWithIAMediaTypeVideo";
export const MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO_BETA =
  "modalCreateWithIAMediaTypeVideoBeta";
export const MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA =
  "modalCreateWithIAImageTypeRealista";
export const MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO =
  "modalCreateWithIAImageTypeProducto";
export const MODAL_CREATE_WITH_IA_LANGUAGE_ES = "modalCreateWithIALanguageEs";
export const MODAL_CREATE_WITH_IA_LANGUAGE_EN = "modalCreateWithIALanguageEn";
export const MODAL_CREATE_WITH_IA_LANGUAGE_FR = "modalCreateWithIALanguageFr";
export const MODAL_CREATE_WITH_IA_LANGUAGE_DE = "modalCreateWithIALanguageDe";
export const MODAL_CREATE_WITH_IA_LANGUAGE_IT = "modalCreateWithIALanguageIt";
export const MODAL_CREATE_WITH_IA_DIMENSION_SQUARE =
  "modalCreateWithIADimensionSquare";
export const MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL =
  "modalCreateWithIADimensionHorizontal";
export const MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL =
  "modalCreateWithIADimensionVertical";
export const MODAL_CREATE_WITH_IA_LABEL_MEDIA_TYPE =
  "modalCreateWithIALabelMediaType";
export const MODAL_CREATE_WITH_IA_LABEL_IMAGE_TYPE =
  "modalCreateWithIALabelImageType";
export const MODAL_CREATE_WITH_IA_LABEL_VIDEO_TYPE =
  "modalCreateWithIALabelVideoType";
export const MODAL_CREATE_WITH_IA_LABEL_LANGUAGE =
  "modalCreateWithIALabelLanguage";
export const MODAL_CREATE_WITH_IA_LABEL_WITH_SUBTITLES =
  "modalCreateWithIALabelWithSubtitles";
export const MODAL_CREATE_WITH_IA_LABEL_AI_WATERMARK =
  "modalCreateWithIALabelAiWatermark";
export const MODAL_CREATE_WITH_IA_AI_WATERMARK_DESCRIPTION =
  "modalCreateWithIAAiWatermarkDescription";
export const MODAL_SUBTITLE_OPTIONS_TITLE = "modalSubtitleOptionsTitle";
export const MODAL_SUBTITLE_OPTIONS_PERSONALIZE =
  "modalSubtitleOptionsPersonalize";
export const MODAL_SUBTITLE_OPTIONS_FONT_FAMILY =
  "modalSubtitleOptionsFontFamily";
export const MODAL_SUBTITLE_OPTIONS_FONT_STYLE =
  "modalSubtitleOptionsFontStyle";
export const MODAL_SUBTITLE_OPTIONS_FONT_STYLE_NORMAL =
  "modalSubtitleOptionsFontStyleNormal";
export const MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD =
  "modalSubtitleOptionsFontStyleBold";
export const MODAL_SUBTITLE_OPTIONS_FONT_STYLE_ITALIC =
  "modalSubtitleOptionsFontStyleItalic";
export const MODAL_SUBTITLE_OPTIONS_FONT_STYLE_BOLD_ITALIC =
  "modalSubtitleOptionsFontStyleBoldItalic";
export const MODAL_SUBTITLE_OPTIONS_SUBTITLE_COLOR =
  "modalSubtitleOptionsSubtitleColor";
export const MODAL_SUBTITLE_OPTIONS_DO_HIGHLIGHT =
  "modalSubtitleOptionsDoHighlight";
export const MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_COLOR =
  "modalSubtitleOptionsHighlightColor";
export const MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE =
  "modalSubtitleOptionsHighlightMode";
export const MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_KARAOKE =
  "modalSubtitleOptionsHighlightModeKaraoke";
export const MODAL_SUBTITLE_OPTIONS_HIGHLIGHT_MODE_WORD =
  "modalSubtitleOptionsHighlightModeWord";
export const MODAL_SUBTITLE_OPTIONS_PRESET = "modalSubtitleOptionsPreset";
export const MODAL_SUBTITLE_OPTIONS_PRESET_KARAOKE =
  "modalSubtitleOptionsPresetKaraoke";
export const MODAL_SUBTITLE_OPTIONS_PRESET_HIGHLIGHT =
  "modalSubtitleOptionsPresetHighlight";
export const MODAL_SUBTITLE_OPTIONS_PRESET_BOXED =
  "modalSubtitleOptionsPresetBoxed";
export const MODAL_SUBTITLE_OPTIONS_BOX_COLOR = "modalSubtitleOptionsBoxColor";
export const MODAL_SUBTITLE_OPTIONS_HAS_BACKGROUND =
  "modalSubtitleOptionsHasBackground";
export const MODAL_SUBTITLE_OPTIONS_BACKGROUND_COLOR =
  "modalSubtitleOptionsBackgroundColor";
export const MODAL_SUBTITLE_OPTIONS_PREVIEW_LABEL =
  "modalSubtitleOptionsPreviewLabel";
export const MODAL_CREATE_WITH_IA_LABEL_ACCENT = "modalCreateWithIALabelAccent";
export const MODAL_CREATE_WITH_IA_LABEL_LOCATION =
  "modalCreateWithIALabelLocation";
export const MODAL_CREATE_WITH_IA_LABEL_DIMENSIONS =
  "modalCreateWithIALabelDimensions";
export const MODAL_CREATE_WITH_IA_LABEL_PLATFORM =
  "modalCreateWithIALabelPlatform";
export const MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT =
  "modalCreateWithIAPlatformDefault";
export const MODAL_CREATE_WITH_IA_LABEL_CAROUSEL =
  "modalCreateWithIALabelCarousel";
export const MODAL_CREATE_WITH_IA_LABEL_NUMBER_OF_IMAGES =
  "modalCreateWithIALabelNumberOfImages";
export const MODAL_CREATE_WITH_IA_PLACEHOLDER_NUMBER_OF_IMAGES =
  "modalCreateWithIAPlaceholderNumberOfImages";
export const MODAL_CREATE_WITH_IA_PLATFORM_META =
  "modalCreateWithIAPlatformMeta";
export const MODAL_CREATE_WITH_IA_PLATFORM_TIKTOK =
  "modalCreateWithIAPlatformTiktok";
export const MODAL_CREATE_WITH_IA_PLATFORM_GOOGLE =
  "modalCreateWithIAPlatformGoogle";
export const MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION =
  "modalCreateWithIAPlaceholderDescription";
export const MODAL_CREATE_WITH_IA_PLACEHOLDER_DESCRIPTION_VIDEO =
  "modalCreateWithIAPlaceholderDescriptionVideo";
export const MODAL_CREATE_WITH_IA_PLACEHOLDER_IMAGE_URL =
  "modalCreateWithIAPlaceholderImageUrl";
export const MODAL_CREATE_WITH_IA_PLACEHOLDER_WEBSITE_URL =
  "modalCreateWithIAPlaceholderWebsiteUrl";
export const MODAL_CREATE_WITH_IA_WARNING_REFERENCE_IMAGE =
  "modalCreateWithIAWarningReferenceImage";
export const MODAL_CREATE_WITH_IA_URLS_ADDED = "modalCreateWithIAUrlsAdded";
export const MODAL_CREATE_WITH_IA_IMAGES_COUNT = "modalCreateWithIAImagesCount";
export const MODAL_CREATE_WITH_IA_SERVICE_IMAGES_COUNT =
  "modalCreateWithIAServiceImagesCount";
export const MODAL_CREATE_WITH_IA_GENERATING = "modalCreateWithIAGenerating";
export const MODAL_CREATE_WITH_IA_GENERATE_WITH_AI =
  "modalCreateWithIAGenerateWithAI";
export const MODAL_CREATE_WITH_IA_IMAGES_CREATED =
  "modalCreateWithIAImagesCreated";
export const MODAL_CREATE_WITH_IA_GENERATING_IMAGES =
  "modalCreateWithIAGeneratingImages";
export const MODAL_CREATE_WITH_IA_YOU_CAN_LEAVE_THE_PAGE =
  "modalCreateWithIAYouCanLeaveThePage";
export const MODAL_CREATE_WITH_IA_GENERATIONS_IN_PROGRESS =
  "modalCreateWithIAGenerationsInProgress";
export const MODAL_CREATE_WITH_IA_GENERATION_FAILED =
  "modalCreateWithIAGenerationFailed";
export const MODAL_CREATE_WITH_IA_MAX_CONCURRENT_GENERATIONS =
  "modalCreateWithIAMaxConcurrentGenerations";
export const MODAL_CREATE_WITH_IA_ERROR_LOADING_IMAGE =
  "modalCreateWithIAErrorLoadingImage";
export const MODAL_CREATE_WITH_IA_GENERATED_IMAGE_ALT =
  "modalCreateWithIAGeneratedImageAlt";
export const MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY =
  "modalCreateWithIASaveToGallery";
export const MODAL_CREATE_WITH_IA_SAVE_TO_GALLERY_NO_COUNT =
  "modalCreateWithIASaveToGalleryNoCount";
export const MODAL_CREATE_WITH_IA_SAVING_TO_GALLERY =
  "modalCreateWithIASavingToGallery";
export const MODAL_CREATE_WITH_IA_SAVED_SUCCESSFULLY =
  "modalCreateWithIASavedSuccessfully";
export const MODAL_CREATE_WITH_IA_DOWNLOAD_ALL = "modalCreateWithIADownloadAll";
export const MODAL_CREATE_WITH_IA_MORE_VARIATIONS =
  "modalCreateWithIAMoreVariations";
export const MODAL_CREATE_WITH_IA_ARIA_LABEL = "modalCreateWithIAAriaLabel";
export const MODAL_CREATE_WITH_IA_CONFIGURATION_ADVANCED =
  "modalCreateWithIAConfigurationAdvanced";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL =
  "modalCreateWithIAAdTemplateLabel";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_LABEL_VIDEO =
  "modalCreateWithIAAdTemplateLabelVideo";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_HELPER =
  "modalCreateWithIAAdTemplateHelper";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NONE =
  "modalCreateWithIAAdTemplateNone";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_WHATSAPP =
  "modalCreateWithIAAdTemplateNameWhatsapp";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_IG_STORY =
  "modalCreateWithIAAdTemplateNameIgStory";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_APOLOGY =
  "modalCreateWithIAAdTemplateNameApology";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_NEWS =
  "modalCreateWithIAAdTemplateNameNews";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_TEXT_POST =
  "modalCreateWithIAAdTemplateNameTextPost";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_COMMENT_THREAD =
  "modalCreateWithIAAdTemplateNameCommentThread";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_REVIEW_CAPTURE =
  "modalCreateWithIAAdTemplateNameReviewCapture";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_SEARCH_AUTOCOMPLETE =
  "modalCreateWithIAAdTemplateNameSearchAutocomplete";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_CHECKLIST =
  "modalCreateWithIAAdTemplateNameChecklist";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_NAME_EMAIL_CAPTURE =
  "modalCreateWithIAAdTemplateNameEmailCapture";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_TEXT_POST =
  "modalCreateWithIAAdTemplateExplanationTextPost";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_COMMENT_THREAD =
  "modalCreateWithIAAdTemplateExplanationCommentThread";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_REVIEW_CAPTURE =
  "modalCreateWithIAAdTemplateExplanationReviewCapture";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_SEARCH_AUTOCOMPLETE =
  "modalCreateWithIAAdTemplateExplanationSearchAutocomplete";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_CHECKLIST =
  "modalCreateWithIAAdTemplateExplanationChecklist";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION_EMAIL_CAPTURE =
  "modalCreateWithIAAdTemplateExplanationEmailCapture";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_LOAD_ERROR =
  "modalCreateWithIAAdTemplateLoadError";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_EXPLANATION =
  "modalCreateWithIAAdTemplateExplanation";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO =
  "modalCreateWithIAAdTemplateRecommendedRatio";
export const MODAL_CREATE_WITH_IA_AD_TEMPLATE_RECOMMENDED_RATIO_ACTION =
  "modalCreateWithIAAdTemplateRecommendedRatioAction";
export const MODAL_CREATE_WITH_IA_GALLERY_BUTTON =
  "modalCreateWithIAGalleryButton";
export const MODAL_CREATE_WITH_IA_IMPORT_META_AD_LIBRARY =
  "modalCreateWithIAImportMetaAdLibrary";
export const COMPETITOR_SCOPE_MENU_ITEM = "competitorScopeMenuItem";
export const COMPETITOR_SCOPE_MODAL_TITLE = "competitorScopeModalTitle";
export const ALERT_COMPETITOR_SCOPE_TITLE = "alertCompetitorScopeTitle";
export const ALERT_COMPETITOR_SCOPE_DESCRIPTION =
  "alertCompetitorScopeDescription";
export const ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE =
  "alertCompetitorScopeMissingCompetitorsTitle";
export const ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION =
  "alertCompetitorScopeMissingCompetitorsDescription";
export const BUTTON_CONFIGURE_BRAND = "buttonConfigureBrand";
export const BUTTON_CONFIGURE_COMPETITORS = "buttonConfigureCompetitors";
export const MODAL_COMPETITORS_CONFIRM_REFERENCE_TITLE =
  "modalCompetitorsConfirmReferenceTitle";
export const MODAL_COMPETITORS_CONFIRM_REFERENCE_DESCRIPTION =
  "modalCompetitorsConfirmReferenceDescription";
export const MODAL_COMPETITORS_PREPARING_REFERENCE =
  "modalCompetitorsPreparingReference";
export const MODAL_COMPETITORS_SHOW_FAVORITES_ONLY =
  "modalCompetitorsShowFavoritesOnly";
export const MODAL_COMPETITORS_SHOW_ALL_ADS = "modalCompetitorsShowAllAds";
export const MODAL_COMPETITORS_FAVORITES_EMPTY =
  "modalCompetitorsFavoritesEmpty";
export const MODAL_COMPETITORS_SAVED_TO_FAVORITES =
  "modalCompetitorsSavedToFavorites";
export const MODAL_COMPETITORS_SAVED_TO_FOLDER =
  "modalCompetitorsSavedToFolder";
export const MODAL_COMPETITORS_REMOVED_FROM_FOLDER =
  "modalCompetitorsRemovedFromFolder";
export const MODAL_COMPETITORS_SELECT_FOLDER_TITLE =
  "modalCompetitorsSelectFolderTitle";
export const MODAL_COMPETITORS_CHANGE_LOCATION =
  "modalCompetitorsChangeLocation";
export const MODAL_COMPETITORS_REMOVED_FROM_FAVORITES =
  "modalCompetitorsRemovedFromFavorites";
export const MODAL_COMPETITORS_ADD_OPTION = "modalCompetitorsAddOption";
export const MODAL_COMPETITORS_EDIT_BUTTON = "modalCompetitorsEditButton";
export const MODAL_COMPETITORS_EDIT_TITLE = "modalCompetitorsEditTitle";
export const MODAL_COMPETITORS_EDIT_SUBTITLE = "modalCompetitorsEditSubtitle";
export const MODAL_COMPETITORS_EDIT_COUNT_ARIA =
  "modalCompetitorsEditCountAria";
export const MODAL_COMPETITORS_STRONG_SIGNAL = "modalCompetitorsStrongSignal";
export const MODAL_COMPETITORS_AD_LIBRARY_CTA_LABEL =
  "modalCompetitorsAdLibraryCtaLabel";
export const MODAL_CREATE_WITH_IA_META_AD_LIBRARY_LOADING =
  "modalCreateWithIAMetaAdLibraryLoading";
export const MODAL_GALLERY_META_AD_LIBRARY_EMPTY_CONTENT =
  "modalGalleryMetaAdLibraryEmptyContent";
export const MODAL_META_AD_LIBRARY_COMPETITOR_FILTER_LABEL =
  "modalMetaAdLibraryCompetitorFilterLabel";
export const MODAL_META_AD_LIBRARY_COMPETITOR_ALL =
  "modalMetaAdLibraryCompetitorAll";
export const MODAL_META_AD_LIBRARY_PLATFORM_ALL =
  "modalMetaAdLibraryPlatformAll";
export const MODAL_META_AD_LIBRARY_DURATION_HOURS =
  "modalMetaAdLibraryDurationHours";
export const MODAL_META_AD_LIBRARY_DURATION_DAYS =
  "modalMetaAdLibraryDurationDays";
export const MODAL_META_AD_LIBRARY_VIEW_ONLY_TOOLTIP =
  "modalMetaAdLibraryViewOnlyTooltip";
export const MODAL_META_AD_LIBRARY_LOADING_RESOLVING_COMPETITORS =
  "modalMetaAdLibraryLoadingResolvingCompetitors";
export const MODAL_META_AD_LIBRARY_LOADING_FETCHING_ADS =
  "modalMetaAdLibraryLoadingFetchingAds";
export const MODAL_META_AD_LIBRARY_LOADING_PREPARING_GALLERY =
  "modalMetaAdLibraryLoadingPreparingGallery";
export const MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TITLE =
  "modalCreateWithIACloseConfirmationTitle";
export const MODAL_CREATE_WITH_IA_CLOSE_CONFIRMATION_TEXT =
  "modalCreateWithIACloseConfirmationText";
export const MODAL_CREATE_WITH_IA_LABEL_VIDEO_DURATION_SECONDS =
  "modalCreateWithIALabelVideoDurationSeconds";
export const MODAL_CREATE_WITH_IA_VIDEO_DURATION_12_SECONDS =
  "modalCreateWithIAVideoDuration12Seconds";
export const MODAL_CREATE_WITH_IA_VIDEO_DURATION_15_SECONDS =
  "modalCreateWithIAVideoDuration15Seconds";
export const MODAL_CREATE_WITH_IA_VIDEO_DURATION_20_SECONDS =
  "modalCreateWithIAVideoDuration20Seconds";
export const MODAL_CREATE_WITH_IA_VIDEO_DURATION_25_SECONDS =
  "modalCreateWithIAVideoDuration25Seconds";
export const MODAL_CREATE_WITH_IA_VIDEO_DURATION_30_SECONDS =
  "modalCreateWithIAVideoDuration30Seconds";

// VIDEO TYPES
export const VIDEO_TYPE_UNBOXING = "videoTypeUnboxing";
export const VIDEO_TYPE_PRODUCT_SHOWCASE = "videoTypeProductShowcase";
export const VIDEO_TYPE_UGC = "videoTypeUGC";
export const VIDEO_TYPE_LIFESTYLE = "videoTypeLifestyle";
export const VIDEO_TYPE_TESTIMONIALS_REVIEWS = "videoTypeTestimonialsReviews";
export const VIDEO_TYPE_TESTIMONIAL = "videoTypeTestimonial";
export const VIDEO_TYPE_EMOTIONAL_STORYTELLING =
  "videoTypeEmotionalStorytelling";
export const VIDEO_TYPE_CASE_STUDY = "videoTypeCaseStudy";
export const VIDEO_TYPE_CORPORATE = "videoTypeCorporate";
export const VIDEO_TYPE_SURREAL = "videoTypeSurreal";
export const VIDEO_TYPE_MEGA_CREATIVE = "videoTypeMegaCreative";
export const VIDEO_TYPE_OTHER = "videoTypeOther";

//ALERTS CAMPAIGNS
export const ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL =
  "alertMarketingObjectiveGoogleNotSetLabel";
export const ALERT_PIXEL_NOT_FIRED_LABEL = "alertPixelNotFiredLabel";
export const ALERT_CAMPAIGN_STARTED_LABEL = "alertCampaignStartedLabel";
export const ALERT_CAMPAIGN_CPA_HIGH_LABEL = "alertCampaignCpaHighLabel";
export const ALERT_AD_ACCOUNT_STATUS_LABEL = "alertAdAccountStatusLabel";
export const ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL =
  "alertAdAccountStatusDisabledLabel";
export const ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL =
  "alertAdAccountStatusUnsettledLabel";
export const ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL =
  "alertAdAccountStatusUnsettledPrepayLabel";
export const ALERT_AD_ACCOUNT_NO_BALANCE_LABEL = "alertAdAccountNoBalanceLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL =
  "alertAdAccountStatusPendingRiskReviewLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL =
  "alertAdAccountStatusPendingSettlementLabel";
export const ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL =
  "alertAdAccountStatusInGracePeriodLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL =
  "alertAdAccountStatusPendingClosureLabel";
export const ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL =
  "alertAdAccountStatusClosedLabel";
export const ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL =
  "alertAdAccountStatusAnyClosedLabel";
export const ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL =
  "alertAdAccountStatusLimitedLabel";
export const ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL =
  "alertAdAccountStatusReviewFailedLabel";
export const ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL =
  "alertAdAccountStatusReviewFailedFinalLabel";
export const ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL =
  "alertAdAccountStatusModifyReviewFailedLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL =
  "alertAdAccountStatusPendingReviewLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL =
  "alertAdAccountStatusPendingVerificationLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL =
  "alertAdAccountStatusPendingModifyReviewLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL =
  "alertAdAccountStatusPendingCrmReviewLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL =
  "alertAdAccountStatusPendingPublicAuthLabel";
export const ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL =
  "alertAdAccountStatusPendingQualificationLabel";
export const ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL =
  "alertAdAccountStatusContractPendingLabel";
export const ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL =
  "alertAdAccountStatusDraftLabel";
export const ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL =
  "alertAdAccountStatusBillingHoldLabel";
export const ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL =
  "alertAdAccountStatusTotalBudgetHoldLabel";
export const ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL =
  "alertAdAccountStatusEndDateHoldLabel";
export const ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL =
  "alertAdAccountStatusRestrictedLabel";
export const ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL =
  "alertAdAccountStatusInternalHoldLabel";
export const ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL =
  "alertAdAccountStatusStoppedLabel";
export const ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL =
  "alertAdAccountStatusSuspendedLabel";
export const ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL =
  "alertAdAccountStatusCanceledLabel";
export const ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL =
  "alertAdAccountStatusBillingPendingLabel";
export const ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL =
  "alertAdAccountStatusBillingCancelledLabel";
export const ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL =
  "alertMerchantNoEligibleProductsLabel";
export const ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL =
  "alertMerchantProductsPartialIssuesLabel";
export const ALERT_AD_CPA_LOW_LABEL = "alertAdCpaLowLabel";
export const ALERT_AD_CPA_MEDIUM_LABEL = "alertAdCpaMediumLabel";
export const ALERT_AD_CPA_HIGH_LABEL = "alertAdCpaHighLabel";
export const ALERT_ASSET_GROUP_CPA_LOW_LABEL = "alertAssetGroupCpaLowLabel";
export const ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL =
  "alertAssetGroupCpaMediumLabel";
export const ALERT_ASSET_GROUP_CPA_HIGH_LABEL = "alertAssetGroupCpaHighLabel";
export const ALERT_AD_GROUP_CPA_LOW_LABEL = "alertAdGroupCpaLowLabel";
export const ALERT_AD_GROUP_CPA_MEDIUM_LABEL = "alertAdGroupCpaMediumLabel";
export const ALERT_AD_GROUP_CPA_HIGH_LABEL = "alertAdGroupCpaHighLabel";

export const ALERT_AD_CPA_LOW_TABLE_LABEL = "alertAdCpaLowTableLabel";
export const ALERT_AD_CPA_MEDIUM_TABLE_LABEL = "alertAdCpaMediumTableLabel";
export const ALERT_AD_CPA_HIGH_TABLE_LABEL = "alertAdCpaHighTableLabel";
export const ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL =
  "alertAssetGroupCpaLowTableLabel";
export const ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL =
  "alertAssetGroupCpaMediumTableLabel";
export const ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL =
  "alertAssetGroupCpaHighTableLabel";
export const ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL =
  "alertAdGroupCpaLowTableLabel";
export const ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL =
  "alertAdGroupCpaMediumTableLabel";
export const ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL =
  "alertAdGroupCpaHighTableLabel";
export const ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL =
  "alertCreativeFatigueMediumLabel";
export const ALERT_CREATIVE_FATIGUE_HIGH_LABEL =
  "alertCreativeFatigueHighLabel";
export const ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL =
  "alertCreativeFatigueMediumTableLabel";
export const ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL =
  "alertCreativeFatigueHighTableLabel";

// CARDS IN CHAT BOT
export const CARD_GENERATE_COPY = "cardGenerateCopy";
export const CARD_GENERATE_COPY_DESCRIPTION = "cardGenerateCopyDescription";
export const CARD_GENERATE_COPY_QUESTION = "cardGenerateCopyQuestion";
export const CARD_GET_CAMPAIGN_LEARNINGS = "cardGetCampaignLearnings";
export const CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION =
  "cardGetCampaignLearningsDescription";
export const CARD_GET_CAMPAIGN_LEARNINGS_QUESTION =
  "cardGetCampaignLearningsQuestion";
export const CARD_OPTIMIZE_GENERAL = "cardOptimizeTargeting";
export const CARD_OPTIMIZE_GENERAL_DESCRIPTION =
  "cardOptimizeTargetingDescription";
export const CARD_OPTIMIZE_GENERAL_QUESTION = "cardOptimizeTargetingQuestion";
export const CARD_MANAGE_BUDGET = "cardManageBudget";
export const CARD_MANAGE_BUDGET_DESCRIPTION = "cardManageBudgetDescription";
export const CARD_MANAGE_BUDGET_QUESTION = "cardManageBudgetQuestion";

// CARDS CHAT BOT OWNER (dashboard agente)
export const CARD_OWNER_INSIGHTS = "cardOwnerInsights";
export const CARD_OWNER_INSIGHTS_DESCRIPTION = "cardOwnerInsightsDescription";
export const CARD_OWNER_INSIGHTS_QUESTION = "cardOwnerInsightsQuestion";
export const CARD_OWNER_ACCOUNTS = "cardOwnerAccounts";
export const CARD_OWNER_ACCOUNTS_DESCRIPTION = "cardOwnerAccountsDescription";
export const CARD_OWNER_ACCOUNTS_QUESTION = "cardOwnerAccountsQuestion";
export const CARD_OWNER_BILLING = "cardOwnerBilling";
export const CARD_OWNER_BILLING_DESCRIPTION = "cardOwnerBillingDescription";
export const CARD_OWNER_BILLING_QUESTION = "cardOwnerBillingQuestion";
export const CARD_OWNER_SUPPORT = "cardOwnerSupport";
export const CARD_OWNER_SUPPORT_DESCRIPTION = "cardOwnerSupportDescription";
export const CARD_OWNER_SUPPORT_QUESTION = "cardOwnerSupportQuestion";

// Date range presets
export const DATE_RANGE_PRESET_TODAY = "dateRangePresetToday";
export const DATE_RANGE_PRESET_YESTERDAY = "dateRangePresetYesterday";
export const DATE_RANGE_PRESET_LAST_7 = "dateRangePresetLast7";
export const DATE_RANGE_PRESET_LAST_14 = "dateRangePresetLast14";
export const DATE_RANGE_PRESET_LAST_30 = "dateRangePresetLast30";
export const DATE_RANGE_PRESET_THIS_WEEK = "dateRangePresetThisWeek";
export const DATE_RANGE_PRESET_LAST_WEEK = "dateRangePresetLastWeek";
export const DATE_RANGE_PRESET_THIS_MONTH = "dateRangePresetThisMonth";
export const DATE_RANGE_PRESET_LAST_MONTH = "dateRangePresetLastMonth";
export const DATE_RANGE_PRESET_THIS_YEAR = "dateRangePresetThisYear";
export const DATE_RANGE_PRESET_LAST_YEAR = "dateRangePresetLastYear";
export const DATE_RANGE_PRESET_CUSTOM = "dateRangePresetCustom";

// NPS - FORM
export const NPS_FORM_TITLE = "npsFormTitle";
export const NPS_LABEL_NOT_LIKELY_AT_ALL = "npsLabelNotLikelyAtAll";
export const NPS_LABEL_EXTREMELY_LIKELY = "npsLabelExtremelyLikely";
export const NPS_SAVING_RATING = "npsSavingRating";
export const NPS_THANK_YOU_TITLE = "npsThankYouTitle";
export const NPS_THANK_YOU_DESCRIPTION = "npsThankYouDescription";

//MODAL OVERLAP CONFLICTS
export const MODAL_OVERLAP_CONFLICTS_TITLE = "modalOverlapConflictsTitle";
export const MODAL_OVERLAP_CONFLICTS_DESCRIPTION =
  "modalOverlapConflictsDescription";
export const PAGE_NUMBER = "pageNumber";

//TABLE ADMIN DASHBOARD
export const TABLE_ADMIN_DASHBOARD_CLIENT = "tableAdminDashboardClient";
export const TABLE_ADMIN_DASHBOARD_RENEW_DATE = "tableAdminDashboardRenewDate";
export const TABLE_ADMIN_DASHBOARD_RENEW_DATE_VALUE =
  "tableAdminDashboardRenewDateValue";
export const TABLE_ADMIN_DASHBOARD_DISCOVERY_SOURCE =
  "tableAdminDashboardDiscoverySource";
export const TABLE_ADMIN_DASHBOARD_HEALTH_SCORE =
  "tableAdminDashboardHealthScore";
export const TABLE_ADMIN_DASHBOARD_CAMPAIGNS = "tableAdminDashboardCampaigns";
export const TABLE_ADMIN_DASHBOARD_KPI = "tableAdminDashboardKpi";
export const TABLE_ADMIN_DASHBOARD_SPEND = "tableAdminDashboardSpent";
export const TABLE_ADMIN_DASHBOARD_CPA = "tableAdminDashboardCpa";
export const TABLE_ADMIN_DASHBOARD_TARGET_CPA = "tableAdminDashboardTargetCpa";
export const TABLE_ADMIN_DASHBOARD_ROAS = "tableAdminDashboardRoas";
export const TABLE_ADMIN_DASHBOARD_RESULTS = "tableAdminDashboardResults";
export const TABLE_ADMIN_DASHBOARD_LAST_LOGIN = "tableAdminDashboardLastLogin";
export const TABLE_ADMIN_DASHBOARD_LOGINS = "tableAdminDashboardLogins";
export const TABLE_ADMIN_DASHBOARD_USERS = "tableAdminDashboardUsers";
export const TABLE_ADMIN_DASHBOARD_AUTOMATION = "tableAdminDashboardAutomation";
export const TABLE_ADMIN_DASHBOARD_MRR = "tableAdminDashboardMrr";
export const TABLE_ADMIN_DASHBOARD_PLAN = "tableAdminDashboardPlan";
export const TABLE_ADMIN_DASHBOARD_CREATIVES = "tableAdminDashboardCreatives";
export const TABLE_ADMIN_DASHBOARD_NPS = "tableAdminDashboardNps";
export const TABLE_ADMIN_DASHBOARD_AI_CREATIVES_LAST_30_DAYS =
  "tableAdminDashboardAiCreativesLast30Days";
export const TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE =
  "tableAdminDashboardCampaignsActive";
export const TABLE_ADMIN_DASHBOARD_CAMPAIGNS_ACTIVE_SINGLE =
  "tableAdminDashboardCampaignsActiveSingle";
export const TABLE_ADMIN_DASHBOARD_INVOICE_OVERDUE =
  "tableAdminDashboardInvoiceOverdue";
export const TABLE_ADMIN_DASHBOARD_LOADING_MORE =
  "tableAdminDashboardLoadingMore";
export const TABLE_ADMIN_DASHBOARD_SHOWING_CLIENTS =
  "tableAdminDashboardShowingClients";
export const TABLE_ADMIN_CREATIVES_UTILIZED = "tableAdminCreativesUtilized";
export const TABLE_ADMIN_CREATIVE_UTILIZED = "tableAdminCreativeUtilized";
export const TABLE_ADMIN_LAST_LOGIN_DAYS = "tableAdminDashboardLastLoginDays";

export const TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE =
  "tableAdminCancellationReasonSubtitle";
export const TABLE_ADMIN_CANCELLATION_REASON_BUTTON =
  "tableAdminCancellationReasonButton";
export const TABLE_ADMIN_CANCELLED_BADGE = "tableAdminCancelledBadge";
export const TABLE_ADMIN_ADD_ADVERTISER_BUTTON =
  "tableAdminAddAdvertiserButton";
export const TABLE_ADMIN_ADD_CREDITS_BUTTON = "tableAdminAddCreditsButton";
export const TABLE_ADMIN_ACTIONS_BUTTON = "tableAdminActionsButton";
export const TABLE_ADMIN_ACTIVATE_PLAN_BUTTON = "tableAdminActivatePlanButton";
export const TABLE_ADMIN_DEACTIVATE_PLAN_BUTTON =
  "tableAdminDeactivatePlanButton";
export const TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_TITLE =
  "tableAdminConfirmActivatePlanTitle";
export const TABLE_ADMIN_CONFIRM_ACTIVATE_PLAN_MESSAGE =
  "tableAdminConfirmActivatePlanMessage";
export const TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_TITLE =
  "tableAdminConfirmDeactivatePlanTitle";
export const TABLE_ADMIN_CONFIRM_DEACTIVATE_PLAN_MESSAGE =
  "tableAdminConfirmDeactivatePlanMessage";
export const TABLE_ADMIN_MARK_DEMO_BUTTON = "tableAdminMarkDemoButton";
export const TABLE_ADMIN_CONFIRM_MARK_DEMO_TITLE =
  "tableAdminConfirmMarkDemoTitle";
export const TABLE_ADMIN_CONFIRM_MARK_DEMO_MESSAGE =
  "tableAdminConfirmMarkDemoMessage";
export const TABLE_ADMIN_CREDITS_USAGE = "tableAdminCreditsUsage";
export const TABLE_ADMIN_PENDING_PAYMENT_BADGE =
  "tableAdminPendingPaymentBadge";
export const TABLE_ADMIN_PRIORITY_BADGE = "tableAdminPriorityBadge";
export const TABLE_ADMIN_SEND_EMAIL_BUTTON = "tableAdminSendEmailButton";
export const TABLE_ADMIN_LOGIN_AS_CLIENT_BUTTON =
  "tableAdminLoginAsClientButton";
export const OWNER_LOGIN_AS_USER_OPTION = "ownerLoginAsUserOption";
export const OWNER_LOGIN_AS_USER_OPTION_EMAIL = "ownerLoginAsUserOptionEmail";
export const OWNER_LOGIN_AS_CONNECTING = "ownerLoginAsConnecting";
export const OWNER_LOGIN_AS_ERROR_TITLE = "ownerLoginAsErrorTitle";
export const SUPPORT_SESSION_BANNER_TITLE = "supportSessionBannerTitle";
export const SUPPORT_SESSION_BANNER_DESCRIPTION =
  "supportSessionBannerDescription";
export const SUPPORT_SESSION_ENDED_TITLE = "supportSessionEndedTitle";
export const SUPPORT_SESSION_ENDED_DESCRIPTION =
  "supportSessionEndedDescription";
export const OWNER_LOGIN_AS_ERROR_EXPIRED = "ownerLoginAsErrorExpired";
export const OWNER_LOGIN_AS_ERROR_INVALID = "ownerLoginAsErrorInvalid";
export const OWNER_LOGIN_AS_ERROR_MISSING_PARAMS =
  "ownerLoginAsErrorMissingParams";
export const OWNER_LOGIN_AS_ERROR_GENERIC = "ownerLoginAsErrorGeneric";
export const OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND =
  "ownerLoginAsErrorUserNotFound";
export const OWNER_LOGIN_AS_ERROR_INVALID_EMAIL =
  "ownerLoginAsErrorInvalidEmail";
export const OWNER_LOGIN_AS_ERROR_FORBIDDEN = "ownerLoginAsErrorForbidden";
export const OWNER_LOGIN_AS_ERROR_UNAUTHORIZED =
  "ownerLoginAsErrorUnauthorized";
export const TABLE_ADMIN_SEND_EMAIL_MODAL_TITLE =
  "tableAdminSendEmailModalTitle";
export const TABLE_ADMIN_SEND_EMAIL_SUBJECT_LABEL =
  "tableAdminSendEmailSubjectLabel";
export const TABLE_ADMIN_SEND_EMAIL_BODY_LABEL = "tableAdminSendEmailBodyLabel";
export const TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_LABEL =
  "tableAdminSendEmailRecipientsLabel";
export const TABLE_ADMIN_SEND_EMAIL_RECIPIENTS_PLACEHOLDER =
  "tableAdminSendEmailRecipientsPlaceholder";
export const TABLE_ADMIN_SEND_EMAIL_SELECT_ALL = "tableAdminSendEmailSelectAll";
export const TABLE_ADMIN_SEND_EMAIL_SEND_BUTTON =
  "tableAdminSendEmailSendButton";
export const TABLE_ADMIN_SEND_EMAIL_SUCCESS = "tableAdminSendEmailSuccess";
export const TABLE_ADMIN_MODIFY_KPI_CPA_BUTTON = "tableAdminModifyKpiCpaButton";
export const TABLE_ADMIN_ENABLE_FEATURES_BUTTON =
  "tableAdminEnableFeaturesButton";
export const TABLE_ADMIN_FEATURE_TYPOGRAPHIC_FIDELITY =
  "tableAdminFeatureTypographicFidelity";
export const TABLE_ADMIN_FEATURE_MINIMUM_TERM_CONTRACT =
  "tableAdminFeatureMinimumTermContract";
export const TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON = "tableAdminAiImageModelButton";
export const TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE =
  "tableAdminAiImageProviderGoogle";
export const TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI =
  "tableAdminAiImageProviderOpenai";
export const TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM =
  "tableAdminAiImageProviderSeedream";
export const ADMIN_DASHBOARD_CREATE_BRAND_FEATURES_LABEL =
  "adminDashboardCreateBrandFeaturesLabel";
export const MODAL_MODIFY_KPI_CPA_TITLE = "modalModifyKpiCpaTitle";
export const MODAL_MODIFY_KPI_CPA_PRIMARY_LABEL =
  "modalModifyKpiCpaPrimaryLabel";
export const MODAL_MODIFY_KPI_CPA_TARGET_LABEL = "modalModifyKpiCpaTargetLabel";
export const MODAL_MODIFY_KPI_CPA_CURRENCY_LABEL =
  "modalModifyKpiCpaCurrencyLabel";
export const MODAL_MODIFY_KPI_CPA_SAVE_SUCCESS = "modalModifyKpiCpaSaveSuccess";
export const MODAL_MODIFY_KPI_CPA_VOLUMEN_LABEL =
  "modalModifyKpiCpaVolumenLabel";
export const MODAL_CAMPAIGN_KPI_CPA_TITLE = "modalCampaignKpiCpaTitle";
export const MODAL_CAMPAIGN_KPI_CPA_INHERIT_HINT =
  "modalCampaignKpiCpaInheritHint";
export const MODAL_CAMPAIGN_KPI_CPA_WEEKLY_VOLUME_LABEL =
  "modalCampaignKpiCpaWeeklyVolumeLabel";
export const ADMIN_KPI_PRIMARY_LEADS = "adminKpiPrimaryLeads";
export const ADMIN_KPI_PRIMARY_SALES = "adminKpiPrimarySales";
export const ADMIN_KPI_PRIMARY_MESSAGES = "adminKpiPrimaryMessages";
export const ADMIN_KPI_PRIMARY_INTERACTIONS = "adminKpiPrimaryInteractions";
export const ADMIN_KPI_PRIMARY_TRAFFIC = "adminKpiPrimaryTraffic";
export const ADMIN_KPI_PRIMARY_CONVERSIONS = "adminKpiPrimaryConversions";
export const ADMIN_KPI_PRIMARY_DOWNLOADS = "adminKpiPrimaryDownloads";
export const ADMIN_KPI_PRIMARY_APP_INSTALLS = "adminKpiPrimaryAppInstalls";
export const ADMIN_KPI_PRIMARY_VIDEO_VIEWS = "adminKpiPrimaryVideoViews";
export const ADMIN_KPI_PRIMARY_AWARENESS = "adminKpiPrimaryAwareness";
export const ADMIN_KPI_PRIMARY_REACH = "adminKpiPrimaryReach";
export const ADMIN_KPI_PRIMARY_ENGAGEMENT = "adminKpiPrimaryEngagement";
export const ADMIN_KPI_PRIMARY_STORE_VISITS = "adminKpiPrimaryStoreVisits";
export const ADMIN_KPI_PRIMARY_WEBSITE_CONVERSIONS =
  "adminKpiPrimaryWebsiteConversions";
export const ADMIN_KPI_PRIMARY_CATALOG_SALES = "adminKpiPrimaryCatalogSales";
export const ADMIN_KPI_PRIMARY_SIGNUPS = "adminKpiPrimarySignups";
export const ADMIN_DASHBOARD_TITLE = "adminDashboardTitle";
export const OWNER_DASHBOARD_NAV_FORM = "ownerDashboardNavForm";
export const OWNER_DASHBOARD_NAV_REPORTED_CONTENT =
  "ownerDashboardNavReportedContent";
export const OWNER_DASHBOARD_NAV_PROMOTIONAL_CODES =
  "ownerDashboardNavPromotionalCodes";
export const OWNER_DASHBOARD_NAV_GLOBAL_NOTIFICATIONS =
  "ownerDashboardNavGlobalNotifications";
export const OWNER_DASHBOARD_NAV_AD_SPEND = "ownerDashboardNavAdSpend";
export const OWNER_AD_SPEND_TITLE = "ownerAdSpendTitle";
export const OWNER_AD_SPEND_DESCRIPTION = "ownerAdSpendDescription";
export const OWNER_AD_SPEND_PRESET_HISTORIC = "ownerAdSpendPresetHistoric";
export const OWNER_AD_SPEND_PRESET_LAST_7 = "ownerAdSpendPresetLast7";
export const OWNER_AD_SPEND_PRESET_LAST_30 = "ownerAdSpendPresetLast30";
export const OWNER_AD_SPEND_PRESET_LAST_90 = "ownerAdSpendPresetLast90";
export const OWNER_AD_SPEND_PRESET_THIS_MONTH = "ownerAdSpendPresetThisMonth";
export const OWNER_AD_SPEND_PRESET_LAST_MONTH = "ownerAdSpendPresetLastMonth";
export const OWNER_AD_SPEND_PRESET_CUSTOM = "ownerAdSpendPresetCustom";
export const OWNER_AD_SPEND_CUSTOM_PENDING = "ownerAdSpendCustomPending";
export const OWNER_AD_SPEND_ACCURACY_WARNING = "ownerAdSpendAccuracyWarning";
export const OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED =
  "ownerAdSpendAccuracyWarningEstimated";
export const OWNER_AD_SPEND_KPI_TOTAL = "ownerAdSpendKpiTotal";
export const OWNER_AD_SPEND_KPI_ADVERTISERS = "ownerAdSpendKpiAdvertisers";
export const OWNER_AD_SPEND_KPI_COUNTRIES = "ownerAdSpendKpiCountries";
export const OWNER_AD_SPEND_VS_PREVIOUS_PERIOD = "ownerAdSpendVsPreviousPeriod";
export const OWNER_AD_SPEND_CHART_TITLE = "ownerAdSpendChartTitle";
export const OWNER_AD_SPEND_CHART_DAILY = "ownerAdSpendChartDaily";
export const OWNER_AD_SPEND_CHART_MONTHLY = "ownerAdSpendChartMonthly";
export const OWNER_AD_SPEND_PLATFORMS_TITLE = "ownerAdSpendPlatformsTitle";
export const OWNER_AD_SPEND_TOP_ADVERTISERS_TITLE =
  "ownerAdSpendTopAdvertisersTitle";
export const OWNER_AD_SPEND_TOP_COUNTRIES_TITLE =
  "ownerAdSpendTopCountriesTitle";
export const OWNER_AD_SPEND_TOP_ADVERTISERS_ARIA =
  "ownerAdSpendTopAdvertisersAria";
export const OWNER_AD_SPEND_TOP_COUNTRIES_ARIA = "ownerAdSpendTopCountriesAria";
export const OWNER_AD_SPEND_COLUMN_ADVERTISER = "ownerAdSpendColumnAdvertiser";
export const OWNER_AD_SPEND_COLUMN_COUNTRY = "ownerAdSpendColumnCountry";
export const OWNER_AD_SPEND_COLUMN_SPEND = "ownerAdSpendColumnSpend";
export const OWNER_AD_SPEND_COLUMN_SHARE = "ownerAdSpendColumnShare";
export const OWNER_AD_SPEND_COLUMN_PLATFORMS = "ownerAdSpendColumnPlatforms";
export const OWNER_AD_SPEND_UNASSIGNED_COUNTRY =
  "ownerAdSpendUnassignedCountry";
export const OWNER_AD_SPEND_TREND_NEW = "ownerAdSpendTrendNew";
export const OWNER_AD_SPEND_ESTIMATED_BADGE = "ownerAdSpendEstimatedBadge";
export const OWNER_AD_SPEND_EMPTY_TITLE = "ownerAdSpendEmptyTitle";
export const OWNER_AD_SPEND_EMPTY_DESCRIPTION = "ownerAdSpendEmptyDescription";
export const OWNER_AD_SPEND_MOCK_BADGE = "ownerAdSpendMockBadge";
export const OWNER_DASHBOARD_NAV_CREATE_USER = "ownerDashboardNavCreateUser";
export const OWNER_DASHBOARD_NAV_OPTIONS = "ownerDashboardNavOptions";
export const OWNER_GLOBAL_NOTIFICATIONS_TITLE = "ownerGlobalNotificationsTitle";
export const OWNER_GLOBAL_NOTIFICATIONS_FIELD_TITLE =
  "ownerGlobalNotificationsFieldTitle";
export const OWNER_GLOBAL_NOTIFICATIONS_FIELD_BODY =
  "ownerGlobalNotificationsFieldBody";
export const OWNER_GLOBAL_NOTIFICATIONS_FIELD_CTA =
  "ownerGlobalNotificationsFieldCta";
export const OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK =
  "ownerGlobalNotificationsFieldLink";
export const OWNER_GLOBAL_NOTIFICATIONS_FIELD_LINK_HELPER =
  "ownerGlobalNotificationsFieldLinkHelper";
export const OWNER_GLOBAL_NOTIFICATIONS_CTA_LINK_PAIR_ERROR =
  "ownerGlobalNotificationsCtaLinkPairError";
export const OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_BUTTON =
  "ownerGlobalNotificationsPublishButton";
export const OWNER_GLOBAL_NOTIFICATIONS_PUBLISH_SUCCESS =
  "ownerGlobalNotificationsPublishSuccess";
export const MODAL_CREATE_OWNER_USER_ARIA_LABEL =
  "modalCreateOwnerUserAriaLabel";
export const MODAL_CREATE_OWNER_USER_TITLE = "modalCreateOwnerUserTitle";
export const MODAL_CREATE_OWNER_USER_DESCRIPTION =
  "modalCreateOwnerUserDescription";
export const MODAL_CREATE_OWNER_USER_SUCCESS = "modalCreateOwnerUserSuccess";
export const REGISTER_PROMOTIONAL_CODE_LABEL = "registerPromotionalCodeLabel";
export const REGISTER_PROMOTIONAL_CODE_PLACEHOLDER =
  "registerPromotionalCodePlaceholder";
export const REGISTER_DISCOVERY_SOURCE_LABEL = "registerDiscoverySourceLabel";
export const OWNER_PROMOTIONAL_CODES_CREATE_TITLE =
  "ownerPromotionalCodesCreateTitle";
export const OWNER_PROMOTIONAL_CODES_CREATE_BUTTON =
  "ownerPromotionalCodesCreateButton";
export const OWNER_PROMOTIONAL_CODES_MODAL_SUBTITLE =
  "ownerPromotionalCodesModalSubtitle";
export const OWNER_PROMOTIONAL_CODES_GENERATE_CODE_TOOLTIP =
  "ownerPromotionalCodesGenerateCodeTooltip";
export const OWNER_PROMOTIONAL_CODES_FIELD_CODE =
  "ownerPromotionalCodesFieldCode";
export const OWNER_PROMOTIONAL_CODES_FIELD_MAX_REDEMPTIONS =
  "ownerPromotionalCodesFieldMaxRedemptions";
export const OWNER_PROMOTIONAL_CODES_FIELD_APP_SUMO =
  "ownerPromotionalCodesFieldAppSumo";
export const OWNER_PROMOTIONAL_CODES_FIELD_TIER =
  "ownerPromotionalCodesFieldTier";
export const OWNER_PROMOTIONAL_CODES_TIER_OPTION_1 =
  "ownerPromotionalCodesTierOption1";
export const OWNER_PROMOTIONAL_CODES_TIER_OPTION_2 =
  "ownerPromotionalCodesTierOption2";
export const OWNER_PROMOTIONAL_CODES_TIER_OPTION_3 =
  "ownerPromotionalCodesTierOption3";
export const OWNER_PROMOTIONAL_CODES_COLUMN_CODE =
  "ownerPromotionalCodesColumnCode";
export const OWNER_PROMOTIONAL_CODES_COLUMN_CREATED =
  "ownerPromotionalCodesColumnCreated";
export const OWNER_PROMOTIONAL_CODES_COLUMN_REGISTERED =
  "ownerPromotionalCodesColumnRegistered";
export const OWNER_PROMOTIONAL_CODES_COLUMN_MAX_REDEMPTIONS =
  "ownerPromotionalCodesColumnMaxRedemptions";
export const OWNER_PROMOTIONAL_CODES_COLUMN_TYPE =
  "ownerPromotionalCodesColumnType";
export const OWNER_PROMOTIONAL_CODES_TYPE_VALUE_APP_SUMO =
  "ownerPromotionalCodesTypeValueAppSumo";
export const OWNER_PROMOTIONAL_CODES_TYPE_APP_SUMO_TIER_SUFFIX =
  "ownerPromotionalCodesTypeAppSumoTierSuffix";
export const OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STANDARD =
  "ownerPromotionalCodesTypeValueStandard";
export const OWNER_PROMOTIONAL_CODES_TYPE_VALUE_STRIPE_DISCOUNT =
  "ownerPromotionalCodesTypeValueStripeDiscount";
export const OWNER_PROMOTIONAL_CODES_FIELD_STRIPE_CODE =
  "ownerPromotionalCodesFieldStripeCode";
export const OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT =
  "ownerPromotionalCodesFieldDiscount";
export const OWNER_PROMOTIONAL_CODES_FIELD_DISCOUNT_TYPE =
  "ownerPromotionalCodesFieldDiscountType";
export const OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_FIXED =
  "ownerPromotionalCodesDiscountTypeFixed";
export const OWNER_PROMOTIONAL_CODES_DISCOUNT_TYPE_PERCENTAGE =
  "ownerPromotionalCodesDiscountTypePercentage";
export const OWNER_PROMOTIONAL_CODES_ERROR_INVALID_STRIPE_DISCOUNT =
  "ownerPromotionalCodesErrorInvalidStripeDiscount";
export const PRICING_PROMO_DISCOUNT_APPLIED = "pricingPromoDiscountApplied";
export const OWNER_PROMOTIONAL_CODES_COLUMN_STATUS =
  "ownerPromotionalCodesColumnStatus";
export const OWNER_PROMOTIONAL_CODES_STATUS_ACTIVE =
  "ownerPromotionalCodesStatusActive";
export const OWNER_PROMOTIONAL_CODES_STATUS_INACTIVE =
  "ownerPromotionalCodesStatusInactive";
export const OWNER_PROMOTIONAL_CODES_CREATE_SUCCESS =
  "ownerPromotionalCodesCreateSuccess";
export const OWNER_PROMOTIONAL_CODES_ERROR_DUPLICATE =
  "ownerPromotionalCodesErrorDuplicate";
export const OWNER_PROMOTIONAL_CODES_ERROR_INVALID =
  "ownerPromotionalCodesErrorInvalid";
export const PROMOTIONAL_CODE_NOT_FOUND = "promotionalCodeNotFound";
export const PROMOTIONAL_CODE_INACTIVE = "promotionalCodeInactive";
export const PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED =
  "promotionalCodeMaxRedemptionsReached";
export const ADMIN_DASHBOARD_SUBTITLE = "adminDashboardSubtitle";
export const ADMIN_DASHBOARD_SEARCH_PLACEHOLDER =
  "adminDashboardSearchPlaceholder";
export const ADMIN_DASHBOARD_FILTER_STATUS_PLACEHOLDER =
  "adminDashboardFilterStatusPlaceholder";
export const ADMIN_DASHBOARD_HEALTH_SUMMARY_TITLE =
  "adminDashboardHealthSummaryTitle";
export const ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_HEALTHY =
  "adminDashboardHealthSummaryLabelHealthy";
export const ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_WATCHLIST =
  "adminDashboardHealthSummaryLabelWatchlist";
export const ADMIN_DASHBOARD_HEALTH_SUMMARY_LABEL_AT_RISK =
  "adminDashboardHealthSummaryLabelAtRisk";
export const CREATE_BRAND_BUTTON = "createBrandButton";
export const ADMIN_DASHBOARD_CREATE_BRAND_BUTTON =
  "adminDashboardCreateBrandButton";
export const ANNOTATIONS_SIDEBAR_AGENCY_HEADER =
  "annotationsSidebarAgencyHeader";
export const ANNOTATIONS_SIDEBAR_ADVERTISER_HEADER =
  "annotationsSidebarAdvertiserHeader";
export const ANNOTATIONS_SIDEBAR_EMPTY_TITLE = "annotationsSidebarEmptyTitle";
export const ANNOTATIONS_SIDEBAR_EMPTY_SUBTITLE =
  "annotationsSidebarEmptySubtitle";
export const ANNOTATIONS_SIDEBAR_INPUT_PLACEHOLDER =
  "annotationsSidebarInputPlaceholder";
export const ANNOTATIONS_SIDEBAR_YOU_LABEL = "annotationsSidebarYouLabel";
export const ANNOTATIONS_SIDEBAR_LOADING = "annotationsSidebarLoading";
export const ANNOTATIONS_SIDEBAR_CLOSE = "annotationsSidebarClose";
export const ANNOTATIONS_UNREAD_BADGE_ARIA = "annotationsUnreadBadgeAria";
export const ANNOTATIONS_UNREAD_COUNT = "annotationsUnreadCount";
export const ANNOTATIONS_MENTION_ALL = "annotationsMentionAll";
export const ANNOTATIONS_MENTION_MENU_ARIA = "annotationsMentionMenuAria";
export const ANNOTATIONS_MESSAGE_EDIT = "annotationsMessageEdit";
export const ANNOTATIONS_MESSAGE_DELETE = "annotationsMessageDelete";
export const ANNOTATIONS_MESSAGE_DELETE_CONFIRM =
  "annotationsMessageDeleteConfirm";
export const ANNOTATIONS_MESSAGE_EDITING = "annotationsMessageEditing";
export const ANNOTATIONS_MESSAGE_CANCEL_EDIT = "annotationsMessageCancelEdit";
export const ANNOTATIONS_MESSAGE_MENU_ARIA = "annotationsMessageMenuAria";
export const ADMIN_DASHBOARD_CREATE_BRAND_MODAL_TITLE =
  "adminDashboardCreateBrandModalTitle";
export const ADMIN_DASHBOARD_CREATE_BRAND_MODAL_SUBTITLE =
  "adminDashboardCreateBrandModalSubtitle";
export const ADMIN_DASHBOARD_CREATE_BRAND_PLAN_ACTIVE_LABEL =
  "adminDashboardCreateBrandPlanActiveLabel";
export const ADMIN_DASHBOARD_CREATE_BRAND_PLAN_TYPE_LABEL =
  "adminDashboardCreateBrandPlanTypeLabel";
export const ADMIN_DASHBOARD_USER_CREATED_SUCCESS =
  "adminDashboardUserCreatedSuccess";
export const ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_LABEL =
  "adminDashboardCreateBrandTrialLabel";
export const ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_YES =
  "adminDashboardCreateBrandTrialYes";
export const ADMIN_DASHBOARD_CREATE_BRAND_TRIAL_NO =
  "adminDashboardCreateBrandTrialNo";
export const ADMIN_DASHBOARD_CREATE_BRAND_PLAN_RECURRENT_LABEL =
  "adminDashboardCreateBrandPlanRecurrentLabel";
export const ADMIN_DASHBOARD_CREATE_BRAND_PLAN_LABEL =
  "adminDashboardCreateBrandPlanLabel";
export const ADMIN_DASHBOARD_CREATE_BRAND_HAS_ADDON_SPEND_FEE_LABEL =
  "adminDashboardCreateBrandHasAddonSpendFeeLabel";
export const ADMIN_DASHBOARD_CREATE_BRAND_AD_SPEND_FEE_PERCENTAGE_LABEL =
  "adminDashboardCreateBrandAdSpendFeePercentageLabel";
export const ADMIN_DASHBOARD_CREATE_BRAND_STRIPE_SUBSCRIPTION_ID_LABEL =
  "adminDashboardCreateBrandStripeSubscriptionIdLabel";
export const ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE =
  "adminDashboardAddAdvertiserModalTitle";
export const ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL =
  "adminDashboardAddAdvertiserModalBrandNameLabel";
export const ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS =
  "adminDashboardAdvertiserCreatedSuccess";
export const DELETE_BRAND_CONFIRMATION_TITLE = "deleteBrandConfirmationTitle";
export const DELETE_BRAND_CONFIRMATION_DESCRIPTION =
  "deleteBrandConfirmationDescription";
export const DELETE_BRAND_SUCCESS = "deleteBrandSuccess";
export const DELETE_BRAND_ERROR = "deleteBrandError";
export const DELETE_BRAND_MAIN_CANNOT_DELETE = "deleteBrandMainCannotDelete";
export const ADMIN_DASHBOARD_ADD_CREDITS_MODAL_TITLE =
  "adminDashboardAddCreditsModalTitle";
export const ADMIN_DASHBOARD_ADD_CREDITS_MODAL_LABEL =
  "adminDashboardAddCreditsModalLabel";
export const ADMIN_DASHBOARD_ADD_CREDITS_MODAL_PLACEHOLDER =
  "adminDashboardAddCreditsModalPlaceholder";
export const ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MIN_ERROR =
  "adminDashboardAddCreditsModalMinError";
export const ADMIN_DASHBOARD_ADD_CREDITS_MODAL_MAX_ERROR =
  "adminDashboardAddCreditsModalMaxError";
export const ADMIN_DASHBOARD_CREDITS_ADDED_SUCCESS =
  "adminDashboardCreditsAddedSuccess";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_MODAL_TITLE =
  "adminDashboardBrandUsageAllocationModalTitle";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CREDITS_LABEL =
  "adminDashboardBrandUsageAllocationCreditsLabel";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_VIDEOS_LABEL =
  "adminDashboardBrandUsageAllocationVideosLabel";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_CONSUMED_LABEL =
  "adminDashboardBrandUsageAllocationConsumedLabel";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_HINT =
  "adminDashboardBrandUsageAllocationPlanMaxHint";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_REMOVE_HINT =
  "adminDashboardBrandUsageAllocationRemoveHint";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_TOTAL_ASSIGNED_LABEL =
  "adminDashboardBrandUsageAllocationTotalAssignedLabel";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_PLAN_MAX_LABEL =
  "adminDashboardBrandUsageAllocationPlanMaxLabel";
export const ADMIN_DASHBOARD_BRAND_USAGE_ALLOCATION_SUCCESS =
  "adminDashboardBrandUsageAllocationSuccess";
export const HEALTH_SCORE_LABEL = "healthScoreLabel";

export const AGENT_LABEL = "agentLabel";
export const GO_TO_DASHBOARD = "goToDashboard";

// Accent translations
export const ACCENT_ES_ARGENTINO = "accent.es.argentino";
export const ACCENT_ES_COLOMBIANO = "accent.es.colombiano";
export const ACCENT_ES_CHILENO = "accent.es.chileno";
export const ACCENT_ES_MEXICANO = "accent.es.mexicano";
export const ACCENT_ES_ESPANOL_ESPANA = "accent.es.espanol_espana";
export const ACCENT_ES_PERUANO = "accent.es.peruano";
export const ACCENT_ES_VENEZOLANO = "accent.es.venezolano";
export const ACCENT_ES_CARIBENO = "accent.es.caribeno";
export const ACCENT_ES_NEUTRAL = "accent.es.neutral";
export const ACCENT_ES_PUERTORRIQUENO = "accent.es.puertorriqueno";

export const ACCENT_EN_AMERICAN = "accent.en.american";
export const ACCENT_EN_BRITISH = "accent.en.british";
export const ACCENT_EN_AUSTRALIAN = "accent.en.australian";
export const ACCENT_EN_NEUTRAL = "accent.en.neutral";
export const PARTNERSHIP = "partnership";

// Campaign Learnings
export const CAMPAIGN_LEARNINGS_TITLE = "campaignLearningsTitle";
export const CAMPAIGN_LEARNINGS_SUBTITLE = "campaignLearningsSubtitle";
export const CAMPAIGN_LEARNINGS_KEY_LEARNINGS = "campaignLearningsKeyLearnings";
export const CAMPAIGN_LEARNINGS_WHAT_WORKED = "campaignLearningsWhatWorked";
export const CAMPAIGN_LEARNINGS_WHAT_DIDNT_WORK =
  "campaignLearningsWhatDidntWork";
export const PLATFORM_META = "platformMeta";
export const PLATFORM_GOOGLE = "platformGoogle";

// BRAND SETUP CONFIRM MODAL
export const MODAL_BRAND_SETUP_CONFIRM_TITLE = "modalBrandSetupConfirmTitle";
export const MODAL_BRAND_SETUP_CONFIRM_DESCRIPTION =
  "modalBrandSetupConfirmDescription";
export const MODAL_BRAND_SETUP_CONFIRM_BUTTON = "modalBrandSetupConfirmButton";
export const MODAL_BRAND_SETUP_REVIEW_BUTTON = "modalBrandSetupReviewButton";
export const BRAND_SETUP_EXTRACTION_WARNING_MESSAGE =
  "brandSetupExtractionWarningMessage";
export const BRAND_SETUP_LOADING_GETTING_WEBSITE_INFORMATION =
  "brandSetupLoadingGettingWebsiteInformation";
export const BRAND_SETUP_LOADING_ANALYZING_BRAND =
  "brandSetupLoadingAnalyzingBrand";
export const BRAND_SETUP_LOADING_GENERATING_BRAND_PROFILE =
  "brandSetupLoadingGeneratingBrandProfile";
export const BRAND_SETUP_LOADING_FINALIZING_DETAILS =
  "brandSetupLoadingFinalizingDetails";
export const BRAND_SETUP_GENERATION_PROMPT_LABEL =
  "brandSetupGenerationPromptLabel";
export const BRAND_SETUP_GENERATION_PROMPT_PLACEHOLDER =
  "brandSetupGenerationPromptPlaceholder";
export const BRAND_SETUP_GENERATION_ATTACH_PDF =
  "brandSetupGenerationAttachPdf";
export const BRAND_SETUP_GENERATION_PDF_HINT = "brandSetupGenerationPdfHint";
export const BRAND_SETUP_GENERATION_REMOVE_PDF =
  "brandSetupGenerationRemovePdf";
export const BRAND_SETUP_GENERATION_PDF_INVALID =
  "brandSetupGenerationPdfInvalid";
export const BRAND_SETUP_GENERATION_PDF_TOO_LARGE =
  "brandSetupGenerationPdfTooLarge";
export const BRAND_SETUP_GENERATION_SHOW_ADVANCED =
  "brandSetupGenerationShowAdvanced";
export const BRAND_SETUP_GENERATION_HIDE_ADVANCED =
  "brandSetupGenerationHideAdvanced";
export const BRAND_SETUP_VERSION_CURRENT = "brandSetupVersionCurrent";
export const BRAND_SETUP_VERSION_LABEL = "brandSetupVersionLabel";
export const BRAND_SETUP_VERSION_PLACEHOLDER = "brandSetupVersionPlaceholder";
export const BRAND_SETUP_GROUP_VISUAL_IDENTITY_TITLE =
  "brandSetupGroupVisualIdentityTitle";
export const BRAND_SETUP_GROUP_VISUAL_IDENTITY_DESCRIPTION =
  "brandSetupGroupVisualIdentityDescription";
export const BRAND_SETUP_GROUP_AUDIENCE_TITLE = "brandSetupGroupAudienceTitle";
export const BRAND_SETUP_GROUP_AUDIENCE_DESCRIPTION =
  "brandSetupGroupAudienceDescription";
export const BRAND_SETUP_GROUP_COPY_TITLE = "brandSetupGroupCopyTitle";
export const BRAND_SETUP_GROUP_COPY_DESCRIPTION =
  "brandSetupGroupCopyDescription";
export const BRAND_INSIGHTS_TAB_TITLE = "brandInsightsTabTitle";
export const BRAND_INSIGHTS_PAGE_TITLE = "brandInsightsPageTitle";
export const BRAND_INSIGHTS_PAGE_DESCRIPTION = "brandInsightsPageDescription";
export const BRAND_INSIGHTS_POSITIVE_TITLE = "brandInsightsPositiveTitle";
export const BRAND_INSIGHTS_NEGATIVE_TITLE = "brandInsightsNegativeTitle";
export const BRAND_INSIGHTS_POSITIVE_SUBTITLE = "brandInsightsPositiveSubtitle";
export const BRAND_INSIGHTS_NEGATIVE_SUBTITLE = "brandInsightsNegativeSubtitle";
export const BRAND_INSIGHTS_TOPIC_ANGLE = "brandInsightsTopicAngle";
export const BRAND_INSIGHTS_TOPIC_COPY = "brandInsightsTopicCopy";
export const BRAND_INSIGHTS_TOPIC_CTA = "brandInsightsTopicCta";
export const BRAND_INSIGHTS_TOPIC_TONE = "brandInsightsTopicTone";
export const BRAND_INSIGHTS_TOPIC_AESTHETIC = "brandInsightsTopicAesthetic";
export const BRAND_INSIGHTS_TOPIC_VALUE_PROP = "brandInsightsTopicValueProp";
export const BRAND_INSIGHTS_EMPTY = "brandInsightsEmpty";
export const BRAND_INSIGHTS_REVIEW_CHANGE = "brandInsightsReviewChange";
export const BRAND_INSIGHTS_DISMISS = "brandInsightsDismiss";
export const BRAND_INSIGHTS_DISMISS_ALERT_TITLE =
  "brandInsightsDismissAlertTitle";
export const BRAND_INSIGHTS_DISMISS_ALERT_DESCRIPTION =
  "brandInsightsDismissAlertDescription";
export const BRAND_INSIGHTS_COUNT = "brandInsightsCount";
export const BRAND_INSIGHTS_UNREAD_ONE = "brandInsightsUnreadOne";
export const BRAND_INSIGHTS_UNREAD_OTHER = "brandInsightsUnreadOther";
export const BRAND_INSIGHTS_APPLY_TITLE = "brandInsightsApplyTitle";
export const BRAND_INSIGHTS_APPLY_LOADING = "brandInsightsApplyLoading";
export const BRAND_INSIGHTS_APPLY_CONFIRM = "brandInsightsApplyConfirm";
export const BRAND_INSIGHTS_APPLY_CANCEL = "brandInsightsApplyCancel";
export const BRAND_INSIGHTS_APPLY_REJECTED = "brandInsightsApplyRejected";
export const BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG =
  "brandInsightsApplyAlreadyInConfig";
export const BRAND_INSIGHTS_APPLY_UNMAPPABLE = "brandInsightsApplyUnmappable";
export const BRAND_INSIGHTS_APPLY_REWRITE = "brandInsightsApplyRewrite";
export const BRAND_INSIGHTS_APPLY_RETRY = "brandInsightsApplyRetry";
export const BRAND_INSIGHTS_APPLY_TIMEOUT = "brandInsightsApplyTimeout";
export const BRAND_INSIGHTS_APPLY_FIELD = "brandInsightsApplyField";
export const BRAND_INSIGHTS_APPLY_RESULT_TITLE =
  "brandInsightsApplyResultTitle";
export const BRAND_INSIGHTS_APPLY_SHOW_FULL = "brandInsightsApplyShowFull";
export const BRAND_INSIGHTS_APPLY_SHOW_CHANGES =
  "brandInsightsApplyShowChanges";
export const BRAND_INSIGHTS_APPLY_NO_CHANGES = "brandInsightsApplyNoChanges";
export const BRAND_INSIGHTS_APPLY_DIFF_COLLAPSED =
  "brandInsightsApplyDiffCollapsed";

// PLANS CREDITS
export const ADS_SUBSCRIPTION_BENEFIT_CREDITS = "plansCreditsCredits";
export const ADS_SUBSCRIPTION_BENEFIT_CREDITS_PER_YEAR =
  "plansCreditsCreditsPerYear";

// APPSUMO PRICING TIERS
export const APPSUMO_SUBSCRIPTION_TIER_1 = "appSumoSubscriptionTier1";
export const APPSUMO_SUBSCRIPTION_TIER_2 = "appSumoSubscriptionTier2";
export const APPSUMO_SUBSCRIPTION_TIER_3 = "appSumoSubscriptionTier3";

export const VALUE_SUBSCRIPTION_ONE_TIME = "valueSubscriptionOneTime";

export const BUTTON_APPSUMO_VIEW_PLANS = "buttonAppSumoViewPlans";

// MODAL PURCHASE CREDITS
export const BUY_CREDITS = "buyCredits";
export const MODAL_PURCHASE_CREDITS_TITLE = "modalPurchaseCreditsTitle";
export const MODAL_PURCHASE_CREDITS_ARIA_LABEL =
  "modalPurchaseCreditsAriaLabel";
export const MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_TITLE =
  "modalPurchaseCreditsHowItWorksTitle";
export const MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_1 =
  "modalPurchaseCreditsHowItWorksItem1";
export const MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_2 =
  "modalPurchaseCreditsHowItWorksItem2";
export const MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3 =
  "modalPurchaseCreditsHowItWorksItem3";
export const MODAL_PURCHASE_CREDITS_HOW_IT_WORKS_ITEM_3_LINK =
  "modalPurchaseCreditsHowItWorksItem3Link";
export const MODAL_PURCHASE_CREDITS_SELECT_AMOUNT =
  "modalPurchaseCreditsSelectAmount";
export const MODAL_PURCHASE_CREDITS_MINIMUM_AMOUNT =
  "modalPurchaseCreditsMinimumAmount";
export const MODAL_PURCHASE_CREDITS_CUSTOM_AMOUNT_PLACEHOLDER =
  "modalPurchaseCreditsCustomAmountPlaceholder";
export const MODAL_PURCHASE_CREDITS_UPGRADE_PLAN =
  "modalPurchaseCreditsUpgradePlan";
export const MODAL_PURCHASE_CREDITS_PURCHASE_BUTTON =
  "modalPurchaseCreditsPurchaseButton";
export const MODAL_PURCHASE_CREDITS_PAYMENT_SUMMARY =
  "modalPurchaseCreditsPaymentSummary";
export const MODAL_PURCHASE_CREDITS_CREDITS_LABEL =
  "modalPurchaseCreditsCreditsLabel";
export const MODAL_PURCHASE_CREDITS_PRICE_PER_CREDIT =
  "modalPurchaseCreditsPricePerCredit";
export const MODAL_PURCHASE_CREDITS_CREDIT_PACKAGES_TITLE =
  "modalPurchaseCreditsCreditPackagesTitle";
export const MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_TITLE =
  "modalPurchaseCreditsVideoPackagesTitle";
export const MODAL_PURCHASE_CREDITS_VIDEO_PACKAGES_SUBTITLE =
  "modalPurchaseCreditsVideoPackagesSubtitle";
export const MODAL_PURCHASE_CREDITS_VIDEO_ON_SCREEN_TEXT_LANGUAGES =
  "modalPurchaseCreditsVideoOnScreenTextLanguages";
export const MODAL_PURCHASE_CREDITS_VIDEOS_LABEL =
  "modalPurchaseCreditsVideosLabel";
export const MODAL_PURCHASE_CREDITS_PRICE_PER_VIDEO =
  "modalPurchaseCreditsPricePerVideo";
export const MODAL_PURCHASE_CREDITS_PURCHASE_VIDEOS_BUTTON =
  "modalPurchaseCreditsPurchaseVideosButton";
export const MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLES_TITLE =
  "modalPurchaseCreditsVideoExamplesTitle";
export const MODAL_PURCHASE_CREDITS_VIDEO_EXAMPLE =
  "modalPurchaseCreditsVideoExample";

export const VIDEO_INSUFFICIENT_CREDITS_ALERT_TITLE =
  "videoInsufficientCreditsAlertTitle";
export const VIDEO_INSUFFICIENT_CREDITS_ALERT_INTRO =
  "videoInsufficientCreditsAlertIntro";
export const VIDEO_INSUFFICIENT_CREDITS_ALERT_INSTRUCTION =
  "videoInsufficientCreditsAlertInstruction";
export const VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_PURCHASE =
  "videoInsufficientCreditsAlertOptionPurchase";
export const VIDEO_INSUFFICIENT_CREDITS_ALERT_OPTION_UPGRADE =
  "videoInsufficientCreditsAlertOptionUpgrade";

/*BRAND SETUP SECTIONS*/
export const SECTION_COMPETITORS_TITLE = "sectionCompetitorsTitle";
export const SECTION_COMPETITORS_SUBTITLE_SINGULAR =
  "sectionCompetitorsSubtitleSingular";
export const SECTION_COMPETITORS_SUBTITLE_PLURAL =
  "sectionCompetitorsSubtitlePlural";
export const SECTION_SOCIAL_TITLE = "sectionSocialTitle";
export const SECTION_SOCIAL_SUBTITLE_SINGULAR = "sectionSocialSubtitleSingular";
export const SECTION_SOCIAL_SUBTITLE_PLURAL = "sectionSocialSubtitlePlural";
export const SECTION_VOICE_TITLE = "sectionVoiceTitle";
export const SECTION_VOICE_SUBTITLE = "sectionVoiceSubtitle";
export const SECTION_VOICE_TONE_DESCRIPTION = "sectionVoiceToneDescription";
export const SECTION_VOICE_ATTRIBUTES_LABEL = "sectionVoiceAttributesLabel";
export const SECTION_OFFER_TITLE = "sectionOfferTitle";
export const SECTION_OFFER_SUBTITLE = "sectionOfferSubtitle";
export const SECTION_OFFER_TYPE_LABEL = "sectionOfferTypeLabel";
export const SECTION_OFFER_VISUAL_STYLE_LABEL = "sectionOfferVisualStyleLabel";
export const SECTION_OFFER_BUSINESS_VALUE_PROPOSITION_LABEL =
  "sectionOfferBusinessValuePropositionLabel";
export const SECTION_OFFER_DEFAULT_VALUE = "sectionOfferDefaultValue";
export const SECTION_COUNTRY_TITLE = "sectionCountryTitle";
export const SECTION_COUNTRY_SUBTITLE = "sectionCountrySubtitle";
export const SECTION_COUNTRY_LABEL = "sectionCountryLabel";
export const SECTION_COUNTRY_DEFAULT_VALUE = "sectionCountryDefaultValue";
export const SECTION_TYPOGRAPHY_TITLE = "sectionTypographyTitle";
export const SECTION_TYPOGRAPHY_SUBTITLE = "sectionTypographySubtitle";
export const SECTION_TYPOGRAPHY_FONT_FAMILY_LABEL =
  "sectionTypographyFontFamilyLabel";
export const SECTION_TYPOGRAPHY_TITLE_FONT_LABEL =
  "sectionTypographyTitleFontLabel";
export const SECTION_TYPOGRAPHY_SUBTITLE_FONT_LABEL =
  "sectionTypographySubtitleFontLabel";
export const SECTION_TYPOGRAPHY_BODY_FONT_LABEL =
  "sectionTypographyBodyFontLabel";
export const SECTION_TYPOGRAPHY_ADD_TYPOGRAPHY =
  "sectionTypographyAddTypography";
export const SECTION_TYPOGRAPHY_FONT_SIZES_LABEL =
  "sectionTypographyFontSizesLabel";
export const SECTION_TYPOGRAPHY_HEADING_LABEL = "sectionTypographyHeadingLabel";
export const SECTION_TYPOGRAPHY_SUBHEADING_LABEL =
  "sectionTypographySubheadingLabel";
export const SECTION_TYPOGRAPHY_BODY_LABEL = "sectionTypographyBodyLabel";
export const SECTION_TYPOGRAPHY_PX_UNIT = "sectionTypographyPxUnit";
export const SECTION_TYPOGRAPHY_GENERATING_PREVIEW =
  "sectionTypographyGeneratingPreview";
export const SECTION_TYPOGRAPHY_ADD_FONT = "sectionTypographyAddFont";
export const SECTION_LOGO_TITLE = "sectionLogoTitle";
export const SECTION_LOGO_SUBTITLE = "sectionLogoSubtitle";
export const SECTION_COLORS_TITLE = "sectionColorsTitle";
export const SECTION_COLORS_SUBTITLE = "sectionColorsSubtitle";
export const SECTION_COLORS_ADD_COLOR = "sectionColorsAddColor";

export const SECTION_TARGET_AUDIENCE_TITLE = "sectionTargetAudienceTitle";
export const SECTION_TARGET_AUDIENCE_SUBTITLE = "sectionTargetAudienceSubtitle";
export const SECTION_TARGET_AUDIENCE_ICP_LABEL =
  "sectionTargetAudienceIcpLabel";

export const SECTION_PRODUCT_IMAGES_TITLE = "sectionProductImagesTitle";
export const SECTION_PRODUCT_IMAGES_SUBTITLE = "sectionProductImagesSubtitle";
export const BUTTON_UPLOAD_PRODUCT_IMAGES = "buttonUploadProductImages";
export const BUTTON_DELETE_PRODUCT_IMAGE = "buttonDeleteProductImage";

export const SECTION_ADDITIONAL_ASSETS_TITLE = "sectionAdditionalAssetsTitle";
export const SECTION_ADDITIONAL_ASSETS_SUBTITLE =
  "sectionAdditionalAssetsSubtitle";
export const SECTION_ADDITIONAL_ASSETS_PROMPT_LABEL =
  "sectionAdditionalAssetsPromptLabel";
export const SECTION_ADDITIONAL_ASSETS_PROMPT_PLACEHOLDER =
  "sectionAdditionalAssetsPromptPlaceholder";
export const SECTION_ADDITIONAL_ASSETS_PROMPT_REQUIRED =
  "sectionAdditionalAssetsPromptRequired";
export const BUTTON_UPLOAD_ADDITIONAL_ASSET = "buttonUploadAdditionalAsset";
export const SECTION_ADDITIONAL_ASSETS_MAX_ERROR =
  "sectionAdditionalAssetsMaxError";
export const SECTION_ADDITIONAL_ASSETS_ASSET_LABEL =
  "sectionAdditionalAssetsAssetLabel";
export const SECTION_ADDITIONAL_ASSETS_MAX_TOOLTIP =
  "sectionAdditionalAssetsMaxTooltip";
export const SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM =
  "sectionAdditionalAssetsDeleteConfirm";
export const SECTION_ADDITIONAL_ASSETS_DELETE_CONFIRM_TITLE =
  "sectionAdditionalAssetsDeleteConfirmTitle";
export const SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR =
  "sectionAdditionalAssetsIncompletePair";
export const SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_LABEL =
  "sectionAdditionalAssetsIsConditionalLabel";
export const SECTION_ADDITIONAL_ASSETS_IS_CONDITIONAL_HELP =
  "sectionAdditionalAssetsIsConditionalHelp";
export const SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_LABEL =
  "sectionAdditionalAssetsVariableInfoLabel";
export const SECTION_ADDITIONAL_ASSETS_VARIABLE_INFO_HELP =
  "sectionAdditionalAssetsVariableInfoHelp";
export const SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_LABEL =
  "sectionAdditionalAssetsVariantGroupLabel";
export const SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_HELP =
  "sectionAdditionalAssetsVariantGroupHelp";
export const SECTION_ADDITIONAL_ASSETS_VARIANT_GROUP_PLACEHOLDER =
  "sectionAdditionalAssetsVariantGroupPlaceholder";
export const MODAL_ADDITIONAL_ASSET_TITLE = "modalAdditionalAssetTitle";
export const BUTTON_CHANGE_ADDITIONAL_ASSET_IMAGE =
  "buttonChangeAdditionalAssetImage";

export const SECTION_BUYER_PERSONA_TITLE = "sectionBuyerPersonaTitle";
export const SECTION_BUYER_PERSONA_SUBTITLE = "sectionBuyerPersonaSubtitle";
export const SECTION_BUYER_PERSONA_LABEL = "sectionBuyerPersonaLabel";
export const SECTION_BUYER_PERSONA_PLACEHOLDER_NAME =
  "sectionBuyerPersonaPlaceholderName";
export const SECTION_BUYER_PERSONA_PLACEHOLDER_DESCRIPTION =
  "sectionBuyerPersonaPlaceholderDescription";

// CREDIT REWARD MODAL
export const LINKEDIN_ARTICLE_DEFAULT_TEXT = "linkedInArticleDefaultText";
export const CREDIT_REWARD_MODAL_TITLE = "creditRewardModalTitle";
export const CREDIT_REWARD_MODAL_SUBTITLE = "creditRewardModalSubtitle";
export const CREDIT_REWARD_MODAL_ARIA_LABEL = "creditRewardModalAriaLabel";
export const CREDIT_REWARD_MODAL_BUTTON_TEXT = "creditRewardModalButtonText";
export const CREDIT_REWARD_MODAL_REWARD = "creditRewardModalReward";
export const CREDIT_REWARD_MODAL_REWARD_DESCRIPTION =
  "creditRewardModalRewardDescription";
export const CREDIT_REWARD_MODAL_ARTICLE_CONTENT_LABEL =
  "creditRewardModalArticleContentLabel";
export const CREDIT_REWARD_MODAL_ARTICLE_CONTENT_PLACEHOLDER =
  "creditRewardModalArticleContentPlaceholder";
export const CREDIT_REWARD_MODAL_VERIFICATION_NOTICE =
  "creditRewardModalVerificationNotice";
export const CREDIT_REWARD_MODAL_BUTTON_CANCEL =
  "creditRewardModalButtonCancel";
export const CREDIT_REWARD_MODAL_BUTTON_PUBLISH =
  "creditRewardModalButtonPublish";
export const CREDIT_REWARD_MODAL_BUTTON_PUBLISHING =
  "creditRewardModalButtonPublishing";
export const CREDIT_REWARD_MODAL_BUTTON_RETRY = "creditRewardModalButtonRetry";
export const CREDIT_REWARD_MODAL_LOADING_TITLE =
  "creditRewardModalLoadingTitle";
export const CREDIT_REWARD_MODAL_LOADING_DESCRIPTION =
  "creditRewardModalLoadingDescription";
export const CREDIT_REWARD_MODAL_SUCCESS_TITLE =
  "creditRewardModalSuccessTitle";
export const CREDIT_REWARD_MODAL_SUCCESS_TEXT = "creditRewardModalSuccessText";
export const CREDIT_REWARD_MODAL_ERROR_TITLE = "creditRewardModalErrorTitle";
export const CREDIT_REWARD_MODAL_ERROR_TEXT = "creditRewardModalErrorText";

export const BRAND_SETUP_SECTION_BRAND_NAME = "brandSetupSectionBrandName";
export const BRAND_SETUP_SECTION_BRAND_NAME_PLACEHOLDER =
  "brandSetupSectionBrandNamePlaceholder";
export const BRAND_SETUP_SECTION_BRAND_DESCRIPTION =
  "brandSetupSectionBrandDescription";
export const BRAND_SETUP_SECTION_BRAND_DESCRIPTION_PLACEHOLDER =
  "brandSetupSectionBrandDescriptionPlaceholder";

export const FILTERS_GALLERY_CAROUSEL = "filtersGalleryCarousel";
export const GALLERY_CREATE_CAROUSEL = "galleryCreateCarousel";
export const FILTERS_GALLERY_FEED = "filtersGalleryFeed";
export const MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL =
  "modalCreateWithIAMediaTypeCarousel";
export const MODAL_UPLOAD_TIKTOK_TYPE_VIDEO_LABEL =
  "modalUploadTiktokVideoLabel";

// MODAL EDIT URL PARAMETERS
export const MODAL_EDIT_URL_PARAMETERS_TITLE = "modalEditUrlParametersTitle";
export const MODAL_EDIT_URL_PARAMETERS_DESCRIPTION =
  "modalEditUrlParametersDescription";
export const MODAL_EDIT_URL_PARAMETERS_UTM_SECTION_LABEL =
  "modalEditUrlParametersUtmSectionLabel";
export const MODAL_EDIT_URL_PARAMETERS_CUSTOM_SECTION_LABEL =
  "modalEditUrlParametersCustomSectionLabel";
export const MODAL_EDIT_URL_PARAMETERS_PREVIEW_LABEL =
  "modalEditUrlParametersPreviewLabel";
export const MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_NAME =
  "modalEditUrlParametersEnterParamName";
export const MODAL_EDIT_URL_PARAMETERS_ENTER_PARAM_VALUE =
  "modalEditUrlParametersEnterParamValue";
export const MODAL_EDIT_URL_PARAMETERS_CONFIGURED =
  "modalEditUrlParametersConfigured";
export const MODAL_EDIT_URL_PARAMETERS_BUTTON_APPLY =
  "modalEditUrlParametersButtonApply";
export const MODAL_EDIT_URL_PARAMETERS_BUTTON_CONFIGURE =
  "modalEditUrlParametersButtonConfigure";
export const MODAL_EDIT_URL_PARAMETERS_CUSTOM_KEY_RESERVED =
  "modalEditUrlParametersCustomKeyReserved";
export const MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL =
  "modalEditUrlParametersBuildLabel";
export const URL_EXAMPLE_PLACEHOLDER = "urlExamplePlaceholder";

// Modal Feedback
export const MODAL_FEEDBACK_TITLE = "modalFeedbackTitle";
export const MODAL_FEEDBACK_DESCRIPTION = "modalFeedbackDescription";
export const MODAL_FEEDBACK_PLACEHOLDER = "modalFeedbackPlaceholder";
export const MODAL_FEEDBACK_LIKE_LABEL = "modalFeedbackLikeLabel";
export const MODAL_FEEDBACK_DISLIKE_LABEL = "modalFeedbackDislikeLabel";
export const MODAL_REPORT_CONTENT_TITLE = "modalReportContentTitle";
export const MODAL_REPORT_CONTENT_DESCRIPTION = "modalReportContentDescription";
export const MODAL_REPORT_CONTENT_PLACEHOLDER = "modalReportContentPlaceholder";
export const MODAL_REPORT_CONTENT_SUCCESS = "modalReportContentSuccess";
export const BUTTON_REPORT_CONTENT = "buttonReportContent";

// COUNTRIES
export const COUNTRY_ANDORRA = "countryAndorra";
export const COUNTRY_UNITED_ARAB_EMIRATES = "countryUnitedArabEmirates";
export const COUNTRY_AFGHANISTAN = "countryAfghanistan";
export const COUNTRY_ANTIGUA_AND_BARBUDA = "countryAntiguaAndBarbuda";
export const COUNTRY_ANGUILLA = "countryAnguilla";
export const COUNTRY_ALBANIA = "countryAlbania";
export const COUNTRY_ARMENIA = "countryArmenia";
export const COUNTRY_ANGOLA = "countryAngola";
export const COUNTRY_ANTARCTICA = "countryAntarctica";
export const COUNTRY_ARGENTINA = "countryArgentina";
export const COUNTRY_AMERICAN_SAMOA = "countryAmericanSamoa";
export const COUNTRY_AUSTRIA = "countryAustria";
export const COUNTRY_AUSTRALIA = "countryAustralia";
export const COUNTRY_ARUBA = "countryAruba";
export const COUNTRY_ALLAND_ISLANDS = "countryAllandIslands";
export const COUNTRY_AZERBAIJAN = "countryAzerbaijan";
export const COUNTRY_BOSNIA_AND_HERZEGOVINA = "countryBosniaAndHerzegovina";
export const COUNTRY_BARBADOS = "countryBarbados";
export const COUNTRY_BANGLADESH = "countryBangladesh";
export const COUNTRY_BELGIUM = "countryBelgium";
export const COUNTRY_BURKINA_FASO = "countryBurkinaFaso";
export const COUNTRY_BULGARIA = "countryBulgaria";
export const COUNTRY_BAHRAIN = "countryBahrain";
export const COUNTRY_BURUNDI = "countryBurundi";
export const COUNTRY_BENIN = "countryBenin";
export const COUNTRY_SAINT_BARTHELEMY = "countrySaintBarthelemy";
export const COUNTRY_BERMUDA = "countryBermuda";
export const COUNTRY_BRUNEI_DARUSSALAM = "countryBruneiDarussalam";
export const COUNTRY_BOLIVIA = "countryBolivia";
export const COUNTRY_BRAZIL = "countryBrazil";
export const COUNTRY_BAHAMAS = "countryBahamas";
export const COUNTRY_BHUTAN = "countryBhutan";
export const COUNTRY_BOUVET_ISLAND = "countryBouvetIsland";
export const COUNTRY_BOTSWANA = "countryBotswana";
export const COUNTRY_BELARUS = "countryBelarus";
export const COUNTRY_BELIZE = "countryBelize";
export const COUNTRY_CANADA = "countryCanada";
export const COUNTRY_COCOS_KEELING_ISLANDS = "countryCocosKeelingIslands";
export const COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE =
  "countryCongoDemocraticRepublicOfThe";
export const COUNTRY_CENTRAL_AFRICAN_REPUBLIC = "countryCentralAfricanRepublic";
export const COUNTRY_CONGO_REPUBLIC_OF_THE = "countryCongoRepublicOfThe";
export const COUNTRY_SWITZERLAND = "countrySwitzerland";
export const COUNTRY_COTE_D_IVOIRE = "countryCoteDIvoire";
export const COUNTRY_COOK_ISLANDS = "countryCookIslands";
export const COUNTRY_CHILE = "countryChile";
export const COUNTRY_CAMEROON = "countryCameroon";
export const COUNTRY_CHINA = "countryChina";
export const COUNTRY_COLOMBIA = "countryColombia";
export const COUNTRY_COSTA_RICA = "countryCostaRica";
export const COUNTRY_CUBA = "countryCuba";
export const COUNTRY_CAPE_VERDE = "countryCapeVerde";
export const COUNTRY_CURACAO = "countryCuracao";
export const COUNTRY_CHRISTMAS_ISLAND = "countryChristmasIsland";
export const COUNTRY_CYPRUS = "countryCyprus";
export const COUNTRY_CZECH_REPUBLIC = "countryCzechRepublic";
export const COUNTRY_GERMANY = "countryGermany";
export const COUNTRY_DJIBOUTI = "countryDjibouti";
export const COUNTRY_DENMARK = "countryDenmark";
export const COUNTRY_DOMINICA = "countryDominica";
export const COUNTRY_DOMINICAN_REPUBLIC = "countryDominicanRepublic";
export const COUNTRY_ALGERIA = "countryAlgeria";
export const COUNTRY_ECUADOR = "countryEcuador";
export const COUNTRY_ESTONIA = "countryEstonia";
export const COUNTRY_EGYPT = "countryEgypt";
export const COUNTRY_WESTERN_SAHARA = "countryWesternSahara";
export const COUNTRY_ERITREA = "countryEritrea";
export const COUNTRY_SPAIN = "countrySpain";
export const COUNTRY_ETHIOPIA = "countryEthiopia";
export const COUNTRY_FINLAND = "countryFinland";
export const COUNTRY_FIJI = "countryFiji";
export const COUNTRY_FALKLAND_ISLANDS_MALVINAS =
  "countryFalklandIslandsMalvinas";
export const COUNTRY_MICRONESIA_FEDERATED_STATES_OF =
  "countryMicronesiaFederatedStatesOf";
export const COUNTRY_FAROE_ISLANDS = "countryFaroeIslands";
export const COUNTRY_FRANCE = "countryFrance";
export const COUNTRY_GABON = "countryGabon";
export const COUNTRY_UNITED_KINGDOM = "countryUnitedKingdom";
export const COUNTRY_GRENADA = "countryGrenada";
export const COUNTRY_GEORGIA = "countryGeorgia";
export const COUNTRY_FRENCH_GUIANA = "countryFrenchGuiana";
export const COUNTRY_GUERNSEY = "countryGuernsey";
export const COUNTRY_GHANA = "countryGhana";
export const COUNTRY_GIBRALTAR = "countryGibraltar";
export const COUNTRY_GREENLAND = "countryGreenland";
export const COUNTRY_GAMBIA = "countryGambia";
export const COUNTRY_GUINEA = "countryGuinea";
export const COUNTRY_GUADELOUPE = "countryGuadeloupe";
export const COUNTRY_EQUATORIAL_GUINEA = "countryEquatorialGuinea";
export const COUNTRY_GREECE = "countryGreece";
export const COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS =
  "countrySouthGeorgiaAndTheSouthSandwichIslands";
export const COUNTRY_GUATEMALA = "countryGuatemala";
export const COUNTRY_GUAM = "countryGuam";
export const COUNTRY_GUINEA_BISSAU = "countryGuineaBissau";
export const COUNTRY_GUYANA = "countryGuyana";
export const COUNTRY_HONG_KONG = "countryHongKong";
export const COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS =
  "countryHeardIslandAndMcDonaldIslands";
export const COUNTRY_HONDURAS = "countryHonduras";
export const COUNTRY_CROATIA = "countryCroatia";
export const COUNTRY_HAITI = "countryHaiti";
export const COUNTRY_HUNGARY = "countryHungary";
export const COUNTRY_INDONESIA = "countryIndonesia";
export const COUNTRY_IRELAND = "countryIreland";
export const COUNTRY_ISRAEL = "countryIsrael";
export const COUNTRY_ISLE_OF_MAN = "countryIsleOfMan";
export const COUNTRY_INDIA = "countryIndia";
export const COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY =
  "countryBritishIndianOceanTerritory";
export const COUNTRY_IRAQ = "countryIraq";
export const COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF = "countryIranIslamicRepublicOf";
export const COUNTRY_ICELAND = "countryIceland";
export const COUNTRY_ITALY = "countryItaly";
export const COUNTRY_JERSEY = "countryJersey";
export const COUNTRY_JAMAICA = "countryJamaica";
export const COUNTRY_JORDAN = "countryJordan";
export const COUNTRY_JAPAN = "countryJapan";
export const COUNTRY_KENYA = "countryKenya";
export const COUNTRY_KYRGYZSTAN = "countryKyrgyzstan";
export const COUNTRY_CAMBODIA = "countryCambodia";
export const COUNTRY_KIRIBATI = "countryKiribati";
export const COUNTRY_COMOROS = "countryComoros";
export const COUNTRY_SAINT_KITTS_AND_NEVIS = "countrySaintKittsAndNevis";
export const COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF =
  "countryKoreaDemocraticPeoplesRepublicOf";
export const COUNTRY_KOREA_REPUBLIC_OF = "countryKoreaRepublicOf";
export const COUNTRY_KUWAIT = "countryKuwait";
export const COUNTRY_CAYMAN_ISLANDS = "countryCaymanIslands";
export const COUNTRY_KAZAKHSTAN = "countryKazakhstan";
export const COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC =
  "countryLaoPeoplesDemocraticRepublic";
export const COUNTRY_LEBANON = "countryLebanon";
export const COUNTRY_SAINT_LUCIA = "countrySaintLucia";
export const COUNTRY_LIECHTENSTEIN = "countryLiechtenstein";
export const COUNTRY_SRI_LANKA = "countrySriLanka";
export const COUNTRY_LIBERIA = "countryLiberia";
export const COUNTRY_LESOTHO = "countryLesotho";
export const COUNTRY_LITHUANIA = "countryLithuania";
export const COUNTRY_LUXEMBOURG = "countryLuxembourg";
export const COUNTRY_LATVIA = "countryLatvia";
export const COUNTRY_LIBYA = "countryLibya";
export const COUNTRY_MOROCCO = "countryMorocco";
export const COUNTRY_MONACO = "countryMonaco";
export const COUNTRY_MOLDOVA_REPUBLIC_OF = "countryMoldovaRepublicOf";
export const COUNTRY_MONTENEGRO = "countryMontenegro";
export const COUNTRY_SAINT_MARTIN_FRENCH_PART = "countrySaintMartinFrenchPart";
export const COUNTRY_MADAGASCAR = "countryMadagascar";
export const COUNTRY_MARSHALL_ISLANDS = "countryMarshallIslands";
export const COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF =
  "countryMacedoniaTheFormerYugoslavRepublicOf";
export const COUNTRY_MALI = "countryMali";
export const COUNTRY_MYANMAR = "countryMyanmar";
export const COUNTRY_MONGOLIA = "countryMongolia";
export const COUNTRY_MACAO = "countryMacao";
export const COUNTRY_NORTHERN_MARIANA_ISLANDS = "countryNorthernMarianaIslands";
export const COUNTRY_MARTINIQUE = "countryMartinique";
export const COUNTRY_MAURITANIA = "countryMauritania";
export const COUNTRY_MONTSERRAT = "countryMontserrat";
export const COUNTRY_MALTA = "countryMalta";
export const COUNTRY_MAURITIUS = "countryMauritius";
export const COUNTRY_MALDIVES = "countryMaldives";
export const COUNTRY_MALAWI = "countryMalawi";
export const COUNTRY_MEXICO = "countryMexico";
export const COUNTRY_MALAYSIA = "countryMalaysia";
export const COUNTRY_MOZAMBIQUE = "countryMozambique";
export const COUNTRY_NAMIBIA = "countryNamibia";
export const COUNTRY_NEW_CALEDONIA = "countryNewCaledonia";
export const COUNTRY_NIGER = "countryNiger";
export const COUNTRY_NORFOLK_ISLAND = "countryNorfolkIsland";
export const COUNTRY_NIGERIA = "countryNigeria";
export const COUNTRY_NICARAGUA = "countryNicaragua";
export const COUNTRY_NETHERLANDS = "countryNetherlands";
export const COUNTRY_NORWAY = "countryNorway";
export const COUNTRY_NEPAL = "countryNepal";
export const COUNTRY_NAURU = "countryNauru";
export const COUNTRY_NIUE = "countryNiue";
export const COUNTRY_NEW_ZEALAND = "countryNewZealand";
export const COUNTRY_OMAN = "countryOman";
export const COUNTRY_PANAMA = "countryPanama";
export const COUNTRY_PERU = "countryPeru";
export const COUNTRY_FRENCH_POLYNESIA = "countryFrenchPolynesia";
export const COUNTRY_PAPUA_NEW_GUINEA = "countryPapuaNewGuinea";
export const COUNTRY_PHILIPPINES = "countryPhilippines";
export const COUNTRY_PAKISTAN = "countryPakistan";
export const COUNTRY_POLAND = "countryPoland";
export const COUNTRY_SAINT_PIERRE_AND_MIQUELON =
  "countrySaintPierreAndMiquelon";
export const COUNTRY_PITCAIRN = "countryPitcairn";
export const COUNTRY_PUERTO_RICO = "countryPuertoRico";
export const COUNTRY_PALESTINE_STATE_OF = "countryPalestineStateOf";
export const COUNTRY_PORTUGAL = "countryPortugal";
export const COUNTRY_PALAU = "countryPalau";
export const COUNTRY_PARAGUAY = "countryParaguay";
export const COUNTRY_QATAR = "countryQatar";
export const COUNTRY_REUNION = "countryReunion";
export const COUNTRY_ROMANIA = "countryRomania";
export const COUNTRY_SERBIA = "countrySerbia";
export const COUNTRY_RUSSIAN_FEDERATION = "countryRussianFederation";
export const COUNTRY_RWANDA = "countryRwanda";
export const COUNTRY_SAUDI_ARABIA = "countrySaudiArabia";
export const COUNTRY_SOLOMON_ISLANDS = "countrySolomonIslands";
export const COUNTRY_SEYCHELLES = "countrySeychelles";
export const COUNTRY_SUDAN = "countrySudan";
export const COUNTRY_SWEDEN = "countrySweden";
export const COUNTRY_SINGAPORE = "countrySingapore";
export const COUNTRY_SAINT_HELENA = "countrySaintHelena";
export const COUNTRY_SLOVENIA = "countrySlovenia";
export const COUNTRY_SVALBARD_AND_JAN_MAYEN = "countrySvalbardAndJanMayen";
export const COUNTRY_SLOVAKIA = "countrySlovakia";
export const COUNTRY_SIERRA_LEONE = "countrySierraLeone";
export const COUNTRY_SAN_MARINO = "countrySanMarino";
export const COUNTRY_SENEGAL = "countrySenegal";
export const COUNTRY_SOMALIA = "countrySomalia";
export const COUNTRY_SURINAME = "countrySuriname";
export const COUNTRY_SOUTH_SUDAN = "countrySouthSudan";
export const COUNTRY_SAO_TOME_AND_PRINCIPE = "countrySaoTomeAndPrincipe";
export const COUNTRY_EL_SALVADOR = "countryElSalvador";
export const COUNTRY_SINT_MAARTEN_DUTCH_PART = "countrySintMaartenDutchPart";
export const COUNTRY_SYRIAN_ARAB_REPUBLIC = "countrySyrianArabRepublic";
export const COUNTRY_SWAZILAND = "countrySwaziland";
export const COUNTRY_TURKS_AND_CAICOS_ISLANDS = "countryTurksAndCaicosIslands";
export const COUNTRY_CHAD = "countryChad";
export const COUNTRY_FRENCH_SOUTHERN_TERRITORIES =
  "countryFrenchSouthernTerritories";
export const COUNTRY_TOGO = "countryTogo";
export const COUNTRY_THAILAND = "countryThailand";
export const COUNTRY_TAJIKISTAN = "countryTajikistan";
export const COUNTRY_TOKELAU = "countryTokelau";
export const COUNTRY_TIMOR_LESTE = "countryTimorLeste";
export const COUNTRY_TURKMENISTAN = "countryTurkmenistan";
export const COUNTRY_TUNISIA = "countryTunisia";
export const COUNTRY_TONGA = "countryTonga";
export const COUNTRY_TURKEY = "countryTurkey";
export const COUNTRY_TRINIDAD_AND_TOBAGO = "countryTrinidadAndTobago";
export const COUNTRY_TUVALU = "countryTuvalu";
export const COUNTRY_TAIWAN = "countryTaiwan";
export const COUNTRY_UNITED_REPUBLIC_OF_TANZANIA =
  "countryUnitedRepublicOfTanzania";
export const COUNTRY_UKRAINE = "countryUkraine";
export const COUNTRY_UGANDA = "countryUganda";
export const COUNTRY_UNITED_STATES = "countryUnitedStates";
export const COUNTRY_URUGUAY = "countryUruguay";
export const COUNTRY_UZBEKISTAN = "countryUzbekistan";
export const COUNTRY_HOLY_SEE_VATICAN_CITY_STATE =
  "countryHolySeeVaticanCityState";
export const COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES =
  "countrySaintVincentAndTheGrenadines";
export const COUNTRY_VENEZUELA = "countryVenezuela";
export const COUNTRY_BRITISH_VIRGIN_ISLANDS = "countryBritishVirginIslands";
export const COUNTRY_US_VIRGIN_ISLANDS = "countryUsVirginIslands";
export const COUNTRY_VIETNAM = "countryVietnam";
export const COUNTRY_VANUATU = "countryVanuatu";
export const COUNTRY_WALLIS_AND_FUTUNA = "countryWallisAndFutuna";
export const COUNTRY_SAMOA = "countrySamoa";
export const COUNTRY_KOSOVO = "countryKosovo";
export const COUNTRY_YEMEN = "countryYemen";
export const COUNTRY_MAYOTTE = "countryMayotte";
export const COUNTRY_SOUTH_AFRICA = "countrySouthAfrica";
export const COUNTRY_ZAMBIA = "countryZambia";
export const COUNTRY_ZIMBABWE = "countryZimbabwe";

// MODAL CREDITS USAGE DETAILED
export const MODAL_CREDITS_USAGE_DETAILED_TITLE =
  "modalCreditsUsageDetailedTitle";
export const MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL =
  "modalCreditsUsageDetailedAriaLabel";
export const MODAL_CREDITS_USAGE_DETAILED_LINK =
  "modalCreditsUsageDetailedLink";
export const MODAL_CREDITS_USAGE_DETAILED_PERIOD =
  "modalCreditsUsageDetailedPeriod";
export const MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_ADVERTISER_TITLE =
  "modalCreditsUsageDetailedTableByAdvertiserTitle";
export const MODAL_CREDITS_USAGE_DETAILED_TABLE_BY_USER_TITLE =
  "modalCreditsUsageDetailedTableByUserTitle";
export const MODAL_CREDITS_USAGE_DETAILED_COLUMN_ADVERTISER =
  "modalCreditsUsageDetailedColumnAdvertiser";
export const MODAL_CREDITS_USAGE_DETAILED_COLUMN_USER =
  "modalCreditsUsageDetailedColumnUser";
export const MODAL_CREDITS_USAGE_DETAILED_COLUMN_CREDITS_SPENT =
  "modalCreditsUsageDetailedColumnCreditsSpent";
export const MODAL_CREDITS_USAGE_DETAILED_COLUMN_VIDEOS_SPENT =
  "modalCreditsUsageDetailedColumnVideosSpent";
export const MODAL_CREDITS_USAGE_DETAILED_LOADING =
  "modalCreditsUsageDetailedLoading";
export const MODAL_CREDITS_USAGE_DETAILED_EMPTY =
  "modalCreditsUsageDetailedEmpty";
export const MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_TOTAL_CREDITS =
  "modalCreditsUsageDetailedSuperAdminTotalCredits";
export const MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CREDITS_BY_GROUP_TITLE =
  "modalCreditsUsageDetailedSuperAdminCreditsByGroupTitle";
export const MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_CREDITS =
  "modalCreditsUsageDetailedSuperAdminGroupCredits";
export const MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_GROUP_ACCORDION_TITLE =
  "modalCreditsUsageDetailedSuperAdminGroupAccordionTitle";
export const MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_EMPTY_GROUPS =
  "modalCreditsUsageDetailedSuperAdminEmptyGroups";
export const MODAL_CREDITS_USAGE_DETAILED_SUPER_ADMIN_CALCULATING =
  "modalCreditsUsageDetailedSuperAdminCalculating";

// PRE-ACTIVACIÓN (onboarding form)
export const PRE_ACTIVATION_BADGE = "preActivationBadge";
export const PRE_ACTIVATION_SECTION_01_BUSINESS =
  "preActivationSection01Business";
export const PRE_ACTIVATION_SECTION_02_CURRENT_ADS =
  "preActivationSection02CurrentAds";
export const PRE_ACTIVATION_SECTION_03_OBJECTIVES =
  "preActivationSection03Objectives";
export const PRE_ACTIVATION_SECTION_04_MEETING_ACCESS =
  "preActivationSection04MeetingAccess";
export const PRE_ACTIVATION_HERO_TITLE = "preActivationHeroTitle";
export const PRE_ACTIVATION_HERO_DESCRIPTION = "preActivationHeroDescription";
export const PRE_ACTIVATION_HERO_DESCRIPTION_AGENCY =
  "preActivationHeroDescriptionAgency";
export const PRE_ACTIVATION_FIELD_BUSINESS_NAME =
  "preActivationFieldBusinessName";
export const PRE_ACTIVATION_FIELD_AGENCY_NAME = "preActivationFieldAgencyName";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_NAME =
  "preActivationPlaceholderAgencyName";
export const PRE_ACTIVATION_FIELD_FULL_NAME = "preActivationFieldFullName";
export const PRE_ACTIVATION_FIELD_EMAIL = "preActivationFieldEmail";
export const PRE_ACTIVATION_FIELD_WHATSAPP = "preActivationFieldWhatsapp";
export const PRE_ACTIVATION_FIELD_WHAT_YOU_SELL =
  "preActivationFieldWhatYouSell";
export const PRE_ACTIVATION_HINT_WHAT_YOU_SELL = "preActivationHintWhatYouSell";
export const PRE_ACTIVATION_FIELD_AVERAGE_PRICE =
  "preActivationFieldAveragePrice";
export const PRE_ACTIVATION_HINT_AVERAGE_PRICE =
  "preActivationHintAveragePrice";
export const PRE_ACTIVATION_FIELD_IDEAL_CUSTOMER =
  "preActivationFieldIdealCustomer";
export const PRE_ACTIVATION_HINT_IDEAL_CUSTOMER =
  "preActivationHintIdealCustomer";
export const PRE_ACTIVATION_FIELD_WHERE_CUSTOMER_BUYS =
  "preActivationFieldWhereCustomerBuys";
export const PRE_ACTIVATION_FIELD_WEBSITE_URL = "preActivationFieldWebsiteUrl";
export const PRE_ACTIVATION_PLACEHOLDER_BUSINESS_NAME =
  "preActivationPlaceholderBusinessName";
export const PRE_ACTIVATION_PLACEHOLDER_FULL_NAME =
  "preActivationPlaceholderFullName";
export const PRE_ACTIVATION_PLACEHOLDER_EMAIL = "preActivationPlaceholderEmail";
export const PRE_ACTIVATION_PLACEHOLDER_WHATSAPP =
  "preActivationPlaceholderWhatsapp";
export const PRE_ACTIVATION_PLACEHOLDER_WHAT_YOU_SELL =
  "preActivationPlaceholderWhatYouSell";
export const PRE_ACTIVATION_PLACEHOLDER_AVERAGE_PRICE =
  "preActivationPlaceholderAveragePrice";
export const PRE_ACTIVATION_PLACEHOLDER_IDEAL_CUSTOMER =
  "preActivationPlaceholderIdealCustomer";
export const PRE_ACTIVATION_PLACEHOLDER_WEBSITE_URL =
  "preActivationPlaceholderWebsiteUrl";
export const PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB =
  "preActivationSalesChannelTiendaWeb";
export const PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA =
  "preActivationSalesChannelTiendaFisica";
export const PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP =
  "preActivationSalesChannelWhatsapp";
export const PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE =
  "preActivationSalesChannelMarketplace";
export const PRE_ACTIVATION_SALES_CHANNEL_APP = "preActivationSalesChannelApp";
export const PRE_ACTIVATION_FIELD_HAS_ADS = "preActivationFieldHasAds";
export const PRE_ACTIVATION_HAS_ADS_SI = "preActivationHasAdsSi";
export const PRE_ACTIVATION_HAS_ADS_ANTES = "preActivationHasAdsAntes";
export const PRE_ACTIVATION_HAS_ADS_NO = "preActivationHasAdsNo";
export const PRE_ACTIVATION_FIELD_AD_PLATFORMS =
  "preActivationFieldAdPlatforms";
export const PRE_ACTIVATION_ADS_PLATFORM_META = "preActivationAdsPlatformMeta";
export const PRE_ACTIVATION_ADS_PLATFORM_GOOGLE =
  "preActivationAdsPlatformGoogle";
export const PRE_ACTIVATION_ADS_PLATFORM_TIKTOK =
  "preActivationAdsPlatformTiktok";
export const PRE_ACTIVATION_ADS_PLATFORM_OTHER =
  "preActivationAdsPlatformOther";
export const PRE_ACTIVATION_PLACEHOLDER_ADS_PLATFORM_OTHER =
  "preActivationPlaceholderAdsPlatformOther";
export const PRE_ACTIVATION_FIELD_MONTHLY_AD_SPEND =
  "preActivationFieldMonthlyAdSpend";
export const PRE_ACTIVATION_HINT_MONTHLY_AD_SPEND =
  "preActivationHintMonthlyAdSpend";
export const PRE_ACTIVATION_FIELD_CURRENT_METRICS =
  "preActivationFieldCurrentMetrics";
export const PRE_ACTIVATION_HINT_CURRENT_METRICS =
  "preActivationHintCurrentMetrics";
export const PRE_ACTIVATION_FIELD_TARGET_CPA = "preActivationFieldTargetCpa";
export const PRE_ACTIVATION_HINT_TARGET_CPA = "preActivationHintTargetCpa";
export const PRE_ACTIVATION_FIELD_BEST_CAMPAIGN_MESSAGES =
  "preActivationFieldBestCampaignMessages";
export const PRE_ACTIVATION_HINT_BEST_CAMPAIGN_MESSAGES =
  "preActivationHintBestCampaignMessages";
export const PRE_ACTIVATION_PLACEHOLDER_MONTHLY_AD_SPEND =
  "preActivationPlaceholderMonthlyAdSpend";
export const PRE_ACTIVATION_PLACEHOLDER_CURRENT_METRICS =
  "preActivationPlaceholderCurrentMetrics";
export const PRE_ACTIVATION_PLACEHOLDER_TARGET_CPA =
  "preActivationPlaceholderTargetCpa";
export const PRE_ACTIVATION_PLACEHOLDER_BEST_CAMPAIGN_MESSAGES =
  "preActivationPlaceholderBestCampaignMessages";
export const PRE_ACTIVATION_FIELD_MONTHLY_SALES =
  "preActivationFieldMonthlySales";
export const PRE_ACTIVATION_FIELD_SALES_GOAL_60_90 =
  "preActivationFieldSalesGoal6090";
export const PRE_ACTIVATION_FIELD_BUZZLY_FOCUS =
  "preActivationFieldBuzzlyFocus";
export const PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE =
  "preActivationBuzzlyFocusPerformance";
export const PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO =
  "preActivationBuzzlyFocusContenido";
export const PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS =
  "preActivationBuzzlyFocusAmbos";
export const PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LEVEL =
  "preActivationFieldCreativeMaterialLevel";
export const PRE_ACTIVATION_HINT_CREATIVE_MATERIAL_LEVEL =
  "preActivationHintCreativeMaterialLevel";
export const PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO =
  "preActivationCreativeMaterialSiMucho";
export const PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO =
  "preActivationCreativeMaterialSiPoco";
export const PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA =
  "preActivationCreativeMaterialNoIa";
export const PRE_ACTIVATION_FIELD_CREATIVE_MATERIAL_LOCATION =
  "preActivationFieldCreativeMaterialLocation";
export const PRE_ACTIVATION_FIELD_ADDITIONAL_MEETING_NOTES =
  "preActivationFieldAdditionalMeetingNotes";
export const PRE_ACTIVATION_PLACEHOLDER_MONTHLY_SALES =
  "preActivationPlaceholderMonthlySales";
export const PRE_ACTIVATION_PLACEHOLDER_SALES_GOAL_60_90 =
  "preActivationPlaceholderSalesGoal6090";
export const PRE_ACTIVATION_PLACEHOLDER_CREATIVE_MATERIAL_LOCATION =
  "preActivationPlaceholderCreativeMaterialLocation";
export const PRE_ACTIVATION_PLACEHOLDER_ADDITIONAL_MEETING_NOTES =
  "preActivationPlaceholderAdditionalMeetingNotes";
export const PRE_ACTIVATION_MEETING_INTRO = "preActivationMeetingIntro";
export const PRE_ACTIVATION_FIELD_MEETING_ACCESS =
  "preActivationFieldMeetingAccess";
export const PRE_ACTIVATION_MEETING_ACCESS_META_BM =
  "preActivationMeetingAccessMetaBm";
export const PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS =
  "preActivationMeetingAccessGoogleAds";
export const PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS =
  "preActivationMeetingAccessTiktokAds";
export const PRE_ACTIVATION_MEETING_ACCESS_GA4 =
  "preActivationMeetingAccessGa4";
export const PRE_ACTIVATION_MEETING_ACCESS_PIXEL =
  "preActivationMeetingAccessPixel";
export const PRE_ACTIVATION_MEETING_ACCESS_GTM =
  "preActivationMeetingAccessGtm";
export const PRE_ACTIVATION_FIELD_ACCESS_NOT_READY =
  "preActivationFieldAccessNotReady";
export const PRE_ACTIVATION_HINT_ACCESS_NOT_READY =
  "preActivationHintAccessNotReady";
export const PRE_ACTIVATION_PLACEHOLDER_ACCESS_NOT_READY =
  "preActivationPlaceholderAccessNotReady";
export const PRE_ACTIVATION_ARIA_REQUIRED = "preActivationAriaRequired";
export const PRE_ACTIVATION_SUBMIT_BUTTON = "preActivationSubmitButton";
export const PRE_ACTIVATION_SUBMIT_SUCCESS_TITLE =
  "preActivationSubmitSuccessTitle";
export const PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE =
  "preActivationSubmitSuccessMessage";
export const PRE_ACTIVATION_CONFIDENTIALITY_NOTE =
  "preActivationConfidentialityNote";
export const PRE_ACTIVATION_FIELD_ORGANIZATION_TYPE =
  "preActivationFieldOrganizationType";
export const PRE_ACTIVATION_HINT_ORGANIZATION_TYPE =
  "preActivationHintOrganizationType";
export const PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL =
  "preActivationOrganizationTypeAgencyLabel";
export const PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL =
  "preActivationOrganizationTypeBrandLabel";
export const PRE_ACTIVATION_SECTION_CONTACT = "preActivationSectionContact";
export const PRE_ACTIVATION_FIELD_JOB_TITLE = "preActivationFieldJobTitle";
export const PRE_ACTIVATION_PLACEHOLDER_JOB_TITLE =
  "preActivationPlaceholderJobTitle";
export const PRE_ACTIVATION_SECTION_AGENCY_01_BASICS =
  "preActivationSectionAgency01Basics";
export const PRE_ACTIVATION_SECTION_AGENCY_02_LIVE_EXERCISE =
  "preActivationSectionAgency02LiveExercise";
export const PRE_ACTIVATION_SECTION_AGENCY_03_OPERATIONS =
  "preActivationSectionAgency03Operations";
export const PRE_ACTIVATION_SECTION_AGENCY_04_MEETING_ACCESS =
  "preActivationSectionAgency04MeetingAccess";
export const PRE_ACTIVATION_FIELD_AGENCY_PLATFORM_USERS_COUNT =
  "preActivationFieldAgencyPlatformUsersCount";
export const PRE_ACTIVATION_HINT_AGENCY_PLATFORM_USERS_COUNT =
  "preActivationHintAgencyPlatformUsersCount";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_PLATFORM_USERS_COUNT =
  "preActivationPlaceholderAgencyPlatformUsersCount";
export const PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS =
  "preActivationFieldAgencyAdPlatforms";
export const PRE_ACTIVATION_FIELD_AGENCY_MODULES =
  "preActivationFieldAgencyModules";
export const PRE_ACTIVATION_HINT_AGENCY_MODULES =
  "preActivationHintAgencyModules";
export const PRE_ACTIVATION_AGENCY_MODULE_CREATIVE =
  "preActivationAgencyModuleCreative";
export const PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA =
  "preActivationAgencyModulePaidMedia";
export const PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL =
  "preActivationAgencyModuleOrganicSocial";
export const PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS =
  "preActivationAgencyModuleCompetitorAds";
export const PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME =
  "preActivationFieldAgencySessionBrandName";
export const PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME =
  "preActivationHintAgencySessionBrandName";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME =
  "preActivationPlaceholderAgencySessionBrandName";
export const PRE_ACTIVATION_FIELD_AGENCY_BRAND_ASSETS_READY =
  "preActivationFieldAgencyBrandAssetsReady";
export const PRE_ACTIVATION_HINT_AGENCY_BRAND_ASSETS_READY =
  "preActivationHintAgencyBrandAssetsReady";
export const PRE_ACTIVATION_FIELD_AGENCY_CREATIVE_BOTTLENECK =
  "preActivationFieldAgencyCreativeBottleneck";
export const PRE_ACTIVATION_HINT_AGENCY_CREATIVE_BOTTLENECK =
  "preActivationHintAgencyCreativeBottleneck";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_CREATIVE_BOTTLENECK =
  "preActivationPlaceholderAgencyCreativeBottleneck";
export const PRE_ACTIVATION_FIELD_AGENCY_USES_AD_AUTOMATION =
  "preActivationFieldAgencyUsesAdAutomation";
export const PRE_ACTIVATION_HINT_AGENCY_USES_AD_AUTOMATION =
  "preActivationHintAgencyUsesAdAutomation";
export const PRE_ACTIVATION_OPTION_YES = "preActivationOptionYes";
export const PRE_ACTIVATION_OPTION_NO = "preActivationOptionNo";
export const PRE_ACTIVATION_BEFORE_START_LABEL =
  "preActivationBeforeStartLabel";
export const PRE_ACTIVATION_BEFORE_START_TITLE =
  "preActivationBeforeStartTitle";
export const PRE_ACTIVATION_BEFORE_START_INTRO =
  "preActivationBeforeStartIntro";
export const PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE =
  "preActivationBeforeStartTip1Title";
export const PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION =
  "preActivationBeforeStartTip1Description";
export const PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE =
  "preActivationBeforeStartTip2Title";
export const PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION =
  "preActivationBeforeStartTip2Description";
export const PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE =
  "preActivationBeforeStartTip3Title";
export const PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION =
  "preActivationBeforeStartTip3Description";
export const PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE =
  "preActivationBeforeStartTip4Title";
export const PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION =
  "preActivationBeforeStartTip4Description";
export const PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE =
  "preActivationBeforeStartTip5Title";
export const PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION =
  "preActivationBeforeStartTip5Description";
export const PRE_ACTIVATION_BEFORE_START_CALLOUT =
  "preActivationBeforeStartCallout";
export const PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN =
  "preActivationAdsPlatformLinkedin";
export const PRE_ACTIVATION_FIELD_AGENCY_PHONE =
  "preActivationFieldAgencyPhone";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_PHONE =
  "preActivationPlaceholderAgencyPhone";
export const PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE =
  "preActivationFieldAgencyJobTitle";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE =
  "preActivationPlaceholderAgencyJobTitle";
export const PRE_ACTIVATION_FIELD_AGENCY_BACKUP_CONTACT =
  "preActivationFieldAgencyBackupContact";
export const PRE_ACTIVATION_HINT_AGENCY_BACKUP_CONTACT =
  "preActivationHintAgencyBackupContact";
export const PRE_ACTIVATION_FIELD_AGENCY_LEADERSHIP_CONTACT =
  "preActivationFieldAgencyLeadershipContact";
export const PRE_ACTIVATION_HINT_AGENCY_LEADERSHIP_CONTACT =
  "preActivationHintAgencyLeadershipContact";
export const PRE_ACTIVATION_SECTION_CONTACT_DESCRIPTION_AGENCY =
  "preActivationSectionContactDescriptionAgency";
export const PRE_ACTIVATION_SECTION_AGENCY_02_TITLE =
  "preActivationSectionAgency02Title";
export const PRE_ACTIVATION_SECTION_AGENCY_02_SUBTITLE =
  "preActivationSectionAgency02Subtitle";
export const PRE_ACTIVATION_SECTION_AGENCY_03_TITLE =
  "preActivationSectionAgency03Title";
export const PRE_ACTIVATION_SECTION_AGENCY_03_SUBTITLE =
  "preActivationSectionAgency03Subtitle";
export const PRE_ACTIVATION_SECTION_AGENCY_04_TITLE =
  "preActivationSectionAgency04Title";
export const PRE_ACTIVATION_SECTION_AGENCY_04_SUBTITLE =
  "preActivationSectionAgency04Subtitle";
export const PRE_ACTIVATION_SECTION_AGENCY_04_DESCRIPTION =
  "preActivationSectionAgency04Description";
export const PRE_ACTIVATION_SECTION_AGENCY_05_TITLE =
  "preActivationSectionAgency05Title";
export const PRE_ACTIVATION_SECTION_AGENCY_05_SUBTITLE =
  "preActivationSectionAgency05Subtitle";
export const PRE_ACTIVATION_SECTION_AGENCY_05_DESCRIPTION =
  "preActivationSectionAgency05Description";
export const PRE_ACTIVATION_SECTION_AGENCY_06_TITLE =
  "preActivationSectionAgency06Title";
export const PRE_ACTIVATION_SECTION_AGENCY_06_HEADING =
  "preActivationSectionAgency06Heading";
export const PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME =
  "preActivationFieldAgencyUserFullName";
export const PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL =
  "preActivationFieldAgencyUserEmail";
export const PRE_ACTIVATION_FIELD_AGENCY_TEAM_FAMILIARITY =
  "preActivationFieldAgencyTeamFamiliarity";
export const PRE_ACTIVATION_HINT_AGENCY_TEAM_FAMILIARITY =
  "preActivationHintAgencyTeamFamiliarity";
export const PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED =
  "preActivationAgencyTeamFamiliarityAdvanced";
export const PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE =
  "preActivationAgencyTeamFamiliarityIntermediate";
export const PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL =
  "preActivationAgencyTeamFamiliarityInitial";
export const PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED =
  "preActivationAgencyTeamFamiliarityMixed";
export const PRE_ACTIVATION_AGENCY_TEAM_CALLOUT =
  "preActivationAgencyTeamCallout";
export const PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE =
  "preActivationFieldAgencyBrandWebsite";
export const PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE =
  "preActivationHintAgencyBrandWebsite";
export const PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE =
  "preActivationPlaceholderAgencyBrandWebsite";
export const PRE_ACTIVATION_AGENCY_SCHEDULE_BUTTON =
  "preActivationAgencyScheduleButton";
export const PRE_ACTIVATION_AGENCY_SCHEDULE_LOCKED_HINT =
  "preActivationAgencyScheduleLockedHint";
export const PRE_ACTIVATION_ONBOARDING_MODAL_ARIA_LABEL =
  "preActivationOnboardingModalAriaLabel";
export const PRE_ACTIVATION_ONBOARDING_MODAL_TITLE =
  "preActivationOnboardingModalTitle";
export const PRE_ACTIVATION_ONBOARDING_MODAL_DESCRIPTION =
  "preActivationOnboardingModalDescription";
export const PRE_ACTIVATION_SCHEDULED_SESSION_TITLE =
  "preActivationScheduledSessionTitle";
export const PRE_ACTIVATION_SCHEDULED_SESSION_DATE =
  "preActivationScheduledSessionDate";
export const PRE_ACTIVATION_SCHEDULED_SESSION_TIME =
  "preActivationScheduledSessionTime";
export const PRE_ACTIVATION_SCHEDULED_SESSION_MISSING =
  "preActivationScheduledSessionMissing";
export const PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND =
  "preActivationFieldAgencyConfirmSingleBrand";
export const PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN =
  "preActivationFieldAgencyConfirmAccountAdmin";
export const PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE =
  "preActivationFieldAgencyConfirmReschedule";
export const PRE_ACTIVATION_SUBMIT_SUCCESS_MESSAGE_AGENCY =
  "preActivationSubmitSuccessMessageAgency";
export const OWNER_FORM_SUBMISSION_COLUMN_ORGANIZATION_TYPE =
  "ownerFormSubmissionColumnOrganizationType";

// APPSUMO CALLBACK
export const APPSUMO_CALLBACK_CONNECTING = "appSumoCallbackConnecting";
export const APPSUMO_CALLBACK_ERROR_TITLE = "appSumoCallbackErrorTitle";
export const APPSUMO_CALLBACK_ERROR_DESCRIPTION =
  "appSumoCallbackErrorDescription";
export const APPSUMO_CALLBACK_ERROR_CODE_EXPIRED =
  "appSumoCallbackErrorCodeExpired";
export const APPSUMO_CALLBACK_ERROR_OAUTH_DENIED =
  "appSumoCallbackErrorOauthDenied";
export const APPSUMO_CALLBACK_BUTTON_RETURN_TO_APPSUMO =
  "appSumoCallbackButtonReturnToAppSumo";
export const APPSUMO_CALLBACK_ERROR_ANOMALOUS = "appSumoCallbackErrorAnomalous";

// APPSUMO REGISTER
export const APPSUMO_REGISTER_TITLE = "appSumoRegisterTitle";
export const APPSUMO_REGISTER_SUBTITLE = "appSumoRegisterSubtitle";
export const APPSUMO_REGISTER_BUTTON_SUBMIT = "appSumoRegisterButtonSubmit";
export const APPSUMO_REGISTER_SESSION_EXPIRED = "appSumoRegisterSessionExpired";
export const APP_SUMO_REACTIVATION_NOT_ELIGIBLE =
  "appSumoReactivationNotEligible";
export const APPSUMO_REACTIVATION_OTP_TITLE = "appSumoReactivationOtpTitle";
export const APPSUMO_REACTIVATION_OTP_EMAIL_SENT =
  "appSumoReactivationOtpEmailSent";

// MODAL PERFORMANCE MARKETING SPECIALIST
export const BUTTON_HIRE_PERFORMANCE_SPECIALIST =
  "buttonHirePerformanceSpecialist";
export const MODAL_PERFORMANCE_SPECIALIST_ARIA_LABEL =
  "modalPerformanceSpecialistAriaLabel";
export const MODAL_PERFORMANCE_SPECIALIST_TITLE =
  "modalPerformanceSpecialistTitle";
export const MODAL_PERFORMANCE_SPECIALIST_SUBTITLE =
  "modalPerformanceSpecialistSubtitle";
export const MODAL_PERFORMANCE_SPECIALIST_WHAT_YOU_GET_TITLE =
  "modalPerformanceSpecialistWhatYouGetTitle";
export const MODAL_PERFORMANCE_SPECIALIST_FEATURE_1 =
  "modalPerformanceSpecialistFeature1";
export const MODAL_PERFORMANCE_SPECIALIST_FEATURE_2 =
  "modalPerformanceSpecialistFeature2";
export const MODAL_PERFORMANCE_SPECIALIST_FEATURE_3 =
  "modalPerformanceSpecialistFeature3";
export const MODAL_PERFORMANCE_SPECIALIST_FEATURE_4 =
  "modalPerformanceSpecialistFeature4";
export const MODAL_PERFORMANCE_SPECIALIST_PRICING_TITLE =
  "modalPerformanceSpecialistPricingTitle";
export const MODAL_PERFORMANCE_SPECIALIST_PRICING_MAIN =
  "modalPerformanceSpecialistPricingMain";
export const MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_1 =
  "modalPerformanceSpecialistPricingNote1";
export const MODAL_PERFORMANCE_SPECIALIST_PRICING_NOTE_2 =
  "modalPerformanceSpecialistPricingNote2";
export const MODAL_PERFORMANCE_SPECIALIST_CTA = "modalPerformanceSpecialistCta";
export const BILLING_SPECIALIST_PURCHASE_SUCCESS_TITLE =
  "billingSpecialistPurchaseSuccessTitle";
export const BILLING_SPECIALIST_PURCHASE_SUCCESS_DESCRIPTION =
  "billingSpecialistPurchaseSuccessDescription";
export const BILLING_SPECIALIST_SCHEDULE_MEETING_BUTTON =
  "billingSpecialistScheduleMeetingButton";
export const MODAL_AD_HOC_SUPPORT_ARIA_LABEL = "modalAdHocSupportAriaLabel";
export const MODAL_AD_HOC_SUPPORT_TITLE = "modalAdHocSupportTitle";
export const MODAL_AD_HOC_SUPPORT_DESCRIPTION = "modalAdHocSupportDescription";

// ENTERPRISE INTAKE
export const ENTERPRISE_INTAKE_BADGE = "enterpriseIntakeBadge";
export const ENTERPRISE_INTAKE_BADGE_AGENCY = "enterpriseIntakeBadgeAgency";
export const ENTERPRISE_INTAKE_BADGE_BRAND = "enterpriseIntakeBadgeBrand";
export const ENTERPRISE_INTAKE_HERO_TITLE = "enterpriseIntakeHeroTitle";
export const ENTERPRISE_INTAKE_HERO_DESCRIPTION =
  "enterpriseIntakeHeroDescription";
export const ENTERPRISE_INTAKE_SECTION_01_CONTACT =
  "enterpriseIntakeSection01Contact";
export const ENTERPRISE_INTAKE_SECTION_02_MODULE_SELECTOR =
  "enterpriseIntakeSection02ModuleSelector";
export const ENTERPRISE_INTAKE_SECTION_03_USERS =
  "enterpriseIntakeSection03Users";
export const ENTERPRISE_INTAKE_SECTION_04_SUPPORT_CONTRACT =
  "enterpriseIntakeSection04SupportContract";
export const ENTERPRISE_INTAKE_SECTION_05_ADDITIONAL_NOTES =
  "enterpriseIntakeSection05AdditionalNotes";
export const ENTERPRISE_INTAKE_ARIA_REQUIRED = "enterpriseIntakeAriaRequired";
export const ENTERPRISE_INTAKE_SUBMIT_BUTTON = "enterpriseIntakeSubmitButton";
export const ENTERPRISE_INTAKE_SUBMIT_SUCCESS_TITLE =
  "enterpriseIntakeSubmitSuccessTitle";
export const ENTERPRISE_INTAKE_SUBMIT_SUCCESS_MESSAGE =
  "enterpriseIntakeSubmitSuccessMessage";
export const ENTERPRISE_INTAKE_CONFIDENTIALITY_NOTE =
  "enterpriseIntakeConfidentialityNote";
export const ENTERPRISE_INTAKE_OTHER_OPTION = "enterpriseIntakeOtherOption";
export const ENTERPRISE_INTAKE_OTHER_PLACEHOLDER =
  "enterpriseIntakeOtherPlaceholder";

// Enterprise Intake — Section 1 Contact
export const ENTERPRISE_INTAKE_FIELD_FULL_NAME =
  "enterpriseIntakeFieldFullName";
export const ENTERPRISE_INTAKE_FIELD_CORPORATE_EMAIL =
  "enterpriseIntakeFieldCorporateEmail";
export const ENTERPRISE_INTAKE_FIELD_COMPANY_NAME =
  "enterpriseIntakeFieldCompanyName";
export const ENTERPRISE_INTAKE_FIELD_JOB_TITLE =
  "enterpriseIntakeFieldJobTitle";
export const ENTERPRISE_INTAKE_FIELD_COMPANY_WEBSITE =
  "enterpriseIntakeFieldCompanyWebsite";
export const ENTERPRISE_INTAKE_PLACEHOLDER_FULL_NAME =
  "enterpriseIntakePlaceholderFullName";
export const ENTERPRISE_INTAKE_PLACEHOLDER_CORPORATE_EMAIL =
  "enterpriseIntakePlaceholderCorporateEmail";
export const ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME =
  "enterpriseIntakePlaceholderCompanyName";
export const ENTERPRISE_INTAKE_PLACEHOLDER_JOB_TITLE =
  "enterpriseIntakePlaceholderJobTitle";
export const ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_WEBSITE =
  "enterpriseIntakePlaceholderCompanyWebsite";
export const ENTERPRISE_INTAKE_FIELD_PURCHASE_DECISION_MAKER =
  "enterpriseIntakeFieldPurchaseDecisionMaker";
export const ENTERPRISE_INTAKE_PURCHASE_DECISION_SELF =
  "enterpriseIntakePurchaseDecisionSelf";
export const ENTERPRISE_INTAKE_PURCHASE_DECISION_COLLECT_INFO =
  "enterpriseIntakePurchaseDecisionCollectInfo";
export const ENTERPRISE_INTAKE_PURCHASE_DECISION_SHARED =
  "enterpriseIntakePurchaseDecisionShared";
export const ENTERPRISE_INTAKE_FIELD_CURRENT_TOOL_OR_ADLE_STATUS =
  "enterpriseIntakeFieldCurrentToolOrAdleStatus";
export const ENTERPRISE_INTAKE_CURRENT_TOOL_ADLE_CLIENT =
  "enterpriseIntakeCurrentToolAdleClient";
export const ENTERPRISE_INTAKE_CURRENT_TOOL_EVALUATING_SWITCH =
  "enterpriseIntakeCurrentToolEvaluatingSwitch";
export const ENTERPRISE_INTAKE_CURRENT_TOOL_NO_SIMILAR =
  "enterpriseIntakeCurrentToolNoSimilar";
export const ENTERPRISE_INTAKE_FIELD_OPERATING_COUNTRIES_COUNT =
  "enterpriseIntakeFieldOperatingCountriesCount";
export const ENTERPRISE_INTAKE_PLACEHOLDER_OPERATING_COUNTRIES_COUNT =
  "enterpriseIntakePlaceholderOperatingCountriesCount";
export const ENTERPRISE_INTAKE_FIELD_CREATIVES_VARY_BY_MARKET =
  "enterpriseIntakeFieldCreativesVaryByMarket";
export const ENTERPRISE_INTAKE_CREATIVES_VARY_YES_PER_MARKET =
  "enterpriseIntakeCreativesVaryYesPerMarket";
export const ENTERPRISE_INTAKE_CREATIVES_VARY_PARTIALLY =
  "enterpriseIntakeCreativesVaryPartially";
export const ENTERPRISE_INTAKE_CREATIVES_VARY_NO_SAME_MATERIAL =
  "enterpriseIntakeCreativesVaryNoSameMaterial";
export const ENTERPRISE_INTAKE_CREATIVES_VARY_NOT_APPLICABLE =
  "enterpriseIntakeCreativesVaryNotApplicable";

// Enterprise Intake — Section 2 Module Selector
export const ENTERPRISE_INTAKE_HINT_SECTION_02_MODULES =
  "enterpriseIntakeHintSection02Modules";
export const ENTERPRISE_INTAKE_FIELD_SELECTED_ADLE_MODULES =
  "enterpriseIntakeFieldSelectedAdleModules";
export const ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS =
  "enterpriseIntakeModuleCreativeAssets";
export const ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH =
  "enterpriseIntakeModulePaidMediaLaunch";
export const ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT =
  "enterpriseIntakeModulePaidMediaImport";
export const ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL =
  "enterpriseIntakeModuleOrganicSocial";
export const ENTERPRISE_INTAKE_FIELD_PRIMARY_GOAL =
  "enterpriseIntakeFieldPrimaryGoal";
export const ENTERPRISE_INTAKE_PRIMARY_GOAL_CREATIVE_SPEED =
  "enterpriseIntakePrimaryGoalCreativeSpeed";
export const ENTERPRISE_INTAKE_PRIMARY_GOAL_PERFORMANCE =
  "enterpriseIntakePrimaryGoalPerformance";
export const ENTERPRISE_INTAKE_PRIMARY_GOAL_SCALE_MULTIPLATFORM =
  "enterpriseIntakePrimaryGoalScaleMultiplatform";
export const ENTERPRISE_INTAKE_PRIMARY_GOAL_REDUCE_COSTS =
  "enterpriseIntakePrimaryGoalReduceCosts";
export const ENTERPRISE_INTAKE_PRIMARY_GOAL_CENTRALIZE_OPERATIONS =
  "enterpriseIntakePrimaryGoalCentralizeOperations";
export const ENTERPRISE_INTAKE_VOLUME_STABLE_YEAR_ROUND =
  "enterpriseIntakeVolumeStableYearRound";
export const ENTERPRISE_INTAKE_VOLUME_PEAK_DEMAND =
  "enterpriseIntakeVolumePeakDemand";

// Enterprise Intake — Module 1 Creative Assets
export const ENTERPRISE_INTAKE_SECTION_MODULE_1_CREATIVE_ASSETS =
  "enterpriseIntakeSectionModule1CreativeAssets";
export const ENTERPRISE_INTAKE_MODULE1_INTRO = "enterpriseIntakeModule1Intro";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_BRANDS_OR_VISUAL_IDENTITIES_COUNT =
  "enterpriseIntakeModule1FieldBrandsOrVisualIdentitiesCount";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_INDEPENDENT_BRAND_CONFIGS_COUNT =
  "enterpriseIntakeModule1FieldIndependentBrandConfigsCount";
export const ENTERPRISE_INTAKE_MODULE1_HINT_INDEPENDENT_BRAND_CONFIGS =
  "enterpriseIntakeModule1HintIndependentBrandConfigs";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_NEW_IMAGES_COUNT =
  "enterpriseIntakeModule1FieldMonthlyNewImagesCount";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_FORMATS_PER_PIECE_AVG =
  "enterpriseIntakeModule1FieldFormatsPerPieceAvg";
export const ENTERPRISE_INTAKE_MODULE1_HINT_FORMATS_PER_PIECE =
  "enterpriseIntakeModule1HintFormatsPerPiece";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_ADDITIONAL_EDITS_COUNT =
  "enterpriseIntakeModule1FieldMonthlyAdditionalEditsCount";
export const ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_ADDITIONAL_EDITS =
  "enterpriseIntakeModule1HintMonthlyAdditionalEdits";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_VIDEOS_COUNT =
  "enterpriseIntakeModule1FieldMonthlyVideosCount";
export const ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_VIDEOS =
  "enterpriseIntakeModule1HintMonthlyVideos";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_MONTHLY_IMAGE_ANIMATIONS_COUNT =
  "enterpriseIntakeModule1FieldMonthlyImageAnimationsCount";
export const ENTERPRISE_INTAKE_MODULE1_HINT_MONTHLY_IMAGE_ANIMATIONS =
  "enterpriseIntakeModule1HintMonthlyImageAnimations";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_VERSIONS_PER_PIECE_BEFORE_APPROVAL =
  "enterpriseIntakeModule1FieldVersionsPerPieceBeforeApproval";
export const ENTERPRISE_INTAKE_MODULE1_HINT_VERSIONS_PER_PIECE =
  "enterpriseIntakeModule1HintVersionsPerPiece";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_CREATIVE_VOLUME_VARIATION =
  "enterpriseIntakeModule1FieldCreativeVolumeVariation";
export const ENTERPRISE_INTAKE_MODULE1_FIELD_PEAK_MONTH_PIECES_COUNT =
  "enterpriseIntakeModule1FieldPeakMonthPiecesCount";

// Enterprise Intake — Module 2 Paid Media Launch
export const ENTERPRISE_INTAKE_SECTION_MODULE_2_PAID_MEDIA_LAUNCH =
  "enterpriseIntakeSectionModule2PaidMediaLaunch";
export const ENTERPRISE_INTAKE_MODULE2_INTRO = "enterpriseIntakeModule2Intro";
export const ENTERPRISE_INTAKE_MODULE2_FIELD_AD_ACCOUNTS_OR_ADVERTISERS_COUNT =
  "enterpriseIntakeModule2FieldAdAccountsOrAdvertisersCount";
export const ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_CAMPAIGNS_COUNT =
  "enterpriseIntakeModule2FieldMonthlyCampaignsCount";
export const ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_CAMPAIGNS =
  "enterpriseIntakeModule2HintMonthlyCampaigns";
export const ENTERPRISE_INTAKE_MODULE2_FIELD_MONTHLY_OPTIMIZATIONS_COUNT =
  "enterpriseIntakeModule2FieldMonthlyOptimizationsCount";
export const ENTERPRISE_INTAKE_MODULE2_HINT_MONTHLY_OPTIMIZATIONS =
  "enterpriseIntakeModule2HintMonthlyOptimizations";
export const ENTERPRISE_INTAKE_MODULE2_FIELD_CAMPAIGN_VOLUME_VARIATION =
  "enterpriseIntakeModule2FieldCampaignVolumeVariation";
export const ENTERPRISE_INTAKE_MODULE2_FIELD_PEAK_MONTH_CAMPAIGNS_COUNT =
  "enterpriseIntakeModule2FieldPeakMonthCampaignsCount";

// Enterprise Intake — Module 3 Paid Media Import
export const ENTERPRISE_INTAKE_SECTION_MODULE_3_PAID_MEDIA_IMPORT =
  "enterpriseIntakeSectionModule3PaidMediaImport";
export const ENTERPRISE_INTAKE_MODULE3_INTRO = "enterpriseIntakeModule3Intro";
export const ENTERPRISE_INTAKE_MODULE3_FIELD_CAMPAIGNS_TO_IMPORT =
  "enterpriseIntakeModule3FieldCampaignsToImport";
export const ENTERPRISE_INTAKE_MODULE3_FIELD_IMPORT_PLATFORMS =
  "enterpriseIntakeModule3FieldImportPlatforms";
export const ENTERPRISE_INTAKE_MODULE3_PLATFORM_META =
  "enterpriseIntakeModule3PlatformMeta";
export const ENTERPRISE_INTAKE_MODULE3_PLATFORM_GOOGLE =
  "enterpriseIntakeModule3PlatformGoogle";
export const ENTERPRISE_INTAKE_MODULE3_PLATFORM_TIKTOK =
  "enterpriseIntakeModule3PlatformTiktok";
export const ENTERPRISE_INTAKE_MODULE3_PLATFORM_LINKEDIN =
  "enterpriseIntakeModule3PlatformLinkedin";

// Enterprise Intake — Module 4 Organic Social
export const ENTERPRISE_INTAKE_SECTION_MODULE_4_ORGANIC_SOCIAL =
  "enterpriseIntakeSectionModule4OrganicSocial";
export const ENTERPRISE_INTAKE_MODULE4_INTRO = "enterpriseIntakeModule4Intro";
export const ENTERPRISE_INTAKE_MODULE4_FIELD_MONTHLY_ORGANIC_POSTS =
  "enterpriseIntakeModule4FieldMonthlyOrganicPosts";
export const ENTERPRISE_INTAKE_MODULE4_FIELD_SCHEDULING_NETWORKS =
  "enterpriseIntakeModule4FieldSchedulingNetworks";
export const ENTERPRISE_INTAKE_MODULE4_NETWORK_INSTAGRAM =
  "enterpriseIntakeModule4NetworkInstagram";
export const ENTERPRISE_INTAKE_MODULE4_NETWORK_FACEBOOK =
  "enterpriseIntakeModule4NetworkFacebook";
export const ENTERPRISE_INTAKE_MODULE4_NETWORK_TIKTOK =
  "enterpriseIntakeModule4NetworkTiktok";
export const ENTERPRISE_INTAKE_MODULE4_NETWORK_LINKEDIN =
  "enterpriseIntakeModule4NetworkLinkedin";
export const ENTERPRISE_INTAKE_MODULE4_NETWORK_X_TWITTER =
  "enterpriseIntakeModule4NetworkXTwitter";
export const ENTERPRISE_INTAKE_MODULE4_FIELD_POST_CREATION_SOURCE =
  "enterpriseIntakeModule4FieldPostCreationSource";
export const ENTERPRISE_INTAKE_MODULE4_POST_CREATED_IN_ADLE =
  "enterpriseIntakeModule4PostCreatedInAdle";
export const ENTERPRISE_INTAKE_MODULE4_POST_READY_TO_SCHEDULE =
  "enterpriseIntakeModule4PostReadyToSchedule";
export const ENTERPRISE_INTAKE_MODULE4_POST_MIXED =
  "enterpriseIntakeModule4PostMixed";

// Enterprise Intake — Section 3 Advertiser Volume
export const ENTERPRISE_INTAKE_FIELD_ACTIVE_ADVERTISERS_MONTH1 =
  "enterpriseIntakeFieldActiveAdvertisersMonth1";
export const ENTERPRISE_INTAKE_HINT_ACTIVE_ADVERTISERS_MONTH1 =
  "enterpriseIntakeHintActiveAdvertisersMonth1";
export const ENTERPRISE_INTAKE_FIELD_TOTAL_ADVERTISERS_60_90 =
  "enterpriseIntakeFieldTotalAdvertisers6090";
export const ENTERPRISE_INTAKE_HINT_TOTAL_ADVERTISERS_60_90 =
  "enterpriseIntakeHintTotalAdvertisers6090";
export const ENTERPRISE_INTAKE_FIELD_ADMIN_ACCESS_PHASE1 =
  "enterpriseIntakeFieldAdminAccessPhase1";
export const ENTERPRISE_INTAKE_ADMIN_ACCESS_ALL =
  "enterpriseIntakeAdminAccessAll";
export const ENTERPRISE_INTAKE_ADMIN_ACCESS_MOST =
  "enterpriseIntakeAdminAccessMost";
export const ENTERPRISE_INTAKE_ADMIN_ACCESS_SOME =
  "enterpriseIntakeAdminAccessSome";

// Enterprise Intake — Section 3 Users
export const ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT =
  "enterpriseIntakeFieldPlatformUsersCount";
export const ENTERPRISE_INTAKE_FIELD_PLATFORM_CAPACITY_MANAGEMENT =
  "enterpriseIntakeFieldPlatformCapacityManagement";
export const ENTERPRISE_INTAKE_PLATFORM_CAPACITY_CENTRALIZED_POOL =
  "enterpriseIntakePlatformCapacityCentralizedPool";
export const ENTERPRISE_INTAKE_PLATFORM_CAPACITY_ASSIGNED_QUOTAS =
  "enterpriseIntakePlatformCapacityAssignedQuotas";
export const ENTERPRISE_INTAKE_CREDITS_MIXED = "enterpriseIntakeCreditsMixed";

// Enterprise Intake — Section 5 Credit Consumption
export const ENTERPRISE_INTAKE_CREDITS_EQUIVALENCES_TITLE =
  "enterpriseIntakeCreditsEquivalencesTitle";
export const ENTERPRISE_INTAKE_CREDITS_RENEWAL_NOTE =
  "enterpriseIntakeCreditsRenewalNote";
export const ENTERPRISE_INTAKE_CREDITS_UNCERTAIN_NOTE =
  "enterpriseIntakeCreditUncertainNote";
export const ENTERPRISE_INTAKE_VOLUME_ZERO = "enterpriseIntakeVolumeZero";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_IMAGES =
  "enterpriseIntakeFieldMonthlyAiImages";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_AI_IMAGES =
  "enterpriseIntakeHintMonthlyAiImages";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_VIDEOS =
  "enterpriseIntakeFieldMonthlyAiVideos";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_AI_VIDEOS =
  "enterpriseIntakeHintMonthlyAiVideos";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_CAMPAIGNS =
  "enterpriseIntakeFieldMonthlyAiCampaigns";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_AI_CAMPAIGNS =
  "enterpriseIntakeHintMonthlyAiCampaigns";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_AI_OPTIMIZATIONS =
  "enterpriseIntakeFieldMonthlyAiOptimizations";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_AI_OPTIMIZATIONS =
  "enterpriseIntakeHintMonthlyAiOptimizations";
export const ENTERPRISE_INTAKE_FIELD_USES_ORGANIC_SCHEDULING =
  "enterpriseIntakeFieldUsesOrganicScheduling";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_ORGANIC_POSTS =
  "enterpriseIntakeFieldMonthlyOrganicPosts";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_ORGANIC_POSTS =
  "enterpriseIntakeHintMonthlyOrganicPosts";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_ESTIMATED_CREDITS =
  "enterpriseIntakeFieldMonthlyEstimatedCredits";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_ESTIMATED_CREDITS =
  "enterpriseIntakeHintMonthlyEstimatedCredits";

// Enterprise Intake — Section 6 Channels & Investment
export const ENTERPRISE_INTAKE_FIELD_PHASE1_PAID_CHANNELS =
  "enterpriseIntakeFieldPhase1PaidChannels";
export const ENTERPRISE_INTAKE_HINT_PHASE1_PAID_CHANNELS =
  "enterpriseIntakeHintPhase1PaidChannels";
export const ENTERPRISE_INTAKE_CHANNEL_META = "enterpriseIntakeChannelMeta";
export const ENTERPRISE_INTAKE_CHANNEL_GOOGLE = "enterpriseIntakeChannelGoogle";
export const ENTERPRISE_INTAKE_CHANNEL_TIKTOK = "enterpriseIntakeChannelTiktok";
export const ENTERPRISE_INTAKE_CHANNEL_LINKEDIN =
  "enterpriseIntakeChannelLinkedin";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_AD_SPEND_RANGE =
  "enterpriseIntakeFieldMonthlyAdSpendRange";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_AD_SPEND_RANGE =
  "enterpriseIntakeHintMonthlyAdSpendRange";
export const ENTERPRISE_INTAKE_AD_SPEND_LESS_THAN_10K =
  "enterpriseIntakeAdSpendLessThan10k";
export const ENTERPRISE_INTAKE_AD_SPEND_MORE_THAN_500K =
  "enterpriseIntakeAdSpendMoreThan500k";

// Enterprise Intake — Section 4 Support, Contract & Implementation
export const ENTERPRISE_INTAKE_FIELD_PLATFORM_MANAGEMENT =
  "enterpriseIntakeFieldPlatformManagement";
export const ENTERPRISE_INTAKE_HINT_PLATFORM_MANAGEMENT =
  "enterpriseIntakeHintPlatformManagement";
export const ENTERPRISE_INTAKE_PLATFORM_MGMT_OWN_TEAM =
  "enterpriseIntakePlatformMgmtOwnTeam";
export const ENTERPRISE_INTAKE_PLATFORM_MGMT_THIRD_PARTY =
  "enterpriseIntakePlatformMgmtThirdParty";
export const ENTERPRISE_INTAKE_PLATFORM_MGMT_ADLE_OPERATES =
  "enterpriseIntakePlatformMgmtAdleOperates";
export const ENTERPRISE_INTAKE_FIELD_WHITE_LABEL =
  "enterpriseIntakeFieldWhiteLabel";
export const ENTERPRISE_INTAKE_HINT_WHITE_LABEL =
  "enterpriseIntakeHintWhiteLabel";
export const ENTERPRISE_INTAKE_WHITE_LABEL_ESSENTIAL =
  "enterpriseIntakeWhiteLabelEssential";
export const ENTERPRISE_INTAKE_WHITE_LABEL_INTERESTED =
  "enterpriseIntakeWhiteLabelInterested";
export const ENTERPRISE_INTAKE_WHITE_LABEL_NOT_NEEDED =
  "enterpriseIntakeWhiteLabelNotNeeded";
export const ENTERPRISE_INTAKE_WHITE_LABEL_UNSURE =
  "enterpriseIntakeWhiteLabelUnsure";
export const ENTERPRISE_INTAKE_FIELD_URGENCY_DEADLINE =
  "enterpriseIntakeFieldUrgencyDeadline";
export const ENTERPRISE_INTAKE_PLACEHOLDER_URGENCY_DEADLINE =
  "enterpriseIntakePlaceholderUrgencyDeadline";
export const ENTERPRISE_INTAKE_FIELD_ESTIMATED_TOOL_BUDGET =
  "enterpriseIntakeFieldEstimatedToolBudget";
export const ENTERPRISE_INTAKE_HINT_ESTIMATED_TOOL_BUDGET =
  "enterpriseIntakeHintEstimatedToolBudget";
export const ENTERPRISE_INTAKE_BUDGET_LT_1000 = "enterpriseIntakeBudgetLt1000";
export const ENTERPRISE_INTAKE_BUDGET_1000_2500 =
  "enterpriseIntakeBudget1000_2500";
export const ENTERPRISE_INTAKE_BUDGET_2500_5000 =
  "enterpriseIntakeBudget2500_5000";
export const ENTERPRISE_INTAKE_BUDGET_5000_10000 =
  "enterpriseIntakeBudget5000_10000";
export const ENTERPRISE_INTAKE_BUDGET_GT_10000 =
  "enterpriseIntakeBudgetGt10000";
export const ENTERPRISE_INTAKE_BUDGET_NOT_DEFINED =
  "enterpriseIntakeBudgetNotDefined";
export const ENTERPRISE_INTAKE_BUDGET_PREFER_NOT_ANSWER =
  "enterpriseIntakeBudgetPreferNotAnswer";

// Enterprise Intake — Section 7 Support, Contract & Implementation
export const ENTERPRISE_INTAKE_FIELD_SUPPORT_LEVEL =
  "enterpriseIntakeFieldSupportLevel";
export const ENTERPRISE_INTAKE_SUPPORT_TECH_ONLY =
  "enterpriseIntakeSupportTechOnly";
export const ENTERPRISE_INTAKE_SUPPORT_PARTIAL =
  "enterpriseIntakeSupportPartial";
export const ENTERPRISE_INTAKE_SUPPORT_FULL_OPERATION =
  "enterpriseIntakeSupportFullOperation";
export const ENTERPRISE_INTAKE_FIELD_CSM_CADENCE =
  "enterpriseIntakeFieldCsmCadence";
export const ENTERPRISE_INTAKE_CSM_WEEKLY = "enterpriseIntakeCsmWeekly";
export const ENTERPRISE_INTAKE_CSM_BIWEEKLY = "enterpriseIntakeCsmBiweekly";
export const ENTERPRISE_INTAKE_CSM_MONTHLY = "enterpriseIntakeCsmMonthly";
export const ENTERPRISE_INTAKE_CSM_AS_NEEDED = "enterpriseIntakeCsmAsNeeded";
export const ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT =
  "enterpriseIntakeFieldContractFormat";
export const ENTERPRISE_INTAKE_CONTRACT_MONTHLY =
  "enterpriseIntakeContractMonthly";
export const ENTERPRISE_INTAKE_CONTRACT_QUARTERLY =
  "enterpriseIntakeContractQuarterly";
export const ENTERPRISE_INTAKE_CONTRACT_ANNUAL =
  "enterpriseIntakeContractAnnual";
export const ENTERPRISE_INTAKE_FIELD_IMPLEMENTATION_TIMELINE =
  "enterpriseIntakeFieldImplementationTimeline";
export const ENTERPRISE_INTAKE_HINT_IMPLEMENTATION_TIMELINE =
  "enterpriseIntakeHintImplementationTimeline";
export const ENTERPRISE_INTAKE_TIMELINE_0_3_DAYS =
  "enterpriseIntakeTimeline03Days";
export const ENTERPRISE_INTAKE_TIMELINE_4_7_DAYS =
  "enterpriseIntakeTimeline47Days";
export const ENTERPRISE_INTAKE_TIMELINE_8_15_DAYS =
  "enterpriseIntakeTimeline815Days";
export const ENTERPRISE_INTAKE_TIMELINE_16_30_DAYS =
  "enterpriseIntakeTimeline1630Days";
export const ENTERPRISE_INTAKE_TIMELINE_30_PLUS_DAYS =
  "enterpriseIntakeTimeline30PlusDays";
export const ENTERPRISE_INTAKE_FIELD_SECURITY_REQUIREMENTS =
  "enterpriseIntakeFieldSecurityRequirements";
export const ENTERPRISE_INTAKE_SECURITY_SSO = "enterpriseIntakeSecuritySso";
export const ENTERPRISE_INTAKE_SECURITY_AUDIT_LOGS =
  "enterpriseIntakeSecurityAuditLogs";
export const ENTERPRISE_INTAKE_SECURITY_NOT_APPLICABLE =
  "enterpriseIntakeSecurityNotApplicable";

// Enterprise Intake — Section 5 Additional Notes
export const ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES =
  "enterpriseIntakeFieldAdditionalNotes";
export const ENTERPRISE_INTAKE_HINT_ADDITIONAL_NOTES =
  "enterpriseIntakeHintAdditionalNotes";
export const ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES =
  "enterpriseIntakePlaceholderAdditionalNotes";
export const ENTERPRISE_INTAKE_FOOTNOTE_ADDITIONAL_NOTES =
  "enterpriseIntakeFootnoteAdditionalNotes";

export const ENTERPRISE_INTAKE_MODULE_REPORTS = "enterpriseIntakeModuleReports";
export const ENTERPRISE_INTAKE_MODULE_COMPETITORS =
  "enterpriseIntakeModuleCompetitors";
export const ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT =
  "enterpriseIntakeFieldScopeBrandsCount";
export const ENTERPRISE_INTAKE_FIELD_SCOPE_BRANDS_COUNT_AGENCY =
  "enterpriseIntakeFieldScopeBrandsCountAgency";
export const ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_AGENCY =
  "enterpriseIntakeHintScopeBrandsCountAgency";
export const ENTERPRISE_INTAKE_HINT_SCOPE_BRANDS_COUNT_BRAND =
  "enterpriseIntakeHintScopeBrandsCountBrand";
export const ENTERPRISE_INTAKE_PLACEHOLDER_SCOPE_BRANDS_COUNT =
  "enterpriseIntakePlaceholderScopeBrandsCount";
export const ENTERPRISE_INTAKE_PLACEHOLDER_COMPANY_NAME_BRAND =
  "enterpriseIntakePlaceholderCompanyNameBrand";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_STATIC_PIECES =
  "enterpriseIntakeHintMonthlyStaticPieces";
export const ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER =
  "enterpriseIntakeFieldCreativesBuffer";
export const ENTERPRISE_INTAKE_HINT_CREATIVES_BUFFER =
  "enterpriseIntakeHintCreativesBuffer";
export const ENTERPRISE_INTAKE_BUFFER_STATICS = "enterpriseIntakeBufferStatics";
export const ENTERPRISE_INTAKE_BUFFER_ANIMATIONS =
  "enterpriseIntakeBufferAnimations";
export const ENTERPRISE_INTAKE_BUFFER_VIDEOS = "enterpriseIntakeBufferVideos";
export const ENTERPRISE_INTAKE_BUFFER_NONE = "enterpriseIntakeBufferNone";
export const ENTERPRISE_INTAKE_FIELD_CREATIVES_BUFFER_PERCENT =
  "enterpriseIntakeFieldCreativesBufferPercent";
export const ENTERPRISE_INTAKE_BUFFER_PERCENT_10 =
  "enterpriseIntakeBufferPercent10";
export const ENTERPRISE_INTAKE_BUFFER_PERCENT_15 =
  "enterpriseIntakeBufferPercent15";
export const ENTERPRISE_INTAKE_BUFFER_PERCENT_20 =
  "enterpriseIntakeBufferPercent20";
export const ENTERPRISE_INTAKE_PLACEHOLDER_BUFFER_PERCENT_OTHER =
  "enterpriseIntakePlaceholderBufferPercentOther";
export const ENTERPRISE_INTAKE_HINT_CAMPAIGNS_SECTION =
  "enterpriseIntakeHintCampaignsSection";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_AGENCY =
  "enterpriseIntakeHintMonthlyCampaignsTotalAgency";
export const ENTERPRISE_INTAKE_HINT_MONTHLY_CAMPAIGNS_TOTAL_BRAND =
  "enterpriseIntakeHintMonthlyCampaignsTotalBrand";
export const ENTERPRISE_INTAKE_FIELD_OPTIMIZATION_FREQUENCY =
  "enterpriseIntakeFieldOptimizationFrequency";
export const ENTERPRISE_INTAKE_HINT_OPTIMIZATION_FREQUENCY =
  "enterpriseIntakeHintOptimizationFrequency";
export const ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW =
  "enterpriseIntakeOptimizationFrequencyLow";
export const ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM =
  "enterpriseIntakeOptimizationFrequencyMedium";
export const ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH =
  "enterpriseIntakeOptimizationFrequencyHigh";
export const ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT =
  "enterpriseIntakeHintPlatformUsersCount";
export const ENTERPRISE_INTAKE_HINT_CONTRACT_TERM =
  "enterpriseIntakeHintContractTerm";
export const ENTERPRISE_INTAKE_CONTRACT_TERM_6 =
  "enterpriseIntakeContractTerm6";
export const ENTERPRISE_INTAKE_CONTRACT_TERM_12 =
  "enterpriseIntakeContractTerm12";
export const ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON =
  "enterpriseIntakeFieldMediaManagementAddon";
export const ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON =
  "enterpriseIntakeHintMediaManagementAddon";
export const ENTERPRISE_INTAKE_MEDIA_ADDON_YES =
  "enterpriseIntakeMediaAddonYes";
export const ENTERPRISE_INTAKE_MEDIA_ADDON_NO = "enterpriseIntakeMediaAddonNo";
export const ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND =
  "enterpriseIntakeFieldMonthlyMediaSpend";
export const ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND =
  "enterpriseIntakePlaceholderMonthlyMediaSpend";
export const ENTERPRISE_INTAKE_WHITE_LABEL_YES =
  "enterpriseIntakeWhiteLabelYes";
export const ENTERPRISE_INTAKE_WHITE_LABEL_NO = "enterpriseIntakeWhiteLabelNo";
export const ENTERPRISE_INTAKE_SECTION_PLAN = "enterpriseIntakeSectionPlan";

// Owner dashboard — unified form submissions list (pre-activation + enterprise)
export const OWNER_FORM_SUBMISSION_TYPE_PRE_ACTIVATION =
  "ownerFormSubmissionTypePreActivation";
export const OWNER_FORM_SUBMISSION_TYPE_ENTERPRISE =
  "ownerFormSubmissionTypeEnterprise";

// Signup / discovery source (how the user heard about the product)
export const OPTION_EMAIL = "optionEmail";
export const OPTION_META = "optionMeta";
export const OPTION_GOOGLE = "optionGoogle";
export const OPTION_LINKEDIN = "optionLinkedin";
export const OPTION_LLM = "optionLlm";
export const OPTION_OTHER = "optionOther";

// Global brand report (MVP)
export const GLOBAL_REPORT_TITLE = "globalReportTitle";
export const GLOBAL_REPORT_DESCRIPTION = "globalReportDescription";
export const GLOBAL_REPORT_MENU_GROUP = "globalReportMenuGroup";
export const GLOBAL_REPORT_MENU_ITEM = "globalReportMenuItem";
export const GLOBAL_REPORT_PAGE_TITLE = "globalReportPageTitle";
export const GLOBAL_REPORT_PERIOD_LAST_7_DAYS = "globalReportPeriodLast7Days";
export const GLOBAL_REPORT_PERIOD_LAST_14_DAYS = "globalReportPeriodLast14Days";
export const GLOBAL_REPORT_PERIOD_LAST_30_DAYS = "globalReportPeriodLast30Days";
export const GLOBAL_REPORT_AI_ANALYSIS = "globalReportAiAnalysis";
export const GLOBAL_REPORT_OBJECTIVES_BUTTON = "globalReportObjectivesButton";
export const GLOBAL_REPORT_TOTAL_INVESTMENT = "globalReportTotalInvestment";
export const GLOBAL_REPORT_AVERAGE_ROAS = "globalReportAverageRoas";
export const GLOBAL_REPORT_ACTIVE_CAMPAIGNS = "globalReportActiveCampaigns";
export const GLOBAL_REPORT_REMAINING_BUDGET = "globalReportRemainingBudget";
export const GLOBAL_REPORT_BUDGET_EXPIRES_IN = "globalReportBudgetExpiresIn";
export const GLOBAL_REPORT_PAUSED_CAMPAIGNS = "globalReportPausedCampaigns";
export const GLOBAL_REPORT_VS_PREVIOUS_WEEK = "globalReportVsPreviousWeek";
export const GLOBAL_REPORT_AGENT_INSIGHTS = "globalReportAgentInsights";
export const GLOBAL_REPORT_NEW_INSIGHTS = "globalReportNewInsights";
export const GLOBAL_REPORT_NO_INSIGHTS = "globalReportNoInsights";
export const GLOBAL_REPORT_INSIGHTS_ERROR = "globalReportInsightsError";
export const GLOBAL_REPORT_SUMMARY_TITLE = "globalReportSummaryTitle";
export const GLOBAL_REPORT_SUMMARY_OVERVIEW_TEXT =
  "globalReportSummaryOverviewText";
export const GLOBAL_REPORT_INSIGHTS_QUESTION = "globalReportInsightsQuestion";
export const GLOBAL_REPORT_GENERATING_SUMMARY = "globalReportGeneratingSummary";
export const GLOBAL_REPORT_SUMMARY_NOT_GENERATED =
  "globalReportSummaryNotGenerated";
export const GLOBAL_REPORT_ASK_QUESTION = "globalReportAskQuestion";
export const GLOBAL_REPORT_ASK_QUESTION_OPEN = "globalReportAskQuestionOpen";
export const GLOBAL_REPORT_VIEW_HISTORICAL_INSIGHTS =
  "globalReportViewHistoricalInsights";
export const GLOBAL_REPORT_AGENT_ACTIONS = "globalReportAgentActions";
export const GLOBAL_REPORT_ACTIONS_PERFORMED = "globalReportActionsPerformed";
export const GLOBAL_REPORT_ACTION_TYPE_GENERATE_CAMPAIGN =
  "globalReportActionTypeGenerateCampaign";
export const GLOBAL_REPORT_ACTION_TYPE_CREATIVES =
  "globalReportActionTypeCreatives";
export const GLOBAL_REPORT_ACTION_TYPE_VIDEOS = "globalReportActionTypeVideos";
export const GLOBAL_REPORT_ACTION_TYPE_MESSAGES =
  "globalReportActionTypeMessages";
export const GLOBAL_REPORT_ACTION_TYPE_OPTIMIZATIONS_APPLIED =
  "globalReportActionTypeOptimizationsApplied";
export const GLOBAL_REPORT_ACTION_TYPE_GENERIC =
  "globalReportActionTypeGeneric";
export const GLOBAL_REPORT_ACTION_CREATIVES_SUBTITLE =
  "globalReportActionCreativesSubtitle";
export const GLOBAL_REPORT_ACTION_VIDEOS_SUBTITLE =
  "globalReportActionVideosSubtitle";
export const GLOBAL_REPORT_ACTION_MESSAGES_SUBTITLE =
  "globalReportActionMessagesSubtitle";
export const GLOBAL_REPORT_ACTION_GENERIC_SUBTITLE =
  "globalReportActionGenericSubtitle";
export const GLOBAL_REPORT_NO_ACTIONS_IN_PERIOD =
  "globalReportNoActionsInPeriod";
export const GLOBAL_REPORT_NO_CAMPAIGNS_IN_PERIOD =
  "globalReportNoCampaignsInPeriod";
export const GLOBAL_REPORT_NO_ACTIVITY_IN_PERIOD =
  "globalReportNoActivityInPeriod";
export const GLOBAL_REPORT_SELECT_DATES_PROMPT =
  "globalReportSelectDatesPrompt";
export const GLOBAL_REPORT_MEASURABLE_KPI_LABEL =
  "globalReportMeasurableKpiLabel";
export const GLOBAL_REPORT_MEASURABLE_KPI_ALL = "globalReportMeasurableKpiAll";
export const GLOBAL_REPORT_NO_CAMPAIGNS_FOR_KPI =
  "globalReportNoCampaignsForKpi";
export const GLOBAL_REPORT_DOWNLOAD_NOT_READY = "globalReportDownloadNotReady";
export const GLOBAL_REPORT_PDF_OPTION = "globalReportPdfOption";
export const GLOBAL_REPORT_CUSTOM_OPTION = "globalReportCustomOption";
export const GLOBAL_REPORT_SERVER_PDF_BUTTON = "globalReportServerPdfButton";
export const GLOBAL_REPORT_SERVER_PDF_FOOTER = "globalReportServerPdfFooter";
export const GLOBAL_REPORT_SERVER_PDF_FILE_NAME =
  "globalReportServerPdfFileName";
export const MODAL_CUSTOM_REPORT_CTA = "modalCustomReportCta";
export const MODAL_CUSTOM_REPORT_TITLE = "modalCustomReportTitle";
export const MODAL_CUSTOM_REPORT_DESCRIPTION = "modalCustomReportDescription";
export const MODAL_CUSTOM_REPORT_TEMPLATE = "modalCustomReportTemplate";
export const MODAL_CUSTOM_REPORT_TEMPLATE_GENERAL =
  "modalCustomReportTemplateGeneral";
export const MODAL_CUSTOM_REPORT_TEMPLATE_SALES =
  "modalCustomReportTemplateSales";
export const MODAL_CUSTOM_REPORT_TEMPLATE_LEADS =
  "modalCustomReportTemplateLeads";
export const MODAL_CUSTOM_REPORT_TEMPLATE_CUSTOM =
  "modalCustomReportTemplateCustom";
export const MODAL_CUSTOM_REPORT_PROMPT = "modalCustomReportPrompt";
export const MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER =
  "modalCustomReportPromptPlaceholder";
export const MODAL_CUSTOM_REPORT_USE_PREVIOUS_PROMPT =
  "modalCustomReportUsePreviousPrompt";
export const MODAL_CUSTOM_REPORT_DATES = "modalCustomReportDates";
export const MODAL_CUSTOM_REPORT_FORMAT = "modalCustomReportFormat";
export const MODAL_CUSTOM_REPORT_LANGUAGE = "modalCustomReportLanguage";
export const MODAL_CUSTOM_REPORT_FORMAT_PDF = "modalCustomReportFormatPdf";
export const MODAL_CUSTOM_REPORT_FORMAT_PPTX = "modalCustomReportFormatPptx";
export const MODAL_CUSTOM_REPORT_FORMAT_CSV = "modalCustomReportFormatCsv";
export const MODAL_CUSTOM_REPORT_PROMPT_PLACEHOLDER_CSV =
  "modalCustomReportPromptPlaceholderCsv";
export const MODAL_CUSTOM_REPORT_PDF_UNAVAILABLE =
  "modalCustomReportPdfUnavailable";
export const MODAL_CUSTOM_REPORT_COLLECTING = "modalCustomReportCollecting";
export const MODAL_CUSTOM_REPORT_ANALYZING = "modalCustomReportAnalyzing";
export const MODAL_CUSTOM_REPORT_RENDERING = "modalCustomReportRendering";
export const MODAL_CUSTOM_REPORT_ERROR = "modalCustomReportError";
export const MODAL_CUSTOM_REPORT_SAVED_PROMPTS_TITLE =
  "modalCustomReportSavedPromptsTitle";
export const MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DESCRIPTION =
  "modalCustomReportSavedPromptsDescription";
export const MODAL_CUSTOM_REPORT_SAVED_PROMPTS_EMPTY =
  "modalCustomReportSavedPromptsEmpty";
export const MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_TITLE =
  "modalCustomReportSavedPromptsDeleteTitle";
export const MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE_DESCRIPTION =
  "modalCustomReportSavedPromptsDeleteDescription";
export const MODAL_CUSTOM_REPORT_SAVED_PROMPTS_DELETE =
  "modalCustomReportSavedPromptsDelete";
export const GLOBAL_REPORT_HEAVY_LOAD_FETCHING_CAMPAIGNS =
  "globalReportHeavyLoadFetchingCampaigns";
export const GLOBAL_REPORT_HEAVY_LOAD_FETCHING_STATS =
  "globalReportHeavyLoadFetchingStats";
export const GLOBAL_REPORT_HEAVY_LOAD_ANALYZING =
  "globalReportHeavyLoadAnalyzing";
export const GLOBAL_REPORT_HEAVY_LOAD_GENERATING_INSIGHTS =
  "globalReportHeavyLoadGeneratingInsights";
export const GLOBAL_REPORT_ACTIVE_CAMPAIGNS_TABLE =
  "globalReportActiveCampaignsTable";
export const GLOBAL_REPORT_CAMPAIGNS_TABLE = "globalReportCampaignsTable";
export const GLOBAL_REPORT_COLUMN_CAMPAIGN = "globalReportColumnCampaign";
export const GLOBAL_REPORT_COLUMN_INVESTMENT = "globalReportColumnInvestment";
export const GLOBAL_REPORT_COLUMN_ROAS = "globalReportColumnRoas";
export const GLOBAL_REPORT_COLUMN_IMPRESSIONS = "globalReportColumnImpressions";
export const GLOBAL_REPORT_COLUMN_CTR = "globalReportColumnCtr";
export const GLOBAL_REPORT_COLUMN_STATUS = "globalReportColumnStatus";
export const GLOBAL_REPORT_STATUS_ALERT = "globalReportStatusAlert";
export const GLOBAL_REPORT_STATUS_OPTIMAL = "globalReportStatusOptimal";
export const GLOBAL_REPORT_STATUS_BRAND = "globalReportStatusBrand";
export const GLOBAL_REPORT_INSIGHT_ROAS_DROP_TITLE =
  "globalReportInsightRoasDropTitle";
export const GLOBAL_REPORT_INSIGHT_ROAS_DROP_DESCRIPTION =
  "globalReportInsightRoasDropDescription";
export const GLOBAL_REPORT_INSIGHT_CPC_PEAK_TITLE =
  "globalReportInsightCpcPeakTitle";
export const GLOBAL_REPORT_INSIGHT_CPC_PEAK_DESCRIPTION =
  "globalReportInsightCpcPeakDescription";
export const GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_TITLE =
  "globalReportInsightVideoOutperformsTitle";
export const GLOBAL_REPORT_INSIGHT_VIDEO_OUTPERFORMS_DESCRIPTION =
  "globalReportInsightVideoOutperformsDescription";
export const GLOBAL_REPORT_ACTION_DATE_TODAY = "globalReportActionDateToday";
export const GLOBAL_REPORT_ACTION_DATE_YESTERDAY =
  "globalReportActionDateYesterday";
export const GLOBAL_REPORT_ACTION_DATE_MAR_26 = "globalReportActionDateMar26";
export const GLOBAL_REPORT_ACTION_DATE_MAR_25 = "globalReportActionDateMar25";
export const GLOBAL_REPORT_ACTION_CAMPAIGNS_CREATED =
  "globalReportActionCampaignsCreated";
export const GLOBAL_REPORT_ACTION_IMAGES_GENERATED =
  "globalReportActionImagesGenerated";
export const GLOBAL_REPORT_ACTION_VIDEOS_PRODUCED =
  "globalReportActionVideosProduced";
export const GLOBAL_REPORT_ACTION_OPTIMIZATION_APPLIED =
  "globalReportActionOptimizationApplied";
export const GLOBAL_REPORT_DEFAULT_BRAND_NAME = "globalReportDefaultBrandName";
export const GLOBAL_REPORT_STATS_TIME_TITLE = "globalReportStatsTimeTitle";
export const GLOBAL_REPORT_STATS_TIME_SUBTITLE =
  "globalReportStatsTimeSubtitle";
export const GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE =
  "globalReportStatsDailyResultsTitle";
export const GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE =
  "globalReportStatsWeeklyResultsTitle";
export const GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE =
  "globalReportStatsMonthlyResultsTitle";
export const GLOBAL_REPORT_STATS_DAILY_RESULTS_SUBTITLE =
  "globalReportStatsDailyResultsSubtitle";
export const GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE =
  "globalReportStatsWeeklyTimeSubtitle";
export const GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE =
  "globalReportStatsMonthlyTimeSubtitle";
export const GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_TITLE =
  "globalReportStatsImpressionsCtrTitle";
export const GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE =
  "globalReportStatsImpressionsCtrSubtitle";
export const GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE =
  "globalReportStatsWeeklyImpressionsCtrSubtitle";
export const GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE =
  "globalReportStatsMonthlyImpressionsCtrSubtitle";
export const GLOBAL_REPORT_STATS_PLATFORM_TITLE =
  "globalReportStatsPlatformTitle";
export const GLOBAL_REPORT_STATS_PLATFORM_SUBTITLE =
  "globalReportStatsPlatformSubtitle";
export const GLOBAL_REPORT_STATS_PLATFORM_CPA_TITLE =
  "globalReportStatsPlatformCpaTitle";
export const GLOBAL_REPORT_STATS_PLATFORM_SPEND_TITLE =
  "globalReportStatsPlatformSpendTitle";
export const GLOBAL_REPORT_STATS_CREATIVES_TITLE =
  "globalReportStatsCreativesTitle";
export const GLOBAL_REPORT_STATS_CREATIVES_SUBTITLE =
  "globalReportStatsCreativesSubtitle";
export const GLOBAL_REPORT_STATS_CREATIVES_LOWEST_CPA_TITLE =
  "globalReportStatsCreativesLowestCpaTitle";
export const GLOBAL_REPORT_STATS_CREATIVES_HIGHEST_VOLUME_TITLE =
  "globalReportStatsCreativesHighestVolumeTitle";
export const GLOBAL_REPORT_STATS_RADAR_TITLE = "globalReportStatsRadarTitle";
export const GLOBAL_REPORT_STATS_RADAR_SUBTITLE =
  "globalReportStatsRadarSubtitle";
export const GLOBAL_REPORT_STATS_BELOW_AVERAGE =
  "globalReportStatsBelowAverage";
export const GLOBAL_REPORT_STATS_ABOVE_AVERAGE =
  "globalReportStatsAboveAverage";
export const GLOBAL_REPORT_STATS_NO_DATA = "globalReportStatsNoData";
export const GLOBAL_REPORT_STATS_SPEND_AXIS = "globalReportStatsSpendAxis";
export const GLOBAL_REPORT_STATS_IMPRESSIONS_AXIS =
  "globalReportStatsImpressionsAxis";
export const GLOBAL_REPORT_STATS_SPEND_DISTRIBUTION =
  "globalReportStatsSpendDistribution";
export const GLOBAL_REPORT_GOALS_TITLE = "globalReportGoalsTitle";
export const GLOBAL_REPORT_GOALS_SUBTITLE = "globalReportGoalsSubtitle";
export const GLOBAL_REPORT_GOALS_STACKED_TITLE =
  "globalReportGoalsStackedTitle";
export const GLOBAL_REPORT_GOALS_STACKED_SUBTITLE =
  "globalReportGoalsStackedSubtitle";
export const GLOBAL_REPORT_GOALS_PROJECTION_TITLE =
  "globalReportGoalsProjectionTitle";
export const GLOBAL_REPORT_GOALS_PROJECTION_SUBTITLE =
  "globalReportGoalsProjectionSubtitle";
export const GLOBAL_REPORT_GOALS_ACHIEVED = "globalReportGoalsAchieved";
export const GLOBAL_REPORT_GOALS_REMAINING = "globalReportGoalsRemaining";
export const GLOBAL_REPORT_GOALS_EXCEEDED = "globalReportGoalsExceeded";
export const GLOBAL_REPORT_GOALS_PROJECTION_ACTUAL =
  "globalReportGoalsProjectionActual";
export const GLOBAL_REPORT_GOALS_PROJECTION_FORECAST =
  "globalReportGoalsProjectionForecast";
export const GLOBAL_REPORT_GOALS_TARGET_LINE = "globalReportGoalsTargetLine";
export const GLOBAL_REPORT_GOALS_CONFIGURE_PROMPT =
  "globalReportGoalsConfigurePrompt";
export const GLOBAL_REPORT_GOALS_CONFIGURE_BUTTON =
  "globalReportGoalsConfigureButton";
export const GLOBAL_REPORT_GOALS_KPI_MISMATCH_PROMPT =
  "globalReportGoalsKpiMismatchPrompt";

// CAMPAIGN APPROVAL
export const CAMPAIGN_APPROVAL_PAGE_TITLE = "campaignApprovalPageTitle";
export const CAMPAIGN_APPROVAL_PAGE_DESCRIPTION =
  "campaignApprovalPageDescription";
export const CAMPAIGN_APPROVAL_INVALID_TITLE = "campaignApprovalInvalidTitle";
export const CAMPAIGN_APPROVAL_INVALID_DESCRIPTION =
  "campaignApprovalInvalidDescription";
export const CAMPAIGN_APPROVAL_EXPIRED_TITLE = "campaignApprovalExpiredTitle";
export const CAMPAIGN_APPROVAL_EXPIRED_DESCRIPTION =
  "campaignApprovalExpiredDescription";
export const CAMPAIGN_APPROVAL_CONTENT_EMPTY = "campaignApprovalContentEmpty";
export const CAMPAIGN_APPROVAL_LOADING_FETCHING_CAMPAIGN_DATA =
  "campaignApprovalLoadingFetchingCampaignData";
export const CAMPAIGN_APPROVAL_LOADING_PREPARING_REVIEW =
  "campaignApprovalLoadingPreparingReview";
export const CAMPAIGN_APPROVAL_GENERAL_COMMENT_TITLE =
  "campaignApprovalGeneralCommentTitle";
export const CAMPAIGN_APPROVAL_GENERAL_COMMENT_DESCRIPTION =
  "campaignApprovalGeneralCommentDescription";
export const CAMPAIGN_APPROVAL_COMMENT_PLACEHOLDER =
  "campaignApprovalCommentPlaceholder";
export const CAMPAIGN_APPROVAL_COMMENT_BUTTON = "campaignApprovalCommentButton";
export const CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_TITLE =
  "campaignApprovalSpecificCommentTitle";
export const CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_DESCRIPTION =
  "campaignApprovalSpecificCommentDescription";
export const CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_PLACEHOLDER =
  "campaignApprovalSpecificCommentPlaceholder";
export const CAMPAIGN_APPROVAL_SPECIFIC_COMMENT_BUTTON =
  "campaignApprovalSpecificCommentButton";
export const CAMPAIGN_APPROVAL_DECISION_TITLE = "campaignApprovalDecisionTitle";
export const CAMPAIGN_APPROVAL_DECISION_DESCRIPTION =
  "campaignApprovalDecisionDescription";
export const CAMPAIGN_APPROVAL_DECISION_PLACEHOLDER =
  "campaignApprovalDecisionPlaceholder";
export const CAMPAIGN_APPROVAL_APPROVE_BUTTON = "campaignApprovalApproveButton";
export const CAMPAIGN_APPROVAL_REJECT_BUTTON = "campaignApprovalRejectButton";
export const CAMPAIGN_APPROVAL_TEXTS_TITLE = "campaignApprovalTextsTitle";
export const CAMPAIGN_APPROVAL_DESTINATION_TITLE =
  "campaignApprovalDestinationTitle";
export const CAMPAIGN_APPROVAL_LEAD_FORM_PREVIEW_UNAVAILABLE =
  "campaignApprovalLeadFormPreviewUnavailable";
export const CAMPAIGN_APPROVAL_CREATIVES_TITLE =
  "campaignApprovalCreativesTitle";
export const CAMPAIGN_APPROVAL_CREATIVE_TITLE = "campaignApprovalCreativeTitle";
export const CAMPAIGN_APPROVAL_SLIDE_LABEL = "campaignApprovalSlideLabel";
export const CAMPAIGN_APPROVAL_FIELD_TITLE_LABEL =
  "campaignApprovalFieldTitleLabel";
export const CAMPAIGN_APPROVAL_FIELD_HEADLINE_LABEL =
  "campaignApprovalFieldHeadlineLabel";
export const CAMPAIGN_APPROVAL_FIELD_LONG_HEADLINE_LABEL =
  "campaignApprovalFieldLongHeadlineLabel";
export const CAMPAIGN_APPROVAL_FIELD_DESCRIPTION_LABEL =
  "campaignApprovalFieldDescriptionLabel";
export const CAMPAIGN_APPROVAL_FIELD_CREATIVE_LABEL =
  "campaignApprovalFieldCreativeLabel";
export const CAMPAIGN_APPROVAL_LOCKED_STATUS_APPROVED =
  "campaignApprovalLockedStatusApproved";
export const CAMPAIGN_APPROVAL_LOCKED_STATUS_REJECTED =
  "campaignApprovalLockedStatusRejected";
export const CAMPAIGN_APPROVAL_LOCKED_STATUS_DECIDED =
  "campaignApprovalLockedStatusDecided";
export const CAMPAIGN_APPROVAL_TARGET_ENTITY_AD =
  "campaignApprovalTargetEntityAd";
export const CAMPAIGN_APPROVAL_TARGET_ENTITY_ASSETS_GROUP =
  "campaignApprovalTargetEntityAssetsGroup";
export const CAMPAIGN_APPROVAL_CONTROLS_TITLE = "campaignApprovalControlsTitle";
export const CAMPAIGN_APPROVAL_CONTROLS_DESCRIPTION =
  "campaignApprovalControlsDescription";
export const CAMPAIGN_APPROVAL_INACTIVE_DESCRIPTION =
  "campaignApprovalInactiveDescription";
export const CAMPAIGN_APPROVAL_STATE_INACTIVE = "campaignApprovalStateInactive";
export const CAMPAIGN_APPROVAL_STATE_ACTIVE = "campaignApprovalStateActive";
export const CAMPAIGN_APPROVAL_SHARED_LINK_LABEL =
  "campaignApprovalSharedLinkLabel";
export const CAMPAIGN_APPROVAL_CONFIRM_ENABLE_TITLE =
  "campaignApprovalConfirmEnableTitle";
export const CAMPAIGN_APPROVAL_CONFIRM_ENABLE_DESCRIPTION =
  "campaignApprovalConfirmEnableDescription";
export const CAMPAIGN_APPROVAL_ENABLE_BUTTON = "campaignApprovalEnableButton";
export const CAMPAIGN_APPROVAL_COPY_LINK_BUTTON =
  "campaignApprovalCopyLinkButton";
export const CAMPAIGN_APPROVAL_COPY_LINK_COPIED =
  "campaignApprovalCopyLinkCopied";
export const CAMPAIGN_APPROVAL_REJECTED_DESCRIPTION =
  "campaignApprovalRejectedDescription";
export const CAMPAIGN_APPROVAL_APPROVED_DESCRIPTION =
  "campaignApprovalApprovedDescription";
export const CAMPAIGN_APPROVAL_PENDING_DESCRIPTION =
  "campaignApprovalPendingDescription";
export const CAMPAIGN_APPROVAL_VIEW_COMMENTS_BUTTON =
  "campaignApprovalViewCommentsButton";
export const CAMPAIGN_APPROVAL_VIEW_REVIEW_BUTTON =
  "campaignApprovalViewReviewButton";
export const CAMPAIGN_APPROVAL_STATUS_PENDING = "campaignApprovalStatusPending";
export const CAMPAIGN_APPROVAL_STATUS_APPROVED =
  "campaignApprovalStatusApproved";
export const CAMPAIGN_APPROVAL_STATUS_REJECTED =
  "campaignApprovalStatusRejected";
export const GALLERY_CONTENT_APPROVAL_STATUS_REJECTED =
  "galleryContentApprovalStatusRejected";
export const CAMPAIGN_APPROVAL_PANEL_TITLE = "campaignApprovalPanelTitle";
export const CAMPAIGN_APPROVAL_PANEL_DESCRIPTION =
  "campaignApprovalPanelDescription";
export const CAMPAIGN_APPROVAL_PANEL_EMPTY = "campaignApprovalPanelEmpty";
export const CAMPAIGN_APPROVAL_PANEL_STALE_TOGGLE =
  "campaignApprovalPanelStaleToggle";
export const CAMPAIGN_APPROVAL_PANEL_CURRENT_DRAFT =
  "campaignApprovalPanelCurrentDraft";
export const CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_PENDING =
  "campaignApprovalMultiPanelTitlePending";
export const CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_APPROVED =
  "campaignApprovalMultiPanelTitleApproved";
export const CAMPAIGN_APPROVAL_MULTI_PANEL_TITLE_REJECTED =
  "campaignApprovalMultiPanelTitleRejected";
export const CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_PENDING =
  "campaignApprovalMultiPanelEmptyPending";
export const CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_APPROVED =
  "campaignApprovalMultiPanelEmptyApproved";
export const CAMPAIGN_APPROVAL_MULTI_PANEL_EMPTY_REJECTED =
  "campaignApprovalMultiPanelEmptyRejected";
export const CAMPAIGN_APPROVAL_STALE_LABEL = "campaignApprovalStaleLabel";
export const CAMPAIGN_APPROVAL_PUBLISH_BLOCKED_BANNER =
  "campaignApprovalPublishBlockedBanner";
export const CAMPAIGN_APPROVAL_AD_PREVIEW_TITLE =
  "campaignApprovalAdPreviewTitle";
export const CAMPAIGN_APPROVAL_AD_PREVIEW_ERROR =
  "campaignApprovalAdPreviewError";
export const CAMPAIGN_APPROVAL_SEND_FOR_REVIEW =
  "campaignApprovalSendForReview";
export const CONTENT_APPROVAL_PAGE_TITLE = "contentApprovalPageTitle";
export const CONTENT_APPROVAL_REPLACE_BUTTON = "contentApprovalReplaceButton";
export const CONTENT_APPROVAL_EDIT_BUTTON = "contentApprovalEditButton";
export const CONTENT_APPROVAL_SAVE_REVISION_BUTTON =
  "contentApprovalSaveRevisionButton";
export const CONTENT_APPROVAL_SAVE_REVISION_SUCCESS_DESCRIPTION =
  "contentApprovalSaveRevisionSuccessDescription";
export const CONTENT_APPROVAL_APPROVE_CONTENT_BUTTON =
  "contentApprovalApproveContentButton";
export const CONTENT_APPROVAL_SIDEBAR_TITLE = "contentApprovalSidebarTitle";
export const CONTENT_APPROVAL_ALL_GOOD_QUESTION =
  "contentApprovalAllGoodQuestion";
export const CONTENT_APPROVAL_CONFIRM_ENABLE_TITLE =
  "contentApprovalConfirmEnableTitle";
export const CONTENT_APPROVAL_CONFIRM_ENABLE_DESCRIPTION =
  "contentApprovalConfirmEnableDescription";
export const CONTENT_APPROVAL_ENABLE_SUCCESS_DESCRIPTION =
  "contentApprovalEnableSuccessDescription";
export const CAMPAIGN_APPROVAL_ENABLE_SUCCESS_DESCRIPTION =
  "campaignApprovalEnableSuccessDescription";
export const APPROVAL_ENABLE_SUCCESS_OR_SEPARATOR =
  "approvalEnableSuccessOrSeparator";
export const APPROVAL_REVIEW_EMAIL_LABEL = "approvalReviewEmailLabel";
export const APPROVAL_EMAIL_SEND_BUTTON = "approvalEmailSendButton";
export const APPROVAL_EMAIL_SEND_SENT = "approvalEmailSendSent";
export const APPROVAL_EMAIL_INVALID = "approvalEmailInvalid";
export const APPROVAL_REVIEWER_NOT_FOUND = "approvalReviewerNotFound";
export const APPROVAL_ADD_REVIEWER = "approvalAddReviewer";
export const APPROVAL_REVIEWER_LABEL = "approvalReviewerLabel";
export const APPROVAL_REVIEWER_MAX_REACHED = "approvalReviewerMaxReached";
export const APPROVAL_REVIEWER_EMAIL_DUPLICATED =
  "approvalReviewerEmailDuplicated";
export const APPROVAL_REVIEWER_ADDED_SUCCESS = "approvalReviewerAddedSuccess";
export const APPROVAL_REVIEWER_STATUS_PENDING = "approvalReviewerStatusPending";
export const APPROVAL_REVIEWER_STATUS_APPROVED =
  "approvalReviewerStatusApproved";
export const APPROVAL_REVIEWER_STATUS_REJECTED =
  "approvalReviewerStatusRejected";
export const APPROVAL_CURRENT_REVIEWER_LABEL = "approvalCurrentReviewerLabel";
export const APPROVAL_REVIEWING_AS_PREFIX = "approvalReviewingAsPrefix";
export const APPROVAL_REVIEWERS_SECTION_LABEL = "approvalReviewersSectionLabel";
export const APPROVAL_COMMENT_AUTHOR_LABEL = "approvalCommentAuthorLabel";
export const CONTENT_APPROVAL_SENT_DATE = "contentApprovalSentDate";
export const CONTENT_APPROVAL_CLIENT_COMMENTS_TITLE =
  "contentApprovalClientCommentsTitle";
export const CONTENT_APPROVAL_CLIENT_COMMENTS_EMPTY =
  "contentApprovalClientCommentsEmpty";
export const CONTENT_APPROVAL_REVIEWER_COMMENTS_EMPTY =
  "contentApprovalReviewerCommentsEmpty";
export const CONTENT_APPROVAL_COMMENT_PLACEHOLDER =
  "contentApprovalCommentPlaceholder";
export const CONTENT_APPROVAL_REVIEW_LINK_LABEL =
  "contentApprovalReviewLinkLabel";
export const CONTENT_APPROVAL_STATUS_SECTION_LABEL =
  "contentApprovalStatusSectionLabel";
export const CONTENT_APPROVAL_MAIN_CREATIVE_LABEL =
  "contentApprovalMainCreativeLabel";
export const CONTENT_APPROVAL_CREATIVE_CARD_TITLE =
  "contentApprovalCreativeCardTitle";
export const CONTENT_APPROVAL_CREATIVE_TYPE_LABEL =
  "contentApprovalCreativeTypeLabel";
export const CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER =
  "contentApprovalCommentCreativeNumber";
export const CONTENT_APPROVAL_CONFIRM_APPROVE_TITLE =
  "contentApprovalConfirmApproveTitle";
export const CONTENT_APPROVAL_CONFIRM_APPROVE_DESCRIPTION =
  "contentApprovalConfirmApproveDescription";
export const CONTENT_APPROVAL_APPROVE_BUTTON = "contentApprovalApproveButton";
export const CONTENT_APPROVAL_DECISION_APPROVED_SUCCESS =
  "contentApprovalDecisionApprovedSuccess";
export const CONTENT_APPROVAL_CONTENT_APPROVED_TITLE =
  "contentApprovalContentApprovedTitle";
export const CONTENT_APPROVAL_COMMENT_SENT_SUCCESS =
  "contentApprovalCommentSentSuccess";
export const CONTENT_APPROVAL_REVIEW_NEXT_CONTENT_BUTTON =
  "contentApprovalReviewNextContentButton";
export const CONTENT_APPROVAL_ANOTHER_COMMENT_BUTTON =
  "contentApprovalAnotherCommentButton";
export const CONTENT_APPROVAL_ALL_CONTENTS_REVIEWED =
  "contentApprovalAllContentsReviewed";
export const CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION =
  "contentApprovalReviewNextDescription";
export const CONTENT_APPROVAL_REVIEW_NEXT_DESCRIPTION_SINGLE =
  "contentApprovalReviewNextDescriptionSingle";
export const CONTENT_APPROVAL_LOCKED_STATUS_APPROVED =
  "contentApprovalLockedStatusApproved";
export const CONTENT_APPROVAL_INVALID_TITLE = "contentApprovalInvalidTitle";
export const CONTENT_APPROVAL_INVALID_DESCRIPTION =
  "contentApprovalInvalidDescription";
export const CONTENT_APPROVAL_EXPIRED_TITLE = "contentApprovalExpiredTitle";
export const CONTENT_APPROVAL_EXPIRED_DESCRIPTION =
  "contentApprovalExpiredDescription";
export const CONTENT_APPROVAL_LOADING_VALIDATING_LINK =
  "contentApprovalLoadingValidatingLink";
export const CONTENT_APPROVAL_LOADING_FETCHING_CREATIVES =
  "contentApprovalLoadingFetchingCreatives";
export const CONTENT_APPROVAL_LOADING_PREPARING_REVIEW =
  "contentApprovalLoadingPreparingReview";
export const CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE =
  "campaignApprovalPublishNotApprovedTitle";
export const CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION =
  "campaignApprovalPublishNotApprovedDescription";
export const CAMPAIGN_APPROVAL_READY_TO_DECIDE =
  "campaignApprovalReadyToDecide";
export const CAMPAIGN_APPROVAL_COMMENTS_LEFT = "campaignApprovalCommentsLeft";
export const CAMPAIGN_APPROVAL_AD_SET_LABEL = "campaignApprovalAdSetLabel";
export const CAMPAIGN_APPROVAL_ADS_COUNT = "campaignApprovalAdsCount";
export const CAMPAIGN_APPROVAL_ADS_COUNT_SINGLE =
  "campaignApprovalAdsCountSingle";
export const CAMPAIGN_APPROVAL_SIDEBAR_CAMPAIGNS =
  "campaignApprovalSidebarCampaigns";
export const CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS =
  "campaignApprovalSidebarAdSets";
export const CAMPAIGN_APPROVAL_SIDEBAR_AD_SETS_SINGLE =
  "campaignApprovalSidebarAdSetsSingle";
export const CAMPAIGN_APPROVAL_SIDEBAR_ADS = "campaignApprovalSidebarAds";
export const CAMPAIGN_APPROVAL_SIDEBAR_ADS_SINGLE =
  "campaignApprovalSidebarAdsSingle";
export const CAMPAIGN_APPROVAL_SIDEBAR_TEXTS = "campaignApprovalSidebarTexts";
export const CAMPAIGN_APPROVAL_SIDEBAR_TEXTS_SINGLE =
  "campaignApprovalSidebarTextsSingle";
export const CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES =
  "campaignApprovalSidebarCreatives";
export const CAMPAIGN_APPROVAL_SIDEBAR_CREATIVES_SINGLE =
  "campaignApprovalSidebarCreativesSingle";
export const CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT =
  "campaignApprovalEntityTextsCount";
export const CAMPAIGN_APPROVAL_ENTITY_TEXTS_COUNT_SINGLE =
  "campaignApprovalEntityTextsCountSingle";
export const CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT =
  "campaignApprovalEntityCreativesCount";
export const CAMPAIGN_APPROVAL_ENTITY_CREATIVES_COUNT_SINGLE =
  "campaignApprovalEntityCreativesCountSingle";
export const CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT =
  "campaignApprovalEntityCommentsCount";
export const CAMPAIGN_APPROVAL_ENTITY_COMMENTS_COUNT_SINGLE =
  "campaignApprovalEntityCommentsCountSingle";
export const CAMPAIGN_APPROVAL_REJECT_REQUIRES_COMMENT =
  "campaignApprovalRejectRequiresComment";
export const CAMPAIGN_APPROVAL_COMMENT_SEND_HINT =
  "campaignApprovalCommentSendHint";
export const CAMPAIGN_APPROVAL_APPROVE_CAMPAIGN_BUTTON =
  "campaignApprovalApproveCampaignButton";
export const CAMPAIGN_APPROVAL_CONFIRM_APPROVE_TITLE =
  "campaignApprovalConfirmApproveTitle";
export const CAMPAIGN_APPROVAL_CONFIRM_APPROVE_DESCRIPTION =
  "campaignApprovalConfirmApproveDescription";
export const CAMPAIGN_APPROVAL_CONFIRM_REJECT_TITLE =
  "campaignApprovalConfirmRejectTitle";
export const CAMPAIGN_APPROVAL_CONFIRM_REJECT_DESCRIPTION =
  "campaignApprovalConfirmRejectDescription";
export const CAMPAIGN_APPROVAL_DECISION_APPROVED_SUCCESS =
  "campaignApprovalDecisionApprovedSuccess";
export const CAMPAIGN_APPROVAL_DECISION_REJECTED_SUCCESS =
  "campaignApprovalDecisionRejectedSuccess";

export const TEMPLATES_MENU_ITEM = "templatesMenuItem";
export const TEMPLATES_TITLE = "templatesTitle";
export const TEMPLATE = "template";
export const TEMPLATES_SEARCH_PLACEHOLDER = "templatesSearchPlaceholder";
export const TEMPLATES_SEARCH_NO_RESULTS = "templatesSearchNoResults";
export const TEMPLATES_SORT_NEWEST_FIRST = "templatesSortNewestFirst";
export const TEMPLATES_SORT_OLDEST_FIRST = "templatesSortOldestFirst";
export const TEMPLATES_SORT_NAME_ASC = "templatesSortNameAsc";
export const TEMPLATES_SORT_NAME_DESC = "templatesSortNameDesc";
export const TEMPLATES_DESCRIPTION = "templatesDescription";
export const TEMPLATES_BUTTON_UPLOAD = "templatesButtonUpload";
export const TEMPLATES_UPLOAD_FROM_GALLERY = "templatesUploadFromGallery";
export const TEMPLATES_UPLOAD_FROM_DEVICE = "templatesUploadFromDevice";
export const TEMPLATES_BUTTON_CREATE = "templatesButtonCreate";
export const TEMPLATES_LAYOUT_KIND_IMAGE = "templatesLayoutKindImage";
export const TEMPLATES_LAYOUT_KIND_CAROUSEL = "templatesLayoutKindCarousel";
export const TEMPLATES_CREATE_KIND_TITLE = "templatesCreateKindTitle";
export const TEMPLATES_CREATE_KIND_DESCRIPTION =
  "templatesCreateKindDescription";
export const TEMPLATES_CREATE_KIND_SINGLE = "templatesCreateKindSingle";
export const TEMPLATES_CREATE_KIND_CAROUSEL = "templatesCreateKindCarousel";
export const TEMPLATES_CREATE_KIND_SLIDE_COUNT =
  "templatesCreateKindSlideCount";
export const TEMPLATES_SLIDE_LABEL = "templatesSlideLabel";
export const TEMPLATES_ADD_SLIDE = "templatesAddSlide";
export const TEMPLATES_DUPLICATE_SLIDE = "templatesDuplicateSlide";
export const TEMPLATES_DELETE_SLIDE = "templatesDeleteSlide";
export const TEMPLATES_SLIDES_ROW = "templatesSlidesRow";
export const TEMPLATES_CAROUSEL_TYPE = "templatesCarouselType";
export const TEMPLATES_CONTINUOUS_SETUP_TITLE = "templatesContinuousSetupTitle";
export const TEMPLATES_CONTINUOUS_SETUP_SLIDES =
  "templatesContinuousSetupSlides";
export const TEMPLATES_CONTINUOUS_SETUP_FORMAT =
  "templatesContinuousSetupFormat";
export const TEMPLATES_LAYOUT_KIND_CONTINUOUS = "templatesLayoutKindContinuous";
export const TEMPLATES_LAYOUT_KIND_INDIVIDUAL = "templatesLayoutKindIndividual";
export const TEMPLATES_LAYOUT_KIND_INDIVIDUAL_TOOLTIP =
  "templatesLayoutKindIndividualTooltip";
export const TEMPLATES_LAYOUT_KIND_CONTINUOUS_TOOLTIP =
  "templatesLayoutKindContinuousTooltip";
export const TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_HINT =
  "templatesLayoutKindToIndividualHint";
export const TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_HINT =
  "templatesLayoutKindToContinuousHint";
export const TEMPLATES_LAYOUT_KIND_TO_INDIVIDUAL_BLOCKED =
  "templatesLayoutKindToIndividualBlocked";
export const TEMPLATES_LAYOUT_KIND_TO_CONTINUOUS_BLOCKED =
  "templatesLayoutKindToContinuousBlocked";
export const TEMPLATES_CONFIRM_DELETE_STRIP_SLIDE_DESCRIPTION =
  "templatesConfirmDeleteStripSlideDescription";
export const TEMPLATES_STRIP_FORMAT_TOO_LARGE = "templatesStripFormatTooLarge";
export const TEMPLATES_FORMATS_ROW = "templatesFormatsRow";
export const TEMPLATES_CAROUSEL_CHIP = "templatesCarouselChip";
export const TEMPLATES_CONTINUOUS_CAROUSEL_CHIP =
  "templatesContinuousCarouselChip";
export const TEMPLATES_EMPTY = "templatesEmpty";
export const TEMPLATES_FOLDER_EMPTY = "templatesFolderEmpty";
export const TEMPLATES_EMPTY_CANVAS_HINT = "templatesEmptyCanvasHint";
export const TEMPLATES_EMPTY_ADD_LAYER = "templatesEmptyAddLayer";
export const TEMPLATES_BACKGROUND_LAYER = "templatesBackgroundLayer";
export const TEMPLATES_ANALYZE_ERROR = "templatesAnalyzeError";
export const TEMPLATES_ANALYZE_IMAGE_TOO_SMALL =
  "templatesAnalyzeImageTooSmall";
export const TEMPLATES_ANALYZE_RETRY = "templatesAnalyzeRetry";
export const TEMPLATES_CREATE_ERROR = "templatesCreateError";
export const TEMPLATES_OPEN = "templatesOpen";
export const TEMPLATES_DUPLICATE = "templatesDuplicate";
export const TEMPLATES_DELETE = "templatesDelete";
export const TEMPLATES_DELETE_ERROR = "templatesDeleteError";
export const TEMPLATES_SAVE = "templatesSave";
export const TEMPLATES_USAGE_GUIDE = "templatesUsageGuide";
export const TEMPLATES_GUIDE_PDF_URL = "templatesGuidePdfUrl";
export const TEMPLATES_GUIDE_VIDEO_URL = "templatesGuideVideoUrl";
export const TEMPLATES_BACK = "templatesBack";
export const TEMPLATES_NAME = "templatesName";
export const TEMPLATES_UNTITLED = "templatesUntitled";
export const TEMPLATES_ZONES = "templatesZones";
export const TEMPLATES_LAYERS = "templatesLayers";
export const TEMPLATES_PROPERTIES = "templatesProperties";
export const TEMPLATES_NO_SELECTION = "templatesNoSelection";
export const TEMPLATES_ADD_LAYER = "templatesAddLayer";
export const TEMPLATES_ZONE_NAME = "templatesZoneName";
export const TEMPLATES_LAYER_NAME = "templatesLayerName";
export const TEMPLATES_ZONE_TYPE = "templatesZoneType";
export const TEMPLATES_ZONE_SOURCE = "templatesZoneSource";
export const TEMPLATES_TYPE_TEXT = "templatesTypeText";
export const TEMPLATES_TYPE_IMAGE = "templatesTypeImage";
export const TEMPLATES_TYPE_SHAPE = "templatesTypeShape";
export const TEMPLATES_TYPE_GROUP = "templatesTypeGroup";
export const TEMPLATES_SOURCE_ASSET = "templatesSourceAsset";
export const TEMPLATES_SOURCE_DATA = "templatesSourceData";
export const TEMPLATES_SOURCE_GENERATED = "templatesSourceGenerated";
export const TEMPLATES_SOURCE_FIXED = "templatesSourceFixed";
export const TEMPLATES_SOURCE_COMPUTED = "templatesSourceComputed";
export const TEMPLATES_SOURCE_ASSET_HINT = "templatesSourceAssetHint";
export const TEMPLATES_SOURCE_DATA_HINT = "templatesSourceDataHint";
export const TEMPLATES_SOURCE_GENERATED_HINT = "templatesSourceGeneratedHint";
export const TEMPLATES_SOURCE_COMPUTED_HINT = "templatesSourceComputedHint";
export const TEMPLATES_FIXED_VALUE = "templatesFixedValue";
export const TEMPLATES_FIXED_VALUE_PLACEHOLDER =
  "templatesFixedValuePlaceholder";
export const TEMPLATES_LAYER_TEXT = "templatesLayerText";
export const TEMPLATES_STYLE = "templatesStyle";
export const TEMPLATES_ORIGIN_TEXT = "templatesOriginText";
export const TEMPLATES_EXPRESSION = "templatesExpression";
export const TEMPLATES_VARIABLE = "templatesVariable";
export const TEMPLATES_PROMPT = "templatesPrompt";
export const TEMPLATES_GENERATE_PROMPT = "templatesGeneratePrompt";
export const TEMPLATES_GENERATE_PROMPT_ERROR = "templatesGeneratePromptError";
export const TEMPLATES_GENERATE_PROMPT_NO_EXAMPLE =
  "templatesGeneratePromptNoExample";
export const TEMPLATES_SAVE_PROMPT = "templatesSavePrompt";
export const TEMPLATES_SAVE_PROMPT_TITLE = "templatesSavePromptTitle";
export const TEMPLATES_SAVE_PROMPT_ERROR = "templatesSavePromptError";
export const TEMPLATES_SAVE_PROMPT_SUCCESS = "templatesSavePromptSuccess";
export const TEMPLATES_IMPORT_PROMPT = "templatesImportPrompt";
export const TEMPLATES_IMPORT_PROMPT_TITLE = "templatesImportPromptTitle";
export const TEMPLATES_IMPORT_SELECTED = "templatesImportSelected";
export const TEMPLATES_IMPORT_PROMPT_EMPTY = "templatesImportPromptEmpty";
export const TEMPLATES_IMPORT_PROMPT_ERROR = "templatesImportPromptError";
export const TEMPLATES_DELETE_PROMPT = "templatesDeletePrompt";
export const TEMPLATES_DELETE_PROMPT_ERROR = "templatesDeletePromptError";
export const TEMPLATES_TRY_LAYER = "templatesTryLayer";
export const TEMPLATES_TRY_LAYER_ERROR = "templatesTryLayerError";
export const TEMPLATES_IS_BACKGROUND = "templatesIsBackground";
export const TEMPLATES_NEGATIVE_PROMPT = "templatesNegativePrompt";
export const TEMPLATES_ASSET_REF = "templatesAssetRef";
export const TEMPLATES_SELECT_ASSET = "templatesSelectAsset";
export const TEMPLATES_CHANGE_ASSET = "templatesChangeAsset";
export const TEMPLATES_FIT = "templatesFit";
export const TEMPLATES_SHAPE_FILL = "templatesShapeFill";
export const TEMPLATES_SHAPE_RADIUS = "templatesShapeRadius";
export const TEMPLATES_FONT_SIZE = "templatesFontSize";
export const TEMPLATES_FONT_COLOR = "templatesFontColor";
export const TEMPLATES_STROKE_WIDTH = "templatesStrokeWidth";
export const TEMPLATES_STROKE_METRIC = "templatesStrokeMetric";
export const TEMPLATES_SHADOW = "templatesShadow";
export const TEMPLATES_SHADOW_ANGLE = "templatesShadowAngle";
export const TEMPLATES_SHADOW_DISTANCE = "templatesShadowDistance";
export const TEMPLATES_SHADOW_BLUR = "templatesShadowBlur";
export const TEMPLATES_PRESETS = "templatesPresets";
export const TEMPLATES_SHADOW_PRESET_SOFT = "templatesShadowPresetSoft";
export const TEMPLATES_SHADOW_PRESET_LIFT = "templatesShadowPresetLift";
export const TEMPLATES_SHADOW_PRESET_HARD = "templatesShadowPresetHard";
export const TEMPLATES_SHADOW_PRESET_GLOW = "templatesShadowPresetGlow";
export const TEMPLATES_STROKE_COLOR = "templatesStrokeColor";
export const TEMPLATES_BACKGROUND_PADDING = "templatesBackgroundPadding";
export const TEMPLATES_BACKGROUND_SEPARATION = "templatesBackgroundSeparation";
export const TEMPLATES_BACKGROUND_RADIUS = "templatesBackgroundRadius";
export const TEMPLATES_BACKGROUND_COLOR = "templatesBackgroundColor";
export const TEMPLATES_PAINT_SETTINGS = "templatesPaintSettings";
export const TEMPLATES_HIGHLIGHTS_TITLE = "templatesHighlightsTitle";
export const TEMPLATES_HIGHLIGHTS_HINT = "templatesHighlightsHint";
export const TEMPLATES_HIGHLIGHTS_ADD = "templatesHighlightsAdd";
export const TEMPLATES_HIGHLIGHTS_REMOVE = "templatesHighlightsRemove";
export const TEMPLATES_HIGHLIGHTS_KIND_FILL = "templatesHighlightsKindFill";
export const TEMPLATES_HIGHLIGHTS_KIND_STROKE = "templatesHighlightsKindStroke";
export const TEMPLATES_HIGHLIGHTS_KIND_BACKGROUND =
  "templatesHighlightsKindBackground";
export const TEMPLATES_HIGHLIGHTS_PHRASE = "templatesHighlightsPhrase";
export const TEMPLATES_HIGHLIGHTS_PHRASE_INVALID =
  "templatesHighlightsPhraseInvalid";
export const TEMPLATES_HIGHLIGHTS_CAPTURE = "templatesHighlightsCapture";
export const TEMPLATES_HIGHLIGHTS_CAPTURING = "templatesHighlightsCapturing";
export const TEMPLATES_INLINE_REPLACEMENTS_TITLE =
  "templatesInlineReplacementsTitle";
export const TEMPLATES_INLINE_REPLACEMENTS_HINT =
  "templatesInlineReplacementsHint";
export const TEMPLATES_INLINE_REPLACEMENTS_ADD =
  "templatesInlineReplacementsAdd";
export const TEMPLATES_INLINE_REPLACEMENTS_REMOVE =
  "templatesInlineReplacementsRemove";
export const TEMPLATES_INLINE_REPLACEMENTS_PHRASE =
  "templatesInlineReplacementsPhrase";
export const TEMPLATES_LINE_SPACING = "templatesLineSpacing";
export const TEMPLATES_LETTER_SPACING = "templatesLetterSpacing";
export const TEMPLATES_FONT_FAMILY = "templatesFontFamily";
export const TEMPLATES_FONT_FACE = "templatesFontFace";
export const TEMPLATES_TEXT_STYLE = "templatesTextStyle";
export const TEMPLATES_TEXT_STYLE_NORMAL = "templatesTextStyleNormal";
export const TEMPLATES_TEXT_STYLE_ITALIC = "templatesTextStyleItalic";
export const TEMPLATES_TEXT_STYLE_UNDERLINE = "templatesTextStyleUnderline";
export const TEMPLATES_TEXT_STYLE_ITALIC_UNDERLINE =
  "templatesTextStyleItalicUnderline";
export const TEMPLATES_ADD_FONT = "templatesAddFont";
export const TEMPLATES_ADD_FONT_TITLE = "templatesAddFontTitle";
export const TEMPLATES_ADD_FONT_NAME = "templatesAddFontName";
export const TEMPLATES_ADD_FONT_NAME_HINT = "templatesAddFontNameHint";
export const TEMPLATES_ADD_FONT_FILE = "templatesAddFontFile";
export const TEMPLATES_ADD_FONT_SELECT_FILE = "templatesAddFontSelectFile";
export const TEMPLATES_ADD_FONT_ERROR = "templatesAddFontError";
export const TEMPLATES_ADD_FONT_INVALID_FILE = "templatesAddFontInvalidFile";
export const TEMPLATES_ADD_FONT_INVALID_NAME = "templatesAddFontInvalidName";
export const TEMPLATES_ADD_FONT_MATCH_HINT = "templatesAddFontMatchHint";
export const TEMPLATES_ADD_FONT_PARSE_FAILED = "templatesAddFontParseFailed";
export const TEMPLATES_ADD_FONT_PARTIAL_ERROR = "templatesAddFontPartialError";
export const TEMPLATES_ADD_FONT_VARIABLE = "templatesAddFontVariable";
export const TEMPLATES_ADD_FONT_SUMMARY = "templatesAddFontSummary";
export const TEMPLATES_ADD_FONT_SUMMARY_FAMILY =
  "templatesAddFontSummaryFamily";
export const TEMPLATES_ADD_FONT_SUMMARY_STYLE = "templatesAddFontSummaryStyle";
export const TEMPLATES_ADD_FONT_SUMMARY_KIND = "templatesAddFontSummaryKind";
export const TEMPLATES_ADD_FONT_SUMMARY_STATIC =
  "templatesAddFontSummaryStatic";
export const TEMPLATES_ADD_FONT_SUMMARY_STYLES =
  "templatesAddFontSummaryStyles";
export const TEMPLATES_ADD_FONT_SUMMARY_HINT = "templatesAddFontSummaryHint";
export const TEMPLATES_ADD_FONT_CHANGE_FILE = "templatesAddFontChangeFile";
export const TEMPLATES_ALIGN = "templatesAlign";
export const TEMPLATES_ALIGN_LEFT = "templatesAlignLeft";
export const TEMPLATES_ALIGN_CENTER = "templatesAlignCenter";
export const TEMPLATES_ALIGN_RIGHT = "templatesAlignRight";
export const TEMPLATES_ALIGN_TOP = "templatesAlignTop";
export const TEMPLATES_ALIGN_MIDDLE = "templatesAlignMiddle";
export const TEMPLATES_ALIGN_BOTTOM = "templatesAlignBottom";
export const TEMPLATES_ALIGN_LAYERS = "templatesAlignLayers";
export const TEMPLATES_LOCK_LAYER = "templatesLockLayer";
export const TEMPLATES_UNLOCK_LAYER = "templatesUnlockLayer";
export const TEMPLATES_HIDE_LAYER = "templatesHideLayer";
export const TEMPLATES_SHOW_LAYER = "templatesShowLayer";
export const TEMPLATES_ALIGNMENT_GUIDES = "templatesAlignmentGuides";
export const TEMPLATES_GUIDE_OPACITY = "templatesGuideOpacity";
export const TEMPLATES_ORIENTATION = "templatesOrientation";
export const TEMPLATES_ORIENTATION_HORIZONTAL =
  "templatesOrientationHorizontal";
export const TEMPLATES_ORIENTATION_VERTICAL = "templatesOrientationVertical";
export const TEMPLATES_ORIENTATION_VERTICAL_UP =
  "templatesOrientationVerticalUp";
export const TEMPLATES_OVERFLOW = "templatesOverflow";
export const TEMPLATES_MAX_LINES = "templatesMaxLines";
export const TEMPLATES_MIN_LINES = "templatesMinLines";
export const TEMPLATES_MIN_FONT = "templatesMinFont";
export const TEMPLATES_POSITION = "templatesPosition";
export const TEMPLATES_SIZE = "templatesSize";
export const TEMPLATES_POS_X = "templatesPosX";
export const TEMPLATES_POS_Y = "templatesPosY";
export const TEMPLATES_POS_W = "templatesPosW";
export const TEMPLATES_POS_H = "templatesPosH";
export const TEMPLATES_FRAME_W = "templatesFrameW";
export const TEMPLATES_FRAME_H = "templatesFrameH";
export const TEMPLATES_CLIP = "templatesClip";
export const TEMPLATES_HIDE = "templatesHide";
export const TEMPLATES_SHOW = "templatesShow";
export const TEMPLATES_MIN_SIZE = "templatesMinSize";
export const TEMPLATES_PADDING = "templatesPadding";
export const TEMPLATES_DRAW = "templatesDraw";
export const TEMPLATES_DRAWING = "templatesDrawing";
export const TEMPLATES_DRAW_HINT = "templatesDrawHint";
export const TEMPLATES_OVERFLOW_SHRINK = "templatesOverflowShrink";
export const TEMPLATES_OVERFLOW_REJECT = "templatesOverflowReject";
export const TEMPLATES_BACKDROP_NOTE = "templatesBackdropNote";
export const TEMPLATES_NODE_COUNT = "templatesNodeCount";
export const TEMPLATES_NODE_COUNT_SINGLE = "templatesNodeCountSingle";
export const TEMPLATES_ARTBOARD = "templatesArtboard";
export const TEMPLATES_ADD_FORMAT = "templatesAddFormat";
export const TEMPLATES_CUSTOM_FORMAT = "templatesCustomFormat";
export const TEMPLATES_CUSTOM_FORMAT_TITLE = "templatesCustomFormatTitle";
export const TEMPLATES_CUSTOM_WIDTH = "templatesCustomWidth";
export const TEMPLATES_CUSTOM_HEIGHT = "templatesCustomHeight";
export const TEMPLATES_CUSTOM_SIZE_INVALID = "templatesCustomSizeInvalid";
export const TEMPLATES_EDIT_PREVIOUS = "templatesEditPrevious";
export const TEMPLATES_NEW_FORMAT_HINT = "templatesNewFormatHint";
export const TEMPLATES_REMOVE_FORMAT = "templatesRemoveFormat";
export const TEMPLATES_THIS_FORMAT = "templatesThisFormat";
export const TEMPLATES_UPLOAD_REFERENCE = "templatesUploadReference";
export const TEMPLATES_CHANGE_REFERENCE = "templatesChangeReference";
export const TEMPLATES_SHOW_GUIDE = "templatesShowGuide";
export const TEMPLATES_HIDE_GUIDE = "templatesHideGuide";
export const TEMPLATES_GUIDE_HINT = "templatesGuideHint";
export const TEMPLATES_EDITOR_PREVIEW_VARIABLES_TITLE =
  "templatesEditorPreviewVariablesTitle";
export const TEMPLATES_EDITOR_PREVIEW_VARIABLES_DESCRIPTION =
  "templatesEditorPreviewVariablesDescription";
export const TEMPLATES_EDITOR_PREVIEW_ERROR = "templatesEditorPreviewError";
export const TEMPLATES_EDITOR_PREVIEW_TITLE = "templatesEditorPreviewTitle";
export const TEMPLATES_EDITOR_PREVIEW_USED_VALUES =
  "templatesEditorPreviewUsedValues";
export const TEMPLATES_EDITOR_PREVIEW_SAVED_TO_GALLERY =
  "templatesEditorPreviewSavedToGallery";
export const TEMPLATES_ZOOM_IN = "templatesZoomIn";
export const TEMPLATES_ZOOM_OUT = "templatesZoomOut";
export const TEMPLATES_ZOOM_FIT = "templatesZoomFit";
export const TEMPLATES_TEXT_COLLISION_ONE = "templatesTextCollisionOne";
export const TEMPLATES_TEXT_COLLISION_OTHER = "templatesTextCollisionOther";
export const TEMPLATES_TEXT_COLLISION_UNNAMED_TEXT =
  "templatesTextCollisionUnnamedText";
export const TEMPLATES_TEXT_COLLISION_UNNAMED_IMAGE =
  "templatesTextCollisionUnnamedImage";
export const CANVAS_TOOLS_BAR_LABEL = "canvasToolsBarLabel";
export const CANVAS_TOOL_ERASER = "canvasToolEraser";
export const CANVAS_TOOL_ERASER_HINT = "canvasToolEraserHint";
export const CANVAS_TOOL_ERASER_BRUSH_SIZE = "canvasToolEraserBrushSize";
export const CANVAS_TOOL_ERASER_APPLY = "canvasToolEraserApply";
export const TEMPLATES_UNAUTHORIZED = "templatesUnauthorized";
export const TEMPLATES_ANALYZING_LOCK = "templatesAnalyzingLock";
export const TEMPLATES_SAVE_SUCCESS = "templatesSaveSuccess";
export const TEMPLATES_UPLOAD_ERROR = "templatesUploadError";
export const TEMPLATES_SAVE_ERROR = "templatesSaveError";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE =
  "templatesSaveVariablesMismatchTitle";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_TITLE_CAROUSEL =
  "templatesSaveVariablesMismatchTitleCarousel";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION =
  "templatesSaveVariablesMismatchDescription";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_DESCRIPTION_CAROUSEL =
  "templatesSaveVariablesMismatchDescriptionCarousel";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_ARIA_LABEL =
  "templatesSaveVariablesMismatchAriaLabel";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_FORMAT =
  "templatesSaveVariablesMismatchColumnFormat";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_TYPE =
  "templatesSaveVariablesMismatchColumnType";
export const TEMPLATES_SAVE_VARIABLES_MISMATCH_COLUMN_VARIABLE =
  "templatesSaveVariablesMismatchColumnVariable";
export const TEMPLATES_SAVE_TRANSPARENCY_GAP_TITLE =
  "templatesSaveTransparencyGapTitle";
export const TEMPLATES_SAVE_TRANSPARENCY_GAP_DESCRIPTION =
  "templatesSaveTransparencyGapDescription";
export const TEMPLATES_CONFIRM_DELETE_TITLE = "templatesConfirmDeleteTitle";
export const TEMPLATES_CONFIRM_DELETE_DESCRIPTION =
  "templatesConfirmDeleteDescription";
export const TEMPLATES_CONFIRM_REMOVE_FORMAT_TITLE =
  "templatesConfirmRemoveFormatTitle";
export const TEMPLATES_CONFIRM_REMOVE_FORMAT_DESCRIPTION =
  "templatesConfirmRemoveFormatDescription";
export const TEMPLATES_CONFIRM_ADD_FORMAT = "templatesConfirmAddFormat";
export const TEMPLATES_CONFIRM_ADD_FORMAT_DESCRIPTION =
  "templatesConfirmAddFormatDescription";
export const TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND =
  "templatesConfirmAiResizeBackground";
export const TEMPLATES_CONFIRM_AI_RESIZE_BACKGROUND_DESCRIPTION =
  "templatesConfirmAiResizeBackgroundDescription";
export const TEMPLATES_AI_RESIZE_BACKGROUND_CONFIRM =
  "templatesAiResizeBackgroundConfirm";
export const TEMPLATES_AI_RESIZE_BACKGROUND_LOCK =
  "templatesAiResizeBackgroundLock";
export const TEMPLATES_KEEP_EDITING = "templatesKeepEditing";
export const TEMPLATES_CLOSE_UNSAVED_DESCRIPTION =
  "templatesCloseUnsavedDescription";
export const TEMPLATES_PRODUCE_DRAFT_TITLE = "templatesProduceDraftTitle";
export const TEMPLATES_PRODUCE_DRAFT_DESCRIPTION =
  "templatesProduceDraftDescription";
export const TEMPLATES_PRODUCE_DRAFT_COMPLETE = "templatesProduceDraftComplete";
export const TEMPLATES_SAVE_BLOCKED_PRODUCING = "templatesSaveBlockedProducing";
export const TEMPLATES_SAVE_PRODUCE_TITLE = "templatesSaveProduceTitle";
export const TEMPLATES_SAVE_PRODUCE_DESCRIPTION =
  "templatesSaveProduceDescription";
export const TEMPLATES_SAVE_PRODUCE_CONFIRM = "templatesSaveProduceConfirm";
export const TEMPLATES_SAVE_PRODUCE_CANCEL = "templatesSaveProduceCancel";
export const TEMPLATES_NEW_ZONE = "templatesNewZone";
export const TEMPLATES_NEW_LAYER = "templatesNewLayer";
export const TEMPLATES_PRODUCE_MENU_ITEM = "templatesProduceMenuItem";
export const TEMPLATES_PRODUCE_TITLE = "templatesProduceTitle";
export const TEMPLATES_PRODUCE_DESCRIPTION = "templatesProduceDescription";
export const TEMPLATES_PRODUCE_CONFIG_KICKER = "templatesProduceConfigKicker";
export const TEMPLATES_PRODUCE_SELECTED_TEMPLATE_LABEL =
  "templatesProduceSelectedTemplateLabel";
export const TEMPLATES_PRODUCE_VARIABLES_EYEBROW =
  "templatesProduceVariablesEyebrow";
export const TEMPLATES_PRODUCE_SUMMARY_IMAGE_UNIT =
  "templatesProduceSummaryImageUnit";
export const TEMPLATES_PRODUCE_SUMMARY_IMAGES_UNIT =
  "templatesProduceSummaryImagesUnit";
export const TEMPLATES_PRODUCE_SUMMARY_VARIATION_LABEL =
  "templatesProduceSummaryVariationLabel";
export const TEMPLATES_PRODUCE_SUMMARY_VARIATIONS_LABEL =
  "templatesProduceSummaryVariationsLabel";
export const TEMPLATES_PRODUCE_SUMMARY_COST = "templatesProduceSummaryCost";
export const TEMPLATES_PRODUCE_SUMMARY_COST_LABEL =
  "templatesProduceSummaryCostLabel";
export const TEMPLATES_PRODUCE_SUMMARY_RATE = "templatesProduceSummaryRate";
export const TEMPLATES_PRODUCE_SUMMARY_FORMAT = "templatesProduceSummaryFormat";
export const TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT =
  "templatesProduceSummaryImagesCount";
export const TEMPLATES_PRODUCE_SUMMARY_IMAGES_COUNT_SINGLE =
  "templatesProduceSummaryImagesCountSingle";
export const TEMPLATES_PRODUCE_SUMMARY_SIZE_COUNT =
  "templatesProduceSummarySizeCount";
export const TEMPLATES_PRODUCE_SUMMARY_SIZES_COUNT =
  "templatesProduceSummarySizesCount";
export const TEMPLATES_PRODUCE_SUMMARY_SLIDE_COUNT =
  "templatesProduceSummarySlideCount";
export const TEMPLATES_PRODUCE_SUMMARY_SLIDES_COUNT =
  "templatesProduceSummarySlidesCount";
export const TEMPLATES_PRODUCE_ROW_COUNT = "templatesProduceRowCount";
export const TEMPLATES_PRODUCE_ROW_COUNT_SINGLE =
  "templatesProduceRowCountSingle";
export const TEMPLATES_PRODUCE_TEMPLATE = "templatesProduceTemplate";
export const TEMPLATES_PRODUCE_CHANGE = "templatesProduceChange";
export const TEMPLATES_PRODUCE_DIMENSIONS = "templatesProduceDimensions";
export const TEMPLATES_PRODUCE_LANGUAGE = "templatesProduceLanguage";
export const TEMPLATES_PRODUCE_VARIATIONS = "templatesProduceVariations";
export const TEMPLATES_PRODUCE_VARIATIONS_PER_ROW =
  "templatesProduceVariationsPerRow";
export const TEMPLATES_PRODUCE_ROWS = "templatesProduceRows";
export const TEMPLATES_PRODUCE_ROWS_HINT = "templatesProduceRowsHint";
export const TEMPLATES_PRODUCE_ADD_ROW = "templatesProduceAddRow";
export const TEMPLATES_PRODUCE_LOAD_LAST_CONFIG =
  "templatesProduceLoadLastConfig";
export const TEMPLATES_PRODUCE_UPLOAD_CSV = "templatesProduceUploadCsv";
export const TEMPLATES_PRODUCE_DOWNLOAD_FORMAT =
  "templatesProduceDownloadFormat";
export const TEMPLATES_PRODUCE_CSV_EXAMPLE_FILENAME =
  "templatesProduceCsvExampleFilename";
export const TEMPLATES_PRODUCE_CSV_EXAMPLE_TEXT =
  "templatesProduceCsvExampleText";
export const TEMPLATES_PRODUCE_GENERATE = "templatesProduceGenerate";
export const TEMPLATES_PRODUCE_GENERATE_SINGLE =
  "templatesProduceGenerateSingle";
export const TEMPLATES_PRODUCE_PREVIEW = "templatesProducePreview";
export const TEMPLATES_PRODUCE_PREVIEW_TOOLTIP =
  "templatesProducePreviewTooltip";
export const TEMPLATES_PRODUCE_PREVIEW_THIS_SLIDE =
  "templatesProducePreviewThisSlide";
export const TEMPLATES_PRODUCE_PREVIEW_WHOLE_CAROUSEL =
  "templatesProducePreviewWholeCarousel";
export const TEMPLATES_PRODUCE_SUMMARY = "templatesProduceSummary";
export const TEMPLATES_PRODUCE_EMPTY_TEMPLATES =
  "templatesProduceEmptyTemplates";
export const TEMPLATES_PRODUCE_EMPTY_VARIABLES =
  "templatesProduceEmptyVariables";
export const TEMPLATES_PRODUCE_SELECT_TEMPLATE =
  "templatesProduceSelectTemplate";
export const TEMPLATES_PRODUCE_CSV_TITLE = "templatesProduceCsvTitle";
export const TEMPLATES_PRODUCE_CSV_DESCRIPTION =
  "templatesProduceCsvDescription";
export const TEMPLATES_PRODUCE_CSV_REPLACE = "templatesProduceCsvReplace";
export const TEMPLATES_PRODUCE_CSV_APPEND = "templatesProduceCsvAppend";
export const TEMPLATES_PRODUCE_CSV_ERROR = "templatesProduceCsvError";
export const TEMPLATES_PRODUCE_CSV_EMPTY = "templatesProduceCsvEmpty";
export const TEMPLATES_PRODUCE_CHANGE_TEMPLATE_TITLE =
  "templatesProduceChangeTemplateTitle";
export const TEMPLATES_PRODUCE_CHANGE_TEMPLATE_DESCRIPTION =
  "templatesProduceChangeTemplateDescription";
export const TEMPLATES_PRODUCE_VALIDATION_ERROR =
  "templatesProduceValidationError";
export const TEMPLATES_PRODUCE_VALIDATION_HIGHLIGHT =
  "templatesProduceValidationHighlight";
export const TEMPLATES_PRODUCE_VALIDATION_NO_ROWS =
  "templatesProduceValidationNoRows";
export const TEMPLATES_PRODUCE_VALIDATION_VARIATIONS =
  "templatesProduceValidationVariations";
export const TEMPLATES_PRODUCE_VALIDATION_NO_FORMATS =
  "templatesProduceValidationNoFormats";
export const TEMPLATES_PRODUCE_VALIDATION_TOO_MANY_ROWS =
  "templatesProduceValidationTooManyRows";
export const TEMPLATES_PRODUCE_GENERATE_SUCCESS =
  "templatesProduceGenerateSuccess";
export const TEMPLATES_PRODUCE_DELETE_ROW = "templatesProduceDeleteRow";
export const TEMPLATES_PRODUCE_COPY_TO_COLUMN = "templatesProduceCopyToColumn";
export const TEMPLATES_PRODUCE_SELECT_IMAGE = "templatesProduceSelectImage";
export const TEMPLATES_PRODUCE_REPLACE_IMAGE = "templatesProduceReplaceImage";
export const TEMPLATES_PRODUCE_IMAGE_CHECKING = "templatesProduceImageChecking";
export const TEMPLATES_PRODUCE_IMAGE_UNUSABLE = "templatesProduceImageUnusable";
export const TEMPLATES_PRODUCE_IMAGES_PROCESSING =
  "templatesProduceImagesProcessing";
export const TEMPLATES_PRODUCE_IMAGES_UNUSABLE =
  "templatesProduceImagesUnusable";
export const TEMPLATES_PRODUCE_DELETE_IMAGE = "templatesProduceDeleteImage";
export const TEMPLATES_PRODUCE_RESULTS = "templatesProduceResults";
export const TEMPLATES_PRODUCE_RUN_TITLE = "templatesProduceRunTitle";
export const TEMPLATES_PRODUCE_RUN_LEGACY = "templatesProduceRunLegacy";
export const TEMPLATES_PRODUCE_DELETE_SELECTED =
  "templatesProduceDeleteSelected";
export const TEMPLATES_PRODUCE_DELETE_CONFIRM_TITLE =
  "templatesProduceDeleteConfirmTitle";
export const TEMPLATES_PRODUCE_DELETE_CONFIRM_TEXT =
  "templatesProduceDeleteConfirmText";
export const TEMPLATES_PRODUCE_DELETE_ERROR = "templatesProduceDeleteError";
export const TEMPLATES_PRODUCE_DOWNLOAD_CONFIG =
  "templatesProduceDownloadConfig";
export const TEMPLATES_PRODUCE_CONFIG_FILENAME =
  "templatesProduceConfigFilename";
export const TEMPLATES_PRODUCE_GENERATING = "templatesProduceGenerating";
export const TEMPLATES_PRODUCE_ACTIVE_RUN = "templatesProduceActiveRun";
export const TEMPLATES_PRODUCE_EDIT_TITLE = "templatesProduceEditTitle";
export const TEMPLATES_PRODUCE_EDIT_NO_INSTANCE =
  "templatesProduceEditNoInstance";
export const TEMPLATES_PRODUCE_ADD_TEXT = "templatesProduceAddText";
export const TEMPLATES_PRODUCE_ADD_IMAGE = "templatesProduceAddImage";
export const TEMPLATES_PRODUCE_ADD_SHAPE = "templatesProduceAddShape";
export const TEMPLATES_PRODUCE_ADD_GROUP = "templatesProduceAddGroup";
export const TEMPLATES_GROUP_LAYERS = "templatesGroupLayers";
export const TEMPLATES_PRODUCE_SAVE_ERROR = "templatesProduceSaveError";
export const TEMPLATES_PRODUCE_PARTIAL_SUMMARY =
  "templatesProducePartialSummary";
export const TEMPLATES_PRODUCE_PARTIAL_TITLE = "templatesProducePartialTitle";
export const TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_SINGULAR =
  "templatesProducePartialSubtitleSingular";
export const TEMPLATES_PRODUCE_PARTIAL_SUBTITLE_PLURAL =
  "templatesProducePartialSubtitlePlural";
export const TEMPLATES_PRODUCE_RETRY_FAILED = "templatesProduceRetryFailed";
export const TEMPLATES_PRODUCE_RETRY_FAILED_SINGULAR =
  "templatesProduceRetryFailedSingular";
export const TEMPLATES_PRODUCE_RETRY_FAILED_PLURAL =
  "templatesProduceRetryFailedPlural";
export const TEMPLATES_PRODUCE_FAILURE_GENERIC =
  "templatesProduceFailureGeneric";
export const TEMPLATES_PRODUCE_FAILURE_BUSY = "templatesProduceFailureBusy";
export const TEMPLATES_PRODUCE_FAILURE_IMAGE = "templatesProduceFailureImage";
export const TEMPLATES_PRODUCE_FAILURE_DATA = "templatesProduceFailureData";

// INSIGHTS
export const INSIGHTS_PAGE_TITLE = "insightsPageTitle";
export const INSIGHTS_HEADER_BRAND = "insightsHeaderBrand";
export const INSIGHTS_HEADER_HELP = "insightsHeaderHelp";
export const INSIGHTS_CONNECT_STEP_NUMBER = "insightsConnectStepNumber";
export const INSIGHTS_CONNECT_TITLE = "insightsConnectTitle";
export const INSIGHTS_CONNECT_MUTED = "insightsConnectMuted";
export const INSIGHTS_CONNECT_DESCRIPTION = "insightsConnectDescription";
export const INSIGHTS_CONNECT_CARD_TITLE = "insightsConnectCardTitle";
export const INSIGHTS_CONNECT_CARD_SUBTITLE = "insightsConnectCardSubtitle";
export const INSIGHTS_CONNECT_CTA = "insightsConnectCta";
export const INSIGHTS_CONNECT_CONNECTING = "insightsConnectConnecting";
export const INSIGHTS_CONNECT_CREDENTIALS_NOTE =
  "insightsConnectCredentialsNote";
export const INSIGHTS_CONNECT_ERROR_CANCELLED = "insightsConnectErrorCancelled";
export const INSIGHTS_CONNECT_ERROR_FAILED = "insightsConnectErrorFailed";
export const INSIGHTS_CONNECT_ERROR_SDK = "insightsConnectErrorSdk";
export const INSIGHTS_CONNECT_ERROR_NO_ACCOUNTS =
  "insightsConnectErrorNoAccounts";
export const INSIGHTS_CONNECT_ERROR_GENERIC = "insightsConnectErrorGeneric";
export const INSIGHTS_ACCOUNT_BACK = "insightsAccountBack";
export const INSIGHTS_ACCOUNT_STEP_NUMBER = "insightsAccountStepNumber";
export const INSIGHTS_ACCOUNT_TITLE = "insightsAccountTitle";
export const INSIGHTS_ACCOUNT_MUTED = "insightsAccountMuted";
export const INSIGHTS_ACCOUNT_DESCRIPTION = "insightsAccountDescription";
export const INSIGHTS_ACCOUNT_CONTINUE = "insightsAccountContinue";
export const INSIGHTS_ACCOUNT_EMPTY = "insightsAccountEmpty";
export const INSIGHTS_ACCOUNT_STATUS_ACTIVE = "insightsAccountStatusActive";
export const INSIGHTS_ACCOUNT_STATUS_PAUSED = "insightsAccountStatusPaused";
export const INSIGHTS_GENERATING_STEP_NUMBER = "insightsGeneratingStepNumber";
export const INSIGHTS_GENERATING_TITLE = "insightsGeneratingTitle";
export const INSIGHTS_GENERATING_MUTED = "insightsGeneratingMuted";
export const INSIGHTS_GENERATING_DESCRIPTION = "insightsGeneratingDescription";
export const INSIGHTS_GENERATING_PROCESSING_LABEL =
  "insightsGeneratingProcessingLabel";
export const INSIGHTS_GENERATING_ERROR = "insightsGeneratingError";
export const INSIGHTS_GENERATING_RETRY = "insightsGeneratingRetry";
export const INSIGHTS_DONE_STEP_NUMBER = "insightsDoneStepNumber";
export const INSIGHTS_DONE_TITLE = "insightsDoneTitle";
export const INSIGHTS_DONE_MUTED = "insightsDoneMuted";
export const INSIGHTS_DONE_DESCRIPTION = "insightsDoneDescription";
export const INSIGHTS_DONE_REPORT_TITLE = "insightsDoneReportTitle";
export const INSIGHTS_DONE_REPORT_SUBTITLE = "insightsDoneReportSubtitle";
export const INSIGHTS_DONE_CTA_TITLE = "insightsDoneCtaTitle";
export const INSIGHTS_DONE_CTA_DESCRIPTION = "insightsDoneCtaDescription";
export const INSIGHTS_DONE_SCHEDULE_DEMO = "insightsDoneScheduleDemo";
export const INSIGHTS_DONE_RESTART = "insightsDoneRestart";
export const INSIGHTS_REPORT_WHY = "insightsReportWhy";
export const INSIGHTS_REPORT_WHAT_TO_DO = "insightsReportWhatToDo";
export const INSIGHTS_REPORT_QUICK_WINS = "insightsReportQuickWins";
export const INSIGHTS_FEATURES_HEADING = "insightsFeaturesHeading";
export const INSIGHTS_FEATURE_AI_MEDIA_TITLE = "insightsFeatureAiMediaTitle";
export const INSIGHTS_FEATURE_AI_MEDIA_DESCRIPTION =
  "insightsFeatureAiMediaDescription";
export const INSIGHTS_FEATURE_AI_CAMPAIGNS_TITLE =
  "insightsFeatureAiCampaignsTitle";
export const INSIGHTS_FEATURE_AI_CAMPAIGNS_DESCRIPTION =
  "insightsFeatureAiCampaignsDescription";
export const INSIGHTS_FEATURE_COMPETITORS_TITLE =
  "insightsFeatureCompetitorsTitle";
export const INSIGHTS_FEATURE_COMPETITORS_DESCRIPTION =
  "insightsFeatureCompetitorsDescription";
export const INSIGHTS_FEATURE_REPORTS_TITLE = "insightsFeatureReportsTitle";
export const INSIGHTS_FEATURE_REPORTS_DESCRIPTION =
  "insightsFeatureReportsDescription";

// AI COMPETITORS
export const AI_COMPETITORS_PAGE_TITLE = "aiCompetitorsPageTitle";
export const AI_COMPETITORS_URL_STEP_NUMBER = "aiCompetitorsUrlStepNumber";
export const AI_COMPETITORS_URL_TITLE = "aiCompetitorsUrlTitle";
export const AI_COMPETITORS_URL_MUTED = "aiCompetitorsUrlMuted";
export const AI_COMPETITORS_URL_DESCRIPTION = "aiCompetitorsUrlDescription";
export const AI_COMPETITORS_URL_PLACEHOLDER = "aiCompetitorsUrlPlaceholder";
export const AI_COMPETITORS_URL_CTA = "aiCompetitorsUrlCta";
export const AI_COMPETITORS_URL_INVALID = "aiCompetitorsUrlInvalid";
export const AI_COMPETITORS_URL_BLOCKED = "aiCompetitorsUrlBlocked";
export const AI_COMPETITORS_URL_NO_COMPETITORS =
  "aiCompetitorsUrlNoCompetitors";
export const AI_COMPETITORS_ANALYZING_STEP_NUMBER =
  "aiCompetitorsAnalyzingStepNumber";
export const AI_COMPETITORS_ANALYZING_TITLE = "aiCompetitorsAnalyzingTitle";
export const AI_COMPETITORS_ANALYZING_MUTED = "aiCompetitorsAnalyzingMuted";
export const AI_COMPETITORS_ANALYZING_DESCRIPTION =
  "aiCompetitorsAnalyzingDescription";
export const AI_COMPETITORS_PROGRESS_FALLBACK = "aiCompetitorsProgressFallback";
export const AI_COMPETITORS_PROGRESS_REVIEWING_PAGE =
  "aiCompetitorsProgressReviewingPage";
export const AI_COMPETITORS_PROGRESS_FINDING_COMPETITORS =
  "aiCompetitorsProgressFindingCompetitors";
export const AI_COMPETITORS_PROGRESS_CONSOLIDATING_COMPETITORS =
  "aiCompetitorsProgressConsolidatingCompetitors";
export const AI_COMPETITORS_PROGRESS_RESOLVING_ADS =
  "aiCompetitorsProgressResolvingAds";
export const AI_COMPETITORS_PROGRESS_SEARCHING_ADS =
  "aiCompetitorsProgressSearchingAds";
export const AI_COMPETITORS_PROGRESS_CONSOLIDATING_ADS =
  "aiCompetitorsProgressConsolidatingAds";
export const AI_COMPETITORS_COMPETITORS_STEP_NUMBER =
  "aiCompetitorsCompetitorsStepNumber";
export const AI_COMPETITORS_COMPETITORS_TITLE = "aiCompetitorsCompetitorsTitle";
export const AI_COMPETITORS_COMPETITORS_MUTED = "aiCompetitorsCompetitorsMuted";
export const AI_COMPETITORS_COMPETITORS_DESCRIPTION =
  "aiCompetitorsCompetitorsDescription";
export const AI_COMPETITORS_COMPETITORS_EMPTY = "aiCompetitorsCompetitorsEmpty";
export const AI_COMPETITORS_COMPETITORS_ADD_PLACEHOLDER =
  "aiCompetitorsCompetitorsAddPlaceholder";
export const AI_COMPETITORS_COMPETITORS_ADD = "aiCompetitorsCompetitorsAdd";
export const AI_COMPETITORS_COMPETITORS_ADD_INVALID =
  "aiCompetitorsCompetitorsAddInvalid";
export const AI_COMPETITORS_COMPETITORS_NAME_LABEL =
  "aiCompetitorsCompetitorsNameLabel";
export const AI_COMPETITORS_COMPETITORS_REMOVE =
  "aiCompetitorsCompetitorsRemove";
export const AI_COMPETITORS_COMPETITORS_CTA = "aiCompetitorsCompetitorsCta";
export const AI_COMPETITORS_COMPETITORS_NEED_ONE =
  "aiCompetitorsCompetitorsNeedOne";
export const AI_COMPETITORS_COMPETITORS_ADD_MAX =
  "aiCompetitorsCompetitorsAddMax";
export const AI_COMPETITORS_SEARCHING_STEP_NUMBER =
  "aiCompetitorsSearchingStepNumber";
export const AI_COMPETITORS_SEARCHING_TITLE = "aiCompetitorsSearchingTitle";
export const AI_COMPETITORS_SEARCHING_MUTED = "aiCompetitorsSearchingMuted";
export const AI_COMPETITORS_SEARCHING_ERROR = "aiCompetitorsSearchingError";
export const AI_COMPETITORS_SEARCHING_RETRY = "aiCompetitorsSearchingRetry";
export const AI_COMPETITORS_RESULTS_STEP_NUMBER =
  "aiCompetitorsResultsStepNumber";
export const AI_COMPETITORS_RESULTS_TITLE = "aiCompetitorsResultsTitle";
export const AI_COMPETITORS_RESULTS_MUTED = "aiCompetitorsResultsMuted";
export const AI_COMPETITORS_RESULTS_SUMMARY = "aiCompetitorsResultsSummary";
export const AI_COMPETITORS_RESULTS_NO_ADS = "aiCompetitorsResultsNoAds";
export const AI_COMPETITORS_RESULTS_NO_ADS_ALERT_TITLE =
  "aiCompetitorsResultsNoAdsAlertTitle";
export const AI_COMPETITORS_RESULTS_NO_ADS_ALERT_BODY =
  "aiCompetitorsResultsNoAdsAlertBody";
export const AI_COMPETITORS_RESULTS_NO_ADS_CTA = "aiCompetitorsResultsNoAdsCta";
export const AI_COMPETITORS_RESULTS_VIEW_MORE = "aiCompetitorsResultsViewMore";
export const AI_COMPETITORS_RESULTS_GENERATE = "aiCompetitorsResultsGenerate";
export const AI_COMPETITORS_RESULTS_LOCKED_COUNT =
  "aiCompetitorsResultsLockedCount";
export const AI_COMPETITORS_RESULTS_DOWNLOAD = "aiCompetitorsResultsDownload";
export const AI_COMPETITORS_RESULTS_FORMAT_IMAGE =
  "aiCompetitorsResultsFormatImage";
export const AI_COMPETITORS_RESULTS_FORMAT_VIDEO =
  "aiCompetitorsResultsFormatVideo";
export const AI_COMPETITORS_RESULTS_FORMAT_CAROUSEL =
  "aiCompetitorsResultsFormatCarousel";
export const AI_COMPETITORS_AGENDA_CONFIRM_TITLE =
  "aiCompetitorsAgendaConfirmTitle";
export const AI_COMPETITORS_AGENDA_CONFIRM_TEXT =
  "aiCompetitorsAgendaConfirmText";
export const AI_COMPETITORS_AGENDA_CONFIRM_CTA =
  "aiCompetitorsAgendaConfirmCta";
export const AI_COMPETITORS_AGENDA_BACK = "aiCompetitorsAgendaBack";
export const AI_COMPETITORS_AGENDA_STEP_NUMBER =
  "aiCompetitorsAgendaStepNumber";
export const AI_COMPETITORS_AGENDA_TITLE = "aiCompetitorsAgendaTitle";
export const AI_COMPETITORS_AGENDA_MUTED = "aiCompetitorsAgendaMuted";
export const AI_COMPETITORS_AGENDA_CONTEXT = "aiCompetitorsAgendaContext";
export const AI_COMPETITORS_AGENDA_CONTEXT_ZERO =
  "aiCompetitorsAgendaContextZero";
export const AI_COMPETITORS_AGENDA_CONTEXT_FALLBACK =
  "aiCompetitorsAgendaContextFallback";
export const AI_COMPETITORS_THANKS_STEP_NUMBER =
  "aiCompetitorsThanksStepNumber";
export const AI_COMPETITORS_THANKS_TITLE = "aiCompetitorsThanksTitle";
export const AI_COMPETITORS_THANKS_MUTED = "aiCompetitorsThanksMuted";
export const AI_COMPETITORS_THANKS_DESCRIPTION =
  "aiCompetitorsThanksDescription";
export const NEW_FEATURE_CALLOUT_BADGE = "newFeatureCalloutBadge";
export const NEW_FEATURE_CALLOUT_CLOSE_ARIA = "newFeatureCalloutCloseAria";
export const NEW_FEATURE_CALLOUT_DEFAULT_CTA = "newFeatureCalloutDefaultCta";
export const NEW_FEATURE_CALLOUT_INSIGHTS_TITLE =
  "newFeatureCalloutInsightsTitle";
export const NEW_FEATURE_CALLOUT_INSIGHTS_DESCRIPTION =
  "newFeatureCalloutInsightsDescription";
export const NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_TITLE =
  "newFeatureCalloutGalleryTemplatesTitle";
export const NEW_FEATURE_CALLOUT_GALLERY_TEMPLATES_DESCRIPTION =
  "newFeatureCalloutGalleryTemplatesDescription";
export const NEW_FEATURE_CALLOUT_AUTOMATIONS_TITLE =
  "newFeatureCalloutAutomationsTitle";
export const NEW_FEATURE_CALLOUT_AUTOMATIONS_DESCRIPTION =
  "newFeatureCalloutAutomationsDescription";

// AUTOMATIONS
export const AUTOMATIONS_MENU_TITLE = "automationsMenuTitle";
export const AUTOMATIONS_PAGE_TITLE = "automationsPageTitle";
export const AUTOMATIONS_PAGE_DESCRIPTION = "automationsPageDescription";
export const BUTTON_NEW_AUTOMATION = "buttonNewAutomation";
export const AUTOMATIONS_HERO_TITLE = "automationsHeroTitle";
export const AUTOMATIONS_HERO_DESCRIPTION = "automationsHeroDescription";
export const AUTOMATIONS_STATUS_ACTIVE = "automationsStatusActive";
export const AUTOMATIONS_STATUS_PAUSED = "automationsStatusPaused";
export const AUTOMATIONS_LABEL_FOLDER = "automationsLabelFolder";
export const AUTOMATIONS_LABEL_PLATFORMS = "automationsLabelPlatforms";
export const AUTOMATIONS_LABEL_FREQUENCY = "automationsLabelFrequency";
export const AUTOMATIONS_LABEL_NEXT_POST = "automationsLabelNextPost";
export const AUTOMATIONS_MOCK_BRAND_CONTENT = "automationsMockBrandContent";
export const AUTOMATIONS_MOCK_PRODUCT_LAUNCH = "automationsMockProductLaunch";
export const AUTOMATIONS_MOCK_THOUGHT_LEADERSHIP =
  "automationsMockThoughtLeadership";
export const AUTOMATIONS_MOCK_FOLDER_SOCIAL_SEPTEMBER =
  "automationsMockFolderSocialSeptember";
export const AUTOMATIONS_MOCK_FOLDER_ALL_CONTENT =
  "automationsMockFolderAllContent";
export const AUTOMATIONS_MOCK_FOLDER_LINKEDIN = "automationsMockFolderLinkedIn";
export const AUTOMATIONS_MOCK_FREQ_ONE_PER_DAY = "automationsMockFreqOnePerDay";
export const AUTOMATIONS_MOCK_FREQ_FIVE_PER_WEEK =
  "automationsMockFreqFivePerWeek";
export const AUTOMATIONS_MOCK_FREQ_THREE_PER_WEEK =
  "automationsMockFreqThreePerWeek";
export const AUTOMATIONS_FREQ_ONE_PER_DAY = "automationsFreqOnePerDay";
export const AUTOMATIONS_FREQ_THREE_PER_WEEK = "automationsFreqThreePerWeek";
export const AUTOMATIONS_FREQ_FOUR_PER_WEEK = "automationsFreqFourPerWeek";
export const AUTOMATIONS_FREQ_FIVE_PER_WEEK = "automationsFreqFivePerWeek";
export const AUTOMATIONS_FREQ_SIX_PER_WEEK = "automationsFreqSixPerWeek";
export const AUTOMATIONS_MOCK_NEXT_TODAY = "automationsMockNextToday";
export const AUTOMATIONS_MOCK_NEXT_EMPTY = "automationsMockNextEmpty";
export const AUTOMATIONS_MOCK_NEXT_TOMORROW = "automationsMockNextTomorrow";
export const MODAL_CREATE_AUTOMATION_TITLE = "modalCreateAutomationTitle";
export const AUTOMATIONS_STEP_SOURCE = "automationsStepSource";
export const AUTOMATIONS_STEP_PLATFORMS = "automationsStepPlatforms";
export const AUTOMATIONS_STEP_SCHEDULE = "automationsStepSchedule";
export const AUTOMATIONS_STEP_CONTENT_AI = "automationsStepContentAi";
export const AUTOMATIONS_STEP_REVIEW = "automationsStepReview";
export const AUTOMATIONS_STEP_SOURCE_TITLE = "automationsStepSourceTitle";
export const AUTOMATIONS_STEP_SOURCE_HELP = "automationsStepSourceHelp";
export const AUTOMATIONS_SOURCE_ALL_TITLE = "automationsSourceAllTitle";
export const AUTOMATIONS_SOURCE_ALL_DESCRIPTION =
  "automationsSourceAllDescription";
export const AUTOMATIONS_SOURCE_FOLDER_TITLE = "automationsSourceFolderTitle";
export const AUTOMATIONS_SOURCE_FOLDER_DESCRIPTION =
  "automationsSourceFolderDescription";
export const AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS =
  "automationsSourceIncludeSubfolders";
export const AUTOMATIONS_SOURCE_INCLUDE_SUBFOLDERS_HELP =
  "automationsSourceIncludeSubfoldersHelp";
export const AUTOMATIONS_STEP_LANGUAGE_TITLE = "automationsStepLanguageTitle";
export const AUTOMATIONS_STEP_LANGUAGE_HELP = "automationsStepLanguageHelp";
export const AUTOMATIONS_VALIDATION_LANGUAGE = "automationsValidationLanguage";
export const AUTOMATIONS_REVIEW_LANGUAGE = "automationsReviewLanguage";
export const AUTOMATIONS_CONNECT_ACCOUNTS = "automationsConnectAccounts";
export const AUTOMATIONS_STEP_PLATFORMS_TITLE = "automationsStepPlatformsTitle";
export const AUTOMATIONS_STEP_PLATFORMS_HELP = "automationsStepPlatformsHelp";
export const AUTOMATIONS_PLATFORM_CONNECTED = "automationsPlatformConnected";
export const AUTOMATIONS_STEP_SCHEDULE_TITLE = "automationsStepScheduleTitle";
export const AUTOMATIONS_STEP_SCHEDULE_HELP = "automationsStepScheduleHelp";
export const AUTOMATIONS_SCHEDULE_FREQUENCY = "automationsScheduleFrequency";
export const AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW =
  "automationsSchedulePublishingWindow";
export const AUTOMATIONS_SCHEDULE_PUBLISHING_WINDOW_HELP =
  "automationsSchedulePublishingWindowHelp";
export const AUTOMATIONS_SCHEDULE_TIMEZONE = "automationsScheduleTimezone";
export const AUTOMATIONS_SCHEDULE_VALIDITY = "automationsScheduleValidity";
export const AUTOMATIONS_SCHEDULE_VALIDITY_HELP =
  "automationsScheduleValidityHelp";
export const AUTOMATIONS_SCHEDULE_START = "automationsScheduleStart";
export const AUTOMATIONS_SCHEDULE_START_NOW = "automationsScheduleStartNow";
export const AUTOMATIONS_SCHEDULE_START_NOW_HELP =
  "automationsScheduleStartNowHelp";
export const AUTOMATIONS_SCHEDULE_START_SCHEDULED =
  "automationsScheduleStartScheduled";
export const AUTOMATIONS_SCHEDULE_END = "automationsScheduleEnd";
export const AUTOMATIONS_SCHEDULE_END_ALWAYS_ON =
  "automationsScheduleEndAlwaysOn";
export const AUTOMATIONS_SCHEDULE_END_ALWAYS_ON_HELP =
  "automationsScheduleEndAlwaysOnHelp";
export const AUTOMATIONS_SCHEDULE_END_SCHEDULED =
  "automationsScheduleEndScheduled";
export const AUTOMATIONS_STEP_CONTENT_AI_TITLE =
  "automationsStepContentAiTitle";
export const AUTOMATIONS_STEP_CONTENT_AI_HELP = "automationsStepContentAiHelp";
export const AUTOMATIONS_CONTENT_ORIGINAL_TITLE =
  "automationsContentOriginalTitle";
export const AUTOMATIONS_CONTENT_ORIGINAL_DESCRIPTION =
  "automationsContentOriginalDescription";
export const AUTOMATIONS_CONTENT_AI_TITLE = "automationsContentAiTitle";
export const AUTOMATIONS_CONTENT_AI_DESCRIPTION =
  "automationsContentAiDescription";
export const AUTOMATIONS_AI_NOTE_TITLE = "automationsAiNoteTitle";
export const AUTOMATIONS_AI_NOTE_DESCRIPTION = "automationsAiNoteDescription";
export const AUTOMATIONS_STEP_REVIEW_TITLE = "automationsStepReviewTitle";
export const AUTOMATIONS_STEP_REVIEW_HELP = "automationsStepReviewHelp";
export const AUTOMATIONS_REVIEW_SOURCE = "automationsReviewSource";
export const AUTOMATIONS_REVIEW_PLATFORMS = "automationsReviewPlatforms";
export const AUTOMATIONS_REVIEW_SCHEDULE = "automationsReviewSchedule";
export const AUTOMATIONS_REVIEW_VALIDITY = "automationsReviewValidity";
export const AUTOMATIONS_REVIEW_VALIDITY_VALUE =
  "automationsReviewValidityValue";
export const AUTOMATIONS_REVIEW_VALIDITY_START_NOW =
  "automationsReviewValidityStartNow";
export const AUTOMATIONS_REVIEW_VALIDITY_START_AT =
  "automationsReviewValidityStartAt";
export const AUTOMATIONS_REVIEW_VALIDITY_ALWAYS_ON =
  "automationsReviewValidityAlwaysOn";
export const AUTOMATIONS_REVIEW_VALIDITY_END_AT =
  "automationsReviewValidityEndAt";
export const AUTOMATIONS_REVIEW_NAME = "automationsReviewName";
export const AUTOMATIONS_DEFAULT_NAME = "automationsDefaultName";
export const AUTOMATIONS_REVIEW_CONTENT_AI = "automationsReviewContentAi";
export const AUTOMATIONS_BUTTON_BACK = "automationsButtonBack";
export const AUTOMATIONS_BUTTON_CREATE = "automationsButtonCreate";
export const AUTOMATIONS_BUTTON_SAVE = "automationsButtonSave";
export const AUTOMATIONS_REVIEW_SCHEDULE_VALUE =
  "automationsReviewScheduleValue";
export const AUTOMATIONS_STATUS_WAITING = "automationsStatusWaiting";
export const AUTOMATIONS_STATUS_SCHEDULING = "automationsStatusScheduling";
export const AUTOMATIONS_STATUS_ATTENTION = "automationsStatusAttention";
export const AUTOMATIONS_STATUS_OFF = "automationsStatusOff";
export const AUTOMATIONS_STATUS_ENDED = "automationsStatusEnded";
export const AUTOMATIONS_MENU_EDIT = "automationsMenuEdit";
export const AUTOMATIONS_MENU_VIEW_CALENDAR = "automationsMenuViewCalendar";
export const AUTOMATIONS_MENU_TURN_OFF = "automationsMenuTurnOff";
export const AUTOMATIONS_TURN_OFF_TITLE = "automationsTurnOffTitle";
export const AUTOMATIONS_TURN_OFF_DESCRIPTION = "automationsTurnOffDescription";
export const AUTOMATIONS_TURN_OFF_CONFIRM = "automationsTurnOffConfirm";
export const AUTOMATIONS_WAITING_BANNER = "automationsWaitingBanner";
export const AUTOMATIONS_ATTENTION_BANNER = "automationsAttentionBanner";
export const AUTOMATIONS_VALIDATION_FOLDER = "automationsValidationFolder";
export const AUTOMATIONS_VALIDATION_ACCOUNTS = "automationsValidationAccounts";
export const AUTOMATIONS_VALIDATION_WINDOW = "automationsValidationWindow";
export const AUTOMATIONS_VALIDATION_START_REQUIRED =
  "automationsValidationStartRequired";
export const AUTOMATIONS_VALIDATION_START_FUTURE =
  "automationsValidationStartFuture";
export const AUTOMATIONS_VALIDATION_END_REQUIRED =
  "automationsValidationEndRequired";
export const AUTOMATIONS_VALIDATION_END_FUTURE =
  "automationsValidationEndFuture";
export const AUTOMATIONS_VALIDATION_END_AFTER_START =
  "automationsValidationEndAfterStart";
export const AUTOMATIONS_HERO_QUEUED = "automationsHeroQueued";
export const AUTOMATIONS_HERO_PUBLISHED = "automationsHeroPublished";
export const AUTOMATIONS_HERO_FAILED = "automationsHeroFailed";
export const AUTOMATIONS_HERO_NEXT = "automationsHeroNext";
export const AUTOMATIONS_NEXT_NONE = "automationsNextNone";
export const AUTOMATIONS_REMAINING_CONTENT = "automationsRemainingContent";
export const CALENDAR_SOURCE_AUTOMATED = "calendarSourceAutomated";
export const CALENDAR_ACTIVE_AUTOMATIONS = "calendarActiveAutomations";
export const CALENDAR_AUTOMATION_ENDS = "calendarAutomationEnds";
export const CALENDAR_AUTOMATION_FOLDER = "calendarAutomationFolder";
export const CALENDAR_SOURCE_MANUAL = "calendarSourceManual";
export const EVENT_DETAILS_AUTOMATION = "eventDetailsAutomation";
export const EVENT_DETAILS_ACCOUNT = "eventDetailsAccount";
export const MODAL_EDIT_AUTOMATION_TITLE = "modalEditAutomationTitle";
export const AUTOMATIONS_NO_PERMISSION = "automationsNoPermission";
export const OPTIMISTIC_SWITCH_FAILURE_BODY = "optimisticSwitchFailureBody";
export const OPTIMISTIC_SWITCH_ACTIVATE_CAMPAIGN =
  "optimisticSwitchActivateCampaign";
export const OPTIMISTIC_SWITCH_DEACTIVATE_CAMPAIGN =
  "optimisticSwitchDeactivateCampaign";
export const OPTIMISTIC_SWITCH_ACTIVATE_ASSETS_GROUP =
  "optimisticSwitchActivateAssetsGroup";
export const OPTIMISTIC_SWITCH_DEACTIVATE_ASSETS_GROUP =
  "optimisticSwitchDeactivateAssetsGroup";
export const OPTIMISTIC_SWITCH_ACTIVATE_AD_GROUP =
  "optimisticSwitchActivateAdGroup";
export const OPTIMISTIC_SWITCH_DEACTIVATE_AD_GROUP =
  "optimisticSwitchDeactivateAdGroup";
export const OPTIMISTIC_SWITCH_ACTIVATE_AD = "optimisticSwitchActivateAd";
export const OPTIMISTIC_SWITCH_DEACTIVATE_AD = "optimisticSwitchDeactivateAd";
export const OPTIMISTIC_SWITCH_ACTIVATE_AUTOMATION =
  "optimisticSwitchActivateAutomation";
export const OPTIMISTIC_SWITCH_DEACTIVATE_AUTOMATION =
  "optimisticSwitchDeactivateAutomation";
export const OPTIMISTIC_SWITCH_ACTIVATE_PROMO_CODE =
  "optimisticSwitchActivatePromoCode";
export const OPTIMISTIC_SWITCH_DEACTIVATE_PROMO_CODE =
  "optimisticSwitchDeactivatePromoCode";
export const OPTIMISTIC_SWITCH_FAILURE_EMAIL_SUBJECT =
  "optimisticSwitchFailureEmailSubject";
export const CREATE_CAMPAIGN_WIZARD_ARIA = "createCampaignWizardAria";
export const CREATE_CAMPAIGN_SETUP_TITLE = "createCampaignSetupTitle";
export const CREATE_CAMPAIGN_SETUP_DESCRIPTION =
  "createCampaignSetupDescription";
export const CREATE_CAMPAIGN_WIZARD_STEP_INSTRUCTIONS_HELP =
  "createCampaignWizardStepInstructionsHelp";
export const CREATE_CAMPAIGN_WIZARD_STEP_LANGUAGE_HELP =
  "createCampaignWizardStepLanguageHelp";
export const CREATE_CAMPAIGN_WIZARD_STEP_LOCATIONS_HELP =
  "createCampaignWizardStepLocationsHelp";
export const CREATE_CAMPAIGN_WIZARD_STEP_PLATFORM_HELP =
  "createCampaignWizardStepPlatformHelp";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_TITLE =
  "googleAdsAccountExclusionsTitle";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_DESCRIPTION =
  "googleAdsAccountExclusionsDescription";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNELS =
  "googleAdsAccountExclusionsChannels";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEOS =
  "googleAdsAccountExclusionsVideos";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CONTENT_CATEGORIES =
  "googleAdsAccountExclusionsContentCategories";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EXCLUDED_APPS =
  "googleAdsAccountExclusionsExcludedApps";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_CATEGORIES =
  "googleAdsAccountExclusionsAppCategories";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOADING =
  "googleAdsAccountExclusionsLoading";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY_ROW =
  "googleAdsAccountExclusionsEmptyRow";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SETTINGS =
  "googleAdsAccountExclusionsSettings";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORDS =
  "googleAdsAccountExclusionsKeywords";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_YOUTUBE =
  "googleAdsAccountExclusionsYoutube";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APPS =
  "googleAdsAccountExclusionsApps";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD =
  "googleAdsAccountExclusionsKeyword";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_INVALID_CHARS =
  "googleAdsAccountExclusionsKeywordInvalidChars";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_KEYWORD_MATCH_SYNTAX =
  "googleAdsAccountExclusionsKeywordMatchSyntax";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_TYPE =
  "googleAdsAccountExclusionsMatchType";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_BROAD =
  "googleAdsAccountExclusionsMatchBroad";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_PHRASE =
  "googleAdsAccountExclusionsMatchPhrase";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_MATCH_EXACT =
  "googleAdsAccountExclusionsMatchExact";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL =
  "googleAdsAccountExclusionsChannel";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CHANNEL_INVALID =
  "googleAdsAccountExclusionsChannelInvalid";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_VIDEO =
  "googleAdsAccountExclusionsVideo";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_CATEGORIES =
  "googleAdsAccountExclusionsCategories";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_ID =
  "googleAdsAccountExclusionsAppId";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_APP_NAME =
  "googleAdsAccountExclusionsAppName";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SEARCH_CATEGORIES =
  "googleAdsAccountExclusionsSearchCategories";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_EMPTY =
  "googleAdsAccountExclusionsEmpty";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVED =
  "googleAdsAccountExclusionsSaved";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_SAVE_ERROR =
  "googleAdsAccountExclusionsSaveError";
export const GOOGLE_ADS_ACCOUNT_EXCLUSIONS_LOAD_ERROR =
  "googleAdsAccountExclusionsLoadError";
export const GOOGLE_ADS_CONTENT_LABEL_BELOW_THE_FOLD =
  "googleAdsContentLabelBelowTheFold";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_CONTENT_FOR_FAMILIES =
  "googleAdsContentLabelContentForFamilies";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_FIGHTING =
  "googleAdsContentLabelGamesFighting";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_GAMES_MATURE =
  "googleAdsContentLabelGamesMature";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SENSITIVE =
  "googleAdsContentLabelHealthSensitive";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_HEALTH_SOURCE_UNDETERMINED =
  "googleAdsContentLabelHealthSourceUndetermined";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_RECENT =
  "googleAdsContentLabelNewsRecent";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SENSITIVE =
  "googleAdsContentLabelNewsSensitive";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_NEWS_SOURCE_NOT_FEATURED =
  "googleAdsContentLabelNewsSourceNotFeatured";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_POLITICS =
  "googleAdsContentLabelPolitics";
export const GOOGLE_ADS_CONTENT_LABEL_BRAND_SUITABILITY_RELIGION =
  "googleAdsContentLabelReligion";
export const GOOGLE_ADS_CONTENT_LABEL_EMBEDDED_VIDEO =
  "googleAdsContentLabelEmbeddedVideo";
export const GOOGLE_ADS_CONTENT_LABEL_JUVENILE =
  "googleAdsContentLabelJuvenile";
export const GOOGLE_ADS_CONTENT_LABEL_LIVE_STREAMING_VIDEO =
  "googleAdsContentLabelLiveStreamingVideo";
export const GOOGLE_ADS_CONTENT_LABEL_PARKED_DOMAIN =
  "googleAdsContentLabelParkedDomain";
export const GOOGLE_ADS_CONTENT_LABEL_PROFANITY =
  "googleAdsContentLabelProfanity";
export const GOOGLE_ADS_CONTENT_LABEL_SEXUALLY_SUGGESTIVE =
  "googleAdsContentLabelSexuallySuggestive";
export const GOOGLE_ADS_CONTENT_LABEL_SOCIAL_ISSUES =
  "googleAdsContentLabelSocialIssues";
export const GOOGLE_ADS_CONTENT_LABEL_TRAGEDY = "googleAdsContentLabelTragedy";
export const GOOGLE_ADS_CONTENT_LABEL_VIDEO = "googleAdsContentLabelVideo";
export const GOOGLE_ADS_CONTENT_LABEL_VIDEO_NOT_YET_RATED =
  "googleAdsContentLabelVideoNotYetRated";
export const GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_G =
  "googleAdsContentLabelVideoRatingG";
export const GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_MA =
  "googleAdsContentLabelVideoRatingMa";
export const GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_PG =
  "googleAdsContentLabelVideoRatingPg";
export const GOOGLE_ADS_CONTENT_LABEL_VIDEO_RATING_DV_T =
  "googleAdsContentLabelVideoRatingT";

export const FEATURE_ADDON_PAYWALL_TITLE = "featureAddonPaywallTitle";
export const FEATURE_ADDON_PAYWALL_DESCRIPTION =
  "featureAddonPaywallDescription";
export const FEATURE_ADDON_PAYWALL_CURRENT_LIMIT =
  "featureAddonPaywallCurrentLimit";
export const FEATURE_ADDON_PAYWALL_TIER_CTA = "featureAddonPaywallTierCta";
export const FEATURE_ADDON_PAYWALL_CLOSE = "featureAddonPaywallClose";
export const FEATURE_ADDON_PAYWALL_FREE = "featureAddonPaywallFree";
export const FEATURE_ADDON_PAYWALL_INCLUDED = "featureAddonPaywallIncluded";
export const FEATURE_ADDON_INCLUDED_AUTOMATIONS =
  "featureAddonIncludedAutomations";
export const FEATURE_ADDON_INCLUDED_TEMPLATES = "featureAddonIncludedTemplates";
export const FEATURE_ADDON_INCLUDED_COMPETITORS =
  "featureAddonIncludedCompetitors";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_POOL_ONE =
  "featureAddonBenefitCompetitorsPoolOne";
export const FEATURE_ADDON_PAYWALL_CURRENT = "featureAddonPaywallCurrent";
export const FEATURE_ADDON_PAYWALL_PER_MONTH = "featureAddonPaywallPerMonth";
export const FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS =
  "featureAddonBenefitCapacityAutomations";
export const FEATURE_ADDON_BENEFIT_CAPACITY_AUTOMATIONS_ONE =
  "featureAddonBenefitCapacityAutomationsOne";
export const FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES =
  "featureAddonBenefitCapacityTemplates";
export const FEATURE_ADDON_BENEFIT_CAPACITY_TEMPLATES_ONE =
  "featureAddonBenefitCapacityTemplatesOne";
export const FEATURE_ADDON_BENEFIT_ACTIONS = "featureAddonBenefitActions";
export const FEATURE_ADDON_BENEFIT_ACTIONS_ONE =
  "featureAddonBenefitActionsOne";
export const FEATURE_ADDON_BENEFIT_VISIBILITY = "featureAddonBenefitVisibility";
export const FEATURE_ADDON_BENEFIT_VISIBILITY_ALL =
  "featureAddonBenefitVisibilityAll";
export const FEATURE_ADDON_PAYWALL_TIER_NAME = "featureAddonPaywallTierName";
export const FEATURE_ADDON_HERO_AUTOMATIONS = "featureAddonHeroAutomations";
export const FEATURE_ADDON_HERO_TEMPLATES = "featureAddonHeroTemplates";
export const FEATURE_ADDON_HERO_COMPETITORS = "featureAddonHeroCompetitors";
export const FEATURE_ADDON_BENEFIT_AUTOMATIONS_PUBLISH =
  "featureAddonBenefitAutomationsPublish";
export const FEATURE_ADDON_BENEFIT_AUTOMATIONS_SCHEDULE =
  "featureAddonBenefitAutomationsSchedule";
export const FEATURE_ADDON_BENEFIT_TEMPLATES_LAYERS =
  "featureAddonBenefitTemplatesLayers";
export const FEATURE_ADDON_BENEFIT_TEMPLATES_ANALYZE =
  "featureAddonBenefitTemplatesAnalyze";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_SAVE =
  "featureAddonBenefitCompetitorsSave";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_INSPIRE =
  "featureAddonBenefitCompetitorsInspire";
export const FEATURE_ADDON_BENEFIT_AUTOMATIONS_PLATFORMS =
  "featureAddonBenefitAutomationsPlatforms";
export const FEATURE_ADDON_BENEFIT_AUTOMATIONS_FREQUENCY =
  "featureAddonBenefitAutomationsFrequency";
export const FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_TERM =
  "featureAddonClarificationMultiplatformTerm";
export const FEATURE_ADDON_CLARIFICATION_MULTIPLATFORM_BODY =
  "featureAddonClarificationMultiplatformBody";
export const FEATURE_ADDON_BENEFIT_TEMPLATES_PRODUCE =
  "featureAddonBenefitTemplatesProduce";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_PLATFORMS =
  "featureAddonBenefitCompetitorsPlatforms";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES =
  "featureAddonBenefitCompetitorsFavorites";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_FAVORITES_ONE =
  "featureAddonBenefitCompetitorsFavoritesOne";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE =
  "featureAddonBenefitCompetitorsGenerate";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_GENERATE_ONE =
  "featureAddonBenefitCompetitorsGenerateOne";
export const FEATURE_ADDON_BENEFIT_COMPETITORS_POOL =
  "featureAddonBenefitCompetitorsPool";
export const FEATURE_ADDON_NAME_AUTOMATIONS = "featureAddonNameAutomations";
export const FEATURE_ADDON_NAME_TEMPLATES = "featureAddonNameTemplates";
export const FEATURE_ADDON_NAME_COMPETITORS = "featureAddonNameCompetitors";
export const FEATURE_ADDON_UNPAID_TITLE = "featureAddonUnpaidTitle";
export const FEATURE_ADDON_UNPAID_PERIOD = "featureAddonUnpaidPeriod";
export const FEATURE_ADDON_UNPAID_AMOUNT = "featureAddonUnpaidAmount";
export const FEATURE_ADDON_BILLING_TITLE = "featureAddonBillingTitle";
export const FEATURE_ADDON_BILLING_RENEWS = "featureAddonBillingRenews";
export const FEATURE_ADDON_BILLING_CANCELS = "featureAddonBillingCancels";
export const FEATURE_ADDON_BILLING_UPGRADE = "featureAddonBillingUpgrade";
export const FEATURE_ADDON_BILLING_CANCEL_TITLE =
  "featureAddonBillingCancelTitle";
export const FEATURE_ADDON_BILLING_CANCEL_MODAL_TITLE =
  "featureAddonBillingCancelModalTitle";
export const FEATURE_ADDON_BILLING_CANCEL_MODAL_CONFIRM =
  "featureAddonBillingCancelModalConfirm";
export const FEATURE_ADDON_BILLING_CANCEL_MODAL_KEEP =
  "featureAddonBillingCancelModalKeep";
export const FEATURE_ADDON_BILLING_CANCEL_DESCRIPTION =
  "featureAddonBillingCancelDescription";
export const FEATURE_ADDON_BILLING_CANCELLED_TITLE =
  "featureAddonBillingCancelledTitle";
export const FEATURE_ADDON_BILLING_REACTIVATED_TITLE =
  "featureAddonBillingReactivatedTitle";
export const FEATURE_ADDON_BILLING_MENU = "featureAddonBillingMenu";
export const EXTRA_SEATS_MANAGE = "extraSeatsManage";
export const EXTRA_SEATS_MODAL_TITLE = "extraSeatsModalTitle";
export const EXTRA_SEATS_MODAL_SUBTITLE = "extraSeatsModalSubtitle";
export const EXTRA_SEATS_MODAL_SUBTITLE_NO_PRICE =
  "extraSeatsModalSubtitleNoPrice";
export const EXTRA_SEATS_QUANTITY_LABEL = "extraSeatsQuantityLabel";
export const EXTRA_SEATS_DELTA_USERS_ONE = "extraSeatsDeltaUsersOne";
export const EXTRA_SEATS_DELTA_USERS = "extraSeatsDeltaUsers";
export const EXTRA_SEATS_AMOUNT_PER_MONTH = "extraSeatsAmountPerMonth";
export const EXTRA_SEATS_DUE_TODAY_LABEL = "extraSeatsDueTodayLabel";
export const EXTRA_SEATS_PRORATION_TODAY = "extraSeatsProrationToday";
export const EXTRA_SEATS_NEXT_TOTAL_FROM = "extraSeatsNextTotalFrom";
export const EXTRA_SEATS_NEXT_TOTAL_MONTHLY = "extraSeatsNextTotalMonthly";
export const EXTRA_SEATS_MONTHLY_TOTAL = "extraSeatsMonthlyTotal";
export const EXTRA_SEATS_KEEP_UNTIL_CYCLE_ONE = "extraSeatsKeepUntilCycleOne";
export const EXTRA_SEATS_KEEP_UNTIL_CYCLE = "extraSeatsKeepUntilCycle";
export const EXTRA_SEATS_PRORATION_NOTE = "extraSeatsProrationNote";
export const EXTRA_SEATS_NO_CHARGE_NOTE = "extraSeatsNoChargeNote";
export const EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK_ONE =
  "extraSeatsActiveMembersBlockOne";
export const EXTRA_SEATS_ACTIVE_MEMBERS_BLOCK = "extraSeatsActiveMembersBlock";
export const EXTRA_SEATS_REDUCE_BLOCKED_ONE = "extraSeatsReduceBlockedOne";
export const EXTRA_SEATS_REDUCE_BLOCKED = "extraSeatsReduceBlocked";
export const EXTRA_SEATS_CONFIRM = "extraSeatsConfirm";
export const EXTRA_SEATS_ADDED = "extraSeatsAdded";
export const EXTRA_SEATS_CHECKOUT_CANCELLED = "extraSeatsCheckoutCancelled";
export const EXTRA_SEATS_CHECKOUT_INCOMPLETE = "extraSeatsCheckoutIncomplete";
export const EXTRA_SEATS_BILLING_ROW_TITLE = "extraSeatsBillingRowTitle";
export const EXTRA_SEATS_QUANTITY_BADGE = "extraSeatsQuantityBadge";
export const EXTRA_SEATS_REDUCE_NOTICE = "extraSeatsReduceNotice";
export const EXTRA_SEATS_CANCEL_NOTICE = "extraSeatsCancelNotice";
export const EXTRA_SEATS_CHANGE_SAVED = "extraSeatsChangeSaved";
export const EXTRA_SEATS_FORBIDDEN = "extraSeatsForbidden";
export const EXTRA_SEATS_DECREASE = "extraSeatsDecrease";
export const EXTRA_SEATS_INCREASE = "extraSeatsIncrease";
export const EXTRA_SEATS_RETRY = "extraSeatsRetry";
export const EXTRA_SEATS_REACTIVATE_NOT_ELIGIBLE =
  "extraSeatsReactivateNotEligible";
export const EXTRA_SEATS_CHECKOUT_FORBIDDEN = "extraSeatsCheckoutForbidden";
export const EXTRA_SEATS_MISSING_AGENCY = "extraSeatsMissingAgency";
export const SEAT_LIMIT_REACHED = "seatLimitReached";
export const SEATS_QUANTITY_CHANGED = "seatsQuantityChanged";
export const SEATS_OPERATION_IN_PROGRESS = "seatsOperationInProgress";
export const SEATS_UNPAID = "seatsUnpaid";
export const SEATS_QUANTITY_OUT_OF_RANGE = "seatsQuantityOutOfRange";
export const SEATS_NOT_ELIGIBLE = "seatsNotEligible";
export const SEATS_PRICE_NOT_CONFIGURED = "seatsPriceNotConfigured";
export const SEATS_SUBSCRIPTION_NOT_FOUND = "seatsSubscriptionNotFound";
export const BUTTON_BULK_CREATE_CAMPAIGNS = "buttonBulkCreateCampaigns";
export const BULK_CAMPAIGNS_DESCRIPTION = "bulkCampaignsDescription";
export const BULK_CAMPAIGNS_SUMMARY = "bulkCampaignsSummary";
export const BULK_CAMPAIGNS_LIST_TITLE = "bulkCampaignsListTitle";
export const BULK_CAMPAIGNS_GENERATE = "bulkCampaignsGenerate";
export const BULK_CAMPAIGNS_GENERATING = "bulkCampaignsGenerating";
export const BULK_CAMPAIGNS_GENERATE_ERROR = "bulkCampaignsGenerateError";
export const BULK_CAMPAIGNS_PLATFORM_NOT_SUPPORTED =
  "bulkCampaignsPlatformNotSupported";
export const BULK_CAMPAIGNS_PLATFORM_NOT_DETECTED =
  "bulkCampaignsPlatformNotDetected";
export const BULK_CAMPAIGNS_TYPE_NOT_SUPPORTED =
  "bulkCampaignsTypeNotSupported";
export const BULK_CAMPAIGNS_ALERT_ANALYZING = "bulkCampaignsAlertAnalyzing";
export const BULK_CAMPAIGNS_ALERT_ANALYSIS_SUCCESS =
  "bulkCampaignsAlertAnalysisSuccess";
export const BULK_CAMPAIGNS_ALERT_ANALYSIS_ERROR =
  "bulkCampaignsAlertAnalysisError";
export const BULK_CAMPAIGNS_ALERT_GENERATING = "bulkCampaignsAlertGenerating";
export const BULK_CAMPAIGNS_ALERT_GENERATION_SUCCESS =
  "bulkCampaignsAlertGenerationSuccess";
export const BULK_CAMPAIGNS_ALERT_GENERATION_ERROR =
  "bulkCampaignsAlertGenerationError";
export const BULK_CAMPAIGNS_TITLE = "bulkCampaignsTitle";
export const BULK_CAMPAIGNS_DROP_TITLE = "bulkCampaignsDropTitle";
export const BULK_CAMPAIGNS_DROP_FORMATS = "bulkCampaignsDropFormats";
export const BULK_CAMPAIGNS_ANALYZING = "bulkCampaignsAnalyzing";
export const BULK_CAMPAIGNS_FILE_NOT_SUPPORTED =
  "bulkCampaignsFileNotSupported";
export const BULK_CAMPAIGNS_FILE_TOO_LARGE = "bulkCampaignsFileTooLarge";
export const BULK_CAMPAIGNS_EXTRACT_ERROR = "bulkCampaignsExtractError";
export const BULK_CAMPAIGNS_CONTENTS_LOAD_ERROR =
  "bulkCampaignsContentsLoadError";
export const BULK_CAMPAIGNS_NO_CAMPAIGNS_FOUND =
  "bulkCampaignsNoCampaignsFound";
export const BULK_CAMPAIGNS_CHOOSE_ANOTHER_FILE =
  "bulkCampaignsChooseAnotherFile";

// Campaign agent panel
export const CAMPAIGN_AGENT_WELCOME_TITLE = "campaignAgentWelcomeTitle";
export const CAMPAIGN_AGENT_WELCOME_SUBTITLE = "campaignAgentWelcomeSubtitle";
export const CAMPAIGN_AGENT_STEP_ASK = "campaignAgentStepAsk";
export const CAMPAIGN_AGENT_STEP_REVIEW = "campaignAgentStepReview";
export const CAMPAIGN_AGENT_STEP_APPLY = "campaignAgentStepApply";
export const CAMPAIGN_AGENT_WELCOME_HINT = "campaignAgentWelcomeHint";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER = "campaignAgentInputPlaceholder";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1 =
  "campaignAgentInputPlaceholderExample1";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2 =
  "campaignAgentInputPlaceholderExample2";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3 =
  "campaignAgentInputPlaceholderExample3";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4 =
  "campaignAgentInputPlaceholderExample4";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5 =
  "campaignAgentInputPlaceholderExample5";
export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6 =
  "campaignAgentInputPlaceholderExample6";
export const CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE =
  "campaignAgentCardLearningsTitle";
export const CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION =
  "campaignAgentCardLearningsDescription";
export const CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION =
  "campaignAgentCardLearningsQuestion";
export const CAMPAIGN_AGENT_CARD_IMPROVE_TITLE =
  "campaignAgentCardImproveTitle";
export const CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION =
  "campaignAgentCardImproveDescription";
export const CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION =
  "campaignAgentCardImproveQuestion";
export const CAMPAIGN_AGENT_CARD_BUDGET_TITLE = "campaignAgentCardBudgetTitle";
export const CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION =
  "campaignAgentCardBudgetDescription";
export const CAMPAIGN_AGENT_CARD_BUDGET_QUESTION =
  "campaignAgentCardBudgetQuestion";
export const CAMPAIGN_AGENT_CARD_COPY_TITLE = "campaignAgentCardCopyTitle";
export const CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION =
  "campaignAgentCardCopyDescription";
export const CAMPAIGN_AGENT_CARD_COPY_QUESTION =
  "campaignAgentCardCopyQuestion";
export const CAMPAIGN_AGENT_IMPROVEMENTS_READY_ONE =
  "campaignAgentImprovementsReadyOne";
export const CAMPAIGN_AGENT_IMPROVEMENTS_READY_MANY =
  "campaignAgentImprovementsReadyMany";
export const CAMPAIGN_AGENT_IMPROVEMENTS_READY_DESCRIPTION =
  "campaignAgentImprovementsReadyDescription";
export const CAMPAIGN_AGENT_CHANGES_COUNT_ONE = "campaignAgentChangesCountOne";
export const CAMPAIGN_AGENT_CHANGES_COUNT_MANY =
  "campaignAgentChangesCountMany";
export const CAMPAIGN_AGENT_CREATIVE_BADGE = "campaignAgentCreativeBadge";
export const CAMPAIGN_AGENT_SUMMARY_TITLE = "campaignAgentSummaryTitle";
export const CAMPAIGN_AGENT_SUMMARY_NEW_VALUE = "campaignAgentSummaryNewValue";
export const CAMPAIGN_AGENT_SUMMARY_NEW_VALUES =
  "campaignAgentSummaryNewValues";
export const CAMPAIGN_AGENT_SUMMARY_ADD_ONE = "campaignAgentSummaryAddOne";
export const CAMPAIGN_AGENT_SUMMARY_ADD_MANY = "campaignAgentSummaryAddMany";
export const CAMPAIGN_AGENT_SUMMARY_REMOVE_ONE =
  "campaignAgentSummaryRemoveOne";
export const CAMPAIGN_AGENT_SUMMARY_REMOVE_ITEM =
  "campaignAgentSummaryRemoveItem";
export const CAMPAIGN_AGENT_SUMMARY_REMOVE_MANY =
  "campaignAgentSummaryRemoveMany";
export const CAMPAIGN_AGENT_SUMMARY_CREATE = "campaignAgentSummaryCreate";
export const CAMPAIGN_AGENT_SUMMARY_CREATE_UNNAMED =
  "campaignAgentSummaryCreateUnnamed";
export const CAMPAIGN_AGENT_SUMMARY_CREATIVE = "campaignAgentSummaryCreative";
export const CAMPAIGN_AGENT_SUMMARY_MORE_ONE = "campaignAgentSummaryMoreOne";
export const CAMPAIGN_AGENT_SUMMARY_MORE_MANY = "campaignAgentSummaryMoreMany";
export const CAMPAIGN_AGENT_SUMMARY_FOOTNOTE = "campaignAgentSummaryFootnote";
export const CAMPAIGN_AGENT_SUMMARY_CREATIVE_FOOTNOTE =
  "campaignAgentSummaryCreativeFootnote";
export const CAMPAIGN_AGENT_SUMMARY_MANUAL = "campaignAgentSummaryManual";
export const BUTTON_CAMPAIGN_AGENT_REVIEW_AND_APPLY =
  "buttonCampaignAgentReviewAndApply";
export const BUTTON_CAMPAIGN_AGENT_APPLY_AND_OPEN_AD =
  "buttonCampaignAgentApplyAndOpenAd";
export const BUTTON_CAMPAIGN_AGENT_VIEW_RECOMMENDATION =
  "buttonCampaignAgentViewRecommendation";
export const BUTTON_CAMPAIGN_AGENT_VIEW_CHANGES =
  "buttonCampaignAgentViewChanges";
export const CAMPAIGN_AGENT_APPLIED_BADGE = "campaignAgentAppliedBadge";
export const CAMPAIGN_AGENT_APPLIED_CAPTION = "campaignAgentAppliedCaption";
export const CAMPAIGN_AGENT_DONE_CAPTION = "campaignAgentDoneCaption";
export const CAMPAIGN_AGENT_DISCARDED_BADGE = "campaignAgentDiscardedBadge";
export const CAMPAIGN_AGENT_DISCARDED_CAPTION = "campaignAgentDiscardedCaption";
export const CAMPAIGN_AGENT_RESULT_APPLIED_TITLE =
  "campaignAgentResultAppliedTitle";
export const CAMPAIGN_AGENT_RESULT_APPLIED_DESCRIPTION =
  "campaignAgentResultAppliedDescription";
export const CAMPAIGN_AGENT_RESULT_PARTIAL_TITLE =
  "campaignAgentResultPartialTitle";
export const CAMPAIGN_AGENT_RESULT_PARTIAL_DESCRIPTION =
  "campaignAgentResultPartialDescription";
export const CAMPAIGN_AGENT_RESULT_FAILED_TITLE =
  "campaignAgentResultFailedTitle";
export const CAMPAIGN_AGENT_RESULT_FAILED_DESCRIPTION =
  "campaignAgentResultFailedDescription";
export const CAMPAIGN_AGENT_RESULT_CREATIVE_TITLE =
  "campaignAgentResultCreativeTitle";
export const CAMPAIGN_AGENT_RESULT_CREATIVE_DESCRIPTION =
  "campaignAgentResultCreativeDescription";
export const BUTTON_CAMPAIGN_AGENT_GO_TO_PUBLISH =
  "buttonCampaignAgentGoToPublish";
export const BUTTON_CAMPAIGN_AGENT_NEXT_IMPROVEMENT =
  "buttonCampaignAgentNextImprovement";
export const BUTTON_CAMPAIGN_AGENT_ASK_ALTERNATIVE =
  "buttonCampaignAgentAskAlternative";
export const CAMPAIGN_AGENT_ASK_ALTERNATIVE_MESSAGE =
  "campaignAgentAskAlternativeMessage";
export const CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE =
  "campaignAgentFollowUpMoreTitle";
export const CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE =
  "campaignAgentFollowUpMoreMessage";
export const CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE =
  "campaignAgentFollowUpBudgetTitle";
export const CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE =
  "campaignAgentFollowUpCopyTitle";
export const CAMPAIGN_AGENT_BUTTON_TOOLTIP = "campaignAgentButtonTooltip";
export const CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_ONE =
  "campaignAgentButtonTooltipPendingOne";
export const CAMPAIGN_AGENT_BUTTON_TOOLTIP_PENDING_MANY =
  "campaignAgentButtonTooltipPendingMany";
export const PAYWALL_INSUFFICIENT_CREDITS_TITLE =
  "paywallInsufficientCreditsTitle";
export const PAYWALL_INSUFFICIENT_CREDITS_SUBTITLE =
  "paywallInsufficientCreditsSubtitle";
export const PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_TITLE =
  "paywallInsufficientCreditsUpgradeTitle";
export const PAYWALL_INSUFFICIENT_CREDITS_UPGRADE_DESCRIPTION =
  "paywallInsufficientCreditsUpgradeDescription";
export const PAYWALL_INSUFFICIENT_CREDITS_BUY_TITLE =
  "paywallInsufficientCreditsBuyTitle";
export const PAYWALL_INSUFFICIENT_CREDITS_BUY_DESCRIPTION =
  "paywallInsufficientCreditsBuyDescription";
export const PAYWALL_INSUFFICIENT_CREDITS_ARIA_LABEL =
  "paywallInsufficientCreditsAriaLabel";
export const BULK_CAMPAIGNS_EMPTY_FILE = "bulkCampaignsEmptyFile";
export const BULK_CAMPAIGNS_TOO_MANY_CONTENTS = "bulkCampaignsTooManyContents";
export const BULK_CAMPAIGNS_ANALYZE = "bulkCampaignsAnalyze";
export const BULK_CAMPAIGNS_CANCEL_ANALYSIS = "bulkCampaignsCancelAnalysis";
export const BULK_CAMPAIGNS_STALE = "bulkCampaignsStale";
export const BULK_CAMPAIGNS_SELECT_CONTENTS = "bulkCampaignsSelectContents";
export const BULK_CAMPAIGNS_CONTENTS_HINT = "bulkCampaignsContentsHint";
export const BULK_CAMPAIGNS_CONTENTS_COUNTER = "bulkCampaignsContentsCounter";
export const BULK_CAMPAIGNS_REMOVE_CONTENT = "bulkCampaignsRemoveContent";
export const BULK_CAMPAIGNS_FILE_READY = "bulkCampaignsFileReady";
export const BULK_CAMPAIGNS_REPLACE_FILE = "bulkCampaignsReplaceFile";
export const BULK_CAMPAIGNS_RESULT_CREATED = "bulkCampaignsResultCreated";
export const BULK_CAMPAIGNS_RESULT_FAILED = "bulkCampaignsResultFailed";
export const BULK_CAMPAIGNS_RESULT_CLEARED = "bulkCampaignsResultCleared";
export const BULK_CAMPAIGNS_RESULT_CLEARED_DETAIL =
  "bulkCampaignsResultClearedDetail";
export const BULK_CAMPAIGNS_RESULT_TITLE = "bulkCampaignsResultTitle";
export const BULK_CAMPAIGNS_VIEW_CAMPAIGNS = "bulkCampaignsViewCampaigns";
export const BULK_CAMPAIGNS_SUMMARY_COUNT = "bulkCampaignsSummaryCount";
export const BULK_CAMPAIGNS_ACCOUNTS_UNAVAILABLE =
  "bulkCampaignsAccountsUnavailable";
export const BULK_FIELD_PRIMARY_TEXT = "bulk.field.primaryText";
export const BULK_FIELD_HEADLINE = "bulk.field.headline";
export const BULK_FIELD_LONG_HEADLINE = "bulk.field.longHeadline";
export const BULK_FIELD_SEARCH_THEME = "bulk.field.searchTheme";
export const BULK_FIELD_CALL_TO_ACTION = "bulk.field.callToAction";
export const BULK_FIELD_TITLES = "bulk.field.titles";
export const BULK_FIELD_HEADLINES = "bulk.field.headlines";
export const BULK_FIELD_LONG_HEADLINES = "bulk.field.longHeadlines";
export const BULK_FIELD_DESCRIPTIONS = "bulk.field.descriptions";
export const BULK_FIELD_KEYWORDS = "bulk.field.keywords";
export const BULK_FIELD_KEYWORDS_NEGATIVE = "bulk.field.keywordsNegative";
export const BULK_FIELD_DESTINATION_URL = "bulk.field.destinationURL";
export const BULK_FIELD_DAILY_BUDGET = "bulk.field.dailyBudget";
export const BULK_FIELD_LANGUAGE = "bulk.field.language";
export const BULK_FIELD_OBJECTIVE = "bulk.field.objective";
export const BULK_FIELD_SEARCH_THEMES = "bulk.field.searchThemes";
export const BULK_FIELD_CALLOUTS = "bulk.field.callOuts";
export const BULK_FIELD_AUDIENCE = "bulk.field.audience";
export const BULK_FIELD_PAGE = "bulk.field.page";
export const BULK_FIELD_INSTAGRAM = "bulk.field.instagram";
export const BULK_FIELD_IDENTITY = "bulk.field.identity";
export const BULK_FIELD_APP = "bulk.field.app";
export const BULK_FIELD_APP_STORE = "bulk.field.appStore";
export const BULK_FIELD_AD_FORMAT = "bulk.field.adFormat";
export const BULK_FIELD_ACCOUNT = "bulk.field.account";
export const BULK_FIELD_MERCHANT = "bulk.field.merchantCenter";
export const BULK_FIELD_LOCATIONS = "bulk.field.locations";
export const BULK_PLATFORM_GOOGLE = "bulk.platform.google";
export const BULK_PLATFORM_META = "bulk.platform.meta";
export const BULK_PLATFORM_TIKTOK = "bulk.platform.tiktok";
export const BULK_PLATFORM_LINKEDIN = "bulk.platform.linkedIn";

// TikTok advertiser industries
export const TIKTOK_INDUSTRY_22102000000 = "tiktokIndustry22102000000";
export const TIKTOK_INDUSTRY_22101000000 = "tiktokIndustry22101000000";
export const TIKTOK_INDUSTRY_22107000000 = "tiktokIndustry22107000000";
export const TIKTOK_INDUSTRY_22108000000 = "tiktokIndustry22108000000";
export const TIKTOK_INDUSTRY_22109000000 = "tiktokIndustry22109000000";
export const TIKTOK_INDUSTRY_22106000000 = "tiktokIndustry22106000000";
export const TIKTOK_INDUSTRY_22999000000 = "tiktokIndustry22999000000";
export const TIKTOK_INDUSTRY_22112000000 = "tiktokIndustry22112000000";
export const TIKTOK_INDUSTRY_22105000000 = "tiktokIndustry22105000000";
export const TIKTOK_INDUSTRY_22113000000 = "tiktokIndustry22113000000";
export const TIKTOK_INDUSTRY_22110000000 = "tiktokIndustry22110000000";
export const TIKTOK_INDUSTRY_22111000000 = "tiktokIndustry22111000000";
export const TIKTOK_INDUSTRY_16105000000 = "tiktokIndustry16105000000";
export const TIKTOK_INDUSTRY_16104000000 = "tiktokIndustry16104000000";
export const TIKTOK_INDUSTRY_16101000000 = "tiktokIndustry16101000000";
export const TIKTOK_INDUSTRY_16102000000 = "tiktokIndustry16102000000";
export const TIKTOK_INDUSTRY_16999000000 = "tiktokIndustry16999000000";
export const TIKTOK_INDUSTRY_16100000000 = "tiktokIndustry16100000000";
export const TIKTOK_INDUSTRY_20101000000 = "tiktokIndustry20101000000";
export const TIKTOK_INDUSTRY_20110000000 = "tiktokIndustry20110000000";
export const TIKTOK_INDUSTRY_20104000000 = "tiktokIndustry20104000000";
export const TIKTOK_INDUSTRY_20106000000 = "tiktokIndustry20106000000";
export const TIKTOK_INDUSTRY_20109000000 = "tiktokIndustry20109000000";
export const TIKTOK_INDUSTRY_20107000000 = "tiktokIndustry20107000000";
export const TIKTOK_INDUSTRY_20102000000 = "tiktokIndustry20102000000";
export const TIKTOK_INDUSTRY_20105000000 = "tiktokIndustry20105000000";
export const TIKTOK_INDUSTRY_20999000000 = "tiktokIndustry20999000000";
export const TIKTOK_INDUSTRY_20111000000 = "tiktokIndustry20111000000";
export const TIKTOK_INDUSTRY_20103000000 = "tiktokIndustry20103000000";
export const TIKTOK_INDUSTRY_20100000000 = "tiktokIndustry20100000000";
export const TIKTOK_INDUSTRY_20108000000 = "tiktokIndustry20108000000";
export const TIKTOK_INDUSTRY_20112000000 = "tiktokIndustry20112000000";
export const TIKTOK_INDUSTRY_12104000000 = "tiktokIndustry12104000000";
export const TIKTOK_INDUSTRY_12108000000 = "tiktokIndustry12108000000";
export const TIKTOK_INDUSTRY_12100000000 = "tiktokIndustry12100000000";
export const TIKTOK_INDUSTRY_12102000000 = "tiktokIndustry12102000000";
export const TIKTOK_INDUSTRY_12110000000 = "tiktokIndustry12110000000";
export const TIKTOK_INDUSTRY_12105000000 = "tiktokIndustry12105000000";
export const TIKTOK_INDUSTRY_12107000000 = "tiktokIndustry12107000000";
export const TIKTOK_INDUSTRY_12109000000 = "tiktokIndustry12109000000";
export const TIKTOK_INDUSTRY_12103000000 = "tiktokIndustry12103000000";
export const TIKTOK_INDUSTRY_12999000000 = "tiktokIndustry12999000000";
export const TIKTOK_INDUSTRY_12101000000 = "tiktokIndustry12101000000";
export const TIKTOK_INDUSTRY_12106000000 = "tiktokIndustry12106000000";
export const TIKTOK_INDUSTRY_14105000000 = "tiktokIndustry14105000000";
export const TIKTOK_INDUSTRY_14104000000 = "tiktokIndustry14104000000";
export const TIKTOK_INDUSTRY_14107000000 = "tiktokIndustry14107000000";
export const TIKTOK_INDUSTRY_14106000000 = "tiktokIndustry14106000000";
export const TIKTOK_INDUSTRY_14101000000 = "tiktokIndustry14101000000";
export const TIKTOK_INDUSTRY_14100000000 = "tiktokIndustry14100000000";
export const TIKTOK_INDUSTRY_14999000000 = "tiktokIndustry14999000000";
export const TIKTOK_INDUSTRY_14103000000 = "tiktokIndustry14103000000";
export const TIKTOK_INDUSTRY_14102000000 = "tiktokIndustry14102000000";
export const TIKTOK_INDUSTRY_24108000000 = "tiktokIndustry24108000000";
export const TIKTOK_INDUSTRY_24118000000 = "tiktokIndustry24118000000";
export const TIKTOK_INDUSTRY_24105000000 = "tiktokIndustry24105000000";
export const TIKTOK_INDUSTRY_24103000000 = "tiktokIndustry24103000000";
export const TIKTOK_INDUSTRY_24104000000 = "tiktokIndustry24104000000";
export const TIKTOK_INDUSTRY_24109000000 = "tiktokIndustry24109000000";
export const TIKTOK_INDUSTRY_24114000000 = "tiktokIndustry24114000000";
export const TIKTOK_INDUSTRY_24107000000 = "tiktokIndustry24107000000";
export const TIKTOK_INDUSTRY_24120000000 = "tiktokIndustry24120000000";
export const TIKTOK_INDUSTRY_24119000000 = "tiktokIndustry24119000000";
export const TIKTOK_INDUSTRY_24116000000 = "tiktokIndustry24116000000";
export const TIKTOK_INDUSTRY_24117000000 = "tiktokIndustry24117000000";
export const TIKTOK_INDUSTRY_24111000000 = "tiktokIndustry24111000000";
export const TIKTOK_INDUSTRY_24106000000 = "tiktokIndustry24106000000";
export const TIKTOK_INDUSTRY_24112000000 = "tiktokIndustry24112000000";
export const TIKTOK_INDUSTRY_24101000000 = "tiktokIndustry24101000000";
export const TIKTOK_INDUSTRY_24999000000 = "tiktokIndustry24999000000";
export const TIKTOK_INDUSTRY_24113000000 = "tiktokIndustry24113000000";
export const TIKTOK_INDUSTRY_24100000000 = "tiktokIndustry24100000000";
export const TIKTOK_INDUSTRY_24102000000 = "tiktokIndustry24102000000";
export const TIKTOK_INDUSTRY_24110000000 = "tiktokIndustry24110000000";
export const TIKTOK_INDUSTRY_24115000000 = "tiktokIndustry24115000000";
export const TIKTOK_INDUSTRY_30100000000 = "tiktokIndustry30100000000";
export const TIKTOK_INDUSTRY_30102000000 = "tiktokIndustry30102000000";
export const TIKTOK_INDUSTRY_30101000000 = "tiktokIndustry30101000000";
export const TIKTOK_INDUSTRY_10100000000 = "tiktokIndustry10100000000";
export const TIKTOK_INDUSTRY_10102000000 = "tiktokIndustry10102000000";
export const TIKTOK_INDUSTRY_10105000000 = "tiktokIndustry10105000000";
export const TIKTOK_INDUSTRY_10106000000 = "tiktokIndustry10106000000";
export const TIKTOK_INDUSTRY_10999000000 = "tiktokIndustry10999000000";
export const TIKTOK_INDUSTRY_10103000000 = "tiktokIndustry10103000000";
export const TIKTOK_INDUSTRY_10101000000 = "tiktokIndustry10101000000";
export const TIKTOK_INDUSTRY_10104000000 = "tiktokIndustry10104000000";
export const TIKTOK_INDUSTRY_13100000000 = "tiktokIndustry13100000000";
export const TIKTOK_INDUSTRY_13108000000 = "tiktokIndustry13108000000";
export const TIKTOK_INDUSTRY_13117000000 = "tiktokIndustry13117000000";
export const TIKTOK_INDUSTRY_13115000000 = "tiktokIndustry13115000000";
export const TIKTOK_INDUSTRY_13116000000 = "tiktokIndustry13116000000";
export const TIKTOK_INDUSTRY_13112000000 = "tiktokIndustry13112000000";
export const TIKTOK_INDUSTRY_13107000000 = "tiktokIndustry13107000000";
export const TIKTOK_INDUSTRY_13104000000 = "tiktokIndustry13104000000";
export const TIKTOK_INDUSTRY_13102000000 = "tiktokIndustry13102000000";
export const TIKTOK_INDUSTRY_13110000000 = "tiktokIndustry13110000000";
export const TIKTOK_INDUSTRY_13111000000 = "tiktokIndustry13111000000";
export const TIKTOK_INDUSTRY_13109000000 = "tiktokIndustry13109000000";
export const TIKTOK_INDUSTRY_13999000000 = "tiktokIndustry13999000000";
export const TIKTOK_INDUSTRY_13105000000 = "tiktokIndustry13105000000";
export const TIKTOK_INDUSTRY_13113000000 = "tiktokIndustry13113000000";
export const TIKTOK_INDUSTRY_13101000000 = "tiktokIndustry13101000000";
export const TIKTOK_INDUSTRY_13114000000 = "tiktokIndustry13114000000";
export const TIKTOK_INDUSTRY_1310300000 = "tiktokIndustry1310300000";
export const TIKTOK_INDUSTRY_27103000000 = "tiktokIndustry27103000000";
export const TIKTOK_INDUSTRY_27104000000 = "tiktokIndustry27104000000";
export const TIKTOK_INDUSTRY_27100000000 = "tiktokIndustry27100000000";
export const TIKTOK_INDUSTRY_27101000000 = "tiktokIndustry27101000000";
export const TIKTOK_INDUSTRY_27102000000 = "tiktokIndustry27102000000";
export const TIKTOK_INDUSTRY_27999000000 = "tiktokIndustry27999000000";
export const TIKTOK_INDUSTRY_25301000000 = "tiktokIndustry25301000000";
export const TIKTOK_INDUSTRY_25302000000 = "tiktokIndustry25302000000";
export const TIKTOK_INDUSTRY_25300000000 = "tiktokIndustry25300000000";
export const TIKTOK_INDUSTRY_25313000000 = "tiktokIndustry25313000000";
export const TIKTOK_INDUSTRY_25303000000 = "tiktokIndustry25303000000";
export const TIKTOK_INDUSTRY_25999000000 = "tiktokIndustry25999000000";
export const TIKTOK_INDUSTRY_25311000000 = "tiktokIndustry25311000000";
export const TIKTOK_INDUSTRY_25304000000 = "tiktokIndustry25304000000";
export const TIKTOK_INDUSTRY_25305000000 = "tiktokIndustry25305000000";
export const TIKTOK_INDUSTRY_25306000000 = "tiktokIndustry25306000000";
export const TIKTOK_INDUSTRY_25307000000 = "tiktokIndustry25307000000";
export const TIKTOK_INDUSTRY_25308000000 = "tiktokIndustry25308000000";
export const TIKTOK_INDUSTRY_25309000000 = "tiktokIndustry25309000000";
export const TIKTOK_INDUSTRY_25310000000 = "tiktokIndustry25310000000";
export const TIKTOK_INDUSTRY_25312000000 = "tiktokIndustry25312000000";
export const TIKTOK_INDUSTRY_29102000000 = "tiktokIndustry29102000000";
export const TIKTOK_INDUSTRY_29101000000 = "tiktokIndustry29101000000";
export const TIKTOK_INDUSTRY_29100000000 = "tiktokIndustry29100000000";
export const TIKTOK_INDUSTRY_29103000000 = "tiktokIndustry29103000000";
export const TIKTOK_INDUSTRY_29999000000 = "tiktokIndustry29999000000";
export const TIKTOK_INDUSTRY_21102000000 = "tiktokIndustry21102000000";
export const TIKTOK_INDUSTRY_21101000000 = "tiktokIndustry21101000000";
export const TIKTOK_INDUSTRY_21103000000 = "tiktokIndustry21103000000";
export const TIKTOK_INDUSTRY_21104000000 = "tiktokIndustry21104000000";
export const TIKTOK_INDUSTRY_21100000000 = "tiktokIndustry21100000000";
export const TIKTOK_INDUSTRY_21999000000 = "tiktokIndustry21999000000";
export const TIKTOK_INDUSTRY_21105000000 = "tiktokIndustry21105000000";
export const TIKTOK_INDUSTRY_18106000000 = "tiktokIndustry18106000000";
export const TIKTOK_INDUSTRY_18110000000 = "tiktokIndustry18110000000";
export const TIKTOK_INDUSTRY_18104000000 = "tiktokIndustry18104000000";
export const TIKTOK_INDUSTRY_18101000000 = "tiktokIndustry18101000000";
export const TIKTOK_INDUSTRY_18102000000 = "tiktokIndustry18102000000";
export const TIKTOK_INDUSTRY_18105000000 = "tiktokIndustry18105000000";
export const TIKTOK_INDUSTRY_18108000000 = "tiktokIndustry18108000000";
export const TIKTOK_INDUSTRY_18109000000 = "tiktokIndustry18109000000";
export const TIKTOK_INDUSTRY_18999000000 = "tiktokIndustry18999000000";
export const TIKTOK_INDUSTRY_18112000000 = "tiktokIndustry18112000000";
export const TIKTOK_INDUSTRY_18100000000 = "tiktokIndustry18100000000";
export const TIKTOK_INDUSTRY_18103000000 = "tiktokIndustry18103000000";
export const TIKTOK_INDUSTRY_18107000000 = "tiktokIndustry18107000000";
export const TIKTOK_INDUSTRY_18111000000 = "tiktokIndustry18111000000";
export const TIKTOK_INDUSTRY_26114000000 = "tiktokIndustry26114000000";
export const TIKTOK_INDUSTRY_26112000000 = "tiktokIndustry26112000000";
export const TIKTOK_INDUSTRY_26102000000 = "tiktokIndustry26102000000";
export const TIKTOK_INDUSTRY_26113000000 = "tiktokIndustry26113000000";
export const TIKTOK_INDUSTRY_26108000000 = "tiktokIndustry26108000000";
export const TIKTOK_INDUSTRY_26104000000 = "tiktokIndustry26104000000";
export const TIKTOK_INDUSTRY_26105000000 = "tiktokIndustry26105000000";
export const TIKTOK_INDUSTRY_26111000000 = "tiktokIndustry26111000000";
export const TIKTOK_INDUSTRY_26999000000 = "tiktokIndustry26999000000";
export const TIKTOK_INDUSTRY_26101000000 = "tiktokIndustry26101000000";
export const TIKTOK_INDUSTRY_26106000000 = "tiktokIndustry26106000000";
export const TIKTOK_INDUSTRY_26107000000 = "tiktokIndustry26107000000";
export const TIKTOK_INDUSTRY_26109000000 = "tiktokIndustry26109000000";
export const TIKTOK_INDUSTRY_26103000000 = "tiktokIndustry26103000000";
export const TIKTOK_INDUSTRY_26100000000 = "tiktokIndustry26100000000";
export const TIKTOK_INDUSTRY_23113000000 = "tiktokIndustry23113000000";
export const TIKTOK_INDUSTRY_23114000000 = "tiktokIndustry23114000000";
export const TIKTOK_INDUSTRY_23122000000 = "tiktokIndustry23122000000";
export const TIKTOK_INDUSTRY_23102000000 = "tiktokIndustry23102000000";
export const TIKTOK_INDUSTRY_23126000000 = "tiktokIndustry23126000000";
export const TIKTOK_INDUSTRY_23108000000 = "tiktokIndustry23108000000";
export const TIKTOK_INDUSTRY_23105000000 = "tiktokIndustry23105000000";
export const TIKTOK_INDUSTRY_23111000000 = "tiktokIndustry23111000000";
export const TIKTOK_INDUSTRY_23116000000 = "tiktokIndustry23116000000";
export const TIKTOK_INDUSTRY_23104000000 = "tiktokIndustry23104000000";
export const TIKTOK_INDUSTRY_23128000000 = "tiktokIndustry23128000000";
export const TIKTOK_INDUSTRY_23107000000 = "tiktokIndustry23107000000";
export const TIKTOK_INDUSTRY_23124000000 = "tiktokIndustry23124000000";
export const TIKTOK_INDUSTRY_23125000000 = "tiktokIndustry23125000000";
export const TIKTOK_INDUSTRY_23127000000 = "tiktokIndustry23127000000";
export const TIKTOK_INDUSTRY_23115000000 = "tiktokIndustry23115000000";
export const TIKTOK_INDUSTRY_23106000000 = "tiktokIndustry23106000000";
export const TIKTOK_INDUSTRY_23109000000 = "tiktokIndustry23109000000";
export const TIKTOK_INDUSTRY_23110000000 = "tiktokIndustry23110000000";
export const TIKTOK_INDUSTRY_23100000000 = "tiktokIndustry23100000000";
export const TIKTOK_INDUSTRY_23119000000 = "tiktokIndustry23119000000";
export const TIKTOK_INDUSTRY_23999000000 = "tiktokIndustry23999000000";
export const TIKTOK_INDUSTRY_23129000000 = "tiktokIndustry23129000000";
export const TIKTOK_INDUSTRY_23101000000 = "tiktokIndustry23101000000";
export const TIKTOK_INDUSTRY_23118000000 = "tiktokIndustry23118000000";
export const TIKTOK_INDUSTRY_23130000000 = "tiktokIndustry23130000000";
export const TIKTOK_INDUSTRY_23131000000 = "tiktokIndustry23131000000";
export const TIKTOK_INDUSTRY_23103000000 = "tiktokIndustry23103000000";
export const TIKTOK_INDUSTRY_23134000000 = "tiktokIndustry23134000000";
export const TIKTOK_INDUSTRY_23123000000 = "tiktokIndustry23123000000";
export const TIKTOK_INDUSTRY_23132000000 = "tiktokIndustry23132000000";
export const TIKTOK_INDUSTRY_23133000000 = "tiktokIndustry23133000000";
export const TIKTOK_INDUSTRY_23112000000 = "tiktokIndustry23112000000";
export const TIKTOK_INDUSTRY_23117000000 = "tiktokIndustry23117000000";
export const TIKTOK_INDUSTRY_19999000000 = "tiktokIndustry19999000000";
export const TIKTOK_INDUSTRY_19103000000 = "tiktokIndustry19103000000";
export const TIKTOK_INDUSTRY_19101000000 = "tiktokIndustry19101000000";
export const TIKTOK_INDUSTRY_19102000000 = "tiktokIndustry19102000000";
export const TIKTOK_INDUSTRY_19105000000 = "tiktokIndustry19105000000";
export const TIKTOK_INDUSTRY_19106000000 = "tiktokIndustry19106000000";
export const TIKTOK_INDUSTRY_19104000000 = "tiktokIndustry19104000000";
export const TIKTOK_INDUSTRY_19100000000 = "tiktokIndustry19100000000";
export const TIKTOK_INDUSTRY_28100000000 = "tiktokIndustry28100000000";
export const TIKTOK_INDUSTRY_28101000000 = "tiktokIndustry28101000000";
export const TIKTOK_INDUSTRY_15100000000 = "tiktokIndustry15100000000";
export const TIKTOK_INDUSTRY_15105000000 = "tiktokIndustry15105000000";
export const TIKTOK_INDUSTRY_15103000000 = "tiktokIndustry15103000000";
export const TIKTOK_INDUSTRY_15101000000 = "tiktokIndustry15101000000";
export const TIKTOK_INDUSTRY_15102000000 = "tiktokIndustry15102000000";
export const TIKTOK_INDUSTRY_15104000000 = "tiktokIndustry15104000000";
export const TIKTOK_INDUSTRY_15106000000 = "tiktokIndustry15106000000";
export const TIKTOK_INDUSTRY_15107000000 = "tiktokIndustry15107000000";
export const TIKTOK_INDUSTRY_15999000000 = "tiktokIndustry15999000000";
export const TIKTOK_INDUSTRY_17103000000 = "tiktokIndustry17103000000";
export const TIKTOK_INDUSTRY_17999000000 = "tiktokIndustry17999000000";
export const TIKTOK_INDUSTRY_17105000000 = "tiktokIndustry17105000000";
export const TIKTOK_INDUSTRY_17106000000 = "tiktokIndustry17106000000";
export const TIKTOK_INDUSTRY_11111000000 = "tiktokIndustry11111000000";
export const TIKTOK_INDUSTRY_11110000000 = "tiktokIndustry11110000000";
export const TIKTOK_INDUSTRY_11101000000 = "tiktokIndustry11101000000";
export const TIKTOK_INDUSTRY_11103000000 = "tiktokIndustry11103000000";
export const TIKTOK_INDUSTRY_11102000000 = "tiktokIndustry11102000000";
export const TIKTOK_INDUSTRY_11100000000 = "tiktokIndustry11100000000";
export const TIKTOK_INDUSTRY_11107000000 = "tiktokIndustry11107000000";
export const TIKTOK_INDUSTRY_11112000000 = "tiktokIndustry11112000000";
export const TIKTOK_INDUSTRY_11104000000 = "tiktokIndustry11104000000";
export const TIKTOK_INDUSTRY_11108000000 = "tiktokIndustry11108000000";
export const TIKTOK_INDUSTRY_11106000000 = "tiktokIndustry11106000000";
export const TIKTOK_INDUSTRY_11999000000 = "tiktokIndustry11999000000";
export const TIKTOK_INDUSTRY_11105000000 = "tiktokIndustry11105000000";
export const TIKTOK_INDUSTRY_11109000000 = "tiktokIndustry11109000000";
export const META_ATTRIBUTION_WINDOW_TITLE = "metaAttributionWindowTitle";
export const META_ATTRIBUTION_WINDOW_DESCRIPTION =
  "metaAttributionWindowDescription";
export const META_ATTRIBUTION_WINDOW_7D_CLICK_1D_VIEW =
  "metaAttributionWindow7dClick1dView";
export const META_ATTRIBUTION_WINDOW_7D_CLICK = "metaAttributionWindow7dClick";
export const META_ATTRIBUTION_WINDOW_1D_CLICK_1D_VIEW =
  "metaAttributionWindow1dClick1dView";
export const META_ATTRIBUTION_WINDOW_1D_CLICK = "metaAttributionWindow1dClick";
export const META_ATTRIBUTION_WINDOW_DEFAULT_OPTION =
  "metaAttributionWindowDefaultOption";
export const META_ATTRIBUTION_ENGAGED_VIEW_LABEL =
  "metaAttributionEngagedViewLabel";

export const WHITE_LABEL_TITLE = "whiteLabelTitle";
export const WHITE_LABEL_BUY = "whiteLabelBuy";
export const WHITE_LABEL_PRICE_PER_MONTH = "whiteLabelPricePerMonth";
export const WHITE_LABEL_DIALOG_BODY = "whiteLabelDialogBody";
export const WHITE_LABEL_NO_SETUP_FEE = "whiteLabelNoSetupFee";
export const WHITE_LABEL_AFTER_PAYMENT = "whiteLabelAfterPayment";
export const WHITE_LABEL_APP_SUMO_CONFIRM = "whiteLabelAppSumoConfirm";
export const WHITE_LABEL_ONLY_OWNER = "whiteLabelOnlyOwner";
export const WHITE_LABEL_STATUS_PENDING_BRANDING =
  "whiteLabelStatusPendingBranding";
export const WHITE_LABEL_STATUS_CONFIGURING = "whiteLabelStatusConfiguring";
export const WHITE_LABEL_STATUS_ACTIVE = "whiteLabelStatusActive";
export const WHITE_LABEL_STATUS_REVERT_PENDING =
  "whiteLabelStatusRevertPending";
export const WHITE_LABEL_ALREADY_ACTIVE = "whiteLabelAlreadyActiveLabel";
export const WHITE_LABEL_COMPLETE_BRAND = "whiteLabelCompleteBrand";
export const WHITE_LABEL_EDIT_BRAND = "whiteLabelEditBrand";
export const WHITE_LABEL_FORM_TITLE = "whiteLabelFormTitle";
export const WHITE_LABEL_FORM_INTRO = "whiteLabelFormIntro";
export const WHITE_LABEL_FORM_SECTION_GENERAL = "whiteLabelFormSectionGeneral";
export const WHITE_LABEL_FORM_SECTION_VISUAL = "whiteLabelFormSectionVisual";
export const WHITE_LABEL_FORM_SECTION_VISUAL_HELP =
  "whiteLabelFormSectionVisualHelp";
export const WHITE_LABEL_FORM_SECTION_COLORS = "whiteLabelFormSectionColors";
export const WHITE_LABEL_FORM_SECTION_COLORS_HELP =
  "whiteLabelFormSectionColorsHelp";
export const WHITE_LABEL_FORM_SECTION_DOMAIN = "whiteLabelFormSectionDomain";
export const WHITE_LABEL_FORM_BADGE_REQUIRED = "whiteLabelFormBadgeRequired";
export const WHITE_LABEL_FORM_BADGE_OPTIONAL = "whiteLabelFormBadgeOptional";
export const WHITE_LABEL_FORM_DROP_TITLE = "whiteLabelFormDropTitle";
export const WHITE_LABEL_FORM_DROP_HINT = "whiteLabelFormDropHint";
export const WHITE_LABEL_FORM_INVALID_FILE = "whiteLabelFormInvalidFile";
export const WHITE_LABEL_FORM_DOMAIN_BLOCKED = "whiteLabelFormDomainBlocked";
export const WHITE_LABEL_FORM_DOMAIN_INVALID = "whiteLabelFormDomainInvalid";
export const WHITE_LABEL_FORM_COLOR_INVALID = "whiteLabelFormColorInvalid";
export const WHITE_LABEL_FORM_NAME_INVALID = "whiteLabelFormNameInvalid";
export const WHITE_LABEL_FORM_NOTES_INVALID = "whiteLabelFormNotesInvalid";
export const WHITE_LABEL_FORM_LOGO_NAV_HELP = "whiteLabelFormLogoNavHelp";
export const WHITE_LABEL_FORM_LOGO_LOGIN_HELP = "whiteLabelFormLogoLoginHelp";
export const WHITE_LABEL_FORM_FAVICON_CAPTION = "whiteLabelFormFaviconCaption";
export const WHITE_LABEL_FORM_FAVICON_HELP = "whiteLabelFormFaviconHelp";
export const WHITE_LABEL_FORM_NAME_PLACEHOLDER =
  "whiteLabelFormNamePlaceholder";
export const WHITE_LABEL_FORM_DOMAIN_PLACEHOLDER =
  "whiteLabelFormDomainPlaceholder";
export const WHITE_LABEL_FORM_NOTES_PLACEHOLDER =
  "whiteLabelFormNotesPlaceholder";
export const WHITE_LABEL_FORM_COLOR_PRIMARY = "whiteLabelFormColorPrimary";
export const WHITE_LABEL_FORM_COLOR_SECONDARY = "whiteLabelFormColorSecondary";
export const WHITE_LABEL_FORM_COLOR_BUTTONS = "whiteLabelFormColorButtons";
export const WHITE_LABEL_FORM_NAME_BUSINESS = "whiteLabelFormNameBusiness";
export const WHITE_LABEL_FORM_LOGO = "whiteLabelFormLogo";
export const WHITE_LABEL_FORM_LOGO_NAVBAR = "whiteLabelFormLogoNavbar";
export const WHITE_LABEL_FORM_LOGO_LOGIN = "whiteLabelFormLogoLogin";
export const WHITE_LABEL_FORM_FAVICON = "whiteLabelFormFavicon";
export const WHITE_LABEL_FORM_PRIMARY_COLOR = "whiteLabelFormPrimaryColor";
export const WHITE_LABEL_FORM_SECONDARY_COLOR = "whiteLabelFormSecondaryColor";
export const WHITE_LABEL_FORM_PRIMARY_BUTTON_COLOR =
  "whiteLabelFormPrimaryButtonColor";
export const WHITE_LABEL_FORM_DESIRED_DOMAIN = "whiteLabelFormDesiredDomain";
export const WHITE_LABEL_FORM_DOMAIN_HELP = "whiteLabelFormDomainHelp";
export const WHITE_LABEL_FORM_NOTES = "whiteLabelFormNotes";
export const WHITE_LABEL_FORM_SUBMIT = "whiteLabelFormSubmit";
export const WHITE_LABEL_FORM_SUBMITTED = "whiteLabelFormSubmitted";
export const WHITE_LABEL_CONFIRMING_PAYMENT = "whiteLabelConfirmingPayment";
export const WHITE_LABEL_CHECKOUT_CANCELLED = "whiteLabelCheckoutCancelled";
export const WHITE_LABEL_NOT_ELIGIBLE = "whiteLabelNotEligible";
export const WHITE_LABEL_ERROR_ALREADY_ACTIVE = "whiteLabelAlreadyActive";
export const WHITE_LABEL_NOT_PURCHASED = "whiteLabelNotPurchased";
export const WHITE_LABEL_INVALID_BRANDING = "whiteLabelInvalidBranding";
export const WHITE_LABEL_INVALID_TRANSITION = "whiteLabelInvalidTransition";
export const AGENCY_ACCOUNT_LINKING_PICKER_TITLE =
  "agencyAccountLinkingPickerTitle";
export const AGENCY_ACCOUNT_LINKING_PICKER_SHEET_TITLE =
  "agencyAccountLinkingPickerSheetTitle";
export const AGENCY_ACCOUNT_LINKING_PICKER_SHEET_DESCRIPTION =
  "agencyAccountLinkingPickerSheetDescription";
export const AGENCY_ACCOUNT_LINKING_CONSENT = "agencyAccountLinkingConsent";
export const AGENCY_ACCOUNT_LINKING_CONSENT_TOOLTIP =
  "agencyAccountLinkingConsentTooltip";
export const AGENCY_ACCOUNT_LINKING_CONSENT_INFO =
  "agencyAccountLinkingConsentInfo";
export const AGENCY_ACCOUNT_LINKING_CARD_TITLE =
  "agencyAccountLinkingCardTitle";
export const AGENCY_ACCOUNT_LINKING_CARD_BODY = "agencyAccountLinkingCardBody";
export const AGENCY_ACCOUNT_LINKING_ENABLE = "agencyAccountLinkingEnable";
export const AGENCY_ACCOUNT_LINKING_NOT_NOW = "agencyAccountLinkingNotNow";
export const AGENCY_ACCOUNT_LINKING_SHEET_TITLE =
  "agencyAccountLinkingSheetTitle";
export const AGENCY_ACCOUNT_LINKING_SHEET_DESCRIPTION =
  "agencyAccountLinkingSheetDescription";
export const AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_TITLE =
  "agencyAccountLinkingConfirmAlertTitle";
export const AGENCY_ACCOUNT_LINKING_CONFIRM_ALERT_BODY =
  "agencyAccountLinkingConfirmAlertBody";
export const AGENCY_ACCOUNT_LINKING_CONFIRM = "agencyAccountLinkingConfirm";
export const AGENCY_ACCOUNT_LINKING_TOAST_DONE_ONE =
  "agencyAccountLinkingToastDoneOne";
export const AGENCY_ACCOUNT_LINKING_TOAST_DONE_OTHER =
  "agencyAccountLinkingToastDoneOther";
export const AGENCY_ACCOUNT_LINKING_TOAST_PARTIAL =
  "agencyAccountLinkingToastPartial";
export const AGENCY_ACCOUNT_LINKING_TOAST_LATER =
  "agencyAccountLinkingToastLater";
export const AGENCY_ACCOUNT_LINKING_PLATFORM_META =
  "agencyAccountLinkingPlatformMeta";
export const AGENCY_ACCOUNT_LINKING_PLATFORM_GOOGLE =
  "agencyAccountLinkingPlatformGoogle";
export const AGENCY_ACCOUNT_LINKING_PLATFORM_TIKTOK =
  "agencyAccountLinkingPlatformTiktok";
export const AGENCY_ACCOUNT_LINKING_SHEET_LINKING =
  "agencyAccountLinkingSheetLinking";
export const AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_TITLE =
  "agencyAccountLinkingSheetPartialTitle";
export const AGENCY_ACCOUNT_LINKING_SHEET_PARTIAL_BODY =
  "agencyAccountLinkingSheetPartialBody";
export const AGENCY_ACCOUNT_LINKING_SHEET_FAILED_TITLE =
  "agencyAccountLinkingSheetFailedTitle";
export const AGENCY_ACCOUNT_LINKING_SHEET_FAILED_BODY =
  "agencyAccountLinkingSheetFailedBody";
export const AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_TITLE =
  "agencyAccountLinkingSheetApprovalTitle";
export const AGENCY_ACCOUNT_LINKING_SHEET_APPROVAL_BODY =
  "agencyAccountLinkingSheetApprovalBody";
export const AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_META =
  "agencyAccountLinkingSheetApproveMeta";
export const AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GOOGLE =
  "agencyAccountLinkingSheetApproveGoogle";
export const AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_TIKTOK =
  "agencyAccountLinkingSheetApproveTiktok";
export const AGENCY_ACCOUNT_LINKING_SHEET_APPROVE_GENERIC =
  "agencyAccountLinkingSheetApproveGeneric";
export const AGENCY_ACCOUNT_LINKING_SHEET_NOT_CONFIGURED =
  "agencyAccountLinkingSheetNotConfigured";
export const AGENCY_ACCOUNT_LINKING_SHEET_RECONNECT =
  "agencyAccountLinkingSheetReconnect";
export const AGENCY_ACCOUNT_LINKING_SHEET_RETRY_STEP =
  "agencyAccountLinkingSheetRetryStep";
export const AGENCY_ACCOUNT_LINKING_SHEET_REQUEST_AGAIN =
  "agencyAccountLinkingSheetRequestAgain";
export const AGENCY_ACCOUNT_LINKING_SHEET_SUPPORT =
  "agencyAccountLinkingSheetSupport";
export const AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS_TITLE =
  "agencyAccountLinkingSheetInProgressTitle";
export const AGENCY_ACCOUNT_LINKING_SHEET_IN_PROGRESS =
  "agencyAccountLinkingSheetInProgress";
export const AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING_TITLE =
  "agencyAccountLinkingSheetProcessingTitle";
export const AGENCY_ACCOUNT_LINKING_SHEET_PROCESSING =
  "agencyAccountLinkingSheetProcessing";
export const AGENCY_ACCOUNT_LINKING_COLUMN_STATUS =
  "agencyAccountLinkingColumnStatus";
export const AGENCY_ACCOUNT_LINKING_COLUMN_DETAILS =
  "agencyAccountLinkingColumnDetails";
export const AGENCY_ACCOUNT_LINKING_STATUS_UNLINKED =
  "agencyAccountLinkingStatusUnlinked";
export const AGENCY_ACCOUNT_LINKING_STATUS_PENDING =
  "agencyAccountLinkingStatusPending";
export const AGENCY_ACCOUNT_LINKING_STATUS_FAILED =
  "agencyAccountLinkingStatusFailed";
export const AGENCY_ACCOUNT_LINKING_STATUS_LINKED =
  "agencyAccountLinkingStatusLinked";
export const AGENCY_ACCOUNT_LINKING_DETAIL_NOT_ADMIN =
  "agencyAccountLinkingDetailNotAdmin";
export const AGENCY_ACCOUNT_LINKING_DETAIL_RECONNECT =
  "agencyAccountLinkingDetailReconnect";
export const AGENCY_ACCOUNT_LINKING_DETAIL_UNREADABLE =
  "agencyAccountLinkingDetailUnreadable";
export const AGENCY_ACCOUNT_LINKING_DETAIL_NOT_CONFIGURED =
  "agencyAccountLinkingDetailNotConfigured";
export const AGENCY_ACCOUNT_LINKING_DETAIL_NOT_IN_BUSINESS =
  "agencyAccountLinkingDetailNotInBusiness";
export const AGENCY_ACCOUNT_LINKING_DETAIL_LIMIT =
  "agencyAccountLinkingDetailLimit";
export const AGENCY_ACCOUNT_LINKING_DETAIL_MANAGED_ELSEWHERE =
  "agencyAccountLinkingDetailManagedElsewhere";
export const AGENCY_ACCOUNT_LINKING_DETAIL_INCOMPATIBLE =
  "agencyAccountLinkingDetailIncompatible";
export const AGENCY_ACCOUNT_LINKING_DETAIL_REJECTED =
  "agencyAccountLinkingDetailRejected";
export const AGENCY_ACCOUNT_LINKING_DETAIL_EXPIRED =
  "agencyAccountLinkingDetailExpired";
export const AGENCY_ACCOUNT_LINKING_DETAIL_REVOKED =
  "agencyAccountLinkingDetailRevoked";
export const AGENCY_ACCOUNT_LINKING_DETAIL_UNSUPPORTED =
  "agencyAccountLinkingDetailUnsupported";
export const AGENCY_ACCOUNT_LINKING_DETAIL_GENERIC =
  "agencyAccountLinkingDetailGeneric";
export const ADLE_CARD_WAITLIST_EYEBROW = "adleCardWaitlistEyebrow";
export const ADLE_CARD_WAITLIST_TITLE = "adleCardWaitlistTitle";
export const ADLE_CARD_WAITLIST_SUBTITLE = "adleCardWaitlistSubtitle";
export const ADLE_CARD_WAITLIST_FEATURE_VIRTUAL_CARDS =
  "adleCardWaitlistFeatureVirtualCards";
export const ADLE_CARD_WAITLIST_FEATURE_SINGLE_BALANCE =
  "adleCardWaitlistFeatureSingleBalance";
export const ADLE_CARD_WAITLIST_FEATURE_CASHBACK =
  "adleCardWaitlistFeatureCashback";
export const ADLE_CARD_WAITLIST_FEATURE_NO_FEES =
  "adleCardWaitlistFeatureNoFees";
export const ADLE_CARD_WAITLIST_FEATURE_NO_DECLINES =
  "adleCardWaitlistFeatureNoDeclines";
export const ADLE_CARD_WAITLIST_FEATURE_TOP_UPS =
  "adleCardWaitlistFeatureTopUps";
export const ADLE_CARD_WAITLIST_EMAIL_LABEL = "adleCardWaitlistEmailLabel";
export const ADLE_CARD_WAITLIST_COUNTRY_LABEL = "adleCardWaitlistCountryLabel";
export const ADLE_CARD_WAITLIST_COUNTRY_PLACEHOLDER =
  "adleCardWaitlistCountryPlaceholder";
export const ADLE_CARD_WAITLIST_CTA = "adleCardWaitlistCta";
export const ADLE_CARD_WAITLIST_NOT_NOW = "adleCardWaitlistNotNow";
export const ADLE_CARD_WAITLIST_DISCLAIMER = "adleCardWaitlistDisclaimer";
export const ADLE_CARD_WAITLIST_SUCCESS_TITLE = "adleCardWaitlistSuccessTitle";
export const ADLE_CARD_WAITLIST_SUCCESS_DESCRIPTION =
  "adleCardWaitlistSuccessDescription";
export const ADLE_CARD_WAITLIST_SUBMIT_ERROR = "adleCardWaitlistSubmitError";
export const ADLE_CARD_WAITLIST_BANNER = "adleCardWaitlistBanner";
export const ADLE_CARD_WAITLIST_BANNER_LINK = "adleCardWaitlistBannerLink";
export const ADLE_CARD_WAITLIST_CARD_ARIA = "adleCardWaitlistCardAria";
export const ADLE_CARD_WAITLIST_CARD_VIRTUAL = "adleCardWaitlistCardVirtual";
export const ADLE_CARD_WAITLIST_CARD_BRAND_FALLBACK =
  "adleCardWaitlistCardBrandFallback";
export const OWNER_DASHBOARD_NAV_ADLE_CARD_WAITLIST =
  "ownerDashboardNavAdleCardWaitlist";
export const ADLE_CARD_WAITLIST_ADMIN_TOTAL = "adleCardWaitlistAdminTotal";
export const ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_ALL_TIME =
  "adleCardWaitlistAdminColumnSpendAllTime";
export const ADLE_CARD_WAITLIST_ADMIN_COLUMN_SPEND_3M =
  "adleCardWaitlistAdminColumnSpend3m";
export const ADLE_CARD_WAITLIST_ADMIN_SPEND_UNAVAILABLE =
  "adleCardWaitlistAdminSpendUnavailable";
export const MCP_TAB_TITLE = "mcpTabTitle";
export const MCP_SETTINGS_DESCRIPTION = "mcpSettingsDescription";
export const MCP_SERVER_URL_LABEL = "mcpServerUrlLabel";
export const MCP_SERVER_URL_NOT_AVAILABLE = "mcpServerUrlNotAvailable";
export const MCP_API_KEY_LABEL = "mcpApiKeyLabel";
export const MCP_GENERATE_API_KEY_BUTTON = "mcpGenerateApiKeyButton";
export const MCP_API_KEY_SHOWN_ONCE_NOTICE = "mcpApiKeyShownOnceNotice";
export const MCP_API_KEY_GENERATE_ERROR = "mcpApiKeyGenerateError";
export const MCP_MANUAL_SETUP_HINT = "mcpManualSetupHint";
export const MCP_COPIED = "mcpCopied";
export const MCP_STEP_URL_TITLE = "mcpStepUrlTitle";
export const MCP_STEP_API_KEY_TITLE = "mcpStepApiKeyTitle";
export const MCP_STEP_API_KEY_DESCRIPTION = "mcpStepApiKeyDescription";
export const MCP_STEP_AUTHORIZE_TITLE = "mcpStepAuthorizeTitle";
export const MCP_STEP_AUTHORIZE_DESCRIPTION = "mcpStepAuthorizeDescription";
export const MCP_STEP_AGENT_TITLE = "mcpStepAgentTitle";
export const MCP_STEP_AGENT_DESCRIPTION = "mcpStepAgentDescription";
export const MCP_AGENT_PROMPT = "mcpAgentPrompt";
export const MCP_API_KEY_PLACEHOLDER = "mcpApiKeyPlaceholder";
export const MCP_HEADER_TITLE = "mcpHeaderTitle";
export const MCP_AUTHORIZE_PAGE_TITLE = "mcpAuthorizePageTitle";
export const MCP_AUTHORIZE_TITLE = "mcpAuthorizeTitle";
export const MCP_AUTHORIZE_ACCESS = "mcpAuthorizeAccess";
export const MCP_AUTHORIZE_HOST_LABEL = "mcpAuthorizeHostLabel";
export const MCP_AUTHORIZE_ADVERTISER_LABEL = "mcpAuthorizeAdvertiserLabel";
export const MCP_AUTHORIZE_ADVERTISER_FALLBACK =
  "mcpAuthorizeAdvertiserFallback";
export const MCP_AUTHORIZE_UNKNOWN_HOST = "mcpAuthorizeUnknownHost";
export const MCP_AUTHORIZE_ALLOW = "mcpAuthorizeAllow";
export const MCP_AUTHORIZE_CLIENT_ERROR = "mcpAuthorizeClientError";
export const MCP_AUTHORIZE_REDIRECT_ERROR = "mcpAuthorizeRedirectError";
export const MCP_AUTHORIZE_REQUEST_ERROR = "mcpAuthorizeRequestError";
export const MCP_AUTHORIZE_PERMISSION_ERROR = "mcpAuthorizePermissionError";
export const MCP_AUTHORIZE_ADVERTISER_NOT_FOUND =
  "mcpAuthorizeAdvertiserNotFound";
export const MCP_AUTHORIZE_UNEXPECTED_ERROR = "mcpAuthorizeUnexpectedError";
export const MCP_CONNECTIONS_TITLE = "mcpConnectionsTitle";
export const MCP_CONNECTIONS_DESCRIPTION = "mcpConnectionsDescription";
export const MCP_CONNECTIONS_EMPTY = "mcpConnectionsEmpty";
export const MCP_CONNECTIONS_STATUS_ACTIVE = "mcpConnectionsStatusActive";
export const MCP_CONNECTIONS_STATUS_REVOKED = "mcpConnectionsStatusRevoked";
export const MCP_CONNECTIONS_REVOKE = "mcpConnectionsRevoke";
export const MCP_CONNECTIONS_REVOKE_CONFIRM_TITLE =
  "mcpConnectionsRevokeConfirmTitle";
export const MCP_CONNECTIONS_REVOKE_CONFIRM_TEXT =
  "mcpConnectionsRevokeConfirmText";
export const MCP_CONNECTIONS_REVOKE_ERROR = "mcpConnectionsRevokeError";
export const MCP_CONNECTIONS_LOAD_ERROR = "mcpConnectionsLoadError";
export const MCP_CONNECTIONS_DATE_UNKNOWN = "mcpConnectionsDateUnknown";
export const MCP_CONNECTIONS_TABLE_ARIA = "mcpConnectionsTableAria";
export const MCP_CONNECTIONS_UNKNOWN_CLIENT = "mcpConnectionsUnknownClient";
export const MCP_STEP_DONE_TITLE = "mcpStepDoneTitle";
export const MCP_STEP_DONE_DESCRIPTION = "mcpStepDoneDescription";
